(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 48665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ApplyUnsignedRoundingMode": function() { return /* reexport */ ApplyUnsignedRoundingMode; },
  "ArrayCreate": function() { return /* reexport */ ArrayCreate; },
  "CanonicalizeLocaleList": function() { return /* reexport */ CanonicalizeLocaleList; },
  "CanonicalizeTimeZoneName": function() { return /* reexport */ CanonicalizeTimeZoneName; },
  "CoerceOptionsToObject": function() { return /* reexport */ CoerceOptionsToObject; },
  "CollapseNumberRange": function() { return /* reexport */ CollapseNumberRange; },
  "ComputeExponent": function() { return /* reexport */ ComputeExponent; },
  "ComputeExponentForMagnitude": function() { return /* reexport */ ComputeExponentForMagnitude; },
  "CurrencyDigits": function() { return /* reexport */ CurrencyDigits; },
  "DateFromTime": function() { return /* reexport */ DateFromTime; },
  "Day": function() { return /* reexport */ Day; },
  "DayFromYear": function() { return /* reexport */ DayFromYear; },
  "DayWithinYear": function() { return /* reexport */ DayWithinYear; },
  "DaysInYear": function() { return /* reexport */ DaysInYear; },
  "FormatApproximately": function() { return /* reexport */ FormatApproximately; },
  "FormatNumericRange": function() { return /* reexport */ FormatNumericRange; },
  "FormatNumericRangeToParts": function() { return /* reexport */ FormatNumericRangeToParts; },
  "FormatNumericToParts": function() { return /* reexport */ FormatNumericToParts; },
  "FormatNumericToString": function() { return /* reexport */ FormatNumericToString; },
  "GetNumberOption": function() { return /* reexport */ GetNumberOption; },
  "GetOption": function() { return /* reexport */ GetOption; },
  "GetOptionsObject": function() { return /* reexport */ GetOptionsObject; },
  "GetStringOrBooleanOption": function() { return /* reexport */ GetStringOrBooleanOption; },
  "GetUnsignedRoundingMode": function() { return /* reexport */ GetUnsignedRoundingMode; },
  "HasOwnProperty": function() { return /* reexport */ HasOwnProperty; },
  "HourFromTime": function() { return /* reexport */ HourFromTime; },
  "InLeapYear": function() { return /* reexport */ InLeapYear; },
  "InitializeNumberFormat": function() { return /* reexport */ InitializeNumberFormat; },
  "IsSanctionedSimpleUnitIdentifier": function() { return /* reexport */ IsSanctionedSimpleUnitIdentifier; },
  "IsValidTimeZoneName": function() { return /* reexport */ IsValidTimeZoneName; },
  "IsWellFormedCurrencyCode": function() { return /* reexport */ IsWellFormedCurrencyCode; },
  "IsWellFormedUnitIdentifier": function() { return /* reexport */ IsWellFormedUnitIdentifier; },
  "MinFromTime": function() { return /* reexport */ MinFromTime; },
  "MonthFromTime": function() { return /* reexport */ MonthFromTime; },
  "OrdinaryHasInstance": function() { return /* reexport */ OrdinaryHasInstance; },
  "PartitionNumberPattern": function() { return /* reexport */ PartitionNumberPattern; },
  "PartitionNumberRangePattern": function() { return /* reexport */ PartitionNumberRangePattern; },
  "PartitionPattern": function() { return /* reexport */ PartitionPattern; },
  "RangePatternType": function() { return /* reexport */ RangePatternType; },
  "SANCTIONED_UNITS": function() { return /* reexport */ SANCTIONED_UNITS; },
  "SIMPLE_UNITS": function() { return /* reexport */ SIMPLE_UNITS; },
  "SameValue": function() { return /* reexport */ SameValue; },
  "SecFromTime": function() { return /* reexport */ SecFromTime; },
  "SetNumberFormatDigitOptions": function() { return /* reexport */ SetNumberFormatDigitOptions; },
  "SetNumberFormatUnitOptions": function() { return /* reexport */ SetNumberFormatUnitOptions; },
  "SupportedLocales": function() { return /* reexport */ SupportedLocales; },
  "TimeClip": function() { return /* reexport */ TimeClip; },
  "TimeFromYear": function() { return /* reexport */ TimeFromYear; },
  "ToNumber": function() { return /* reexport */ ToNumber; },
  "ToObject": function() { return /* reexport */ ToObject; },
  "ToRawFixed": function() { return /* reexport */ ToRawFixed; },
  "ToRawPrecision": function() { return /* reexport */ ToRawPrecision; },
  "ToString": function() { return /* reexport */ ToString; },
  "Type": function() { return /* reexport */ Type; },
  "WeekDay": function() { return /* reexport */ WeekDay; },
  "YearFromTime": function() { return /* reexport */ YearFromTime; },
  "_formatToParts": function() { return /* reexport */ formatToParts; },
  "defineProperty": function() { return /* reexport */ defineProperty; },
  "getInternalSlot": function() { return /* reexport */ getInternalSlot; },
  "getMagnitude": function() { return /* reexport */ getMagnitude; },
  "getMultiInternalSlots": function() { return /* reexport */ getMultiInternalSlots; },
  "invariant": function() { return /* reexport */ invariant; },
  "isLiteralPart": function() { return /* reexport */ isLiteralPart; },
  "isMissingLocaleDataError": function() { return /* reexport */ isMissingLocaleDataError; },
  "msFromTime": function() { return /* reexport */ msFromTime; },
  "removeUnitNamespace": function() { return /* reexport */ removeUnitNamespace; },
  "setInternalSlot": function() { return /* reexport */ setInternalSlot; },
  "setMultiInternalSlots": function() { return /* reexport */ setMultiInternalSlots; }
});

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/CanonicalizeLocaleList.js
/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */
function CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/CanonicalizeTimeZoneName.js
/**
 * https://tc39.es/ecma402/#sec-canonicalizetimezonename
 * @param tz
 */
function CanonicalizeTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var uppercasedZones = Object.keys(tzData).reduce(function (all, z) {
        all[z.toUpperCase()] = z;
        return all;
    }, {});
    var ianaTimeZone = uppercaseLinks[uppercasedTz] || uppercasedZones[uppercasedTz];
    if (ianaTimeZone === 'Etc/UTC' || ianaTimeZone === 'Etc/GMT') {
        return 'UTC';
    }
    return ianaTimeZone;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/262.js
/**
 * https://tc39.es/ecma262/#sec-tostring
 */
function ToString(o) {
    // Only symbol is irregular...
    if (typeof o === 'symbol') {
        throw TypeError('Cannot convert a Symbol value to a string');
    }
    return String(o);
}
/**
 * https://tc39.es/ecma262/#sec-tonumber
 * @param val
 */
function ToNumber(val) {
    if (val === undefined) {
        return NaN;
    }
    if (val === null) {
        return +0;
    }
    if (typeof val === 'boolean') {
        return val ? 1 : +0;
    }
    if (typeof val === 'number') {
        return val;
    }
    if (typeof val === 'symbol' || typeof val === 'bigint') {
        throw new TypeError('Cannot convert symbol/bigint to number');
    }
    return Number(val);
}
/**
 * https://tc39.es/ecma262/#sec-tointeger
 * @param n
 */
function ToInteger(n) {
    var number = ToNumber(n);
    if (isNaN(number) || SameValue(number, -0)) {
        return 0;
    }
    if (isFinite(number)) {
        return number;
    }
    var integer = Math.floor(Math.abs(number));
    if (number < 0) {
        integer = -integer;
    }
    if (SameValue(integer, -0)) {
        return 0;
    }
    return integer;
}
/**
 * https://tc39.es/ecma262/#sec-timeclip
 * @param time
 */
function TimeClip(time) {
    if (!isFinite(time)) {
        return NaN;
    }
    if (Math.abs(time) > 8.64 * 1e15) {
        return NaN;
    }
    return ToInteger(time);
}
/**
 * https://tc39.es/ecma262/#sec-toobject
 * @param arg
 */
function ToObject(arg) {
    if (arg == null) {
        throw new TypeError('undefined/null cannot be converted to object');
    }
    return Object(arg);
}
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-samevalue
 * @param x
 * @param y
 */
function SameValue(x, y) {
    if (Object.is) {
        return Object.is(x, y);
    }
    // SameValue algorithm
    if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
    }
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-arraycreate
 * @param len
 */
function ArrayCreate(len) {
    return new Array(len);
}
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-hasownproperty
 * @param o
 * @param prop
 */
function HasOwnProperty(o, prop) {
    return Object.prototype.hasOwnProperty.call(o, prop);
}
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-type
 * @param x
 */
function Type(x) {
    if (x === null) {
        return 'Null';
    }
    if (typeof x === 'undefined') {
        return 'Undefined';
    }
    if (typeof x === 'function' || typeof x === 'object') {
        return 'Object';
    }
    if (typeof x === 'number') {
        return 'Number';
    }
    if (typeof x === 'boolean') {
        return 'Boolean';
    }
    if (typeof x === 'string') {
        return 'String';
    }
    if (typeof x === 'symbol') {
        return 'Symbol';
    }
    if (typeof x === 'bigint') {
        return 'BigInt';
    }
}
var MS_PER_DAY = 86400000;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#eqn-modulo
 * @param x
 * @param y
 * @return k of the same sign as y
 */
function mod(x, y) {
    return x - Math.floor(x / y) * y;
}
/**
 * https://tc39.es/ecma262/#eqn-Day
 * @param t
 */
function Day(t) {
    return Math.floor(t / MS_PER_DAY);
}
/**
 * https://tc39.es/ecma262/#sec-week-day
 * @param t
 */
function WeekDay(t) {
    return mod(Day(t) + 4, 7);
}
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */
function DayFromYear(y) {
    return Date.UTC(y, 0) / MS_PER_DAY;
}
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */
function TimeFromYear(y) {
    return Date.UTC(y, 0);
}
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param t
 */
function YearFromTime(t) {
    return new Date(t).getUTCFullYear();
}
function DaysInYear(y) {
    if (y % 4 !== 0) {
        return 365;
    }
    if (y % 100 !== 0) {
        return 366;
    }
    if (y % 400 !== 0) {
        return 365;
    }
    return 366;
}
function DayWithinYear(t) {
    return Day(t) - DayFromYear(YearFromTime(t));
}
function InLeapYear(t) {
    return DaysInYear(YearFromTime(t)) === 365 ? 0 : 1;
}
/**
 * https://tc39.es/ecma262/#sec-month-number
 * @param t
 */
function MonthFromTime(t) {
    var dwy = DayWithinYear(t);
    var leap = InLeapYear(t);
    if (dwy >= 0 && dwy < 31) {
        return 0;
    }
    if (dwy < 59 + leap) {
        return 1;
    }
    if (dwy < 90 + leap) {
        return 2;
    }
    if (dwy < 120 + leap) {
        return 3;
    }
    if (dwy < 151 + leap) {
        return 4;
    }
    if (dwy < 181 + leap) {
        return 5;
    }
    if (dwy < 212 + leap) {
        return 6;
    }
    if (dwy < 243 + leap) {
        return 7;
    }
    if (dwy < 273 + leap) {
        return 8;
    }
    if (dwy < 304 + leap) {
        return 9;
    }
    if (dwy < 334 + leap) {
        return 10;
    }
    if (dwy < 365 + leap) {
        return 11;
    }
    throw new Error('Invalid time');
}
function DateFromTime(t) {
    var dwy = DayWithinYear(t);
    var mft = MonthFromTime(t);
    var leap = InLeapYear(t);
    if (mft === 0) {
        return dwy + 1;
    }
    if (mft === 1) {
        return dwy - 30;
    }
    if (mft === 2) {
        return dwy - 58 - leap;
    }
    if (mft === 3) {
        return dwy - 89 - leap;
    }
    if (mft === 4) {
        return dwy - 119 - leap;
    }
    if (mft === 5) {
        return dwy - 150 - leap;
    }
    if (mft === 6) {
        return dwy - 180 - leap;
    }
    if (mft === 7) {
        return dwy - 211 - leap;
    }
    if (mft === 8) {
        return dwy - 242 - leap;
    }
    if (mft === 9) {
        return dwy - 272 - leap;
    }
    if (mft === 10) {
        return dwy - 303 - leap;
    }
    if (mft === 11) {
        return dwy - 333 - leap;
    }
    throw new Error('Invalid time');
}
var HOURS_PER_DAY = 24;
var MINUTES_PER_HOUR = 60;
var SECONDS_PER_MINUTE = 60;
var MS_PER_SECOND = 1e3;
var MS_PER_MINUTE = MS_PER_SECOND * SECONDS_PER_MINUTE;
var MS_PER_HOUR = MS_PER_MINUTE * MINUTES_PER_HOUR;
function HourFromTime(t) {
    return mod(Math.floor(t / MS_PER_HOUR), HOURS_PER_DAY);
}
function MinFromTime(t) {
    return mod(Math.floor(t / MS_PER_MINUTE), MINUTES_PER_HOUR);
}
function SecFromTime(t) {
    return mod(Math.floor(t / MS_PER_SECOND), SECONDS_PER_MINUTE);
}
function IsCallable(fn) {
    return typeof fn === 'function';
}
/**
 * The abstract operation OrdinaryHasInstance implements
 * the default algorithm for determining if an object O
 * inherits from the instance object inheritance path
 * provided by constructor C.
 * @param C class
 * @param O object
 * @param internalSlots internalSlots
 */
function OrdinaryHasInstance(C, O, internalSlots) {
    if (!IsCallable(C)) {
        return false;
    }
    if (internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction) {
        var BC = internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction;
        return O instanceof BC;
    }
    if (typeof O !== 'object') {
        return false;
    }
    var P = C.prototype;
    if (typeof P !== 'object') {
        throw new TypeError('OrdinaryHasInstance called on an object with an invalid prototype property.');
    }
    return Object.prototype.isPrototypeOf.call(P, O);
}
function msFromTime(t) {
    return mod(t, MS_PER_SECOND);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/CoerceOptionsToObject.js

/**
 * https://tc39.es/ecma402/#sec-coerceoptionstoobject
 * @param options
 * @returns
 */
function CoerceOptionsToObject(options) {
    if (typeof options === 'undefined') {
        return Object.create(null);
    }
    return ToObject(options);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/DefaultNumberOption.js
function DefaultNumberOption(val, min, max, fallback) {
    if (val !== undefined) {
        val = Number(val);
        if (isNaN(val) || val < min || val > max) {
            throw new RangeError("".concat(val, " is outside of range [").concat(min, ", ").concat(max, "]"));
        }
        return Math.floor(val);
    }
    return fallback;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/GetNumberOption.js
/**
 * https://tc39.es/ecma402/#sec-getnumberoption
 * @param options
 * @param property
 * @param min
 * @param max
 * @param fallback
 */

function GetNumberOption(options, property, minimum, maximum, fallback) {
    var val = options[property];
    // @ts-expect-error
    return DefaultNumberOption(val, minimum, maximum, fallback);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/GetOption.js

/**
 * https://tc39.es/ecma402/#sec-getoption
 * @param opts
 * @param prop
 * @param type
 * @param values
 * @param fallback
 */
function GetOption(opts, prop, type, values, fallback) {
    if (typeof opts !== 'object') {
        throw new TypeError('Options must be an object');
    }
    var value = opts[prop];
    if (value !== undefined) {
        if (type !== 'boolean' && type !== 'string') {
            throw new TypeError('invalid type');
        }
        if (type === 'boolean') {
            value = Boolean(value);
        }
        if (type === 'string') {
            value = ToString(value);
        }
        if (values !== undefined && !values.filter(function (val) { return val == value; }).length) {
            throw new RangeError("".concat(value, " is not within ").concat(values.join(', ')));
        }
        return value;
    }
    return fallback;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/GetOptionsObject.js
/**
 * https://tc39.es/ecma402/#sec-getoptionsobject
 * @param options
 * @returns
 */
function GetOptionsObject(options) {
    if (typeof options === 'undefined') {
        return Object.create(null);
    }
    if (typeof options === 'object') {
        return options;
    }
    throw new TypeError('Options must be an object');
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/GetStringOrBooleanOption.js
/**
 * https://tc39.es/ecma402/#sec-getstringorbooleanoption
 * @param opts
 * @param prop
 * @param values
 * @param trueValue
 * @param falsyValue
 * @param fallback
 */

function GetStringOrBooleanOption(opts, prop, values, trueValue, falsyValue, fallback) {
    var value = opts[prop];
    if (value === undefined) {
        return fallback;
    }
    if (value === true) {
        return trueValue;
    }
    var valueBoolean = Boolean(value);
    if (valueBoolean === false) {
        return falsyValue;
    }
    value = ToString(value);
    if (value === 'true' || value === 'false') {
        return fallback;
    }
    if ((values || []).indexOf(value) === -1) {
        throw new RangeError("Invalid value ".concat(value));
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/IsSanctionedSimpleUnitIdentifier.js
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */
var SANCTIONED_UNITS = [
    'angle-degree',
    'area-acre',
    'area-hectare',
    'concentr-percent',
    'digital-bit',
    'digital-byte',
    'digital-gigabit',
    'digital-gigabyte',
    'digital-kilobit',
    'digital-kilobyte',
    'digital-megabit',
    'digital-megabyte',
    'digital-petabyte',
    'digital-terabit',
    'digital-terabyte',
    'duration-day',
    'duration-hour',
    'duration-millisecond',
    'duration-minute',
    'duration-month',
    'duration-second',
    'duration-week',
    'duration-year',
    'length-centimeter',
    'length-foot',
    'length-inch',
    'length-kilometer',
    'length-meter',
    'length-mile-scandinavian',
    'length-mile',
    'length-millimeter',
    'length-yard',
    'mass-gram',
    'mass-kilogram',
    'mass-ounce',
    'mass-pound',
    'mass-stone',
    'temperature-celsius',
    'temperature-fahrenheit',
    'volume-fluid-ounce',
    'volume-gallon',
    'volume-liter',
    'volume-milliliter',
];
// In CLDR, the unit name always follows the form `namespace-unit` pattern.
// For example: `digital-bit` instead of `bit`. This function removes the namespace prefix.
function removeUnitNamespace(unit) {
    return unit.slice(unit.indexOf('-') + 1);
}
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */
var SIMPLE_UNITS = SANCTIONED_UNITS.map(removeUnitNamespace);
/**
 * https://tc39.es/ecma402/#sec-issanctionedsimpleunitidentifier
 */
function IsSanctionedSimpleUnitIdentifier(unitIdentifier) {
    return SIMPLE_UNITS.indexOf(unitIdentifier) > -1;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/IsValidTimeZoneName.js
/**
 * https://tc39.es/ecma402/#sec-isvalidtimezonename
 * @param tz
 * @param implDetails implementation details
 */
function IsValidTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var zoneNames = new Set();
    var linkNames = new Set();
    Object.keys(tzData)
        .map(function (z) { return z.toUpperCase(); })
        .forEach(function (z) { return zoneNames.add(z); });
    Object.keys(uppercaseLinks).forEach(function (linkName) {
        linkNames.add(linkName.toUpperCase());
        zoneNames.add(uppercaseLinks[linkName].toUpperCase());
    });
    return zoneNames.has(uppercasedTz) || linkNames.has(uppercasedTz);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/IsWellFormedCurrencyCode.js
/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */
function toUpperCase(str) {
    return str.replace(/([a-z])/g, function (_, c) { return c.toUpperCase(); });
}
var NOT_A_Z_REGEX = /[^A-Z]/;
/**
 * https://tc39.es/ecma402/#sec-iswellformedcurrencycode
 */
function IsWellFormedCurrencyCode(currency) {
    currency = toUpperCase(currency);
    if (currency.length !== 3) {
        return false;
    }
    if (NOT_A_Z_REGEX.test(currency)) {
        return false;
    }
    return true;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/IsWellFormedUnitIdentifier.js

/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */
function toLowerCase(str) {
    return str.replace(/([A-Z])/g, function (_, c) { return c.toLowerCase(); });
}
/**
 * https://tc39.es/ecma402/#sec-iswellformedunitidentifier
 * @param unit
 */
function IsWellFormedUnitIdentifier(unit) {
    unit = toLowerCase(unit);
    if (IsSanctionedSimpleUnitIdentifier(unit)) {
        return true;
    }
    var units = unit.split('-per-');
    if (units.length !== 2) {
        return false;
    }
    var numerator = units[0], denominator = units[1];
    if (!IsSanctionedSimpleUnitIdentifier(numerator) ||
        !IsSanctionedSimpleUnitIdentifier(denominator)) {
        return false;
    }
    return true;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/ApplyUnsignedRoundingMode.js
function ApplyUnsignedRoundingMode(x, r1, r2, unsignedRoundingMode) {
    if (x === r1)
        return r1;
    if (unsignedRoundingMode === undefined) {
        throw new Error('unsignedRoundingMode is mandatory');
    }
    if (unsignedRoundingMode === 'zero') {
        return r1;
    }
    if (unsignedRoundingMode === 'infinity') {
        return r2;
    }
    var d1 = x - r1;
    var d2 = r2 - x;
    if (d1 < d2) {
        return r1;
    }
    if (d2 < d1) {
        return r2;
    }
    if (d1 !== d2) {
        throw new Error('Unexpected error');
    }
    if (unsignedRoundingMode === 'half-zero') {
        return r1;
    }
    if (unsignedRoundingMode === 'half-infinity') {
        return r2;
    }
    if (unsignedRoundingMode !== 'half-even') {
        throw new Error("Unexpected value for unsignedRoundingMode: ".concat(unsignedRoundingMode));
    }
    var cardinality = (r1 / (r2 - r1)) % 2;
    if (cardinality === 0) {
        return r1;
    }
    return r2;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/CollapseNumberRange.js
/**
 * https://tc39.es/ecma402/#sec-collapsenumberrange
 */
function CollapseNumberRange(result) {
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/utils.js
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === 'function') {
        return s.repeat(times);
    }
    var arr = new Array(times);
    for (var i = 0; i < arr.length; i++) {
        arr[i] = s;
    }
    return arr.join('');
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) {
        map.set(pl, Object.create(null));
    }
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        fields[_i - 2] = arguments[_i];
    }
    var slots = map.get(pl);
    if (!slots) {
        throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    }
    return fields.reduce(function (all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === 'literal';
}
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value,
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/ComputeExponentForMagnitude.js
/**
 * The abstract operation ComputeExponentForMagnitude computes an exponent by which to scale a
 * number of the given magnitude (power of ten of the most significant digit) according to the
 * locale and the desired notation (scientific, engineering, or compact).
 */
function ComputeExponentForMagnitude(numberFormat, magnitude, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var notation = internalSlots.notation, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    switch (notation) {
        case 'standard':
            return 0;
        case 'scientific':
            return magnitude;
        case 'engineering':
            return Math.floor(magnitude / 3) * 3;
        default: {
            // Let exponent be an implementation- and locale-dependent (ILD) integer by which to scale a
            // number of the given magnitude in compact notation for the current locale.
            var compactDisplay = internalSlots.compactDisplay, style = internalSlots.style, currencyDisplay = internalSlots.currencyDisplay;
            var thresholdMap = void 0;
            if (style === 'currency' && currencyDisplay !== 'name') {
                var currency = dataLocaleData.numbers.currency[numberingSystem] ||
                    dataLocaleData.numbers.currency[dataLocaleData.numbers.nu[0]];
                thresholdMap = currency.short;
            }
            else {
                var decimal = dataLocaleData.numbers.decimal[numberingSystem] ||
                    dataLocaleData.numbers.decimal[dataLocaleData.numbers.nu[0]];
                thresholdMap = compactDisplay === 'long' ? decimal.long : decimal.short;
            }
            if (!thresholdMap) {
                return 0;
            }
            var num = String(Math.pow(10, magnitude));
            var thresholds = Object.keys(thresholdMap); // TODO: this can be pre-processed
            if (num < thresholds[0]) {
                return 0;
            }
            if (num > thresholds[thresholds.length - 1]) {
                return thresholds[thresholds.length - 1].length - 1;
            }
            var i = thresholds.indexOf(num);
            if (i === -1) {
                return 0;
            }
            // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
            // Special handling if the pattern is precisely `0`.
            var magnitudeKey = thresholds[i];
            // TODO: do we need to handle plural here?
            var compactPattern = thresholdMap[magnitudeKey].other;
            if (compactPattern === '0') {
                return 0;
            }
            // Example: in zh-TW, `10000000` maps to `0000萬`. So we need to return 8 - 4 = 4 here.
            return (magnitudeKey.length -
                thresholdMap[magnitudeKey].other.match(/0+/)[0].length);
        }
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/ToRawPrecision.js

function ToRawPrecision(x, minPrecision, maxPrecision) {
    var p = maxPrecision;
    var m;
    var e;
    var xFinal;
    if (x === 0) {
        m = repeat('0', p);
        e = 0;
        xFinal = 0;
    }
    else {
        var xToString = x.toString();
        // If xToString is formatted as scientific notation, the number is either very small or very
        // large. If the precision of the formatted string is lower that requested max precision, we
        // should still infer them from the formatted string, otherwise the formatted result might have
        // precision loss (e.g. 1e41 will not have 0 in every trailing digits).
        var xToStringExponentIndex = xToString.indexOf('e');
        var _a = xToString.split('e'), xToStringMantissa = _a[0], xToStringExponent = _a[1];
        var xToStringMantissaWithoutDecimalPoint = xToStringMantissa.replace('.', '');
        if (xToStringExponentIndex >= 0 &&
            xToStringMantissaWithoutDecimalPoint.length <= p) {
            e = +xToStringExponent;
            m =
                xToStringMantissaWithoutDecimalPoint +
                    repeat('0', p - xToStringMantissaWithoutDecimalPoint.length);
            xFinal = x;
        }
        else {
            e = getMagnitude(x);
            var decimalPlaceOffset = e - p + 1;
            // n is the integer containing the required precision digits. To derive the formatted string,
            // we will adjust its decimal place in the logic below.
            var n = Math.round(adjustDecimalPlace(x, decimalPlaceOffset));
            // The rounding caused the change of magnitude, so we should increment `e` by 1.
            if (adjustDecimalPlace(n, p - 1) >= 10) {
                e = e + 1;
                // Divide n by 10 to swallow one precision.
                n = Math.floor(n / 10);
            }
            m = n.toString();
            // Equivalent of n * 10 ** (e - p + 1)
            xFinal = adjustDecimalPlace(n, p - 1 - e);
        }
    }
    var int;
    if (e >= p - 1) {
        m = m + repeat('0', e - p + 1);
        int = e + 1;
    }
    else if (e >= 0) {
        m = "".concat(m.slice(0, e + 1), ".").concat(m.slice(e + 1));
        int = e + 1;
    }
    else {
        m = "0.".concat(repeat('0', -e - 1)).concat(m);
        int = 1;
    }
    if (m.indexOf('.') >= 0 && maxPrecision > minPrecision) {
        var cut = maxPrecision - minPrecision;
        while (cut > 0 && m[m.length - 1] === '0') {
            m = m.slice(0, -1);
            cut--;
        }
        if (m[m.length - 1] === '.') {
            m = m.slice(0, -1);
        }
    }
    return { formattedString: m, roundedNumber: xFinal, integerDigitsCount: int };
    // x / (10 ** magnitude), but try to preserve as much floating point precision as possible.
    function adjustDecimalPlace(x, magnitude) {
        return magnitude < 0 ? x * Math.pow(10, -magnitude) : x / Math.pow(10, magnitude);
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/ToRawFixed.js

/**
 * TODO: dedup with intl-pluralrules and support BigInt
 * https://tc39.es/ecma402/#sec-torawfixed
 * @param x a finite non-negative Number or BigInt
 * @param minFraction and integer between 0 and 20
 * @param maxFraction and integer between 0 and 20
 */
function ToRawFixed(x, minFraction, maxFraction) {
    var f = maxFraction;
    var n = Math.round(x * Math.pow(10, f));
    var xFinal = n / Math.pow(10, f);
    // n is a positive integer, but it is possible to be greater than 1e21.
    // In such case we will go the slow path.
    // See also: https://tc39.es/ecma262/#sec-numeric-types-number-tostring
    var m;
    if (n < 1e21) {
        m = n.toString();
    }
    else {
        m = n.toString();
        var _a = m.split('e'), mantissa = _a[0], exponent = _a[1];
        m = mantissa.replace('.', '');
        m = m + repeat('0', Math.max(+exponent - m.length + 1, 0));
    }
    var int;
    if (f !== 0) {
        var k = m.length;
        if (k <= f) {
            var z = repeat('0', f + 1 - k);
            m = z + m;
            k = f + 1;
        }
        var a = m.slice(0, k - f);
        var b = m.slice(k - f);
        m = "".concat(a, ".").concat(b);
        int = a.length;
    }
    else {
        int = m.length;
    }
    var cut = maxFraction - minFraction;
    while (cut > 0 && m[m.length - 1] === '0') {
        m = m.slice(0, -1);
        cut--;
    }
    if (m[m.length - 1] === '.') {
        m = m.slice(0, -1);
    }
    return { formattedString: m, roundedNumber: xFinal, integerDigitsCount: int };
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/FormatNumericToString.js




/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */
function FormatNumericToString(intlObject, x) {
    var isNegative = x < 0 || SameValue(x, -0);
    if (isNegative) {
        x = -x;
    }
    var result;
    var rourndingType = intlObject.roundingType;
    switch (rourndingType) {
        case 'significantDigits':
            result = ToRawPrecision(x, intlObject.minimumSignificantDigits, intlObject.maximumSignificantDigits);
            break;
        case 'fractionDigits':
            result = ToRawFixed(x, intlObject.minimumFractionDigits, intlObject.maximumFractionDigits);
            break;
        default:
            result = ToRawPrecision(x, 1, 2);
            if (result.integerDigitsCount > 1) {
                result = ToRawFixed(x, 0, 0);
            }
            break;
    }
    x = result.roundedNumber;
    var string = result.formattedString;
    var int = result.integerDigitsCount;
    var minInteger = intlObject.minimumIntegerDigits;
    if (int < minInteger) {
        var forwardZeros = repeat('0', minInteger - int);
        string = forwardZeros + string;
    }
    if (isNegative) {
        x = -x;
    }
    return { roundedNumber: x, formattedString: string };
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/ComputeExponent.js



/**
 * The abstract operation ComputeExponent computes an exponent (power of ten) by which to scale x
 * according to the number formatting settings. It handles cases such as 999 rounding up to 1000,
 * requiring a different exponent.
 *
 * NOT IN SPEC: it returns [exponent, magnitude].
 */
function ComputeExponent(numberFormat, x, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (x === 0) {
        return [0, 0];
    }
    if (x < 0) {
        x = -x;
    }
    var magnitude = getMagnitude(x);
    var exponent = ComputeExponentForMagnitude(numberFormat, magnitude, {
        getInternalSlots: getInternalSlots,
    });
    // Preserve more precision by doing multiplication when exponent is negative.
    x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
    var formatNumberResult = FormatNumericToString(getInternalSlots(numberFormat), x);
    if (formatNumberResult.roundedNumber === 0) {
        return [exponent, magnitude];
    }
    var newMagnitude = getMagnitude(formatNumberResult.roundedNumber);
    if (newMagnitude === magnitude - exponent) {
        return [exponent, magnitude];
    }
    return [
        ComputeExponentForMagnitude(numberFormat, magnitude + 1, {
            getInternalSlots: getInternalSlots,
        }),
        magnitude + 1,
    ];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/CurrencyDigits.js

/**
 * https://tc39.es/ecma402/#sec-currencydigits
 */
function CurrencyDigits(c, _a) {
    var currencyDigitsData = _a.currencyDigitsData;
    return HasOwnProperty(currencyDigitsData, c)
        ? currencyDigitsData[c]
        : 2;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/FormatApproximately.js
/**
 * https://tc39.es/ecma402/#sec-formatapproximately
 */
function FormatApproximately(numberFormat, result, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
    var approximatelySign = symbols.approximatelySign;
    result.push({ type: 'approximatelySign', value: approximatelySign });
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/digit-mapping.generated.js
var digitMapping = { "adlm": ["𞥐", "𞥑", "𞥒", "𞥓", "𞥔", "𞥕", "𞥖", "𞥗", "𞥘", "𞥙"], "ahom": ["𑜰", "𑜱", "𑜲", "𑜳", "𑜴", "𑜵", "𑜶", "𑜷", "𑜸", "𑜹"], "arab": ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"], "arabext": ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"], "bali": ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"], "beng": ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"], "bhks": ["𑱐", "𑱑", "𑱒", "𑱓", "𑱔", "𑱕", "𑱖", "𑱗", "𑱘", "𑱙"], "brah": ["𑁦", "𑁧", "𑁨", "𑁩", "𑁪", "𑁫", "𑁬", "𑁭", "𑁮", "𑁯"], "cakm": ["𑄶", "𑄷", "𑄸", "𑄹", "𑄺", "𑄻", "𑄼", "𑄽", "𑄾", "𑄿"], "cham": ["꩐", "꩑", "꩒", "꩓", "꩔", "꩕", "꩖", "꩗", "꩘", "꩙"], "deva": ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"], "diak": ["𑥐", "𑥑", "𑥒", "𑥓", "𑥔", "𑥕", "𑥖", "𑥗", "𑥘", "𑥙"], "fullwide": ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"], "gong": ["𑶠", "𑶡", "𑶢", "𑶣", "𑶤", "𑶥", "𑶦", "𑶧", "𑶨", "𑶩"], "gonm": ["𑵐", "𑵑", "𑵒", "𑵓", "𑵔", "𑵕", "𑵖", "𑵗", "𑵘", "𑵙"], "gujr": ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"], "guru": ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"], "hanidec": ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"], "hmng": ["𖭐", "𖭑", "𖭒", "𖭓", "𖭔", "𖭕", "𖭖", "𖭗", "𖭘", "𖭙"], "hmnp": ["𞅀", "𞅁", "𞅂", "𞅃", "𞅄", "𞅅", "𞅆", "𞅇", "𞅈", "𞅉"], "java": ["꧐", "꧑", "꧒", "꧓", "꧔", "꧕", "꧖", "꧗", "꧘", "꧙"], "kali": ["꤀", "꤁", "꤂", "꤃", "꤄", "꤅", "꤆", "꤇", "꤈", "꤉"], "khmr": ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"], "knda": ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"], "lana": ["᪀", "᪁", "᪂", "᪃", "᪄", "᪅", "᪆", "᪇", "᪈", "᪉"], "lanatham": ["᪐", "᪑", "᪒", "᪓", "᪔", "᪕", "᪖", "᪗", "᪘", "᪙"], "laoo": ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"], "lepc": ["᪐", "᪑", "᪒", "᪓", "᪔", "᪕", "᪖", "᪗", "᪘", "᪙"], "limb": ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"], "mathbold": ["𝟎", "𝟏", "𝟐", "𝟑", "𝟒", "𝟓", "𝟔", "𝟕", "𝟖", "𝟗"], "mathdbl": ["𝟘", "𝟙", "𝟚", "𝟛", "𝟜", "𝟝", "𝟞", "𝟟", "𝟠", "𝟡"], "mathmono": ["𝟶", "𝟷", "𝟸", "𝟹", "𝟺", "𝟻", "𝟼", "𝟽", "𝟾", "𝟿"], "mathsanb": ["𝟬", "𝟭", "𝟮", "𝟯", "𝟰", "𝟱", "𝟲", "𝟳", "𝟴", "𝟵"], "mathsans": ["𝟢", "𝟣", "𝟤", "𝟥", "𝟦", "𝟧", "𝟨", "𝟩", "𝟪", "𝟫"], "mlym": ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"], "modi": ["𑙐", "𑙑", "𑙒", "𑙓", "𑙔", "𑙕", "𑙖", "𑙗", "𑙘", "𑙙"], "mong": ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"], "mroo": ["𖩠", "𖩡", "𖩢", "𖩣", "𖩤", "𖩥", "𖩦", "𖩧", "𖩨", "𖩩"], "mtei": ["꯰", "꯱", "꯲", "꯳", "꯴", "꯵", "꯶", "꯷", "꯸", "꯹"], "mymr": ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"], "mymrshan": ["႐", "႑", "႒", "႓", "႔", "႕", "႖", "႗", "႘", "႙"], "mymrtlng": ["꧰", "꧱", "꧲", "꧳", "꧴", "꧵", "꧶", "꧷", "꧸", "꧹"], "newa": ["𑑐", "𑑑", "𑑒", "𑑓", "𑑔", "𑑕", "𑑖", "𑑗", "𑑘", "𑑙"], "nkoo": ["߀", "߁", "߂", "߃", "߄", "߅", "߆", "߇", "߈", "߉"], "olck": ["᱐", "᱑", "᱒", "᱓", "᱔", "᱕", "᱖", "᱗", "᱘", "᱙"], "orya": ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"], "osma": ["𐒠", "𐒡", "𐒢", "𐒣", "𐒤", "𐒥", "𐒦", "𐒧", "𐒨", "𐒩"], "rohg": ["𐴰", "𐴱", "𐴲", "𐴳", "𐴴", "𐴵", "𐴶", "𐴷", "𐴸", "𐴹"], "saur": ["꣐", "꣑", "꣒", "꣓", "꣔", "꣕", "꣖", "꣗", "꣘", "꣙"], "segment": ["🯰", "🯱", "🯲", "🯳", "🯴", "🯵", "🯶", "🯷", "🯸", "🯹"], "shrd": ["𑇐", "𑇑", "𑇒", "𑇓", "𑇔", "𑇕", "𑇖", "𑇗", "𑇘", "𑇙"], "sind": ["𑋰", "𑋱", "𑋲", "𑋳", "𑋴", "𑋵", "𑋶", "𑋷", "𑋸", "𑋹"], "sinh": ["෦", "෧", "෨", "෩", "෪", "෫", "෬", "෭", "෮", "෯"], "sora": ["𑃰", "𑃱", "𑃲", "𑃳", "𑃴", "𑃵", "𑃶", "𑃷", "𑃸", "𑃹"], "sund": ["᮰", "᮱", "᮲", "᮳", "᮴", "᮵", "᮶", "᮷", "᮸", "᮹"], "takr": ["𑛀", "𑛁", "𑛂", "𑛃", "𑛄", "𑛅", "𑛆", "𑛇", "𑛈", "𑛉"], "talu": ["᧐", "᧑", "᧒", "᧓", "᧔", "᧕", "᧖", "᧗", "᧘", "᧙"], "tamldec": ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"], "telu": ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"], "thai": ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"], "tibt": ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"], "tirh": ["𑓐", "𑓑", "𑓒", "𑓓", "𑓔", "𑓕", "𑓖", "𑓗", "𑓘", "𑓙"], "vaii": ["ᘠ", "ᘡ", "ᘢ", "ᘣ", "ᘤ", "ᘥ", "ᘦ", "ᘧ", "ᘨ", "ᘩ"], "wara": ["𑣠", "𑣡", "𑣢", "𑣣", "𑣤", "𑣥", "𑣦", "𑣧", "𑣨", "𑣩"], "wcho": ["𞋰", "𞋱", "𞋲", "𞋳", "𞋴", "𞋵", "𞋶", "𞋷", "𞋸", "𞋹"] };

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/regex.generated.js
// @generated from regex-gen.ts
var S_UNICODE_REGEX = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA]/;

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/format_to_parts.js



// This is from: unicode-12.1.0/General_Category/Symbol/regex.js
// IE11 does not support unicode flag, otherwise this is just /\p{S}/u.
// /^\p{S}/u
var CARET_S_UNICODE_REGEX = new RegExp("^".concat(S_UNICODE_REGEX.source));
// /\p{S}$/u
var S_DOLLAR_UNICODE_REGEX = new RegExp("".concat(S_UNICODE_REGEX.source, "$"));
var CLDR_NUMBER_PATTERN = /[#0](?:[\.,][#0]+)*/g;
function formatToParts(numberResult, data, pl, options) {
    var sign = numberResult.sign, exponent = numberResult.exponent, magnitude = numberResult.magnitude;
    var notation = options.notation, style = options.style, numberingSystem = options.numberingSystem;
    var defaultNumberingSystem = data.numbers.nu[0];
    // #region Part 1: partition and interpolate the CLDR number pattern.
    // ----------------------------------------------------------
    var compactNumberPattern = null;
    if (notation === 'compact' && magnitude) {
        compactNumberPattern = getCompactDisplayPattern(numberResult, pl, data, style, options.compactDisplay, options.currencyDisplay, numberingSystem);
    }
    // This is used multiple times
    var nonNameCurrencyPart;
    if (style === 'currency' && options.currencyDisplay !== 'name') {
        var byCurrencyDisplay = data.currencies[options.currency];
        if (byCurrencyDisplay) {
            switch (options.currencyDisplay) {
                case 'code':
                    nonNameCurrencyPart = options.currency;
                    break;
                case 'symbol':
                    nonNameCurrencyPart = byCurrencyDisplay.symbol;
                    break;
                default:
                    nonNameCurrencyPart = byCurrencyDisplay.narrow;
                    break;
            }
        }
        else {
            // Fallback for unknown currency
            nonNameCurrencyPart = options.currency;
        }
    }
    var numberPattern;
    if (!compactNumberPattern) {
        // Note: if the style is unit, or is currency and the currency display is name,
        // its unit parts will be interpolated in part 2. So here we can fallback to decimal.
        if (style === 'decimal' ||
            style === 'unit' ||
            (style === 'currency' && options.currencyDisplay === 'name')) {
            // Shortcut for decimal
            var decimalData = data.numbers.decimal[numberingSystem] ||
                data.numbers.decimal[defaultNumberingSystem];
            numberPattern = getPatternForSign(decimalData.standard, sign);
        }
        else if (style === 'currency') {
            var currencyData = data.numbers.currency[numberingSystem] ||
                data.numbers.currency[defaultNumberingSystem];
            // We replace number pattern part with `0` for easier postprocessing.
            numberPattern = getPatternForSign(currencyData[options.currencySign], sign);
        }
        else {
            // percent
            var percentPattern = data.numbers.percent[numberingSystem] ||
                data.numbers.percent[defaultNumberingSystem];
            numberPattern = getPatternForSign(percentPattern, sign);
        }
    }
    else {
        numberPattern = compactNumberPattern;
    }
    // Extract the decimal number pattern string. It looks like "#,##0,00", which will later be
    // used to infer decimal group sizes.
    var decimalNumberPattern = CLDR_NUMBER_PATTERN.exec(numberPattern)[0];
    // Now we start to substitute patterns
    // 1. replace strings like `0` and `#,##0.00` with `{0}`
    // 2. unquote characters (invariant: the quoted characters does not contain the special tokens)
    numberPattern = numberPattern
        .replace(CLDR_NUMBER_PATTERN, '{0}')
        .replace(/'(.)'/g, '$1');
    // Handle currency spacing (both compact and non-compact).
    if (style === 'currency' && options.currencyDisplay !== 'name') {
        var currencyData = data.numbers.currency[numberingSystem] ||
            data.numbers.currency[defaultNumberingSystem];
        // See `currencySpacing` substitution rule in TR-35.
        // Here we always assume the currencyMatch is "[:^S:]" and surroundingMatch is "[:digit:]".
        //
        // Example 1: for pattern "#,##0.00¤" with symbol "US$", we replace "¤" with the symbol,
        // but insert an extra non-break space before the symbol, because "[:^S:]" matches "U" in
        // "US$" and "[:digit:]" matches the latn numbering system digits.
        //
        // Example 2: for pattern "¤#,##0.00" with symbol "US$", there is no spacing between symbol
        // and number, because `$` does not match "[:^S:]".
        //
        // Implementation note: here we do the best effort to infer the insertion.
        // We also assume that `beforeInsertBetween` and `afterInsertBetween` will never be `;`.
        var afterCurrency = currencyData.currencySpacing.afterInsertBetween;
        if (afterCurrency && !S_DOLLAR_UNICODE_REGEX.test(nonNameCurrencyPart)) {
            numberPattern = numberPattern.replace('¤{0}', "\u00A4".concat(afterCurrency, "{0}"));
        }
        var beforeCurrency = currencyData.currencySpacing.beforeInsertBetween;
        if (beforeCurrency && !CARET_S_UNICODE_REGEX.test(nonNameCurrencyPart)) {
            numberPattern = numberPattern.replace('{0}¤', "{0}".concat(beforeCurrency, "\u00A4"));
        }
    }
    // The following tokens are special: `{0}`, `¤`, `%`, `-`, `+`, `{c:...}.
    var numberPatternParts = numberPattern.split(/({c:[^}]+}|\{0\}|[¤%\-\+])/g);
    var numberParts = [];
    var symbols = data.numbers.symbols[numberingSystem] ||
        data.numbers.symbols[defaultNumberingSystem];
    for (var _i = 0, numberPatternParts_1 = numberPatternParts; _i < numberPatternParts_1.length; _i++) {
        var part = numberPatternParts_1[_i];
        if (!part) {
            continue;
        }
        switch (part) {
            case '{0}': {
                // We only need to handle scientific and engineering notation here.
                numberParts.push.apply(numberParts, paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, 
                // If compact number pattern exists, do not insert group separators.
                !compactNumberPattern && Boolean(options.useGrouping), decimalNumberPattern));
                break;
            }
            case '-':
                numberParts.push({ type: 'minusSign', value: symbols.minusSign });
                break;
            case '+':
                numberParts.push({ type: 'plusSign', value: symbols.plusSign });
                break;
            case '%':
                numberParts.push({ type: 'percentSign', value: symbols.percentSign });
                break;
            case '¤':
                // Computed above when handling currency spacing.
                numberParts.push({ type: 'currency', value: nonNameCurrencyPart });
                break;
            default:
                if (/^\{c:/.test(part)) {
                    numberParts.push({
                        type: 'compact',
                        value: part.substring(3, part.length - 1),
                    });
                }
                else {
                    // literal
                    numberParts.push({ type: 'literal', value: part });
                }
                break;
        }
    }
    // #endregion
    // #region Part 2: interpolate unit pattern if necessary.
    // ----------------------------------------------
    switch (style) {
        case 'currency': {
            // `currencyDisplay: 'name'` has similar pattern handling as units.
            if (options.currencyDisplay === 'name') {
                var unitPattern = (data.numbers.currency[numberingSystem] ||
                    data.numbers.currency[defaultNumberingSystem]).unitPattern;
                // Select plural
                var unitName = void 0;
                var currencyNameData = data.currencies[options.currency];
                if (currencyNameData) {
                    unitName = selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), currencyNameData.displayName);
                }
                else {
                    // Fallback for unknown currency
                    unitName = options.currency;
                }
                // Do {0} and {1} substitution
                var unitPatternParts = unitPattern.split(/(\{[01]\})/g);
                var result = [];
                for (var _a = 0, unitPatternParts_1 = unitPatternParts; _a < unitPatternParts_1.length; _a++) {
                    var part = unitPatternParts_1[_a];
                    switch (part) {
                        case '{0}':
                            result.push.apply(result, numberParts);
                            break;
                        case '{1}':
                            result.push({ type: 'currency', value: unitName });
                            break;
                        default:
                            if (part) {
                                result.push({ type: 'literal', value: part });
                            }
                            break;
                    }
                }
                return result;
            }
            else {
                return numberParts;
            }
        }
        case 'unit': {
            var unit = options.unit, unitDisplay = options.unitDisplay;
            var unitData = data.units.simple[unit];
            var unitPattern = void 0;
            if (unitData) {
                // Simple unit pattern
                unitPattern = selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[unit][unitDisplay]);
            }
            else {
                // See: http://unicode.org/reports/tr35/tr35-general.html#perUnitPatterns
                // If cannot find unit in the simple pattern, it must be "per" compound pattern.
                // Implementation note: we are not following TR-35 here because we need to format to parts!
                var _b = unit.split('-per-'), numeratorUnit = _b[0], denominatorUnit = _b[1];
                unitData = data.units.simple[numeratorUnit];
                var numeratorUnitPattern = selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[numeratorUnit][unitDisplay]);
                var perUnitPattern = data.units.simple[denominatorUnit].perUnit[unitDisplay];
                if (perUnitPattern) {
                    // perUnitPattern exists, combine it with numeratorUnitPattern
                    unitPattern = perUnitPattern.replace('{0}', numeratorUnitPattern);
                }
                else {
                    // get compoundUnit pattern (e.g. "{0} per {1}"), repalce {0} with numerator pattern and {1} with
                    // the denominator pattern in singular form.
                    var perPattern = data.units.compound.per[unitDisplay];
                    var denominatorPattern = selectPlural(pl, 1, data.units.simple[denominatorUnit][unitDisplay]);
                    unitPattern = unitPattern = perPattern
                        .replace('{0}', numeratorUnitPattern)
                        .replace('{1}', denominatorPattern.replace('{0}', ''));
                }
            }
            var result = [];
            // We need spacing around "{0}" because they are not treated as "unit" parts, but "literal".
            for (var _c = 0, _d = unitPattern.split(/(\s*\{0\}\s*)/); _c < _d.length; _c++) {
                var part = _d[_c];
                var interpolateMatch = /^(\s*)\{0\}(\s*)$/.exec(part);
                if (interpolateMatch) {
                    // Space before "{0}"
                    if (interpolateMatch[1]) {
                        result.push({ type: 'literal', value: interpolateMatch[1] });
                    }
                    // "{0}" itself
                    result.push.apply(result, numberParts);
                    // Space after "{0}"
                    if (interpolateMatch[2]) {
                        result.push({ type: 'literal', value: interpolateMatch[2] });
                    }
                }
                else if (part) {
                    result.push({ type: 'unit', value: part });
                }
            }
            return result;
        }
        default:
            return numberParts;
    }
    // #endregion
}
// A subset of https://tc39.es/ecma402/#sec-partitionnotationsubpattern
// Plus the exponent parts handling.
function paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, useGrouping, 
/**
 * This is the decimal number pattern without signs or symbols.
 * It is used to infer the group size when `useGrouping` is true.
 *
 * A typical value looks like "#,##0.00" (primary group size is 3).
 * Some locales like Hindi has secondary group size of 2 (e.g. "#,##,##0.00").
 */
decimalNumberPattern) {
    var result = [];
    // eslint-disable-next-line prefer-const
    var n = numberResult.formattedString, x = numberResult.roundedNumber;
    if (isNaN(x)) {
        return [{ type: 'nan', value: n }];
    }
    else if (!isFinite(x)) {
        return [{ type: 'infinity', value: n }];
    }
    var digitReplacementTable = digitMapping[numberingSystem];
    if (digitReplacementTable) {
        n = n.replace(/\d/g, function (digit) { return digitReplacementTable[+digit] || digit; });
    }
    // TODO: Else use an implementation dependent algorithm to map n to the appropriate
    // representation of n in the given numbering system.
    var decimalSepIndex = n.indexOf('.');
    var integer;
    var fraction;
    if (decimalSepIndex > 0) {
        integer = n.slice(0, decimalSepIndex);
        fraction = n.slice(decimalSepIndex + 1);
    }
    else {
        integer = n;
    }
    // #region Grouping integer digits
    // The weird compact and x >= 10000 check is to ensure consistency with Node.js and Chrome.
    // Note that `de` does not have compact form for thousands, but Node.js does not insert grouping separator
    // unless the rounded number is greater than 10000:
    //   NumberFormat('de', {notation: 'compact', compactDisplay: 'short'}).format(1234) //=> "1234"
    //   NumberFormat('de').format(1234) //=> "1.234"
    if (useGrouping && (notation !== 'compact' || x >= 10000)) {
        var groupSepSymbol = symbols.group;
        var groups = [];
        // > There may be two different grouping sizes: The primary grouping size used for the least
        // > significant integer group, and the secondary grouping size used for more significant groups.
        // > If a pattern contains multiple grouping separators, the interval between the last one and the
        // > end of the integer defines the primary grouping size, and the interval between the last two
        // > defines the secondary grouping size. All others are ignored.
        var integerNumberPattern = decimalNumberPattern.split('.')[0];
        var patternGroups = integerNumberPattern.split(',');
        var primaryGroupingSize = 3;
        var secondaryGroupingSize = 3;
        if (patternGroups.length > 1) {
            primaryGroupingSize = patternGroups[patternGroups.length - 1].length;
        }
        if (patternGroups.length > 2) {
            secondaryGroupingSize = patternGroups[patternGroups.length - 2].length;
        }
        var i = integer.length - primaryGroupingSize;
        if (i > 0) {
            // Slice the least significant integer group
            groups.push(integer.slice(i, i + primaryGroupingSize));
            // Then iteratively push the more signicant groups
            // TODO: handle surrogate pairs in some numbering system digits
            for (i -= secondaryGroupingSize; i > 0; i -= secondaryGroupingSize) {
                groups.push(integer.slice(i, i + secondaryGroupingSize));
            }
            groups.push(integer.slice(0, i + secondaryGroupingSize));
        }
        else {
            groups.push(integer);
        }
        while (groups.length > 0) {
            var integerGroup = groups.pop();
            result.push({ type: 'integer', value: integerGroup });
            if (groups.length > 0) {
                result.push({ type: 'group', value: groupSepSymbol });
            }
        }
    }
    else {
        result.push({ type: 'integer', value: integer });
    }
    // #endregion
    if (fraction !== undefined) {
        result.push({ type: 'decimal', value: symbols.decimal }, { type: 'fraction', value: fraction });
    }
    if ((notation === 'scientific' || notation === 'engineering') &&
        isFinite(x)) {
        result.push({ type: 'exponentSeparator', value: symbols.exponential });
        if (exponent < 0) {
            result.push({ type: 'exponentMinusSign', value: symbols.minusSign });
            exponent = -exponent;
        }
        var exponentResult = ToRawFixed(exponent, 0, 0);
        result.push({
            type: 'exponentInteger',
            value: exponentResult.formattedString,
        });
    }
    return result;
}
function getPatternForSign(pattern, sign) {
    if (pattern.indexOf(';') < 0) {
        pattern = "".concat(pattern, ";-").concat(pattern);
    }
    var _a = pattern.split(';'), zeroPattern = _a[0], negativePattern = _a[1];
    switch (sign) {
        case 0:
            return zeroPattern;
        case -1:
            return negativePattern;
        default:
            return negativePattern.indexOf('-') >= 0
                ? negativePattern.replace(/-/g, '+')
                : "+".concat(zeroPattern);
    }
}
// Find the CLDR pattern for compact notation based on the magnitude of data and style.
//
// Example return value: "¤ {c:laki}000;¤{c:laki} -0" (`sw` locale):
// - Notice the `{c:...}` token that wraps the compact literal.
// - The consecutive zeros are normalized to single zero to match CLDR_NUMBER_PATTERN.
//
// Returning null means the compact display pattern cannot be found.
function getCompactDisplayPattern(numberResult, pl, data, style, compactDisplay, currencyDisplay, numberingSystem) {
    var _a;
    var roundedNumber = numberResult.roundedNumber, sign = numberResult.sign, magnitude = numberResult.magnitude;
    var magnitudeKey = String(Math.pow(10, magnitude));
    var defaultNumberingSystem = data.numbers.nu[0];
    var pattern;
    if (style === 'currency' && currencyDisplay !== 'name') {
        var byNumberingSystem = data.numbers.currency;
        var currencyData = byNumberingSystem[numberingSystem] ||
            byNumberingSystem[defaultNumberingSystem];
        // NOTE: compact notation ignores currencySign!
        var compactPluralRules = (_a = currencyData.short) === null || _a === void 0 ? void 0 : _a[magnitudeKey];
        if (!compactPluralRules) {
            return null;
        }
        pattern = selectPlural(pl, roundedNumber, compactPluralRules);
    }
    else {
        var byNumberingSystem = data.numbers.decimal;
        var byCompactDisplay = byNumberingSystem[numberingSystem] ||
            byNumberingSystem[defaultNumberingSystem];
        var compactPlaralRule = byCompactDisplay[compactDisplay][magnitudeKey];
        if (!compactPlaralRule) {
            return null;
        }
        pattern = selectPlural(pl, roundedNumber, compactPlaralRule);
    }
    // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
    // > If the value is precisely “0”, either explicit or defaulted, then the normal number format
    // > pattern for that sort of object is supplied.
    if (pattern === '0') {
        return null;
    }
    pattern = getPatternForSign(pattern, sign)
        // Extract compact literal from the pattern
        .replace(/([^\s;\-\+\d¤]+)/g, '{c:$1}')
        // We replace one or more zeros with a single zero so it matches `CLDR_NUMBER_PATTERN`.
        .replace(/0+/, '0');
    return pattern;
}
function selectPlural(pl, x, rules) {
    return rules[pl.select(x)] || rules.other;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/PartitionNumberPattern.js




/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */
function PartitionNumberPattern(numberFormat, x, _a) {
    var _b;
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var pl = internalSlots.pl, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    var symbols = dataLocaleData.numbers.symbols[numberingSystem] ||
        dataLocaleData.numbers.symbols[dataLocaleData.numbers.nu[0]];
    var magnitude = 0;
    var exponent = 0;
    var n;
    if (isNaN(x)) {
        n = symbols.nan;
    }
    else if (x == Number.POSITIVE_INFINITY || x == Number.NEGATIVE_INFINITY) {
        n = symbols.infinity;
    }
    else {
        if (!SameValue(x, -0)) {
            if (!isFinite(x)) {
                throw new Error('Input must be a mathematical value');
            }
            if (internalSlots.style == 'percent') {
                x *= 100;
            }
            ;
            _b = ComputeExponent(numberFormat, x, {
                getInternalSlots: getInternalSlots,
            }), exponent = _b[0], magnitude = _b[1];
            // Preserve more precision by doing multiplication when exponent is negative.
            x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
        }
        var formatNumberResult = FormatNumericToString(internalSlots, x);
        n = formatNumberResult.formattedString;
        x = formatNumberResult.roundedNumber;
    }
    // Based on https://tc39.es/ecma402/#sec-getnumberformatpattern
    // We need to do this before `x` is rounded.
    var sign;
    var signDisplay = internalSlots.signDisplay;
    switch (signDisplay) {
        case 'never':
            sign = 0;
            break;
        case 'auto':
            if (SameValue(x, 0) || x > 0 || isNaN(x)) {
                sign = 0;
            }
            else {
                sign = -1;
            }
            break;
        case 'always':
            if (SameValue(x, 0) || x > 0 || isNaN(x)) {
                sign = 1;
            }
            else {
                sign = -1;
            }
            break;
        default:
            // x === 0 -> x is 0 or x is -0
            if (x === 0 || isNaN(x)) {
                sign = 0;
            }
            else if (x > 0) {
                sign = 1;
            }
            else {
                sign = -1;
            }
    }
    return formatToParts({ roundedNumber: x, formattedString: n, exponent: exponent, magnitude: magnitude, sign: sign }, internalSlots.dataLocaleData, pl, internalSlots);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/PartitionNumberRangePattern.js



/**
 * https://tc39.es/ecma402/#sec-partitionnumberrangepattern
 */
function PartitionNumberRangePattern(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (isNaN(x) || isNaN(y)) {
        throw new RangeError('Input must be a number');
    }
    var result = [];
    var xResult = PartitionNumberPattern(numberFormat, x, { getInternalSlots: getInternalSlots });
    var yResult = PartitionNumberPattern(numberFormat, y, { getInternalSlots: getInternalSlots });
    if (xResult === yResult) {
        return FormatApproximately(numberFormat, xResult, { getInternalSlots: getInternalSlots });
    }
    for (var _i = 0, xResult_1 = xResult; _i < xResult_1.length; _i++) {
        var r = xResult_1[_i];
        r.source = 'startRange';
    }
    result = result.concat(xResult);
    var internalSlots = getInternalSlots(numberFormat);
    var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
    result.push({ type: 'literal', value: symbols.rangeSign, source: 'shared' });
    for (var _b = 0, yResult_1 = yResult; _b < yResult_1.length; _b++) {
        var r = yResult_1[_b];
        r.source = 'endRange';
    }
    result = result.concat(yResult);
    return CollapseNumberRange(result);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/FormatNumericRange.js

/**
 * https://tc39.es/ecma402/#sec-formatnumericrange
 */
function FormatNumericRange(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var parts = PartitionNumberRangePattern(numberFormat, x, y, {
        getInternalSlots: getInternalSlots,
    });
    return parts.map(function (part) { return part.value; }).join('');
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/FormatNumericRangeToParts.js

/**
 * https://tc39.es/ecma402/#sec-formatnumericrangetoparts
 */
function FormatNumericRangeToParts(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var parts = PartitionNumberRangePattern(numberFormat, x, y, {
        getInternalSlots: getInternalSlots,
    });
    return parts.map(function (part, index) { return ({
        type: part.type,
        value: part.value,
        source: part.source,
        result: index.toString(),
    }); });
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/FormatNumericToParts.js


function FormatNumericToParts(nf, x, implDetails) {
    var parts = PartitionNumberPattern(nf, x, implDetails);
    var result = ArrayCreate(0);
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        result.push({
            type: part.type,
            value: part.value,
        });
    }
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/GetUnsignedRoundingMode.js
var negativeMapping = {
    ceil: 'zero',
    floor: 'infinity',
    expand: 'infinity',
    trunc: 'zero',
    halfCeil: 'half-zero',
    halfFloor: 'half-infinity',
    halfExpand: 'half-infinity',
    halfTrunc: 'half-zero',
    halfEven: 'half-even',
};
var positiveMapping = {
    ceil: 'infinity',
    floor: 'zero',
    expand: 'infinity',
    trunc: 'zero',
    halfCeil: 'half-infinity',
    halfFloor: 'half-zero',
    halfExpand: 'half-infinity',
    halfTrunc: 'half-zero',
    halfEven: 'half-even',
};
function GetUnsignedRoundingMode(roundingMode, isNegative) {
    if (isNegative) {
        return negativeMapping[roundingMode];
    }
    return positiveMapping[roundingMode];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl-localematcher/lib/abstract/utils.js
var utils_UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function utils_invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl-localematcher/lib/abstract/BestAvailableLocale.js
/**
 * https://tc39.es/ecma402/#sec-bestavailablelocale
 * @param availableLocales
 * @param locale
 */
function BestAvailableLocale(availableLocales, locale) {
    var candidate = locale;
    while (true) {
        if (availableLocales.has(candidate)) {
            return candidate;
        }
        var pos = candidate.lastIndexOf('-');
        if (!~pos) {
            return undefined;
        }
        if (pos >= 2 && candidate[pos - 2] === '-') {
            pos -= 2;
        }
        candidate = candidate.slice(0, pos);
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl-localematcher/lib/abstract/LookupMatcher.js


/**
 * https://tc39.es/ecma402/#sec-lookupmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */
function LookupMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var result = { locale: '' };
    for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace(utils_UNICODE_EXTENSION_SEQUENCE_REGEX, '');
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionLocale);
        if (availableLocale) {
            result.locale = availableLocale;
            if (locale !== noExtensionLocale) {
                result.extension = locale.slice(noExtensionLocale.length + 1, locale.length);
            }
            return result;
        }
    }
    result.locale = getDefaultLocale();
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl-localematcher/lib/abstract/BestFitMatcher.js


/**
 * https://tc39.es/ecma402/#sec-bestfitmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */
function BestFitMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var minimizedAvailableLocaleMap = {};
    var availableLocaleMap = {};
    var canonicalizedLocaleMap = {};
    var minimizedAvailableLocales = new Set();
    availableLocales.forEach(function (locale) {
        var minimizedLocale = new Intl.Locale(locale)
            .minimize()
            .toString();
        var canonicalizedLocale = Intl.getCanonicalLocales(locale)[0] || locale;
        minimizedAvailableLocaleMap[minimizedLocale] = locale;
        availableLocaleMap[locale] = locale;
        canonicalizedLocaleMap[canonicalizedLocale] = locale;
        minimizedAvailableLocales.add(minimizedLocale);
        minimizedAvailableLocales.add(locale);
        minimizedAvailableLocales.add(canonicalizedLocale);
    });
    var foundLocale;
    for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
        var l = requestedLocales_1[_i];
        if (foundLocale) {
            break;
        }
        var noExtensionLocale = l.replace(utils_UNICODE_EXTENSION_SEQUENCE_REGEX, '');
        if (availableLocales.has(noExtensionLocale)) {
            foundLocale = noExtensionLocale;
            break;
        }
        if (minimizedAvailableLocales.has(noExtensionLocale)) {
            foundLocale = noExtensionLocale;
            break;
        }
        var locale = new Intl.Locale(noExtensionLocale);
        var maximizedRequestedLocale = locale.maximize().toString();
        var minimizedRequestedLocale = locale.minimize().toString();
        // Check minimized locale
        if (minimizedAvailableLocales.has(minimizedRequestedLocale)) {
            foundLocale = minimizedRequestedLocale;
            break;
        }
        // Lookup algo on maximized locale
        foundLocale = BestAvailableLocale(minimizedAvailableLocales, maximizedRequestedLocale);
    }
    if (!foundLocale) {
        return { locale: getDefaultLocale() };
    }
    return {
        locale: availableLocaleMap[foundLocale] ||
            canonicalizedLocaleMap[foundLocale] ||
            minimizedAvailableLocaleMap[foundLocale] ||
            foundLocale,
    };
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl-localematcher/lib/abstract/UnicodeExtensionValue.js

/**
 * https://tc39.es/ecma402/#sec-unicodeextensionvalue
 * @param extension
 * @param key
 */
function UnicodeExtensionValue(extension, key) {
    utils_invariant(key.length === 2, 'key must have 2 elements');
    var size = extension.length;
    var searchValue = "-".concat(key, "-");
    var pos = extension.indexOf(searchValue);
    if (pos !== -1) {
        var start = pos + 4;
        var end = start;
        var k = start;
        var done = false;
        while (!done) {
            var e = extension.indexOf('-', k);
            var len = void 0;
            if (e === -1) {
                len = size - k;
            }
            else {
                len = e - k;
            }
            if (len === 2) {
                done = true;
            }
            else if (e === -1) {
                end = size;
                done = true;
            }
            else {
                end = e;
                k = e + 1;
            }
        }
        return extension.slice(start, end);
    }
    searchValue = "-".concat(key);
    pos = extension.indexOf(searchValue);
    if (pos !== -1 && pos + 3 === size) {
        return '';
    }
    return undefined;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl-localematcher/lib/abstract/ResolveLocale.js




/**
 * https://tc39.es/ecma402/#sec-resolvelocale
 */
function ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData, getDefaultLocale) {
    var matcher = options.localeMatcher;
    var r;
    if (matcher === 'lookup') {
        r = LookupMatcher(availableLocales, requestedLocales, getDefaultLocale);
    }
    else {
        r = BestFitMatcher(availableLocales, requestedLocales, getDefaultLocale);
    }
    var foundLocale = r.locale;
    var result = { locale: '', dataLocale: foundLocale };
    var supportedExtension = '-u';
    for (var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++) {
        var key = relevantExtensionKeys_1[_i];
        utils_invariant(foundLocale in localeData, "Missing locale data for ".concat(foundLocale));
        var foundLocaleData = localeData[foundLocale];
        utils_invariant(typeof foundLocaleData === 'object' && foundLocaleData !== null, "locale data ".concat(key, " must be an object"));
        var keyLocaleData = foundLocaleData[key];
        utils_invariant(Array.isArray(keyLocaleData), "keyLocaleData for ".concat(key, " must be an array"));
        var value = keyLocaleData[0];
        utils_invariant(typeof value === 'string' || value === null, "value must be string or null but got ".concat(typeof value, " in key ").concat(key));
        var supportedExtensionAddition = '';
        if (r.extension) {
            var requestedValue = UnicodeExtensionValue(r.extension, key);
            if (requestedValue !== undefined) {
                if (requestedValue !== '') {
                    if (~keyLocaleData.indexOf(requestedValue)) {
                        value = requestedValue;
                        supportedExtensionAddition = "-".concat(key, "-").concat(value);
                    }
                }
                else if (~requestedValue.indexOf('true')) {
                    value = 'true';
                    supportedExtensionAddition = "-".concat(key);
                }
            }
        }
        if (key in options) {
            var optionsValue = options[key];
            utils_invariant(typeof optionsValue === 'string' ||
                typeof optionsValue === 'undefined' ||
                optionsValue === null, 'optionsValue must be String, Undefined or Null');
            if (~keyLocaleData.indexOf(optionsValue)) {
                if (optionsValue !== value) {
                    value = optionsValue;
                    supportedExtensionAddition = '';
                }
            }
        }
        result[key] = value;
        supportedExtension += supportedExtensionAddition;
    }
    if (supportedExtension.length > 2) {
        var privateIndex = foundLocale.indexOf('-x-');
        if (privateIndex === -1) {
            foundLocale = foundLocale + supportedExtension;
        }
        else {
            var preExtension = foundLocale.slice(0, privateIndex);
            var postExtension = foundLocale.slice(privateIndex, foundLocale.length);
            foundLocale = preExtension + supportedExtension + postExtension;
        }
        foundLocale = Intl.getCanonicalLocales(foundLocale)[0];
    }
    result.locale = foundLocale;
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/SetNumberFormatUnitOptions.js



/**
 * https://tc39.es/ecma402/#sec-setnumberformatunitoptions
 */
function SetNumberFormatUnitOptions(nf, options, _a) {
    if (options === void 0) { options = Object.create(null); }
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(nf);
    var style = GetOption(options, 'style', 'string', ['decimal', 'percent', 'currency', 'unit'], 'decimal');
    internalSlots.style = style;
    var currency = GetOption(options, 'currency', 'string', undefined, undefined);
    if (currency !== undefined && !IsWellFormedCurrencyCode(currency)) {
        throw RangeError('Malformed currency code');
    }
    if (style === 'currency' && currency === undefined) {
        throw TypeError('currency cannot be undefined');
    }
    var currencyDisplay = GetOption(options, 'currencyDisplay', 'string', ['code', 'symbol', 'narrowSymbol', 'name'], 'symbol');
    var currencySign = GetOption(options, 'currencySign', 'string', ['standard', 'accounting'], 'standard');
    var unit = GetOption(options, 'unit', 'string', undefined, undefined);
    if (unit !== undefined && !IsWellFormedUnitIdentifier(unit)) {
        throw RangeError('Invalid unit argument for Intl.NumberFormat()');
    }
    if (style === 'unit' && unit === undefined) {
        throw TypeError('unit cannot be undefined');
    }
    var unitDisplay = GetOption(options, 'unitDisplay', 'string', ['short', 'narrow', 'long'], 'short');
    if (style === 'currency') {
        internalSlots.currency = currency.toUpperCase();
        internalSlots.currencyDisplay = currencyDisplay;
        internalSlots.currencySign = currencySign;
    }
    if (style === 'unit') {
        internalSlots.unit = unit;
        internalSlots.unitDisplay = unitDisplay;
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/SetNumberFormatDigitOptions.js



/**
 * https://tc39.es/ecma402/#sec-setnfdigitoptions
 */
function SetNumberFormatDigitOptions(internalSlots, opts, mnfdDefault, mxfdDefault, notation) {
    var mnid = GetNumberOption(opts, 'minimumIntegerDigits', 1, 21, 1);
    var mnfd = opts.minimumFractionDigits;
    var mxfd = opts.maximumFractionDigits;
    var mnsd = opts.minimumSignificantDigits;
    var mxsd = opts.maximumSignificantDigits;
    internalSlots.minimumIntegerDigits = mnid;
    var roundingPriority = GetOption(opts, 'roundingPriority', 'string', ['auto', 'morePrecision', 'lessPrecision'], 'auto');
    var hasSd = mnsd !== undefined || mxsd !== undefined;
    var hasFd = mnfd !== undefined || mxfd !== undefined;
    var needSd = true;
    var needFd = true;
    if (roundingPriority === 'auto') {
        needSd = hasSd;
        if (hasSd || (!hasFd && notation === 'compact')) {
            needFd = false;
        }
    }
    if (needSd) {
        if (hasSd) {
            mnsd = DefaultNumberOption(mnsd, 1, 21, 1);
            mxsd = DefaultNumberOption(mxsd, mnsd, 21, 21);
            internalSlots.minimumSignificantDigits = mnsd;
            internalSlots.maximumSignificantDigits = mxsd;
        }
        else {
            internalSlots.minimumSignificantDigits = 1;
            internalSlots.maximumSignificantDigits = 21;
        }
    }
    if (needFd) {
        if (hasFd) {
            // @ts-expect-error
            mnfd = DefaultNumberOption(mnfd, 0, 20, undefined);
            // @ts-expect-error
            mxfd = DefaultNumberOption(mxfd, 0, 20, undefined);
            if (mnfd === undefined) {
                mnfd = Math.min(mnfdDefault, mxfd);
            }
            else if (mxfd === undefined) {
                mxfd = Math.max(mxfdDefault, mnfd);
            }
            else if (mnfd > mxfd) {
                throw new RangeError("Invalid range, ".concat(mnfd, " > ").concat(mxfd));
            }
            internalSlots.minimumFractionDigits = mnfd;
            internalSlots.maximumFractionDigits = mxfd;
        }
        else {
            internalSlots.minimumFractionDigits = mnfdDefault;
            internalSlots.maximumFractionDigits = mxfdDefault;
        }
    }
    if (needSd || needFd) {
        if (roundingPriority === 'morePrecision') {
            internalSlots.roundingType = 'morePrecision';
        }
        else if (roundingPriority === 'lessPrecision') {
            internalSlots.roundingType = 'lessPrecision';
        }
        else if (hasSd) {
            internalSlots.roundingType = 'significantDigits';
        }
        else {
            internalSlots.roundingType = 'fractionDigits';
        }
    }
    else {
        internalSlots.roundingType = 'morePrecision';
        internalSlots.minimumFractionDigits = 0;
        internalSlots.maximumFractionDigits = 0;
        internalSlots.minimumSignificantDigits = 1;
        internalSlots.maximumSignificantDigits = 2;
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/NumberFormat/InitializeNumberFormat.js










var VALID_ROUND_INCREMENT_VALUES = [
    1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500, 1000, 2000,
];
/**
 * https://tc39.es/ecma402/#sec-initializenumberformat
 */
function InitializeNumberFormat(nf, locales, opts, _a) {
    var getInternalSlots = _a.getInternalSlots, localeData = _a.localeData, availableLocales = _a.availableLocales, numberingSystemNames = _a.numberingSystemNames, getDefaultLocale = _a.getDefaultLocale, currencyDigitsData = _a.currencyDigitsData;
    // @ts-ignore
    var requestedLocales = CanonicalizeLocaleList(locales);
    var options = CoerceOptionsToObject(opts);
    var opt = Object.create(null);
    var matcher = GetOption(options, 'localeMatcher', 'string', ['lookup', 'best fit'], 'best fit');
    opt.localeMatcher = matcher;
    var numberingSystem = GetOption(options, 'numberingSystem', 'string', undefined, undefined);
    if (numberingSystem !== undefined &&
        numberingSystemNames.indexOf(numberingSystem) < 0) {
        // 8.a. If numberingSystem does not match the Unicode Locale Identifier type nonterminal,
        // throw a RangeError exception.
        throw RangeError("Invalid numberingSystems: ".concat(numberingSystem));
    }
    opt.nu = numberingSystem;
    var r = ResolveLocale(availableLocales, requestedLocales, opt, 
    // [[RelevantExtensionKeys]] slot, which is a constant
    ['nu'], localeData, getDefaultLocale);
    var dataLocaleData = localeData[r.dataLocale];
    invariant(!!dataLocaleData, "Missing locale data for ".concat(r.dataLocale));
    var internalSlots = getInternalSlots(nf);
    internalSlots.locale = r.locale;
    internalSlots.dataLocale = r.dataLocale;
    internalSlots.numberingSystem = r.nu;
    internalSlots.dataLocaleData = dataLocaleData;
    SetNumberFormatUnitOptions(nf, options, { getInternalSlots: getInternalSlots });
    var style = internalSlots.style;
    var mnfdDefault;
    var mxfdDefault;
    if (style === 'currency') {
        var currency = internalSlots.currency;
        var cDigits = CurrencyDigits(currency, { currencyDigitsData: currencyDigitsData });
        mnfdDefault = cDigits;
        mxfdDefault = cDigits;
    }
    else {
        mnfdDefault = 0;
        mxfdDefault = style === 'percent' ? 0 : 3;
    }
    var notation = GetOption(options, 'notation', 'string', ['standard', 'scientific', 'engineering', 'compact'], 'standard');
    internalSlots.notation = notation;
    SetNumberFormatDigitOptions(internalSlots, options, mnfdDefault, mxfdDefault, notation);
    var roundingIncrement = GetNumberOption(options, 'roundingIncrement', 1, 5000, 1);
    if (VALID_ROUND_INCREMENT_VALUES.indexOf(roundingIncrement) === -1) {
        throw new RangeError("Invalid rounding increment value: ".concat(roundingIncrement, ".\nValid values are ").concat(VALID_ROUND_INCREMENT_VALUES, "."));
    }
    if (roundingIncrement !== 1 &&
        internalSlots.roundingType !== 'fractionDigits') {
        throw new TypeError("For roundingIncrement > 1 only fractionDigits is a valid roundingType");
    }
    if (roundingIncrement !== 1 &&
        internalSlots.maximumFractionDigits !== internalSlots.minimumFractionDigits) {
        throw new RangeError('With roundingIncrement > 1, maximumFractionDigits and minimumFractionDigits must be equal.');
    }
    internalSlots.roundingIncrement = roundingIncrement;
    var trailingZeroDisplay = GetOption(options, 'trailingZeroDisplay', 'string', ['auto', 'stripIfInteger'], 'auto');
    internalSlots.trailingZeroDisplay = trailingZeroDisplay;
    var compactDisplay = GetOption(options, 'compactDisplay', 'string', ['short', 'long'], 'short');
    var defaultUseGrouping = 'auto';
    if (notation === 'compact') {
        internalSlots.compactDisplay = compactDisplay;
        defaultUseGrouping = 'min2';
    }
    internalSlots.useGrouping = GetStringOrBooleanOption(options, 'useGrouping', ['min2', 'auto', 'always'], 'always', false, defaultUseGrouping);
    internalSlots.signDisplay = GetOption(options, 'signDisplay', 'string', ['auto', 'never', 'always', 'exceptZero', 'negative'], 'auto');
    internalSlots.roundingMode = GetOption(options, 'roundingMode', 'string', [
        'ceil',
        'floor',
        'expand',
        'trunc',
        'halfCeil',
        'halfFloor',
        'halfExpand',
        'halfTrunc',
        'halfEven',
    ], 'halfExpand');
    return nf;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/PartitionPattern.js

/**
 * https://tc39.es/ecma402/#sec-partitionpattern
 * @param pattern
 */
function PartitionPattern(pattern) {
    var result = [];
    var beginIndex = pattern.indexOf('{');
    var endIndex = 0;
    var nextIndex = 0;
    var length = pattern.length;
    while (beginIndex < pattern.length && beginIndex > -1) {
        endIndex = pattern.indexOf('}', beginIndex);
        invariant(endIndex > beginIndex, "Invalid pattern ".concat(pattern));
        if (beginIndex > nextIndex) {
            result.push({
                type: 'literal',
                value: pattern.substring(nextIndex, beginIndex),
            });
        }
        result.push({
            type: pattern.substring(beginIndex + 1, endIndex),
            value: undefined,
        });
        nextIndex = endIndex + 1;
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    if (nextIndex < length) {
        result.push({
            type: 'literal',
            value: pattern.substring(nextIndex, length),
        });
    }
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl-localematcher/lib/abstract/LookupSupportedLocales.js


/**
 * https://tc39.es/ecma402/#sec-lookupsupportedlocales
 * @param availableLocales
 * @param requestedLocales
 */
function LookupSupportedLocales(availableLocales, requestedLocales) {
    var subset = [];
    for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace(utils_UNICODE_EXTENSION_SEQUENCE_REGEX, '');
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionLocale);
        if (availableLocale) {
            subset.push(availableLocale);
        }
    }
    return subset;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/SupportedLocales.js



/**
 * https://tc39.es/ecma402/#sec-supportedlocales
 * @param availableLocales
 * @param requestedLocales
 * @param options
 */
function SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = 'best fit';
    if (options !== undefined) {
        options = ToObject(options);
        matcher = GetOption(options, 'localeMatcher', 'string', ['lookup', 'best fit'], 'best fit');
    }
    if (matcher === 'best fit') {
        return LookupSupportedLocales(availableLocales, requestedLocales);
    }
    return LookupSupportedLocales(availableLocales, requestedLocales);
}

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/data.js

var MissingLocaleDataError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(MissingLocaleDataError, _super);
    function MissingLocaleDataError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'MISSING_LOCALE_DATA';
        return _this;
    }
    return MissingLocaleDataError;
}(Error));
function isMissingLocaleDataError(e) {
    return e.type === 'MISSING_LOCALE_DATA';
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/types/date-time.js
var RangePatternType;
(function (RangePatternType) {
    RangePatternType["startRange"] = "startRange";
    RangePatternType["shared"] = "shared";
    RangePatternType["endRange"] = "endRange";
})(RangePatternType || (RangePatternType = {}));

;// CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/index.js












































/***/ }),

/***/ 89097:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isUnicodeLanguageSubtag = exports.isUnicodeScriptSubtag = exports.isUnicodeRegionSubtag = exports.isStructurallyValidLanguageTag = exports.parseUnicodeLanguageId = exports.parseUnicodeLocaleId = exports.getCanonicalLocales = void 0;
var tslib_1 = __webpack_require__(70655);
var parser_1 = __webpack_require__(18371);
var emitter_1 = __webpack_require__(60825);
var canonicalizer_1 = __webpack_require__(69391);
/**
 * https://tc39.es/ecma402/#sec-canonicalizelocalelist
 * @param locales
 */
function CanonicalizeLocaleList(locales) {
    if (locales === undefined) {
        return [];
    }
    var seen = [];
    if (typeof locales === 'string') {
        locales = [locales];
    }
    for (var _i = 0, locales_1 = locales; _i < locales_1.length; _i++) {
        var locale = locales_1[_i];
        var canonicalizedTag = (0, emitter_1.emitUnicodeLocaleId)((0, canonicalizer_1.canonicalizeUnicodeLocaleId)((0, parser_1.parseUnicodeLocaleId)(locale)));
        if (seen.indexOf(canonicalizedTag) < 0) {
            seen.push(canonicalizedTag);
        }
    }
    return seen;
}
function getCanonicalLocales(locales) {
    return CanonicalizeLocaleList(locales);
}
exports.getCanonicalLocales = getCanonicalLocales;
var parser_2 = __webpack_require__(18371);
Object.defineProperty(exports, "parseUnicodeLocaleId", ({ enumerable: true, get: function () { return parser_2.parseUnicodeLocaleId; } }));
Object.defineProperty(exports, "parseUnicodeLanguageId", ({ enumerable: true, get: function () { return parser_2.parseUnicodeLanguageId; } }));
Object.defineProperty(exports, "isStructurallyValidLanguageTag", ({ enumerable: true, get: function () { return parser_2.isStructurallyValidLanguageTag; } }));
Object.defineProperty(exports, "isUnicodeRegionSubtag", ({ enumerable: true, get: function () { return parser_2.isUnicodeRegionSubtag; } }));
Object.defineProperty(exports, "isUnicodeScriptSubtag", ({ enumerable: true, get: function () { return parser_2.isUnicodeScriptSubtag; } }));
Object.defineProperty(exports, "isUnicodeLanguageSubtag", ({ enumerable: true, get: function () { return parser_2.isUnicodeLanguageSubtag; } }));
tslib_1.__exportStar(__webpack_require__(539), exports);
tslib_1.__exportStar(__webpack_require__(60825), exports);
tslib_1.__exportStar(__webpack_require__(43020), exports);


/***/ }),

/***/ 71692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var _1 = __webpack_require__(89097);
var should_polyfill_1 = __webpack_require__(65010);
if (typeof Intl === 'undefined') {
    if (typeof window !== 'undefined') {
        Object.defineProperty(window, 'Intl', {
            value: {},
        });
        // @ts-ignore we don't include @types/node so global isn't a thing
    }
    else if (typeof __webpack_require__.g !== 'undefined') {
        // @ts-ignore we don't include @types/node so global isn't a thing
        Object.defineProperty(__webpack_require__.g, 'Intl', {
            value: {},
        });
    }
}
if ((0, should_polyfill_1.shouldPolyfill)()) {
    Object.defineProperty(Intl, 'getCanonicalLocales', {
        value: _1.getCanonicalLocales,
        writable: true,
        enumerable: false,
        configurable: true,
    });
}


/***/ }),

/***/ 65010:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shouldPolyfill = void 0;
function shouldPolyfill() {
    return (typeof Intl === 'undefined' ||
        !('getCanonicalLocales' in Intl) ||
        // Native Intl.getCanonicalLocales is just buggy
        // https://bugs.chromium.org/p/v8/issues/detail?id=10682
        Intl.getCanonicalLocales('und-x-private')[0] ===
            'x-private');
}
exports.shouldPolyfill = shouldPolyfill;


/***/ }),

/***/ 22263:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.variantAlias = exports.scriptAlias = exports.territoryAlias = exports.languageAlias = void 0;
/* @generated */
// prettier-ignore  
exports.languageAlias = {
    "aa-saaho": "ssy",
    "aam": "aas",
    "aar": "aa",
    "abk": "ab",
    "adp": "dz",
    "afr": "af",
    "agp": "apf",
    "ais": "ami",
    "aju": "jrb",
    "aka": "ak",
    "alb": "sq",
    "als": "sq",
    "amh": "am",
    "ara": "ar",
    "arb": "ar",
    "arg": "an",
    "arm": "hy",
    "art-lojban": "jbo",
    "asd": "snz",
    "asm": "as",
    "aue": "ktz",
    "ava": "av",
    "ave": "ae",
    "aym": "ay",
    "ayr": "ay",
    "ayx": "nun",
    "aze": "az",
    "azj": "az",
    "bak": "ba",
    "bam": "bm",
    "baq": "eu",
    "baz": "nvo",
    "bcc": "bal",
    "bcl": "bik",
    "bel": "be",
    "ben": "bn",
    "bgm": "bcg",
    "bh": "bho",
    "bhk": "fbl",
    "bic": "bir",
    "bih": "bho",
    "bis": "bi",
    "bjd": "drl",
    "bjq": "bzc",
    "bkb": "ebk",
    "blg": "iba",
    "bod": "bo",
    "bos": "bs",
    "bre": "br",
    "btb": "beb",
    "bul": "bg",
    "bur": "my",
    "bxk": "luy",
    "bxr": "bua",
    "cat": "ca",
    "ccq": "rki",
    "cel-gaulish": "xtg",
    "ces": "cs",
    "cha": "ch",
    "che": "ce",
    "chi": "zh",
    "chu": "cu",
    "chv": "cv",
    "cjr": "mom",
    "cka": "cmr",
    "cld": "syr",
    "cmk": "xch",
    "cmn": "zh",
    "cnr": "sr-ME",
    "cor": "kw",
    "cos": "co",
    "coy": "pij",
    "cqu": "quh",
    "cre": "cr",
    "cwd": "cr",
    "cym": "cy",
    "cze": "cs",
    "daf": "dnj",
    "dan": "da",
    "dap": "njz",
    "deu": "de",
    "dgo": "doi",
    "dhd": "mwr",
    "dik": "din",
    "diq": "zza",
    "dit": "dif",
    "div": "dv",
    "djl": "dze",
    "dkl": "aqd",
    "drh": "mn",
    "drr": "kzk",
    "drw": "fa-AF",
    "dud": "uth",
    "duj": "dwu",
    "dut": "nl",
    "dwl": "dbt",
    "dzo": "dz",
    "ekk": "et",
    "ell": "el",
    "elp": "amq",
    "emk": "man",
    "en-GB-oed": "en-GB-oxendict",
    "eng": "en",
    "epo": "eo",
    "esk": "ik",
    "est": "et",
    "eus": "eu",
    "ewe": "ee",
    "fao": "fo",
    "fas": "fa",
    "fat": "ak",
    "fij": "fj",
    "fin": "fi",
    "fra": "fr",
    "fre": "fr",
    "fry": "fy",
    "fuc": "ff",
    "ful": "ff",
    "gav": "dev",
    "gaz": "om",
    "gbc": "wny",
    "gbo": "grb",
    "geo": "ka",
    "ger": "de",
    "gfx": "vaj",
    "ggn": "gvr",
    "ggo": "esg",
    "ggr": "gtu",
    "gio": "aou",
    "gla": "gd",
    "gle": "ga",
    "glg": "gl",
    "gli": "kzk",
    "glv": "gv",
    "gno": "gon",
    "gre": "el",
    "grn": "gn",
    "gti": "nyc",
    "gug": "gn",
    "guj": "gu",
    "guv": "duz",
    "gya": "gba",
    "hat": "ht",
    "hau": "ha",
    "hbs": "sr-Latn",
    "hdn": "hai",
    "hea": "hmn",
    "heb": "he",
    "her": "hz",
    "him": "srx",
    "hin": "hi",
    "hmo": "ho",
    "hrr": "jal",
    "hrv": "hr",
    "hun": "hu",
    "hy-arevmda": "hyw",
    "hye": "hy",
    "i-ami": "ami",
    "i-bnn": "bnn",
    "i-default": "en-x-i-default",
    "i-enochian": "und-x-i-enochian",
    "i-hak": "hak",
    "i-klingon": "tlh",
    "i-lux": "lb",
    "i-mingo": "see-x-i-mingo",
    "i-navajo": "nv",
    "i-pwn": "pwn",
    "i-tao": "tao",
    "i-tay": "tay",
    "i-tsu": "tsu",
    "ibi": "opa",
    "ibo": "ig",
    "ice": "is",
    "ido": "io",
    "iii": "ii",
    "ike": "iu",
    "iku": "iu",
    "ile": "ie",
    "ill": "ilm",
    "ilw": "gal",
    "in": "id",
    "ina": "ia",
    "ind": "id",
    "ipk": "ik",
    "isl": "is",
    "ita": "it",
    "iw": "he",
    "izi": "eza",
    "jar": "jgk",
    "jav": "jv",
    "jeg": "oyb",
    "ji": "yi",
    "jpn": "ja",
    "jw": "jv",
    "kal": "kl",
    "kan": "kn",
    "kas": "ks",
    "kat": "ka",
    "kau": "kr",
    "kaz": "kk",
    "kdv": "zkd",
    "kgc": "tdf",
    "kgd": "ncq",
    "kgh": "kml",
    "khk": "mn",
    "khm": "km",
    "kik": "ki",
    "kin": "rw",
    "kir": "ky",
    "kmr": "ku",
    "knc": "kr",
    "kng": "kg",
    "knn": "kok",
    "koj": "kwv",
    "kom": "kv",
    "kon": "kg",
    "kor": "ko",
    "kpp": "jkm",
    "kpv": "kv",
    "krm": "bmf",
    "ktr": "dtp",
    "kua": "kj",
    "kur": "ku",
    "kvs": "gdj",
    "kwq": "yam",
    "kxe": "tvd",
    "kxl": "kru",
    "kzh": "dgl",
    "kzj": "dtp",
    "kzt": "dtp",
    "lao": "lo",
    "lat": "la",
    "lav": "lv",
    "lbk": "bnc",
    "leg": "enl",
    "lii": "raq",
    "lim": "li",
    "lin": "ln",
    "lit": "lt",
    "llo": "ngt",
    "lmm": "rmx",
    "ltz": "lb",
    "lub": "lu",
    "lug": "lg",
    "lvs": "lv",
    "mac": "mk",
    "mah": "mh",
    "mal": "ml",
    "mao": "mi",
    "mar": "mr",
    "may": "ms",
    "meg": "cir",
    "mgx": "jbk",
    "mhr": "chm",
    "mkd": "mk",
    "mlg": "mg",
    "mlt": "mt",
    "mnk": "man",
    "mnt": "wnn",
    "mo": "ro",
    "mof": "xnt",
    "mol": "ro",
    "mon": "mn",
    "mri": "mi",
    "msa": "ms",
    "mst": "mry",
    "mup": "raj",
    "mwd": "dmw",
    "mwj": "vaj",
    "mya": "my",
    "myd": "aog",
    "myt": "mry",
    "nad": "xny",
    "nau": "na",
    "nav": "nv",
    "nbf": "nru",
    "nbl": "nr",
    "nbx": "ekc",
    "ncp": "kdz",
    "nde": "nd",
    "ndo": "ng",
    "nep": "ne",
    "nld": "nl",
    "nln": "azd",
    "nlr": "nrk",
    "nno": "nn",
    "nns": "nbr",
    "nnx": "ngv",
    "no-bok": "nb",
    "no-bokmal": "nb",
    "no-nyn": "nn",
    "no-nynorsk": "nn",
    "nob": "nb",
    "noo": "dtd",
    "nor": "no",
    "npi": "ne",
    "nts": "pij",
    "nxu": "bpp",
    "nya": "ny",
    "oci": "oc",
    "ojg": "oj",
    "oji": "oj",
    "ori": "or",
    "orm": "om",
    "ory": "or",
    "oss": "os",
    "oun": "vaj",
    "pan": "pa",
    "pat": "kxr",
    "pbu": "ps",
    "pcr": "adx",
    "per": "fa",
    "pes": "fa",
    "pli": "pi",
    "plt": "mg",
    "pmc": "huw",
    "pmu": "phr",
    "pnb": "lah",
    "pol": "pl",
    "por": "pt",
    "ppa": "bfy",
    "ppr": "lcq",
    "prs": "fa-AF",
    "pry": "prt",
    "pus": "ps",
    "puz": "pub",
    "que": "qu",
    "quz": "qu",
    "rmr": "emx",
    "rmy": "rom",
    "roh": "rm",
    "ron": "ro",
    "rum": "ro",
    "run": "rn",
    "rus": "ru",
    "sag": "sg",
    "san": "sa",
    "sap": "aqt",
    "sca": "hle",
    "scc": "sr",
    "scr": "hr",
    "sgl": "isk",
    "sgn-BE-FR": "sfb",
    "sgn-BE-NL": "vgt",
    "sgn-BR": "bzs",
    "sgn-CH-DE": "sgg",
    "sgn-CO": "csn",
    "sgn-DE": "gsg",
    "sgn-DK": "dsl",
    "sgn-ES": "ssp",
    "sgn-FR": "fsl",
    "sgn-GB": "bfi",
    "sgn-GR": "gss",
    "sgn-IE": "isg",
    "sgn-IT": "ise",
    "sgn-JP": "jsl",
    "sgn-MX": "mfs",
    "sgn-NI": "ncs",
    "sgn-NL": "dse",
    "sgn-NO": "nsi",
    "sgn-PT": "psr",
    "sgn-SE": "swl",
    "sgn-US": "ase",
    "sgn-ZA": "sfs",
    "sh": "sr-Latn",
    "sin": "si",
    "skk": "oyb",
    "slk": "sk",
    "slo": "sk",
    "slv": "sl",
    "sme": "se",
    "smo": "sm",
    "sna": "sn",
    "snd": "sd",
    "som": "so",
    "sot": "st",
    "spa": "es",
    "spy": "kln",
    "sqi": "sq",
    "src": "sc",
    "srd": "sc",
    "srp": "sr",
    "ssw": "ss",
    "sul": "sgd",
    "sum": "ulw",
    "sun": "su",
    "swa": "sw",
    "swc": "sw-CD",
    "swe": "sv",
    "swh": "sw",
    "tah": "ty",
    "tam": "ta",
    "tat": "tt",
    "tdu": "dtp",
    "tel": "te",
    "tgg": "bjp",
    "tgk": "tg",
    "tgl": "fil",
    "tha": "th",
    "thc": "tpo",
    "thw": "ola",
    "thx": "oyb",
    "tib": "bo",
    "tid": "itd",
    "tie": "ras",
    "tir": "ti",
    "tkk": "twm",
    "tl": "fil",
    "tlw": "weo",
    "tmp": "tyj",
    "tne": "kak",
    "tnf": "fa-AF",
    "ton": "to",
    "tsf": "taj",
    "tsn": "tn",
    "tso": "ts",
    "ttq": "tmh",
    "tuk": "tk",
    "tur": "tr",
    "tw": "ak",
    "twi": "ak",
    "uig": "ug",
    "ukr": "uk",
    "umu": "del",
    "und-aaland": "und-AX",
    "und-arevela": "und",
    "und-arevmda": "und",
    "und-bokmal": "und",
    "und-hakka": "und",
    "und-hepburn-heploc": "und-alalc97",
    "und-lojban": "und",
    "und-nynorsk": "und",
    "und-saaho": "und",
    "und-xiang": "und",
    "unp": "wro",
    "uok": "ema",
    "urd": "ur",
    "uzb": "uz",
    "uzn": "uz",
    "ven": "ve",
    "vie": "vi",
    "vol": "vo",
    "wel": "cy",
    "wgw": "wgb",
    "wit": "nol",
    "wiw": "nwo",
    "wln": "wa",
    "wol": "wo",
    "xba": "cax",
    "xho": "xh",
    "xia": "acn",
    "xkh": "waw",
    "xpe": "kpe",
    "xrq": "dmw",
    "xsj": "suj",
    "xsl": "den",
    "ybd": "rki",
    "ydd": "yi",
    "yen": "ynq",
    "yid": "yi",
    "yiy": "yrm",
    "yma": "lrr",
    "ymt": "mtm",
    "yor": "yo",
    "yos": "zom",
    "yuu": "yug",
    "zai": "zap",
    "zh-cmn": "zh",
    "zh-cmn-Hans": "zh-Hans",
    "zh-cmn-Hant": "zh-Hant",
    "zh-gan": "gan",
    "zh-guoyu": "zh",
    "zh-hakka": "hak",
    "zh-min": "nan-x-zh-min",
    "zh-min-nan": "nan",
    "zh-wuu": "wuu",
    "zh-xiang": "hsn",
    "zh-yue": "yue",
    "zha": "za",
    "zho": "zh",
    "zir": "scv",
    "zsm": "ms",
    "zul": "zu",
    "zyb": "za"
};
exports.territoryAlias = {
    "100": "BG",
    "104": "MM",
    "108": "BI",
    "112": "BY",
    "116": "KH",
    "120": "CM",
    "124": "CA",
    "132": "CV",
    "136": "KY",
    "140": "CF",
    "144": "LK",
    "148": "TD",
    "152": "CL",
    "156": "CN",
    "158": "TW",
    "162": "CX",
    "166": "CC",
    "170": "CO",
    "172": "RU AM AZ BY GE KG KZ MD TJ TM UA UZ",
    "174": "KM",
    "175": "YT",
    "178": "CG",
    "180": "CD",
    "184": "CK",
    "188": "CR",
    "191": "HR",
    "192": "CU",
    "196": "CY",
    "200": "CZ SK",
    "203": "CZ",
    "204": "BJ",
    "208": "DK",
    "212": "DM",
    "214": "DO",
    "218": "EC",
    "222": "SV",
    "226": "GQ",
    "230": "ET",
    "231": "ET",
    "232": "ER",
    "233": "EE",
    "234": "FO",
    "238": "FK",
    "239": "GS",
    "242": "FJ",
    "246": "FI",
    "248": "AX",
    "249": "FR",
    "250": "FR",
    "254": "GF",
    "258": "PF",
    "260": "TF",
    "262": "DJ",
    "266": "GA",
    "268": "GE",
    "270": "GM",
    "275": "PS",
    "276": "DE",
    "278": "DE",
    "280": "DE",
    "288": "GH",
    "292": "GI",
    "296": "KI",
    "300": "GR",
    "304": "GL",
    "308": "GD",
    "312": "GP",
    "316": "GU",
    "320": "GT",
    "324": "GN",
    "328": "GY",
    "332": "HT",
    "334": "HM",
    "336": "VA",
    "340": "HN",
    "344": "HK",
    "348": "HU",
    "352": "IS",
    "356": "IN",
    "360": "ID",
    "364": "IR",
    "368": "IQ",
    "372": "IE",
    "376": "IL",
    "380": "IT",
    "384": "CI",
    "388": "JM",
    "392": "JP",
    "398": "KZ",
    "400": "JO",
    "404": "KE",
    "408": "KP",
    "410": "KR",
    "414": "KW",
    "417": "KG",
    "418": "LA",
    "422": "LB",
    "426": "LS",
    "428": "LV",
    "430": "LR",
    "434": "LY",
    "438": "LI",
    "440": "LT",
    "442": "LU",
    "446": "MO",
    "450": "MG",
    "454": "MW",
    "458": "MY",
    "462": "MV",
    "466": "ML",
    "470": "MT",
    "474": "MQ",
    "478": "MR",
    "480": "MU",
    "484": "MX",
    "492": "MC",
    "496": "MN",
    "498": "MD",
    "499": "ME",
    "500": "MS",
    "504": "MA",
    "508": "MZ",
    "512": "OM",
    "516": "NA",
    "520": "NR",
    "524": "NP",
    "528": "NL",
    "530": "CW SX BQ",
    "531": "CW",
    "532": "CW SX BQ",
    "533": "AW",
    "534": "SX",
    "535": "BQ",
    "536": "SA IQ",
    "540": "NC",
    "548": "VU",
    "554": "NZ",
    "558": "NI",
    "562": "NE",
    "566": "NG",
    "570": "NU",
    "574": "NF",
    "578": "NO",
    "580": "MP",
    "581": "UM",
    "582": "FM MH MP PW",
    "583": "FM",
    "584": "MH",
    "585": "PW",
    "586": "PK",
    "591": "PA",
    "598": "PG",
    "600": "PY",
    "604": "PE",
    "608": "PH",
    "612": "PN",
    "616": "PL",
    "620": "PT",
    "624": "GW",
    "626": "TL",
    "630": "PR",
    "634": "QA",
    "638": "RE",
    "642": "RO",
    "643": "RU",
    "646": "RW",
    "652": "BL",
    "654": "SH",
    "659": "KN",
    "660": "AI",
    "662": "LC",
    "663": "MF",
    "666": "PM",
    "670": "VC",
    "674": "SM",
    "678": "ST",
    "682": "SA",
    "686": "SN",
    "688": "RS",
    "690": "SC",
    "694": "SL",
    "702": "SG",
    "703": "SK",
    "704": "VN",
    "705": "SI",
    "706": "SO",
    "710": "ZA",
    "716": "ZW",
    "720": "YE",
    "724": "ES",
    "728": "SS",
    "729": "SD",
    "732": "EH",
    "736": "SD",
    "740": "SR",
    "744": "SJ",
    "748": "SZ",
    "752": "SE",
    "756": "CH",
    "760": "SY",
    "762": "TJ",
    "764": "TH",
    "768": "TG",
    "772": "TK",
    "776": "TO",
    "780": "TT",
    "784": "AE",
    "788": "TN",
    "792": "TR",
    "795": "TM",
    "796": "TC",
    "798": "TV",
    "800": "UG",
    "804": "UA",
    "807": "MK",
    "810": "RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ",
    "818": "EG",
    "826": "GB",
    "830": "JE GG",
    "831": "GG",
    "832": "JE",
    "833": "IM",
    "834": "TZ",
    "840": "US",
    "850": "VI",
    "854": "BF",
    "858": "UY",
    "860": "UZ",
    "862": "VE",
    "876": "WF",
    "882": "WS",
    "886": "YE",
    "887": "YE",
    "890": "RS ME SI HR MK BA",
    "891": "RS ME",
    "894": "ZM",
    "958": "AA",
    "959": "QM",
    "960": "QN",
    "962": "QP",
    "963": "QQ",
    "964": "QR",
    "965": "QS",
    "966": "QT",
    "967": "EU",
    "968": "QV",
    "969": "QW",
    "970": "QX",
    "971": "QY",
    "972": "QZ",
    "973": "XA",
    "974": "XB",
    "975": "XC",
    "976": "XD",
    "977": "XE",
    "978": "XF",
    "979": "XG",
    "980": "XH",
    "981": "XI",
    "982": "XJ",
    "983": "XK",
    "984": "XL",
    "985": "XM",
    "986": "XN",
    "987": "XO",
    "988": "XP",
    "989": "XQ",
    "990": "XR",
    "991": "XS",
    "992": "XT",
    "993": "XU",
    "994": "XV",
    "995": "XW",
    "996": "XX",
    "997": "XY",
    "998": "XZ",
    "999": "ZZ",
    "004": "AF",
    "008": "AL",
    "010": "AQ",
    "012": "DZ",
    "016": "AS",
    "020": "AD",
    "024": "AO",
    "028": "AG",
    "031": "AZ",
    "032": "AR",
    "036": "AU",
    "040": "AT",
    "044": "BS",
    "048": "BH",
    "050": "BD",
    "051": "AM",
    "052": "BB",
    "056": "BE",
    "060": "BM",
    "062": "034 143",
    "064": "BT",
    "068": "BO",
    "070": "BA",
    "072": "BW",
    "074": "BV",
    "076": "BR",
    "084": "BZ",
    "086": "IO",
    "090": "SB",
    "092": "VG",
    "096": "BN",
    "AAA": "AA",
    "ABW": "AW",
    "AFG": "AF",
    "AGO": "AO",
    "AIA": "AI",
    "ALA": "AX",
    "ALB": "AL",
    "AN": "CW SX BQ",
    "AND": "AD",
    "ANT": "CW SX BQ",
    "ARE": "AE",
    "ARG": "AR",
    "ARM": "AM",
    "ASC": "AC",
    "ASM": "AS",
    "ATA": "AQ",
    "ATF": "TF",
    "ATG": "AG",
    "AUS": "AU",
    "AUT": "AT",
    "AZE": "AZ",
    "BDI": "BI",
    "BEL": "BE",
    "BEN": "BJ",
    "BES": "BQ",
    "BFA": "BF",
    "BGD": "BD",
    "BGR": "BG",
    "BHR": "BH",
    "BHS": "BS",
    "BIH": "BA",
    "BLM": "BL",
    "BLR": "BY",
    "BLZ": "BZ",
    "BMU": "BM",
    "BOL": "BO",
    "BRA": "BR",
    "BRB": "BB",
    "BRN": "BN",
    "BTN": "BT",
    "BU": "MM",
    "BUR": "MM",
    "BVT": "BV",
    "BWA": "BW",
    "CAF": "CF",
    "CAN": "CA",
    "CCK": "CC",
    "CHE": "CH",
    "CHL": "CL",
    "CHN": "CN",
    "CIV": "CI",
    "CMR": "CM",
    "COD": "CD",
    "COG": "CG",
    "COK": "CK",
    "COL": "CO",
    "COM": "KM",
    "CPT": "CP",
    "CPV": "CV",
    "CRI": "CR",
    "CS": "RS ME",
    "CT": "KI",
    "CUB": "CU",
    "CUW": "CW",
    "CXR": "CX",
    "CYM": "KY",
    "CYP": "CY",
    "CZE": "CZ",
    "DD": "DE",
    "DDR": "DE",
    "DEU": "DE",
    "DGA": "DG",
    "DJI": "DJ",
    "DMA": "DM",
    "DNK": "DK",
    "DOM": "DO",
    "DY": "BJ",
    "DZA": "DZ",
    "ECU": "EC",
    "EGY": "EG",
    "ERI": "ER",
    "ESH": "EH",
    "ESP": "ES",
    "EST": "EE",
    "ETH": "ET",
    "FIN": "FI",
    "FJI": "FJ",
    "FLK": "FK",
    "FQ": "AQ TF",
    "FRA": "FR",
    "FRO": "FO",
    "FSM": "FM",
    "FX": "FR",
    "FXX": "FR",
    "GAB": "GA",
    "GBR": "GB",
    "GEO": "GE",
    "GGY": "GG",
    "GHA": "GH",
    "GIB": "GI",
    "GIN": "GN",
    "GLP": "GP",
    "GMB": "GM",
    "GNB": "GW",
    "GNQ": "GQ",
    "GRC": "GR",
    "GRD": "GD",
    "GRL": "GL",
    "GTM": "GT",
    "GUF": "GF",
    "GUM": "GU",
    "GUY": "GY",
    "HKG": "HK",
    "HMD": "HM",
    "HND": "HN",
    "HRV": "HR",
    "HTI": "HT",
    "HUN": "HU",
    "HV": "BF",
    "IDN": "ID",
    "IMN": "IM",
    "IND": "IN",
    "IOT": "IO",
    "IRL": "IE",
    "IRN": "IR",
    "IRQ": "IQ",
    "ISL": "IS",
    "ISR": "IL",
    "ITA": "IT",
    "JAM": "JM",
    "JEY": "JE",
    "JOR": "JO",
    "JPN": "JP",
    "JT": "UM",
    "KAZ": "KZ",
    "KEN": "KE",
    "KGZ": "KG",
    "KHM": "KH",
    "KIR": "KI",
    "KNA": "KN",
    "KOR": "KR",
    "KWT": "KW",
    "LAO": "LA",
    "LBN": "LB",
    "LBR": "LR",
    "LBY": "LY",
    "LCA": "LC",
    "LIE": "LI",
    "LKA": "LK",
    "LSO": "LS",
    "LTU": "LT",
    "LUX": "LU",
    "LVA": "LV",
    "MAC": "MO",
    "MAF": "MF",
    "MAR": "MA",
    "MCO": "MC",
    "MDA": "MD",
    "MDG": "MG",
    "MDV": "MV",
    "MEX": "MX",
    "MHL": "MH",
    "MI": "UM",
    "MKD": "MK",
    "MLI": "ML",
    "MLT": "MT",
    "MMR": "MM",
    "MNE": "ME",
    "MNG": "MN",
    "MNP": "MP",
    "MOZ": "MZ",
    "MRT": "MR",
    "MSR": "MS",
    "MTQ": "MQ",
    "MUS": "MU",
    "MWI": "MW",
    "MYS": "MY",
    "MYT": "YT",
    "NAM": "NA",
    "NCL": "NC",
    "NER": "NE",
    "NFK": "NF",
    "NGA": "NG",
    "NH": "VU",
    "NIC": "NI",
    "NIU": "NU",
    "NLD": "NL",
    "NOR": "NO",
    "NPL": "NP",
    "NQ": "AQ",
    "NRU": "NR",
    "NT": "SA IQ",
    "NTZ": "SA IQ",
    "NZL": "NZ",
    "OMN": "OM",
    "PAK": "PK",
    "PAN": "PA",
    "PC": "FM MH MP PW",
    "PCN": "PN",
    "PER": "PE",
    "PHL": "PH",
    "PLW": "PW",
    "PNG": "PG",
    "POL": "PL",
    "PRI": "PR",
    "PRK": "KP",
    "PRT": "PT",
    "PRY": "PY",
    "PSE": "PS",
    "PU": "UM",
    "PYF": "PF",
    "PZ": "PA",
    "QAT": "QA",
    "QMM": "QM",
    "QNN": "QN",
    "QPP": "QP",
    "QQQ": "QQ",
    "QRR": "QR",
    "QSS": "QS",
    "QTT": "QT",
    "QU": "EU",
    "QUU": "EU",
    "QVV": "QV",
    "QWW": "QW",
    "QXX": "QX",
    "QYY": "QY",
    "QZZ": "QZ",
    "REU": "RE",
    "RH": "ZW",
    "ROU": "RO",
    "RUS": "RU",
    "RWA": "RW",
    "SAU": "SA",
    "SCG": "RS ME",
    "SDN": "SD",
    "SEN": "SN",
    "SGP": "SG",
    "SGS": "GS",
    "SHN": "SH",
    "SJM": "SJ",
    "SLB": "SB",
    "SLE": "SL",
    "SLV": "SV",
    "SMR": "SM",
    "SOM": "SO",
    "SPM": "PM",
    "SRB": "RS",
    "SSD": "SS",
    "STP": "ST",
    "SU": "RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ",
    "SUN": "RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ",
    "SUR": "SR",
    "SVK": "SK",
    "SVN": "SI",
    "SWE": "SE",
    "SWZ": "SZ",
    "SXM": "SX",
    "SYC": "SC",
    "SYR": "SY",
    "TAA": "TA",
    "TCA": "TC",
    "TCD": "TD",
    "TGO": "TG",
    "THA": "TH",
    "TJK": "TJ",
    "TKL": "TK",
    "TKM": "TM",
    "TLS": "TL",
    "TMP": "TL",
    "TON": "TO",
    "TP": "TL",
    "TTO": "TT",
    "TUN": "TN",
    "TUR": "TR",
    "TUV": "TV",
    "TWN": "TW",
    "TZA": "TZ",
    "UGA": "UG",
    "UK": "GB",
    "UKR": "UA",
    "UMI": "UM",
    "URY": "UY",
    "USA": "US",
    "UZB": "UZ",
    "VAT": "VA",
    "VCT": "VC",
    "VD": "VN",
    "VEN": "VE",
    "VGB": "VG",
    "VIR": "VI",
    "VNM": "VN",
    "VUT": "VU",
    "WK": "UM",
    "WLF": "WF",
    "WSM": "WS",
    "XAA": "XA",
    "XBB": "XB",
    "XCC": "XC",
    "XDD": "XD",
    "XEE": "XE",
    "XFF": "XF",
    "XGG": "XG",
    "XHH": "XH",
    "XII": "XI",
    "XJJ": "XJ",
    "XKK": "XK",
    "XLL": "XL",
    "XMM": "XM",
    "XNN": "XN",
    "XOO": "XO",
    "XPP": "XP",
    "XQQ": "XQ",
    "XRR": "XR",
    "XSS": "XS",
    "XTT": "XT",
    "XUU": "XU",
    "XVV": "XV",
    "XWW": "XW",
    "XXX": "XX",
    "XYY": "XY",
    "XZZ": "XZ",
    "YD": "YE",
    "YEM": "YE",
    "YMD": "YE",
    "YU": "RS ME",
    "YUG": "RS ME",
    "ZAF": "ZA",
    "ZAR": "CD",
    "ZMB": "ZM",
    "ZR": "CD",
    "ZWE": "ZW",
    "ZZZ": "ZZ"
};
exports.scriptAlias = {
    "Qaai": "Zinh"
};
exports.variantAlias = {
    "heploc": "alalc97",
    "polytoni": "polyton"
};


/***/ }),

/***/ 69391:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.canonicalizeUnicodeLocaleId = exports.canonicalizeUnicodeLanguageId = void 0;
var tslib_1 = __webpack_require__(70655);
var aliases_generated_1 = __webpack_require__(22263);
var parser_1 = __webpack_require__(18371);
var likelySubtags_generated_1 = __webpack_require__(43020);
var emitter_1 = __webpack_require__(60825);
function canonicalizeAttrs(strs) {
    return Object.keys(strs.reduce(function (all, str) {
        all[str.toLowerCase()] = 1;
        return all;
    }, {})).sort();
}
function canonicalizeKVs(arr) {
    var all = {};
    var result = [];
    for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
        var kv = arr_1[_i];
        if (kv[0] in all) {
            continue;
        }
        all[kv[0]] = 1;
        if (!kv[1] || kv[1] === 'true') {
            result.push([kv[0].toLowerCase()]);
        }
        else {
            result.push([kv[0].toLowerCase(), kv[1].toLowerCase()]);
        }
    }
    return result.sort(compareKV);
}
function compareKV(t1, t2) {
    return t1[0] < t2[0] ? -1 : t1[0] > t2[0] ? 1 : 0;
}
function compareExtension(e1, e2) {
    return e1.type < e2.type ? -1 : e1.type > e2.type ? 1 : 0;
}
function mergeVariants(v1, v2) {
    var result = tslib_1.__spreadArray([], v1, true);
    for (var _i = 0, v2_1 = v2; _i < v2_1.length; _i++) {
        var v = v2_1[_i];
        if (v1.indexOf(v) < 0) {
            result.push(v);
        }
    }
    return result;
}
/**
 * CAVEAT: We don't do this section in the spec bc they have no JSON data
 * Use the bcp47 data to replace keys, types, tfields, and tvalues by their canonical forms. See Section 3.6.4 U Extension Data Files) and Section 3.7.1 T Extension Data Files. The aliases are in the alias attribute value, while the canonical is in the name attribute value. For example,
Because of the following bcp47 data:
<key name="ms"…>…<type name="uksystem" … alias="imperial" … />…</key>
We get the following transformation:
en-u-ms-imperial ⇒ en-u-ms-uksystem
 * @param lang
 */
function canonicalizeUnicodeLanguageId(unicodeLanguageId) {
    /**
     * If the language subtag matches the type attribute of a languageAlias element in Supplemental Data, replace the language subtag with the replacement value.
     *  1. If there are additional subtags in the replacement value, add them to the result, but only if there is no corresponding subtag already in the tag.
     *  2. Five special deprecated grandfathered codes (such as i-default) are in type attributes, and are also replaced.
     */
    // From https://github.com/unicode-org/icu/blob/master/icu4j/main/classes/core/src/com/ibm/icu/util/ULocale.java#L1246
    // Try language _ variant
    var finalLangAst = unicodeLanguageId;
    if (unicodeLanguageId.variants.length) {
        var replacedLang_1 = '';
        for (var _i = 0, _a = unicodeLanguageId.variants; _i < _a.length; _i++) {
            var variant = _a[_i];
            if ((replacedLang_1 =
                aliases_generated_1.languageAlias[(0, emitter_1.emitUnicodeLanguageId)({
                    lang: unicodeLanguageId.lang,
                    variants: [variant],
                })])) {
                var replacedLangAst = (0, parser_1.parseUnicodeLanguageId)(replacedLang_1.split(parser_1.SEPARATOR));
                finalLangAst = {
                    lang: replacedLangAst.lang,
                    script: finalLangAst.script || replacedLangAst.script,
                    region: finalLangAst.region || replacedLangAst.region,
                    variants: mergeVariants(finalLangAst.variants, replacedLangAst.variants),
                };
                break;
            }
        }
    }
    // language _ script _ country
    // ug-Arab-CN -> ug-CN
    if (finalLangAst.script && finalLangAst.region) {
        var replacedLang_2 = aliases_generated_1.languageAlias[(0, emitter_1.emitUnicodeLanguageId)({
            lang: finalLangAst.lang,
            script: finalLangAst.script,
            region: finalLangAst.region,
            variants: [],
        })];
        if (replacedLang_2) {
            var replacedLangAst = (0, parser_1.parseUnicodeLanguageId)(replacedLang_2.split(parser_1.SEPARATOR));
            finalLangAst = {
                lang: replacedLangAst.lang,
                script: replacedLangAst.script,
                region: replacedLangAst.region,
                variants: finalLangAst.variants,
            };
        }
    }
    // language _ country
    // eg. az_AZ -> az_Latn_A
    if (finalLangAst.region) {
        var replacedLang_3 = aliases_generated_1.languageAlias[(0, emitter_1.emitUnicodeLanguageId)({
            lang: finalLangAst.lang,
            region: finalLangAst.region,
            variants: [],
        })];
        if (replacedLang_3) {
            var replacedLangAst = (0, parser_1.parseUnicodeLanguageId)(replacedLang_3.split(parser_1.SEPARATOR));
            finalLangAst = {
                lang: replacedLangAst.lang,
                script: finalLangAst.script || replacedLangAst.script,
                region: replacedLangAst.region,
                variants: finalLangAst.variants,
            };
        }
    }
    // only language
    // e.g. twi -> ak
    var replacedLang = aliases_generated_1.languageAlias[(0, emitter_1.emitUnicodeLanguageId)({
        lang: finalLangAst.lang,
        variants: [],
    })];
    if (replacedLang) {
        var replacedLangAst = (0, parser_1.parseUnicodeLanguageId)(replacedLang.split(parser_1.SEPARATOR));
        finalLangAst = {
            lang: replacedLangAst.lang,
            script: finalLangAst.script || replacedLangAst.script,
            region: finalLangAst.region || replacedLangAst.region,
            variants: finalLangAst.variants,
        };
    }
    if (finalLangAst.region) {
        var region = finalLangAst.region.toUpperCase();
        var regionAlias = aliases_generated_1.territoryAlias[region];
        var replacedRegion = void 0;
        if (regionAlias) {
            var regions = regionAlias.split(' ');
            replacedRegion = regions[0];
            var likelySubtag = likelySubtags_generated_1.likelySubtags[(0, emitter_1.emitUnicodeLanguageId)({
                lang: finalLangAst.lang,
                script: finalLangAst.script,
                variants: [],
            })];
            if (likelySubtag) {
                var likelyRegion = (0, parser_1.parseUnicodeLanguageId)(likelySubtag.split(parser_1.SEPARATOR)).region;
                if (likelyRegion && regions.indexOf(likelyRegion) > -1) {
                    replacedRegion = likelyRegion;
                }
            }
        }
        if (replacedRegion) {
            finalLangAst.region = replacedRegion;
        }
        finalLangAst.region = finalLangAst.region.toUpperCase();
    }
    if (finalLangAst.script) {
        finalLangAst.script =
            finalLangAst.script[0].toUpperCase() +
                finalLangAst.script.slice(1).toLowerCase();
        if (aliases_generated_1.scriptAlias[finalLangAst.script]) {
            finalLangAst.script = aliases_generated_1.scriptAlias[finalLangAst.script];
        }
    }
    if (finalLangAst.variants.length) {
        for (var i = 0; i < finalLangAst.variants.length; i++) {
            var variant = finalLangAst.variants[i].toLowerCase();
            if (aliases_generated_1.variantAlias[variant]) {
                var alias = aliases_generated_1.variantAlias[variant];
                if ((0, parser_1.isUnicodeVariantSubtag)(alias)) {
                    finalLangAst.variants[i] = alias;
                }
                else if ((0, parser_1.isUnicodeLanguageSubtag)(alias)) {
                    // Yes this can happen per the spec
                    finalLangAst.lang = alias;
                }
            }
        }
        finalLangAst.variants.sort();
    }
    return finalLangAst;
}
exports.canonicalizeUnicodeLanguageId = canonicalizeUnicodeLanguageId;
/**
 * Canonicalize based on
 * https://www.unicode.org/reports/tr35/tr35.html#Canonical_Unicode_Locale_Identifiers
 * https://tc39.es/ecma402/#sec-canonicalizeunicodelocaleid
 * IMPORTANT: This modifies the object inline
 * @param locale
 */
function canonicalizeUnicodeLocaleId(locale) {
    locale.lang = canonicalizeUnicodeLanguageId(locale.lang);
    if (locale.extensions) {
        for (var _i = 0, _a = locale.extensions; _i < _a.length; _i++) {
            var extension = _a[_i];
            switch (extension.type) {
                case 'u':
                    extension.keywords = canonicalizeKVs(extension.keywords);
                    if (extension.attributes) {
                        extension.attributes = canonicalizeAttrs(extension.attributes);
                    }
                    break;
                case 't':
                    if (extension.lang) {
                        extension.lang = canonicalizeUnicodeLanguageId(extension.lang);
                    }
                    extension.fields = canonicalizeKVs(extension.fields);
                    break;
                default:
                    extension.value = extension.value.toLowerCase();
                    break;
            }
        }
        locale.extensions.sort(compareExtension);
    }
    return locale;
}
exports.canonicalizeUnicodeLocaleId = canonicalizeUnicodeLocaleId;


/***/ }),

/***/ 60825:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.emitUnicodeLocaleId = exports.emitUnicodeLanguageId = void 0;
var tslib_1 = __webpack_require__(70655);
function emitUnicodeLanguageId(lang) {
    if (!lang) {
        return '';
    }
    return tslib_1.__spreadArray([lang.lang, lang.script, lang.region], (lang.variants || []), true).filter(Boolean)
        .join('-');
}
exports.emitUnicodeLanguageId = emitUnicodeLanguageId;
function emitUnicodeLocaleId(_a) {
    var lang = _a.lang, extensions = _a.extensions;
    var chunks = [emitUnicodeLanguageId(lang)];
    for (var _i = 0, extensions_1 = extensions; _i < extensions_1.length; _i++) {
        var ext = extensions_1[_i];
        chunks.push(ext.type);
        switch (ext.type) {
            case 'u':
                chunks.push.apply(chunks, tslib_1.__spreadArray(tslib_1.__spreadArray([], ext.attributes, false), ext.keywords.reduce(function (all, kv) { return all.concat(kv); }, []), false));
                break;
            case 't':
                chunks.push.apply(chunks, tslib_1.__spreadArray([emitUnicodeLanguageId(ext.lang)], ext.fields.reduce(function (all, kv) { return all.concat(kv); }, []), false));
                break;
            default:
                chunks.push(ext.value);
                break;
        }
    }
    return chunks.filter(Boolean).join('-');
}
exports.emitUnicodeLocaleId = emitUnicodeLocaleId;


/***/ }),

/***/ 43020:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.likelySubtags = void 0;
/* @generated */
// prettier-ignore  
exports.likelySubtags = {
    "aa": "aa-Latn-ET",
    "aai": "aai-Latn-ZZ",
    "aak": "aak-Latn-ZZ",
    "aau": "aau-Latn-ZZ",
    "ab": "ab-Cyrl-GE",
    "abi": "abi-Latn-ZZ",
    "abq": "abq-Cyrl-ZZ",
    "abr": "abr-Latn-GH",
    "abt": "abt-Latn-ZZ",
    "aby": "aby-Latn-ZZ",
    "acd": "acd-Latn-ZZ",
    "ace": "ace-Latn-ID",
    "ach": "ach-Latn-UG",
    "ada": "ada-Latn-GH",
    "ade": "ade-Latn-ZZ",
    "adj": "adj-Latn-ZZ",
    "adp": "adp-Tibt-BT",
    "ady": "ady-Cyrl-RU",
    "adz": "adz-Latn-ZZ",
    "ae": "ae-Avst-IR",
    "aeb": "aeb-Arab-TN",
    "aey": "aey-Latn-ZZ",
    "af": "af-Latn-ZA",
    "agc": "agc-Latn-ZZ",
    "agd": "agd-Latn-ZZ",
    "agg": "agg-Latn-ZZ",
    "agm": "agm-Latn-ZZ",
    "ago": "ago-Latn-ZZ",
    "agq": "agq-Latn-CM",
    "aha": "aha-Latn-ZZ",
    "ahl": "ahl-Latn-ZZ",
    "aho": "aho-Ahom-IN",
    "ajg": "ajg-Latn-ZZ",
    "ak": "ak-Latn-GH",
    "akk": "akk-Xsux-IQ",
    "ala": "ala-Latn-ZZ",
    "ali": "ali-Latn-ZZ",
    "aln": "aln-Latn-XK",
    "alt": "alt-Cyrl-RU",
    "am": "am-Ethi-ET",
    "amm": "amm-Latn-ZZ",
    "amn": "amn-Latn-ZZ",
    "amo": "amo-Latn-NG",
    "amp": "amp-Latn-ZZ",
    "an": "an-Latn-ES",
    "anc": "anc-Latn-ZZ",
    "ank": "ank-Latn-ZZ",
    "ann": "ann-Latn-ZZ",
    "any": "any-Latn-ZZ",
    "aoj": "aoj-Latn-ZZ",
    "aom": "aom-Latn-ZZ",
    "aoz": "aoz-Latn-ID",
    "apc": "apc-Arab-ZZ",
    "apd": "apd-Arab-TG",
    "ape": "ape-Latn-ZZ",
    "apr": "apr-Latn-ZZ",
    "aps": "aps-Latn-ZZ",
    "apz": "apz-Latn-ZZ",
    "ar": "ar-Arab-EG",
    "arc": "arc-Armi-IR",
    "arc-Nbat": "arc-Nbat-JO",
    "arc-Palm": "arc-Palm-SY",
    "arh": "arh-Latn-ZZ",
    "arn": "arn-Latn-CL",
    "aro": "aro-Latn-BO",
    "arq": "arq-Arab-DZ",
    "ars": "ars-Arab-SA",
    "ary": "ary-Arab-MA",
    "arz": "arz-Arab-EG",
    "as": "as-Beng-IN",
    "asa": "asa-Latn-TZ",
    "ase": "ase-Sgnw-US",
    "asg": "asg-Latn-ZZ",
    "aso": "aso-Latn-ZZ",
    "ast": "ast-Latn-ES",
    "ata": "ata-Latn-ZZ",
    "atg": "atg-Latn-ZZ",
    "atj": "atj-Latn-CA",
    "auy": "auy-Latn-ZZ",
    "av": "av-Cyrl-RU",
    "avl": "avl-Arab-ZZ",
    "avn": "avn-Latn-ZZ",
    "avt": "avt-Latn-ZZ",
    "avu": "avu-Latn-ZZ",
    "awa": "awa-Deva-IN",
    "awb": "awb-Latn-ZZ",
    "awo": "awo-Latn-ZZ",
    "awx": "awx-Latn-ZZ",
    "ay": "ay-Latn-BO",
    "ayb": "ayb-Latn-ZZ",
    "az": "az-Latn-AZ",
    "az-Arab": "az-Arab-IR",
    "az-IQ": "az-Arab-IQ",
    "az-IR": "az-Arab-IR",
    "az-RU": "az-Cyrl-RU",
    "ba": "ba-Cyrl-RU",
    "bal": "bal-Arab-PK",
    "ban": "ban-Latn-ID",
    "bap": "bap-Deva-NP",
    "bar": "bar-Latn-AT",
    "bas": "bas-Latn-CM",
    "bav": "bav-Latn-ZZ",
    "bax": "bax-Bamu-CM",
    "bba": "bba-Latn-ZZ",
    "bbb": "bbb-Latn-ZZ",
    "bbc": "bbc-Latn-ID",
    "bbd": "bbd-Latn-ZZ",
    "bbj": "bbj-Latn-CM",
    "bbp": "bbp-Latn-ZZ",
    "bbr": "bbr-Latn-ZZ",
    "bcf": "bcf-Latn-ZZ",
    "bch": "bch-Latn-ZZ",
    "bci": "bci-Latn-CI",
    "bcm": "bcm-Latn-ZZ",
    "bcn": "bcn-Latn-ZZ",
    "bco": "bco-Latn-ZZ",
    "bcq": "bcq-Ethi-ZZ",
    "bcu": "bcu-Latn-ZZ",
    "bdd": "bdd-Latn-ZZ",
    "be": "be-Cyrl-BY",
    "bef": "bef-Latn-ZZ",
    "beh": "beh-Latn-ZZ",
    "bej": "bej-Arab-SD",
    "bem": "bem-Latn-ZM",
    "bet": "bet-Latn-ZZ",
    "bew": "bew-Latn-ID",
    "bex": "bex-Latn-ZZ",
    "bez": "bez-Latn-TZ",
    "bfd": "bfd-Latn-CM",
    "bfq": "bfq-Taml-IN",
    "bft": "bft-Arab-PK",
    "bfy": "bfy-Deva-IN",
    "bg": "bg-Cyrl-BG",
    "bgc": "bgc-Deva-IN",
    "bgn": "bgn-Arab-PK",
    "bgx": "bgx-Grek-TR",
    "bhb": "bhb-Deva-IN",
    "bhg": "bhg-Latn-ZZ",
    "bhi": "bhi-Deva-IN",
    "bhl": "bhl-Latn-ZZ",
    "bho": "bho-Deva-IN",
    "bhy": "bhy-Latn-ZZ",
    "bi": "bi-Latn-VU",
    "bib": "bib-Latn-ZZ",
    "big": "big-Latn-ZZ",
    "bik": "bik-Latn-PH",
    "bim": "bim-Latn-ZZ",
    "bin": "bin-Latn-NG",
    "bio": "bio-Latn-ZZ",
    "biq": "biq-Latn-ZZ",
    "bjh": "bjh-Latn-ZZ",
    "bji": "bji-Ethi-ZZ",
    "bjj": "bjj-Deva-IN",
    "bjn": "bjn-Latn-ID",
    "bjo": "bjo-Latn-ZZ",
    "bjr": "bjr-Latn-ZZ",
    "bjt": "bjt-Latn-SN",
    "bjz": "bjz-Latn-ZZ",
    "bkc": "bkc-Latn-ZZ",
    "bkm": "bkm-Latn-CM",
    "bkq": "bkq-Latn-ZZ",
    "bku": "bku-Latn-PH",
    "bkv": "bkv-Latn-ZZ",
    "blg": "blg-Latn-MY",
    "blt": "blt-Tavt-VN",
    "bm": "bm-Latn-ML",
    "bmh": "bmh-Latn-ZZ",
    "bmk": "bmk-Latn-ZZ",
    "bmq": "bmq-Latn-ML",
    "bmu": "bmu-Latn-ZZ",
    "bn": "bn-Beng-BD",
    "bng": "bng-Latn-ZZ",
    "bnm": "bnm-Latn-ZZ",
    "bnp": "bnp-Latn-ZZ",
    "bo": "bo-Tibt-CN",
    "boj": "boj-Latn-ZZ",
    "bom": "bom-Latn-ZZ",
    "bon": "bon-Latn-ZZ",
    "bpy": "bpy-Beng-IN",
    "bqc": "bqc-Latn-ZZ",
    "bqi": "bqi-Arab-IR",
    "bqp": "bqp-Latn-ZZ",
    "bqv": "bqv-Latn-CI",
    "br": "br-Latn-FR",
    "bra": "bra-Deva-IN",
    "brh": "brh-Arab-PK",
    "brx": "brx-Deva-IN",
    "brz": "brz-Latn-ZZ",
    "bs": "bs-Latn-BA",
    "bsj": "bsj-Latn-ZZ",
    "bsq": "bsq-Bass-LR",
    "bss": "bss-Latn-CM",
    "bst": "bst-Ethi-ZZ",
    "bto": "bto-Latn-PH",
    "btt": "btt-Latn-ZZ",
    "btv": "btv-Deva-PK",
    "bua": "bua-Cyrl-RU",
    "buc": "buc-Latn-YT",
    "bud": "bud-Latn-ZZ",
    "bug": "bug-Latn-ID",
    "buk": "buk-Latn-ZZ",
    "bum": "bum-Latn-CM",
    "buo": "buo-Latn-ZZ",
    "bus": "bus-Latn-ZZ",
    "buu": "buu-Latn-ZZ",
    "bvb": "bvb-Latn-GQ",
    "bwd": "bwd-Latn-ZZ",
    "bwr": "bwr-Latn-ZZ",
    "bxh": "bxh-Latn-ZZ",
    "bye": "bye-Latn-ZZ",
    "byn": "byn-Ethi-ER",
    "byr": "byr-Latn-ZZ",
    "bys": "bys-Latn-ZZ",
    "byv": "byv-Latn-CM",
    "byx": "byx-Latn-ZZ",
    "bza": "bza-Latn-ZZ",
    "bze": "bze-Latn-ML",
    "bzf": "bzf-Latn-ZZ",
    "bzh": "bzh-Latn-ZZ",
    "bzw": "bzw-Latn-ZZ",
    "ca": "ca-Latn-ES",
    "cad": "cad-Latn-US",
    "can": "can-Latn-ZZ",
    "cbj": "cbj-Latn-ZZ",
    "cch": "cch-Latn-NG",
    "ccp": "ccp-Cakm-BD",
    "ce": "ce-Cyrl-RU",
    "ceb": "ceb-Latn-PH",
    "cfa": "cfa-Latn-ZZ",
    "cgg": "cgg-Latn-UG",
    "ch": "ch-Latn-GU",
    "chk": "chk-Latn-FM",
    "chm": "chm-Cyrl-RU",
    "cho": "cho-Latn-US",
    "chp": "chp-Latn-CA",
    "chr": "chr-Cher-US",
    "cic": "cic-Latn-US",
    "cja": "cja-Arab-KH",
    "cjm": "cjm-Cham-VN",
    "cjv": "cjv-Latn-ZZ",
    "ckb": "ckb-Arab-IQ",
    "ckl": "ckl-Latn-ZZ",
    "cko": "cko-Latn-ZZ",
    "cky": "cky-Latn-ZZ",
    "cla": "cla-Latn-ZZ",
    "cme": "cme-Latn-ZZ",
    "cmg": "cmg-Soyo-MN",
    "co": "co-Latn-FR",
    "cop": "cop-Copt-EG",
    "cps": "cps-Latn-PH",
    "cr": "cr-Cans-CA",
    "crh": "crh-Cyrl-UA",
    "crj": "crj-Cans-CA",
    "crk": "crk-Cans-CA",
    "crl": "crl-Cans-CA",
    "crm": "crm-Cans-CA",
    "crs": "crs-Latn-SC",
    "cs": "cs-Latn-CZ",
    "csb": "csb-Latn-PL",
    "csw": "csw-Cans-CA",
    "ctd": "ctd-Pauc-MM",
    "cu": "cu-Cyrl-RU",
    "cu-Glag": "cu-Glag-BG",
    "cv": "cv-Cyrl-RU",
    "cy": "cy-Latn-GB",
    "da": "da-Latn-DK",
    "dad": "dad-Latn-ZZ",
    "daf": "daf-Latn-CI",
    "dag": "dag-Latn-ZZ",
    "dah": "dah-Latn-ZZ",
    "dak": "dak-Latn-US",
    "dar": "dar-Cyrl-RU",
    "dav": "dav-Latn-KE",
    "dbd": "dbd-Latn-ZZ",
    "dbq": "dbq-Latn-ZZ",
    "dcc": "dcc-Arab-IN",
    "ddn": "ddn-Latn-ZZ",
    "de": "de-Latn-DE",
    "ded": "ded-Latn-ZZ",
    "den": "den-Latn-CA",
    "dga": "dga-Latn-ZZ",
    "dgh": "dgh-Latn-ZZ",
    "dgi": "dgi-Latn-ZZ",
    "dgl": "dgl-Arab-ZZ",
    "dgr": "dgr-Latn-CA",
    "dgz": "dgz-Latn-ZZ",
    "dia": "dia-Latn-ZZ",
    "dje": "dje-Latn-NE",
    "dmf": "dmf-Medf-NG",
    "dnj": "dnj-Latn-CI",
    "dob": "dob-Latn-ZZ",
    "doi": "doi-Deva-IN",
    "dop": "dop-Latn-ZZ",
    "dow": "dow-Latn-ZZ",
    "drh": "drh-Mong-CN",
    "dri": "dri-Latn-ZZ",
    "drs": "drs-Ethi-ZZ",
    "dsb": "dsb-Latn-DE",
    "dtm": "dtm-Latn-ML",
    "dtp": "dtp-Latn-MY",
    "dts": "dts-Latn-ZZ",
    "dty": "dty-Deva-NP",
    "dua": "dua-Latn-CM",
    "duc": "duc-Latn-ZZ",
    "dud": "dud-Latn-ZZ",
    "dug": "dug-Latn-ZZ",
    "dv": "dv-Thaa-MV",
    "dva": "dva-Latn-ZZ",
    "dww": "dww-Latn-ZZ",
    "dyo": "dyo-Latn-SN",
    "dyu": "dyu-Latn-BF",
    "dz": "dz-Tibt-BT",
    "dzg": "dzg-Latn-ZZ",
    "ebu": "ebu-Latn-KE",
    "ee": "ee-Latn-GH",
    "efi": "efi-Latn-NG",
    "egl": "egl-Latn-IT",
    "egy": "egy-Egyp-EG",
    "eka": "eka-Latn-ZZ",
    "eky": "eky-Kali-MM",
    "el": "el-Grek-GR",
    "ema": "ema-Latn-ZZ",
    "emi": "emi-Latn-ZZ",
    "en": "en-Latn-US",
    "en-Shaw": "en-Shaw-GB",
    "enn": "enn-Latn-ZZ",
    "enq": "enq-Latn-ZZ",
    "eo": "eo-Latn-001",
    "eri": "eri-Latn-ZZ",
    "es": "es-Latn-ES",
    "esg": "esg-Gonm-IN",
    "esu": "esu-Latn-US",
    "et": "et-Latn-EE",
    "etr": "etr-Latn-ZZ",
    "ett": "ett-Ital-IT",
    "etu": "etu-Latn-ZZ",
    "etx": "etx-Latn-ZZ",
    "eu": "eu-Latn-ES",
    "ewo": "ewo-Latn-CM",
    "ext": "ext-Latn-ES",
    "eza": "eza-Latn-ZZ",
    "fa": "fa-Arab-IR",
    "faa": "faa-Latn-ZZ",
    "fab": "fab-Latn-ZZ",
    "fag": "fag-Latn-ZZ",
    "fai": "fai-Latn-ZZ",
    "fan": "fan-Latn-GQ",
    "ff": "ff-Latn-SN",
    "ff-Adlm": "ff-Adlm-GN",
    "ffi": "ffi-Latn-ZZ",
    "ffm": "ffm-Latn-ML",
    "fi": "fi-Latn-FI",
    "fia": "fia-Arab-SD",
    "fil": "fil-Latn-PH",
    "fit": "fit-Latn-SE",
    "fj": "fj-Latn-FJ",
    "flr": "flr-Latn-ZZ",
    "fmp": "fmp-Latn-ZZ",
    "fo": "fo-Latn-FO",
    "fod": "fod-Latn-ZZ",
    "fon": "fon-Latn-BJ",
    "for": "for-Latn-ZZ",
    "fpe": "fpe-Latn-ZZ",
    "fqs": "fqs-Latn-ZZ",
    "fr": "fr-Latn-FR",
    "frc": "frc-Latn-US",
    "frp": "frp-Latn-FR",
    "frr": "frr-Latn-DE",
    "frs": "frs-Latn-DE",
    "fub": "fub-Arab-CM",
    "fud": "fud-Latn-WF",
    "fue": "fue-Latn-ZZ",
    "fuf": "fuf-Latn-GN",
    "fuh": "fuh-Latn-ZZ",
    "fuq": "fuq-Latn-NE",
    "fur": "fur-Latn-IT",
    "fuv": "fuv-Latn-NG",
    "fuy": "fuy-Latn-ZZ",
    "fvr": "fvr-Latn-SD",
    "fy": "fy-Latn-NL",
    "ga": "ga-Latn-IE",
    "gaa": "gaa-Latn-GH",
    "gaf": "gaf-Latn-ZZ",
    "gag": "gag-Latn-MD",
    "gah": "gah-Latn-ZZ",
    "gaj": "gaj-Latn-ZZ",
    "gam": "gam-Latn-ZZ",
    "gan": "gan-Hans-CN",
    "gaw": "gaw-Latn-ZZ",
    "gay": "gay-Latn-ID",
    "gba": "gba-Latn-ZZ",
    "gbf": "gbf-Latn-ZZ",
    "gbm": "gbm-Deva-IN",
    "gby": "gby-Latn-ZZ",
    "gbz": "gbz-Arab-IR",
    "gcr": "gcr-Latn-GF",
    "gd": "gd-Latn-GB",
    "gde": "gde-Latn-ZZ",
    "gdn": "gdn-Latn-ZZ",
    "gdr": "gdr-Latn-ZZ",
    "geb": "geb-Latn-ZZ",
    "gej": "gej-Latn-ZZ",
    "gel": "gel-Latn-ZZ",
    "gez": "gez-Ethi-ET",
    "gfk": "gfk-Latn-ZZ",
    "ggn": "ggn-Deva-NP",
    "ghs": "ghs-Latn-ZZ",
    "gil": "gil-Latn-KI",
    "gim": "gim-Latn-ZZ",
    "gjk": "gjk-Arab-PK",
    "gjn": "gjn-Latn-ZZ",
    "gju": "gju-Arab-PK",
    "gkn": "gkn-Latn-ZZ",
    "gkp": "gkp-Latn-ZZ",
    "gl": "gl-Latn-ES",
    "glk": "glk-Arab-IR",
    "gmm": "gmm-Latn-ZZ",
    "gmv": "gmv-Ethi-ZZ",
    "gn": "gn-Latn-PY",
    "gnd": "gnd-Latn-ZZ",
    "gng": "gng-Latn-ZZ",
    "god": "god-Latn-ZZ",
    "gof": "gof-Ethi-ZZ",
    "goi": "goi-Latn-ZZ",
    "gom": "gom-Deva-IN",
    "gon": "gon-Telu-IN",
    "gor": "gor-Latn-ID",
    "gos": "gos-Latn-NL",
    "got": "got-Goth-UA",
    "grb": "grb-Latn-ZZ",
    "grc": "grc-Cprt-CY",
    "grc-Linb": "grc-Linb-GR",
    "grt": "grt-Beng-IN",
    "grw": "grw-Latn-ZZ",
    "gsw": "gsw-Latn-CH",
    "gu": "gu-Gujr-IN",
    "gub": "gub-Latn-BR",
    "guc": "guc-Latn-CO",
    "gud": "gud-Latn-ZZ",
    "gur": "gur-Latn-GH",
    "guw": "guw-Latn-ZZ",
    "gux": "gux-Latn-ZZ",
    "guz": "guz-Latn-KE",
    "gv": "gv-Latn-IM",
    "gvf": "gvf-Latn-ZZ",
    "gvr": "gvr-Deva-NP",
    "gvs": "gvs-Latn-ZZ",
    "gwc": "gwc-Arab-ZZ",
    "gwi": "gwi-Latn-CA",
    "gwt": "gwt-Arab-ZZ",
    "gyi": "gyi-Latn-ZZ",
    "ha": "ha-Latn-NG",
    "ha-CM": "ha-Arab-CM",
    "ha-SD": "ha-Arab-SD",
    "hag": "hag-Latn-ZZ",
    "hak": "hak-Hans-CN",
    "ham": "ham-Latn-ZZ",
    "haw": "haw-Latn-US",
    "haz": "haz-Arab-AF",
    "hbb": "hbb-Latn-ZZ",
    "hdy": "hdy-Ethi-ZZ",
    "he": "he-Hebr-IL",
    "hhy": "hhy-Latn-ZZ",
    "hi": "hi-Deva-IN",
    "hia": "hia-Latn-ZZ",
    "hif": "hif-Latn-FJ",
    "hig": "hig-Latn-ZZ",
    "hih": "hih-Latn-ZZ",
    "hil": "hil-Latn-PH",
    "hla": "hla-Latn-ZZ",
    "hlu": "hlu-Hluw-TR",
    "hmd": "hmd-Plrd-CN",
    "hmt": "hmt-Latn-ZZ",
    "hnd": "hnd-Arab-PK",
    "hne": "hne-Deva-IN",
    "hnj": "hnj-Hmnp-US",
    "hnn": "hnn-Latn-PH",
    "hno": "hno-Arab-PK",
    "ho": "ho-Latn-PG",
    "hoc": "hoc-Deva-IN",
    "hoj": "hoj-Deva-IN",
    "hot": "hot-Latn-ZZ",
    "hr": "hr-Latn-HR",
    "hsb": "hsb-Latn-DE",
    "hsn": "hsn-Hans-CN",
    "ht": "ht-Latn-HT",
    "hu": "hu-Latn-HU",
    "hui": "hui-Latn-ZZ",
    "hy": "hy-Armn-AM",
    "hz": "hz-Latn-NA",
    "ia": "ia-Latn-001",
    "ian": "ian-Latn-ZZ",
    "iar": "iar-Latn-ZZ",
    "iba": "iba-Latn-MY",
    "ibb": "ibb-Latn-NG",
    "iby": "iby-Latn-ZZ",
    "ica": "ica-Latn-ZZ",
    "ich": "ich-Latn-ZZ",
    "id": "id-Latn-ID",
    "idd": "idd-Latn-ZZ",
    "idi": "idi-Latn-ZZ",
    "idu": "idu-Latn-ZZ",
    "ife": "ife-Latn-TG",
    "ig": "ig-Latn-NG",
    "igb": "igb-Latn-ZZ",
    "ige": "ige-Latn-ZZ",
    "ii": "ii-Yiii-CN",
    "ijj": "ijj-Latn-ZZ",
    "ik": "ik-Latn-US",
    "ikk": "ikk-Latn-ZZ",
    "ikt": "ikt-Latn-CA",
    "ikw": "ikw-Latn-ZZ",
    "ikx": "ikx-Latn-ZZ",
    "ilo": "ilo-Latn-PH",
    "imo": "imo-Latn-ZZ",
    "in": "in-Latn-ID",
    "inh": "inh-Cyrl-RU",
    "io": "io-Latn-001",
    "iou": "iou-Latn-ZZ",
    "iri": "iri-Latn-ZZ",
    "is": "is-Latn-IS",
    "it": "it-Latn-IT",
    "iu": "iu-Cans-CA",
    "iw": "iw-Hebr-IL",
    "iwm": "iwm-Latn-ZZ",
    "iws": "iws-Latn-ZZ",
    "izh": "izh-Latn-RU",
    "izi": "izi-Latn-ZZ",
    "ja": "ja-Jpan-JP",
    "jab": "jab-Latn-ZZ",
    "jam": "jam-Latn-JM",
    "jar": "jar-Latn-ZZ",
    "jbo": "jbo-Latn-001",
    "jbu": "jbu-Latn-ZZ",
    "jen": "jen-Latn-ZZ",
    "jgk": "jgk-Latn-ZZ",
    "jgo": "jgo-Latn-CM",
    "ji": "ji-Hebr-UA",
    "jib": "jib-Latn-ZZ",
    "jmc": "jmc-Latn-TZ",
    "jml": "jml-Deva-NP",
    "jra": "jra-Latn-ZZ",
    "jut": "jut-Latn-DK",
    "jv": "jv-Latn-ID",
    "jw": "jw-Latn-ID",
    "ka": "ka-Geor-GE",
    "kaa": "kaa-Cyrl-UZ",
    "kab": "kab-Latn-DZ",
    "kac": "kac-Latn-MM",
    "kad": "kad-Latn-ZZ",
    "kai": "kai-Latn-ZZ",
    "kaj": "kaj-Latn-NG",
    "kam": "kam-Latn-KE",
    "kao": "kao-Latn-ML",
    "kbd": "kbd-Cyrl-RU",
    "kbm": "kbm-Latn-ZZ",
    "kbp": "kbp-Latn-ZZ",
    "kbq": "kbq-Latn-ZZ",
    "kbx": "kbx-Latn-ZZ",
    "kby": "kby-Arab-NE",
    "kcg": "kcg-Latn-NG",
    "kck": "kck-Latn-ZW",
    "kcl": "kcl-Latn-ZZ",
    "kct": "kct-Latn-ZZ",
    "kde": "kde-Latn-TZ",
    "kdh": "kdh-Latn-TG",
    "kdl": "kdl-Latn-ZZ",
    "kdt": "kdt-Thai-TH",
    "kea": "kea-Latn-CV",
    "ken": "ken-Latn-CM",
    "kez": "kez-Latn-ZZ",
    "kfo": "kfo-Latn-CI",
    "kfr": "kfr-Deva-IN",
    "kfy": "kfy-Deva-IN",
    "kg": "kg-Latn-CD",
    "kge": "kge-Latn-ID",
    "kgf": "kgf-Latn-ZZ",
    "kgp": "kgp-Latn-BR",
    "kha": "kha-Latn-IN",
    "khb": "khb-Talu-CN",
    "khn": "khn-Deva-IN",
    "khq": "khq-Latn-ML",
    "khs": "khs-Latn-ZZ",
    "kht": "kht-Mymr-IN",
    "khw": "khw-Arab-PK",
    "khz": "khz-Latn-ZZ",
    "ki": "ki-Latn-KE",
    "kij": "kij-Latn-ZZ",
    "kiu": "kiu-Latn-TR",
    "kiw": "kiw-Latn-ZZ",
    "kj": "kj-Latn-NA",
    "kjd": "kjd-Latn-ZZ",
    "kjg": "kjg-Laoo-LA",
    "kjs": "kjs-Latn-ZZ",
    "kjy": "kjy-Latn-ZZ",
    "kk": "kk-Cyrl-KZ",
    "kk-AF": "kk-Arab-AF",
    "kk-Arab": "kk-Arab-CN",
    "kk-CN": "kk-Arab-CN",
    "kk-IR": "kk-Arab-IR",
    "kk-MN": "kk-Arab-MN",
    "kkc": "kkc-Latn-ZZ",
    "kkj": "kkj-Latn-CM",
    "kl": "kl-Latn-GL",
    "kln": "kln-Latn-KE",
    "klq": "klq-Latn-ZZ",
    "klt": "klt-Latn-ZZ",
    "klx": "klx-Latn-ZZ",
    "km": "km-Khmr-KH",
    "kmb": "kmb-Latn-AO",
    "kmh": "kmh-Latn-ZZ",
    "kmo": "kmo-Latn-ZZ",
    "kms": "kms-Latn-ZZ",
    "kmu": "kmu-Latn-ZZ",
    "kmw": "kmw-Latn-ZZ",
    "kn": "kn-Knda-IN",
    "knf": "knf-Latn-GW",
    "knp": "knp-Latn-ZZ",
    "ko": "ko-Kore-KR",
    "koi": "koi-Cyrl-RU",
    "kok": "kok-Deva-IN",
    "kol": "kol-Latn-ZZ",
    "kos": "kos-Latn-FM",
    "koz": "koz-Latn-ZZ",
    "kpe": "kpe-Latn-LR",
    "kpf": "kpf-Latn-ZZ",
    "kpo": "kpo-Latn-ZZ",
    "kpr": "kpr-Latn-ZZ",
    "kpx": "kpx-Latn-ZZ",
    "kqb": "kqb-Latn-ZZ",
    "kqf": "kqf-Latn-ZZ",
    "kqs": "kqs-Latn-ZZ",
    "kqy": "kqy-Ethi-ZZ",
    "kr": "kr-Latn-ZZ",
    "krc": "krc-Cyrl-RU",
    "kri": "kri-Latn-SL",
    "krj": "krj-Latn-PH",
    "krl": "krl-Latn-RU",
    "krs": "krs-Latn-ZZ",
    "kru": "kru-Deva-IN",
    "ks": "ks-Arab-IN",
    "ksb": "ksb-Latn-TZ",
    "ksd": "ksd-Latn-ZZ",
    "ksf": "ksf-Latn-CM",
    "ksh": "ksh-Latn-DE",
    "ksj": "ksj-Latn-ZZ",
    "ksr": "ksr-Latn-ZZ",
    "ktb": "ktb-Ethi-ZZ",
    "ktm": "ktm-Latn-ZZ",
    "kto": "kto-Latn-ZZ",
    "ktr": "ktr-Latn-MY",
    "ku": "ku-Latn-TR",
    "ku-Arab": "ku-Arab-IQ",
    "ku-LB": "ku-Arab-LB",
    "ku-Yezi": "ku-Yezi-GE",
    "kub": "kub-Latn-ZZ",
    "kud": "kud-Latn-ZZ",
    "kue": "kue-Latn-ZZ",
    "kuj": "kuj-Latn-ZZ",
    "kum": "kum-Cyrl-RU",
    "kun": "kun-Latn-ZZ",
    "kup": "kup-Latn-ZZ",
    "kus": "kus-Latn-ZZ",
    "kv": "kv-Cyrl-RU",
    "kvg": "kvg-Latn-ZZ",
    "kvr": "kvr-Latn-ID",
    "kvx": "kvx-Arab-PK",
    "kw": "kw-Latn-GB",
    "kwj": "kwj-Latn-ZZ",
    "kwo": "kwo-Latn-ZZ",
    "kwq": "kwq-Latn-ZZ",
    "kxa": "kxa-Latn-ZZ",
    "kxc": "kxc-Ethi-ZZ",
    "kxe": "kxe-Latn-ZZ",
    "kxl": "kxl-Deva-IN",
    "kxm": "kxm-Thai-TH",
    "kxp": "kxp-Arab-PK",
    "kxw": "kxw-Latn-ZZ",
    "kxz": "kxz-Latn-ZZ",
    "ky": "ky-Cyrl-KG",
    "ky-Arab": "ky-Arab-CN",
    "ky-CN": "ky-Arab-CN",
    "ky-Latn": "ky-Latn-TR",
    "ky-TR": "ky-Latn-TR",
    "kye": "kye-Latn-ZZ",
    "kyx": "kyx-Latn-ZZ",
    "kzh": "kzh-Arab-ZZ",
    "kzj": "kzj-Latn-MY",
    "kzr": "kzr-Latn-ZZ",
    "kzt": "kzt-Latn-MY",
    "la": "la-Latn-VA",
    "lab": "lab-Lina-GR",
    "lad": "lad-Hebr-IL",
    "lag": "lag-Latn-TZ",
    "lah": "lah-Arab-PK",
    "laj": "laj-Latn-UG",
    "las": "las-Latn-ZZ",
    "lb": "lb-Latn-LU",
    "lbe": "lbe-Cyrl-RU",
    "lbu": "lbu-Latn-ZZ",
    "lbw": "lbw-Latn-ID",
    "lcm": "lcm-Latn-ZZ",
    "lcp": "lcp-Thai-CN",
    "ldb": "ldb-Latn-ZZ",
    "led": "led-Latn-ZZ",
    "lee": "lee-Latn-ZZ",
    "lem": "lem-Latn-ZZ",
    "lep": "lep-Lepc-IN",
    "leq": "leq-Latn-ZZ",
    "leu": "leu-Latn-ZZ",
    "lez": "lez-Cyrl-RU",
    "lg": "lg-Latn-UG",
    "lgg": "lgg-Latn-ZZ",
    "li": "li-Latn-NL",
    "lia": "lia-Latn-ZZ",
    "lid": "lid-Latn-ZZ",
    "lif": "lif-Deva-NP",
    "lif-Limb": "lif-Limb-IN",
    "lig": "lig-Latn-ZZ",
    "lih": "lih-Latn-ZZ",
    "lij": "lij-Latn-IT",
    "lis": "lis-Lisu-CN",
    "ljp": "ljp-Latn-ID",
    "lki": "lki-Arab-IR",
    "lkt": "lkt-Latn-US",
    "lle": "lle-Latn-ZZ",
    "lln": "lln-Latn-ZZ",
    "lmn": "lmn-Telu-IN",
    "lmo": "lmo-Latn-IT",
    "lmp": "lmp-Latn-ZZ",
    "ln": "ln-Latn-CD",
    "lns": "lns-Latn-ZZ",
    "lnu": "lnu-Latn-ZZ",
    "lo": "lo-Laoo-LA",
    "loj": "loj-Latn-ZZ",
    "lok": "lok-Latn-ZZ",
    "lol": "lol-Latn-CD",
    "lor": "lor-Latn-ZZ",
    "los": "los-Latn-ZZ",
    "loz": "loz-Latn-ZM",
    "lrc": "lrc-Arab-IR",
    "lt": "lt-Latn-LT",
    "ltg": "ltg-Latn-LV",
    "lu": "lu-Latn-CD",
    "lua": "lua-Latn-CD",
    "luo": "luo-Latn-KE",
    "luy": "luy-Latn-KE",
    "luz": "luz-Arab-IR",
    "lv": "lv-Latn-LV",
    "lwl": "lwl-Thai-TH",
    "lzh": "lzh-Hans-CN",
    "lzz": "lzz-Latn-TR",
    "mad": "mad-Latn-ID",
    "maf": "maf-Latn-CM",
    "mag": "mag-Deva-IN",
    "mai": "mai-Deva-IN",
    "mak": "mak-Latn-ID",
    "man": "man-Latn-GM",
    "man-GN": "man-Nkoo-GN",
    "man-Nkoo": "man-Nkoo-GN",
    "mas": "mas-Latn-KE",
    "maw": "maw-Latn-ZZ",
    "maz": "maz-Latn-MX",
    "mbh": "mbh-Latn-ZZ",
    "mbo": "mbo-Latn-ZZ",
    "mbq": "mbq-Latn-ZZ",
    "mbu": "mbu-Latn-ZZ",
    "mbw": "mbw-Latn-ZZ",
    "mci": "mci-Latn-ZZ",
    "mcp": "mcp-Latn-ZZ",
    "mcq": "mcq-Latn-ZZ",
    "mcr": "mcr-Latn-ZZ",
    "mcu": "mcu-Latn-ZZ",
    "mda": "mda-Latn-ZZ",
    "mde": "mde-Arab-ZZ",
    "mdf": "mdf-Cyrl-RU",
    "mdh": "mdh-Latn-PH",
    "mdj": "mdj-Latn-ZZ",
    "mdr": "mdr-Latn-ID",
    "mdx": "mdx-Ethi-ZZ",
    "med": "med-Latn-ZZ",
    "mee": "mee-Latn-ZZ",
    "mek": "mek-Latn-ZZ",
    "men": "men-Latn-SL",
    "mer": "mer-Latn-KE",
    "met": "met-Latn-ZZ",
    "meu": "meu-Latn-ZZ",
    "mfa": "mfa-Arab-TH",
    "mfe": "mfe-Latn-MU",
    "mfn": "mfn-Latn-ZZ",
    "mfo": "mfo-Latn-ZZ",
    "mfq": "mfq-Latn-ZZ",
    "mg": "mg-Latn-MG",
    "mgh": "mgh-Latn-MZ",
    "mgl": "mgl-Latn-ZZ",
    "mgo": "mgo-Latn-CM",
    "mgp": "mgp-Deva-NP",
    "mgy": "mgy-Latn-TZ",
    "mh": "mh-Latn-MH",
    "mhi": "mhi-Latn-ZZ",
    "mhl": "mhl-Latn-ZZ",
    "mi": "mi-Latn-NZ",
    "mif": "mif-Latn-ZZ",
    "min": "min-Latn-ID",
    "miw": "miw-Latn-ZZ",
    "mk": "mk-Cyrl-MK",
    "mki": "mki-Arab-ZZ",
    "mkl": "mkl-Latn-ZZ",
    "mkp": "mkp-Latn-ZZ",
    "mkw": "mkw-Latn-ZZ",
    "ml": "ml-Mlym-IN",
    "mle": "mle-Latn-ZZ",
    "mlp": "mlp-Latn-ZZ",
    "mls": "mls-Latn-SD",
    "mmo": "mmo-Latn-ZZ",
    "mmu": "mmu-Latn-ZZ",
    "mmx": "mmx-Latn-ZZ",
    "mn": "mn-Cyrl-MN",
    "mn-CN": "mn-Mong-CN",
    "mn-Mong": "mn-Mong-CN",
    "mna": "mna-Latn-ZZ",
    "mnf": "mnf-Latn-ZZ",
    "mni": "mni-Beng-IN",
    "mnw": "mnw-Mymr-MM",
    "mo": "mo-Latn-RO",
    "moa": "moa-Latn-ZZ",
    "moe": "moe-Latn-CA",
    "moh": "moh-Latn-CA",
    "mos": "mos-Latn-BF",
    "mox": "mox-Latn-ZZ",
    "mpp": "mpp-Latn-ZZ",
    "mps": "mps-Latn-ZZ",
    "mpt": "mpt-Latn-ZZ",
    "mpx": "mpx-Latn-ZZ",
    "mql": "mql-Latn-ZZ",
    "mr": "mr-Deva-IN",
    "mrd": "mrd-Deva-NP",
    "mrj": "mrj-Cyrl-RU",
    "mro": "mro-Mroo-BD",
    "ms": "ms-Latn-MY",
    "ms-CC": "ms-Arab-CC",
    "mt": "mt-Latn-MT",
    "mtc": "mtc-Latn-ZZ",
    "mtf": "mtf-Latn-ZZ",
    "mti": "mti-Latn-ZZ",
    "mtr": "mtr-Deva-IN",
    "mua": "mua-Latn-CM",
    "mur": "mur-Latn-ZZ",
    "mus": "mus-Latn-US",
    "mva": "mva-Latn-ZZ",
    "mvn": "mvn-Latn-ZZ",
    "mvy": "mvy-Arab-PK",
    "mwk": "mwk-Latn-ML",
    "mwr": "mwr-Deva-IN",
    "mwv": "mwv-Latn-ID",
    "mww": "mww-Hmnp-US",
    "mxc": "mxc-Latn-ZW",
    "mxm": "mxm-Latn-ZZ",
    "my": "my-Mymr-MM",
    "myk": "myk-Latn-ZZ",
    "mym": "mym-Ethi-ZZ",
    "myv": "myv-Cyrl-RU",
    "myw": "myw-Latn-ZZ",
    "myx": "myx-Latn-UG",
    "myz": "myz-Mand-IR",
    "mzk": "mzk-Latn-ZZ",
    "mzm": "mzm-Latn-ZZ",
    "mzn": "mzn-Arab-IR",
    "mzp": "mzp-Latn-ZZ",
    "mzw": "mzw-Latn-ZZ",
    "mzz": "mzz-Latn-ZZ",
    "na": "na-Latn-NR",
    "nac": "nac-Latn-ZZ",
    "naf": "naf-Latn-ZZ",
    "nak": "nak-Latn-ZZ",
    "nan": "nan-Hans-CN",
    "nap": "nap-Latn-IT",
    "naq": "naq-Latn-NA",
    "nas": "nas-Latn-ZZ",
    "nb": "nb-Latn-NO",
    "nca": "nca-Latn-ZZ",
    "nce": "nce-Latn-ZZ",
    "ncf": "ncf-Latn-ZZ",
    "nch": "nch-Latn-MX",
    "nco": "nco-Latn-ZZ",
    "ncu": "ncu-Latn-ZZ",
    "nd": "nd-Latn-ZW",
    "ndc": "ndc-Latn-MZ",
    "nds": "nds-Latn-DE",
    "ne": "ne-Deva-NP",
    "neb": "neb-Latn-ZZ",
    "new": "new-Deva-NP",
    "nex": "nex-Latn-ZZ",
    "nfr": "nfr-Latn-ZZ",
    "ng": "ng-Latn-NA",
    "nga": "nga-Latn-ZZ",
    "ngb": "ngb-Latn-ZZ",
    "ngl": "ngl-Latn-MZ",
    "nhb": "nhb-Latn-ZZ",
    "nhe": "nhe-Latn-MX",
    "nhw": "nhw-Latn-MX",
    "nif": "nif-Latn-ZZ",
    "nii": "nii-Latn-ZZ",
    "nij": "nij-Latn-ID",
    "nin": "nin-Latn-ZZ",
    "niu": "niu-Latn-NU",
    "niy": "niy-Latn-ZZ",
    "niz": "niz-Latn-ZZ",
    "njo": "njo-Latn-IN",
    "nkg": "nkg-Latn-ZZ",
    "nko": "nko-Latn-ZZ",
    "nl": "nl-Latn-NL",
    "nmg": "nmg-Latn-CM",
    "nmz": "nmz-Latn-ZZ",
    "nn": "nn-Latn-NO",
    "nnf": "nnf-Latn-ZZ",
    "nnh": "nnh-Latn-CM",
    "nnk": "nnk-Latn-ZZ",
    "nnm": "nnm-Latn-ZZ",
    "nnp": "nnp-Wcho-IN",
    "no": "no-Latn-NO",
    "nod": "nod-Lana-TH",
    "noe": "noe-Deva-IN",
    "non": "non-Runr-SE",
    "nop": "nop-Latn-ZZ",
    "nou": "nou-Latn-ZZ",
    "nqo": "nqo-Nkoo-GN",
    "nr": "nr-Latn-ZA",
    "nrb": "nrb-Latn-ZZ",
    "nsk": "nsk-Cans-CA",
    "nsn": "nsn-Latn-ZZ",
    "nso": "nso-Latn-ZA",
    "nss": "nss-Latn-ZZ",
    "nst": "nst-Tnsa-IN",
    "ntm": "ntm-Latn-ZZ",
    "ntr": "ntr-Latn-ZZ",
    "nui": "nui-Latn-ZZ",
    "nup": "nup-Latn-ZZ",
    "nus": "nus-Latn-SS",
    "nuv": "nuv-Latn-ZZ",
    "nux": "nux-Latn-ZZ",
    "nv": "nv-Latn-US",
    "nwb": "nwb-Latn-ZZ",
    "nxq": "nxq-Latn-CN",
    "nxr": "nxr-Latn-ZZ",
    "ny": "ny-Latn-MW",
    "nym": "nym-Latn-TZ",
    "nyn": "nyn-Latn-UG",
    "nzi": "nzi-Latn-GH",
    "oc": "oc-Latn-FR",
    "ogc": "ogc-Latn-ZZ",
    "okr": "okr-Latn-ZZ",
    "okv": "okv-Latn-ZZ",
    "om": "om-Latn-ET",
    "ong": "ong-Latn-ZZ",
    "onn": "onn-Latn-ZZ",
    "ons": "ons-Latn-ZZ",
    "opm": "opm-Latn-ZZ",
    "or": "or-Orya-IN",
    "oro": "oro-Latn-ZZ",
    "oru": "oru-Arab-ZZ",
    "os": "os-Cyrl-GE",
    "osa": "osa-Osge-US",
    "ota": "ota-Arab-ZZ",
    "otk": "otk-Orkh-MN",
    "oui": "oui-Ougr-143",
    "ozm": "ozm-Latn-ZZ",
    "pa": "pa-Guru-IN",
    "pa-Arab": "pa-Arab-PK",
    "pa-PK": "pa-Arab-PK",
    "pag": "pag-Latn-PH",
    "pal": "pal-Phli-IR",
    "pal-Phlp": "pal-Phlp-CN",
    "pam": "pam-Latn-PH",
    "pap": "pap-Latn-AW",
    "pau": "pau-Latn-PW",
    "pbi": "pbi-Latn-ZZ",
    "pcd": "pcd-Latn-FR",
    "pcm": "pcm-Latn-NG",
    "pdc": "pdc-Latn-US",
    "pdt": "pdt-Latn-CA",
    "ped": "ped-Latn-ZZ",
    "peo": "peo-Xpeo-IR",
    "pex": "pex-Latn-ZZ",
    "pfl": "pfl-Latn-DE",
    "phl": "phl-Arab-ZZ",
    "phn": "phn-Phnx-LB",
    "pil": "pil-Latn-ZZ",
    "pip": "pip-Latn-ZZ",
    "pka": "pka-Brah-IN",
    "pko": "pko-Latn-KE",
    "pl": "pl-Latn-PL",
    "pla": "pla-Latn-ZZ",
    "pms": "pms-Latn-IT",
    "png": "png-Latn-ZZ",
    "pnn": "pnn-Latn-ZZ",
    "pnt": "pnt-Grek-GR",
    "pon": "pon-Latn-FM",
    "ppa": "ppa-Deva-IN",
    "ppo": "ppo-Latn-ZZ",
    "pra": "pra-Khar-PK",
    "prd": "prd-Arab-IR",
    "prg": "prg-Latn-001",
    "ps": "ps-Arab-AF",
    "pss": "pss-Latn-ZZ",
    "pt": "pt-Latn-BR",
    "ptp": "ptp-Latn-ZZ",
    "puu": "puu-Latn-GA",
    "pwa": "pwa-Latn-ZZ",
    "qu": "qu-Latn-PE",
    "quc": "quc-Latn-GT",
    "qug": "qug-Latn-EC",
    "rai": "rai-Latn-ZZ",
    "raj": "raj-Deva-IN",
    "rao": "rao-Latn-ZZ",
    "rcf": "rcf-Latn-RE",
    "rej": "rej-Latn-ID",
    "rel": "rel-Latn-ZZ",
    "res": "res-Latn-ZZ",
    "rgn": "rgn-Latn-IT",
    "rhg": "rhg-Rohg-MM",
    "ria": "ria-Latn-IN",
    "rif": "rif-Tfng-MA",
    "rif-NL": "rif-Latn-NL",
    "rjs": "rjs-Deva-NP",
    "rkt": "rkt-Beng-BD",
    "rm": "rm-Latn-CH",
    "rmf": "rmf-Latn-FI",
    "rmo": "rmo-Latn-CH",
    "rmt": "rmt-Arab-IR",
    "rmu": "rmu-Latn-SE",
    "rn": "rn-Latn-BI",
    "rna": "rna-Latn-ZZ",
    "rng": "rng-Latn-MZ",
    "ro": "ro-Latn-RO",
    "rob": "rob-Latn-ID",
    "rof": "rof-Latn-TZ",
    "roo": "roo-Latn-ZZ",
    "rro": "rro-Latn-ZZ",
    "rtm": "rtm-Latn-FJ",
    "ru": "ru-Cyrl-RU",
    "rue": "rue-Cyrl-UA",
    "rug": "rug-Latn-SB",
    "rw": "rw-Latn-RW",
    "rwk": "rwk-Latn-TZ",
    "rwo": "rwo-Latn-ZZ",
    "ryu": "ryu-Kana-JP",
    "sa": "sa-Deva-IN",
    "saf": "saf-Latn-GH",
    "sah": "sah-Cyrl-RU",
    "saq": "saq-Latn-KE",
    "sas": "sas-Latn-ID",
    "sat": "sat-Olck-IN",
    "sav": "sav-Latn-SN",
    "saz": "saz-Saur-IN",
    "sba": "sba-Latn-ZZ",
    "sbe": "sbe-Latn-ZZ",
    "sbp": "sbp-Latn-TZ",
    "sc": "sc-Latn-IT",
    "sck": "sck-Deva-IN",
    "scl": "scl-Arab-ZZ",
    "scn": "scn-Latn-IT",
    "sco": "sco-Latn-GB",
    "scs": "scs-Latn-CA",
    "sd": "sd-Arab-PK",
    "sd-Deva": "sd-Deva-IN",
    "sd-Khoj": "sd-Khoj-IN",
    "sd-Sind": "sd-Sind-IN",
    "sdc": "sdc-Latn-IT",
    "sdh": "sdh-Arab-IR",
    "se": "se-Latn-NO",
    "sef": "sef-Latn-CI",
    "seh": "seh-Latn-MZ",
    "sei": "sei-Latn-MX",
    "ses": "ses-Latn-ML",
    "sg": "sg-Latn-CF",
    "sga": "sga-Ogam-IE",
    "sgs": "sgs-Latn-LT",
    "sgw": "sgw-Ethi-ZZ",
    "sgz": "sgz-Latn-ZZ",
    "shi": "shi-Tfng-MA",
    "shk": "shk-Latn-ZZ",
    "shn": "shn-Mymr-MM",
    "shu": "shu-Arab-ZZ",
    "si": "si-Sinh-LK",
    "sid": "sid-Latn-ET",
    "sig": "sig-Latn-ZZ",
    "sil": "sil-Latn-ZZ",
    "sim": "sim-Latn-ZZ",
    "sjr": "sjr-Latn-ZZ",
    "sk": "sk-Latn-SK",
    "skc": "skc-Latn-ZZ",
    "skr": "skr-Arab-PK",
    "sks": "sks-Latn-ZZ",
    "sl": "sl-Latn-SI",
    "sld": "sld-Latn-ZZ",
    "sli": "sli-Latn-PL",
    "sll": "sll-Latn-ZZ",
    "sly": "sly-Latn-ID",
    "sm": "sm-Latn-WS",
    "sma": "sma-Latn-SE",
    "smj": "smj-Latn-SE",
    "smn": "smn-Latn-FI",
    "smp": "smp-Samr-IL",
    "smq": "smq-Latn-ZZ",
    "sms": "sms-Latn-FI",
    "sn": "sn-Latn-ZW",
    "snc": "snc-Latn-ZZ",
    "snk": "snk-Latn-ML",
    "snp": "snp-Latn-ZZ",
    "snx": "snx-Latn-ZZ",
    "sny": "sny-Latn-ZZ",
    "so": "so-Latn-SO",
    "sog": "sog-Sogd-UZ",
    "sok": "sok-Latn-ZZ",
    "soq": "soq-Latn-ZZ",
    "sou": "sou-Thai-TH",
    "soy": "soy-Latn-ZZ",
    "spd": "spd-Latn-ZZ",
    "spl": "spl-Latn-ZZ",
    "sps": "sps-Latn-ZZ",
    "sq": "sq-Latn-AL",
    "sr": "sr-Cyrl-RS",
    "sr-ME": "sr-Latn-ME",
    "sr-RO": "sr-Latn-RO",
    "sr-RU": "sr-Latn-RU",
    "sr-TR": "sr-Latn-TR",
    "srb": "srb-Sora-IN",
    "srn": "srn-Latn-SR",
    "srr": "srr-Latn-SN",
    "srx": "srx-Deva-IN",
    "ss": "ss-Latn-ZA",
    "ssd": "ssd-Latn-ZZ",
    "ssg": "ssg-Latn-ZZ",
    "ssy": "ssy-Latn-ER",
    "st": "st-Latn-ZA",
    "stk": "stk-Latn-ZZ",
    "stq": "stq-Latn-DE",
    "su": "su-Latn-ID",
    "sua": "sua-Latn-ZZ",
    "sue": "sue-Latn-ZZ",
    "suk": "suk-Latn-TZ",
    "sur": "sur-Latn-ZZ",
    "sus": "sus-Latn-GN",
    "sv": "sv-Latn-SE",
    "sw": "sw-Latn-TZ",
    "swb": "swb-Arab-YT",
    "swc": "swc-Latn-CD",
    "swg": "swg-Latn-DE",
    "swp": "swp-Latn-ZZ",
    "swv": "swv-Deva-IN",
    "sxn": "sxn-Latn-ID",
    "sxw": "sxw-Latn-ZZ",
    "syl": "syl-Beng-BD",
    "syr": "syr-Syrc-IQ",
    "szl": "szl-Latn-PL",
    "ta": "ta-Taml-IN",
    "taj": "taj-Deva-NP",
    "tal": "tal-Latn-ZZ",
    "tan": "tan-Latn-ZZ",
    "taq": "taq-Latn-ZZ",
    "tbc": "tbc-Latn-ZZ",
    "tbd": "tbd-Latn-ZZ",
    "tbf": "tbf-Latn-ZZ",
    "tbg": "tbg-Latn-ZZ",
    "tbo": "tbo-Latn-ZZ",
    "tbw": "tbw-Latn-PH",
    "tbz": "tbz-Latn-ZZ",
    "tci": "tci-Latn-ZZ",
    "tcy": "tcy-Knda-IN",
    "tdd": "tdd-Tale-CN",
    "tdg": "tdg-Deva-NP",
    "tdh": "tdh-Deva-NP",
    "tdu": "tdu-Latn-MY",
    "te": "te-Telu-IN",
    "ted": "ted-Latn-ZZ",
    "tem": "tem-Latn-SL",
    "teo": "teo-Latn-UG",
    "tet": "tet-Latn-TL",
    "tfi": "tfi-Latn-ZZ",
    "tg": "tg-Cyrl-TJ",
    "tg-Arab": "tg-Arab-PK",
    "tg-PK": "tg-Arab-PK",
    "tgc": "tgc-Latn-ZZ",
    "tgo": "tgo-Latn-ZZ",
    "tgu": "tgu-Latn-ZZ",
    "th": "th-Thai-TH",
    "thl": "thl-Deva-NP",
    "thq": "thq-Deva-NP",
    "thr": "thr-Deva-NP",
    "ti": "ti-Ethi-ET",
    "tif": "tif-Latn-ZZ",
    "tig": "tig-Ethi-ER",
    "tik": "tik-Latn-ZZ",
    "tim": "tim-Latn-ZZ",
    "tio": "tio-Latn-ZZ",
    "tiv": "tiv-Latn-NG",
    "tk": "tk-Latn-TM",
    "tkl": "tkl-Latn-TK",
    "tkr": "tkr-Latn-AZ",
    "tkt": "tkt-Deva-NP",
    "tl": "tl-Latn-PH",
    "tlf": "tlf-Latn-ZZ",
    "tlx": "tlx-Latn-ZZ",
    "tly": "tly-Latn-AZ",
    "tmh": "tmh-Latn-NE",
    "tmy": "tmy-Latn-ZZ",
    "tn": "tn-Latn-ZA",
    "tnh": "tnh-Latn-ZZ",
    "to": "to-Latn-TO",
    "tof": "tof-Latn-ZZ",
    "tog": "tog-Latn-MW",
    "toq": "toq-Latn-ZZ",
    "tpi": "tpi-Latn-PG",
    "tpm": "tpm-Latn-ZZ",
    "tpz": "tpz-Latn-ZZ",
    "tqo": "tqo-Latn-ZZ",
    "tr": "tr-Latn-TR",
    "tru": "tru-Latn-TR",
    "trv": "trv-Latn-TW",
    "trw": "trw-Arab-PK",
    "ts": "ts-Latn-ZA",
    "tsd": "tsd-Grek-GR",
    "tsf": "tsf-Deva-NP",
    "tsg": "tsg-Latn-PH",
    "tsj": "tsj-Tibt-BT",
    "tsw": "tsw-Latn-ZZ",
    "tt": "tt-Cyrl-RU",
    "ttd": "ttd-Latn-ZZ",
    "tte": "tte-Latn-ZZ",
    "ttj": "ttj-Latn-UG",
    "ttr": "ttr-Latn-ZZ",
    "tts": "tts-Thai-TH",
    "ttt": "ttt-Latn-AZ",
    "tuh": "tuh-Latn-ZZ",
    "tul": "tul-Latn-ZZ",
    "tum": "tum-Latn-MW",
    "tuq": "tuq-Latn-ZZ",
    "tvd": "tvd-Latn-ZZ",
    "tvl": "tvl-Latn-TV",
    "tvu": "tvu-Latn-ZZ",
    "twh": "twh-Latn-ZZ",
    "twq": "twq-Latn-NE",
    "txg": "txg-Tang-CN",
    "txo": "txo-Toto-IN",
    "ty": "ty-Latn-PF",
    "tya": "tya-Latn-ZZ",
    "tyv": "tyv-Cyrl-RU",
    "tzm": "tzm-Latn-MA",
    "ubu": "ubu-Latn-ZZ",
    "udi": "udi-Aghb-RU",
    "udm": "udm-Cyrl-RU",
    "ug": "ug-Arab-CN",
    "ug-Cyrl": "ug-Cyrl-KZ",
    "ug-KZ": "ug-Cyrl-KZ",
    "ug-MN": "ug-Cyrl-MN",
    "uga": "uga-Ugar-SY",
    "uk": "uk-Cyrl-UA",
    "uli": "uli-Latn-FM",
    "umb": "umb-Latn-AO",
    "und": "en-Latn-US",
    "und-002": "en-Latn-NG",
    "und-003": "en-Latn-US",
    "und-005": "pt-Latn-BR",
    "und-009": "en-Latn-AU",
    "und-011": "en-Latn-NG",
    "und-013": "es-Latn-MX",
    "und-014": "sw-Latn-TZ",
    "und-015": "ar-Arab-EG",
    "und-017": "sw-Latn-CD",
    "und-018": "en-Latn-ZA",
    "und-019": "en-Latn-US",
    "und-021": "en-Latn-US",
    "und-029": "es-Latn-CU",
    "und-030": "zh-Hans-CN",
    "und-034": "hi-Deva-IN",
    "und-035": "id-Latn-ID",
    "und-039": "it-Latn-IT",
    "und-053": "en-Latn-AU",
    "und-054": "en-Latn-PG",
    "und-057": "en-Latn-GU",
    "und-061": "sm-Latn-WS",
    "und-142": "zh-Hans-CN",
    "und-143": "uz-Latn-UZ",
    "und-145": "ar-Arab-SA",
    "und-150": "ru-Cyrl-RU",
    "und-151": "ru-Cyrl-RU",
    "und-154": "en-Latn-GB",
    "und-155": "de-Latn-DE",
    "und-202": "en-Latn-NG",
    "und-419": "es-Latn-419",
    "und-AD": "ca-Latn-AD",
    "und-Adlm": "ff-Adlm-GN",
    "und-AE": "ar-Arab-AE",
    "und-AF": "fa-Arab-AF",
    "und-Aghb": "udi-Aghb-RU",
    "und-Ahom": "aho-Ahom-IN",
    "und-AL": "sq-Latn-AL",
    "und-AM": "hy-Armn-AM",
    "und-AO": "pt-Latn-AO",
    "und-AQ": "und-Latn-AQ",
    "und-AR": "es-Latn-AR",
    "und-Arab": "ar-Arab-EG",
    "und-Arab-CC": "ms-Arab-CC",
    "und-Arab-CN": "ug-Arab-CN",
    "und-Arab-GB": "ks-Arab-GB",
    "und-Arab-ID": "ms-Arab-ID",
    "und-Arab-IN": "ur-Arab-IN",
    "und-Arab-KH": "cja-Arab-KH",
    "und-Arab-MM": "rhg-Arab-MM",
    "und-Arab-MN": "kk-Arab-MN",
    "und-Arab-MU": "ur-Arab-MU",
    "und-Arab-NG": "ha-Arab-NG",
    "und-Arab-PK": "ur-Arab-PK",
    "und-Arab-TG": "apd-Arab-TG",
    "und-Arab-TH": "mfa-Arab-TH",
    "und-Arab-TJ": "fa-Arab-TJ",
    "und-Arab-TR": "az-Arab-TR",
    "und-Arab-YT": "swb-Arab-YT",
    "und-Armi": "arc-Armi-IR",
    "und-Armn": "hy-Armn-AM",
    "und-AS": "sm-Latn-AS",
    "und-AT": "de-Latn-AT",
    "und-Avst": "ae-Avst-IR",
    "und-AW": "nl-Latn-AW",
    "und-AX": "sv-Latn-AX",
    "und-AZ": "az-Latn-AZ",
    "und-BA": "bs-Latn-BA",
    "und-Bali": "ban-Bali-ID",
    "und-Bamu": "bax-Bamu-CM",
    "und-Bass": "bsq-Bass-LR",
    "und-Batk": "bbc-Batk-ID",
    "und-BD": "bn-Beng-BD",
    "und-BE": "nl-Latn-BE",
    "und-Beng": "bn-Beng-BD",
    "und-BF": "fr-Latn-BF",
    "und-BG": "bg-Cyrl-BG",
    "und-BH": "ar-Arab-BH",
    "und-Bhks": "sa-Bhks-IN",
    "und-BI": "rn-Latn-BI",
    "und-BJ": "fr-Latn-BJ",
    "und-BL": "fr-Latn-BL",
    "und-BN": "ms-Latn-BN",
    "und-BO": "es-Latn-BO",
    "und-Bopo": "zh-Bopo-TW",
    "und-BQ": "pap-Latn-BQ",
    "und-BR": "pt-Latn-BR",
    "und-Brah": "pka-Brah-IN",
    "und-Brai": "fr-Brai-FR",
    "und-BT": "dz-Tibt-BT",
    "und-Bugi": "bug-Bugi-ID",
    "und-Buhd": "bku-Buhd-PH",
    "und-BV": "und-Latn-BV",
    "und-BY": "be-Cyrl-BY",
    "und-Cakm": "ccp-Cakm-BD",
    "und-Cans": "cr-Cans-CA",
    "und-Cari": "xcr-Cari-TR",
    "und-CD": "sw-Latn-CD",
    "und-CF": "fr-Latn-CF",
    "und-CG": "fr-Latn-CG",
    "und-CH": "de-Latn-CH",
    "und-Cham": "cjm-Cham-VN",
    "und-Cher": "chr-Cher-US",
    "und-Chrs": "xco-Chrs-UZ",
    "und-CI": "fr-Latn-CI",
    "und-CL": "es-Latn-CL",
    "und-CM": "fr-Latn-CM",
    "und-CN": "zh-Hans-CN",
    "und-CO": "es-Latn-CO",
    "und-Copt": "cop-Copt-EG",
    "und-CP": "und-Latn-CP",
    "und-Cpmn": "und-Cpmn-CY",
    "und-Cpmn-CY": "und-Cpmn-CY",
    "und-Cprt": "grc-Cprt-CY",
    "und-CR": "es-Latn-CR",
    "und-CU": "es-Latn-CU",
    "und-CV": "pt-Latn-CV",
    "und-CW": "pap-Latn-CW",
    "und-CY": "el-Grek-CY",
    "und-Cyrl": "ru-Cyrl-RU",
    "und-Cyrl-AL": "mk-Cyrl-AL",
    "und-Cyrl-BA": "sr-Cyrl-BA",
    "und-Cyrl-GE": "os-Cyrl-GE",
    "und-Cyrl-GR": "mk-Cyrl-GR",
    "und-Cyrl-MD": "uk-Cyrl-MD",
    "und-Cyrl-RO": "bg-Cyrl-RO",
    "und-Cyrl-SK": "uk-Cyrl-SK",
    "und-Cyrl-TR": "kbd-Cyrl-TR",
    "und-Cyrl-XK": "sr-Cyrl-XK",
    "und-CZ": "cs-Latn-CZ",
    "und-DE": "de-Latn-DE",
    "und-Deva": "hi-Deva-IN",
    "und-Deva-BT": "ne-Deva-BT",
    "und-Deva-FJ": "hif-Deva-FJ",
    "und-Deva-MU": "bho-Deva-MU",
    "und-Deva-PK": "btv-Deva-PK",
    "und-Diak": "dv-Diak-MV",
    "und-DJ": "aa-Latn-DJ",
    "und-DK": "da-Latn-DK",
    "und-DO": "es-Latn-DO",
    "und-Dogr": "doi-Dogr-IN",
    "und-Dupl": "fr-Dupl-FR",
    "und-DZ": "ar-Arab-DZ",
    "und-EA": "es-Latn-EA",
    "und-EC": "es-Latn-EC",
    "und-EE": "et-Latn-EE",
    "und-EG": "ar-Arab-EG",
    "und-Egyp": "egy-Egyp-EG",
    "und-EH": "ar-Arab-EH",
    "und-Elba": "sq-Elba-AL",
    "und-Elym": "arc-Elym-IR",
    "und-ER": "ti-Ethi-ER",
    "und-ES": "es-Latn-ES",
    "und-ET": "am-Ethi-ET",
    "und-Ethi": "am-Ethi-ET",
    "und-EU": "en-Latn-IE",
    "und-EZ": "de-Latn-EZ",
    "und-FI": "fi-Latn-FI",
    "und-FO": "fo-Latn-FO",
    "und-FR": "fr-Latn-FR",
    "und-GA": "fr-Latn-GA",
    "und-GE": "ka-Geor-GE",
    "und-Geor": "ka-Geor-GE",
    "und-GF": "fr-Latn-GF",
    "und-GH": "ak-Latn-GH",
    "und-GL": "kl-Latn-GL",
    "und-Glag": "cu-Glag-BG",
    "und-GN": "fr-Latn-GN",
    "und-Gong": "wsg-Gong-IN",
    "und-Gonm": "esg-Gonm-IN",
    "und-Goth": "got-Goth-UA",
    "und-GP": "fr-Latn-GP",
    "und-GQ": "es-Latn-GQ",
    "und-GR": "el-Grek-GR",
    "und-Gran": "sa-Gran-IN",
    "und-Grek": "el-Grek-GR",
    "und-Grek-TR": "bgx-Grek-TR",
    "und-GS": "und-Latn-GS",
    "und-GT": "es-Latn-GT",
    "und-Gujr": "gu-Gujr-IN",
    "und-Guru": "pa-Guru-IN",
    "und-GW": "pt-Latn-GW",
    "und-Hanb": "zh-Hanb-TW",
    "und-Hang": "ko-Hang-KR",
    "und-Hani": "zh-Hani-CN",
    "und-Hano": "hnn-Hano-PH",
    "und-Hans": "zh-Hans-CN",
    "und-Hant": "zh-Hant-TW",
    "und-Hebr": "he-Hebr-IL",
    "und-Hebr-CA": "yi-Hebr-CA",
    "und-Hebr-GB": "yi-Hebr-GB",
    "und-Hebr-SE": "yi-Hebr-SE",
    "und-Hebr-UA": "yi-Hebr-UA",
    "und-Hebr-US": "yi-Hebr-US",
    "und-Hira": "ja-Hira-JP",
    "und-HK": "zh-Hant-HK",
    "und-Hluw": "hlu-Hluw-TR",
    "und-HM": "und-Latn-HM",
    "und-Hmng": "hnj-Hmng-LA",
    "und-Hmnp": "hnj-Hmnp-US",
    "und-HN": "es-Latn-HN",
    "und-HR": "hr-Latn-HR",
    "und-HT": "ht-Latn-HT",
    "und-HU": "hu-Latn-HU",
    "und-Hung": "hu-Hung-HU",
    "und-IC": "es-Latn-IC",
    "und-ID": "id-Latn-ID",
    "und-IL": "he-Hebr-IL",
    "und-IN": "hi-Deva-IN",
    "und-IQ": "ar-Arab-IQ",
    "und-IR": "fa-Arab-IR",
    "und-IS": "is-Latn-IS",
    "und-IT": "it-Latn-IT",
    "und-Ital": "ett-Ital-IT",
    "und-Jamo": "ko-Jamo-KR",
    "und-Java": "jv-Java-ID",
    "und-JO": "ar-Arab-JO",
    "und-JP": "ja-Jpan-JP",
    "und-Jpan": "ja-Jpan-JP",
    "und-Kali": "eky-Kali-MM",
    "und-Kana": "ja-Kana-JP",
    "und-KE": "sw-Latn-KE",
    "und-KG": "ky-Cyrl-KG",
    "und-KH": "km-Khmr-KH",
    "und-Khar": "pra-Khar-PK",
    "und-Khmr": "km-Khmr-KH",
    "und-Khoj": "sd-Khoj-IN",
    "und-Kits": "zkt-Kits-CN",
    "und-KM": "ar-Arab-KM",
    "und-Knda": "kn-Knda-IN",
    "und-Kore": "ko-Kore-KR",
    "und-KP": "ko-Kore-KP",
    "und-KR": "ko-Kore-KR",
    "und-Kthi": "bho-Kthi-IN",
    "und-KW": "ar-Arab-KW",
    "und-KZ": "ru-Cyrl-KZ",
    "und-LA": "lo-Laoo-LA",
    "und-Lana": "nod-Lana-TH",
    "und-Laoo": "lo-Laoo-LA",
    "und-Latn-AF": "tk-Latn-AF",
    "und-Latn-AM": "ku-Latn-AM",
    "und-Latn-CN": "za-Latn-CN",
    "und-Latn-CY": "tr-Latn-CY",
    "und-Latn-DZ": "fr-Latn-DZ",
    "und-Latn-ET": "en-Latn-ET",
    "und-Latn-GE": "ku-Latn-GE",
    "und-Latn-IR": "tk-Latn-IR",
    "und-Latn-KM": "fr-Latn-KM",
    "und-Latn-MA": "fr-Latn-MA",
    "und-Latn-MK": "sq-Latn-MK",
    "und-Latn-MM": "kac-Latn-MM",
    "und-Latn-MO": "pt-Latn-MO",
    "und-Latn-MR": "fr-Latn-MR",
    "und-Latn-RU": "krl-Latn-RU",
    "und-Latn-SY": "fr-Latn-SY",
    "und-Latn-TN": "fr-Latn-TN",
    "und-Latn-TW": "trv-Latn-TW",
    "und-Latn-UA": "pl-Latn-UA",
    "und-LB": "ar-Arab-LB",
    "und-Lepc": "lep-Lepc-IN",
    "und-LI": "de-Latn-LI",
    "und-Limb": "lif-Limb-IN",
    "und-Lina": "lab-Lina-GR",
    "und-Linb": "grc-Linb-GR",
    "und-Lisu": "lis-Lisu-CN",
    "und-LK": "si-Sinh-LK",
    "und-LS": "st-Latn-LS",
    "und-LT": "lt-Latn-LT",
    "und-LU": "fr-Latn-LU",
    "und-LV": "lv-Latn-LV",
    "und-LY": "ar-Arab-LY",
    "und-Lyci": "xlc-Lyci-TR",
    "und-Lydi": "xld-Lydi-TR",
    "und-MA": "ar-Arab-MA",
    "und-Mahj": "hi-Mahj-IN",
    "und-Maka": "mak-Maka-ID",
    "und-Mand": "myz-Mand-IR",
    "und-Mani": "xmn-Mani-CN",
    "und-Marc": "bo-Marc-CN",
    "und-MC": "fr-Latn-MC",
    "und-MD": "ro-Latn-MD",
    "und-ME": "sr-Latn-ME",
    "und-Medf": "dmf-Medf-NG",
    "und-Mend": "men-Mend-SL",
    "und-Merc": "xmr-Merc-SD",
    "und-Mero": "xmr-Mero-SD",
    "und-MF": "fr-Latn-MF",
    "und-MG": "mg-Latn-MG",
    "und-MK": "mk-Cyrl-MK",
    "und-ML": "bm-Latn-ML",
    "und-Mlym": "ml-Mlym-IN",
    "und-MM": "my-Mymr-MM",
    "und-MN": "mn-Cyrl-MN",
    "und-MO": "zh-Hant-MO",
    "und-Modi": "mr-Modi-IN",
    "und-Mong": "mn-Mong-CN",
    "und-MQ": "fr-Latn-MQ",
    "und-MR": "ar-Arab-MR",
    "und-Mroo": "mro-Mroo-BD",
    "und-MT": "mt-Latn-MT",
    "und-Mtei": "mni-Mtei-IN",
    "und-MU": "mfe-Latn-MU",
    "und-Mult": "skr-Mult-PK",
    "und-MV": "dv-Thaa-MV",
    "und-MX": "es-Latn-MX",
    "und-MY": "ms-Latn-MY",
    "und-Mymr": "my-Mymr-MM",
    "und-Mymr-IN": "kht-Mymr-IN",
    "und-Mymr-TH": "mnw-Mymr-TH",
    "und-MZ": "pt-Latn-MZ",
    "und-NA": "af-Latn-NA",
    "und-Nand": "sa-Nand-IN",
    "und-Narb": "xna-Narb-SA",
    "und-Nbat": "arc-Nbat-JO",
    "und-NC": "fr-Latn-NC",
    "und-NE": "ha-Latn-NE",
    "und-Newa": "new-Newa-NP",
    "und-NI": "es-Latn-NI",
    "und-Nkoo": "man-Nkoo-GN",
    "und-NL": "nl-Latn-NL",
    "und-NO": "nb-Latn-NO",
    "und-NP": "ne-Deva-NP",
    "und-Nshu": "zhx-Nshu-CN",
    "und-Ogam": "sga-Ogam-IE",
    "und-Olck": "sat-Olck-IN",
    "und-OM": "ar-Arab-OM",
    "und-Orkh": "otk-Orkh-MN",
    "und-Orya": "or-Orya-IN",
    "und-Osge": "osa-Osge-US",
    "und-Osma": "so-Osma-SO",
    "und-Ougr": "oui-Ougr-143",
    "und-PA": "es-Latn-PA",
    "und-Palm": "arc-Palm-SY",
    "und-Pauc": "ctd-Pauc-MM",
    "und-PE": "es-Latn-PE",
    "und-Perm": "kv-Perm-RU",
    "und-PF": "fr-Latn-PF",
    "und-PG": "tpi-Latn-PG",
    "und-PH": "fil-Latn-PH",
    "und-Phag": "lzh-Phag-CN",
    "und-Phli": "pal-Phli-IR",
    "und-Phlp": "pal-Phlp-CN",
    "und-Phnx": "phn-Phnx-LB",
    "und-PK": "ur-Arab-PK",
    "und-PL": "pl-Latn-PL",
    "und-Plrd": "hmd-Plrd-CN",
    "und-PM": "fr-Latn-PM",
    "und-PR": "es-Latn-PR",
    "und-Prti": "xpr-Prti-IR",
    "und-PS": "ar-Arab-PS",
    "und-PT": "pt-Latn-PT",
    "und-PW": "pau-Latn-PW",
    "und-PY": "gn-Latn-PY",
    "und-QA": "ar-Arab-QA",
    "und-QO": "en-Latn-DG",
    "und-RE": "fr-Latn-RE",
    "und-Rjng": "rej-Rjng-ID",
    "und-RO": "ro-Latn-RO",
    "und-Rohg": "rhg-Rohg-MM",
    "und-RS": "sr-Cyrl-RS",
    "und-RU": "ru-Cyrl-RU",
    "und-Runr": "non-Runr-SE",
    "und-RW": "rw-Latn-RW",
    "und-SA": "ar-Arab-SA",
    "und-Samr": "smp-Samr-IL",
    "und-Sarb": "xsa-Sarb-YE",
    "und-Saur": "saz-Saur-IN",
    "und-SC": "fr-Latn-SC",
    "und-SD": "ar-Arab-SD",
    "und-SE": "sv-Latn-SE",
    "und-Sgnw": "ase-Sgnw-US",
    "und-Shaw": "en-Shaw-GB",
    "und-Shrd": "sa-Shrd-IN",
    "und-SI": "sl-Latn-SI",
    "und-Sidd": "sa-Sidd-IN",
    "und-Sind": "sd-Sind-IN",
    "und-Sinh": "si-Sinh-LK",
    "und-SJ": "nb-Latn-SJ",
    "und-SK": "sk-Latn-SK",
    "und-SM": "it-Latn-SM",
    "und-SN": "fr-Latn-SN",
    "und-SO": "so-Latn-SO",
    "und-Sogd": "sog-Sogd-UZ",
    "und-Sogo": "sog-Sogo-UZ",
    "und-Sora": "srb-Sora-IN",
    "und-Soyo": "cmg-Soyo-MN",
    "und-SR": "nl-Latn-SR",
    "und-ST": "pt-Latn-ST",
    "und-Sund": "su-Sund-ID",
    "und-SV": "es-Latn-SV",
    "und-SY": "ar-Arab-SY",
    "und-Sylo": "syl-Sylo-BD",
    "und-Syrc": "syr-Syrc-IQ",
    "und-Tagb": "tbw-Tagb-PH",
    "und-Takr": "doi-Takr-IN",
    "und-Tale": "tdd-Tale-CN",
    "und-Talu": "khb-Talu-CN",
    "und-Taml": "ta-Taml-IN",
    "und-Tang": "txg-Tang-CN",
    "und-Tavt": "blt-Tavt-VN",
    "und-TD": "fr-Latn-TD",
    "und-Telu": "te-Telu-IN",
    "und-TF": "fr-Latn-TF",
    "und-Tfng": "zgh-Tfng-MA",
    "und-TG": "fr-Latn-TG",
    "und-Tglg": "fil-Tglg-PH",
    "und-TH": "th-Thai-TH",
    "und-Thaa": "dv-Thaa-MV",
    "und-Thai": "th-Thai-TH",
    "und-Thai-CN": "lcp-Thai-CN",
    "und-Thai-KH": "kdt-Thai-KH",
    "und-Thai-LA": "kdt-Thai-LA",
    "und-Tibt": "bo-Tibt-CN",
    "und-Tirh": "mai-Tirh-IN",
    "und-TJ": "tg-Cyrl-TJ",
    "und-TK": "tkl-Latn-TK",
    "und-TL": "pt-Latn-TL",
    "und-TM": "tk-Latn-TM",
    "und-TN": "ar-Arab-TN",
    "und-Tnsa": "nst-Tnsa-IN",
    "und-TO": "to-Latn-TO",
    "und-Toto": "txo-Toto-IN",
    "und-TR": "tr-Latn-TR",
    "und-TV": "tvl-Latn-TV",
    "und-TW": "zh-Hant-TW",
    "und-TZ": "sw-Latn-TZ",
    "und-UA": "uk-Cyrl-UA",
    "und-UG": "sw-Latn-UG",
    "und-Ugar": "uga-Ugar-SY",
    "und-UY": "es-Latn-UY",
    "und-UZ": "uz-Latn-UZ",
    "und-VA": "it-Latn-VA",
    "und-Vaii": "vai-Vaii-LR",
    "und-VE": "es-Latn-VE",
    "und-Vith": "sq-Vith-AL",
    "und-VN": "vi-Latn-VN",
    "und-VU": "bi-Latn-VU",
    "und-Wara": "hoc-Wara-IN",
    "und-Wcho": "nnp-Wcho-IN",
    "und-WF": "fr-Latn-WF",
    "und-WS": "sm-Latn-WS",
    "und-XK": "sq-Latn-XK",
    "und-Xpeo": "peo-Xpeo-IR",
    "und-Xsux": "akk-Xsux-IQ",
    "und-YE": "ar-Arab-YE",
    "und-Yezi": "ku-Yezi-GE",
    "und-Yiii": "ii-Yiii-CN",
    "und-YT": "fr-Latn-YT",
    "und-Zanb": "cmg-Zanb-MN",
    "und-ZW": "sn-Latn-ZW",
    "unr": "unr-Beng-IN",
    "unr-Deva": "unr-Deva-NP",
    "unr-NP": "unr-Deva-NP",
    "unx": "unx-Beng-IN",
    "uok": "uok-Latn-ZZ",
    "ur": "ur-Arab-PK",
    "uri": "uri-Latn-ZZ",
    "urt": "urt-Latn-ZZ",
    "urw": "urw-Latn-ZZ",
    "usa": "usa-Latn-ZZ",
    "uth": "uth-Latn-ZZ",
    "utr": "utr-Latn-ZZ",
    "uvh": "uvh-Latn-ZZ",
    "uvl": "uvl-Latn-ZZ",
    "uz": "uz-Latn-UZ",
    "uz-AF": "uz-Arab-AF",
    "uz-Arab": "uz-Arab-AF",
    "uz-CN": "uz-Cyrl-CN",
    "vag": "vag-Latn-ZZ",
    "vai": "vai-Vaii-LR",
    "van": "van-Latn-ZZ",
    "ve": "ve-Latn-ZA",
    "vec": "vec-Latn-IT",
    "vep": "vep-Latn-RU",
    "vi": "vi-Latn-VN",
    "vic": "vic-Latn-SX",
    "viv": "viv-Latn-ZZ",
    "vls": "vls-Latn-BE",
    "vmf": "vmf-Latn-DE",
    "vmw": "vmw-Latn-MZ",
    "vo": "vo-Latn-001",
    "vot": "vot-Latn-RU",
    "vro": "vro-Latn-EE",
    "vun": "vun-Latn-TZ",
    "vut": "vut-Latn-ZZ",
    "wa": "wa-Latn-BE",
    "wae": "wae-Latn-CH",
    "waj": "waj-Latn-ZZ",
    "wal": "wal-Ethi-ET",
    "wan": "wan-Latn-ZZ",
    "war": "war-Latn-PH",
    "wbp": "wbp-Latn-AU",
    "wbq": "wbq-Telu-IN",
    "wbr": "wbr-Deva-IN",
    "wci": "wci-Latn-ZZ",
    "wer": "wer-Latn-ZZ",
    "wgi": "wgi-Latn-ZZ",
    "whg": "whg-Latn-ZZ",
    "wib": "wib-Latn-ZZ",
    "wiu": "wiu-Latn-ZZ",
    "wiv": "wiv-Latn-ZZ",
    "wja": "wja-Latn-ZZ",
    "wji": "wji-Latn-ZZ",
    "wls": "wls-Latn-WF",
    "wmo": "wmo-Latn-ZZ",
    "wnc": "wnc-Latn-ZZ",
    "wni": "wni-Arab-KM",
    "wnu": "wnu-Latn-ZZ",
    "wo": "wo-Latn-SN",
    "wob": "wob-Latn-ZZ",
    "wos": "wos-Latn-ZZ",
    "wrs": "wrs-Latn-ZZ",
    "wsg": "wsg-Gong-IN",
    "wsk": "wsk-Latn-ZZ",
    "wtm": "wtm-Deva-IN",
    "wuu": "wuu-Hans-CN",
    "wuv": "wuv-Latn-ZZ",
    "wwa": "wwa-Latn-ZZ",
    "xav": "xav-Latn-BR",
    "xbi": "xbi-Latn-ZZ",
    "xco": "xco-Chrs-UZ",
    "xcr": "xcr-Cari-TR",
    "xes": "xes-Latn-ZZ",
    "xh": "xh-Latn-ZA",
    "xla": "xla-Latn-ZZ",
    "xlc": "xlc-Lyci-TR",
    "xld": "xld-Lydi-TR",
    "xmf": "xmf-Geor-GE",
    "xmn": "xmn-Mani-CN",
    "xmr": "xmr-Merc-SD",
    "xna": "xna-Narb-SA",
    "xnr": "xnr-Deva-IN",
    "xog": "xog-Latn-UG",
    "xon": "xon-Latn-ZZ",
    "xpr": "xpr-Prti-IR",
    "xrb": "xrb-Latn-ZZ",
    "xsa": "xsa-Sarb-YE",
    "xsi": "xsi-Latn-ZZ",
    "xsm": "xsm-Latn-ZZ",
    "xsr": "xsr-Deva-NP",
    "xwe": "xwe-Latn-ZZ",
    "yam": "yam-Latn-ZZ",
    "yao": "yao-Latn-MZ",
    "yap": "yap-Latn-FM",
    "yas": "yas-Latn-ZZ",
    "yat": "yat-Latn-ZZ",
    "yav": "yav-Latn-CM",
    "yay": "yay-Latn-ZZ",
    "yaz": "yaz-Latn-ZZ",
    "yba": "yba-Latn-ZZ",
    "ybb": "ybb-Latn-CM",
    "yby": "yby-Latn-ZZ",
    "yer": "yer-Latn-ZZ",
    "ygr": "ygr-Latn-ZZ",
    "ygw": "ygw-Latn-ZZ",
    "yi": "yi-Hebr-001",
    "yko": "yko-Latn-ZZ",
    "yle": "yle-Latn-ZZ",
    "ylg": "ylg-Latn-ZZ",
    "yll": "yll-Latn-ZZ",
    "yml": "yml-Latn-ZZ",
    "yo": "yo-Latn-NG",
    "yon": "yon-Latn-ZZ",
    "yrb": "yrb-Latn-ZZ",
    "yre": "yre-Latn-ZZ",
    "yrl": "yrl-Latn-BR",
    "yss": "yss-Latn-ZZ",
    "yua": "yua-Latn-MX",
    "yue": "yue-Hant-HK",
    "yue-CN": "yue-Hans-CN",
    "yue-Hans": "yue-Hans-CN",
    "yuj": "yuj-Latn-ZZ",
    "yut": "yut-Latn-ZZ",
    "yuw": "yuw-Latn-ZZ",
    "za": "za-Latn-CN",
    "zag": "zag-Latn-SD",
    "zdj": "zdj-Arab-KM",
    "zea": "zea-Latn-NL",
    "zgh": "zgh-Tfng-MA",
    "zh": "zh-Hans-CN",
    "zh-AU": "zh-Hant-AU",
    "zh-BN": "zh-Hant-BN",
    "zh-Bopo": "zh-Bopo-TW",
    "zh-GB": "zh-Hant-GB",
    "zh-GF": "zh-Hant-GF",
    "zh-Hanb": "zh-Hanb-TW",
    "zh-Hant": "zh-Hant-TW",
    "zh-HK": "zh-Hant-HK",
    "zh-ID": "zh-Hant-ID",
    "zh-MO": "zh-Hant-MO",
    "zh-PA": "zh-Hant-PA",
    "zh-PF": "zh-Hant-PF",
    "zh-PH": "zh-Hant-PH",
    "zh-SR": "zh-Hant-SR",
    "zh-TH": "zh-Hant-TH",
    "zh-TW": "zh-Hant-TW",
    "zh-US": "zh-Hant-US",
    "zh-VN": "zh-Hant-VN",
    "zhx": "zhx-Nshu-CN",
    "zia": "zia-Latn-ZZ",
    "zkt": "zkt-Kits-CN",
    "zlm": "zlm-Latn-TG",
    "zmi": "zmi-Latn-MY",
    "zne": "zne-Latn-ZZ",
    "zu": "zu-Latn-ZA",
    "zza": "zza-Latn-TR"
};


/***/ }),

/***/ 18371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseUnicodeLocaleId = exports.parseUnicodeLanguageId = exports.isUnicodeVariantSubtag = exports.isUnicodeScriptSubtag = exports.isUnicodeRegionSubtag = exports.isStructurallyValidLanguageTag = exports.isUnicodeLanguageSubtag = exports.SEPARATOR = void 0;
var tslib_1 = __webpack_require__(70655);
var ALPHANUM_1_8 = /^[a-z0-9]{1,8}$/i;
var ALPHANUM_2_8 = /^[a-z0-9]{2,8}$/i;
var ALPHANUM_3_8 = /^[a-z0-9]{3,8}$/i;
var KEY_REGEX = /^[a-z0-9][a-z]$/i;
var TYPE_REGEX = /^[a-z0-9]{3,8}$/i;
var ALPHA_4 = /^[a-z]{4}$/i;
// alphanum-[tTuUxX]
var OTHER_EXTENSION_TYPE = /^[0-9a-svwyz]$/i;
var UNICODE_REGION_SUBTAG_REGEX = /^([a-z]{2}|[0-9]{3})$/i;
var UNICODE_VARIANT_SUBTAG_REGEX = /^([a-z0-9]{5,8}|[0-9][a-z0-9]{3})$/i;
var UNICODE_LANGUAGE_SUBTAG_REGEX = /^([a-z]{2,3}|[a-z]{5,8})$/i;
var TKEY_REGEX = /^[a-z][0-9]$/i;
exports.SEPARATOR = '-';
function isUnicodeLanguageSubtag(lang) {
    return UNICODE_LANGUAGE_SUBTAG_REGEX.test(lang);
}
exports.isUnicodeLanguageSubtag = isUnicodeLanguageSubtag;
function isStructurallyValidLanguageTag(tag) {
    try {
        parseUnicodeLanguageId(tag.split(exports.SEPARATOR));
    }
    catch (e) {
        return false;
    }
    return true;
}
exports.isStructurallyValidLanguageTag = isStructurallyValidLanguageTag;
function isUnicodeRegionSubtag(region) {
    return UNICODE_REGION_SUBTAG_REGEX.test(region);
}
exports.isUnicodeRegionSubtag = isUnicodeRegionSubtag;
function isUnicodeScriptSubtag(script) {
    return ALPHA_4.test(script);
}
exports.isUnicodeScriptSubtag = isUnicodeScriptSubtag;
function isUnicodeVariantSubtag(variant) {
    return UNICODE_VARIANT_SUBTAG_REGEX.test(variant);
}
exports.isUnicodeVariantSubtag = isUnicodeVariantSubtag;
function parseUnicodeLanguageId(chunks) {
    if (typeof chunks === 'string') {
        chunks = chunks.split(exports.SEPARATOR);
    }
    var lang = chunks.shift();
    if (!lang) {
        throw new RangeError('Missing unicode_language_subtag');
    }
    if (lang === 'root') {
        return { lang: 'root', variants: [] };
    }
    // unicode_language_subtag
    if (!isUnicodeLanguageSubtag(lang)) {
        throw new RangeError('Malformed unicode_language_subtag');
    }
    var script;
    // unicode_script_subtag
    if (chunks.length && isUnicodeScriptSubtag(chunks[0])) {
        script = chunks.shift();
    }
    var region;
    // unicode_region_subtag
    if (chunks.length && isUnicodeRegionSubtag(chunks[0])) {
        region = chunks.shift();
    }
    var variants = {};
    while (chunks.length && isUnicodeVariantSubtag(chunks[0])) {
        var variant = chunks.shift();
        if (variant in variants) {
            throw new RangeError("Duplicate variant \"".concat(variant, "\""));
        }
        variants[variant] = 1;
    }
    return {
        lang: lang,
        script: script,
        region: region,
        variants: Object.keys(variants),
    };
}
exports.parseUnicodeLanguageId = parseUnicodeLanguageId;
function parseUnicodeExtension(chunks) {
    var keywords = [];
    var keyword;
    while (chunks.length && (keyword = parseKeyword(chunks))) {
        keywords.push(keyword);
    }
    if (keywords.length) {
        return {
            type: 'u',
            keywords: keywords,
            attributes: [],
        };
    }
    // Mix of attributes & keywords
    // Check for attributes first
    var attributes = [];
    while (chunks.length && ALPHANUM_3_8.test(chunks[0])) {
        attributes.push(chunks.shift());
    }
    while (chunks.length && (keyword = parseKeyword(chunks))) {
        keywords.push(keyword);
    }
    if (keywords.length || attributes.length) {
        return {
            type: 'u',
            attributes: attributes,
            keywords: keywords,
        };
    }
    throw new RangeError('Malformed unicode_extension');
}
function parseKeyword(chunks) {
    var key;
    if (!KEY_REGEX.test(chunks[0])) {
        return;
    }
    key = chunks.shift();
    var type = [];
    while (chunks.length && TYPE_REGEX.test(chunks[0])) {
        type.push(chunks.shift());
    }
    var value = '';
    if (type.length) {
        value = type.join(exports.SEPARATOR);
    }
    return [key, value];
}
function parseTransformedExtension(chunks) {
    var lang;
    try {
        lang = parseUnicodeLanguageId(chunks);
    }
    catch (e) {
        // Try just parsing tfield
    }
    var fields = [];
    while (chunks.length && TKEY_REGEX.test(chunks[0])) {
        var key = chunks.shift();
        var value = [];
        while (chunks.length && ALPHANUM_3_8.test(chunks[0])) {
            value.push(chunks.shift());
        }
        if (!value.length) {
            throw new RangeError("Missing tvalue for tkey \"".concat(key, "\""));
        }
        fields.push([key, value.join(exports.SEPARATOR)]);
    }
    if (fields.length) {
        return {
            type: 't',
            fields: fields,
            lang: lang,
        };
    }
    throw new RangeError('Malformed transformed_extension');
}
function parsePuExtension(chunks) {
    var exts = [];
    while (chunks.length && ALPHANUM_1_8.test(chunks[0])) {
        exts.push(chunks.shift());
    }
    if (exts.length) {
        return {
            type: 'x',
            value: exts.join(exports.SEPARATOR),
        };
    }
    throw new RangeError('Malformed private_use_extension');
}
function parseOtherExtensionValue(chunks) {
    var exts = [];
    while (chunks.length && ALPHANUM_2_8.test(chunks[0])) {
        exts.push(chunks.shift());
    }
    if (exts.length) {
        return exts.join(exports.SEPARATOR);
    }
    return '';
}
function parseExtensions(chunks) {
    if (!chunks.length) {
        return { extensions: [] };
    }
    var extensions = [];
    var unicodeExtension;
    var transformedExtension;
    var puExtension;
    var otherExtensionMap = {};
    do {
        var type = chunks.shift();
        switch (type) {
            case 'u':
            case 'U':
                if (unicodeExtension) {
                    throw new RangeError('There can only be 1 -u- extension');
                }
                unicodeExtension = parseUnicodeExtension(chunks);
                extensions.push(unicodeExtension);
                break;
            case 't':
            case 'T':
                if (transformedExtension) {
                    throw new RangeError('There can only be 1 -t- extension');
                }
                transformedExtension = parseTransformedExtension(chunks);
                extensions.push(transformedExtension);
                break;
            case 'x':
            case 'X':
                if (puExtension) {
                    throw new RangeError('There can only be 1 -x- extension');
                }
                puExtension = parsePuExtension(chunks);
                extensions.push(puExtension);
                break;
            default:
                if (!OTHER_EXTENSION_TYPE.test(type)) {
                    throw new RangeError('Malformed extension type');
                }
                if (type in otherExtensionMap) {
                    throw new RangeError("There can only be 1 -".concat(type, "- extension"));
                }
                var extension = {
                    type: type,
                    value: parseOtherExtensionValue(chunks),
                };
                otherExtensionMap[extension.type] = extension;
                extensions.push(extension);
                break;
        }
    } while (chunks.length);
    return { extensions: extensions };
}
function parseUnicodeLocaleId(locale) {
    var chunks = locale.split(exports.SEPARATOR);
    var lang = parseUnicodeLanguageId(chunks);
    return tslib_1.__assign({ lang: lang }, parseExtensions(chunks));
}
exports.parseUnicodeLocaleId = parseUnicodeLocaleId;


/***/ }),

/***/ 539:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 31069:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// Type-only circular import
// eslint-disable-next-line import/no-cycle
Object.defineProperty(exports, "__esModule", ({ value: true }));
var internalSlotMap = new WeakMap();
function getInternalSlots(x) {
    var internalSlots = internalSlotMap.get(x);
    if (!internalSlots) {
        internalSlots = Object.create(null);
        internalSlotMap.set(x, internalSlots);
    }
    return internalSlots;
}
exports["default"] = getInternalSlots;


/***/ }),

/***/ 49679:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Locale = void 0;
var tslib_1 = __webpack_require__(70655);
var ecma402_abstract_1 = __webpack_require__(48665);
var intl_getcanonicallocales_1 = __webpack_require__(89097);
var get_internal_slots_1 = tslib_1.__importDefault(__webpack_require__(31069));
var RELEVANT_EXTENSION_KEYS = ['ca', 'co', 'hc', 'kf', 'kn', 'nu'];
var UNICODE_TYPE_REGEX = /^[a-z0-9]{3,8}(-[a-z0-9]{3,8})*$/i;
function applyOptionsToTag(tag, options) {
    (0, ecma402_abstract_1.invariant)(typeof tag === 'string', 'language tag must be a string');
    (0, ecma402_abstract_1.invariant)((0, intl_getcanonicallocales_1.isStructurallyValidLanguageTag)(tag), 'malformed language tag', RangeError);
    var language = (0, ecma402_abstract_1.GetOption)(options, 'language', 'string', undefined, undefined);
    if (language !== undefined) {
        (0, ecma402_abstract_1.invariant)((0, intl_getcanonicallocales_1.isUnicodeLanguageSubtag)(language), 'Malformed unicode_language_subtag', RangeError);
    }
    var script = (0, ecma402_abstract_1.GetOption)(options, 'script', 'string', undefined, undefined);
    if (script !== undefined) {
        (0, ecma402_abstract_1.invariant)((0, intl_getcanonicallocales_1.isUnicodeScriptSubtag)(script), 'Malformed unicode_script_subtag', RangeError);
    }
    var region = (0, ecma402_abstract_1.GetOption)(options, 'region', 'string', undefined, undefined);
    if (region !== undefined) {
        (0, ecma402_abstract_1.invariant)((0, intl_getcanonicallocales_1.isUnicodeRegionSubtag)(region), 'Malformed unicode_region_subtag', RangeError);
    }
    var languageId = (0, intl_getcanonicallocales_1.parseUnicodeLanguageId)(tag);
    if (language !== undefined) {
        languageId.lang = language;
    }
    if (script !== undefined) {
        languageId.script = script;
    }
    if (region !== undefined) {
        languageId.region = region;
    }
    return Intl.getCanonicalLocales((0, intl_getcanonicallocales_1.emitUnicodeLocaleId)(tslib_1.__assign(tslib_1.__assign({}, (0, intl_getcanonicallocales_1.parseUnicodeLocaleId)(tag)), { lang: languageId })))[0];
}
function applyUnicodeExtensionToTag(tag, options, relevantExtensionKeys) {
    var unicodeExtension;
    var keywords = [];
    var ast = (0, intl_getcanonicallocales_1.parseUnicodeLocaleId)(tag);
    for (var _i = 0, _a = ast.extensions; _i < _a.length; _i++) {
        var ext = _a[_i];
        if (ext.type === 'u') {
            unicodeExtension = ext;
            if (Array.isArray(ext.keywords))
                keywords = ext.keywords;
        }
    }
    var result = Object.create(null);
    for (var _b = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _b < relevantExtensionKeys_1.length; _b++) {
        var key = relevantExtensionKeys_1[_b];
        var value = void 0, entry = void 0;
        for (var _c = 0, keywords_1 = keywords; _c < keywords_1.length; _c++) {
            var keyword = keywords_1[_c];
            if (keyword[0] === key) {
                entry = keyword;
                value = entry[1];
            }
        }
        (0, ecma402_abstract_1.invariant)(key in options, "".concat(key, " must be in options"));
        var optionsValue = options[key];
        if (optionsValue !== undefined) {
            (0, ecma402_abstract_1.invariant)(typeof optionsValue === 'string', "Value for ".concat(key, " must be a string"));
            value = optionsValue;
            if (entry) {
                entry[1] = value;
            }
            else {
                keywords.push([key, value]);
            }
        }
        result[key] = value;
    }
    if (!unicodeExtension) {
        if (keywords.length) {
            ast.extensions.push({
                type: 'u',
                keywords: keywords,
                attributes: [],
            });
        }
    }
    else {
        unicodeExtension.keywords = keywords;
    }
    result.locale = Intl.getCanonicalLocales((0, intl_getcanonicallocales_1.emitUnicodeLocaleId)(ast))[0];
    return result;
}
function mergeUnicodeLanguageId(lang, script, region, variants, replacement) {
    if (variants === void 0) { variants = []; }
    if (!replacement) {
        return {
            lang: lang || 'und',
            script: script,
            region: region,
            variants: variants,
        };
    }
    return {
        lang: !lang || lang === 'und' ? replacement.lang : lang,
        script: script || replacement.script,
        region: region || replacement.region,
        variants: tslib_1.__spreadArray(tslib_1.__spreadArray([], variants, true), replacement.variants, true),
    };
}
function addLikelySubtags(tag) {
    var ast = (0, intl_getcanonicallocales_1.parseUnicodeLocaleId)(tag);
    var unicodeLangId = ast.lang;
    var lang = unicodeLangId.lang, script = unicodeLangId.script, region = unicodeLangId.region, variants = unicodeLangId.variants;
    if (script && region) {
        var match_1 = intl_getcanonicallocales_1.likelySubtags[(0, intl_getcanonicallocales_1.emitUnicodeLanguageId)({ lang: lang, script: script, region: region, variants: [] })];
        if (match_1) {
            var parts_1 = (0, intl_getcanonicallocales_1.parseUnicodeLanguageId)(match_1);
            ast.lang = mergeUnicodeLanguageId(undefined, undefined, undefined, variants, parts_1);
            return (0, intl_getcanonicallocales_1.emitUnicodeLocaleId)(ast);
        }
    }
    if (script) {
        var match_2 = intl_getcanonicallocales_1.likelySubtags[(0, intl_getcanonicallocales_1.emitUnicodeLanguageId)({ lang: lang, script: script, variants: [] })];
        if (match_2) {
            var parts_2 = (0, intl_getcanonicallocales_1.parseUnicodeLanguageId)(match_2);
            ast.lang = mergeUnicodeLanguageId(undefined, undefined, region, variants, parts_2);
            return (0, intl_getcanonicallocales_1.emitUnicodeLocaleId)(ast);
        }
    }
    if (region) {
        var match_3 = intl_getcanonicallocales_1.likelySubtags[(0, intl_getcanonicallocales_1.emitUnicodeLanguageId)({ lang: lang, region: region, variants: [] })];
        if (match_3) {
            var parts_3 = (0, intl_getcanonicallocales_1.parseUnicodeLanguageId)(match_3);
            ast.lang = mergeUnicodeLanguageId(undefined, script, undefined, variants, parts_3);
            return (0, intl_getcanonicallocales_1.emitUnicodeLocaleId)(ast);
        }
    }
    var match = intl_getcanonicallocales_1.likelySubtags[lang] ||
        intl_getcanonicallocales_1.likelySubtags[(0, intl_getcanonicallocales_1.emitUnicodeLanguageId)({ lang: 'und', script: script, variants: [] })];
    if (!match) {
        throw new Error("No match for addLikelySubtags");
    }
    var parts = (0, intl_getcanonicallocales_1.parseUnicodeLanguageId)(match);
    ast.lang = mergeUnicodeLanguageId(undefined, script, region, variants, parts);
    return (0, intl_getcanonicallocales_1.emitUnicodeLocaleId)(ast);
}
/**
 * From: https://github.com/unicode-org/icu/blob/4231ca5be053a22a1be24eb891817458c97db709/icu4j/main/classes/core/src/com/ibm/icu/util/ULocale.java#L2395
 * @param tag
 */
function removeLikelySubtags(tag) {
    var maxLocale = addLikelySubtags(tag);
    if (!maxLocale) {
        return tag;
    }
    maxLocale = (0, intl_getcanonicallocales_1.emitUnicodeLanguageId)(tslib_1.__assign(tslib_1.__assign({}, (0, intl_getcanonicallocales_1.parseUnicodeLanguageId)(maxLocale)), { variants: [] }));
    var ast = (0, intl_getcanonicallocales_1.parseUnicodeLocaleId)(tag);
    var _a = ast.lang, lang = _a.lang, script = _a.script, region = _a.region, variants = _a.variants;
    var trial = addLikelySubtags((0, intl_getcanonicallocales_1.emitUnicodeLanguageId)({ lang: lang, variants: [] }));
    if (trial === maxLocale) {
        return (0, intl_getcanonicallocales_1.emitUnicodeLocaleId)(tslib_1.__assign(tslib_1.__assign({}, ast), { lang: mergeUnicodeLanguageId(lang, undefined, undefined, variants) }));
    }
    if (region) {
        var trial_1 = addLikelySubtags((0, intl_getcanonicallocales_1.emitUnicodeLanguageId)({ lang: lang, region: region, variants: [] }));
        if (trial_1 === maxLocale) {
            return (0, intl_getcanonicallocales_1.emitUnicodeLocaleId)(tslib_1.__assign(tslib_1.__assign({}, ast), { lang: mergeUnicodeLanguageId(lang, undefined, region, variants) }));
        }
    }
    if (script) {
        var trial_2 = addLikelySubtags((0, intl_getcanonicallocales_1.emitUnicodeLanguageId)({ lang: lang, script: script, variants: [] }));
        if (trial_2 === maxLocale) {
            return (0, intl_getcanonicallocales_1.emitUnicodeLocaleId)(tslib_1.__assign(tslib_1.__assign({}, ast), { lang: mergeUnicodeLanguageId(lang, script, undefined, variants) }));
        }
    }
    return tag;
}
var Locale = /** @class */ (function () {
    function Locale(tag, opts) {
        // test262/test/intl402/RelativeTimeFormat/constructor/constructor/newtarget-undefined.js
        // Cannot use `new.target` bc of IE11 & TS transpiles it to something else
        var newTarget = this && this instanceof Locale ? this.constructor : void 0;
        if (!newTarget) {
            throw new TypeError("Intl.Locale must be called with 'new'");
        }
        var relevantExtensionKeys = Locale.relevantExtensionKeys;
        var internalSlotsList = [
            'initializedLocale',
            'locale',
            'calendar',
            'collation',
            'hourCycle',
            'numberingSystem',
        ];
        if (relevantExtensionKeys.indexOf('kf') > -1) {
            internalSlotsList.push('caseFirst');
        }
        if (relevantExtensionKeys.indexOf('kn') > -1) {
            internalSlotsList.push('numeric');
        }
        if (tag === undefined) {
            throw new TypeError("First argument to Intl.Locale constructor can't be empty or missing");
        }
        if (typeof tag !== 'string' && typeof tag !== 'object') {
            throw new TypeError('tag must be a string or object');
        }
        var internalSlots;
        if (typeof tag === 'object' &&
            (internalSlots = (0, get_internal_slots_1.default)(tag)) &&
            internalSlots.initializedLocale) {
            tag = internalSlots.locale;
        }
        else {
            tag = tag.toString();
        }
        internalSlots = (0, get_internal_slots_1.default)(this);
        var options = (0, ecma402_abstract_1.CoerceOptionsToObject)(opts);
        tag = applyOptionsToTag(tag, options);
        var opt = Object.create(null);
        var calendar = (0, ecma402_abstract_1.GetOption)(options, 'calendar', 'string', undefined, undefined);
        if (calendar !== undefined) {
            if (!UNICODE_TYPE_REGEX.test(calendar)) {
                throw new RangeError('invalid calendar');
            }
        }
        opt.ca = calendar;
        var collation = (0, ecma402_abstract_1.GetOption)(options, 'collation', 'string', undefined, undefined);
        if (collation !== undefined) {
            if (!UNICODE_TYPE_REGEX.test(collation)) {
                throw new RangeError('invalid collation');
            }
        }
        opt.co = collation;
        var hc = (0, ecma402_abstract_1.GetOption)(options, 'hourCycle', 'string', ['h11', 'h12', 'h23', 'h24'], undefined);
        opt.hc = hc;
        var kf = (0, ecma402_abstract_1.GetOption)(options, 'caseFirst', 'string', ['upper', 'lower', 'false'], undefined);
        opt.kf = kf;
        var _kn = (0, ecma402_abstract_1.GetOption)(options, 'numeric', 'boolean', undefined, undefined);
        var kn;
        if (_kn !== undefined) {
            kn = String(_kn);
        }
        opt.kn = kn;
        var numberingSystem = (0, ecma402_abstract_1.GetOption)(options, 'numberingSystem', 'string', undefined, undefined);
        if (numberingSystem !== undefined) {
            if (!UNICODE_TYPE_REGEX.test(numberingSystem)) {
                throw new RangeError('Invalid numberingSystem');
            }
        }
        opt.nu = numberingSystem;
        var r = applyUnicodeExtensionToTag(tag, opt, relevantExtensionKeys);
        internalSlots.locale = r.locale;
        internalSlots.calendar = r.ca;
        internalSlots.collation = r.co;
        internalSlots.hourCycle = r.hc;
        if (relevantExtensionKeys.indexOf('kf') > -1) {
            internalSlots.caseFirst = r.kf;
        }
        if (relevantExtensionKeys.indexOf('kn') > -1) {
            internalSlots.numeric = (0, ecma402_abstract_1.SameValue)(r.kn, 'true');
        }
        internalSlots.numberingSystem = r.nu;
    }
    /**
     * https://www.unicode.org/reports/tr35/#Likely_Subtags
     */
    Locale.prototype.maximize = function () {
        var locale = (0, get_internal_slots_1.default)(this).locale;
        try {
            var maximizedLocale = addLikelySubtags(locale);
            return new Locale(maximizedLocale);
        }
        catch (e) {
            return new Locale(locale);
        }
    };
    /**
     * https://www.unicode.org/reports/tr35/#Likely_Subtags
     */
    Locale.prototype.minimize = function () {
        var locale = (0, get_internal_slots_1.default)(this).locale;
        try {
            var minimizedLocale = removeLikelySubtags(locale);
            return new Locale(minimizedLocale);
        }
        catch (e) {
            return new Locale(locale);
        }
    };
    Locale.prototype.toString = function () {
        return (0, get_internal_slots_1.default)(this).locale;
    };
    Object.defineProperty(Locale.prototype, "baseName", {
        get: function () {
            var locale = (0, get_internal_slots_1.default)(this).locale;
            return (0, intl_getcanonicallocales_1.emitUnicodeLanguageId)((0, intl_getcanonicallocales_1.parseUnicodeLanguageId)(locale));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "calendar", {
        get: function () {
            return (0, get_internal_slots_1.default)(this).calendar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "collation", {
        get: function () {
            return (0, get_internal_slots_1.default)(this).collation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "hourCycle", {
        get: function () {
            return (0, get_internal_slots_1.default)(this).hourCycle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "caseFirst", {
        get: function () {
            return (0, get_internal_slots_1.default)(this).caseFirst;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "numeric", {
        get: function () {
            return (0, get_internal_slots_1.default)(this).numeric;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "numberingSystem", {
        get: function () {
            return (0, get_internal_slots_1.default)(this).numberingSystem;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "language", {
        /**
         * https://tc39.es/proposal-intl-locale/#sec-Intl.Locale.prototype.language
         */
        get: function () {
            var locale = (0, get_internal_slots_1.default)(this).locale;
            return (0, intl_getcanonicallocales_1.parseUnicodeLanguageId)(locale).lang;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "script", {
        /**
         * https://tc39.es/proposal-intl-locale/#sec-Intl.Locale.prototype.script
         */
        get: function () {
            var locale = (0, get_internal_slots_1.default)(this).locale;
            return (0, intl_getcanonicallocales_1.parseUnicodeLanguageId)(locale).script;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "region", {
        /**
         * https://tc39.es/proposal-intl-locale/#sec-Intl.Locale.prototype.region
         */
        get: function () {
            var locale = (0, get_internal_slots_1.default)(this).locale;
            return (0, intl_getcanonicallocales_1.parseUnicodeLanguageId)(locale).region;
        },
        enumerable: false,
        configurable: true
    });
    Locale.relevantExtensionKeys = RELEVANT_EXTENSION_KEYS;
    return Locale;
}());
exports.Locale = Locale;
try {
    if (typeof Symbol !== 'undefined') {
        Object.defineProperty(Locale.prototype, Symbol.toStringTag, {
            value: 'Intl.Locale',
            writable: false,
            enumerable: false,
            configurable: true,
        });
    }
    Object.defineProperty(Locale.prototype.constructor, 'length', {
        value: 1,
        writable: false,
        enumerable: false,
        configurable: true,
    });
}
catch (e) {
    // Meta fix so we're test262-compliant, not important
}
exports["default"] = Locale;


/***/ }),

/***/ 31942:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var _1 = __webpack_require__(49679);
var should_polyfill_1 = __webpack_require__(95916);
if ((0, should_polyfill_1.shouldPolyfill)()) {
    Object.defineProperty(Intl, 'Locale', {
        value: _1.Locale,
        writable: true,
        enumerable: false,
        configurable: true,
    });
}


/***/ }),

/***/ 95916:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shouldPolyfill = void 0;
/**
 * https://bugs.chromium.org/p/v8/issues/detail?id=10682
 */
function hasIntlGetCanonicalLocalesBug() {
    try {
        return new Intl.Locale('und-x-private').toString() === 'x-private';
    }
    catch (e) {
        return true;
    }
}
function shouldPolyfill() {
    return !('Locale' in Intl) || hasIntlGetCanonicalLocalesBug();
}
exports.shouldPolyfill = shouldPolyfill;


/***/ }),

/***/ 66741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xC": function() { return /* binding */ configureStore; },
  "hg": function() { return /* binding */ createAsyncThunk; },
  "oM": function() { return /* binding */ createSlice; },
  "x0": function() { return /* binding */ nanoid; }
});

// UNUSED EXPORTS: MiddlewareArray, SHOULD_AUTOBATCH, TaskAbortError, __DO_NOT_USE__ActionTypes, addListener, applyMiddleware, autoBatchEnhancer, bindActionCreators, clearAllListeners, combineReducers, compose, createAction, createDraftSafeSelector, createEntityAdapter, createImmutableStateInvariantMiddleware, createListenerMiddleware, createNextState, createReducer, createSelector, createSerializableStateInvariantMiddleware, createStore, current, findNonSerializableValue, freeze, getDefaultMiddleware, getType, isAllOf, isAnyOf, isAsyncThunkAction, isDraft, isFulfilled, isImmutableDefault, isPending, isPlain, isPlainObject, isRejected, isRejectedWithValue, legacy_createStore, miniSerializeError, original, prepareAutoBatched, removeListener, unwrapResult

;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function O(n){g(n),n.p.forEach(S),n.p=null}function g(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.O=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.g||b("ES5").S(e,r,o),o?(i[Q].P&&(O(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),O(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.g?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.O&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,O:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=""+i[s];0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.O&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,O:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,O:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.g=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?O(c):g(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw O(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,g(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.g=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = (fn);
//# sourceMappingURL=immer.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}



;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js
/* provided dependency */ var process = __webpack_require__(83454);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var __spreadProps = function (a, b) { return __defProps(a, __getOwnPropDescs(b)); };
var __async = function (__this, __arguments, generator) {
    return new Promise(function (resolve, reject) {
        var fulfilled = function (value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var rejected = function (value) {
            try {
                step(generator.throw(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var step = function (x) { return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected); };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelector = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var selector = createSelector.apply(void 0, args);
    var wrappedSelector = function (value) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return selector.apply(void 0, __spreadArray([isDraft(value) ? current(value) : value], rest));
    };
    return wrappedSelector;
};
// src/configureStore.ts

// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return compose;
    return compose.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
    return function (noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function redux_toolkit_esm_isPlainObject(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/getDefaultMiddleware.ts

// src/utils.ts

function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function (fn) {
            var started = Date.now();
            try {
                return fn();
            }
            finally {
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function () {
            if (elapsed > maxDelay) {
                console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
            }
        }
    };
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
function freezeDraftable(val) {
    return t(val) ? immer_esm(val, function () {
    }) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = (/* unused pure expression or super */ null && ("production" === "production"));
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler)
        decycler = function (_, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                value = decycler.call(this, key, value);
        }
        else
            stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (path === void 0) { path = ""; }
    var tracked = { value: obj };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for (var key in obj) {
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
                continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignorePaths, trackedProperty, obj, sameParentRef, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (sameParentRef === void 0) { sameParentRef = false; }
    if (path === void 0) { path = ""; }
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
        return { wasMutated: true, path: path };
    }
    if (isImmutable(prevObj) || isImmutable(obj)) {
        return { wasMutated: false };
    }
    var keysToDetect = {};
    for (var key in trackedProperty.children) {
        keysToDetect[key] = true;
    }
    for (var key in obj) {
        keysToDetect[key] = true;
    }
    for (var key in keysToDetect) {
        var childPath = path ? path + "." + key : key;
        if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
            continue;
        }
        var result = detectMutations(isImmutable, ignorePaths, trackedProperty.children[key], obj[key], sameRef, childPath);
        if (result.wasMutated) {
            return result;
        }
    }
    return { wasMutated: false };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isImmutable, isImmutable = _c === void 0 ? isImmutableDefault : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function (_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function (next) { return function (action) {
            var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            var dispatchedAction = next(action);
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            measureUtils.warnIfExceeded();
            return dispatchedAction;
        }; };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || redux_toolkit_esm_isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths) {
    if (path === void 0) { path = ""; }
    if (isSerializable === void 0) { isSerializable = isPlain; }
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    var foundNestedSerializable;
    if (!isSerializable(value)) {
        return {
            keyPath: path || "<root>",
            value: value
        };
    }
    if (typeof value !== "object" || value === null) {
        return false;
    }
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths && ignoredPaths.indexOf(nestedPath) >= 0) {
            continue;
        }
        if (!isSerializable(nestedValue)) {
            return {
                keyPath: nestedPath,
                value: nestedValue
            };
        }
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths);
            if (foundNestedSerializable) {
                return foundNestedSerializable;
            }
        }
    }
    return false;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isSerializable, isSerializable = _c === void 0 ? isPlain : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j;
    return function (storeAPI) { return function (next) { return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
            measureUtils.measureTime(function () {
                var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths);
                if (foundActionNonSerializableValue) {
                    var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                    console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                }
            });
        }
        if (!ignoreState) {
            measureUtils.measureTime(function () {
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths);
                if (foundStateNonSerializableValue) {
                    var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                    console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                }
            });
            measureUtils.warnIfExceeded();
        }
        return result;
    }; }; };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) {
            middlewareArray.push(es);
        }
        else {
            middlewareArray.push(es.withExtraArgument(thunk.extraArgument));
        }
    }
    if (false) { var serializableOptions, immutableOptions; }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = "production" === "production";
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (redux_toolkit_esm_isPlainObject(reducer)) {
        rootReducer = combineReducers(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
            throw new Error("when using a middleware builder function, an array of middleware must be returned");
        }
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function (item) { return typeof item !== "function"; })) {
        throw new Error("each middleware provided to configureStore must be a function");
    }
    var middlewareEnhancer = applyMiddleware.apply(void 0, finalMiddleware);
    var finalCompose = compose;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var storeEnhancers = [middlewareEnhancer];
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(storeEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return createStore(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
function isFSA(action) {
    return redux_toolkit_esm_isPlainObject(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/createReducer.ts

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            if (false) {}
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) {
                throw new Error("addCase cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            if (false) {}
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            if (false) {}
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    if (false) {}
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return freezeDraftable(initialState()); };
    }
    else {
        var frozenInitialState_1 = freezeDraftable(initialState);
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if (r(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) {
                        return previousState;
                    }
                    return result;
                }
                else if (!t(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return immer_esm(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    if (typeof process !== "undefined" && "production" === "development") {}
    var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        if (false) {}
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, function (builder) {
            for (var key in finalCaseReducers) {
                builder.addCase(key, finalCaseReducers[key]);
            }
            for (var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++) {
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) {
                builder.addDefaultCase(defaultCaseReducer);
            }
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) { additionalState = {}; }
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return { getInitialState: getInitialState };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function (state) { return state.ids; };
        var selectEntities = function (state) { return state.entities; };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function (ids, entities) { return ids.map(function (id) { return entities[id]; }); });
        var selectId = function (_, id) { return id; };
        var selectById = function (entities, id) { return entities[id]; };
        var selectTotal = createDraftSafeSelector(selectIds, function (ids) { return ids.length; });
        if (!selectState) {
            return {
                selectIds: selectIds,
                selectEntities: selectEntities,
                selectAll: selectAll,
                selectTotal: selectTotal,
                selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
            };
        }
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return { getSelectors: getSelectors };
}
// src/entities/state_adapter.ts

function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function (_, state) { return mutator(state); });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function (draft) {
            if (isPayloadActionArgument(arg)) {
                mutator(arg.payload, draft);
            }
            else {
                mutator(arg, draft);
            }
        };
        if (isDraft3(state)) {
            runMutator(state);
            return state;
        }
        else {
            return createNextState3(state, runMutator);
        }
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (false) {}
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) {
        entities = Object.values(entities);
    }
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for (var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++) {
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) {
            updated.push({ id: id, changes: entity });
        }
        else {
            added.push(entity);
        }
    }
    return [added, updated];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) {
            return;
        }
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++) {
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) {
            state.ids.push(key);
        }
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++) {
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([key], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function (key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) {
            state.ids = state.ids.filter(function (id) { return id in state.entities; });
        }
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function (update) {
            if (update.id in state.entities) {
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function (update) { return takeNewKey(newKeys, update, state); }).length > 0;
            if (didMutateIds) {
                state.ids = Object.keys(state.entities);
            }
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([entity], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function (model) { return !(selectIdValue(model, selectId) in state.entities); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function setOneMutably(entity, state) {
        return setManyMutably([entity], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            merge(newEntities, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for (var _i = 0, updates_1 = updates; _i < updates_1.length; _i++) {
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) {
                continue;
            }
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) {
            resortEntities(state);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length && i < b.length; i++) {
            if (a[i] === b[i]) {
                continue;
            }
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function (model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) {
            state.ids = newSortedIds;
        }
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) { options = {}; }
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function (instance) { return instance.id; }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
    if (size === void 0) { size = 21; }
    var id = "";
    var i = size;
    while (i--) {
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ (function () {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}());
var FulfillWithMeta = /** @class */ (function () {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}());
var miniSerializeError = function (value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
var createAsyncThunk = (function () {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) { return ({
            payload: payload,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "fulfilled"
            })
        }); });
        var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) { return ({
            payload: void 0,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "pending"
            })
        }); });
        var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) { return ({
            payload: payload,
            error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                rejectedWithValue: !!payload,
                requestStatus: "rejected",
                aborted: (error == null ? void 0 : error.name) === "AbortError",
                condition: (error == null ? void 0 : error.name) === "ConditionError"
            })
        }); });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ (function () {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function () {
                    },
                    dispatchEvent: function () {
                        return false;
                    },
                    onabort: function () {
                    },
                    removeEventListener: function () {
                    },
                    reason: void 0,
                    throwIfAborted: function () {
                    }
                };
            }
            class_1.prototype.abort = function () {
                if (false) {}
            };
            return class_1;
        }());
        function actionCreator(arg) {
            return function (dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function () {
                    return __async(this, null, function () {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _c.trys.push([0, 4, , 5]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, { getState: getState, extra: extra });
                                    if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, conditionResult];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) {
                                        throw {
                                            name: "ConditionError",
                                            message: "Aborted due to condition callback returning false."
                                        };
                                    }
                                    started = true;
                                    abortedPromise = new Promise(function (_, reject) { return abortController.signal.addEventListener("abort", function () { return reject({
                                        name: "AbortError",
                                        message: abortReason || "Aborted"
                                    }); }); });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, { requestId: requestId, arg: arg }, { getState: getState, extra: extra })));
                                    return [4 /*yield*/, Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function (value, meta) {
                                                    return new RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function (value, meta) {
                                                    return new FulfillWithMeta(value, meta);
                                                }
                                            })).then(function (result) {
                                                if (result instanceof RejectWithValue) {
                                                    throw result;
                                                }
                                                if (result instanceof FulfillWithMeta) {
                                                    return fulfilled(result.payload, requestId, arg, result.meta);
                                                }
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])];
                                case 3:
                                    finalAction = _c.sent();
                                    return [3 /*break*/, 5];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [3 /*break*/, 5];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) {
                                        dispatch(finalAction);
                                    }
                                    return [2 /*return*/, finalAction];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function () {
                        return promise2.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function () { return createAsyncThunk2; };
    return createAsyncThunk2;
})();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) {
        throw action.payload;
    }
    if (action.error) {
        throw action.error;
    }
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var hasMatchFunction = function (v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var matches = function (matcher, action) {
    if (hasMatchFunction(matcher)) {
        return matcher.match(action);
    }
    else {
        return matcher(action);
    }
};
function isAnyOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.some(function (matcher) { return matches(matcher, action); });
    };
}
function isAllOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.every(function (matcher) { return matches(matcher, action); });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta)
        return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isPending()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.pending; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejected()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.rejected; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    var hasFlag = function (action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) {
        return function (action) {
            var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
            return combinedMatcher(action);
        };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejectedWithValue()(asyncThunks[0]);
    }
    return function (action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["fulfilled"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isFulfilled()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.fulfilled; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isAsyncThunkAction()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = [];
        for (var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++) {
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function (func, expected) {
    if (typeof func !== "function") {
        throw new TypeError(expected + " is not a function");
    }
};
var noop = function () {
};
var catchRejection = function (promise2, onError) {
    if (onError === void 0) { onError = noop; }
    promise2.catch(onError);
    return promise2;
};
var addAbortSignalListener = function (abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, { once: true });
};
var abortControllerWithReason = function (abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) {
        return;
    }
    if (!("reason" in signal)) {
        Object.defineProperty(signal, "reason", {
            enumerable: true,
            value: reason,
            configurable: true,
            writable: true
        });
    }
    ;
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ (function () {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}());
// src/listenerMiddleware/task.ts
var validateActive = function (signal) {
    if (signal.aborted) {
        throw new TaskAbortError(signal.reason);
    }
};
var promisifyAbortSignal = function (signal) {
    return catchRejection(new Promise(function (_, reject) {
        var notifyRejection = function () { return reject(new TaskAbortError(signal.reason)); };
        if (signal.aborted) {
            notifyRejection();
        }
        else {
            addAbortSignalListener(signal, notifyRejection);
        }
    }));
};
var runTask = function (task2, cleanUp) { return __async(void 0, null, function () {
    var value, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, 4, 5]);
                return [4 /*yield*/, Promise.resolve()];
            case 1:
                _c.sent();
                return [4 /*yield*/, task2()];
            case 2:
                value = _c.sent();
                return [2 /*return*/, {
                        status: "ok",
                        value: value
                    }];
            case 3:
                error_1 = _c.sent();
                return [2 /*return*/, {
                        status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                        error: error_1
                    }];
            case 4:
                cleanUp == null ? void 0 : cleanUp();
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var createPause = function (signal) {
    return function (promise2) {
        return catchRejection(Promise.race([promisifyAbortSignal(signal), promise2]).then(function (output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function (signal) {
    var pause = createPause(signal);
    return function (timeoutMs) {
        return pause(new Promise(function (resolve) { return setTimeout(resolve, timeoutMs); }));
    };
};
// src/listenerMiddleware/index.ts
var redux_toolkit_esm_assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function (parentAbortSignal) {
    var linkControllers = function (controller) { return addAbortSignalListener(parentAbortSignal, function () { return abortControllerWithReason(controller, parentAbortSignal.reason); }); };
    return function (taskExecutor) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function () { return __async(void 0, null, function () {
            var result2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        validateActive(parentAbortSignal);
                        validateActive(childAbortController.signal);
                        return [4 /*yield*/, taskExecutor({
                                pause: createPause(childAbortController.signal),
                                delay: createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })];
                    case 1:
                        result2 = _c.sent();
                        validateActive(childAbortController.signal);
                        return [2 /*return*/, result2];
                }
            });
        }); }, function () { return abortControllerWithReason(childAbortController, taskCompleted); });
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function (startListening, signal) {
    var take = function (predicate, timeout) { return __async(void 0, null, function () {
        var unsubscribe, tuplePromise, promises, output;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    validateActive(signal);
                    unsubscribe = function () {
                    };
                    tuplePromise = new Promise(function (resolve) {
                        unsubscribe = startListening({
                            predicate: predicate,
                            effect: function (action, listenerApi) {
                                listenerApi.unsubscribe();
                                resolve([
                                    action,
                                    listenerApi.getState(),
                                    listenerApi.getOriginalState()
                                ]);
                            }
                        });
                    });
                    promises = [
                        promisifyAbortSignal(signal),
                        tuplePromise
                    ];
                    if (timeout != null) {
                        promises.push(new Promise(function (resolve) { return setTimeout(resolve, timeout, null); }));
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, Promise.race(promises)];
                case 2:
                    output = _c.sent();
                    validateActive(signal);
                    return [2 /*return*/, output];
                case 3:
                    unsubscribe();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return function (predicate, timeout) { return catchRejection(take(predicate, timeout)); };
};
var getListenerEntryPropsFrom = function (options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) {
        predicate = createAction(type).match;
    }
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    }
    else if (matcher) {
        predicate = matcher;
    }
    else if (predicate) {
    }
    else {
        throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    }
    assertFunction(effect, "options.listener");
    return { predicate: predicate, type: type, effect: effect };
};
var createListenerEntry = function (options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function () {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var createClearListenerMiddleware = function (listenerMap) {
    return function () {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function (errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    }
    catch (errorHandlerError) {
        setTimeout(function () {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.error.apply(console, __spreadArray([alm + "/error"], args));
};
var cancelActiveListeners = function (entry) {
    entry.pending.forEach(function (controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) { middlewareOptions = {}; }
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function (entry) {
        entry.unsubscribe = function () { return listenerMap.delete(entry.id); };
        listenerMap.set(entry.id, entry);
        return function (cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) {
                cancelActiveListeners(entry);
            }
        };
    };
    var findListenerEntry = function (comparator) {
        for (var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++) {
            var entry = _c[_i];
            if (comparator(entry)) {
                return entry;
            }
        }
        return void 0;
    };
    var startListening = function (options) {
        var entry = findListenerEntry(function (existingEntry) { return existingEntry.effect === options.effect; });
        if (!entry) {
            entry = createListenerEntry(options);
        }
        return insertEntry(entry);
    };
    var stopListening = function (options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function (entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) {
                cancelActiveListeners(entry);
            }
        }
        return !!entry;
    };
    var notifyListener = function (entry, action, api, getOriginalState) { return __async(_this, null, function () {
        var internalTaskController, take, listenerError_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    internalTaskController = new AbortController();
                    take = createTakePattern(startListening, internalTaskController.signal);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    entry.pending.add(internalTaskController);
                    return [4 /*yield*/, Promise.resolve(entry.effect(action, redux_toolkit_esm_assign({}, api, {
                            getOriginalState: getOriginalState,
                            condition: function (predicate, timeout) { return take(predicate, timeout).then(Boolean); },
                            take: take,
                            delay: createDelay(internalTaskController.signal),
                            pause: createPause(internalTaskController.signal),
                            extra: extra,
                            signal: internalTaskController.signal,
                            fork: createFork(internalTaskController.signal),
                            unsubscribe: entry.unsubscribe,
                            subscribe: function () {
                                listenerMap.set(entry.id, entry);
                            },
                            cancelActiveListeners: function () {
                                entry.pending.forEach(function (controller, _, set) {
                                    if (controller !== internalTaskController) {
                                        abortControllerWithReason(controller, listenerCancelled);
                                        set.delete(controller);
                                    }
                                });
                            }
                        })))];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    listenerError_1 = _c.sent();
                    if (!(listenerError_1 instanceof TaskAbortError)) {
                        safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                    }
                    return [3 /*break*/, 5];
                case 4:
                    abortControllerWithReason(internalTaskController, listenerCompleted);
                    entry.pending.delete(internalTaskController);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function (api) { return function (next) { return function (action) {
        if (addListener.match(action)) {
            return startListening(action.payload);
        }
        if (clearAllListeners.match(action)) {
            clearListenerMiddleware();
            return;
        }
        if (removeListener.match(action)) {
            return stopListening(action.payload);
        }
        var originalState = api.getState();
        var getOriginalState = function () {
            if (originalState === INTERNAL_NIL_TOKEN) {
                throw new Error(alm + ": getOriginalState can only be called synchronously");
            }
            return originalState;
        };
        var result;
        try {
            result = next(action);
            if (listenerMap.size > 0) {
                var currentState = api.getState();
                var listenerEntries = Array.from(listenerMap.values());
                for (var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++) {
                    var entry = listenerEntries_1[_i];
                    var runListener = false;
                    try {
                        runListener = entry.predicate(action, currentState, originalState);
                    }
                    catch (predicateError) {
                        runListener = false;
                        safelyNotifyError(onError, predicateError, {
                            raisedBy: "predicate"
                        });
                    }
                    if (!runListener) {
                        continue;
                    }
                    notifyListener(entry, action, api, getOriginalState);
                }
            }
        }
        finally {
            originalState = INTERNAL_NIL_TOKEN;
        }
        return result;
    }; }; };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = function () { return function (payload) {
    var _c;
    return ({
        payload: payload,
        meta: (_c = {}, _c[SHOULD_AUTOBATCH] = true, _c)
    });
}; };
var promise;
var queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : globalThis) : function (cb) { return (promise || (promise = Promise.resolve())).then(cb).catch(function (err) { return setTimeout(function () {
    throw err;
}, 0); }); };
var createQueueWithTimer = function (timeout) {
    return function (notify) {
        setTimeout(notify, timeout);
    };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = function (options) {
    if (options === void 0) { options = { type: "raf" }; }
    return function (next) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var store = next.apply(void 0, args);
        var notifying = true;
        var shouldNotifyAtEndOfTick = false;
        var notificationQueued = false;
        var listeners = new Set();
        var queueCallback = options.type === "tick" ? queueMicrotaskShim : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
        var notifyListeners = function () {
            notificationQueued = false;
            if (shouldNotifyAtEndOfTick) {
                shouldNotifyAtEndOfTick = false;
                listeners.forEach(function (l) { return l(); });
            }
        };
        return Object.assign({}, store, {
            subscribe: function (listener2) {
                var wrappedListener = function () { return notifying && listener2(); };
                var unsubscribe = store.subscribe(wrappedListener);
                listeners.add(listener2);
                return function () {
                    unsubscribe();
                    listeners.delete(listener2);
                };
            },
            dispatch: function (action) {
                var _a;
                try {
                    notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                    shouldNotifyAtEndOfTick = !notifying;
                    if (shouldNotifyAtEndOfTick) {
                        if (!notificationQueued) {
                            notificationQueued = true;
                            queueCallback(notifyListeners);
                        }
                    }
                    return store.dispatch(action);
                }
                finally {
                    notifying = true;
                }
            }
        });
    }; };
};
// src/index.ts
F();

//# sourceMappingURL=redux-toolkit.esm.js.map

/***/ }),

/***/ 51131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
const DEFAULT_ENVIRONMENT = 'production';


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 71195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RP": function() { return /* binding */ notifyEventProcessors; },
/* harmony export */   "cc": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "fH": function() { return /* binding */ getGlobalEventProcessors; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67597);


/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}

/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */
function notifyEventProcessors(
  processors,
  event,
  hint,
  index = 0,
) {
  return new _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .SyncPromise */ .cW((resolve, reject) => {
    const processor = processors[index];
    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      const result = processor({ ...event }, hint) ;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        processor.id &&
        result === null &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

      if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .isThenable */ .J8)(result)) {
        void result
          .then(final => notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
          .then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1)
          .then(resolve)
          .then(null, reject);
      }
    }
  });
}


//# sourceMappingURL=eventProcessors.js.map


/***/ }),

/***/ 64487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "e": function() { return /* binding */ configureScope; }
/* harmony export */ });
/* unused harmony exports addBreadcrumb, captureCheckIn, captureEvent, captureMessage, close, flush, lastEventId, setContext, setExtra, setExtras, setTag, setTags, setUser, startTransaction, withMonitor */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95659);



// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  getCurrentHub().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  getCurrentHub().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}

/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function captureCheckIn(checkIn, upsertMonitorConfig) {
  const hub = getCurrentHub();
  const scope = hub.getScope();
  const client = hub.getClient();
  if (!client) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot capture check-in. No client defined.');
  } else if (!client.captureCheckIn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot capture check-in. Client does not support sending check-ins.');
  } else {
    return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
  }

  return uuid4();
}

/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function withMonitor(
  monitorSlug,
  callback,
  upsertMonitorConfig,
) {
  const checkInId = captureCheckIn({ monitorSlug, status: 'in_progress' }, upsertMonitorConfig);
  const now = timestampInSeconds();

  function finishCheckIn(status) {
    captureCheckIn({ monitorSlug, status, checkInId, duration: timestampInSeconds() - now });
  }

  let maybePromiseResult;
  try {
    maybePromiseResult = callback();
  } catch (e) {
    finishCheckIn('error');
    throw e;
  }

  if (isThenable(maybePromiseResult)) {
    Promise.resolve(maybePromiseResult).then(
      () => {
        finishCheckIn('ok');
      },
      () => {
        finishCheckIn('error');
      },
    );
  } else {
    finishCheckIn('ok');
  }

  return maybePromiseResult;
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function flush(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events. No client defined.');
  return Promise.resolve(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function close(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return Promise.resolve(false);
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 95659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, ensureHubOnCarrier, getHubFromCarrier, makeMain, runWithAsyncContext, setAsyncContextStrategy, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71235);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51131);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10350);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9015);





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {this._version = _version;
    this._stack = [{ scope }];
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this.getScope().setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this.getScope().setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this.getScope().setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.getScope().setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this.getScope().setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    this.getScope().setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && !result) {
      const client = this.getClient();
      if (!client) {
        // eslint-disable-next-line no-console
        console.warn(
          "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'",
        );
      } else {
        // eslint-disable-next-line no-console
        console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
      }
    }

    return result;
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    scope.setSession();
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      user: scope.getUser(),
      ...(userAgent && { userAgent }),
      ...context,
    });

    // End existing session if there's one
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === 'ok') {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
    }
    this.endSession();

    // Afterwards we set the new session on the scope
    scope.setSession(session);

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();

    const session = scope.getSession();
    if (session && client && client.captureSession) {
      client.captureSession(session);
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();

    if (hub) {
      return hub;
    }
  }

  // Return hub that lives on a global object
  return getGlobalHub(registry);
}

function getGlobalHub(registry = getMainCarrier()) {
  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */
function ensureHubOnCarrier(carrier, parent = getGlobalHub()) {
  // If there's no hub on current domain, or it's an old API, assign a new one
  if (!hasHubOnCarrier(carrier) || getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
    const globalHubTopStack = parent.getStackTop();
    setHubOnCarrier(carrier, new Hub(globalHubTopStack.client, Scope.clone(globalHubTopStack.scope)));
  }
}

/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();
  registry.__SENTRY__ = registry.__SENTRY__ || {};
  registry.__SENTRY__.acs = strategy;
}

/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */
function runWithAsyncContext(callback, options = {}) {
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
  }

  // if there was no strategy, fallback to just calling the callback
  return callback();
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 10350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62844);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71195);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9015);




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /** Propagation Context for distributed tracing */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = generatePropagationContext();
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
      newScope._propagationContext = { ...scope._propagationContext };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
      if (captureContext._propagationContext) {
        this._propagationContext = captureContext._propagationContext;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
      if (captureContext.propagationContext) {
        this._propagationContext = captureContext.propagationContext;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    this._propagationContext = generatePropagationContext();
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };

    const breadcrumbs = this._breadcrumbs;
    breadcrumbs.push(mergedBreadcrumb);
    this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;

    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(
    event,
    hint = {},
    additionalEventProcessors,
  ) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transaction = this._span.transaction;
      if (transaction) {
        event.sdkProcessingMetadata = {
          dynamicSamplingContext: transaction.getDynamicSamplingContext(),
          ...event.sdkProcessingMetadata,
        };
        const transactionName = transaction.name;
        if (transactionName) {
          event.tags = { transaction: transactionName, ...event.tags };
        }
      }
    }

    this._applyFingerprint(event);

    const scopeBreadcrumbs = this._getBreadcrumbs();
    const breadcrumbs = [...(event.breadcrumbs || []), ...scopeBreadcrumbs];
    event.breadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : undefined;

    event.sdkProcessingMetadata = {
      ...event.sdkProcessingMetadata,
      ...this._sdkProcessingMetadata,
      propagationContext: this._propagationContext,
    };

    // TODO (v8): Update this order to be: Global > Client > Scope
    return (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_3__/* .notifyEventProcessors */ .RP)(
      [...(additionalEventProcessors || []), ...(0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_3__/* .getGlobalEventProcessors */ .fH)(), ...this._eventProcessors],
      event,
      hint,
    );
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * @inheritDoc
   */
   setPropagationContext(context) {
    this._propagationContext = context;
    return this;
  }

  /**
   * @inheritDoc
   */
   getPropagationContext() {
    return this._propagationContext;
  }

  /**
   * Get the breadcrumbs for this scope.
   */
   _getBreadcrumbs() {
    return this._breadcrumbs;
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .arrayify */ .lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

function generatePropagationContext() {
  return {
    traceId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .uuid4 */ .DM)(),
    spanId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .uuid4 */ .DM)().substring(16),
  };
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 9015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20535);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.abnormal_mechanism) {
    session.abnormal_mechanism = context.abnormal_mechanism;
  }

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    abnormal_mechanism: session.abnormal_mechanism,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 58464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {

  if (!elem) {
    return '<unknown>';
  }

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 68518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getSDKSource; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-expect-error "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map


/***/ }),

/***/ 67597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "y1": function() { return /* binding */ isVueViewModel; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}

/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isVueViewModel(wat) {
  // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
  return !!(typeof wat === 'object' && wat !== null && ((wat ).__isVue || (wat )._isVue));
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 12343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "LD": function() { return /* binding */ originalConsoleMethods; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/** This may be mutated by the console instrumentation. */
const originalConsoleMethods

 = {};

/** JSDoc */

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const console = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedFuncs = {};

  const wrappedLevels = Object.keys(originalConsoleMethods) ;

  // Restore all wrapped console methods
  wrappedLevels.forEach(level => {
    const originalConsoleMethod = originalConsoleMethods[level] ;
    wrappedFuncs[level] = console[level] ;
    console[level] = originalConsoleMethod;
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    wrappedLevels.forEach(level => {
      console[level] = wrappedFuncs[level] ;
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
    isEnabled: () => enabled,
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

const logger = makeLogger();


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 62844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  let getRandomByte = () => Math.random() * 16;
  try {
    if (crypto && crypto.randomUUID) {
      return crypto.randomUUID().replace(/-/g, '');
    }
    if (crypto && crypto.getRandomValues) {
      getRandomByte = () => crypto.getRandomValues(new Uint8Array(1))[0];
    }
  } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
  }

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 61422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; },
/* harmony export */   "l$": function() { return /* binding */ dynamicRequire; }
/* harmony export */ });
/* unused harmony export loadModule */
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68518);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(83454);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !(0,_env_js__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 20535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58464);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12343);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57321);





/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    markFunctionWrapped(wrapped, original);
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  try {
    Object.defineProperty(obj, name, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: value,
      writable: true,
      configurable: true,
    });
  } catch (o_O) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.log */ .kg.log(`Failed to add non-enumerable property "${name}" to object`, obj);
  }
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  try {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
  } catch (o_O) {} // eslint-disable-line no-empty
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_2__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_3__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_3__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 57321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
      // console warnings. This happens when a Vue template is rendered with
      // an undeclared variable, which we try to stringify, ultimately causing
      // Vue to issue another warning which repeats indefinitely.
      // see: https://github.com/getsentry/sentry-javascript/pull/8981
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isVueViewModel */ .y1)(value)) {
        output.push('[VueViewModel]');
      } else {
        output.push(String(value));
      }
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 96893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);
    this._state = States.PENDING;
    this._handlers = [];

    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init2() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init3() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init4() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 21170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, timestampWithMs, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61422);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 71235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var createError = __webpack_require__(85061);
var defaults = __webpack_require__(45655);
var Cancel = __webpack_require__(65263);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(65263);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 65263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(65263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 85061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(80481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45655);
var Cancel = __webpack_require__(65263);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 80481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(85061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var enhanceError = __webpack_require__(80481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.24.0"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 21924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBind = __webpack_require__(55559);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 55559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var GetIntrinsic = __webpack_require__(40210);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 19662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var tryToString = __webpack_require__(66330);

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 19670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var isObject = __webpack_require__(70111);

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ 41318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(45656);
var toAbsoluteIndex = __webpack_require__(51400);
var lengthOfArrayLike = __webpack_require__(26244);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 84326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 70648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var isCallable = __webpack_require__(60614);
var classofRaw = __webpack_require__(84326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 99920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasOwn = __webpack_require__(92597);
var ownKeys = __webpack_require__(53887);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 68880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(79114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 79114:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 19781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 80317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var isObject = __webpack_require__(70111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 88113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(35005);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ 7392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var userAgent = __webpack_require__(88113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 80748:
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 82109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var getOwnPropertyDescriptor = (__webpack_require__(31236).f);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var setGlobal = __webpack_require__(83505);
var copyConstructorProperties = __webpack_require__(99920);
var isForced = __webpack_require__(54705);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 47293:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 34374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);

module.exports = !fails(function () {
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 46916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(34374);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 76530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var hasOwn = __webpack_require__(92597);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 1702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(34374);

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = NATIVE_BIND && bind.bind(call, call);

module.exports = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 35005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 58173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aCallable = __webpack_require__(19662);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ 10647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(47908);

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ 17854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 92597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(47908);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 64664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var fails = __webpack_require__(47293);
var createElement = __webpack_require__(80317);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 68361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(47293);
var classof = __webpack_require__(84326);

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


/***/ }),

/***/ 42788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var isCallable = __webpack_require__(60614);
var store = __webpack_require__(5465);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 29909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(68536);
var global = __webpack_require__(17854);
var uncurryThis = __webpack_require__(1702);
var isObject = __webpack_require__(70111);
var createNonEnumerableProperty = __webpack_require__(68880);
var hasOwn = __webpack_require__(92597);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 60614:
/***/ (function(module) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);
var isCallable = __webpack_require__(60614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 70111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(60614);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 31913:
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ 47850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(70111);
var classof = __webpack_require__(84326);
var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ 52190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var getBuiltIn = __webpack_require__(35005);
var isCallable = __webpack_require__(60614);
var isPrototypeOf = __webpack_require__(47976);
var USE_SYMBOL_AS_UID = __webpack_require__(43307);

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


/***/ }),

/***/ 26244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toLength = __webpack_require__(17466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 30133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(47293);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 68536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var inspectSource = __webpack_require__(42788);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var global = __webpack_require__(17854);
var DESCRIPTORS = __webpack_require__(19781);
var IE8_DOM_DEFINE = __webpack_require__(64664);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var anObject = __webpack_require__(19670);
var toPropertyKey = __webpack_require__(34948);

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 31236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var call = __webpack_require__(46916);
var propertyIsEnumerableModule = __webpack_require__(55296);
var createPropertyDescriptor = __webpack_require__(79114);
var toIndexedObject = __webpack_require__(45656);
var toPropertyKey = __webpack_require__(34948);
var hasOwn = __webpack_require__(92597);
var IE8_DOM_DEFINE = __webpack_require__(64664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 8006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(16324);
var enumBugKeys = __webpack_require__(80748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 25181:
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 47976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 16324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(92597);
var toIndexedObject = __webpack_require__(45656);
var indexOf = (__webpack_require__(41318).indexOf);
var hiddenKeys = __webpack_require__(3501);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 55296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 92140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var call = __webpack_require__(46916);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 53887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(35005);
var uncurryThis = __webpack_require__(1702);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var anObject = __webpack_require__(19670);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 31320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var hasOwn = __webpack_require__(92597);
var createNonEnumerableProperty = __webpack_require__(68880);
var setGlobal = __webpack_require__(83505);
var inspectSource = __webpack_require__(42788);
var InternalStateModule = __webpack_require__(29909);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(76530).CONFIGURABLE);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ 67066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(19670);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 84488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 83505:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 6200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(72309);
var uid = __webpack_require__(69711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var setGlobal = __webpack_require__(83505);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ 72309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(31913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.21.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.21.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 51400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(19303);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 45656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(68361);
var requireObjectCoercible = __webpack_require__(84488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 19303:
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


/***/ }),

/***/ 17466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(19303);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 47908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var requireObjectCoercible = __webpack_require__(84488);

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 57593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var call = __webpack_require__(46916);
var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var getMethod = __webpack_require__(58173);
var ordinaryToPrimitive = __webpack_require__(92140);
var wellKnownSymbol = __webpack_require__(5112);

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 34948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(57593);
var isSymbol = __webpack_require__(52190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 51694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 41340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var classof = __webpack_require__(70648);

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ 66330:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 69711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 43307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(30133);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var fails = __webpack_require__(47293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 5112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var shared = __webpack_require__(72309);
var hasOwn = __webpack_require__(92597);
var uid = __webpack_require__(69711);
var NATIVE_SYMBOL = __webpack_require__(30133);
var USE_SYMBOL_AS_UID = __webpack_require__(43307);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 68757:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var call = __webpack_require__(46916);
var uncurryThis = __webpack_require__(1702);
var requireObjectCoercible = __webpack_require__(84488);
var isCallable = __webpack_require__(60614);
var isRegExp = __webpack_require__(47850);
var toString = __webpack_require__(41340);
var getMethod = __webpack_require__(58173);
var regExpFlags = __webpack_require__(67066);
var getSubstitution = __webpack_require__(10647);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);

var REPLACE = wellKnownSymbol('replace');
var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError;
var getFlags = uncurryThis(regExpFlags);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var max = Math.max;

var stringIndexOf = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return indexOf(string, searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (searchValue != null) {
      IS_REG_EXP = isRegExp(searchValue);
      if (IS_REG_EXP) {
        flags = toString(requireObjectCoercible('flags' in RegExpPrototype
          ? searchValue.flags
          : getFlags(searchValue)
        ));
        if (!~indexOf(flags, 'g')) throw TypeError('`.replaceAll` does not allow non-global regexes');
      }
      replacer = getMethod(searchValue, REPLACE);
      if (replacer) {
        return call(replacer, searchValue, O, replaceValue);
      } else if (IS_PURE && IS_REG_EXP) {
        return replace(toString(O), searchValue, replaceValue);
      }
    }
    string = toString(O);
    searchString = toString(searchValue);
    functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString(replaceValue);
    searchLength = searchString.length;
    advanceBy = max(1, searchLength);
    position = stringIndexOf(string, searchString, 0);
    while (position !== -1) {
      replacement = functionalReplace
        ? toString(replaceValue(searchString, position, string))
        : getSubstitution(searchString, string, position, [], undefined, replaceValue);
      result += stringSlice(string, endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += stringSlice(string, endOfLastMatch);
    }
    return result;
  }
});


/***/ }),

/***/ 84314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* unused harmony export setDefaultOptions */
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 59025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84314);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 83946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 49526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buildFormatLongFn; }
/* harmony export */ });
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

/***/ }),

/***/ 88486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buildLocalizeFn; }
/* harmony export */ });
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

/***/ }),

/***/ 76723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buildMatchFn; }
/* harmony export */ });
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

/***/ }),

/***/ 60974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buildMatchPatternFn; }
/* harmony export */ });
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

/***/ }),

/***/ 81991:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ __webpack_exports__["Z"] = (formatDistance);

/***/ }),

/***/ 21865:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ __webpack_exports__["Z"] = (formatRelative);

/***/ }),

/***/ 11950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88486);

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: (0,_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ __webpack_exports__["Z"] = (localize);

/***/ }),

/***/ 7219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76723);
/* harmony import */ var _lib_buildMatchPatternFn_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60974);


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: (0,_lib_buildMatchPatternFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ __webpack_exports__["Z"] = (match);

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 17648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(17642);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 41405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 17642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 66337:
/***/ (function() {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {
'use strict';

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}

/**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */
function getFrameElement(doc) {
  try {
    return doc.defaultView && doc.defaultView.frameElement || null;
  } catch (e) {
    // Ignore the error.
    return null;
  }
}

/**
 * A local reference to the root document.
 */
var document = (function(startDoc) {
  var doc = startDoc;
  var frame = getFrameElement(doc);
  while (frame) {
    doc = frame.ownerDocument;
    frame = getFrameElement(doc);
  }
  return doc;
})(window.document);

/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];

/**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
var crossOriginUpdater = null;

/**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */
var crossOriginRect = null;


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = ensureDOMRect(entry.rootBounds);
  this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
  this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (
    options.root &&
    options.root.nodeType != 1 &&
    options.root.nodeType != 9
  ) {
    throw new Error('root must be a Document or Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');

  /** @private @const {!Array<!Document>} */
  this._monitoringDocuments = [];
  /** @private @const {!Array<function()>} */
  this._monitoringUnsubscribes = [];
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
IntersectionObserver._setupCrossOriginUpdater = function() {
  if (!crossOriginUpdater) {
    /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */
    crossOriginUpdater = function(boundingClientRect, intersectionRect) {
      if (!boundingClientRect || !intersectionRect) {
        crossOriginRect = getEmptyRect();
      } else {
        crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
      }
      registry.forEach(function(observer) {
        observer._checkForIntersections();
      });
    };
  }
  return crossOriginUpdater;
};


/**
 * Resets the cross-origin mode.
 */
IntersectionObserver._resetCrossOriginUpdater = function() {
  crossOriginUpdater = null;
  crossOriginRect = null;
};


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections(target.ownerDocument);
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {
        return item.element != target;
      });
  this._unmonitorIntersections(target.ownerDocument);
  if (this._observationTargets.length == 0) {
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorAllIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function(doc) {
  var win = doc.defaultView;
  if (!win) {
    // Already destroyed.
    return;
  }
  if (this._monitoringDocuments.indexOf(doc) != -1) {
    // Already monitoring.
    return;
  }

  // Private state for monitoring.
  var callback = this._checkForIntersections;
  var monitoringInterval = null;
  var domObserver = null;

  // If a poll interval is set, use polling instead of listening to
  // resize and scroll events or DOM mutations.
  if (this.POLL_INTERVAL) {
    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
  } else {
    addEvent(win, 'resize', callback, true);
    addEvent(doc, 'scroll', callback, true);
    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
      domObserver = new win.MutationObserver(callback);
      domObserver.observe(doc, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  this._monitoringDocuments.push(doc);
  this._monitoringUnsubscribes.push(function() {
    // Get the window object again. When a friendly iframe is destroyed, it
    // will be null.
    var win = doc.defaultView;

    if (win) {
      if (monitoringInterval) {
        win.clearInterval(monitoringInterval);
      }
      removeEvent(win, 'resize', callback, true);
    }

    removeEvent(doc, 'scroll', callback, true);
    if (domObserver) {
      domObserver.disconnect();
    }
  });

  // Also monitor the parent.
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._monitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
  var index = this._monitoringDocuments.indexOf(doc);
  if (index == -1) {
    return;
  }

  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;

  // Check if any dependent targets are still remaining.
  var hasDependentTargets =
      this._observationTargets.some(function(item) {
        var itemDoc = item.element.ownerDocument;
        // Target is in this context.
        if (itemDoc == doc) {
          return true;
        }
        // Target is nested in this context.
        while (itemDoc && itemDoc != rootDoc) {
          var frame = getFrameElement(itemDoc);
          itemDoc = frame && frame.ownerDocument;
          if (itemDoc == doc) {
            return true;
          }
        }
        return false;
      });
  if (hasDependentTargets) {
    return;
  }

  // Unsubscribe.
  var unsubscribe = this._monitoringUnsubscribes[index];
  this._monitoringDocuments.splice(index, 1);
  this._monitoringUnsubscribes.splice(index, 1);
  unsubscribe();

  // Also unmonitor the parent.
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._unmonitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorAllIntersections = function() {
  var unsubscribes = this._monitoringUnsubscribes.slice(0);
  this._monitoringDocuments.length = 0;
  this._monitoringUnsubscribes.length = 0;
  for (var i = 0; i < unsubscribes.length; i++) {
    unsubscribes[i]();
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  if (!this.root && crossOriginUpdater && !crossOriginRect) {
    // Cross origin monitoring, but no initial data available yet.
    return;
  }

  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, targetRect, rootRect);

    var rootBounds = null;
    if (!this._rootContainsTarget(target)) {
      rootBounds = getEmptyRect();
    } else if (!crossOriginUpdater || this.root) {
      rootBounds = rootRect;
    }

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootBounds,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, targetRect, rootRect) {
  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot && parent) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return null;

    if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
      atRoot = true;
      if (parent == this.root || parent == document) {
        if (crossOriginUpdater && !this.root) {
          if (!crossOriginRect ||
              crossOriginRect.width == 0 && crossOriginRect.height == 0) {
            // A 0-size cross-origin intersection means no-intersection.
            parent = null;
            parentRect = null;
            intersectionRect = null;
          } else {
            parentRect = crossOriginRect;
          }
        } else {
          parentRect = rootRect;
        }
      } else {
        // Check if there's a frame that can be navigated to.
        var frame = getParentNode(parent);
        var frameRect = frame && getBoundingClientRect(frame);
        var frameIntersect =
            frame &&
            this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
        if (frameRect && frameIntersect) {
          parent = frame;
          parentRect = convertFromParentRect(frameRect, frameIntersect);
        } else {
          parent = null;
          intersectionRect = null;
        }
      }
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      var doc = parent.ownerDocument;
      if (parent != doc.body &&
          parent != doc.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
    }
    if (!intersectionRect) break;
    parent = parent && getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root && !isDoc(this.root)) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var doc = isDoc(this.root) ? this.root : document;
    var html = doc.documentElement;
    var body = doc.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  return (
    containsDeep(rootDoc, target) &&
    (!this.root || rootDoc == target.ownerDocument)
  );
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detachEvent == 'function') {
    node.detachEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  } || null;
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}


/**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */
function ensureDOMRect(rect) {
  // A `DOMRect` object has `x` and `y` fields.
  if (!rect || 'x' in rect) {
    return rect;
  }
  // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
  // for internally calculated Rect objects. For the purposes of
  // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
  // for these fields.
  return {
    top: rect.top,
    y: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height
  };
}


/**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */
function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
  var top = parentIntersectionRect.top - parentBoundingRect.top;
  var left = parentIntersectionRect.left - parentBoundingRect.left;
  return {
    top: top,
    left: left,
    height: parentIntersectionRect.height,
    width: parentIntersectionRect.width,
    bottom: top + parentIntersectionRect.height,
    right: left + parentIntersectionRect.width
  };
}


/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (node.nodeType == /* DOCUMENT */ 9 && node != document) {
    // If this node is a document node, look for the embedding frame.
    return getFrameElement(node);
  }

  // If the parent has element that is assigned through shadow root slot
  if (parent && parent.assignedSlot) {
    parent = parent.assignedSlot.parentNode
  }

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  return parent;
}

/**
 * Returns true if `node` is a Document.
 * @param {!Node} node
 * @returns {boolean}
 */
function isDoc(node) {
  return node && node.nodeType === 9;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());


/***/ }),

/***/ 37387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58590);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Loader_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["dark"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Loader = function Loader(_ref) {
  var dark = _ref.dark,
      props = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 38",
    stroke: dark ? "#000" : "#fff"
  }, props), {}, {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_Loader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().rotate_bar), props.className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      transform: "translate(1 1)",
      strokeWidth: 2,
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
        strokeOpacity: 0.5,
        cx: 18,
        cy: 18,
        r: 18
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M36 18c0-9.94-8.06-18-18-18"
      })]
    })
  }));
};

var MemoLoader = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Loader);
/* harmony default export */ __webpack_exports__["Z"] = (MemoLoader);

/***/ }),

/***/ 23583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);

var _excluded = ["width", "height"];



var Logo = function Logo(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 1060 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 214 : _ref$height,
      props = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
    src: "/radioline.png",
    alt: "Radioline",
    className: props.className
  });
};

var MemoLogo = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Logo);
/* harmony default export */ __webpack_exports__["Z"] = (MemoLogo);

/***/ }),

/***/ 52659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var OfflineOutline = function OfflineOutline(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 24",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M20.833 15.6V18c3.348 0 6.061-2.686 6.061-6 0-3.018-2.25-5.516-5.181-5.937C20.682 2.527 17.389 0 13.56 0a8.502 8.502 0 00-7.006 3.66C2.974 4.12.226 7.15.226 10.8c0 3.568 2.621 6.53 6.061 7.1V15.45c-2.091-.533-3.636-2.412-3.636-4.649 0-2.58 2.06-4.695 4.654-4.796l.668-.026.334-.573A6.068 6.068 0 0113.56 2.4c2.97 0 5.491 2.132 5.977 5l.173 1.022 1.047-.021a5.987 5.987 0 01.075-.001c2.009 0 3.637 1.612 3.637 3.6s-1.628 3.6-3.637 3.6z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M12.349 12v7.504l-2.78-2.693-1.714 1.661L13.561 24l5.705-5.528-1.714-1.66-2.78 2.692V12H12.35z",
      fill: "#fff"
    })]
  }));
};

var MemoOfflineOutline = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(OfflineOutline);
/* harmony default export */ __webpack_exports__["Z"] = (MemoOfflineOutline);

/***/ }),

/***/ 17812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ VlybyContainer; }
/* harmony export */ });
/* harmony import */ var app_context_features_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10833);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var iFrameSrcs = {
  floating: "/vlyby/vlyby-player-floating.html",
  fullScreenPlayer: "/vlyby/vlyby-player.html"
};
var VlybyContainer = function VlybyContainer(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? "100%" : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "100%" : _ref$width,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "fullScreenPlayer" : _ref$variant;

  var _useFeaturesContext = (0,app_context_features_context__WEBPACK_IMPORTED_MODULE_0__/* .useFeaturesContext */ .Pp)(),
      vlybyPublisherId = _useFeaturesContext.vlybyPublisherId;

  if (true) {
    window.vlybyId = vlybyPublisherId;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
    src: iFrameSrcs[variant],
    width: width,
    height: height
  });
};

/***/ }),

/***/ 53483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VW": function() { return /* binding */ ToastProvider; },
  "Ty": function() { return /* binding */ ToastRenderer; },
  "cM": function() { return /* binding */ useErrorToast; },
  "pm": function() { return /* binding */ useToast; },
  "e1": function() { return /* binding */ useToasts; }
});

// UNUSED EXPORTS: Toast, useToastContext

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./app/components/toast/toast.module.scss
var toast_module = __webpack_require__(8043);
var toast_module_default = /*#__PURE__*/__webpack_require__.n(toast_module);
;// CONCATENATED MODULE: ./node_modules/nanoid/index.browser.js


var random = function random(bytes) {
  return crypto.getRandomValues(new Uint8Array(bytes));
};

var customRandom = function customRandom(alphabet, defaultSize, getRandom) {
  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
  var step = -~(1.6 * mask * defaultSize / alphabet.length);
  return function () {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSize;
    var id = '';

    while (true) {
      var bytes = getRandom(step);
      var j = step;

      while (j--) {
        id += alphabet[bytes[j] & mask] || '';
        if (id.length === size) return id;
      }
    }
  };
};

var customAlphabet = function customAlphabet(alphabet) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 21;
  return customRandom(alphabet, size, random);
};

var nanoid = function nanoid() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
  return crypto.getRandomValues(new Uint8Array(size)).reduce(function (id, byte) {
    byte &= 63;

    if (byte < 36) {
      id += byte.toString(36);
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase();
    } else if (byte > 62) {
      id += '-';
    } else {
      id += '_';
    }

    return id;
  }, '');
};


// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./app/components/ui/portal.tsx + 1 modules
var portal = __webpack_require__(64263);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/toast/toast.component.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var Toast = function Toast(_ref) {
  var toast = _ref.toast;

  var getAnimationClass = function getAnimationClass() {
    switch (toast.config.position) {
      case "bottom-center":
      case "bottom-left":
      case "bottom-right":
        return (toast_module_default()).slide_down;

      case "top-center":
      case "top-left":
      case "top-right":
        return (toast_module_default()).slide_up;
    }
  };

  return toast ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((toast_module_default()).toast, getAnimationClass(), toast.toast.className),
    children: toast.toast.content
  }) : null;
};
var ToastContext = /*#__PURE__*/(0,react.createContext)(null);
var initialState = {
  "top-left": [],
  "top-center": [],
  "top-right": [],
  "bottom-left": [],
  "bottom-center": [],
  "bottom-right": []
};

var toastReducer = function toastReducer(toasts, action) {
  switch (action.type) {
    case "ADD":
      return _objectSpread(_objectSpread({}, toasts), {}, (0,defineProperty/* default */.Z)({}, action.toast.config.position, [].concat((0,toConsumableArray/* default */.Z)(toasts[action.toast.config.position]), [action.toast])));

    case "REMOVE":
      {
        for (var _i = 0, _Object$entries = Object.entries(toasts); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          var toastToHideIndex = value.findIndex(function (toastItem) {
            return toastItem.toast.id === action.id;
          });

          if (toastToHideIndex !== -1) {
            var toastsCopy = (0,toConsumableArray/* default */.Z)(value);

            toastsCopy.splice(toastToHideIndex, 1);
            return _objectSpread(_objectSpread({}, toasts), {}, (0,defineProperty/* default */.Z)({}, key, toastsCopy));
          }
        }

        return toasts;
      }

    case "REMOVE_ALL":
      return initialState;

    default:
      throw new Error();
  }
};

var ToastRenderer = function ToastRenderer() {
  var _useToastContext = useToastContext(),
      toasts = _useToastContext.toasts,
      hideToast = _useToastContext.hideToast;

  var renderToasts = function renderToasts(position) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((toast_module_default()).toast_container, (toast_module_default())[position]),
      children: toasts[position].map(function (toastItem) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Toast, {
          toast: toastItem,
          onDismiss: function onDismiss() {
            return hideToast(toastItem.toast.id);
          }
        }, toastItem.toast.id);
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(portal/* Portal */.h, {
    children: [renderToasts("bottom-center"), renderToasts("bottom-left"), renderToasts("bottom-right"), renderToasts("top-center"), renderToasts("top-left"), renderToasts("top-right")]
  });
};
var ToastProvider = function ToastProvider(_ref2) {
  var children = _ref2.children;

  var _useReducer = (0,react.useReducer)(toastReducer, initialState),
      toasts = _useReducer[0],
      dispatch = _useReducer[1];

  var addToast = function addToast(toast) {
    dispatch({
      type: "ADD",
      toast: toast
    });
    setTimeout(function () {
      hideToast(toast.toast.id);
    }, toast.config.duration);
  };

  var hideToast = function hideToast(toastId) {
    dispatch({
      type: "REMOVE",
      id: toastId
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ToastContext.Provider, {
    value: {
      toasts: toasts,
      addToast: addToast,
      hideToast: hideToast
    },
    children: children
  });
};
var useToastContext = function useToastContext() {
  var value = (0,react.useContext)(ToastContext);
  if (value === null) throw new Error("Use useToastContext only in components wrapped in ToastProvider");
  return value;
};
var useToasts = function useToasts(toast) {
  var toastConfig = _objectSpread({}, {
    duration: 4000,
    position: "top-center"
  });

  var toastContext = useToastContext();

  var showToast = function showToast(toastContentOverride) {
    var toastId = nanoid();
    toastContext.addToast({
      toast: {
        content: toastContentOverride || toast.success,
        id: toastId
      },
      config: toastConfig
    });
  };

  var showErrorToast = function showErrorToast(toastContentOverride) {
    var toastId = nanoid();
    toastContext.addToast({
      toast: {
        content: toastContentOverride || toast.error,
        id: toastId
      },
      config: toastConfig
    });
  };

  return [showToast, showErrorToast];
};
var useToast = function useToast(toast) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var toastConfig = _objectSpread(_objectSpread({}, {
    duration: 3000,
    position: "top-center"
  }), config);

  var toastContext = useToastContext();

  var showToast = function showToast(toastContentOverride) {
    var toastId = nanoid();
    toastContext.addToast({
      toast: {
        content: toastContentOverride || toast.content,
        className: toast.className,
        id: toastId
      },
      config: toastConfig
    });
  };

  return showToast;
};
var useErrorToast = function useErrorToast(toast) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return useToast(_objectSpread(_objectSpread({}, toast), {}, {
    className: (0,clsx_m/* default */.Z)((toast_module_default()).toast_error, toast.className)
  }), config);
};

/***/ }),

/***/ 61947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bb": function() { return /* binding */ ButtonDanger; },
/* harmony export */   "Ig": function() { return /* binding */ ButtonOutline; },
/* harmony export */   "oD": function() { return /* binding */ ButtonText; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _icons_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37387);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1711);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["className", "icon", "small", "compact", "children", "loading", "accent"],
    _excluded2 = ["className", "icon", "small", "children"],
    _excluded3 = ["className", "icon", "children", "small"],
    _excluded4 = ["className", "icon", "children", "small", "loading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref, ref) {
  var _clsx;

  var className = _ref.className,
      icon = _ref.icon,
      small = _ref.small,
      compact = _ref.compact,
      children = _ref.children,
      loading = _ref.loading,
      accent = _ref.accent,
      buttonProps = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", _objectSpread(_objectSpread({}, buttonProps), {}, {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button), (_clsx = {}, (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_clsx, (_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().small), small), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_clsx, (_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().accent), accent), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_clsx, (_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().compact), compact), _clsx), className),
    ref: ref,
    children: loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_icons_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}) : children
  }));
});
var ButtonText = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      icon = _ref2.icon,
      small = _ref2.small,
      children = _ref2.children,
      buttonProps = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref2, _excluded2);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", _objectSpread(_objectSpread({}, buttonProps), {}, {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button_text), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().small), small), className),
    ref: ref,
    children: children
  }));
});
var ButtonOutline = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
      icon = _ref3.icon,
      children = _ref3.children,
      small = _ref3.small,
      buttonProps = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", _objectSpread(_objectSpread({}, buttonProps), {}, {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button), (_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button_outline), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().small), small), className),
    ref: ref,
    children: children
  }));
});
var ButtonDanger = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
      icon = _ref4.icon,
      children = _ref4.children,
      small = _ref4.small,
      loading = _ref4.loading,
      buttonProps = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref4, _excluded4);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", _objectSpread(_objectSpread({}, buttonProps), {}, {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button), (_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button_danger), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().small), small), className),
    ref: ref,
    children: loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_icons_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}) : children
  }));
});
ButtonOutline.displayName = "ButtonOutline";
Button.displayName = "Button";
ButtonDanger.displayName = "ButtonDanger";

/***/ }),

/***/ 64263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Portal; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./app/hooks/portal.hook.ts

/**
 * Creates DOM element to be used as React root.
 * @returns {HTMLElement}
 */

function createRootElement(id) {
  var rootContainer = document.createElement("div");

  if (id) {
    rootContainer.setAttribute("id", id);
  }

  return rootContainer;
}
/**
 * Appends element as last child of body.
 * @param {HTMLElement} rootElem
 */


function addRootElement(rootElem) {
  var _document$body$lastEl;

  document.body.insertBefore(rootElem, ((_document$body$lastEl = document.body.lastElementChild) === null || _document$body$lastEl === void 0 ? void 0 : _document$body$lastEl.nextElementSibling) || null);
}
/**
 * Hook to create a React Portal.
 * Automatically handles creating and tearing-down the root elements (no SRR
 * makes this trivial), so there is no need to ensure the parent target already
 * exists.
 * @example
 * const target = usePortal(id, [id]);
 * return createPortal(children, target);
 * @param {String} id The id of the target container, e.g 'modal' or 'spotlight'
 * @returns {HTMLElement} The DOM node to use as the Portal target.
 */


var usePortal = function usePortal(id) {
  var _useState = (0,react.useState)(null),
      rootElement = _useState[0],
      setRootElement = _useState[1];

  (0,react.useEffect)(function setupElement() {
    // Look for existing target dom element to append to
    var existingParent = id ? document.querySelector("#".concat(id)) : null; // Parent is either a new root or the existing dom element

    var parentElem = existingParent || createRootElement(id); // If there is no existing DOM element, add a new one.

    if (!existingParent) {
      addRootElement(parentElem);
    }

    if (rootElement) {
      // Add the detached element to the parent
      parentElem.appendChild(rootElement);
    }

    return function removeElement() {
      rootElement === null || rootElement === void 0 ? void 0 : rootElement.remove();

      if (!parentElem.childElementCount) {
        parentElem.remove();
      }
    };
  }, [id]);
  /**
   * It's important we evaluate this lazily:
   * - We need first render to contain the DOM element, so it shouldn't happen
   *   in useEffect. We would normally put this in the constructor().
   * - We can't do 'const rootElemRef = useRef(document.createElement('div))',
   *   since this will run every single render (that's a lot).
   * - We want the ref to consistently point to the same DOM element and only
   *   ever run once.
   * @link https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
   */

  var getRootElem = function getRootElem() {
    if (!rootElement && typeof document !== "undefined") {
      setRootElement(document.createElement("div"));
    }

    return rootElement;
  };

  return getRootElem();
};
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./app/components/ui/portal.tsx



/**
 * @example
 * <Portal id="modal">
 *   <p>Thinking with portals</p>
 * </Portal>
 */
var Portal = function Portal(_ref) {
  var id = _ref.id,
      children = _ref.children;
  var target = usePortal(id);
  return target ? /*#__PURE__*/(0,react_dom.createPortal)(children, target) : null;
};

/***/ }),

/***/ 92862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useAuth; },
/* harmony export */   "s": function() { return /* binding */ AuthUserProvider; }
/* harmony export */ });
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var app_store_slices_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38886);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4062);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var services_hooks_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46725);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64487);
/* harmony import */ var app_utils_db__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43007);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var app_utils_language__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79490);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);











var REDIRECT_KEY = "REDIRECT_KEY";
var AuthUserContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)(null);
var AuthUserProvider = function AuthUserProvider(_ref) {
  var children = _ref.children;

  var _useAppSelector = (0,app_store_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppSelector */ .CG)(app_store_slices_user__WEBPACK_IMPORTED_MODULE_1__/* .selectUserState */ .tH),
      session = _useAppSelector.session,
      deviceId = _useAppSelector.deviceId;

  var dispatch = (0,app_store_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .TL)();
  var timer = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
  var lang = (0,app_utils_language__WEBPACK_IMPORTED_MODULE_7__/* .getNavigatorLanguageForSignUp */ .G3)();

  var clearRefreshTokenTimer = function clearRefreshTokenTimer() {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  };

  var signUp = /*#__PURE__*/function () {
    var _ref2 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(email, password) {
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,services_hooks_services__WEBPACK_IMPORTED_MODULE_4__/* .postPillowUserV2UsersRegister */ .GK)({
                client_id: "meAyv7NWFskWa7JLubMgf3ewckHqdsKETsVaopnw",
                client_key: "HNEKMPbPyxHxdzjTzTVepWwTurnEVPsYfWYxjAtCXzgjueaavwHKmzjXPjcJcoyzEU3rWRqtMbEudyNnNwsTM4sJ9Noqbn7ujyavrFWeqqrrrxsPePagLrE4LXYWbdnX",
                country: lang.substring(lang.lastIndexOf("_") + 1) || "GB",
                email: email,
                password: password
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function signUp(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var signInUser = /*#__PURE__*/function () {
    var _ref3 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(email, password) {
      var response;
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('signInUser', email, password);
              _context2.next = 3;
              return (0,services_hooks_services__WEBPACK_IMPORTED_MODULE_4__/* .postPillowSessionV2SessionCreate */ .K2)({
                client_id: "meAyv7NWFskWa7JLubMgf3ewckHqdsKETsVaopnw",
                client_key: "HNEKMPbPyxHxdzjTzTVepWwTurnEVPsYfWYxjAtCXzgjueaavwHKmzjXPjcJcoyzEU3rWRqtMbEudyNnNwsTM4sJ9Noqbn7ujyavrFWeqqrrrxsPePagLrE4LXYWbdnX",
                device_serial: deviceId,
                email: email,
                password: password
              });

            case 3:
              response = _context2.sent;
              dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_1__/* .userActions.setSession */ .hI.setSession(response.data.data));
              dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_1__/* .userActions.loadFavorites */ .hI.loadFavorites());
              return _context2.abrupt("return", response.data.data);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function signInUser(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var loginwWithToken = /*#__PURE__*/function () {
    var _ref4 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(token, deviceSerial) {
      var response;
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log('loginwWithToken', token, deviceSerial); // const serial = await signIn(0)

              _context3.next = 3;
              return (0,services_hooks_services__WEBPACK_IMPORTED_MODULE_4__/* .postPillowSessionV2SessionLogin_token */ .BT)({
                client_id: "meAyv7NWFskWa7JLubMgf3ewckHqdsKETsVaopnw" || 0,
                client_key: "HNEKMPbPyxHxdzjTzTVepWwTurnEVPsYfWYxjAtCXzgjueaavwHKmzjXPjcJcoyzEU3rWRqtMbEudyNnNwsTM4sJ9Noqbn7ujyavrFWeqqrrrxsPePagLrE4LXYWbdnX" || 0,
                device_serial: deviceSerial || deviceId || '',
                login_token: token
              });

            case 3:
              response = _context3.sent;
              dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_1__/* .userActions.setSession */ .hI.setSession(response.data.data));
              return _context3.abrupt("return", response.data.data);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function loginwWithToken(_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();

  var redirectToFacebookLogin = function redirectToFacebookLogin() {
    window.location.href = "https://www.facebook.com/v14.0/dialog/oauth?" + qs__WEBPACK_IMPORTED_MODULE_6___default().stringify({
      client_id: "158761204309396",
      redirect_uri: "".concat(window.location.origin, "/facebook"),
      response_type: "token",
      scope: "public_profile"
    });
  };

  var fetchUserData = /*#__PURE__*/function () {
    var _ref5 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0,services_hooks_services__WEBPACK_IMPORTED_MODULE_4__/* .getPillowUserV2UsersMe */ .Zj)());

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function fetchUserData() {
      return _ref5.apply(this, arguments);
    };
  }();

  var updateUserData = function updateUserData(response) {
    if (response.data && response.data.data) {
      dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_1__/* .userActions.setUser */ .hI.setUser({
        country: response.data.data.country,
        email: response.data.data.email,
        first_name: response.data.data.first_name,
        id: response.data.data.id,
        last_name: response.data.data.last_name,
        permalink: response.data.data.permalink,
        premium: response.data.data.premium,
        spotify_connect: response.data.data.spotify_connect,
        deezer_connect: response.data.data.deezer_connect
      }));
    }
  };

  var refreshUserData = /*#__PURE__*/function () {
    var _ref6 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5() {
      var response;
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(session !== null && session !== void 0 && session.user)) {
                _context5.next = 10;
                break;
              }

              _context5.prev = 1;
              _context5.next = 4;
              return fetchUserData();

            case 4:
              response = _context5.sent;
              updateUserData(response);
              _context5.next = 10;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 8]]);
    }));

    return function refreshUserData() {
      return _ref6.apply(this, arguments);
    };
  }();

  var resetPassword = /*#__PURE__*/function () {
    var _ref7 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(email) {
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return (0,services_hooks_services__WEBPACK_IMPORTED_MODULE_4__/* .postPillowUserV2UsersPasswordReset */ .PJ)({
                client_id: "meAyv7NWFskWa7JLubMgf3ewckHqdsKETsVaopnw",
                client_key: "HNEKMPbPyxHxdzjTzTVepWwTurnEVPsYfWYxjAtCXzgjueaavwHKmzjXPjcJcoyzEU3rWRqtMbEudyNnNwsTM4sJ9Noqbn7ujyavrFWeqqrrrxsPePagLrE4LXYWbdnX",
                email: email
              });

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function resetPassword(_x7) {
      return _ref7.apply(this, arguments);
    };
  }();

  var signOut = /*#__PURE__*/function () {
    var _ref8 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7() {
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              if (!app_utils_db__WEBPACK_IMPORTED_MODULE_5__.db.isOpen()) {
                _context7.next = 4;
                break;
              }

              _context7.next = 4;
              return app_utils_db__WEBPACK_IMPORTED_MODULE_5__.db.offlineChapters.clear();

            case 4:
              _context7.next = 6;
              return (0,services_hooks_services__WEBPACK_IMPORTED_MODULE_4__/* .postPillowSessionV2SessionLogout */ .Qf)();

            case 6:
              _context7.next = 11;
              break;

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              _sentry_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .captureException */ .Tb(_context7.t0);

            case 11:
              dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_1__/* .userActions.logout */ .hI.logout());

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 8]]);
    }));

    return function signOut() {
      return _ref8.apply(this, arguments);
    };
  }();

  var clearRedirect = function clearRedirect() {
    if (true) {
      window.localStorage.removeItem(REDIRECT_KEY);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(AuthUserContext.Provider, {
    value: {
      signOut: signOut,
      clearRedirect: clearRedirect,
      signInUser: signInUser,
      signUp: signUp,
      resetPassword: resetPassword,
      refreshUserData: refreshUserData,
      redirectToFacebookLogin: redirectToFacebookLogin,
      fetchUserData: fetchUserData,
      updateUserData: updateUserData,
      loginwWithToken: loginwWithToken
    },
    children: children
  });
};
var useAuth = function useAuth() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(AuthUserContext);
  if (value === null) throw new Error("Make sure that you use your hook inside of AuthUserContext");
  return value;
};

/***/ }),

/***/ 91537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CI": function() { return /* binding */ LOCAL_STORAGE_LOCALE_KEY; },
/* harmony export */   "IF": function() { return /* binding */ CountryContextProvider; },
/* harmony export */   "VL": function() { return /* binding */ LOCAL_STORAGE_COUNTRY_KEY; },
/* harmony export */   "jY": function() { return /* binding */ LOCAL_STORAGE_LOCALE_OVERRIDE_KEY; },
/* harmony export */   "o": function() { return /* binding */ useCountryContext; }
/* harmony export */ });
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16835);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var app_hooks_sticky_state_hook__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39428);
/* harmony import */ var app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38886);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4062);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var services_hooks_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90413);
/* harmony import */ var services_hooks_services__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46725);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);
/* provided dependency */ var process = __webpack_require__(83454);











var LOCAL_STORAGE_COUNTRY_KEY = "countryCode-v2";
var LOCAL_STORAGE_LOCALE_KEY = "locale";
var LOCAL_STORAGE_LOCALE_OVERRIDE_KEY = "locale-override";
var CountryContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_5__.createContext)(null);
var CountryContextProvider = function CountryContextProvider(_ref) {
  var _ipBasedCountryData$d;

  var children = _ref.children;
  var dispatch = (0,app_store_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .TL)();

  var _useAppSelector = (0,app_store_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__/* .selectUserState */ .tH),
      session = _useAppSelector.session;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(),
      locale = _useRouter.locale;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false),
      countryValidationLoading = _useState[0],
      setCountryValidationLoading = _useState[1];

  var _useGetPillowV2Countr = (0,services_hooks_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useGetPillowV2Country */ .WQ)({
    enabled: process.env.NEXT_PUBLIC_COUNTRY_CHECK_ON_LOAD === "true",
    retry: 1
  }),
      ipBasedCountryData = _useGetPillowV2Countr.data,
      isIpBasedCounryError = _useGetPillowV2Countr.isError,
      isIpBasedCounryFetched = _useGetPillowV2Countr.isFetched,
      refetch = _useGetPillowV2Countr.refetch;

  var _useStickyState = (0,app_hooks_sticky_state_hook__WEBPACK_IMPORTED_MODULE_1__/* .useStickyState */ .u)(LOCAL_STORAGE_COUNTRY_KEY, {
    countryCode: "gb",
    name: "",
    logo: "",
    permalink: "",
    ip: "",
    preset: true
  }),
      _useStickyState2 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_useStickyState, 2),
      country = _useStickyState2[0],
      setCountry = _useStickyState2[1];

  var _useStickyState3 = (0,app_hooks_sticky_state_hook__WEBPACK_IMPORTED_MODULE_1__/* .useStickyState */ .u)(LOCAL_STORAGE_LOCALE_OVERRIDE_KEY, null),
      _useStickyState4 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_useStickyState3, 2),
      localeOverride = _useStickyState4[0],
      setLocaleOverride = _useStickyState4[1];

  var ipBasedCountryCode = ipBasedCountryData === null || ipBasedCountryData === void 0 ? void 0 : (_ipBasedCountryData$d = ipBasedCountryData.data.data.country) === null || _ipBasedCountryData$d === void 0 ? void 0 : _ipBasedCountryData$d.toLowerCase();
  var ip = (ipBasedCountryData === null || ipBasedCountryData === void 0 ? void 0 : ipBasedCountryData.data.data.ip) || "";
  (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function () {
    function validateCountry() {
      return _validateCountry.apply(this, arguments);
    }

    function _validateCountry() {
      _validateCountry = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var countryResponse, pageData, response, _pageData;

        return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setCountryValidationLoading(true);
                _context.prev = 1;

                if (ipBasedCountryCode) {
                  _context.next = 4;
                  break;
                }

                throw new Error("No response from radioline country endpoint");

              case 4:
                _context.next = 6;
                return (0,services_hooks_services__WEBPACK_IMPORTED_MODULE_7__/* .getPillowCategoryPath */ .it)("categories/radioline_countries/".concat(ipBasedCountryCode), {});

              case 6:
                countryResponse = _context.sent;
                pageData = countryResponse.data.path ? countryResponse.data.path[countryResponse.data.path.length - 1] || null : null;

                if (pageData && pageData.name && pageData.logo && pageData.permalink) {
                  setCountry({
                    countryCode: ipBasedCountryCode,
                    name: pageData.name,
                    logo: pageData.logo,
                    permalink: pageData.permalink,
                    ip: ip,
                    preset: false
                  });
                }

                _context.next = 23;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                _context.prev = 13;
                _context.next = 16;
                return (0,services_hooks_services__WEBPACK_IMPORTED_MODULE_7__/* .getPillowCategoryPath */ .it)("categories/radioline_countries/gb", {});

              case 16:
                response = _context.sent;
                _pageData = response.data.path ? response.data.path[response.data.path.length - 1] || null : null;

                if (_pageData) {
                  if (_pageData.name && _pageData.logo && _pageData.permalink) {
                    setCountry({
                      countryCode: "gb",
                      name: _pageData.name,
                      logo: _pageData.logo,
                      permalink: _pageData.permalink,
                      ip: ip,
                      preset: false
                    });
                  }
                }

                _context.next = 23;
                break;

              case 21:
                _context.prev = 21;
                _context.t1 = _context["catch"](13);

              case 23:
                setCountryValidationLoading(false);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11], [13, 21]]);
      }));
      return _validateCountry.apply(this, arguments);
    }

    if (isIpBasedCounryFetched && !!session) {
      validateCountry();
    }
  }, [ipBasedCountryCode, isIpBasedCounryFetched, !!session]);
  (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function () {
    if (window.localStorage) {
      window.localStorage.setItem(LOCAL_STORAGE_LOCALE_KEY, locale);
    }

    if (ip) {
      dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__/* .userActions.setIP */ .hI.setIP(ip));
    }
  }, [ip, locale]);
  (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function () {
    if (country.preset) {
      refetch();
    }
  }, [country]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(CountryContext.Provider, {
    value: {
      country: country,
      setCountry: setCountry,
      setLocaleOverride: setLocaleOverride,
      localeOverride: localeOverride
    },
    children: children
  });
};
var useCountryContext = function useCountryContext() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(CountryContext);
  if (value === null) throw new Error("Make sure that you use your hook inside of CountryContext");
  return value;
};

/***/ }),

/***/ 10833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pp": function() { return /* binding */ useFeaturesContext; },
/* harmony export */   "mO": function() { return /* binding */ FeaturesContextProvider; }
/* harmony export */ });
/* unused harmony exports LOCAL_STORAGE_COUNTRY_KEY, LOCAL_STORAGE_LOCALE_KEY */
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16835);
/* harmony import */ var app_hooks_sticky_state_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39428);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/* provided dependency */ var process = __webpack_require__(83454);




var LOCAL_STORAGE_COUNTRY_KEY = "countryCode";
var LOCAL_STORAGE_LOCALE_KEY = "locale";
var FeaturesContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var FeaturesContextProvider = function FeaturesContextProvider(_ref) {
  var children = _ref.children;
  var downloadFeatureEnabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "false" === "true";
  }, []);
  var arrowNavigationEnabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "false" === "true";
  }, []);
  var customVirtualKeyboardEnabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_CUSTOM_VIRTUAL_KEYBOARD === "true";
  }, []);
  var demoVersion = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_DEMO_VERSION === "true";
  }, []);
  var showFooter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "true" === "true";
  }, []);
  var forceMediaSession = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_FORCE_MEDIASESSION === "true";
  }, []);
  var forceAutoplayFeatureEnabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_FORCE_AUTOPLAY === "true";
  }, []);
  var showRadioWebsite = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "true" === "true";
  }, []);
  var premiumVersion = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_PREMIUM_VERSION === "true";
  }, []);
  var showAddDevice = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "true" === "true";
  }, []);
  var showInstallApp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "true" === "true";
  }, []);
  var targetspotEnabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "true" === "true";
  }, []);
  var targetspotStaging = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_TARGETSPOT_STAGING === "true";
  }, []);
  var targetspotUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "https://api.tsbluebox.com/80/vast/3.0/";
  }, []);
  var audioDotsPublisherId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_AV_PUBLISHERID;
  }, []);
  var audioDotsChannelId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_AV_CHANNELID;
  }, []);
  var audioDotsEnabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return !!audioDotsPublisherId && !!audioDotsChannelId;
  }, [audioDotsPublisherId, audioDotsChannelId]);
  var vlybyPublisherId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "bPjRybOkIdzkJe2tGnhkWp";
  }, []);
  var showQRCode = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "false" === "true";
  }, []);
  var exitConfirmationPopupEnabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_EXIT_CONFIRMATION === "true";
  }, []);
  var hideScrollbars = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "false" === "true";
  }, []);
  var targetspotApikey = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "f849cb09-b11a-492f-a371-bb81d39b2993";
  }, []);
  var facebookLoginEnabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return !!"158761204309396";
  }, []);
  var disableDeleteAccount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_DISABLE_DELETE_ACCOUNT === "true";
  }, []);
  var isCarMode = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return process.env.NEXT_PUBLIC_CAR_MODE === "true";
  }, []);
  var isHTTPModeEnabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "true" === "true";
  }, []);

  var _useStickyState = (0,app_hooks_sticky_state_hook__WEBPACK_IMPORTED_MODULE_0__/* .useStickyState */ .u)("AUTOPLAY_FEATURE_ENABLED", forceAutoplayFeatureEnabled),
      _useStickyState2 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useStickyState, 2),
      forceAutoplay = _useStickyState2[0],
      setForceAutoPlay = _useStickyState2[1];

  var _useStickyState3 = (0,app_hooks_sticky_state_hook__WEBPACK_IMPORTED_MODULE_0__/* .useStickyState */ .u)("OFFLINE_FEATURE_ENABLED", downloadFeatureEnabled),
      _useStickyState4 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useStickyState3, 2),
      downloadEnabled = _useStickyState4[0],
      setDownloadEnabled = _useStickyState4[1];

  var targetspotActive = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return !!targetspotEnabled && !!targetspotUrl && !!targetspotApikey;
  }, [targetspotEnabled, targetspotUrl, targetspotApikey]);
  var appVersion = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return "1.0";
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(FeaturesContext.Provider, {
    value: {
      audioDotsEnabled: audioDotsEnabled,
      customVirtualKeyboardEnabled: customVirtualKeyboardEnabled,
      audioDotsPublisherId: audioDotsPublisherId,
      exitConfirmationPopupEnabled: exitConfirmationPopupEnabled,
      audioDotsChannelId: audioDotsChannelId,
      vlybyPublisherId: vlybyPublisherId,
      downloadEnabled: downloadEnabled,
      arrowNavigationEnabled: arrowNavigationEnabled,
      showFooter: showFooter,
      demoVersion: demoVersion,
      appVersion: appVersion,
      facebookLoginEnabled: facebookLoginEnabled,
      forceAutoplay: forceAutoplay,
      forceMediaSession: forceMediaSession,
      targetspotStaging: targetspotStaging,
      setForceAutoPlay: setForceAutoPlay,
      setDownloadEnabled: setDownloadEnabled,
      premiumVersion: premiumVersion,
      showRadioWebsite: showRadioWebsite,
      showAddDevice: showAddDevice,
      showInstallApp: showInstallApp,
      targetspotApikey: targetspotApikey,
      targetspotUrl: targetspotUrl,
      targetspotEnabled: targetspotActive,
      showQRCode: showQRCode,
      hideScrollbars: hideScrollbars,
      disableDeleteAccount: disableDeleteAccount,
      isCarMode: isCarMode,
      isHTTPModeEnabled: isHTTPModeEnabled
    },
    children: children
  });
};
var useFeaturesContext = function useFeaturesContext() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(FeaturesContext);
  if (value === null) throw new Error("Make sure that you use your hook inside of FeaturesContext");
  return value;
};

/***/ }),

/***/ 85655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j$": function() { return /* binding */ NavigationContextProvider; },
  "QR": function() { return /* binding */ useNavigationContext; }
});

// UNUSED EXPORTS: LOCAL_STORAGE_COUNTRY_KEY, LOCAL_STORAGE_LOCALE_KEY

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./app/components/ui/button.component.tsx
var button_component = __webpack_require__(61947);
// EXTERNAL MODULE: ./app/components/ui/portal.tsx + 1 modules
var portal = __webpack_require__(64263);
// EXTERNAL MODULE: ./app/components/exit-confirmation/exit-confirmation.module.scss
var exit_confirmation_module = __webpack_require__(44156);
var exit_confirmation_module_default = /*#__PURE__*/__webpack_require__.n(exit_confirmation_module);
// EXTERNAL MODULE: ./app/hooks/keyboard-navigation.hook.ts
var keyboard_navigation_hook = __webpack_require__(36158);
// EXTERNAL MODULE: ./app/hooks/modal-scroll.hook.ts
var modal_scroll_hook = __webpack_require__(76299);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useEffectOnce.js
var useEffectOnce = __webpack_require__(18127);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/exit-confirmation/exit-confirmation.component.tsx










var ExitConfirmation = function ExitConfirmation(_ref) {
  var onClose = _ref.onClose;
  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)();
  var noButtonRef = (0,react.useRef)(null);
  (0,modal_scroll_hook/* default */.Z)();
  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("ExitConfirmation", goBackCallback);
  (0,useEffectOnce/* default */.Z)(function () {
    var _noButtonRef$current;

    (_noButtonRef$current = noButtonRef.current) === null || _noButtonRef$current === void 0 ? void 0 : _noButtonRef$current.focus();
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(portal/* Portal */.h, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (exit_confirmation_module_default()).wrapper,
      ref: wrapperRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (exit_confirmation_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (exit_confirmation_module_default()).title,
          children: "Are you sure you want to exit? "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (exit_confirmation_module_default()).action_wrapper,
          "data-navigate-row": true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* ButtonOutline */.Ig, {
            ref: noButtonRef,
            small: true,
            "data-navigate-item": true,
            onClick: function onClick() {
              return onClose();
            },
            children: "No"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* ButtonOutline */.Ig, {
            small: true,
            "data-navigate-item": true,
            onClick: function onClick() {
              try {
                console.log("CLOSE APP");
                window.close();
              } catch (e) {
                console.error(e);
              }
            },
            children: "Yes"
          })]
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ./app/context/navigation.context.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var LOCAL_STORAGE_COUNTRY_KEY = "countryCode";
var LOCAL_STORAGE_LOCALE_KEY = "locale";
var NavigationContext = /*#__PURE__*/(0,react.createContext)(null);
var NavigationContextProvider = function NavigationContextProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)({}),
      stack = _useState[0],
      setStack = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showConfirmation = _useState2[0],
      setShowConfirmation = _useState2[1];

  var setIdActive = function setIdActive(id, active) {
    setStack(function (value) {
      return _objectSpread(_objectSpread({}, value), {}, (0,defineProperty/* default */.Z)({}, id, active));
    });
  };

  var removeId = function removeId(id) {
    var newStack = _objectSpread({}, stack);

    delete newStack[id];
    setStack(newStack);
  };

  var isOverlayPresent = Object.keys(stack).reduce(function (isPresent, stackKey) {
    return isPresent || stack[stackKey];
  }, false);

  var showExitConfirmationPopup = function showExitConfirmationPopup() {
    setShowConfirmation(true);
  };

  var closeExitConfirmationCallback = (0,react.useCallback)(function () {
    return setShowConfirmation(false);
  }, [setShowConfirmation]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationContext.Provider, {
    value: {
      setIdActive: setIdActive,
      removeId: removeId,
      isOverlayPresent: isOverlayPresent,
      showExitConfirmationPopup: showExitConfirmationPopup
    },
    children: [children, showConfirmation && /*#__PURE__*/(0,jsx_runtime.jsx)(ExitConfirmation, {
      onClose: closeExitConfirmationCallback
    })]
  });
};
var useNavigationContext = function useNavigationContext() {
  var value = (0,react.useContext)(NavigationContext);
  if (value === null) throw new Error("Make sure that you use your hook inside of NavigationContext");
  return value;
};

/***/ }),

/***/ 85889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dU": function() { return /* binding */ OfflineContextProvider; },
/* harmony export */   "tw": function() { return /* binding */ useOfflineContext; }
/* harmony export */ });
/* unused harmony exports LOCAL_STORAGE_COUNTRY_KEY, LOCAL_STORAGE_LOCALE_KEY */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var app_utils_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43007);
/* harmony import */ var dexie_react_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37248);
/* harmony import */ var dexie_react_hooks__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dexie_react_hooks__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _features_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10833);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var LOCAL_STORAGE_COUNTRY_KEY = "countryCode";
var LOCAL_STORAGE_LOCALE_KEY = "locale";
var OfflineContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var OfflineContextProvider = function OfflineContextProvider(_ref) {
  var children = _ref.children;

  var _useFeaturesContext = (0,_features_context__WEBPACK_IMPORTED_MODULE_3__/* .useFeaturesContext */ .Pp)(),
      setDownloadEnabled = _useFeaturesContext.setDownloadEnabled,
      downloadEnabled = _useFeaturesContext.downloadEnabled;

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (downloadEnabled) {
      app_utils_db__WEBPACK_IMPORTED_MODULE_1__.db.open();
    } else {
      if (app_utils_db__WEBPACK_IMPORTED_MODULE_1__.db.isOpen()) {
        app_utils_db__WEBPACK_IMPORTED_MODULE_1__.db.close();
      }
    }
  }, [downloadEnabled]);
  var offlineChapters = (0,dexie_react_hooks__WEBPACK_IMPORTED_MODULE_2__.useLiveQuery)(function () {
    return downloadEnabled && true ? app_utils_db__WEBPACK_IMPORTED_MODULE_1__.db.offlineChapters.toArray().catch(function (e) {
      _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(e);
      setDownloadEnabled(false);
      return [];
    }) : [];
  }, [downloadEnabled]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(OfflineContext.Provider, {
    value: {
      offlineChapters: offlineChapters
    },
    children: children
  });
};
var useOfflineContext = function useOfflineContext() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(OfflineContext);
  if (value === null) throw new Error("Make sure that you use your hook inside of OfflineContext");
  return value;
};

/***/ }),

/***/ 48346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ld": function() { return /* binding */ VLYBY_AD_ERROR_TIMEOUT; },
/* harmony export */   "QM": function() { return /* binding */ PlayerContextProvider; },
/* harmony export */   "UU": function() { return /* binding */ VLYBY_TIMEOUT; },
/* harmony export */   "gD": function() { return /* binding */ usePlayerContext; }
/* harmony export */ });
/* unused harmony exports LOCAL_STORAGE_COUNTRY_KEY, LOCAL_STORAGE_LOCALE_KEY */
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var app_store_slices_player__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22564);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4062);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var services_hooks_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90413);
/* harmony import */ var _features_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10833);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6765);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);









var LOCAL_STORAGE_COUNTRY_KEY = "countryCode";
var LOCAL_STORAGE_LOCALE_KEY = "locale";
var VLYBY_TIMEOUT = 3 * 60000;
var VLYBY_AD_ERROR_TIMEOUT = 12000;
var PlayerContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)(null);
var PlayerContextProvider = function PlayerContextProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      fullscreenPlayerInitialyOpen = _useState[0],
      setFullscreenPlayerInitialyOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      playerEnabled = _useState2[0],
      setPlayerEnabled = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      httpMode = _useState3[0],
      setHttpMode = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isPlaying = _useState4[0],
      setIsPlaying = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isMediaLoading = _useState5[0],
      setIsMediaLoading = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null),
      duration = _useState6[0],
      setDuration = _useState6[1];

  var dispatch = (0,app_store_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .TL)();

  var _useGetPillowAdvertis = (0,services_hooks_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useGetPillowAdvertisingTargetspot */ .Rj)({
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 1
  }),
      config = _useGetPillowAdvertis.data;

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      globalAdCloseTime = _useState7[0],
      setGlobalAdCloseTime = _useState7[1];

  var checkGlobalTimer = function checkGlobalTimer() {
    return Date.now() - globalAdCloseTime >= VLYBY_TIMEOUT;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    dispatch(app_store_slices_player__WEBPACK_IMPORTED_MODULE_1__/* .playerActions.setTargetspoConfig */ .i9.setTargetspoConfig((config === null || config === void 0 ? void 0 : config.data) || null));
  }, [config === null || config === void 0 ? void 0 : config.data]);

  var _useFeaturesContext = (0,_features_context__WEBPACK_IMPORTED_MODULE_5__/* .useFeaturesContext */ .Pp)(),
      audioDotsEnabled = _useFeaturesContext.audioDotsEnabled;

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    playerConstructor: null
  }),
      audioDots = _useState8[0],
      setAudioDots = _useState8[1];

  var defaultPrice = {
    amount: "4.99",
    currency: "EUR",
    currency_symbol: "€"
  };

  var _useGetPillowBillingS = (0,services_hooks_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useGetPillowBillingStripeV2Price */ .jd)(),
      priceDataRaw = _useGetPillowBillingS.data;

  var priceData = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
    var _priceDataRaw$data, _priceDataRaw$data2;

    if (!(priceDataRaw !== null && priceDataRaw !== void 0 && (_priceDataRaw$data = priceDataRaw.data) !== null && _priceDataRaw$data !== void 0 && _priceDataRaw$data.data)) {
      return defaultPrice;
    }

    var newPrice = priceDataRaw === null || priceDataRaw === void 0 ? void 0 : (_priceDataRaw$data2 = priceDataRaw.data) === null || _priceDataRaw$data2 === void 0 ? void 0 : _priceDataRaw$data2.data;
    return {
      amount: newPrice.amount || defaultPrice.amount,
      currency: newPrice.currency || defaultPrice.currency,
      currency_symbol: newPrice.currency_symbol || defaultPrice.currency_symbol
    };
  }, [priceDataRaw === null || priceDataRaw === void 0 ? void 0 : priceDataRaw.data]);
  var networkState = (0,react_use__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
  var refetchMetadataInterval = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
    if (networkState.effectiveType) {
      if (["2g", "slow-2g"].includes(networkState.effectiveType)) {
        return 15000;
      }

      if (["3g"].includes(networkState.effectiveType)) {
        return 10000;
      }
    }

    return 5000;
  }, [networkState]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(PlayerContext.Provider, {
    value: {
      audioDots: audioDots,
      fullscreenPlayerInitialyOpen: fullscreenPlayerInitialyOpen,
      setFullscreenPlayerInitialyOpen: setFullscreenPlayerInitialyOpen,
      playerEnabled: playerEnabled,
      isPlaying: isPlaying,
      duration: duration,
      setDuration: setDuration,
      setIsPlaying: setIsPlaying,
      setIsMediaLoading: setIsMediaLoading,
      isMediaLoading: isMediaLoading,
      setPlayerEnabled: setPlayerEnabled,
      globalAdCloseTime: globalAdCloseTime,
      setGlobalAdCloseTime: setGlobalAdCloseTime,
      checkGlobalTimer: checkGlobalTimer,
      httpMode: httpMode,
      setHttpMode: setHttpMode,
      refetchMetadataInterval: refetchMetadataInterval,
      priceData: priceData
    },
    children: [audioDotsEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: "aniplayer",
      src: "https://player.aniview.com/script/6.1/aniview.js?v=1&type=s&pid=619cb5b8553c9019897ec945" //${audioDotsPublisherId}
      ,
      onLoad: function onLoad() {
        setAudioDots({
          playerConstructor: window.avPlayer
        });
      }
    }), children]
  });
};
var usePlayerContext = function usePlayerContext() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(PlayerContext);
  if (value === null) throw new Error("Make sure that you use your hook inside of PlayerContext");
  return value;
};

/***/ }),

/***/ 5451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ VirtualKeyboardContextProvider; },
/* harmony export */   "z": function() { return /* binding */ useVirtualKeyboardContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var VirtualKeyboardContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var VirtualKeyboardContextProvider = function VirtualKeyboardContextProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      activeInput = _useState[0],
      setActiveInput = _useState[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VirtualKeyboardContext.Provider, {
    value: {
      activeInput: activeInput,
      setActiveInput: setActiveInput
    },
    children: children
  });
};
var useVirtualKeyboardContext = function useVirtualKeyboardContext() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(VirtualKeyboardContext);
  if (value === null) throw new Error("Make sure that you use your hook inside of VirtualKeyboardContext");
  return value;
};

/***/ }),

/***/ 71014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useGoBackEvent; },
/* harmony export */   "J": function() { return /* binding */ useGoBackHistory; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66741);
/* harmony import */ var app_context_features_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10833);
/* harmony import */ var app_context_navigation_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77823);
/* harmony import */ var _keyboard_navigation_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36158);
/* harmony import */ var _navigation_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26793);







var useGoBackHistory = function useGoBackHistory(readableId) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _useNavigationContext = (0,app_context_navigation_context__WEBPACK_IMPORTED_MODULE_1__/* .useNavigationContext */ .QR)(),
      isOverlayPresent = _useNavigationContext.isOverlayPresent;

  var navigateBack = (0,_navigation_hook__WEBPACK_IMPORTED_MODULE_4__/* .useNavigateBack */ .ub)();
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var eventHandler = function eventHandler(event) {
      if (event.key === "Escape" || event.keyCode === _keyboard_navigation_hook__WEBPACK_IMPORTED_MODULE_3__/* .WEBOS_BACK */ .Nx || window["VK_BACK_SPACE"] && event.keyCode === window["VK_BACK_SPACE"] || window["VK_BACK"] && event.keyCode === window["VK_BACK"]) {
        navigateBack();
        event.preventDefault();
        event.stopPropagation();
      }
    };

    if (!isOverlayPresent) {
      document.addEventListener("keydown", eventHandler);
    } else {
      document.removeEventListener("keydown", eventHandler);
    }

    return function () {
      return document.removeEventListener("keydown", eventHandler);
    };
  }, [enabled, isOverlayPresent]);
};
var useGoBackEvent = function useGoBackEvent(readableId, onGoBack) {
  var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var triggerOnArrowNavigationOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var id = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)("".concat(readableId).concat((0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .nanoid */ .x0)()));
  var features = (0,app_context_features_context__WEBPACK_IMPORTED_MODULE_0__/* .useFeaturesContext */ .Pp)();

  var _useNavigationContext2 = (0,app_context_navigation_context__WEBPACK_IMPORTED_MODULE_1__/* .useNavigationContext */ .QR)(),
      setIdActive = _useNavigationContext2.setIdActive,
      removeId = _useNavigationContext2.removeId;

  var shouldTrigger = enabled && (triggerOnArrowNavigationOnly ? features.arrowNavigationEnabled : true);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    setIdActive(id.current, shouldTrigger);
  }, [shouldTrigger]);
  (0,react_use__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function () {
    removeId(id.current);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var eventHandler = function eventHandler(event) {
      if (event.key === "Escape" || event.keyCode === _keyboard_navigation_hook__WEBPACK_IMPORTED_MODULE_3__/* .WEBOS_BACK */ .Nx || window["VK_BACK_SPACE"] && event.keyCode === window["VK_BACK_SPACE"] || window["VK_BACK"] && event.keyCode === window["VK_BACK"]) {
        onGoBack();
        event.preventDefault();
        event.stopPropagation();
      }
    };

    if (shouldTrigger) {
      document.addEventListener("keydown", eventHandler);
    } else {
      document.removeEventListener("keydown", eventHandler);
    }

    return function () {
      document.removeEventListener("keydown", eventHandler);
    };
  }, [shouldTrigger, onGoBack]);
  return id.current;
};

/***/ }),

/***/ 36158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jz": function() { return /* binding */ useArrowKeyNavigation; },
/* harmony export */   "Nx": function() { return /* binding */ WEBOS_BACK; },
/* harmony export */   "Sy": function() { return /* binding */ useArrowKeyNavigationOverlay; },
/* harmony export */   "Uy": function() { return /* binding */ WEBOS_PLAY; },
/* harmony export */   "b_": function() { return /* binding */ WEBOS_PAUSE; }
/* harmony export */ });
/* unused harmony exports NAVIGATION_OVERLAY_ATTRIBUTE, NAVIGATION_LAST_ACTIVE_ITEM_ATTRIBUTE, NAVIGATION_LAST_ACTIVE_ROW_ATTRIBUTE, NAVIGATION_ITEM_ATTRIBUTE, NAVIGATION_ROW_ATTRIBUTE, NAVIGATION_ROW_SELECTOR, NAVIGATION_GRID_ATTRIBUTE, NAVIGATION_GRID_SELECTOR, NAVIGATION_SYNC_SCROLL_POSITION_ATTRIBUTE, NAVIGATION_LAST_ACTIVE_ITEM_SELECTOR, NAVIGATION_LAST_ACTIVE_ROW_SELECTOR, NAVIGATION_ITEM_SELECTOR, WEBOS_FAST_FORWARD, WEBOS_REWIND, WEBOS_STOP, default */
/* harmony import */ var _context_virtual_keyboard_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5451);
/* harmony import */ var app_context_features_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10833);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var NAVIGATION_OVERLAY_ATTRIBUTE = "data-navigate-overlay";
var NAVIGATION_LAST_ACTIVE_ITEM_ATTRIBUTE = "data-navigate-last-active-item";
var NAVIGATION_LAST_ACTIVE_ROW_ATTRIBUTE = "data-navigate-last-active-row";
var NAVIGATION_ITEM_ATTRIBUTE = "data-navigate-item";
var NAVIGATION_ROW_ATTRIBUTE = "data-navigate-row";
var NAVIGATION_ROW_SELECTOR = "[".concat(NAVIGATION_ROW_ATTRIBUTE, "=\"true\"]");
var NAVIGATION_GRID_ATTRIBUTE = "data-navigate-grid";
var NAVIGATION_GRID_SELECTOR = "[".concat(NAVIGATION_GRID_ATTRIBUTE, "=\"true\"]");
var NAVIGATION_SYNC_SCROLL_POSITION_ATTRIBUTE = "data-sync-scroll-position";
var NAVIGATION_LAST_ACTIVE_ITEM_SELECTOR = "[".concat(NAVIGATION_LAST_ACTIVE_ITEM_ATTRIBUTE, "=\"true\"]");
var NAVIGATION_LAST_ACTIVE_ROW_SELECTOR = "[".concat(NAVIGATION_LAST_ACTIVE_ROW_ATTRIBUTE, "=\"true\"]");
var NAVIGATION_ITEM_SELECTOR = "[".concat(NAVIGATION_ITEM_ATTRIBUTE, "=\"true\"]");
var WEBOS_PLAY = 415;
var WEBOS_PAUSE = 19;
var WEBOS_FAST_FORWARD = 417;
var WEBOS_REWIND = 412;
var WEBOS_STOP = 413;
var WEBOS_BACK = 461;
function useArrowKeyNavigationOverlay() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var parentNode = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (active) {
      var _parentNode$current;

      (_parentNode$current = parentNode.current) === null || _parentNode$current === void 0 ? void 0 : _parentNode$current.setAttribute(NAVIGATION_OVERLAY_ATTRIBUTE, document.querySelectorAll("[".concat(NAVIGATION_OVERLAY_ATTRIBUTE, "]")).length.toString());
    } else {
      var _parentNode$current2, _parentNode$current3, _parentNode$current4;

      (_parentNode$current2 = parentNode.current) === null || _parentNode$current2 === void 0 ? void 0 : _parentNode$current2.removeAttribute(NAVIGATION_OVERLAY_ATTRIBUTE);
      Array.from(((_parentNode$current3 = parentNode.current) === null || _parentNode$current3 === void 0 ? void 0 : _parentNode$current3.querySelectorAll(NAVIGATION_LAST_ACTIVE_ROW_SELECTOR)) || []).forEach(function (item) {
        item.removeAttribute(NAVIGATION_LAST_ACTIVE_ROW_ATTRIBUTE);
      });
      Array.from(((_parentNode$current4 = parentNode.current) === null || _parentNode$current4 === void 0 ? void 0 : _parentNode$current4.querySelectorAll(NAVIGATION_LAST_ACTIVE_ITEM_SELECTOR)) || []).forEach(function (item) {
        item.removeAttribute(NAVIGATION_LAST_ACTIVE_ITEM_ATTRIBUTE);
      });
    }
  }, [active]);
  return parentNode;
}
/**
 * A react hook to enable arrow key navigation on a component.
 * @returns a useRef, which can be applied to a component
 */

function useArrowKeyNavigation() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var _useFeaturesContext = (0,app_context_features_context__WEBPACK_IMPORTED_MODULE_1__/* .useFeaturesContext */ .Pp)(),
      arrowNavigationEnabled = _useFeaturesContext.arrowNavigationEnabled,
      customVirtualKeyboardEnabled = _useFeaturesContext.customVirtualKeyboardEnabled;

  var _useVirtualKeyboardCo = (0,_context_virtual_keyboard_context__WEBPACK_IMPORTED_MODULE_0__/* .useVirtualKeyboardContext */ .z)(),
      setActiveInput = _useVirtualKeyboardCo.setActiveInput;

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (active) {
      var eventHandler = function eventHandler(event) {
        handleEvents({
          event: event,
          showKeyboardCallback: function showKeyboardCallback(element) {
            if (arrowNavigationEnabled) {
              if (window["Hisense_enableVKB"]) {
                window.Hisense_enableVKB();
              } else if (customVirtualKeyboardEnabled) {
                setActiveInput(element);
                element.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                });
              }
            }
          }
        });
      };

      document.addEventListener("keydown", eventHandler);
      return function () {
        console.log("UNMOUNTING useArrowKeyNavigation");
        document.removeEventListener("keydown", eventHandler);
      };
    }
  }, [active]);
}

function focusItem(item) {
  item.setAttribute(NAVIGATION_LAST_ACTIVE_ITEM_ATTRIBUTE, "true");
  item.focus({
    preventScroll: true
  });
}

function scrollRowIntoView(item) {
  if (item && !item.getAttribute("noscroll")) {
    item.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }
}

function hasGridWrapper(row) {
  if (row) {
    var closestGrid = row.closest(NAVIGATION_GRID_SELECTOR);
    return (closestGrid === null || closestGrid === void 0 ? void 0 : closestGrid.getAttribute(NAVIGATION_GRID_ATTRIBUTE)) === "true";
  }

  return false;
}

function handleKeyPress(_ref) {
  var parentNode = _ref.parentNode,
      event = _ref.event,
      activeItemIndex = _ref.activeItemIndex,
      activeRowItems = _ref.activeRowItems,
      availableRows = _ref.availableRows,
      activeRowIndex = _ref.activeRowIndex,
      activeItem = _ref.activeItem,
      showKeyboardCallback = _ref.showKeyboardCallback;

  if (event.key === "Enter" || event.keyCode === 13 || window["VK_ENTER"] && event.keyCode === window["VK_ENTER"]) {
    if (activeItemIndex === -1) return;

    try {
      var path = event === null || event === void 0 ? void 0 : event.composedPath();
      console.log("Enter pressed, composedPath: ", path);
      console.log("Active element:", document.activeElement, path[0].nodeName);

      if (path[0].nodeName !== "INPUT" && path[0].nodeName !== "TEXTAREA") {
        activeItem === null || activeItem === void 0 ? void 0 : activeItem.click();
        event.preventDefault();
      } else if (activeItem) {
        showKeyboardCallback(activeItem);
      }
    } catch (e) {
      activeItem === null || activeItem === void 0 ? void 0 : activeItem.click();
    }
  } else {
    var activeRow = availableRows[activeRowIndex];
    var nextItem = null;

    if (event.key === "ArrowDown" || event.keyCode === 40 || window["VK_DOWN"] && event.keyCode === window["VK_DOWN"]) {
      var nextRow = availableRows[activeRowIndex + 1];

      if (nextRow) {
        var _availableRows$active;

        var nextRowItems = Array.from(nextRow.querySelectorAll(NAVIGATION_ITEM_SELECTOR));
        var lastActiveRow = parentNode.querySelector(NAVIGATION_LAST_ACTIVE_ROW_SELECTOR);

        if (lastActiveRow) {
          lastActiveRow.removeAttribute(NAVIGATION_LAST_ACTIVE_ROW_ATTRIBUTE);
        }

        nextRow.setAttribute(NAVIGATION_LAST_ACTIVE_ROW_ATTRIBUTE, "true");
        var previousActiveItem = nextRow.querySelector(NAVIGATION_LAST_ACTIVE_ITEM_SELECTOR);
        var nextRowSyncPositionId = nextRow.getAttribute(NAVIGATION_SYNC_SCROLL_POSITION_ATTRIBUTE);
        var activeRowSyncPositionId = (_availableRows$active = availableRows[activeRowIndex]) === null || _availableRows$active === void 0 ? void 0 : _availableRows$active.getAttribute(NAVIGATION_SYNC_SCROLL_POSITION_ATTRIBUTE);

        if (hasGridWrapper(nextRow) && hasGridWrapper(activeRow)) {
          var rowsRelation = nextRowItems.length / activeRowItems.length;
          var nextMappedIndex = rowsRelation * activeItemIndex;
          var nextRowItemIndex = Math.round(nextMappedIndex);
          nextItem = nextRowItems[nextRowItemIndex < 0 ? 0 : nextRowItemIndex >= nextRowItems.length ? nextRowItems.length - 1 : nextRowItemIndex];
        } else {
          if (nextRowSyncPositionId && activeRowSyncPositionId && nextRowSyncPositionId === activeRowSyncPositionId && activeItemIndex > 0 && activeItemIndex < nextRowItems.length) {
            nextItem = nextRowItems[activeItemIndex];
          } else {
            if (previousActiveItem) {
              nextItem = previousActiveItem;
            } else if (nextRowItems[0]) {
              nextItem = nextRowItems[0];
            }
          }
        }

        if (nextItem) {
          scrollRowIntoView(nextItem);
        }
      }
    }

    if (event.key === "ArrowUp" || event.keyCode === 38 || window["VK_UP"] && event.keyCode === window["VK_UP"]) {
      var previousRow = availableRows[activeRowIndex - 1];

      if (previousRow) {
        var previousRowItems = Array.from(previousRow.querySelectorAll(NAVIGATION_ITEM_SELECTOR));

        var _lastActiveRow = parentNode.querySelector(NAVIGATION_LAST_ACTIVE_ROW_SELECTOR);

        if (_lastActiveRow) {
          _lastActiveRow.removeAttribute(NAVIGATION_LAST_ACTIVE_ROW_ATTRIBUTE);
        }

        previousRow.setAttribute(NAVIGATION_LAST_ACTIVE_ROW_ATTRIBUTE, "true");

        var _previousActiveItem = previousRow.querySelector("[".concat(NAVIGATION_LAST_ACTIVE_ITEM_ATTRIBUTE, "]"));

        var previousRowSyncPositionId = previousRow.getAttribute(NAVIGATION_SYNC_SCROLL_POSITION_ATTRIBUTE);

        var _activeRowSyncPositionId = availableRows[activeRowIndex].getAttribute(NAVIGATION_SYNC_SCROLL_POSITION_ATTRIBUTE);

        if (hasGridWrapper(previousRow) && hasGridWrapper(activeRow)) {
          var _rowsRelation = previousRowItems.length / activeRowItems.length;

          var previousMappedIndex = _rowsRelation * activeItemIndex;
          var previousRowItemIndex = Math.round(previousMappedIndex);
          nextItem = previousRowItems[previousRowItemIndex < 0 ? 0 : previousRowItemIndex >= previousRowItems.length ? previousRowItems.length - 1 : previousRowItemIndex];
        } else {
          if (previousRowSyncPositionId && _activeRowSyncPositionId && previousRowSyncPositionId === _activeRowSyncPositionId && activeItemIndex > 0 && activeItemIndex < previousRowItems.length) {
            nextItem = previousRowItems[activeItemIndex];
          } else {
            if (_previousActiveItem) {
              nextItem = _previousActiveItem;
            } else if (previousRowItems[0]) {
              nextItem = previousRowItems[0];
            }
          }
        }

        if (nextItem) {
          scrollRowIntoView(nextItem);
        }
      }
    }

    if (event.key === "ArrowRight" || event.keyCode === 39 || window["VK_RIGHT"] && event.keyCode === window["VK_RIGHT"]) {
      if (activeItemIndex < activeRowItems.length - 1) {
        var width = activeRowItems[activeItemIndex + 1].clientWidth;

        if (activeRow.dataset.navigateScrollable) {
          if (activeRow.dataset.navigateScrollableParent && activeRow.parentNode) {
            activeRow.parentNode.scrollTo({
              left: width * (activeItemIndex + 1),
              behavior: "smooth"
            });
          } else {
            activeRow.scrollTo({
              left: width * (activeItemIndex + 1),
              behavior: "smooth"
            });
          }
        }

        nextItem = activeRowItems[activeItemIndex + 1];
        activeItem === null || activeItem === void 0 ? void 0 : activeItem.removeAttribute(NAVIGATION_LAST_ACTIVE_ITEM_ATTRIBUTE);
      }
    }

    if (event.key === "ArrowLeft" || event.keyCode === 37 || window["VK_LEFT"] && event.keyCode === window["VK_LEFT"]) {
      if (activeItemIndex > 0) {
        var _width = activeRowItems[activeItemIndex - 1].clientWidth;

        if (activeRow.dataset.navigateScrollable) {
          if (activeRow.dataset.navigateScrollableParent && activeRow.parentNode) {
            activeRow.parentNode.scrollTo({
              left: (activeItemIndex - 1) * _width,
              behavior: "smooth"
            });
          } else {
            activeRow.scrollTo({
              left: (activeItemIndex - 1) * _width,
              behavior: "smooth"
            });
          }
        }

        nextItem = activeRowItems[activeItemIndex - 1];
        activeItem === null || activeItem === void 0 ? void 0 : activeItem.removeAttribute(NAVIGATION_LAST_ACTIVE_ITEM_ATTRIBUTE);
      }
    }

    if (nextItem) {
      focusItem(nextItem);
    }
  }

  event.preventDefault();
}
/**
 * Implement arrow key navigation for the given parentNode
 * @param {object}  options
 * @param {Event}   options.e          Keydown event
 * @param {DOMNode} options.parentNode The parent node to operate on. Arrow keys won't navigate outside of this node
 * @param {String}  options.selectors  Selectors for elements we want to be able to key through
 */


function handleEvents(_ref2) {
  var event = _ref2.event,
      showKeyboardCallback = _ref2.showKeyboardCallback;
  // console.log("KEYBOARD_EVENT", event.key, event.keyCode);
  var overlays = Array.from(document.querySelectorAll("[".concat(NAVIGATION_OVERLAY_ATTRIBUTE, "]")));
  var parentNode = overlays.length > 0 ? overlays[overlays.length - 1] : document.body;
  var key = event.key;

  if (key && !["ArrowUp", "ArrowDown", "Enter", "ArrowRight", "ArrowLeft"].includes(key) || ![40, 39, 38, 37, 13].includes(event.keyCode)) {
    return;
  }

  var activeElement = document.activeElement !== document.body && parentNode.contains(document.activeElement) ? document.activeElement : null; // If we're not inside the container, don't do anything
  // if (!parentNode.contains(activeElement)) return;

  var availableRows = Array.from(parentNode.querySelectorAll(NAVIGATION_ROW_SELECTOR));
  var activeRowIndex = 0;

  if (activeElement) {
    var closestRow = activeElement.closest(NAVIGATION_ROW_SELECTOR);

    if (closestRow) {
      var availableRowsIndex = availableRows.indexOf(closestRow);

      if (availableRowsIndex >= 0) {
        activeRowIndex = availableRowsIndex;
      }
    }
  } else {
    var lastActiveRow = parentNode.querySelector(NAVIGATION_LAST_ACTIVE_ROW_SELECTOR);

    if (lastActiveRow) {
      var _availableRowsIndex = availableRows.indexOf(lastActiveRow);

      if (_availableRowsIndex >= 0) {
        var lastActiveItem = lastActiveRow.querySelector(NAVIGATION_LAST_ACTIVE_ITEM_SELECTOR);

        if (lastActiveItem) {
          activeElement = lastActiveItem;
        }

        activeRowIndex = _availableRowsIndex;
      }
    }
  }

  var activeRow = availableRows[activeRowIndex] || null; // Get the list of elements we're allowed to scroll through

  var availableItems = activeRow ? Array.from(activeRow.querySelectorAll(NAVIGATION_ITEM_SELECTOR)) : [];
  var activeElementIndex = Array.from(availableItems).findIndex(function (availableElement) {
    return availableElement === activeElement;
  });

  if (activeElementIndex === -1 && availableItems[0]) {
    availableItems[0].focus();
  }

  handleKeyPress({
    parentNode: parentNode,
    event: event,
    activeItemIndex: activeElementIndex,
    activeRowItems: availableItems,
    availableRows: availableRows,
    activeRowIndex: activeRowIndex,
    activeItem: activeElement,
    showKeyboardCallback: showKeyboardCallback
  });
}

/***/ }),

/***/ 91289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ useTranslate; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/react/use-intl.esm7.js
var use_intl_esm7 = __webpack_require__(31733);
;// CONCATENATED MODULE: ./node_modules/use-intl/dist/react/use-intl.esm8.js



function useIntlContext() {
  var context = (0,react.useContext)(use_intl_esm7/* default */.Z);

  if (!context) {
    throw new Error( false ? 0 : undefined);
  }

  return context;
}


//# sourceMappingURL=use-intl.esm8.js.map

// EXTERNAL MODULE: ./node_modules/use-intl/dist/_virtual/use-intl.esm.js
var use_intl_esm = __webpack_require__(50079);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/error.js
var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/types.js
var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value,
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style,
    };
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var regex_generated_WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/number.js


function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(regex_generated_WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData["001"];
    return hourCycles[0];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
var _a;






var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0,tslib_es6.__assign)({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        }
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());

/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js




function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = (0,tslib_es6.__assign)({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}


;// CONCATENATED MODULE: ./node_modules/@formatjs/fast-memoize/lib/index.js
//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};

;// CONCATENATED MODULE: ./node_modules/intl-messageformat/lib/src/error.js

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));

var InvalidValueError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));

var InvalidValueTypeError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));

var MissingValueError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));


;// CONCATENATED MODULE: ./node_modules/intl-messageformat/lib/src/formatters.js


var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && isLiteralElement(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (isLiteralElement(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (isPoundElement(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if (isArgumentElement(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (isDateElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTimeElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isNumberElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : isNumberSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTagElement(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new InvalidValueTypeError(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if (isSelectElement(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if (isPluralElement(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

;// CONCATENATED MODULE: ./node_modules/intl-messageformat/lib/src/core.js
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0,tslib_es6.__assign)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib_es6.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: strategies.variadic,
        }),
        getDateTimeFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib_es6.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: strategies.variadic,
        }),
        getPluralRules: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib_es6.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: strategies.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== PART_TYPE.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () { return ({
            locale: _this.resolvedLocale.toString(),
        }); };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());


;// CONCATENATED MODULE: ./node_modules/intl-messageformat/lib/index.js
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




/* harmony default export */ var lib = (IntlMessageFormat);

;// CONCATENATED MODULE: ./node_modules/use-intl/dist/core/use-intl.esm.js


var IntlErrorCode;

(function (IntlErrorCode) {
  IntlErrorCode["MISSING_MESSAGE"] = "MISSING_MESSAGE";
  IntlErrorCode["MISSING_FORMAT"] = "MISSING_FORMAT";
  IntlErrorCode["INSUFFICIENT_PATH"] = "INSUFFICIENT_PATH";
  IntlErrorCode["INVALID_MESSAGE"] = "INVALID_MESSAGE";
  IntlErrorCode["INVALID_KEY"] = "INVALID_KEY";
  IntlErrorCode["FORMATTING_ERROR"] = "FORMATTING_ERROR";
})(IntlErrorCode || (IntlErrorCode = {}));

var IntlError = /*#__PURE__*/function (_Error) {
  (0,use_intl_esm/* inheritsLoose */.UL)(IntlError, _Error);

  function IntlError(code, originalMessage) {
    var _this;

    var message = code;

    if (originalMessage) {
      message += ': ' + originalMessage;
    }

    _this = _Error.call(this, message) || this;
    _this.code = void 0;
    _this.originalMessage = void 0;
    _this.code = code;

    if (originalMessage) {
      _this.originalMessage = originalMessage;
    }

    return _this;
  }

  return IntlError;
}( /*#__PURE__*/(0,use_intl_esm/* wrapNativeSuper */.wm)(Error));


//# sourceMappingURL=use-intl.esm.js.map

;// CONCATENATED MODULE: ./node_modules/use-intl/dist/core/use-intl.esm9.js


function setTimeZoneInFormats(formats, timeZone) {
  if (!formats) return formats; // The only way to set a time zone with `intl-messageformat` is to merge it into the formats
  // https://github.com/formatjs/formatjs/blob/8256c5271505cf2606e48e3c97ecdd16ede4f1b5/packages/intl/src/message.ts#L15

  return Object.keys(formats).reduce(function (acc, key) {
    acc[key] = (0,use_intl_esm/* extends */.gY)({
      timeZone: timeZone
    }, formats[key]);
    return acc;
  }, {});
}
/**
 * `intl-messageformat` uses separate keys for `date` and `time`, but there's
 * only one native API: `Intl.DateTimeFormat`. Additionally you might want to
 * include both a time and a date in a value, therefore the separation doesn't
 * seem so useful. We offer a single `dateTime` namespace instead, but we have
 * to convert the format before `intl-messageformat` can be used.
 */


function convertFormatsToIntlMessageFormat(formats, timeZone) {
  var formatsWithTimeZone = timeZone ? (0,use_intl_esm/* extends */.gY)({}, formats, {
    dateTime: setTimeZoneInFormats(formats.dateTime, timeZone)
  }) : formats;
  return (0,use_intl_esm/* extends */.gY)({}, formatsWithTimeZone, {
    date: formatsWithTimeZone == null ? void 0 : formatsWithTimeZone.dateTime,
    time: formatsWithTimeZone == null ? void 0 : formatsWithTimeZone.dateTime
  });
}


//# sourceMappingURL=use-intl.esm9.js.map

// EXTERNAL MODULE: ./node_modules/use-intl/dist/core/use-intl.esm5.js
var use_intl_esm5 = __webpack_require__(31954);
;// CONCATENATED MODULE: ./node_modules/use-intl/dist/core/use-intl.esm7.js







function resolvePath(messages, key, namespace) {
  if (!messages) {
    throw new Error( false ? 0 : undefined);
  }

  var message = messages;
  key.split('.').forEach(function (part) {
    var next = message[part];

    if (part == null || next == null) {
      throw new Error( false ? 0 : undefined);
    }

    message = next;
  });
  return message;
}

function prepareTranslationValues(values) {
  if (Object.keys(values).length === 0) return undefined; // Workaround for https://github.com/formatjs/formatjs/issues/1467

  var transformedValues = {};
  Object.keys(values).forEach(function (key) {
    var index = 0;
    var value = values[key];
    var transformed;

    if (typeof value === 'function') {
      transformed = function transformed(chunks) {
        var result = value(chunks);
        return (0,react.isValidElement)(result) ? (0,react.cloneElement)(result, {
          key: key + index++
        }) : result;
      };
    } else {
      transformed = value;
    }

    transformedValues[key] = transformed;
  });
  return transformedValues;
}

function getMessagesOrError(_ref) {
  var messages = _ref.messages,
      namespace = _ref.namespace,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? use_intl_esm5/* defaultOnError */.h : _ref$onError;

  try {
    if (!messages) {
      throw new Error( false ? 0 : undefined);
    }

    var retrievedMessages = namespace ? resolvePath(messages, namespace) : messages;

    if (!retrievedMessages) {
      throw new Error( false ? 0 : undefined);
    }

    return retrievedMessages;
  } catch (error) {
    var intlError = new IntlError(IntlErrorCode.MISSING_MESSAGE, error.message);
    onError(intlError);
    return intlError;
  }
}
function createBaseTranslator(_ref2) {
  var cachedFormatsByLocale = _ref2.cachedFormatsByLocale,
      defaultTranslationValues = _ref2.defaultTranslationValues,
      globalFormats = _ref2.formats,
      _ref2$getMessageFallb = _ref2.getMessageFallback,
      getMessageFallback = _ref2$getMessageFallb === void 0 ? use_intl_esm5/* defaultGetMessageFallback */.i : _ref2$getMessageFallb,
      locale = _ref2.locale,
      messagesOrError = _ref2.messagesOrError,
      namespace = _ref2.namespace,
      onError = _ref2.onError,
      timeZone = _ref2.timeZone;

  function getFallbackFromErrorAndNotify(key, code, message) {
    var error = new IntlError(code, message);
    onError(error);
    return getMessageFallback({
      error: error,
      key: key,
      namespace: namespace
    });
  }

  function translateBaseFn(
  /** Use a dot to indicate a level of nesting (e.g. `namespace.nestedLabel`). */
  key,
  /** Key value pairs for values to interpolate into the message. */
  values,
  /** Provide custom formats for numbers, dates and times. */
  formats) {
    var _cachedFormatsByLocal;

    if (messagesOrError instanceof IntlError) {
      // We have already warned about this during render
      return getMessageFallback({
        error: messagesOrError,
        key: key,
        namespace: namespace
      });
    }

    var messages = messagesOrError;
    var cacheKey = [namespace, key].filter(function (part) {
      return part != null;
    }).join('.');
    var messageFormat;

    if (cachedFormatsByLocale != null && (_cachedFormatsByLocal = cachedFormatsByLocale[locale]) != null && _cachedFormatsByLocal[cacheKey]) {
      messageFormat = cachedFormatsByLocale == null ? void 0 : cachedFormatsByLocale[locale][cacheKey];
    } else {
      var message;

      try {
        message = resolvePath(messages, key, namespace);
      } catch (error) {
        return getFallbackFromErrorAndNotify(key, IntlErrorCode.MISSING_MESSAGE, error.message);
      }

      if (typeof message === 'object') {
        return getFallbackFromErrorAndNotify(key, IntlErrorCode.INSUFFICIENT_PATH,  false ? 0 : undefined);
      }

      try {
        messageFormat = new lib(message, locale, convertFormatsToIntlMessageFormat((0,use_intl_esm/* extends */.gY)({}, globalFormats, formats), timeZone));
      } catch (error) {
        return getFallbackFromErrorAndNotify(key, IntlErrorCode.INVALID_MESSAGE, error.message);
      }

      if (cachedFormatsByLocale) {
        if (!cachedFormatsByLocale[locale]) {
          cachedFormatsByLocale[locale] = {};
        }

        cachedFormatsByLocale[locale][cacheKey] = messageFormat;
      }
    }

    try {
      var formattedMessage = messageFormat.format( // @ts-ignore `intl-messageformat` expects a different format
      // for rich text elements since a recent minor update. This
      // needs to be evaluated in detail, possibly also in regards
      // to be able to format to parts.
      prepareTranslationValues((0,use_intl_esm/* extends */.gY)({}, defaultTranslationValues, values)));

      if (formattedMessage == null) {
        throw new Error( false ? 0 : undefined);
      } // Limit the function signature to return strings or React elements


      return (0,react.isValidElement)(formattedMessage) || // Arrays of React elements
      Array.isArray(formattedMessage) || typeof formattedMessage === 'string' ? formattedMessage : String(formattedMessage);
    } catch (error) {
      return getFallbackFromErrorAndNotify(key, IntlErrorCode.FORMATTING_ERROR, error.message);
    }
  }

  function translateFn(
  /** Use a dot to indicate a level of nesting (e.g. `namespace.nestedLabel`). */
  key,
  /** Key value pairs for values to interpolate into the message. */
  values,
  /** Provide custom formats for numbers, dates and times. */
  formats) {
    var result = translateBaseFn(key, values, formats);

    if (typeof result !== 'string') {
      return getFallbackFromErrorAndNotify(key, IntlErrorCode.INVALID_MESSAGE,  false ? 0 : undefined);
    }

    return result;
  }

  translateFn.rich = translateBaseFn;

  translateFn.raw = function (
  /** Use a dot to indicate a level of nesting (e.g. `namespace.nestedLabel`). */
  key) {
    if (messagesOrError instanceof IntlError) {
      // We have already warned about this during render
      return getMessageFallback({
        error: messagesOrError,
        key: key,
        namespace: namespace
      });
    }

    var messages = messagesOrError;

    try {
      return resolvePath(messages, key, namespace);
    } catch (error) {
      return getFallbackFromErrorAndNotify(key, IntlErrorCode.MISSING_MESSAGE, error.message);
    }
  };

  return translateFn;
}


//# sourceMappingURL=use-intl.esm7.js.map

;// CONCATENATED MODULE: ./node_modules/use-intl/dist/core/use-intl.esm8.js
/**
 * For the strictly typed messages to work we have to wrap the namespace into
 * a mandatory prefix. See https://stackoverflow.com/a/71529575/343045
 */
function resolveNamespace(namespace, namespacePrefix) {
  return namespace === namespacePrefix ? undefined : namespace.slice((namespacePrefix + '.').length);
}


//# sourceMappingURL=use-intl.esm8.js.map

;// CONCATENATED MODULE: ./node_modules/use-intl/dist/react/use-intl.esm9.js





function useTranslationsImpl(allMessages, namespace, namespacePrefix) {
  var _useIntlContext = useIntlContext(),
      defaultTranslationValues = _useIntlContext.defaultTranslationValues,
      globalFormats = _useIntlContext.formats,
      getMessageFallback = _useIntlContext.getMessageFallback,
      locale = _useIntlContext.locale,
      onError = _useIntlContext.onError,
      timeZone = _useIntlContext.timeZone; // The `namespacePrefix` is part of the type system.
  // See the comment in the hook invocation.


  allMessages = allMessages[namespacePrefix];
  namespace = resolveNamespace(namespace, namespacePrefix);
  var cachedFormatsByLocaleRef = (0,react.useRef)({});
  var messagesOrError = (0,react.useMemo)(function () {
    return getMessagesOrError({
      messages: allMessages,
      namespace: namespace,
      onError: onError
    });
  }, [allMessages, namespace, onError]);
  var translate = (0,react.useMemo)(function () {
    return createBaseTranslator({
      cachedFormatsByLocale: cachedFormatsByLocaleRef.current,
      getMessageFallback: getMessageFallback,
      messagesOrError: messagesOrError,
      defaultTranslationValues: defaultTranslationValues,
      namespace: namespace,
      onError: onError,
      formats: globalFormats,
      locale: locale,
      timeZone: timeZone
    });
  }, [getMessageFallback, messagesOrError, defaultTranslationValues, namespace, onError, globalFormats, locale, timeZone]);
  return translate;
}


//# sourceMappingURL=use-intl.esm9.js.map

;// CONCATENATED MODULE: ./node_modules/use-intl/dist/react/use-intl.esm2.js



/**
 * Translates messages from the given namespace by using the ICU syntax.
 * See https://formatjs.io/docs/core-concepts/icu-syntax.
 *
 * If no namespace is provided, all available messages are returned.
 * The namespace can also indicate nesting by using a dot
 * (e.g. `namespace.Component`).
 */

function useTranslations(namespace) {
  var context = useIntlContext();
  var messages = context.messages; // We have to wrap the actual hook so the type inference for the optional
  // namespace works correctly. See https://stackoverflow.com/a/71529575/343045
  // The prefix ("!") is arbitrary.

  return useTranslationsImpl({
    '!': messages
  }, // @ts-ignore
  namespace ? "!." + namespace : '!', '!');
}


//# sourceMappingURL=use-intl.esm2.js.map

;// CONCATENATED MODULE: ./app/hooks/lang.ts

var useTranslate = function useTranslate(defaultNs) {
  var t = useTranslations(defaultNs);
  return t;
};

/***/ }),

/***/ 76299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getClosestBody */
/* harmony import */ var app_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38448);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




function on(obj) {
  if (obj && obj.addEventListener) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    obj.addEventListener.apply(obj, _toConsumableArray(args));
  }
}

function off(obj) {
  if (obj && obj.removeEventListener) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    obj.removeEventListener.apply(obj, _toConsumableArray(args));
  }
}

function getClosestBody(el) {
  if (!el) {
    return null;
  } else if (el.tagName === "BODY") {
    return el;
  } else if (el.tagName === "IFRAME") {
    var _document = el.contentDocument;
    return _document ? _document.body : null;
  } else if (!el.offsetParent) {
    return null;
  }

  return getClosestBody(el.offsetParent);
}

function preventDefault(rawEvent) {
  var e = rawEvent || window.event; // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).

  if (e.touches.length > 1) return true;
  if (e.preventDefault) e.preventDefault();
  return false;
}

var isIosDevice = app_ts__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU && window.navigator && window.navigator.platform && /iP(ad|hone|od)/.test(window.navigator.platform);
var bodies = new Map();
var doc = typeof document === "object" ? document : undefined;
var documentListenerAdded = false;
/* harmony default export */ __webpack_exports__["Z"] = (!doc ? function useModalScroll() {
  var _locked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var _elementRef = arguments.length > 1 ? arguments[1] : undefined;
} : function useLockBody() {
  var locked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var elementRef = arguments.length > 1 ? arguments[1] : undefined;
  var bodyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(doc.body);
  elementRef = elementRef || bodyRef;

  var lock = function lock(body) {
    var bodyInfo = bodies.get(body);

    if (!bodyInfo) {
      bodies.set(body, {
        counter: 1,
        initialOverflow: body.style.overflow
      });
      body.classList.add("modal_open");
    } else {
      bodies.set(body, {
        counter: bodyInfo.counter + 1,
        initialOverflow: bodyInfo.initialOverflow
      });
    }
  };

  var unlock = function unlock(body) {
    var bodyInfo = bodies.get(body);

    if (bodyInfo) {
      if (bodyInfo.counter === 1) {
        bodies.delete(body);
        body.classList.remove("modal_open");
      } else {
        bodies.set(body, {
          counter: bodyInfo.counter - 1,
          initialOverflow: bodyInfo.initialOverflow
        });
      }
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var body = getClosestBody(elementRef.current);

    if (!body) {
      return;
    }

    if (locked) {
      lock(body);
    } else {
      unlock(body);
    }
  }, [locked, elementRef.current]); // clean up, on un-mount

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var body = getClosestBody(elementRef.current);

    if (!body) {
      return;
    }

    return function () {
      unlock(body);
    };
  }, []);
});

/***/ }),

/***/ 26793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IT": function() { return /* binding */ useGoToPodcast; },
/* harmony export */   "bj": function() { return /* binding */ HISTORY_STACK_KEY; },
/* harmony export */   "ub": function() { return /* binding */ useNavigateBack; },
/* harmony export */   "xQ": function() { return /* binding */ useNavigatePath; }
/* harmony export */ });
/* unused harmony export useGoToRadio */
/* harmony import */ var app_context_features_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10833);
/* harmony import */ var app_context_navigation_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



var HISTORY_STACK_KEY = "HISTORY_STACK";
var useNavigateBack = function useNavigateBack() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var _useNavigationContext = (0,app_context_navigation_context__WEBPACK_IMPORTED_MODULE_1__/* .useNavigationContext */ .QR)(),
      showExitConfirmationPopup = _useNavigationContext.showExitConfirmationPopup;

  var _useFeaturesContext = (0,app_context_features_context__WEBPACK_IMPORTED_MODULE_0__/* .useFeaturesContext */ .Pp)(),
      arrowNavigationEnabled = _useFeaturesContext.arrowNavigationEnabled,
      exitConfirmationPopupEnabled = _useFeaturesContext.exitConfirmationPopupEnabled;

  var goBack = function goBack() {
    var overwrire = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var historyStack = JSON.parse(window.sessionStorage.getItem(HISTORY_STACK_KEY) || "[]");

    if (historyStack.length > 1) {
      router.back();
    } else if (arrowNavigationEnabled) {
      if (overwrire !== "") {
        router.push(overwrire);
      } else {
        try {
          if (exitConfirmationPopupEnabled) {
            showExitConfirmationPopup();
          } else {
            console.log("CLOSE APP");
            window.close();
          }
        } catch (e) {
          console.error(e);
        }
      }
    } else {
      router.push("/");
    }
  };

  return goBack;
};
var useGoToRadio = function useGoToRadio() {
  var router = useRouter();

  var goToRadio = function goToRadio(permalink) {
    router.push({
      pathname: permalink,
      query: {
        back: true
      }
    });
  };

  return goToRadio;
};
var useGoToPodcast = function useGoToPodcast() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var goToPodcast = function goToPodcast(permalink) {
    router.push({
      pathname: permalink
    });
  };

  return goToPodcast;
};
var useNavigatePath = function useNavigatePath() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var navigate = function navigate(path) {
    var back = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    router.push({
      pathname: path,
      query: query
    });
  };

  return navigate;
};

/***/ }),

/***/ 39428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useStickyState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useStickyState(key, defaultValue) {
  var getValue = function getValue() {
    if (true) {
      var stickyValue = window.localStorage.getItem(key);

      if (stickyValue !== null) {
        return JSON.parse(stickyValue);
      }
    }

    return null;
  };

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getValue() || defaultValue),
      value = _useState[0],
      setValue = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var stickyValue = getValue();

    if (stickyValue !== null) {
      setValue(stickyValue);
    }
  }, [key]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);
  return [value, setValue];
}

/***/ }),

/***/ 8176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TE": function() { return /* binding */ appVersionActions; },
/* harmony export */   "pu": function() { return /* binding */ selectAppVersionState; }
/* harmony export */ });
/* unused harmony export appVersionSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66741);

var initialState = {
  version: null
};
var appVersionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
  name: "appVersion",
  initialState: initialState,
  reducers: {
    setAppVersion: function setAppVersion(state, payload) {
      var _payload$payload;

      state.version = ((_payload$payload = payload.payload) === null || _payload$payload === void 0 ? void 0 : _payload$payload.version) || null;
    }
  }
});
var appVersionActions = appVersionSlice.actions;
var selectAppVersionState = function selectAppVersionState(state) {
  return state.appVersion;
};
/* harmony default export */ __webpack_exports__["ZP"] = (appVersionSlice.reducer);

/***/ }),

/***/ 22564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i9": function() { return /* binding */ playerActions; },
/* harmony export */   "tA": function() { return /* binding */ selectPlayerState; }
/* harmony export */ });
/* unused harmony export playerSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66741);

var initialState = {
  activeMedia: null,
  loop: false,
  shuffle: false,
  radioQueue: {
    items: [],
    activeIndex: null
  },
  podcastQueue: {
    items: [],
    activeIndex: null
  }
};
var playerSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
  name: "player",
  initialState: initialState,
  reducers: {
    selectTrack: function selectTrack(state, payload) {
      state.activeMedia = payload.payload;
    },
    selectTrackWithQueue: function selectTrackWithQueue(state, payload) {
      state.activeMedia = payload.payload.track;
      state.radioQueue = payload.payload.queue;
    },
    selectNextStation: function selectNextStation(state) {
      var _state$activeMedia, _state$activeMedia$ca;

      if (state.radioQueue.activeIndex !== null && state.radioQueue.items[state.radioQueue.activeIndex] && state.radioQueue.items[state.radioQueue.activeIndex].permalink !== ((_state$activeMedia = state.activeMedia) === null || _state$activeMedia === void 0 ? void 0 : (_state$activeMedia$ca = _state$activeMedia.category) === null || _state$activeMedia$ca === void 0 ? void 0 : _state$activeMedia$ca.permalink)) {
        state.activeMedia = {
          category: state.radioQueue.items[state.radioQueue.activeIndex],
          podcast: null
        };
      }
    },
    setRadioQueue: function setRadioQueue(state, payload) {
      state.radioQueue = payload.payload;
    },
    setPodcastQueue: function setPodcastQueue(state, payload) {
      state.podcastQueue = payload.payload;
    },
    setFailedPlaybackPermalink: function setFailedPlaybackPermalink(state, payload) {
      state.failedPlaybackPermalink = payload.payload;
    },
    setTargetspoConfig: function setTargetspoConfig(state, payload) {
      state.targetspotConfig = payload.payload;
    },
    reset: function reset() {
      return initialState;
    }
  }
});
var playerActions = playerSlice.actions;
var selectPlayerState = function selectPlayerState(state) {
  return state.player;
};
/* harmony default export */ __webpack_exports__["ZP"] = (playerSlice.reducer);

/***/ }),

/***/ 49624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K_": function() { return /* binding */ selectRadioState; },
/* harmony export */   "xF": function() { return /* binding */ radioActions; }
/* harmony export */ });
/* unused harmony export radioSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66741);

var initialState = {
  activeSection: [],
  activeIndex: 0
};
var radioSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
  name: "radio",
  initialState: initialState,
  reducers: {
    selectRadio: function selectRadio(state, payload) {
      var _payload$payload, _payload$payload2;

      state.activeSection = (_payload$payload = payload.payload) === null || _payload$payload === void 0 ? void 0 : _payload$payload.section;
      state.activeIndex = (_payload$payload2 = payload.payload) === null || _payload$payload2 === void 0 ? void 0 : _payload$payload2.activeIndex;
    },
    reset: function reset() {
      return initialState;
    }
  }
});
var radioActions = radioSlice.actions;
var selectRadioState = function selectRadioState(state) {
  return state.radio;
};
/* harmony default export */ __webpack_exports__["ZP"] = (radioSlice.reducer);

/***/ }),

/***/ 38886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hI": function() { return /* binding */ userActions; },
/* harmony export */   "tH": function() { return /* binding */ selectUserState; }
/* harmony export */ });
/* unused harmony export userSlice */
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66741);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25934);
/* harmony import */ var services_hooks_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46725);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var initialState = {
  session: null,
  deviceId: (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
  favoritesLoading: false,
  favorites: [],
  ip: null,
  previouslyPlaying: null,
  lastAdCompletedDate: null,
  selectedDiscoverLanguage: null
};
var loadFavorites = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("salons/fetch", /*#__PURE__*/(0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
  var _response$data$body, response;

  return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0,services_hooks_services__WEBPACK_IMPORTED_MODULE_2__/* .getAccountUsersMePresets */ .Zn)({});

        case 3:
          response = _context.sent;
          return _context.abrupt("return", ((_response$data$body = response.data.body) === null || _response$data$body === void 0 ? void 0 : _response$data$body.content) || []);

        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", []);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[0, 7]]);
})));
var userSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
  name: "user",
  initialState: initialState,
  reducers: {
    setSession: function setSession(state, action) {
      state.session = action.payload;
    },
    setUser: function setUser(state, action) {
      if (state.session) {
        state.session.user = action.payload;
      }
    },
    setIP: function setIP(state, action) {
      state.ip = action.payload;
    },
    logout: function logout(state) {
      state.session = null;
      state.favorites = [];
      state.favoritesLoading = false;
      state.previouslyPlaying = null;
    },
    reset: function reset() {
      return initialState;
    },
    setPreviouslyPlaying: function setPreviouslyPlaying(state, payload) {
      state.previouslyPlaying = payload.payload;
    },
    setLastAdTimestamp: function setLastAdTimestamp(state, payload) {
      state.lastAdCompletedDate = payload.payload;
    },
    setSelectedDiscoverLanguage: function setSelectedDiscoverLanguage(state, payload) {
      state.selectedDiscoverLanguage = payload.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(loadFavorites.pending, function (state, action) {
      state.favoritesLoading = true;
    }).addCase(loadFavorites.fulfilled, function (state, action) {
      state.favoritesLoading = false;
      state.favorites = action.payload;
    }).addCase(loadFavorites.rejected, function (state, action) {
      state.favoritesLoading = false;
    });
  }
});
var userActions = _objectSpread(_objectSpread({}, userSlice.actions), {}, {
  loadFavorites: loadFavorites
});
var selectUserState = function selectUserState(state) {
  return state.user;
};
/* harmony default export */ __webpack_exports__["ZP"] = (userSlice.reducer);

/***/ }),

/***/ 4062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CG": function() { return /* binding */ useAppSelector; },
/* harmony export */   "TL": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* unused harmony export makeStore */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66741);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);
/* harmony import */ var _slices_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38886);
/* harmony import */ var _slices_player__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22564);
/* harmony import */ var _slices_radio__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49624);
/* harmony import */ var _slices_app_version__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8176);






var STORAGE_KEY = "state";
function makeStore() {
  var savedState =  true && window.localStorage.getItem(STORAGE_KEY);
  var preloadedState = savedState ? JSON.parse(savedState) : {};
  return (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .configureStore */ .xC)({
    reducer: {
      user: _slices_user__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP,
      player: _slices_player__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP,
      radio: _slices_radio__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP,
      appVersion: _slices_app_version__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP
    },
    preloadedState: preloadedState
  });
}
var store = makeStore();
store.subscribe(function () {
  if (true) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store.getState()));
  }
});
var useAppDispatch = function useAppDispatch() {
  return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
};
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;
/* harmony default export */ __webpack_exports__["ZP"] = (store);

/***/ }),

/***/ 38448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dw": function() { return /* binding */ notEmpty; },
/* harmony export */   "jU": function() { return /* binding */ isBrowser; }
/* harmony export */ });
/* unused harmony export timeout */
function notEmpty(value) {
  return value !== null && value !== undefined;
}
var timeout = function timeout(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var isBrowser = true;

/***/ }),

/***/ 43007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "db": function() { return /* binding */ db; }
/* harmony export */ });
/* unused harmony export OfflineChaptersDexie */
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82262);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92777);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10748);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81531);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59499);
/* harmony import */ var dexie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4614);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


var OfflineChaptersDexie = /*#__PURE__*/function (_Dexie) {
  (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(OfflineChaptersDexie, _Dexie);

  var _super = _createSuper(OfflineChaptersDexie);

  function OfflineChaptersDexie() {
    var _this;

    (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, OfflineChaptersDexie);

    _this = _super.call(this, 'RadiolineOfflineChapters');

    (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "offlineChapters", void 0);

    _this.version(1).stores({
      offlineChapters: '++permalink, chapterName, podcastName' // Primary key and indexed props

    });

    return _this;
  }

  return (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(OfflineChaptersDexie);
}(dexie__WEBPACK_IMPORTED_MODULE_2__["default"]);
var db = new OfflineChaptersDexie();

/***/ }),

/***/ 79490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gr": function() { return /* binding */ getDateFnsLocale; },
  "BE": function() { return /* binding */ getNavigatorLanguage; },
  "G3": function() { return /* binding */ getNavigatorLanguageForSignUp; }
});

// UNUSED EXPORTS: getNextLocale

// EXTERNAL MODULE: ./app/context/country.context.tsx
var country_context = __webpack_require__(91537);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ar/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'أقل من ثانية',
    two: 'أقل من ثانيتين',
    threeToTen: 'أقل من {{count}} ثواني',
    other: 'أقل من {{count}} ثانية'
  },
  xSeconds: {
    one: 'ثانية واحدة',
    two: 'ثانيتان',
    threeToTen: '{{count}} ثواني',
    other: '{{count}} ثانية'
  },
  halfAMinute: 'نصف دقيقة',
  lessThanXMinutes: {
    one: 'أقل من دقيقة',
    two: 'أقل من دقيقتين',
    threeToTen: 'أقل من {{count}} دقائق',
    other: 'أقل من {{count}} دقيقة'
  },
  xMinutes: {
    one: 'دقيقة واحدة',
    two: 'دقيقتان',
    threeToTen: '{{count}} دقائق',
    other: '{{count}} دقيقة'
  },
  aboutXHours: {
    one: 'ساعة واحدة تقريباً',
    two: 'ساعتين تقريبا',
    threeToTen: '{{count}} ساعات تقريباً',
    other: '{{count}} ساعة تقريباً'
  },
  xHours: {
    one: 'ساعة واحدة',
    two: 'ساعتان',
    threeToTen: '{{count}} ساعات',
    other: '{{count}} ساعة'
  },
  xDays: {
    one: 'يوم واحد',
    two: 'يومان',
    threeToTen: '{{count}} أيام',
    other: '{{count}} يوم'
  },
  aboutXWeeks: {
    one: 'أسبوع واحد تقريبا',
    two: 'أسبوعين تقريبا',
    threeToTen: '{{count}} أسابيع تقريبا',
    other: '{{count}} أسبوعا تقريبا'
  },
  xWeeks: {
    one: 'أسبوع واحد',
    two: 'أسبوعان',
    threeToTen: '{{count}} أسابيع',
    other: '{{count}} أسبوعا'
  },
  aboutXMonths: {
    one: 'شهر واحد تقريباً',
    two: 'شهرين تقريبا',
    threeToTen: '{{count}} أشهر تقريبا',
    other: '{{count}} شهرا تقريباً'
  },
  xMonths: {
    one: 'شهر واحد',
    two: 'شهران',
    threeToTen: '{{count}} أشهر',
    other: '{{count}} شهرا'
  },
  aboutXYears: {
    one: 'سنة واحدة تقريباً',
    two: 'سنتين تقريبا',
    threeToTen: '{{count}} سنوات تقريباً',
    other: '{{count}} سنة تقريباً'
  },
  xYears: {
    one: 'سنة واحد',
    two: 'سنتان',
    threeToTen: '{{count}} سنوات',
    other: '{{count}} سنة'
  },
  overXYears: {
    one: 'أكثر من سنة',
    two: 'أكثر من سنتين',
    threeToTen: 'أكثر من {{count}} سنوات',
    other: 'أكثر من {{count}} سنة'
  },
  almostXYears: {
    one: 'ما يقارب سنة واحدة',
    two: 'ما يقارب سنتين',
    threeToTen: 'ما يقارب {{count}} سنوات',
    other: 'ما يقارب {{count}} سنة'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var usageGroup = formatDistanceLocale[token];
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else if (count === 2) {
    result = usageGroup.two;
  } else if (count <= 10) {
    result = usageGroup.threeToTen.replace('{{count}}', String(count));
  } else {
    result = usageGroup.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'خلال ' + result;
    } else {
      return 'منذ ' + result;
    }
  }

  return result;
};

/* harmony default export */ var _lib_formatDistance = (formatDistance);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(49526);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ar/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE، do MMMM y',
  long: 'do MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/yyyy'
};
var timeFormats = {
  full: 'HH:mm:ss',
  long: 'HH:mm:ss',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'عند الساعة' {{time}}",
  long: "{{date}} 'عند الساعة' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ar/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "eeee 'الماضي عند الساعة' p",
  yesterday: "'الأمس عند الساعة' p",
  today: "'اليوم عند الساعة' p",
  tomorrow: "'غدا عند الساعة' p",
  nextWeek: "eeee 'القادم عند الساعة' p",
  other: 'P'
};

var formatRelative = function formatRelative(token) {
  return formatRelativeLocale[token];
};

/* harmony default export */ var _lib_formatRelative = (formatRelative);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
var buildLocalizeFn = __webpack_require__(88486);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ar/_lib/localize/index.js

var eraValues = {
  narrow: ['ق', 'ب'],
  abbreviated: ['ق.م.', 'ب.م.'],
  wide: ['قبل الميلاد', 'بعد الميلاد']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
};
var monthValues = {
  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'أ', 'س', 'أ', 'ن', 'د'],
  abbreviated: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
};
var dayValues = {
  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  abbreviated: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
};
var dayPeriodValues = {
  narrow: {
    am: 'ص',
    pm: 'م',
    morning: 'الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'المساء',
    night: 'الليل',
    midnight: 'منتصف الليل'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    morning: 'الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'المساء',
    night: 'الليل',
    midnight: 'منتصف الليل'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    morning: 'الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'المساء',
    night: 'الليل',
    midnight: 'منتصف الليل'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'ص',
    pm: 'م',
    morning: 'في الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل',
    midnight: 'منتصف الليل'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    morning: 'في الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل',
    midnight: 'منتصف الليل'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    morning: 'في الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل',
    midnight: 'منتصف الليل'
  }
};

var ordinalNumber = function ordinalNumber(num) {
  return String(num);
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
var buildMatchPatternFn = __webpack_require__(60974);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
var buildMatchFn = __webpack_require__(76723);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ar/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/
};
var parseEraPatterns = {
  any: [/قبل/, /بعد/]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[أيفمسند]/,
  abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^يناير/i, /^فبراير/i, /^مارس/i, /^أبريل/i, /^مايو/i, /^يونيو/i, /^يوليو/i, /^أغسطس/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
};
var matchDayPatterns = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
  any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var parseDayPeriodPatterns = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /منتصف الليل/,
    noon: /الظهر/,
    afternoon: /بعد الظهر/,
    morning: /في الصباح/,
    evening: /في المساء/,
    night: /في الليل/
  }
};
var match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ar/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */
var locale = {
  code: 'ar',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 6
    /* Saturday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var ar = (locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatDistance/index.js
var formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    standalone: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    },
    withPreposition: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    }
  },
  xSeconds: {
    standalone: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    },
    withPreposition: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    }
  },
  halfAMinute: {
    standalone: 'halbe Minute',
    withPreposition: 'halben Minute'
  },
  lessThanXMinutes: {
    standalone: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    },
    withPreposition: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    }
  },
  xMinutes: {
    standalone: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    },
    withPreposition: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    }
  },
  aboutXHours: {
    standalone: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    },
    withPreposition: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    }
  },
  xHours: {
    standalone: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    },
    withPreposition: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    }
  },
  xDays: {
    standalone: {
      one: '1 Tag',
      other: '{{count}} Tage'
    },
    withPreposition: {
      one: '1 Tag',
      other: '{{count}} Tagen'
    }
  },
  aboutXWeeks: {
    standalone: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    },
    withPreposition: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    }
  },
  xWeeks: {
    standalone: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    },
    withPreposition: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    }
  },
  aboutXMonths: {
    standalone: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monate'
    },
    withPreposition: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monaten'
    }
  },
  xMonths: {
    standalone: {
      one: '1 Monat',
      other: '{{count}} Monate'
    },
    withPreposition: {
      one: '1 Monat',
      other: '{{count}} Monaten'
    }
  },
  aboutXYears: {
    standalone: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahre'
    },
    withPreposition: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahren'
    }
  },
  xYears: {
    standalone: {
      one: '1 Jahr',
      other: '{{count}} Jahre'
    },
    withPreposition: {
      one: '1 Jahr',
      other: '{{count}} Jahren'
    }
  },
  overXYears: {
    standalone: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahre'
    },
    withPreposition: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahren'
    }
  },
  almostXYears: {
    standalone: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahre'
    },
    withPreposition: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahren'
    }
  }
};

var formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistance_formatDistanceLocale[token].withPreposition : formatDistance_formatDistanceLocale[token].standalone;

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return 'vor ' + result;
    }
  }

  return result;
};

/* harmony default export */ var de_lib_formatDistance = (formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatLong/index.js

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var formatLong_dateFormats = {
  full: 'EEEE, do MMMM y',
  // Montag, 7. Januar 2018
  long: 'do MMMM y',
  // 7. Januar 2018
  medium: 'do MMM y',
  // 7. Jan. 2018
  short: 'dd.MM.y' // 07.01.2018

};
var formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var formatLong_dateTimeFormats = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var de_lib_formatLong = (formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatRelative/index.js
var formatRelative_formatRelativeLocale = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: 'P'
};

var formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelative_formatRelativeLocale[token];
};

/* harmony default export */ var de_lib_formatRelative = (formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/localize/index.js

var localize_eraValues = {
  narrow: ['v.Chr.', 'n.Chr.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['vor Christus', 'nach Christus']
};
var localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
}; // Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var localize_monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  wide: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
}; // https://st.unicode.org/cldr-apps/v#/de/Gregorian/

var formattingMonthValues = {
  narrow: localize_monthValues.narrow,
  abbreviated: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
  wide: localize_monthValues.wide
};
var localize_dayValues = {
  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
}; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881

var localize_dayPeriodValues = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachm.',
    evening: 'Abend',
    night: 'Nacht'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  }
};
var localize_formattingDayPeriodValues = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachm.',
    evening: 'abends',
    night: 'nachts'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  }
};

var localize_ordinalNumber = function ordinalNumber(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
};

var localize_localize = {
  ordinalNumber: localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: localize_monthValues,
    formattingValues: formattingMonthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var de_lib_localize = (localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/match/index.js


var match_matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var match_parseOrdinalNumberPattern = /\d+/i;
var match_matchEraPatterns = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var match_parseEraPatterns = {
  any: [/^v/i, /^n/i]
};
var match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var match_matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var match_parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var match_matchDayPatterns = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var match_parseDayPatterns = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
var match_matchDayPeriodPatterns = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var match_parseDayPeriodPatterns = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i // will never be matched. Night is matched by `pm`

  }
};
var match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: match_matchOrdinalNumberPattern,
    parsePattern: match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: match_matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var de_lib_match = (match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */
var de_locale = {
  code: 'de',
  formatDistance: de_lib_formatDistance,
  formatLong: de_lib_formatLong,
  formatRelative: de_lib_formatRelative,
  localize: de_lib_localize,
  match: de_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var de = (de_locale);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var en_US_lib_formatDistance = __webpack_require__(81991);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var en_US_lib_formatRelative = __webpack_require__(21865);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js
var en_US_lib_localize = __webpack_require__(11950);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js
var en_US_lib_match = __webpack_require__(7219);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-GB/_lib/formatLong/index.js

var _lib_formatLong_dateFormats = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var _lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var _lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var _lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: _lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: _lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: _lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var en_GB_lib_formatLong = (_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-GB/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */

var en_GB_locale = {
  code: 'en-GB',
  formatDistance: en_US_lib_formatDistance/* default */.Z,
  formatLong: en_GB_lib_formatLong,
  formatRelative: en_US_lib_formatRelative/* default */.Z,
  localize: en_US_lib_localize/* default */.Z,
  match: en_US_lib_match/* default */.Z,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var en_GB = (en_GB_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/_lib/formatDistance/index.js
var _lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'menos de un segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'medio minuto',
  lessThanXMinutes: {
    one: 'menos de un minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'alrededor de 1 hora',
    other: 'alrededor de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 día',
    other: '{{count}} días'
  },
  aboutXWeeks: {
    one: 'alrededor de 1 semana',
    other: 'alrededor de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'alrededor de 1 mes',
    other: 'alrededor de {{count}} meses'
  },
  xMonths: {
    one: '1 mes',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'alrededor de 1 año',
    other: 'alrededor de {{count}} años'
  },
  xYears: {
    one: '1 año',
    other: '{{count}} años'
  },
  overXYears: {
    one: 'más de 1 año',
    other: 'más de {{count}} años'
  },
  almostXYears: {
    one: 'casi 1 año',
    other: 'casi {{count}} años'
  }
};

var _lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = _lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'en ' + result;
    } else {
      return 'hace ' + result;
    }
  }

  return result;
};

/* harmony default export */ var es_lib_formatDistance = (_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/_lib/formatLong/index.js

var es_lib_formatLong_dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var es_lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var es_lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var es_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: es_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: es_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: es_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var es_lib_formatLong = (es_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/_lib/formatRelative/index.js
var _lib_formatRelative_formatRelativeLocale = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: 'P'
};
var formatRelativeLocalePlural = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: 'P'
};

var _lib_formatRelative_formatRelative = function formatRelative(token, date, _baseDate, _options) {
  if (date.getUTCHours() !== 1) {
    return formatRelativeLocalePlural[token];
  } else {
    return _lib_formatRelative_formatRelativeLocale[token];
  }
};

/* harmony default export */ var es_lib_formatRelative = (_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/_lib/localize/index.js

var _lib_localize_eraValues = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'después de cristo']
};
var _lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var _lib_localize_monthValues = {
  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  wide: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
};
var _lib_localize_dayValues = {
  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
  short: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
  abbreviated: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  wide: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
};
var _lib_localize_dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  }
};
var _lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  }
};

var _lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + 'º';
};

var _lib_localize_localize = {
  ordinalNumber: _lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: _lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: _lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: _lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: _lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: _lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: _lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var es_lib_localize = (_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/_lib/match/index.js


var _lib_match_matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var _lib_match_parseOrdinalNumberPattern = /\d+/i;
var _lib_match_matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var _lib_match_parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
};
var _lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var _lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var _lib_match_matchMonthPatterns = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var _lib_match_parseMonthPatterns = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
};
var _lib_match_matchDayPatterns = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var _lib_match_parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
};
var _lib_match_matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var _lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
};
var _lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: _lib_match_matchOrdinalNumberPattern,
    parsePattern: _lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: _lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: _lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: _lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: _lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: _lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: _lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: _lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: _lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: _lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: _lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var es_lib_match = (_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/es/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */
var es_locale = {
  code: 'es',
  formatDistance: es_lib_formatDistance,
  formatLong: es_lib_formatLong,
  formatRelative: es_lib_formatRelative,
  localize: es_lib_localize,
  match: es_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var es = (es_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/fr/_lib/formatDistance/index.js
var fr_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'moins d’une seconde',
    other: 'moins de {{count}} secondes'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} secondes'
  },
  halfAMinute: '30 secondes',
  lessThanXMinutes: {
    one: 'moins d’une minute',
    other: 'moins de {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'environ 1 heure',
    other: 'environ {{count}} heures'
  },
  xHours: {
    one: '1 heure',
    other: '{{count}} heures'
  },
  xDays: {
    one: '1 jour',
    other: '{{count}} jours'
  },
  aboutXWeeks: {
    one: 'environ 1 semaine',
    other: 'environ {{count}} semaines'
  },
  xWeeks: {
    one: '1 semaine',
    other: '{{count}} semaines'
  },
  aboutXMonths: {
    one: 'environ 1 mois',
    other: 'environ {{count}} mois'
  },
  xMonths: {
    one: '1 mois',
    other: '{{count}} mois'
  },
  aboutXYears: {
    one: 'environ 1 an',
    other: 'environ {{count}} ans'
  },
  xYears: {
    one: '1 an',
    other: '{{count}} ans'
  },
  overXYears: {
    one: 'plus d’un an',
    other: 'plus de {{count}} ans'
  },
  almostXYears: {
    one: 'presqu’un an',
    other: 'presque {{count}} ans'
  }
};

var fr_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var form = fr_lib_formatDistance_formatDistanceLocale[token];

  if (typeof form === 'string') {
    result = form;
  } else if (count === 1) {
    result = form.one;
  } else {
    result = form.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'dans ' + result;
    } else {
      return 'il y a ' + result;
    }
  }

  return result;
};

/* harmony default export */ var fr_lib_formatDistance = (fr_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/fr/_lib/formatLong/index.js

var fr_lib_formatLong_dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var fr_lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var fr_lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var fr_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: fr_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: fr_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: fr_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var fr_lib_formatLong = (fr_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/fr/_lib/formatRelative/index.js
var fr_lib_formatRelative_formatRelativeLocale = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: 'P'
};

var fr_lib_formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return fr_lib_formatRelative_formatRelativeLocale[token];
};

/* harmony default export */ var fr_lib_formatRelative = (fr_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/fr/_lib/localize/index.js

var fr_lib_localize_eraValues = {
  narrow: ['av. J.-C', 'ap. J.-C'],
  abbreviated: ['av. J.-C', 'ap. J.-C'],
  wide: ['avant Jésus-Christ', 'après Jésus-Christ']
};
var fr_lib_localize_quarterValues = {
  narrow: ['T1', 'T2', 'T3', 'T4'],
  abbreviated: ['1er trim.', '2ème trim.', '3ème trim.', '4ème trim.'],
  wide: ['1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre']
};
var fr_lib_localize_monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
};
var fr_lib_localize_dayValues = {
  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  short: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
  abbreviated: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
  wide: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
};
var fr_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'mat.',
    afternoon: 'ap.m.',
    evening: 'soir',
    night: 'mat.'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'matin',
    afternoon: 'après-midi',
    evening: 'soir',
    night: 'matin'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'du matin',
    afternoon: 'de l’après-midi',
    evening: 'du soir',
    night: 'du matin'
  }
};

var fr_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  if (number === 0) return '0';
  var feminineUnits = ['year', 'week', 'hour', 'minute', 'second'];
  var suffix;

  if (number === 1) {
    suffix = unit && feminineUnits.includes(unit) ? 'ère' : 'er';
  } else {
    suffix = 'ème';
  }

  return number + suffix;
};

var fr_lib_localize_localize = {
  ordinalNumber: fr_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: fr_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: fr_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: fr_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: fr_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: fr_lib_localize_dayPeriodValues,
    defaultWidth: 'wide'
  })
};
/* harmony default export */ var fr_lib_localize = (fr_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/fr/_lib/match/index.js


var fr_lib_match_matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var fr_lib_match_parseOrdinalNumberPattern = /\d+/i;
var fr_lib_match_matchEraPatterns = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var fr_lib_match_parseEraPatterns = {
  any: [/^av/i, /^ap/i]
};
var fr_lib_match_matchQuarterPatterns = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
};
var fr_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var fr_lib_match_matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var fr_lib_match_parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var fr_lib_match_matchDayPatterns = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var fr_lib_match_parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
};
var fr_lib_match_matchDayPeriodPatterns = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var fr_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
};
var fr_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: fr_lib_match_matchOrdinalNumberPattern,
    parsePattern: fr_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: fr_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: fr_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: fr_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: fr_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: fr_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: fr_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: fr_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: fr_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: fr_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: fr_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var fr_lib_match = (fr_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/fr/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */

var fr_locale = {
  code: 'fr',
  formatDistance: fr_lib_formatDistance,
  formatLong: fr_lib_formatLong,
  formatRelative: fr_lib_formatRelative,
  localize: fr_lib_localize,
  match: fr_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var fr = (fr_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/hi/_lib/localize/index.js

var numberValues = {
  locale: {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
  },
  number: {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
  }
}; // CLDR #1585 - #1592

var hi_lib_localize_eraValues = {
  narrow: ['ईसा-पूर्व', 'ईस्वी'],
  abbreviated: ['ईसा-पूर्व', 'ईस्वी'],
  wide: ['ईसा-पूर्व', 'ईसवी सन']
}; // CLDR #1593 - #1616

var hi_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['ति1', 'ति2', 'ति3', 'ति4'],
  wide: ['पहली तिमाही', 'दूसरी तिमाही', 'तीसरी तिमाही', 'चौथी तिमाही']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688

var hi_lib_localize_monthValues = {
  narrow: ['ज', 'फ़', 'मा', 'अ', 'मई', 'जू', 'जु', 'अग', 'सि', 'अक्टू', 'न', 'दि'],
  abbreviated: ['जन', 'फ़र', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुल', 'अग', 'सित', 'अक्टू', 'नव', 'दिस'],
  wide: ['जनवरी', 'फ़रवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर']
}; // CLDR #1689 - #1744

var hi_lib_localize_dayValues = {
  narrow: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
  short: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
  abbreviated: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
  wide: ['रविवार', 'सोमवार', 'मंगलवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार']
};
var hi_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  },
  abbreviated: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  },
  wide: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  }
};
var hi_lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  },
  abbreviated: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  },
  wide: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  }
};

var hi_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return numberToLocale(number);
};

function localeToNumber(locale) {
  var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function (match) {
    return numberValues.number[match];
  });
  return Number(enNumber);
}
function numberToLocale(enNumber) {
  return enNumber.toString().replace(/\d/g, function (match) {
    return numberValues.locale[match];
  });
}
var hi_lib_localize_localize = {
  ordinalNumber: hi_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: hi_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: hi_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: hi_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: hi_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: hi_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: hi_lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var hi_lib_localize = (hi_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/hi/_lib/formatDistance/index.js
 // Source: https://www.unicode.org/cldr/charts/32/summary/hi.html

var hi_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: '१ सेकंड से कम',
    // CLDR #1310
    other: '{{count}} सेकंड से कम'
  },
  xSeconds: {
    one: '१ सेकंड',
    other: '{{count}} सेकंड'
  },
  halfAMinute: 'आधा मिनट',
  lessThanXMinutes: {
    one: '१ मिनट से कम',
    other: '{{count}} मिनट से कम'
  },
  xMinutes: {
    one: '१ मिनट',
    // CLDR #1307
    other: '{{count}} मिनट'
  },
  aboutXHours: {
    one: 'लगभग १ घंटा',
    other: 'लगभग {{count}} घंटे'
  },
  xHours: {
    one: '१ घंटा',
    // CLDR #1304
    other: '{{count}} घंटे' // CLDR #4467

  },
  xDays: {
    one: '१ दिन',
    // CLDR #1286
    other: '{{count}} दिन'
  },
  aboutXWeeks: {
    one: 'लगभग १ सप्ताह',
    other: 'लगभग {{count}} सप्ताह'
  },
  xWeeks: {
    one: '१ सप्ताह',
    other: '{{count}} सप्ताह'
  },
  aboutXMonths: {
    one: 'लगभग १ महीना',
    other: 'लगभग {{count}} महीने'
  },
  xMonths: {
    one: '१ महीना',
    other: '{{count}} महीने'
  },
  aboutXYears: {
    one: 'लगभग १ वर्ष',
    other: 'लगभग {{count}} वर्ष' // CLDR #4823

  },
  xYears: {
    one: '१ वर्ष',
    other: '{{count}} वर्ष'
  },
  overXYears: {
    one: '१ वर्ष से अधिक',
    other: '{{count}} वर्ष से अधिक'
  },
  almostXYears: {
    one: 'लगभग १ वर्ष',
    other: 'लगभग {{count}} वर्ष'
  }
};

var hi_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = hi_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', numberToLocale(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + 'मे ';
    } else {
      return result + ' पहले';
    }
  }

  return result;
};

/* harmony default export */ var hi_lib_formatDistance = (hi_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/hi/_lib/formatLong/index.js

var hi_lib_formatLong_dateFormats = {
  full: 'EEEE, do MMMM, y',
  // CLDR #1787
  long: 'do MMMM, y',
  // CLDR #1788
  medium: 'd MMM, y',
  // CLDR #1789
  short: 'dd/MM/yyyy' // CLDR #1790

};
var hi_lib_formatLong_timeFormats = {
  full: 'h:mm:ss a zzzz',
  // CLDR #1791
  long: 'h:mm:ss a z',
  // CLDR #1792
  medium: 'h:mm:ss a',
  // CLDR #1793
  short: 'h:mm a' // CLDR #1794

};
var hi_lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'को' {{time}}",
  // CLDR #1795
  long: "{{date}} 'को' {{time}}",
  // CLDR #1796
  medium: '{{date}}, {{time}}',
  // CLDR #1797
  short: '{{date}}, {{time}}' // CLDR #1798

};
var hi_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: hi_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: hi_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: hi_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var hi_lib_formatLong = (hi_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/hi/_lib/formatRelative/index.js
var hi_lib_formatRelative_formatRelativeLocale = {
  lastWeek: "'पिछले' eeee p",
  yesterday: "'कल' p",
  today: "'आज' p",
  tomorrow: "'कल' p",
  nextWeek: "eeee 'को' p",
  other: 'P'
};

var hi_lib_formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return hi_lib_formatRelative_formatRelativeLocale[token];
};

/* harmony default export */ var hi_lib_formatRelative = (hi_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/hi/_lib/match/index.js



var hi_lib_match_matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var hi_lib_match_parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var hi_lib_match_matchEraPatterns = {
  narrow: /^(ईसा-पूर्व|ईस्वी)/i,
  abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
  wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var hi_lib_match_parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var hi_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^ति[1234]/i,
  wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var hi_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var hi_lib_match_matchMonthPatterns = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
  abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
  wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var hi_lib_match_parseMonthPatterns = {
  narrow: [/^ज/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^न/i, /^दि/i],
  any: [/^जन/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^नव/i, /^दिस/i]
};
var hi_lib_match_matchDayPatterns = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
  short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var hi_lib_match_parseDayPatterns = {
  narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
  any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
};
var hi_lib_match_matchDayPeriodPatterns = {
  narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
  any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var hi_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^पूर्वाह्न/i,
    pm: /^अपराह्न/i,
    midnight: /^मध्य/i,
    noon: /^दो/i,
    morning: /सु/i,
    afternoon: /दो/i,
    evening: /शा/i,
    night: /रा/i
  }
};
var hi_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: hi_lib_match_matchOrdinalNumberPattern,
    parsePattern: hi_lib_match_parseOrdinalNumberPattern,
    valueCallback: localeToNumber
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: hi_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: hi_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: hi_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: hi_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: hi_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: hi_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: hi_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: hi_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: hi_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: hi_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var hi_lib_match = (hi_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/hi/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */

var hi_locale = {
  code: 'hi',
  formatDistance: hi_lib_formatDistance,
  formatLong: hi_lib_formatLong,
  formatRelative: hi_lib_formatRelative,
  localize: hi_lib_localize,
  match: hi_lib_match,
  options: {
    weekStartsOn: 0
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var hi = (hi_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/it/_lib/formatDistance/index.js
var it_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'meno di un secondo',
    other: 'meno di {{count}} secondi'
  },
  xSeconds: {
    one: 'un secondo',
    other: '{{count}} secondi'
  },
  halfAMinute: 'alcuni secondi',
  lessThanXMinutes: {
    one: 'meno di un minuto',
    other: 'meno di {{count}} minuti'
  },
  xMinutes: {
    one: 'un minuto',
    other: '{{count}} minuti'
  },
  aboutXHours: {
    one: "circa un'ora",
    other: 'circa {{count}} ore'
  },
  xHours: {
    one: "un'ora",
    other: '{{count}} ore'
  },
  xDays: {
    one: 'un giorno',
    other: '{{count}} giorni'
  },
  aboutXWeeks: {
    one: 'circa una settimana',
    other: 'circa {{count}} settimane'
  },
  xWeeks: {
    one: 'una settimana',
    other: '{{count}} settimane'
  },
  aboutXMonths: {
    one: 'circa un mese',
    other: 'circa {{count}} mesi'
  },
  xMonths: {
    one: 'un mese',
    other: '{{count}} mesi'
  },
  aboutXYears: {
    one: 'circa un anno',
    other: 'circa {{count}} anni'
  },
  xYears: {
    one: 'un anno',
    other: '{{count}} anni'
  },
  overXYears: {
    one: 'più di un anno',
    other: 'più di {{count}} anni'
  },
  almostXYears: {
    one: 'quasi un anno',
    other: 'quasi {{count}} anni'
  }
};

var it_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = it_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'tra ' + result;
    } else {
      return result + ' fa';
    }
  }

  return result;
};

/* harmony default export */ var it_lib_formatDistance = (it_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/it/_lib/formatLong/index.js

var it_lib_formatLong_dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var it_lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var it_lib_formatLong_dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var it_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: it_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: it_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: it_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var it_lib_formatLong = (it_lib_formatLong_formatLong);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(59025);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/isSameUTCWeek/index.js


function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeftStartOfWeek = (0,startOfUTCWeek/* default */.Z)(dirtyDateLeft, options);
  var dateRightStartOfWeek = (0,startOfUTCWeek/* default */.Z)(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/it/_lib/formatRelative/index.js

var weekdays = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];

function _lastWeek(day) {
  switch (day) {
    case 0:
      return "'domenica scorsa alle' p";

    default:
      return "'" + weekdays[day] + " scorso alle' p";
  }
}

function thisWeek(day) {
  return "'" + weekdays[day] + " alle' p";
}

function _nextWeek(day) {
  switch (day) {
    case 0:
      return "'domenica prossima alle' p";

    default:
      return "'" + weekdays[day] + " prossimo alle' p";
  }
}

var it_lib_formatRelative_formatRelativeLocale = {
  lastWeek: function lastWeek(date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return _lastWeek(day);
    }
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function nextWeek(date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return _nextWeek(day);
    }
  },
  other: 'P'
};

var it_lib_formatRelative_formatRelative = function formatRelative(token, date, baseDate, options) {
  var format = it_lib_formatRelative_formatRelativeLocale[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
};

/* harmony default export */ var it_lib_formatRelative = (it_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/it/_lib/localize/index.js

var it_lib_localize_eraValues = {
  narrow: ['aC', 'dC'],
  abbreviated: ['a.C.', 'd.C.'],
  wide: ['avanti Cristo', 'dopo Cristo']
};
var it_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var it_lib_localize_monthValues = {
  narrow: ['G', 'F', 'M', 'A', 'M', 'G', 'L', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
  wide: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre']
};
var it_lib_localize_dayValues = {
  narrow: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
  short: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
  abbreviated: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
  wide: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato']
};
var it_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'm.',
    pm: 'p.',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'mattina',
    afternoon: 'pomeriggio',
    evening: 'sera',
    night: 'notte'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'mattina',
    afternoon: 'pomeriggio',
    evening: 'sera',
    night: 'notte'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'mattina',
    afternoon: 'pomeriggio',
    evening: 'sera',
    night: 'notte'
  }
};
var it_lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: 'm.',
    pm: 'p.',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'di mattina',
    afternoon: 'del pomeriggio',
    evening: 'di sera',
    night: 'di notte'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'di mattina',
    afternoon: 'del pomeriggio',
    evening: 'di sera',
    night: 'di notte'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'di mattina',
    afternoon: 'del pomeriggio',
    evening: 'di sera',
    night: 'di notte'
  }
};

var it_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return String(number);
};

var it_lib_localize_localize = {
  ordinalNumber: it_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: it_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: it_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: it_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: it_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: it_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: it_lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var it_lib_localize = (it_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/it/_lib/match/index.js


var it_lib_match_matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var it_lib_match_parseOrdinalNumberPattern = /\d+/i;
var it_lib_match_matchEraPatterns = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var it_lib_match_parseEraPatterns = {
  any: [/^a/i, /^(d|e)/i]
};
var it_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var it_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var it_lib_match_matchMonthPatterns = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var it_lib_match_parseMonthPatterns = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var it_lib_match_matchDayPatterns = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var it_lib_match_parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
};
var it_lib_match_matchDayPeriodPatterns = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var it_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
};
var it_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: it_lib_match_matchOrdinalNumberPattern,
    parsePattern: it_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: it_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: it_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: it_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: it_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: it_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: it_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: it_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: it_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: it_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: it_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var it_lib_match = (it_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/it/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */

var it_locale = {
  code: 'it',
  formatDistance: it_lib_formatDistance,
  formatLong: it_lib_formatLong,
  formatRelative: it_lib_formatRelative,
  localize: it_lib_localize,
  match: it_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var it = (it_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ja/_lib/formatDistance/index.js
var ja_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: '1秒未満',
    other: '{{count}}秒未満',
    oneWithSuffix: '約1秒',
    otherWithSuffix: '約{{count}}秒'
  },
  xSeconds: {
    one: '1秒',
    other: '{{count}}秒'
  },
  halfAMinute: '30秒',
  lessThanXMinutes: {
    one: '1分未満',
    other: '{{count}}分未満',
    oneWithSuffix: '約1分',
    otherWithSuffix: '約{{count}}分'
  },
  xMinutes: {
    one: '1分',
    other: '{{count}}分'
  },
  aboutXHours: {
    one: '約1時間',
    other: '約{{count}}時間'
  },
  xHours: {
    one: '1時間',
    other: '{{count}}時間'
  },
  xDays: {
    one: '1日',
    other: '{{count}}日'
  },
  aboutXWeeks: {
    one: '約1週間',
    other: '約{{count}}週間'
  },
  xWeeks: {
    one: '1週間',
    other: '{{count}}週間'
  },
  aboutXMonths: {
    one: '約1か月',
    other: '約{{count}}か月'
  },
  xMonths: {
    one: '1か月',
    other: '{{count}}か月'
  },
  aboutXYears: {
    one: '約1年',
    other: '約{{count}}年'
  },
  xYears: {
    one: '1年',
    other: '{{count}}年'
  },
  overXYears: {
    one: '1年以上',
    other: '{{count}}年以上'
  },
  almostXYears: {
    one: '1年近く',
    other: '{{count}}年近く'
  }
};

var ja_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  options = options || {};
  var result;
  var tokenValue = ja_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    if (options.addSuffix && tokenValue.oneWithSuffix) {
      result = tokenValue.oneWithSuffix;
    } else {
      result = tokenValue.one;
    }
  } else {
    if (options.addSuffix && tokenValue.otherWithSuffix) {
      result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    } else {
      result = tokenValue.other.replace('{{count}}', String(count));
    }
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + '後';
    } else {
      return result + '前';
    }
  }

  return result;
};

/* harmony default export */ var ja_lib_formatDistance = (ja_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ja/_lib/formatLong/index.js

var ja_lib_formatLong_dateFormats = {
  full: 'y年M月d日EEEE',
  long: 'y年M月d日',
  medium: 'y/MM/dd',
  short: 'y/MM/dd'
};
var ja_lib_formatLong_timeFormats = {
  full: 'H時mm分ss秒 zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var ja_lib_formatLong_dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var ja_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: ja_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: ja_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: ja_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var ja_lib_formatLong = (ja_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ja/_lib/formatRelative/index.js
var ja_lib_formatRelative_formatRelativeLocale = {
  lastWeek: '先週のeeeeのp',
  yesterday: '昨日のp',
  today: '今日のp',
  tomorrow: '明日のp',
  nextWeek: '翌週のeeeeのp',
  other: 'P'
};

var ja_lib_formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return ja_lib_formatRelative_formatRelativeLocale[token];
};

/* harmony default export */ var ja_lib_formatRelative = (ja_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ja/_lib/localize/index.js

var ja_lib_localize_eraValues = {
  narrow: ['BC', 'AC'],
  abbreviated: ['紀元前', '西暦'],
  wide: ['紀元前', '西暦']
};
var ja_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['第1四半期', '第2四半期', '第3四半期', '第4四半期']
};
var ja_lib_localize_monthValues = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  wide: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
};
var ja_lib_localize_dayValues = {
  narrow: ['日', '月', '火', '水', '木', '金', '土'],
  short: ['日', '月', '火', '水', '木', '金', '土'],
  abbreviated: ['日', '月', '火', '水', '木', '金', '土'],
  wide: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
};
var ja_lib_localize_dayPeriodValues = {
  narrow: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  },
  abbreviated: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  },
  wide: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  }
};
var ja_lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  },
  abbreviated: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  },
  wide: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  }
};

var ja_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = String(options === null || options === void 0 ? void 0 : options.unit);

  switch (unit) {
    case 'year':
      return "".concat(number, "\u5E74");

    case 'quarter':
      return "\u7B2C".concat(number, "\u56DB\u534A\u671F");

    case 'month':
      return "".concat(number, "\u6708");

    case 'week':
      return "\u7B2C".concat(number, "\u9031");

    case 'date':
      return "".concat(number, "\u65E5");

    case 'hour':
      return "".concat(number, "\u6642");

    case 'minute':
      return "".concat(number, "\u5206");

    case 'second':
      return "".concat(number, "\u79D2");

    default:
      return "".concat(number);
  }
};

var ja_lib_localize_localize = {
  ordinalNumber: ja_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: ja_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: ja_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: ja_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: ja_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: ja_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: ja_lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var ja_lib_localize = (ja_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ja/_lib/match/index.js


var ja_lib_match_matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var ja_lib_match_parseOrdinalNumberPattern = /\d+/i;
var ja_lib_match_matchEraPatterns = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(紀元[前後]|西暦)/i,
  wide: /^(紀元[前後]|西暦)/i
};
var ja_lib_match_parseEraPatterns = {
  narrow: [/^B/i, /^A/i],
  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
};
var ja_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^第[1234一二三四１２３４]四半期/i
};
var ja_lib_match_parseQuarterPatterns = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
};
var ja_lib_match_matchMonthPatterns = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])月/i,
  wide: /^([123456789]|1[012])月/i
};
var ja_lib_match_parseMonthPatterns = {
  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
};
var ja_lib_match_matchDayPatterns = {
  narrow: /^[日月火水木金土]/,
  short: /^[日月火水木金土]/,
  abbreviated: /^[日月火水木金土]/,
  wide: /^[日月火水木金土]曜日/
};
var ja_lib_match_parseDayPatterns = {
  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
};
var ja_lib_match_matchDayPeriodPatterns = {
  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var ja_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^(A|午前)/i,
    pm: /^(P|午後)/i,
    midnight: /^深夜|真夜中/i,
    noon: /^正午/i,
    morning: /^朝/i,
    afternoon: /^午後/i,
    evening: /^夜/i,
    night: /^深夜/i
  }
};
var ja_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: ja_lib_match_matchOrdinalNumberPattern,
    parsePattern: ja_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ja_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ja_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ja_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ja_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ja_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ja_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ja_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ja_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ja_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: ja_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var ja_lib_match = (ja_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ja/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */
var ja_locale = {
  code: 'ja',
  formatDistance: ja_lib_formatDistance,
  formatLong: ja_lib_formatLong,
  formatRelative: ja_lib_formatRelative,
  localize: ja_lib_localize,
  match: ja_lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var ja = (ja_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nb/_lib/formatDistance/index.js
var nb_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'mindre enn ett sekund',
    other: 'mindre enn {{count}} sekunder'
  },
  xSeconds: {
    one: 'ett sekund',
    other: '{{count}} sekunder'
  },
  halfAMinute: 'et halvt minutt',
  lessThanXMinutes: {
    one: 'mindre enn ett minutt',
    other: 'mindre enn {{count}} minutter'
  },
  xMinutes: {
    one: 'ett minutt',
    other: '{{count}} minutter'
  },
  aboutXHours: {
    one: 'omtrent en time',
    other: 'omtrent {{count}} timer'
  },
  xHours: {
    one: 'en time',
    other: '{{count}} timer'
  },
  xDays: {
    one: 'en dag',
    other: '{{count}} dager'
  },
  aboutXWeeks: {
    one: 'omtrent en uke',
    other: 'omtrent {{count}} uker'
  },
  xWeeks: {
    one: 'en uke',
    other: '{{count}} uker'
  },
  aboutXMonths: {
    one: 'omtrent en måned',
    other: 'omtrent {{count}} måneder'
  },
  xMonths: {
    one: 'en måned',
    other: '{{count}} måneder'
  },
  aboutXYears: {
    one: 'omtrent ett år',
    other: 'omtrent {{count}} år'
  },
  xYears: {
    one: 'ett år',
    other: '{{count}} år'
  },
  overXYears: {
    one: 'over ett år',
    other: 'over {{count}} år'
  },
  almostXYears: {
    one: 'nesten ett år',
    other: 'nesten {{count}} år'
  }
};

var nb_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = nb_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'om ' + result;
    } else {
      return result + ' siden';
    }
  }

  return result;
};

/* harmony default export */ var nb_lib_formatDistance = (nb_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nb/_lib/formatLong/index.js

var nb_lib_formatLong_dateFormats = {
  full: 'EEEE d. MMMM y',
  long: 'd. MMMM y',
  medium: 'd. MMM y',
  short: 'dd.MM.y'
};
var nb_lib_formatLong_timeFormats = {
  full: "'kl'. HH:mm:ss zzzz",
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var nb_lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var nb_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: nb_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: nb_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: nb_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var nb_lib_formatLong = (nb_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nb/_lib/formatRelative/index.js
var nb_lib_formatRelative_formatRelativeLocale = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: 'P'
};

var nb_lib_formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return nb_lib_formatRelative_formatRelativeLocale[token];
};

/* harmony default export */ var nb_lib_formatRelative = (nb_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nb/_lib/localize/index.js

var nb_lib_localize_eraValues = {
  narrow: ['f.Kr.', 'e.Kr.'],
  abbreviated: ['f.Kr.', 'e.Kr.'],
  wide: ['før Kristus', 'etter Kristus']
};
var nb_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
};
var nb_lib_localize_monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
  wide: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
};
var nb_lib_localize_dayValues = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
  abbreviated: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
  wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
};
var nb_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på etterm.',
    evening: 'på kvelden',
    night: 'på natten'
  },
  abbreviated: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på etterm.',
    evening: 'på kvelden',
    night: 'på natten'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morgenen',
    afternoon: 'på ettermiddagen',
    evening: 'på kvelden',
    night: 'på natten'
  }
};

var nb_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + '.';
};

var nb_lib_localize_localize = {
  ordinalNumber: nb_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: nb_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: nb_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: nb_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: nb_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: nb_lib_localize_dayPeriodValues,
    defaultWidth: 'wide'
  })
};
/* harmony default export */ var nb_lib_localize = (nb_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nb/_lib/match/index.js


var nb_lib_match_matchOrdinalNumberPattern = /^(\d+)\.?/i;
var nb_lib_match_parseOrdinalNumberPattern = /\d+/i;
var nb_lib_match_matchEraPatterns = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var nb_lib_match_parseEraPatterns = {
  any: [/^f/i, /^e/i]
};
var nb_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
};
var nb_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var nb_lib_match_matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var nb_lib_match_parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var nb_lib_match_matchDayPatterns = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var nb_lib_match_parseDayPatterns = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
var nb_lib_match_matchDayPeriodPatterns = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var nb_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
};
var nb_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: nb_lib_match_matchOrdinalNumberPattern,
    parsePattern: nb_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: nb_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: nb_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: nb_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: nb_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: nb_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: nb_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: nb_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: nb_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: nb_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: nb_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var nb_lib_match = (nb_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nb/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */

var nb_locale = {
  code: 'nb',
  formatDistance: nb_lib_formatDistance,
  formatLong: nb_lib_formatLong,
  formatRelative: nb_lib_formatRelative,
  localize: nb_lib_localize,
  match: nb_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var nb = (nb_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/_lib/formatDistance/index.js
var nl_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'minder dan een seconde',
    other: 'minder dan {{count}} seconden'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} seconden'
  },
  halfAMinute: 'een halve minuut',
  lessThanXMinutes: {
    one: 'minder dan een minuut',
    other: 'minder dan {{count}} minuten'
  },
  xMinutes: {
    one: 'een minuut',
    other: '{{count}} minuten'
  },
  aboutXHours: {
    one: 'ongeveer 1 uur',
    other: 'ongeveer {{count}} uur'
  },
  xHours: {
    one: '1 uur',
    other: '{{count}} uur'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dagen'
  },
  aboutXWeeks: {
    one: 'ongeveer 1 week',
    other: 'ongeveer {{count}} weken'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weken'
  },
  aboutXMonths: {
    one: 'ongeveer 1 maand',
    other: 'ongeveer {{count}} maanden'
  },
  xMonths: {
    one: '1 maand',
    other: '{{count}} maanden'
  },
  aboutXYears: {
    one: 'ongeveer 1 jaar',
    other: 'ongeveer {{count}} jaar'
  },
  xYears: {
    one: '1 jaar',
    other: '{{count}} jaar'
  },
  overXYears: {
    one: 'meer dan 1 jaar',
    other: 'meer dan {{count}} jaar'
  },
  almostXYears: {
    one: 'bijna 1 jaar',
    other: 'bijna {{count}} jaar'
  }
};

var nl_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = nl_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'over ' + result;
    } else {
      return result + ' geleden';
    }
  }

  return result;
};

/* harmony default export */ var nl_lib_formatDistance = (nl_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/_lib/formatLong/index.js

var nl_lib_formatLong_dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd-MM-y'
};
var nl_lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var nl_lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var nl_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: nl_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: nl_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: nl_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var nl_lib_formatLong = (nl_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/_lib/formatRelative/index.js
var nl_lib_formatRelative_formatRelativeLocale = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: 'P'
};

var nl_lib_formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return nl_lib_formatRelative_formatRelativeLocale[token];
};

/* harmony default export */ var nl_lib_formatRelative = (nl_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/_lib/localize/index.js

var nl_lib_localize_eraValues = {
  narrow: ['v.C.', 'n.C.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['voor Christus', 'na Christus']
};
var nl_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
};
var nl_lib_localize_monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
};
var nl_lib_localize_dayValues = {
  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
};
var nl_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
};

var nl_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + 'e';
};

var nl_lib_localize_localize = {
  ordinalNumber: nl_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: nl_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: nl_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: nl_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: nl_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: nl_lib_localize_dayPeriodValues,
    defaultWidth: 'wide'
  })
};
/* harmony default export */ var nl_lib_localize = (nl_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/_lib/match/index.js


var nl_lib_match_matchOrdinalNumberPattern = /^(\d+)e?/i;
var nl_lib_match_parseOrdinalNumberPattern = /\d+/i;
var nl_lib_match_matchEraPatterns = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
};
var nl_lib_match_parseEraPatterns = {
  any: [/^v/, /^n/]
};
var nl_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
};
var nl_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var nl_lib_match_matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var nl_lib_match_parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
};
var nl_lib_match_matchDayPatterns = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var nl_lib_match_parseDayPatterns = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
};
var nl_lib_match_matchDayPeriodPatterns = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var nl_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
};
var nl_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: nl_lib_match_matchOrdinalNumberPattern,
    parsePattern: nl_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: nl_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: nl_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: nl_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: nl_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: nl_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: nl_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: nl_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: nl_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: nl_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: nl_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var nl_lib_match = (nl_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/nl/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */

var nl_locale = {
  code: 'nl',
  formatDistance: nl_lib_formatDistance,
  formatLong: nl_lib_formatLong,
  formatRelative: nl_lib_formatRelative,
  localize: nl_lib_localize,
  match: nl_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var nl = (nl_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pl/_lib/formatDistance/index.js
var pl_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: {
      regular: 'mniej niż sekunda',
      past: 'mniej niż sekundę',
      future: 'mniej niż sekundę'
    },
    twoFour: 'mniej niż {{count}} sekundy',
    other: 'mniej niż {{count}} sekund'
  },
  xSeconds: {
    one: {
      regular: 'sekunda',
      past: 'sekundę',
      future: 'sekundę'
    },
    twoFour: '{{count}} sekundy',
    other: '{{count}} sekund'
  },
  halfAMinute: {
    one: 'pół minuty',
    twoFour: 'pół minuty',
    other: 'pół minuty'
  },
  lessThanXMinutes: {
    one: {
      regular: 'mniej niż minuta',
      past: 'mniej niż minutę',
      future: 'mniej niż minutę'
    },
    twoFour: 'mniej niż {{count}} minuty',
    other: 'mniej niż {{count}} minut'
  },
  xMinutes: {
    one: {
      regular: 'minuta',
      past: 'minutę',
      future: 'minutę'
    },
    twoFour: '{{count}} minuty',
    other: '{{count}} minut'
  },
  aboutXHours: {
    one: {
      regular: 'około godziny',
      past: 'około godziny',
      future: 'około godzinę'
    },
    twoFour: 'około {{count}} godziny',
    other: 'około {{count}} godzin'
  },
  xHours: {
    one: {
      regular: 'godzina',
      past: 'godzinę',
      future: 'godzinę'
    },
    twoFour: '{{count}} godziny',
    other: '{{count}} godzin'
  },
  xDays: {
    one: {
      regular: 'dzień',
      past: 'dzień',
      future: '1 dzień'
    },
    twoFour: '{{count}} dni',
    other: '{{count}} dni'
  },
  aboutXWeeks: {
    one: 'około tygodnia',
    twoFour: 'około {{count}} tygodni',
    other: 'około {{count}} tygodni'
  },
  xWeeks: {
    one: 'tydzień',
    twoFour: '{{count}} tygodnie',
    other: '{{count}} tygodni'
  },
  aboutXMonths: {
    one: 'około miesiąc',
    twoFour: 'około {{count}} miesiące',
    other: 'około {{count}} miesięcy'
  },
  xMonths: {
    one: 'miesiąc',
    twoFour: '{{count}} miesiące',
    other: '{{count}} miesięcy'
  },
  aboutXYears: {
    one: 'około rok',
    twoFour: 'około {{count}} lata',
    other: 'około {{count}} lat'
  },
  xYears: {
    one: 'rok',
    twoFour: '{{count}} lata',
    other: '{{count}} lat'
  },
  overXYears: {
    one: 'ponad rok',
    twoFour: 'ponad {{count}} lata',
    other: 'ponad {{count}} lat'
  },
  almostXYears: {
    one: 'prawie rok',
    twoFour: 'prawie {{count}} lata',
    other: 'prawie {{count}} lat'
  }
};

function declensionGroup(scheme, count) {
  if (count === 1) {
    return scheme.one;
  }

  var rem100 = count % 100; // ends with 11-20

  if (rem100 <= 20 && rem100 > 10) {
    return scheme.other;
  }

  var rem10 = rem100 % 10; // ends with 2, 3, 4

  if (rem10 >= 2 && rem10 <= 4) {
    return scheme.twoFour;
  }

  return scheme.other;
}

function declension(scheme, count, time) {
  var group = declensionGroup(scheme, count);
  var finalText = typeof group === 'string' ? group : group[time];
  return finalText.replace('{{count}}', String(count));
}

var pl_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var scheme = pl_lib_formatDistance_formatDistanceLocale[token];

  if (!(options !== null && options !== void 0 && options.addSuffix)) {
    return declension(scheme, count, 'regular');
  }

  if (options.comparison && options.comparison > 0) {
    return 'za ' + declension(scheme, count, 'future');
  } else {
    return declension(scheme, count, 'past') + ' temu';
  }
};

/* harmony default export */ var pl_lib_formatDistance = (pl_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pl/_lib/formatLong/index.js

var pl_lib_formatLong_dateFormats = {
  full: 'EEEE, do MMMM y',
  long: 'do MMMM y',
  medium: 'do MMM y',
  short: 'dd.MM.y'
};
var pl_lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var pl_lib_formatLong_dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var pl_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: pl_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: pl_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: pl_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var pl_lib_formatLong = (pl_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pl/_lib/formatRelative/index.js

var adjectivesLastWeek = {
  masculine: 'ostatni',
  feminine: 'ostatnia'
};
var adjectivesThisWeek = {
  masculine: 'ten',
  feminine: 'ta'
};
var adjectivesNextWeek = {
  masculine: 'następny',
  feminine: 'następna'
};
var dayGrammaticalGender = {
  0: 'feminine',
  1: 'masculine',
  2: 'masculine',
  3: 'feminine',
  4: 'masculine',
  5: 'masculine',
  6: 'feminine'
};

function dayAndTimeWithAdjective(token, date, baseDate, options) {
  var adjectives;

  if (isSameUTCWeek(date, baseDate, options)) {
    adjectives = adjectivesThisWeek;
  } else if (token === 'lastWeek') {
    adjectives = adjectivesLastWeek;
  } else if (token === 'nextWeek') {
    adjectives = adjectivesNextWeek;
  } else {
    throw new Error("Cannot determine adjectives for token ".concat(token));
  }

  var day = date.getUTCDay();
  var grammaticalGender = dayGrammaticalGender[day];
  var adjective = adjectives[grammaticalGender];
  return "'".concat(adjective, "' eeee 'o' p");
}

var pl_lib_formatRelative_formatRelativeLocale = {
  lastWeek: dayAndTimeWithAdjective,
  yesterday: "'wczoraj o' p",
  today: "'dzisiaj o' p",
  tomorrow: "'jutro o' p",
  nextWeek: dayAndTimeWithAdjective,
  other: 'P'
};

var pl_lib_formatRelative_formatRelative = function formatRelative(token, date, baseDate, options) {
  var format = pl_lib_formatRelative_formatRelativeLocale[token];

  if (typeof format === 'function') {
    return format(token, date, baseDate, options);
  }

  return format;
};

/* harmony default export */ var pl_lib_formatRelative = (pl_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pl/_lib/localize/index.js

var pl_lib_localize_eraValues = {
  narrow: ['p.n.e.', 'n.e.'],
  abbreviated: ['p.n.e.', 'n.e.'],
  wide: ['przed naszą erą', 'naszej ery']
};
var pl_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['I kw.', 'II kw.', 'III kw.', 'IV kw.'],
  wide: ['I kwartał', 'II kwartał', 'III kwartał', 'IV kwartał']
};
var pl_lib_localize_monthValues = {
  narrow: ['S', 'L', 'M', 'K', 'M', 'C', 'L', 'S', 'W', 'P', 'L', 'G'],
  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  wide: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień']
};
var monthFormattingValues = {
  narrow: ['s', 'l', 'm', 'k', 'm', 'c', 'l', 's', 'w', 'p', 'l', 'g'],
  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  wide: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia']
};
var pl_lib_localize_dayValues = {
  narrow: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
};
var dayFormattingValues = {
  narrow: ['n', 'p', 'w', 'ś', 'c', 'p', 's'],
  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
};
var pl_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'półn.',
    noon: 'poł',
    morning: 'rano',
    afternoon: 'popoł.',
    evening: 'wiecz.',
    night: 'noc'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'północ',
    noon: 'południe',
    morning: 'rano',
    afternoon: 'popołudnie',
    evening: 'wieczór',
    night: 'noc'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'północ',
    noon: 'południe',
    morning: 'rano',
    afternoon: 'popołudnie',
    evening: 'wieczór',
    night: 'noc'
  }
};
var dayPeriodFormattingValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'o półn.',
    noon: 'w poł.',
    morning: 'rano',
    afternoon: 'po poł.',
    evening: 'wiecz.',
    night: 'w nocy'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o północy',
    noon: 'w południe',
    morning: 'rano',
    afternoon: 'po południu',
    evening: 'wieczorem',
    night: 'w nocy'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o północy',
    noon: 'w południe',
    morning: 'rano',
    afternoon: 'po południu',
    evening: 'wieczorem',
    night: 'w nocy'
  }
};

var pl_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  return String(dirtyNumber);
};

var pl_lib_localize_localize = {
  ordinalNumber: pl_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: pl_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: pl_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: pl_lib_localize_monthValues,
    defaultWidth: 'wide',
    formattingValues: monthFormattingValues,
    defaultFormattingWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: pl_lib_localize_dayValues,
    defaultWidth: 'wide',
    formattingValues: dayFormattingValues,
    defaultFormattingWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: pl_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: dayPeriodFormattingValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var pl_lib_localize = (pl_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pl/_lib/match/index.js


var pl_lib_match_matchOrdinalNumberPattern = /^(\d+)?/i;
var pl_lib_match_parseOrdinalNumberPattern = /\d+/i;
var pl_lib_match_matchEraPatterns = {
  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var pl_lib_match_parseEraPatterns = {
  any: [/^p/i, /^n/i]
};
var pl_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var pl_lib_match_parseQuarterPatterns = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
};
var pl_lib_match_matchMonthPatterns = {
  narrow: /^[slmkcwpg]/i,
  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var pl_lib_match_parseMonthPatterns = {
  narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
  any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
};
var pl_lib_match_matchDayPatterns = {
  narrow: /^[npwścs]/i,
  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var pl_lib_match_parseDayPatterns = {
  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
};
var pl_lib_match_matchDayPeriodPatterns = {
  narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var pl_lib_match_parseDayPeriodPatterns = {
  narrow: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  },
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  }
};
var pl_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: pl_lib_match_matchOrdinalNumberPattern,
    parsePattern: pl_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pl_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pl_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pl_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pl_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pl_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pl_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pl_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pl_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pl_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: pl_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var pl_lib_match = (pl_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pl/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */

var pl_locale = {
  code: 'pl',
  formatDistance: pl_lib_formatDistance,
  formatLong: pl_lib_formatLong,
  formatRelative: pl_lib_formatRelative,
  localize: pl_lib_localize,
  match: pl_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var pl = (pl_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt-BR/_lib/formatDistance/index.js
var pt_BR_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'menos de um segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'meio minuto',
  lessThanXMinutes: {
    one: 'menos de um minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'cerca de 1 hora',
    other: 'cerca de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 dia',
    other: '{{count}} dias'
  },
  aboutXWeeks: {
    one: 'cerca de 1 semana',
    other: 'cerca de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'cerca de 1 mês',
    other: 'cerca de {{count}} meses'
  },
  xMonths: {
    one: '1 mês',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'cerca de 1 ano',
    other: 'cerca de {{count}} anos'
  },
  xYears: {
    one: '1 ano',
    other: '{{count}} anos'
  },
  overXYears: {
    one: 'mais de 1 ano',
    other: 'mais de {{count}} anos'
  },
  almostXYears: {
    one: 'quase 1 ano',
    other: 'quase {{count}} anos'
  }
};

var pt_BR_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = pt_BR_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'em ' + result;
    } else {
      return 'há ' + result;
    }
  }

  return result;
};

/* harmony default export */ var pt_BR_lib_formatDistance = (pt_BR_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt-BR/_lib/formatLong/index.js

var pt_BR_lib_formatLong_dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/yyyy'
};
var pt_BR_lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var pt_BR_lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var pt_BR_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: pt_BR_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: pt_BR_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: pt_BR_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var pt_BR_lib_formatLong = (pt_BR_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt-BR/_lib/formatRelative/index.js
var pt_BR_lib_formatRelative_formatRelativeLocale = {
  lastWeek: function lastWeek(date) {
    var weekday = date.getUTCDay();
    var last = weekday === 0 || weekday === 6 ? 'último' : 'última';
    return "'" + last + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: 'P'
};

var pt_BR_lib_formatRelative_formatRelative = function formatRelative(token, date, _baseDate, _options) {
  var format = pt_BR_lib_formatRelative_formatRelativeLocale[token];

  if (typeof format === 'function') {
    return format(date);
  }

  return format;
};

/* harmony default export */ var pt_BR_lib_formatRelative = (pt_BR_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt-BR/_lib/localize/index.js

var pt_BR_lib_localize_eraValues = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'depois de cristo']
};
var pt_BR_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var pt_BR_lib_localize_monthValues = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
};
var pt_BR_lib_localize_dayValues = {
  narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
  abbreviated: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
};
var pt_BR_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  }
};
var pt_BR_lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  }
};

var pt_BR_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);

  if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') {
    return number + 'ª';
  }

  return number + 'º';
};

var pt_BR_lib_localize_localize = {
  ordinalNumber: pt_BR_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: pt_BR_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: pt_BR_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: pt_BR_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: pt_BR_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: pt_BR_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: pt_BR_lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var pt_BR_lib_localize = (pt_BR_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt-BR/_lib/match/index.js


var pt_BR_lib_match_matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var pt_BR_lib_match_parseOrdinalNumberPattern = /\d+/i;
var pt_BR_lib_match_matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
};
var pt_BR_lib_match_parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
};
var pt_BR_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var pt_BR_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var pt_BR_lib_match_matchMonthPatterns = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var pt_BR_lib_match_parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
};
var pt_BR_lib_match_matchDayPatterns = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var pt_BR_lib_match_parseDayPatterns = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
};
var pt_BR_lib_match_matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var pt_BR_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
};
var pt_BR_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: pt_BR_lib_match_matchOrdinalNumberPattern,
    parsePattern: pt_BR_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pt_BR_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pt_BR_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pt_BR_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pt_BR_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pt_BR_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pt_BR_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pt_BR_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pt_BR_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pt_BR_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: pt_BR_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var pt_BR_lib_match = (pt_BR_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt-BR/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */

var pt_BR_locale = {
  code: 'pt-BR',
  formatDistance: pt_BR_lib_formatDistance,
  formatLong: pt_BR_lib_formatLong,
  formatRelative: pt_BR_lib_formatRelative,
  localize: pt_BR_lib_localize,
  match: pt_BR_lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var pt_BR = (pt_BR_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt/_lib/formatDistance/index.js
var pt_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'menos de um segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'meio minuto',
  lessThanXMinutes: {
    one: 'menos de um minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'aproximadamente 1 hora',
    other: 'aproximadamente {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 dia',
    other: '{{count}} dias'
  },
  aboutXWeeks: {
    one: 'aproximadamente 1 semana',
    other: 'aproximadamente {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'aproximadamente 1 mês',
    other: 'aproximadamente {{count}} meses'
  },
  xMonths: {
    one: '1 mês',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'aproximadamente 1 ano',
    other: 'aproximadamente {{count}} anos'
  },
  xYears: {
    one: '1 ano',
    other: '{{count}} anos'
  },
  overXYears: {
    one: 'mais de 1 ano',
    other: 'mais de {{count}} anos'
  },
  almostXYears: {
    one: 'quase 1 ano',
    other: 'quase {{count}} anos'
  }
};

var pt_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = pt_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'daqui a ' + result;
    } else {
      return 'há ' + result;
    }
  }

  return result;
};

/* harmony default export */ var pt_lib_formatDistance = (pt_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt/_lib/formatLong/index.js

var pt_lib_formatLong_dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: 'dd/MM/y'
};
var pt_lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var pt_lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var pt_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: pt_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: pt_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: pt_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var pt_lib_formatLong = (pt_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt/_lib/formatRelative/index.js
var pt_lib_formatRelative_formatRelativeLocale = {
  lastWeek: function lastWeek(date) {
    var weekday = date.getUTCDay();
    var last = weekday === 0 || weekday === 6 ? 'último' : 'última';
    return "'" + last + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: 'P'
};

var pt_lib_formatRelative_formatRelative = function formatRelative(token, date, _baseDate, _options) {
  var format = pt_lib_formatRelative_formatRelativeLocale[token];

  if (typeof format === 'function') {
    return format(date);
  }

  return format;
};

/* harmony default export */ var pt_lib_formatRelative = (pt_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt/_lib/localize/index.js

var pt_lib_localize_eraValues = {
  narrow: ['aC', 'dC'],
  abbreviated: ['a.C.', 'd.C.'],
  wide: ['antes de Cristo', 'depois de Cristo']
};
var pt_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var pt_lib_localize_monthValues = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
};
var pt_lib_localize_dayValues = {
  narrow: ['d', 's', 't', 'q', 'q', 's', 's'],
  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  abbreviated: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
};
var pt_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'noite',
    night: 'madrugada'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'noite',
    night: 'madrugada'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'noite',
    night: 'madrugada'
  }
};
var pt_lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da noite',
    night: 'da madrugada'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da noite',
    night: 'da madrugada'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da noite',
    night: 'da madrugada'
  }
};

var pt_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + 'º';
};

var pt_lib_localize_localize = {
  ordinalNumber: pt_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: pt_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: pt_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: pt_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: pt_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: pt_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: pt_lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var pt_lib_localize = (pt_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt/_lib/match/index.js


var pt_lib_match_matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var pt_lib_match_parseOrdinalNumberPattern = /\d+/i;
var pt_lib_match_matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var pt_lib_match_parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
};
var pt_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
};
var pt_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var pt_lib_match_matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var pt_lib_match_parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var pt_lib_match_matchDayPatterns = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var pt_lib_match_parseDayPatterns = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
};
var pt_lib_match_matchDayPeriodPatterns = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var pt_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
};
var pt_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: pt_lib_match_matchOrdinalNumberPattern,
    parsePattern: pt_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pt_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pt_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pt_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pt_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pt_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pt_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pt_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: pt_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: pt_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: pt_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var pt_lib_match = (pt_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/pt/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */

var pt_locale = {
  code: 'pt',
  formatDistance: pt_lib_formatDistance,
  formatLong: pt_lib_formatLong,
  formatRelative: pt_lib_formatRelative,
  localize: pt_lib_localize,
  match: pt_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var pt = (pt_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ro/_lib/formatDistance/index.js
var ro_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'mai puțin de o secundă',
    other: 'mai puțin de {{count}} secunde'
  },
  xSeconds: {
    one: '1 secundă',
    other: '{{count}} secunde'
  },
  halfAMinute: 'jumătate de minut',
  lessThanXMinutes: {
    one: 'mai puțin de un minut',
    other: 'mai puțin de {{count}} minute'
  },
  xMinutes: {
    one: '1 minut',
    other: '{{count}} minute'
  },
  aboutXHours: {
    one: 'circa 1 oră',
    other: 'circa {{count}} ore'
  },
  xHours: {
    one: '1 oră',
    other: '{{count}} ore'
  },
  xDays: {
    one: '1 zi',
    other: '{{count}} zile'
  },
  aboutXWeeks: {
    one: 'circa o săptămână',
    other: 'circa {{count}} săptămâni'
  },
  xWeeks: {
    one: '1 săptămână',
    other: '{{count}} săptămâni'
  },
  aboutXMonths: {
    one: 'circa 1 lună',
    other: 'circa {{count}} luni'
  },
  xMonths: {
    one: '1 lună',
    other: '{{count}} luni'
  },
  aboutXYears: {
    one: 'circa 1 an',
    other: 'circa {{count}} ani'
  },
  xYears: {
    one: '1 an',
    other: '{{count}} ani'
  },
  overXYears: {
    one: 'peste 1 an',
    other: 'peste {{count}} ani'
  },
  almostXYears: {
    one: 'aproape 1 an',
    other: 'aproape {{count}} ani'
  }
};

var ro_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = ro_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'în ' + result;
    } else {
      return result + ' în urmă';
    }
  }

  return result;
};

/* harmony default export */ var ro_lib_formatDistance = (ro_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ro/_lib/formatLong/index.js

var ro_lib_formatLong_dateFormats = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd.MM.yyyy'
};
var ro_lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var ro_lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var ro_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: ro_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: ro_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: ro_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var ro_lib_formatLong = (ro_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ro/_lib/formatRelative/index.js
var ro_lib_formatRelative_formatRelativeLocale = {
  lastWeek: "eeee 'trecută la' p",
  yesterday: "'ieri la' p",
  today: "'astăzi la' p",
  tomorrow: "'mâine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: 'P'
};

var ro_lib_formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return ro_lib_formatRelative_formatRelativeLocale[token];
};

/* harmony default export */ var ro_lib_formatRelative = (ro_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ro/_lib/localize/index.js

var ro_lib_localize_eraValues = {
  narrow: ['Î', 'D'],
  abbreviated: ['Î.d.C.', 'D.C.'],
  wide: ['Înainte de Cristos', 'După Cristos']
};
var ro_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['primul trimestru', 'al doilea trimestru', 'al treilea trimestru', 'al patrulea trimestru']
};
var ro_lib_localize_monthValues = {
  narrow: ['I', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'noi', 'dec'],
  wide: ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie']
};
var ro_lib_localize_dayValues = {
  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
  short: ['du', 'lu', 'ma', 'mi', 'jo', 'vi', 'sâ'],
  abbreviated: ['dum', 'lun', 'mar', 'mie', 'joi', 'vin', 'sâm'],
  wide: ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă']
};
var ro_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'ami',
    morning: 'dim',
    afternoon: 'da',
    evening: 's',
    night: 'n'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'miezul nopții',
    noon: 'amiază',
    morning: 'dimineață',
    afternoon: 'după-amiază',
    evening: 'seară',
    night: 'noapte'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'miezul nopții',
    noon: 'amiază',
    morning: 'dimineață',
    afternoon: 'după-amiază',
    evening: 'seară',
    night: 'noapte'
  }
};
var ro_lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'amiază',
    morning: 'dimineață',
    afternoon: 'după-amiază',
    evening: 'seară',
    night: 'noapte'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'miezul nopții',
    noon: 'amiază',
    morning: 'dimineață',
    afternoon: 'după-amiază',
    evening: 'seară',
    night: 'noapte'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'miezul nopții',
    noon: 'amiază',
    morning: 'dimineață',
    afternoon: 'după-amiază',
    evening: 'seară',
    night: 'noapte'
  }
};

var ro_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  return String(dirtyNumber);
};

var ro_lib_localize_localize = {
  ordinalNumber: ro_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: ro_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: ro_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: ro_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: ro_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: ro_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: ro_lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var ro_lib_localize = (ro_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ro/_lib/match/index.js


var ro_lib_match_matchOrdinalNumberPattern = /^(\d+)?/i;
var ro_lib_match_parseOrdinalNumberPattern = /\d+/i;
var ro_lib_match_matchEraPatterns = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var ro_lib_match_parseEraPatterns = {
  any: [/^ÎC/i, /^DC/i],
  wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
};
var ro_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
};
var ro_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var ro_lib_match_matchMonthPatterns = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var ro_lib_match_parseMonthPatterns = {
  narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var ro_lib_match_matchDayPatterns = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var ro_lib_match_parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
};
var ro_lib_match_matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var ro_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
};
var ro_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: ro_lib_match_matchOrdinalNumberPattern,
    parsePattern: ro_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ro_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ro_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ro_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ro_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ro_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ro_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ro_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ro_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ro_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: ro_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var ro_lib_match = (ro_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ro/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */

var ro_locale = {
  code: 'ro',
  formatDistance: ro_lib_formatDistance,
  formatLong: ro_lib_formatLong,
  formatRelative: ro_lib_formatRelative,
  localize: ro_lib_localize,
  match: ro_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var ro = (ro_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/_lib/formatDistance/index.js
function formatDistance_declension(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  var rem10 = count % 10;
  var rem100 = count % 100; // 1, 21, 31, ...

  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace('{{count}}', String(count)); // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace('{{count}}', String(count)); // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace('{{count}}', String(count));
  }
}

function buildLocalizeTokenFn(scheme) {
  return function (count, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return formatDistance_declension(scheme.future, count);
        } else {
          return 'через ' + formatDistance_declension(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return formatDistance_declension(scheme.past, count);
        } else {
          return formatDistance_declension(scheme.regular, count) + ' назад';
        }
      }
    } else {
      return formatDistance_declension(scheme.regular, count);
    }
  };
}

var ru_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: buildLocalizeTokenFn({
    regular: {
      one: 'меньше секунды',
      singularNominative: 'меньше {{count}} секунды',
      singularGenitive: 'меньше {{count}} секунд',
      pluralGenitive: 'меньше {{count}} секунд'
    },
    future: {
      one: 'меньше, чем через секунду',
      singularNominative: 'меньше, чем через {{count}} секунду',
      singularGenitive: 'меньше, чем через {{count}} секунды',
      pluralGenitive: 'меньше, чем через {{count}} секунд'
    }
  }),
  xSeconds: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} секунда',
      singularGenitive: '{{count}} секунды',
      pluralGenitive: '{{count}} секунд'
    },
    past: {
      singularNominative: '{{count}} секунду назад',
      singularGenitive: '{{count}} секунды назад',
      pluralGenitive: '{{count}} секунд назад'
    },
    future: {
      singularNominative: 'через {{count}} секунду',
      singularGenitive: 'через {{count}} секунды',
      pluralGenitive: 'через {{count}} секунд'
    }
  }),
  halfAMinute: function halfAMinute(_count, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'через полминуты';
      } else {
        return 'полминуты назад';
      }
    }

    return 'полминуты';
  },
  lessThanXMinutes: buildLocalizeTokenFn({
    regular: {
      one: 'меньше минуты',
      singularNominative: 'меньше {{count}} минуты',
      singularGenitive: 'меньше {{count}} минут',
      pluralGenitive: 'меньше {{count}} минут'
    },
    future: {
      one: 'меньше, чем через минуту',
      singularNominative: 'меньше, чем через {{count}} минуту',
      singularGenitive: 'меньше, чем через {{count}} минуты',
      pluralGenitive: 'меньше, чем через {{count}} минут'
    }
  }),
  xMinutes: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} минута',
      singularGenitive: '{{count}} минуты',
      pluralGenitive: '{{count}} минут'
    },
    past: {
      singularNominative: '{{count}} минуту назад',
      singularGenitive: '{{count}} минуты назад',
      pluralGenitive: '{{count}} минут назад'
    },
    future: {
      singularNominative: 'через {{count}} минуту',
      singularGenitive: 'через {{count}} минуты',
      pluralGenitive: 'через {{count}} минут'
    }
  }),
  aboutXHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} часа',
      singularGenitive: 'около {{count}} часов',
      pluralGenitive: 'около {{count}} часов'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} час',
      singularGenitive: 'приблизительно через {{count}} часа',
      pluralGenitive: 'приблизительно через {{count}} часов'
    }
  }),
  xHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} час',
      singularGenitive: '{{count}} часа',
      pluralGenitive: '{{count}} часов'
    }
  }),
  xDays: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} день',
      singularGenitive: '{{count}} дня',
      pluralGenitive: '{{count}} дней'
    }
  }),
  aboutXWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} недели',
      singularGenitive: 'около {{count}} недель',
      pluralGenitive: 'около {{count}} недель'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} неделю',
      singularGenitive: 'приблизительно через {{count}} недели',
      pluralGenitive: 'приблизительно через {{count}} недель'
    }
  }),
  xWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} неделя',
      singularGenitive: '{{count}} недели',
      pluralGenitive: '{{count}} недель'
    }
  }),
  aboutXMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} месяца',
      singularGenitive: 'около {{count}} месяцев',
      pluralGenitive: 'около {{count}} месяцев'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} месяц',
      singularGenitive: 'приблизительно через {{count}} месяца',
      pluralGenitive: 'приблизительно через {{count}} месяцев'
    }
  }),
  xMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} месяц',
      singularGenitive: '{{count}} месяца',
      pluralGenitive: '{{count}} месяцев'
    }
  }),
  aboutXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} года',
      singularGenitive: 'около {{count}} лет',
      pluralGenitive: 'около {{count}} лет'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} год',
      singularGenitive: 'приблизительно через {{count}} года',
      pluralGenitive: 'приблизительно через {{count}} лет'
    }
  }),
  xYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} год',
      singularGenitive: '{{count}} года',
      pluralGenitive: '{{count}} лет'
    }
  }),
  overXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'больше {{count}} года',
      singularGenitive: 'больше {{count}} лет',
      pluralGenitive: 'больше {{count}} лет'
    },
    future: {
      singularNominative: 'больше, чем через {{count}} год',
      singularGenitive: 'больше, чем через {{count}} года',
      pluralGenitive: 'больше, чем через {{count}} лет'
    }
  }),
  almostXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'почти {{count}} год',
      singularGenitive: 'почти {{count}} года',
      pluralGenitive: 'почти {{count}} лет'
    },
    future: {
      singularNominative: 'почти через {{count}} год',
      singularGenitive: 'почти через {{count}} года',
      pluralGenitive: 'почти через {{count}} лет'
    }
  })
};

var ru_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  return ru_lib_formatDistance_formatDistanceLocale[token](count, options);
};

/* harmony default export */ var ru_lib_formatDistance = (ru_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/_lib/formatLong/index.js

var ru_lib_formatLong_dateFormats = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: 'dd.MM.y'
};
var ru_lib_formatLong_timeFormats = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var ru_lib_formatLong_dateTimeFormats = {
  any: '{{date}}, {{time}}'
};
var ru_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: ru_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: ru_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: ru_lib_formatLong_dateTimeFormats,
    defaultWidth: 'any'
  })
};
/* harmony default export */ var ru_lib_formatLong = (ru_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/_lib/formatRelative/index.js

var accusativeWeekdays = ['воскресенье', 'понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу'];

function formatRelative_lastWeek(day) {
  var weekday = accusativeWeekdays[day];

  switch (day) {
    case 0:
      return "'в прошлое " + weekday + " в' p";

    case 1:
    case 2:
    case 4:
      return "'в прошлый " + weekday + " в' p";

    case 3:
    case 5:
    case 6:
      return "'в прошлую " + weekday + " в' p";
  }
}

function formatRelative_thisWeek(day) {
  var weekday = accusativeWeekdays[day];

  if (day === 2
  /* Tue */
  ) {
      return "'во " + weekday + " в' p";
    } else {
    return "'в " + weekday + " в' p";
  }
}

function formatRelative_nextWeek(day) {
  var weekday = accusativeWeekdays[day];

  switch (day) {
    case 0:
      return "'в следующее " + weekday + " в' p";

    case 1:
    case 2:
    case 4:
      return "'в следующий " + weekday + " в' p";

    case 3:
    case 5:
    case 6:
      return "'в следующую " + weekday + " в' p";
  }
}

var ru_lib_formatRelative_formatRelativeLocale = {
  lastWeek: function lastWeek(date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return formatRelative_thisWeek(day);
    } else {
      return formatRelative_lastWeek(day);
    }
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: function nextWeek(date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return formatRelative_thisWeek(day);
    } else {
      return formatRelative_nextWeek(day);
    }
  },
  other: 'P'
};

var ru_lib_formatRelative_formatRelative = function formatRelative(token, date, baseDate, options) {
  var format = ru_lib_formatRelative_formatRelativeLocale[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
};

/* harmony default export */ var ru_lib_formatRelative = (ru_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/_lib/localize/index.js

var ru_lib_localize_eraValues = {
  narrow: ['до н.э.', 'н.э.'],
  abbreviated: ['до н. э.', 'н. э.'],
  wide: ['до нашей эры', 'нашей эры']
};
var ru_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
  wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
};
var ru_lib_localize_monthValues = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв.', 'фев.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
  wide: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь']
};
var localize_formattingMonthValues = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв.', 'фев.', 'мар.', 'апр.', 'мая', 'июн.', 'июл.', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
  wide: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
};
var ru_lib_localize_dayValues = {
  narrow: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  abbreviated: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'],
  wide: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
};
var ru_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утро',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ночь'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утро',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ночь'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полночь',
    noon: 'полдень',
    morning: 'утро',
    afternoon: 'день',
    evening: 'вечер',
    night: 'ночь'
  }
};
var ru_lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночи'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночи'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полночь',
    noon: 'полдень',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'вечера',
    night: 'ночи'
  }
};

var ru_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  var suffix;

  if (unit === 'date') {
    suffix = '-е';
  } else if (unit === 'week' || unit === 'minute' || unit === 'second') {
    suffix = '-я';
  } else {
    suffix = '-й';
  }

  return number + suffix;
};

var ru_lib_localize_localize = {
  ordinalNumber: ru_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: ru_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: ru_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: ru_lib_localize_monthValues,
    defaultWidth: 'wide',
    formattingValues: localize_formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: ru_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: ru_lib_localize_dayPeriodValues,
    defaultWidth: 'any',
    formattingValues: ru_lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var ru_lib_localize = (ru_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/_lib/match/index.js


var ru_lib_match_matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var ru_lib_match_parseOrdinalNumberPattern = /\d+/i;
var ru_lib_match_matchEraPatterns = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var ru_lib_match_parseEraPatterns = {
  any: [/^д/i, /^н/i]
};
var ru_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var ru_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var ru_lib_match_matchMonthPatterns = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var ru_lib_match_parseMonthPatterns = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
};
var ru_lib_match_matchDayPatterns = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var ru_lib_match_parseDayPatterns = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
};
var ru_lib_match_matchDayPeriodPatterns = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var ru_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
};
var ru_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: ru_lib_match_matchOrdinalNumberPattern,
    parsePattern: ru_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ru_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ru_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ru_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ru_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ru_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ru_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ru_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ru_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: ru_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ru_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var ru_lib_match = (ru_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/ru/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var ru_locale = {
  code: 'ru',
  formatDistance: ru_lib_formatDistance,
  formatLong: ru_lib_formatLong,
  formatRelative: ru_lib_formatRelative,
  localize: ru_lib_localize,
  match: ru_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var ru = (ru_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/_lib/formatDistance/index.js
var sv_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'mindre än en sekund',
    other: 'mindre än {{count}} sekunder'
  },
  xSeconds: {
    one: 'en sekund',
    other: '{{count}} sekunder'
  },
  halfAMinute: 'en halv minut',
  lessThanXMinutes: {
    one: 'mindre än en minut',
    other: 'mindre än {{count}} minuter'
  },
  xMinutes: {
    one: 'en minut',
    other: '{{count}} minuter'
  },
  aboutXHours: {
    one: 'ungefär en timme',
    other: 'ungefär {{count}} timmar'
  },
  xHours: {
    one: 'en timme',
    other: '{{count}} timmar'
  },
  xDays: {
    one: 'en dag',
    other: '{{count}} dagar'
  },
  aboutXWeeks: {
    one: 'ungefär en vecka',
    other: 'ungefär {{count}} vecka'
  },
  xWeeks: {
    one: 'en vecka',
    other: '{{count}} vecka'
  },
  aboutXMonths: {
    one: 'ungefär en månad',
    other: 'ungefär {{count}} månader'
  },
  xMonths: {
    one: 'en månad',
    other: '{{count}} månader'
  },
  aboutXYears: {
    one: 'ungefär ett år',
    other: 'ungefär {{count}} år'
  },
  xYears: {
    one: 'ett år',
    other: '{{count}} år'
  },
  overXYears: {
    one: 'över ett år',
    other: 'över {{count}} år'
  },
  almostXYears: {
    one: 'nästan ett år',
    other: 'nästan {{count}} år'
  }
};
var wordMapping = ['noll', 'en', 'två', 'tre', 'fyra', 'fem', 'sex', 'sju', 'åtta', 'nio', 'tio', 'elva', 'tolv'];

var sv_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = sv_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    if (options && options.onlyNumeric) {
      result = tokenValue.other.replace('{{count}}', String(count));
    } else {
      result = tokenValue.other.replace('{{count}}', count < 13 ? wordMapping[count] : String(count));
    }
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'om ' + result;
    } else {
      return result + ' sedan';
    }
  }

  return result;
};

/* harmony default export */ var sv_lib_formatDistance = (sv_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/_lib/formatLong/index.js

var sv_lib_formatLong_dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'y-MM-dd'
};
var sv_lib_formatLong_timeFormats = {
  full: "'kl'. HH:mm:ss zzzz",
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var sv_lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var sv_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: sv_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: sv_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: sv_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var sv_lib_formatLong = (sv_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/_lib/formatRelative/index.js
var sv_lib_formatRelative_formatRelativeLocale = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: 'P'
};

var sv_lib_formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return sv_lib_formatRelative_formatRelativeLocale[token];
};

/* harmony default export */ var sv_lib_formatRelative = (sv_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/_lib/localize/index.js

var sv_lib_localize_eraValues = {
  narrow: ['f.Kr.', 'e.Kr.'],
  abbreviated: ['f.Kr.', 'e.Kr.'],
  wide: ['före Kristus', 'efter Kristus']
};
var sv_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1:a kvartalet', '2:a kvartalet', '3:e kvartalet', '4:e kvartalet']
};
var sv_lib_localize_monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'maj', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']
};
var sv_lib_localize_dayValues = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'],
  abbreviated: ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'],
  wide: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag']
}; // https://www.unicode.org/cldr/charts/32/summary/sv.html#1888

var sv_lib_localize_dayPeriodValues = {
  narrow: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morg.',
    afternoon: 'efterm.',
    evening: 'kväll',
    night: 'natt'
  },
  abbreviated: {
    am: 'f.m.',
    pm: 'e.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morgon',
    afternoon: 'efterm.',
    evening: 'kväll',
    night: 'natt'
  },
  wide: {
    am: 'förmiddag',
    pm: 'eftermiddag',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morgon',
    afternoon: 'eftermiddag',
    evening: 'kväll',
    night: 'natt'
  }
};
var sv_lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på efterm.',
    evening: 'på kvällen',
    night: 'på natten'
  },
  abbreviated: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på efterm.',
    evening: 'på kvällen',
    night: 'på natten'
  },
  wide: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morgonen',
    afternoon: 'på eftermiddagen',
    evening: 'på kvällen',
    night: 'på natten'
  }
};

var sv_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
      case 2:
        return number + ':a';
    }
  }

  return number + ':e';
};

var sv_lib_localize_localize = {
  ordinalNumber: sv_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: sv_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: sv_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: sv_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: sv_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: sv_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: sv_lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var sv_lib_localize = (sv_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/_lib/match/index.js


var sv_lib_match_matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var sv_lib_match_parseOrdinalNumberPattern = /\d+/i;
var sv_lib_match_matchEraPatterns = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var sv_lib_match_parseEraPatterns = {
  any: [/^f/i, /^[ev]/i]
};
var sv_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
};
var sv_lib_match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var sv_lib_match_matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var sv_lib_match_parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var sv_lib_match_matchDayPatterns = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var sv_lib_match_parseDayPatterns = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
var sv_lib_match_matchDayPeriodPatterns = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var sv_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
};
var sv_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: sv_lib_match_matchOrdinalNumberPattern,
    parsePattern: sv_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: sv_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: sv_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: sv_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: sv_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: sv_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: sv_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: sv_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: sv_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: sv_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: sv_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var sv_lib_match = (sv_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */

var sv_locale = {
  code: 'sv',
  formatDistance: sv_lib_formatDistance,
  formatLong: sv_lib_formatLong,
  formatRelative: sv_lib_formatRelative,
  localize: sv_lib_localize,
  match: sv_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var sv = (sv_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/formatDistance/index.js
var zh_CN_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: '不到 1 秒',
    other: '不到 {{count}} 秒'
  },
  xSeconds: {
    one: '1 秒',
    other: '{{count}} 秒'
  },
  halfAMinute: '半分钟',
  lessThanXMinutes: {
    one: '不到 1 分钟',
    other: '不到 {{count}} 分钟'
  },
  xMinutes: {
    one: '1 分钟',
    other: '{{count}} 分钟'
  },
  xHours: {
    one: '1 小时',
    other: '{{count}} 小时'
  },
  aboutXHours: {
    one: '大约 1 小时',
    other: '大约 {{count}} 小时'
  },
  xDays: {
    one: '1 天',
    other: '{{count}} 天'
  },
  aboutXWeeks: {
    one: '大约 1 个星期',
    other: '大约 {{count}} 个星期'
  },
  xWeeks: {
    one: '1 个星期',
    other: '{{count}} 个星期'
  },
  aboutXMonths: {
    one: '大约 1 个月',
    other: '大约 {{count}} 个月'
  },
  xMonths: {
    one: '1 个月',
    other: '{{count}} 个月'
  },
  aboutXYears: {
    one: '大约 1 年',
    other: '大约 {{count}} 年'
  },
  xYears: {
    one: '1 年',
    other: '{{count}} 年'
  },
  overXYears: {
    one: '超过 1 年',
    other: '超过 {{count}} 年'
  },
  almostXYears: {
    one: '将近 1 年',
    other: '将近 {{count}} 年'
  }
};

var zh_CN_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = zh_CN_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + '内';
    } else {
      return result + '前';
    }
  }

  return result;
};

/* harmony default export */ var zh_CN_lib_formatDistance = (zh_CN_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/formatLong/index.js

var zh_CN_lib_formatLong_dateFormats = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: 'yyyy-MM-dd',
  short: 'yy-MM-dd'
};
var zh_CN_lib_formatLong_timeFormats = {
  full: 'zzzz a h:mm:ss',
  long: 'z a h:mm:ss',
  medium: 'a h:mm:ss',
  short: 'a h:mm'
};
var zh_CN_lib_formatLong_dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var zh_CN_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: zh_CN_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: zh_CN_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: zh_CN_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var zh_CN_lib_formatLong = (zh_CN_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/formatRelative/index.js


function checkWeek(date, baseDate, options) {
  var baseFormat = 'eeee p';

  if (isSameUTCWeek(date, baseDate, options)) {
    return baseFormat; // in same week
  } else if (date.getTime() > baseDate.getTime()) {
    return "'下个'" + baseFormat; // in next week
  }

  return "'上个'" + baseFormat; // in last week
}

var zh_CN_lib_formatRelative_formatRelativeLocale = {
  lastWeek: checkWeek,
  // days before yesterday, maybe in this week or last week
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: checkWeek,
  // days after tomorrow, maybe in this week or next week
  other: 'PP p'
};

var zh_CN_lib_formatRelative_formatRelative = function formatRelative(token, date, baseDate, options) {
  var format = zh_CN_lib_formatRelative_formatRelativeLocale[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
};

/* harmony default export */ var zh_CN_lib_formatRelative = (zh_CN_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/localize/index.js

var zh_CN_lib_localize_eraValues = {
  narrow: ['前', '公元'],
  abbreviated: ['前', '公元'],
  wide: ['公元前', '公元']
};
var zh_CN_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['第一季', '第二季', '第三季', '第四季'],
  wide: ['第一季度', '第二季度', '第三季度', '第四季度']
};
var zh_CN_lib_localize_monthValues = {
  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
};
var zh_CN_lib_localize_dayValues = {
  narrow: ['日', '一', '二', '三', '四', '五', '六'],
  short: ['日', '一', '二', '三', '四', '五', '六'],
  abbreviated: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
};
var zh_CN_lib_localize_dayPeriodValues = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '凌晨',
    noon: '午',
    morning: '早',
    afternoon: '下午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  }
};
var zh_CN_lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '凌晨',
    noon: '午',
    morning: '早',
    afternoon: '下午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  }
};

var zh_CN_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);

  switch (options === null || options === void 0 ? void 0 : options.unit) {
    case 'date':
      return number.toString() + '日';

    case 'hour':
      return number.toString() + '时';

    case 'minute':
      return number.toString() + '分';

    case 'second':
      return number.toString() + '秒';

    default:
      return '第 ' + number.toString();
  }
};

var zh_CN_lib_localize_localize = {
  ordinalNumber: zh_CN_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: zh_CN_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: zh_CN_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: zh_CN_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: zh_CN_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: zh_CN_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: zh_CN_lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var zh_CN_lib_localize = (zh_CN_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/match/index.js


var zh_CN_lib_match_matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var zh_CN_lib_match_parseOrdinalNumberPattern = /\d+/i;
var zh_CN_lib_match_matchEraPatterns = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
};
var zh_CN_lib_match_parseEraPatterns = {
  any: [/^(前)/i, /^(公元)/i]
};
var zh_CN_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻钟/i
};
var zh_CN_lib_match_parseQuarterPatterns = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
};
var zh_CN_lib_match_matchMonthPatterns = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var zh_CN_lib_match_parseMonthPatterns = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
};
var zh_CN_lib_match_matchDayPatterns = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^周[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
};
var zh_CN_lib_match_parseDayPatterns = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
};
var zh_CN_lib_match_matchDayPeriodPatterns = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var zh_CN_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
};
var zh_CN_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: zh_CN_lib_match_matchOrdinalNumberPattern,
    parsePattern: zh_CN_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: zh_CN_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: zh_CN_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: zh_CN_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: zh_CN_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: zh_CN_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: zh_CN_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: zh_CN_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: zh_CN_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: zh_CN_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: zh_CN_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var zh_CN_lib_match = (zh_CN_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */

var zh_CN_locale = {
  code: 'zh-CN',
  formatDistance: zh_CN_lib_formatDistance,
  formatLong: zh_CN_lib_formatLong,
  formatRelative: zh_CN_lib_formatRelative,
  localize: zh_CN_lib_localize,
  match: zh_CN_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var zh_CN = (zh_CN_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-TW/_lib/formatDistance/index.js
var zh_TW_lib_formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: '少於 1 秒',
    other: '少於 {{count}} 秒'
  },
  xSeconds: {
    one: '1 秒',
    other: '{{count}} 秒'
  },
  halfAMinute: '半分鐘',
  lessThanXMinutes: {
    one: '少於 1 分鐘',
    other: '少於 {{count}} 分鐘'
  },
  xMinutes: {
    one: '1 分鐘',
    other: '{{count}} 分鐘'
  },
  xHours: {
    one: '1 小時',
    other: '{{count}} 小時'
  },
  aboutXHours: {
    one: '大約 1 小時',
    other: '大約 {{count}} 小時'
  },
  xDays: {
    one: '1 天',
    other: '{{count}} 天'
  },
  aboutXWeeks: {
    one: '大約 1 個星期',
    other: '大約 {{count}} 個星期'
  },
  xWeeks: {
    one: '1 個星期',
    other: '{{count}} 個星期'
  },
  aboutXMonths: {
    one: '大約 1 個月',
    other: '大約 {{count}} 個月'
  },
  xMonths: {
    one: '1 個月',
    other: '{{count}} 個月'
  },
  aboutXYears: {
    one: '大約 1 年',
    other: '大約 {{count}} 年'
  },
  xYears: {
    one: '1 年',
    other: '{{count}} 年'
  },
  overXYears: {
    one: '超過 1 年',
    other: '超過 {{count}} 年'
  },
  almostXYears: {
    one: '將近 1 年',
    other: '將近 {{count}} 年'
  }
};

var zh_TW_lib_formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = zh_TW_lib_formatDistance_formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + '內';
    } else {
      return result + '前';
    }
  }

  return result;
};

/* harmony default export */ var zh_TW_lib_formatDistance = (zh_TW_lib_formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-TW/_lib/formatLong/index.js

var zh_TW_lib_formatLong_dateFormats = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: 'yyyy-MM-dd',
  short: 'yy-MM-dd'
};
var zh_TW_lib_formatLong_timeFormats = {
  full: 'zzzz a h:mm:ss',
  long: 'z a h:mm:ss',
  medium: 'a h:mm:ss',
  short: 'a h:mm'
};
var zh_TW_lib_formatLong_dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var zh_TW_lib_formatLong_formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: zh_TW_lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: zh_TW_lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: zh_TW_lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var zh_TW_lib_formatLong = (zh_TW_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-TW/_lib/formatRelative/index.js
var zh_TW_lib_formatRelative_formatRelativeLocale = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: 'P'
};

var zh_TW_lib_formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return zh_TW_lib_formatRelative_formatRelativeLocale[token];
};

/* harmony default export */ var zh_TW_lib_formatRelative = (zh_TW_lib_formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-TW/_lib/localize/index.js

var zh_TW_lib_localize_eraValues = {
  narrow: ['前', '公元'],
  abbreviated: ['前', '公元'],
  wide: ['公元前', '公元']
};
var zh_TW_lib_localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['第一刻', '第二刻', '第三刻', '第四刻'],
  wide: ['第一刻鐘', '第二刻鐘', '第三刻鐘', '第四刻鐘']
};
var zh_TW_lib_localize_monthValues = {
  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
};
var zh_TW_lib_localize_dayValues = {
  narrow: ['日', '一', '二', '三', '四', '五', '六'],
  short: ['日', '一', '二', '三', '四', '五', '六'],
  abbreviated: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
};
var zh_TW_lib_localize_dayPeriodValues = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '凌晨',
    noon: '午',
    morning: '早',
    afternoon: '下午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜間'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜間'
  }
};
var zh_TW_lib_localize_formattingDayPeriodValues = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '凌晨',
    noon: '午',
    morning: '早',
    afternoon: '下午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜間'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜間'
  }
};

var zh_TW_lib_localize_ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);

  switch (options === null || options === void 0 ? void 0 : options.unit) {
    case 'date':
      return number + '日';

    case 'hour':
      return number + '時';

    case 'minute':
      return number + '分';

    case 'second':
      return number + '秒';

    default:
      return '第 ' + number;
  }
};

var zh_TW_lib_localize_localize = {
  ordinalNumber: zh_TW_lib_localize_ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: zh_TW_lib_localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: zh_TW_lib_localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: zh_TW_lib_localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: zh_TW_lib_localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: zh_TW_lib_localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: zh_TW_lib_localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var zh_TW_lib_localize = (zh_TW_lib_localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-TW/_lib/match/index.js


var zh_TW_lib_match_matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var zh_TW_lib_match_parseOrdinalNumberPattern = /\d+/i;
var zh_TW_lib_match_matchEraPatterns = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
};
var zh_TW_lib_match_parseEraPatterns = {
  any: [/^(前)/i, /^(公元)/i]
};
var zh_TW_lib_match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻鐘/i
};
var zh_TW_lib_match_parseQuarterPatterns = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
};
var zh_TW_lib_match_matchMonthPatterns = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var zh_TW_lib_match_parseMonthPatterns = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
};
var zh_TW_lib_match_matchDayPatterns = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
};
var zh_TW_lib_match_parseDayPatterns = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
};
var zh_TW_lib_match_matchDayPeriodPatterns = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var zh_TW_lib_match_parseDayPeriodPatterns = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
};
var zh_TW_lib_match_match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: zh_TW_lib_match_matchOrdinalNumberPattern,
    parsePattern: zh_TW_lib_match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: zh_TW_lib_match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: zh_TW_lib_match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: zh_TW_lib_match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: zh_TW_lib_match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: zh_TW_lib_match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: zh_TW_lib_match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: zh_TW_lib_match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: zh_TW_lib_match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: zh_TW_lib_match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: zh_TW_lib_match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var zh_TW_lib_match = (zh_TW_lib_match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-TW/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */

var zh_TW_locale = {
  code: 'zh-TW',
  formatDistance: zh_TW_lib_formatDistance,
  formatLong: zh_TW_lib_formatLong,
  formatRelative: zh_TW_lib_formatRelative,
  localize: zh_TW_lib_localize,
  match: zh_TW_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var zh_TW = (zh_TW_locale);
;// CONCATENATED MODULE: ./app/utils/language.ts


var dateFnsLocales = {
  ar: ar,
  de: de,
  en: en_GB,
  es: es,
  fr: fr,
  hi: hi,
  it: it,
  ja: ja,
  nb: nb,
  nl: nl,
  pl: pl,
  "pt-BR": pt_BR,
  pt: pt,
  ro: ro,
  ru: ru,
  se: sv,
  "zh-CN": zh_CN,
  "zh-TW": zh_TW
};
var getDateFnsLocale = function getDateFnsLocale() {
  var localeLang = getNextLocale();
  return dateFnsLocales[localeLang] || en_GB;
};
var getNextLocale = function getNextLocale() {
  var locale = window.localStorage.getItem(country_context/* LOCAL_STORAGE_LOCALE_KEY */.CI);
  return locale !== "defaultLang" ? locale : "en";
};

var internalGetNavigatorLanguage = function internalGetNavigatorLanguage() {
  var checkIpCountry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var language = "";
  var country = "";
  var nextLocale = "";

  if (typeof navigator !== "undefined" && navigator.languages && navigator.languages.length) {
    language = navigator.languages[0];
  } else if (typeof navigator !== "undefined" && navigator.language) {
    language = navigator.language;
  } else {
    language = "en_GB";
  }

  language = language.replaceAll("-", "_");

  if ( true && window.localStorage && checkIpCountry) {
    var localCountry = window.localStorage.getItem(country_context/* LOCAL_STORAGE_COUNTRY_KEY */.VL);

    if (localCountry !== null) {
      try {
        var parsedCountry = JSON.parse(localCountry);
        country = parsedCountry.countryCode;
      } catch (e) {}
    }

    var localLocale = getNextLocale();

    if (localLocale !== null) {
      nextLocale = localLocale;
    }
  }

  if (nextLocale) {
    language = nextLocale;
    language = language.replaceAll("-", "_");
  }

  if (country && checkIpCountry) {
    var splitArray = language.split("_");
    language = "".concat(splitArray[0], "_").concat(country.toUpperCase());
  }

  return language;
};

var getNavigatorLanguage = function getNavigatorLanguage() {
  return internalGetNavigatorLanguage(true);
};
var getNavigatorLanguageForSignUp = function getNavigatorLanguageForSignUp() {
  return internalGetNavigatorLanguage(false);
};

/***/ }),

/***/ 94367:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(95659);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */
function splitPath(filename) {
  // Truncate files names greater than 1024 characters to avoid regex dos
  // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
  const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
  const parts = splitPathRe.exec(truncated);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/rewriteframes.js


/** Rewrite event frames paths */
class RewriteFrames  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'RewriteFrames';}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {RewriteFrames.prototype.__init.call(this);
    this.name = RewriteFrames.id;

    if (options.root) {
      this._root = options.root;
    }
    this._prefix = options.prefix || 'app:///';
    if (options.iteratee) {
      this._iteratee = options.iteratee;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
    // noop
  }

  /** @inheritDoc */
   processEvent(event) {
    return this.process(event);
  }

  /**
   * TODO (v8): Make this private/internal
   */
   process(originalEvent) {
    let processedEvent = originalEvent;

    if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
      processedEvent = this._processExceptionsEvent(processedEvent);
    }

    return processedEvent;
  }

  /**
   * @inheritDoc
   */
    __init() {this._iteratee = (frame) => {
    if (!frame.filename) {
      return frame;
    }
    // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
    const isWindowsFrame =
      /^[a-zA-Z]:\\/.test(frame.filename) ||
      // or the presence of a backslash without a forward slash (which are not allowed on Windows)
      (frame.filename.includes('\\') && !frame.filename.includes('/'));
    // Check if the frame filename begins with `/`
    const startsWithSlash = /^\//.test(frame.filename);
    if (isWindowsFrame || startsWithSlash) {
      const filename = isWindowsFrame
        ? frame.filename
            .replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
      const base = this._root ? relative(this._root, filename) : basename(filename);
      frame.filename = `${this._prefix}${base}`;
    }
    return frame;
  };}

  /** JSDoc */
   _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: this._processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** JSDoc */
   _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => this._iteratee(f)),
    };
  }
} RewriteFrames.__initStatic();


//# sourceMappingURL=rewriteframes.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/version.js
const SDK_VERSION = '7.80.0';


//# sourceMappingURL=version.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

const DEFAULT_IGNORE_TRANSACTIONS = [
  /^.*\/healthcheck$/,
  /^.*\/healthy$/,
  /^.*\/live$/,
  /^.*\/ready$/,
  /^.*\/heartbeat$/,
  /^.*\/health$/,
  /^.*\/healthz$/,
];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */

   constructor(options = {}) {
    this.name = InboundFilters.id;
    this._options = options;
  }

  /**
   * @inheritDoc
   */
   setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
    // noop
  }

  /** @inheritDoc */
   processEvent(event, _eventHint, client) {
    const clientOptions = client.getOptions();
    const options = _mergeOptions(this._options, clientOptions);
    return _shouldDropEvent(event, options) ? null : event;
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS),
    ],
    ignoreTransactions: [
      ...(internalOptions.ignoreTransactions || []),
      ...(clientOptions.ignoreTransactions || []),
      ...(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS),
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  // If event.type, this is not an error
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,string/* stringMatchesSomePattern */.U0)(message, ignoreErrors));
}

function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }

  const name = event.transaction;
  return name ? (0,string/* stringMatchesSomePattern */.U0)(name, ignoreTransactions) : false;
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,string/* stringMatchesSomePattern */.U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,string/* stringMatchesSomePattern */.U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  const possibleMessages = [];

  if (event.message) {
    possibleMessages.push(event.message);
  }

  let lastException;
  try {
    // @ts-expect-error Try catching to save bundle size
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    lastException = event.exception.values[event.exception.values.length - 1];
  } catch (e) {
    // try catching to save bundle size checking existence of variables
  }

  if (lastException) {
    if (lastException.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
      }
    }
  }

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && possibleMessages.length === 0) {
    esm_logger/* logger.error */.kg.error(`Could not extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
  }

  return possibleMessages;
}

function _isSentryError(event) {
  try {
    // @ts-expect-error can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-expect-error we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */

   constructor() {
    this.name = FunctionToString.id;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // intrinsics (like Function.prototype) might be immutable in some environments
    // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Function.prototype.toString = function ( ...args) {
        const context = (0,object/* getOriginalFunction */.HK)(this) || this;
        return originalFunctionToString.apply(context, args);
      };
    } catch (e) {
      // ignore errors here, just don't patch this
    }
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/eventProcessors.js
var eventProcessors = __webpack_require__(71195);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.keys(integrationsByName).map(k => integrationsByName[k]);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,misc/* arrayify */.lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = findIndex(finalIntegrations, integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(client, integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(client, integration, integrationIndex);
    }
  });

  return integrationIndex;
}

/** Setup a single integration.  */
function setupIntegration(client, integration, integrationIndex) {
  integrationIndex[integration.name] = integration;

  if (installedIntegrations.indexOf(integration.name) === -1) {
    integration.setupOnce(eventProcessors/* addGlobalEventProcessor */.cc, esm_hub/* getCurrentHub */.Gd);
    installedIntegrations.push(integration.name);
  }

  if (client.on && typeof integration.preprocessEvent === 'function') {
    const callback = integration.preprocessEvent.bind(integration) ;
    client.on('preprocessEvent', (event, hint) => callback(event, hint, client));
  }

  if (client.addEventProcessor && typeof integration.processEvent === 'function') {
    const callback = integration.processEvent.bind(integration) ;

    const processor = Object.assign((event, hint) => callback(event, hint, client), {
      id: integration.name,
    });

    client.addEventProcessor(processor);
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
}

/** Add an integration to the current hub's client. */
function addIntegration(integration) {
  const client = getCurrentHub().getClient();

  if (!client || !client.addIntegration) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
    return;
  }

  client.addIntegration(integration);
}

// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
  for (let i = 0; i < arr.length; i++) {
    if (callback(arr[i]) === true) {
      return i;
    }
  }

  return -1;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  scope.update(options.initialScope);

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js



const STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const STRIP_FRAME_REGEXP = /captureMessage|captureException/;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    const lines = stack.split('\n');

    for (let i = skipFirst; i < lines.length; i++) {
      const line = lines[i];
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;

      // https://github.com/getsentry/sentry-javascript/issues/7813
      // Skip Error: lines
      if (cleanedLine.match(/\S*Error: /)) {
        continue;
      }

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }

      if (frames.length >= STACKTRACE_FRAME_LIMIT) {
        break;
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  const localStack = Array.from(stack);

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) {
    localStack.pop();
  }

  // Reversing in the middle of the procedure allows us to just pop the values off the stack
  localStack.reverse();

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
    localStack.pop();

    // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
    // is produced within the hub itself, making it:
    //
    //   Sentry.captureException()
    //   getCurrentHub().captureException()
    //
    // instead of just the top `Sentry` call itself.
    // This forces us to possibly strip an additional frame in the exact same was as above.
    if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
      localStack.pop();
    }
  }

  return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(frame => ({
    ...frame,
    filename: frame.filename || localStack[localStack.length - 1].filename,
    function: frame.function || '?',
  }));
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(71235);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/supports.js



// eslint-disable-next-line deprecation/deprecation
const supports_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-expect-error It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in supports_WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(supports_WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = supports_WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in supports_WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}


//# sourceMappingURL=supports.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/vendor/supportsHistory.js


// Based on https://github.com/angular/angular.js/pull/13945/files

// eslint-disable-next-line deprecation/deprecation
const supportsHistory_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (supportsHistory_WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in supportsHistory_WINDOW && !!supportsHistory_WINDOW.history.pushState && !!supportsHistory_WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supportsHistory.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument.js









// eslint-disable-next-line deprecation/deprecation
const instrument_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

const SENTRY_XHR_DATA_KEY = '__sentry_xhr_v2__';

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */
function resetInstrumentationHandlers() {
  Object.keys(handlers).forEach(key => {
    handlers[key ] = undefined;
  });
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${getFunctionName(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!("console" in worldwide/* GLOBAL_OBJ */.n2)) {
    return;
  }

  esm_logger/* CONSOLE_LEVELS.forEach */.RU.forEach(function (level) {
    if (!(level in worldwide/* GLOBAL_OBJ.console */.n2.console)) {
      return;
    }

    (0,object/* fill */.hl)(worldwide/* GLOBAL_OBJ.console */.n2.console, level, function (originalConsoleMethod) {
      esm_logger/* originalConsoleMethods */.LD[level] = originalConsoleMethod;

      return function (...args) {
        triggerHandlers('console', { args, level });

        const log = esm_logger/* originalConsoleMethods */.LD[level];
        log && log.apply(worldwide/* GLOBAL_OBJ.console */.n2.console, args);
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!supportsNativeFetch()) {
    return;
  }

  (0,object/* fill */.hl)(worldwide/* GLOBAL_OBJ */.n2, 'fetch', function (originalFetch) {
    return function (...args) {
      const { method, url } = parseFetchArgs(args);

      const handlerData = {
        args,
        fetchData: {
          method,
          url,
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(worldwide/* GLOBAL_OBJ */.n2, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!(obj )[prop];
}

function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }

  if (!resource) {
    return '';
  }

  if (hasProp(resource, 'url')) {
    return resource.url;
  }

  if (resource.toString) {
    return resource.toString();
  }

  return '';
}

/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: 'GET', url: '' };
  }

  if (fetchArgs.length === 2) {
    const [url, options] = fetchArgs ;

    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET',
    };
  }

  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg ),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET',
  };
}

/** JSDoc */
function instrumentXHR() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (!(instrument_WINDOW ).XMLHttpRequest) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,object/* fill */.hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      const startTimestamp = Date.now();

      const url = args[1];
      const xhrInfo = (this[SENTRY_XHR_DATA_KEY] = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: (0,is/* isString */.HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
        request_headers: {},
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ((0,is/* isString */.HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = () => {
        // For whatever reason, this is not the same instance here as from the outer method
        const xhrInfo = this[SENTRY_XHR_DATA_KEY];

        if (!xhrInfo) {
          return;
        }

        if (this.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = this.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args: args ,
            endTimestamp: Date.now(),
            startTimestamp,
            xhr: this,
          } );
        }
      };

      if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') {
        (0,object/* fill */.hl)(this, 'onreadystatechange', function (original) {
          return function ( ...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      // Intercepting `setRequestHeader` to access the request headers of XHR instance.
      // This will only work for user/library defined headers, not for the default/browser-assigned headers.
      // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
      (0,object/* fill */.hl)(this, 'setRequestHeader', function (original) {
        return function ( ...setRequestHeaderArgs) {
          const [header, value] = setRequestHeaderArgs ;

          const xhrInfo = this[SENTRY_XHR_DATA_KEY];

          if (xhrInfo) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }

          return original.apply(this, setRequestHeaderArgs);
        };
      });

      return originalOpen.apply(this, args);
    };
  });

  (0,object/* fill */.hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      const sentryXhrData = this[SENTRY_XHR_DATA_KEY];
      if (sentryXhrData && args[0] !== undefined) {
        sentryXhrData.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  const oldOnPopState = instrument_WINDOW.onpopstate;
  instrument_WINDOW.onpopstate = function ( ...args) {
    const to = instrument_WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,object/* fill */.hl)(instrument_WINDOW.history, 'pushState', historyReplacementFunction);
  (0,object/* fill */.hl)(instrument_WINDOW.history, 'replaceState', historyReplacementFunction);
}

const DEBOUNCE_DURATION = 1000;
let debounceTimerID;
let lastCapturedEventType;
let lastCapturedEventTargetId;

/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */
function isSimilarToLastCapturedEvent(event) {
  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (event.type !== lastCapturedEventType) {
    return false;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (!event.target || (event.target )._sentryId !== lastCapturedEventTargetId) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return true;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(eventType, target) {
  // We are only interested in filtering `keypress` events for now.
  if (eventType !== 'keypress') {
    return false;
  }

  if (!target || !target.tagName) {
    return true;
  }

  // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
  // e.g.tabbing through elements, hotkeys, etc.
  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
    return false;
  }

  return true;
}

function getEventTarget(event) {
  try {
    return event.target ;
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    return null;
  }
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || event['_sentryCaptured']) {
      return;
    }

    const target = getEventTarget(event);

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event.type, target)) {
      return;
    }

    // Mark event as "seen"
    (0,object/* addNonEnumerableProperty */.xp)(event, '_sentryCaptured', true);

    if (target && !target._sentryId) {
      // Add UUID to event target so we can identify if
      (0,object/* addNonEnumerableProperty */.xp)(target, '_sentryId', (0,misc/* uuid4 */.DM)());
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
    // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    if (!isSimilarToLastCapturedEvent(event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEventType = event.type;
      lastCapturedEventTargetId = target ? target._sentryId : undefined;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = instrument_WINDOW.setTimeout(() => {
      lastCapturedEventTargetId = undefined;
      lastCapturedEventType = undefined;
    }, DEBOUNCE_DURATION);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!instrument_WINDOW.document) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  instrument_WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  instrument_WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (instrument_WINDOW )[target] && (instrument_WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,object/* fill */.hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,object/* fill */.hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = instrument_WINDOW.onerror;

  instrument_WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };

  instrument_WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = instrument_WINDOW.onunhandledrejection;

  instrument_WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };

  instrument_WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=instrument.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    // This should be logged to the console
    // eslint-disable-next-line no-console
    console.error(`Invalid Sentry Dsn: ${str}`);
    return undefined;
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return true;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });

  if (hasMissingRequiredComponent) {
    return false;
  }

  if (!projectId.match(/^\d+$/)) {
    esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }

  if (!isValidProtocol(protocol)) {
    esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }

  if (port && isNaN(parseInt(port, 10))) {
    esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }

  return true;
}

/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */
function dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return undefined;
  }
  return components;
}


//# sourceMappingURL=dsn.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (
    value == null || // this matches null and undefined -> eqeq not eqeqeq
    (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))
  ) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
  // We keep a certain amount of depth.
  // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
  const remainingDepth =
    typeof (value )['__sentry_override_normalization_depth__'] === 'number'
      ? ((value )['__sentry_override_normalization_depth__'] )
      : depth;

  // We're also done if we've reached the max depth
  if (remainingDepth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/* eslint-disable complexity */
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    if ((0,is/* isVueViewModel */.y1)(value)) {
      return '[VueViewModel]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    if (typeof value === 'function') {
      return `[Function: ${getFunctionName(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    const objName = getConstructorName(value);

    // Handle HTML Elements
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }

    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
/* eslint-enable complexity */

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);

  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];

  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);

    if (result) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify(normalize(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
  check_in: 'monitor',
  feedback: 'feedback',
  // TODO: This is a temporary workaround until we have a proper data category for metrics
  statsd: 'unknown',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && dsn && { dsn: dsn_dsnToString(dsn) }),
    ...(dynamicSamplingContext && {
      trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }),
    }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  if (!dsn) {
    return '';
  }

  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && dsn && { dsn: dsn_dsnToString(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session.toJSON()];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(9015);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/constants.js
var constants = __webpack_require__(51131);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js



/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatchs the `createDsc` lifecycle hook as a side effect.
 */
function getDynamicSamplingContextFromClient(
  trace_id,
  client,
  scope,
) {
  const options = client.getOptions();

  const { publicKey: public_key } = client.getDsn() || {};
  const { segment: user_segment } = (scope && scope.getUser()) || {};

  const dsc = (0,object/* dropUndefinedKeys */.Jr)({
    environment: options.environment || constants/* DEFAULT_ENVIRONMENT */.J,
    release: options.release,
    user_segment,
    public_key,
    trace_id,
  }) ;

  client.emit && client.emit('createDsc', dsc);

  return dsc;
}


//# sourceMappingURL=dynamicSamplingContext.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/scope.js
var esm_scope = __webpack_require__(10350);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/utils/prepareEvent.js





/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
  client,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
    timestamp: event.timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);

  // Only put debug IDs onto frames for error events.
  if (event.type === undefined) {
    applyDebugIds(prepared, options.stackParser);
  }

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  let finalScope = scope;
  if (hint.captureContext) {
    finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
  }

  // We prepare the result here with a resolved Event.
  let result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);

  const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  //
  // We need to check for the existence of `finalScope.getAttachments`
  // because `getAttachments` can be undefined if users are using an older version
  // of `@sentry/core` that does not have the `getAttachments` method.
  // See: https://github.com/getsentry/sentry-javascript/issues/5229
  if (finalScope) {
    // Collect attachments from the hint and scope
    if (finalScope.getAttachments) {
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }
    }

    // In case we have a hub we reassign it.
    result = finalScope.applyToEvent(prepared, hint, clientEventProcessors);
  } else {
    // Apply client & global event processors even if there is no scope
    // TODO (v8): Update the order to be Global > Client
    result = (0,eventProcessors/* notifyEventProcessors */.RP)([...clientEventProcessors, ...(0,eventProcessors/* getGlobalEventProcessors */.fH)()], prepared, hint);
  }

  return result.then(evt => {
    if (evt) {
      // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
      // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
      // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
      // any new data
      applyDebugMeta(evt);
    }

    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : constants/* DEFAULT_ENVIRONMENT */.J;
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
  }
}

const debugIdStackParserCache = new WeakMap();

/**
 * Puts debug IDs into the stack frames of an error event.
 */
function applyDebugIds(event, stackParser) {
  const debugIdMap = worldwide/* GLOBAL_OBJ._sentryDebugIds */.n2._sentryDebugIds;

  if (!debugIdMap) {
    return;
  }

  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }

  // Build a map of filename -> debug_id
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;
    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }

    for (let i = parsedStack.length - 1; i >= 0; i--) {
      const stackFrame = parsedStack[i];
      if (stackFrame.filename) {
        acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});

  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.filename) {
          frame.debug_id = filenameDebugIdMap[frame.filename];
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}

/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */
function applyDebugMeta(event) {
  // Extract debug IDs and filenames from the stack frames on the event.
  const filenameDebugIdMap = {};
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.debug_id) {
          if (frame.abs_path) {
            filenameDebugIdMap[frame.abs_path] = frame.debug_id;
          } else if (frame.filename) {
            filenameDebugIdMap[frame.filename] = frame.debug_id;
          }
          delete frame.debug_id;
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }

  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.keys(filenameDebugIdMap).forEach(filename => {
    images.push({
      type: 'sourcemap',
      code_file: filename,
      debug_id: filenameDebugIdMap[filename],
    });
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: normalize(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: normalize(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: normalize(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: normalize(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
      if (span.data) {
        span.data = normalize(span.data, depth, maxBreadth);
      }
      return span;
    });
  }

  return normalized;
}


//# sourceMappingURL=prepareEvent.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js








const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */

  /** Indicates whether this client's integrations have been set up. */

  /** Number of calls being processed */

  /** Holds flushable  */

  // eslint-disable-next-line @typescript-eslint/ban-types

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {
    this._options = options;
    this._integrations = {};
    this._integrationsInitialized = false;
    this._numProcessing = 0;
    this._outcomes = {};
    this._hooks = {};
    this._eventProcessors = [];

    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not send events.');
    }

    if (this._dsn) {
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /** Get all installed event processors. */
   getEventProcessors() {
    return this._eventProcessors;
  }

  /** @inheritDoc */
   addEventProcessor(eventProcessor) {
    this._eventProcessors.push(eventProcessor);
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations(forceInitialize) {
    if ((forceInitialize && !this._integrationsInitialized) || (this._isEnabled() && !this._integrationsInitialized)) {
      this._integrations = setupIntegrations(this, this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    setupIntegration(this, integration, this._integrations);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    this.emit('beforeSendEvent', event, hint);

    let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

    for (const attachment of hint.attachments || []) {
      env = addItemToEnvelope(
        env,
        createAttachmentEnvelopeItem(
          attachment,
          this._options.transportOptions && this._options.transportOptions.textEncoder,
        ),
      );
    }

    const promise = this._sendEnvelope(env);
    if (promise) {
      promise.then(sendResponse => this.emit('afterSendEvent', event, sendResponse), null);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
    void this._sendEnvelope(env);
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, _event) {
    // Note: we use `event` in replay, where we overwrite this hook.

    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */

  /** @inheritdoc */

  /** @inheritdoc */
   on(hook, callback) {
    if (!this._hooks[hook]) {
      this._hooks[hook] = [];
    }

    // @ts-expect-error We assue the types are correct
    this._hooks[hook].push(callback);
  }

  /** @inheritdoc */

  /** @inheritdoc */
   emit(hook, ...rest) {
    if (this._hooks[hook]) {
      this._hooks[hook].forEach(callback => callback(...rest));
    }
  }

  /* eslint-enable @typescript-eslint/unified-signatures */

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a transport is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._transport !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }

    this.emit('preprocessEvent', event, hint);

    return prepareEvent(options, event, hint, scope, this).then(evt => {
      if (evt === null) {
        return evt;
      }

      // If a trace context is not set on the event, we use the propagationContext set on the event to
      // generate a trace context. If the propagationContext does not have a dynamic sampling context, we
      // also generate one for it.
      const { propagationContext } = evt.sdkProcessingMetadata || {};
      const trace = evt.contexts && evt.contexts.trace;
      if (!trace && propagationContext) {
        const { traceId: trace_id, spanId, parentSpanId, dsc } = propagationContext ;
        evt.contexts = {
          trace: {
            trace_id,
            span_id: spanId,
            parent_span_id: parentSpanId,
          },
          ...evt.contexts,
        };

        const dynamicSamplingContext = dsc ? dsc : getDynamicSamplingContextFromClient(trace_id, this, scope);

        evt.sdkProcessingMetadata = {
          dynamicSamplingContext,
          ...evt.sdkProcessingMetadata,
        };
      }
      return evt;
    });
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger/* logger.log */.kg.log(sentryError.message);
          } else {
            esm_logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          throw new SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    this.emit('beforeEnvelope', envelope);

    if (this._isEnabled() && this._transport) {
      return this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new SentryError(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}


//# sourceMappingURL=baseclient.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(68518);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }),
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception) || (0,is/* isDOMException */.fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      // eslint-disable-next-line deprecation/deprecation
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}

function getNonErrorObjectExceptionValue(
  exception,
  { isUnhandledRejection },
) {
  const keys = (0,object/* extractExceptionKeysForMessage */.zf)(exception);
  const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';

  // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
  // We still want to try to get a decent message for these cases
  if ((0,is/* isErrorEvent */.VW)(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }

  if ((0,is/* isEvent */.cO)(exception)) {
    const className = getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }

  return `Object captured as ${captureType} with keys: ${keys}`;
}

function getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : undefined;
  } catch (e) {
    // ignore errors here
  }
}


//# sourceMappingURL=eventbuilder.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/helpers.js



const helpers_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,esm_exports/* withScope */.$e)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,esm_exports/* captureException */.Tb)(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/userfeedback.js


/**
 * Creates an envelope from a user feedback.
 */
function createUserFeedbackEnvelope(
  feedback,
  {
    metadata,
    tunnel,
    dsn,
  }

,
) {
  const headers = {
    event_id: feedback.event_id,
    sent_at: new Date().toISOString(),
    ...(metadata &&
      metadata.sdk && {
        sdk: {
          name: metadata.sdk.name,
          version: metadata.sdk.version,
        },
      }),
    ...(!!tunnel && !!dsn && { dsn: dsn_dsnToString(dsn) }),
  };
  const item = createUserFeedbackEnvelopeItem(feedback);

  return createEnvelope(headers, [item]);
}

function createUserFeedbackEnvelopeItem(feedback) {
  const feedbackHeaders = {
    type: 'user_report',
  };
  return [feedbackHeaders, feedback];
}


//# sourceMappingURL=userfeedback.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js






/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    const sdkSource = helpers_WINDOW.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.S)();

    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: `${sdkSource}:@sentry/browser`,
          version: SDK_VERSION,
        },
      ],
      version: SDK_VERSION,
    };

    super(options);

    if (options.sendClientReports && helpers_WINDOW.document) {
      helpers_WINDOW.document.addEventListener('visibilitychange', () => {
        if (helpers_WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * Sends user feedback to Sentry.
   */
   captureUserFeedback(feedback) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture user feedback.');
      return;
    }

    const envelope = createUserFeedbackEnvelope(feedback, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel,
    });
    void this._sendEnvelope(envelope);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    // This is really the only place where we want to check for a DSN and only send outcomes then
    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));
    void this._sendEnvelope(envelope);
  }
}


//# sourceMappingURL=client.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */

  /** JSDoc */
   constructor(options) {
    this.name = GlobalHandlers.id;
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };

    this._installFunc = {
      onerror: _installGlobalOnErrorHandler,
      onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  addInstrumentationHandler(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && (0,is/* isString */.HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  addInstrumentationHandler(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = (0,is/* isPrimitive */.pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,misc/* addExceptionMechanism */.EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'BroadcastChannel',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'SharedWorker',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {
    this.name = TryCatch.id;
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
      (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: getFunctionName(original) },
        handled: false,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: getFunctionName(original),
          },
          handled: false,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,object/* fill */.hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: getFunctionName(original),
              },
              handled: false,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = getFunctionName(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers_WINDOW ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: getFunctionName(fn),
                target,
              },
              handled: false,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: getFunctionName(fn),
              target,
            },
            handled: false,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}

/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */
function getSanitizedUrlString(url) {
  const { protocol, host, path } = url;

  const filteredHost =
    (host &&
      host
        // Always filter out authority
        .replace(/^.*@/, '[filtered]:[filtered]@')
        // Don't show standard :80 (http) and :443 (https) ports to reduce the noise
        .replace(':80', '')
        .replace(':443', '')) ||
    '';

  return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Breadcrumbs';}

  /**
   * @inheritDoc
   */

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {
    this.name = Breadcrumbs.id;
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      addInstrumentationHandler('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      addInstrumentationHandler('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      addInstrumentationHandler('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      addInstrumentationHandler('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      addInstrumentationHandler('history', _historyBreadcrumb);
    }
    if (this.options.sentry) {
      const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
      client && client.on && client.on('beforeSendEvent', addSentryBreadcrumb);
    }
  }
} Breadcrumbs.__initStatic();

/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */
function addSentryBreadcrumb(event) {
  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
    {
      category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
      event_id: event.event_id,
      level: event.level,
      message: (0,misc/* getEventDescription */.jH)(event),
    },
    {
      event,
    },
  );
}

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _domBreadcrumb(dom) {
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      const event = handlerData.event ;
      target = _isEvent(event)
        ? (0,browser/* htmlTreeAsString */.Rt)(event.target, { keyAttrs, maxStringLength })
        : (0,browser/* htmlTreeAsString */.Rt)(event, { keyAttrs, maxStringLength });
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
function _consoleBreadcrumb(handlerData) {
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _xhrBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  const sentryXhrData = handlerData.xhr[SENTRY_XHR_DATA_KEY];

  // We only capture complete, non-sentry requests
  if (!startTimestamp || !endTimestamp || !sentryXhrData) {
    return;
  }

  const { method, url, status_code, body } = sentryXhrData;

  const data = {
    method,
    url,
    status_code,
  };

  const hint = {
    xhr: handlerData.xhr,
    input: body,
    startTimestamp,
    endTimestamp,
  };

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
    {
      category: 'xhr',
      data,
      type: 'http',
    },
    hint,
  );
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _fetchBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  // We only capture complete fetch requests
  if (!endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    const data = handlerData.fetchData;
    const hint = {
      data: handlerData.error,
      input: handlerData.args,
      startTimestamp,
      endTimestamp,
    };

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data,
        level: 'error',
        type: 'http',
      },
      hint,
    );
  } else {
    const data = {
      ...handlerData.fetchData,
      status_code: handlerData.response && handlerData.response.status,
    };
    const hint = {
      input: handlerData.args,
      response: handlerData.response,
      startTimestamp,
      endTimestamp,
    };
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data,
        type: 'http',
      },
      hint,
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = parseUrl(helpers_WINDOW.location.href);
  let parsedFrom = parseUrl(from);
  const parsedTo = parseUrl(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}

function _isEvent(event) {
  return !!event && !!(event ).target;
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/aggregate-errors.js



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */
function applyAggregateErrorsToEvent(
  exceptionFromErrorImplementation,
  parser,
  maxValueLimit = 250,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return;
  }

  // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
  const originalException =
    event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;

  // We only create exception grouping if there is an exception in the event.
  if (originalException) {
    event.exception.values = truncateAggregateExceptions(
      aggregateExceptionsFromError(
        exceptionFromErrorImplementation,
        parser,
        limit,
        hint.originalException ,
        key,
        event.exception.values,
        originalException,
        0,
      ),
      maxValueLimit,
    );
  }
}

function aggregateExceptionsFromError(
  exceptionFromErrorImplementation,
  parser,
  limit,
  error,
  key,
  prevExceptions,
  exception,
  exceptionId,
) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }

  let newExceptions = [...prevExceptions];

  if ((0,is/* isInstanceOf */.V9)(error[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId);
    const newException = exceptionFromErrorImplementation(parser, error[key]);
    const newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      error[key],
      key,
      [newException, ...newExceptions],
      newException,
      newExceptionId,
    );
  }

  // This will create exception grouping for AggregateErrors
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
  if (Array.isArray(error.errors)) {
    error.errors.forEach((childError, i) => {
      if ((0,is/* isInstanceOf */.V9)(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, childError);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(
          exceptionFromErrorImplementation,
          parser,
          limit,
          childError,
          key,
          [newException, ...newExceptions],
          newException,
          newExceptionId,
        );
      }
    });
  }

  return newExceptions;
}

function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    is_exception_group: true,
    exception_id: exceptionId,
  };
}

function applyExceptionGroupFieldsForChildException(
  exception,
  source,
  exceptionId,
  parentId,
) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    type: 'chained',
    source,
    exception_id: exceptionId,
    parent_id: parentId,
  };
}

/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */
function truncateAggregateExceptions(exceptions, maxValueLength) {
  return exceptions.map(exception => {
    if (exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }
    return exception;
  });
}


//# sourceMappingURL=aggregate-errors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js



const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {
    this.name = LinkedErrors.id;
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /** @inheritdoc */
   setupOnce() {
    // noop
  }

  /**
   * @inheritDoc
   */
   preprocessEvent(event, hint, client) {
    const options = client.getOptions();

    applyAggregateErrorsToEvent(
      exceptionFromError,
      options.stackParser,
      options.maxValueLength,
      this._key,
      this._limit,
      event,
      hint,
    );
  }
} LinkedErrors.__initStatic();


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js


/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */

   constructor() {
    this.name = HttpContext.id;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    // noop
  }

  /** @inheritDoc */
   preprocessEvent(event) {
    // if none of the information we want exists, don't bother
    if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
      return;
    }

    // grab as much info as exists and add it to the event
    const url = (event.request && event.request.url) || (helpers_WINDOW.location && helpers_WINDOW.location.href);
    const { referrer } = helpers_WINDOW.document || {};
    const { userAgent } = helpers_WINDOW.navigator || {};

    const headers = {
      ...(event.request && event.request.headers),
      ...(referrer && { Referer: referrer }),
      ...(userAgent && { 'User-Agent': userAgent }),
    };
    const request = { ...event.request, ...(url && { url }), headers };

    event.request = request;
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

   constructor() {
    this.name = Dedupe.id;
  }

  /** @inheritDoc */
   setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
    // noop
  }

  /**
   * @inheritDoc
   */
   processEvent(currentEvent) {
    // We want to ignore any non-error type events, e.g. transactions or replays
    // These should never be deduped, and also not be compared against as _previousEvent.
    if (currentEvent.type) {
      return currentEvent;
    }

    // Juuust in case something goes wrong
    try {
      if (dedupe_shouldDropEvent(currentEvent, this._previousEvent)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
        return null;
      }
    } catch (_oO) {} // eslint-disable-line no-empty

    return (this._previousEvent = currentEvent);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-expect-error Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    in_app: true, // All browser frames are considered in_app
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = createStackParser(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  // We use this to identifify if the transport is the base transport
  // TODO (v8): Remove this again as we'll no longer need it
  send.__sentry__baseTransport__ = true;

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if (isNativeFetch(helpers_WINDOW.fetch)) {
    return (cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW));
  }

  const document = helpers_WINDOW.document;
  let fetchImpl = helpers_WINDOW.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers_WINDOW));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  let pendingBodySize = 0;
  let pendingCount = 0;

  function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;

    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 60000 && pendingCount < 15,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => {
        pendingBodySize -= requestSize;
        pendingCount--;
        return {
          statusCode: response.status,
          headers: {
            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
            'retry-after': response.headers.get('Retry-After'),
          },
        };
      });
    } catch (e) {
      clearCachedFetchImplementation();
      pendingBodySize -= requestSize;
      pendingCount--;
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js














const defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
      options.release = helpers_WINDOW.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: stackParserFromStackParserOptions(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || (supportsFetch() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers_WINDOW.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  addInstrumentationHandler('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}

/**
 * Captures user feedback and sends it to Sentry.
 */
function captureUserFeedback(feedback) {
  const client = getCurrentHub().getClient();
  if (client) {
    client.captureUserFeedback(feedback);
  }
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function sdk_init(options) {
  const opts = {
    _metadata: {} ,
    ...options,
  };

  opts._metadata.sdk = opts._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: SDK_VERSION,
      },
    ],
    version: SDK_VERSION,
  };
  init(opts);
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,is/* isString */.HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  if (!dynamicSamplingContext) {
    return undefined;
  }

  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/tracing.js



const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }

  const matches = traceparent.match(TRACEPARENT_REGEXP);
  if (!matches) {
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}

/**
 * Create tracing context from incoming headers.
 */
function tracingContextFromHeaders(
  sentryTrace,
  baggage,
)

 {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

  const { traceId, parentSpanId, parentSampled } = traceparentData || {};

  const propagationContext = {
    traceId: traceId || (0,misc/* uuid4 */.DM)(),
    spanId: (0,misc/* uuid4 */.DM)().substring(16),
    sampled: parentSampled,
  };

  if (parentSpanId) {
    propagationContext.parentSpanId = parentSpanId;
  }

  if (dynamicSamplingContext) {
    propagationContext.dsc = dynamicSamplingContext ;
  }

  return {
    traceparentData,
    dynamicSamplingContext,
    propagationContext,
  };
}

/**
 * Create sentry-trace header from span context values.
 */
function generateSentryTraceHeader(
  traceId = (0,misc/* uuid4 */.DM)(),
  spanId = (0,misc/* uuid4 */.DM)().substring(16),
  sampled,
) {
  let sampledString = '';
  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }
  return `${traceId}-${spanId}${sampledString}`;
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/span.js


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {

   constructor(maxlen = 1000) {
    this._maxlen = maxlen;
    this.spans = [];
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * The instrumenter that created this span.
   */

  /**
   * The origin of the span, giving context about what created the span.
   */

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext = {}) {
    this.traceId = spanContext.traceId || (0,misc/* uuid4 */.DM)();
    this.spanId = spanContext.spanId || (0,misc/* uuid4 */.DM)().substring(16);
    this.startTimestamp = spanContext.startTimestamp || (0,esm_time/* timestampInSeconds */.ph)();
    this.tags = spanContext.tags || {};
    this.data = spanContext.data || {};
    this.instrumenter = spanContext.instrumenter || 'sentry';
    this.origin = spanContext.origin || 'manual';

    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.name) {
      this.description = spanContext.name;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
  }

  /** An alias for `description` of the Span. */
   get name() {
    return this.description || '';
  }
  /** Update the name of the span. */
   set name(name) {
    this.setName(name);
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      esm_logger/* logger.log */.kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    this.setData('http.response.status_code', httpStatus);
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   setName(name) {
    this.description = name;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        esm_logger/* logger.log */.kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,esm_time/* timestampInSeconds */.ph)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    return generateSentryTraceHeader(this.traceId, this.spanId, this.sampled);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = spanContext.data || {};
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = spanContext.spanId || this.spanId;
    this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
    this.status = spanContext.status;
    this.tags = spanContext.tags || {};
    this.traceId = spanContext.traceId || this.traceId;

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
      origin: this.origin,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
      origin: this.origin,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/transaction.js





/** JSDoc */
class Transaction extends Span  {

  /**
   * The reference to the current hub.
   */

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);
    // We need to delete description since it's set by the Span class constructor
    // but not needed for transactions.
    delete this.description;

    this._measurements = {};
    this._contexts = {};

    this._hub = hub || (0,esm_hub/* getCurrentHub */.Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new SpanRecorder(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    const transaction = this._finishTransaction(endTimestamp);
    if (!transaction) {
      return undefined;
    }
    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return (0,object/* dropUndefinedKeys */.Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = transactionContext.name || '';

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || (0,esm_hub/* getCurrentHub */.Gd)();
    const client = hub.getClient();

    if (!client) return {};

    const scope = hub.getScope();
    const dsc = getDynamicSamplingContextFromClient(this.traceId, client, scope);

    const maybeSampleRate = this.metadata.sampleRate;
    if (maybeSampleRate !== undefined) {
      dsc.sample_rate = `${maybeSampleRate}`;
    }

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = this.metadata.source;
    if (source && source !== 'url') {
      dsc.transaction = this.name;
    }

    if (this.sampled !== undefined) {
      dsc.sampled = String(this.sampled);
    }

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    return dsc;
  }

  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
   setHub(hub) {
    this._hub = hub;
  }

  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
   _finishTransaction(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    const client = this._hub.getClient();
    if (client && client.emit) {
      client.emit('finishTransaction', this);
    }

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return transaction;
  }
}


//# sourceMappingURL=transaction.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/idletransaction.js




const TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  heartbeatInterval: 5000,
};

const FINISH_REASON_TAG = 'finishReason';

const IDLE_TRANSACTION_FINISH_REASONS = [
  'heartbeatFailed',
  'idleTimeout',
  'documentHidden',
  'finalTimeout',
  'externalFinish',
  'cancelled',
];

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends SpanRecorder {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,esm_time/* timestampInSeconds */.ph)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends Transaction {
  // Activities store a list of active spans

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.

  // We should not use heartbeat if we finished a transaction

  // Idle timeout was canceled and we should finish the transaction with the last span end.

  /**
   * Timer that tracks Transaction idleTimeout
   */

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = TRACING_DEFAULTS.idleTimeout,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = TRACING_DEFAULTS.finalTimeout,
      _heartbeatInterval = TRACING_DEFAULTS.heartbeatInterval,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;
    this.activities = {};
    this._heartbeatCounter = 0;
    this._finished = false;
    this._idleTimeoutCanceledPermanently = false;
    this._beforeFinishCallbacks = [];
    this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];

    if (_onScope) {
      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._restartIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,esm_time/* timestampInSeconds */.ph)()) {
    this._finished = true;
    this.activities = {};

    if (this.op === 'ui.action.click') {
      this.setTag(FINISH_REASON_TAG, this._finishReason);
    }

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            esm_logger/* logger.log */.kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const spanStartedBeforeTransactionFinish = span.startTimestamp < endTimestamp;

        // Add a delta with idle timeout so that we prevent false positives
        const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
        const spanEndedBeforeFinalTimeout = span.endTimestamp - this.startTimestamp < timeoutWithMarginOfError;

        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          const stringifiedSpan = JSON.stringify(span, undefined, 2);
          if (!spanStartedBeforeTransactionFinish) {
            esm_logger/* logger.log */.kg.log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
          } else if (!spanEndedBeforeFinalTimeout) {
            esm_logger/* logger.log */.kg.log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
          }
        }

        return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      const scope = this._idleHub.getScope();
      if (scope.getTransaction() === this) {
        scope.setSpan(undefined);
      }
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
   cancelIdleTimeout(
    endTimestamp,
    {
      restartOnChildSpanChange,
    }

 = {
      restartOnChildSpanChange: true,
    },
  ) {
    this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;

      if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      }
    }
  }

  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
   setFinishReason(reason) {
    this._finishReason = reason;
  }

  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
   _restartIdleTimeout(endTimestamp) {
    this.cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this.cancelIdleTimeout(undefined, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently });
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      const endTimestamp = (0,esm_time/* timestampInSeconds */.ph)();
      if (this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      } else {
        // We need to add the timeout here to have the real endtimestamp of the transaction
        // Remember timestampInSeconds is in seconds, timeout is in ms
        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
      }
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}


//# sourceMappingURL=idletransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js



/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  return scope.getTransaction() ;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/errors.js



let errorsInstrumented = false;

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }

  errorsInstrumented = true;
  addInstrumentationHandler('error', errorCallback);
  addInstrumentationHandler('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = getActiveTransaction();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}

// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = 'sentry_tracingErrorCallback';


//# sourceMappingURL=errors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/sampling.js



/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */
function sampleTransaction(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!hasTracingEnabled(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    transaction.setMetadata({
      sampleRate,
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}


//# sourceMappingURL=sampling.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  const span = scope.getSpan();

  return span
    ? {
        'sentry-trace': span.toTraceparent(),
      }
    : {};
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    transactionContext.sampled = false;
  }

  let transaction = new Transaction(transactionContext, this);
  transaction = sampleTransaction(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new IdleTransaction(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sampleTransaction(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Adds tracing extensions to the global hub.
 */
function addTracingExtensions() {
  const carrier = (0,esm_hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }

  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/types.js


const types_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (types_WINDOW && types_WINDOW.document) {
    types_WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = getActiveTransaction() ;
      if (types_WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = types_WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = types_WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      // eslint-disable-next-line deprecation/deprecation
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      types_WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (types_WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || types_WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      handleEntries(po.takeRecords() );
      report(true);
    };

    onHidden(stopListening);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return types_WINDOW.document.visibilityState === 'hidden' && !types_WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/instrument.js






const instrument_handlers = {};
const instrument_instrumented = {};

let _previousCls;
let _previousFid;
let _previousLcp;

/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addClsInstrumentationHandler(callback) {
  return addMetricObserver('cls', callback, instrumentCls, _previousCls);
}

/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addLcpInstrumentationHandler(callback) {
  return addMetricObserver('lcp', callback, instrumentLcp, _previousLcp);
}

/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addFidInstrumentationHandler(callback) {
  return addMetricObserver('fid', callback, instrumentFid, _previousFid);
}

/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addPerformanceInstrumentationHandler(
  type,
  callback,
) {
  addHandler(type, callback);

  if (!instrument_instrumented[type]) {
    instrumentPerformanceObserver(type);
    instrument_instrumented[type] = true;
  }

  return getCleanupCallback(type, callback);
}

/** Trigger all handlers of a given type. */
function instrument_triggerHandlers(type, data) {
  const typeHandlers = instrument_handlers[type];

  if (!typeHandlers || !typeHandlers.length) {
    return;
  }

  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${getFunctionName(handler)}\nError:`,
          e,
        );
    }
  }
}

function instrumentCls() {
  onCLS(metric => {
    instrument_triggerHandlers('cls', {
      metric,
    });
    _previousCls = metric;
  });
}

function instrumentFid() {
  onFID(metric => {
    instrument_triggerHandlers('fid', {
      metric,
    });
    _previousFid = metric;
  });
}

function instrumentLcp() {
  onLCP(metric => {
    instrument_triggerHandlers('lcp', {
      metric,
    });
    _previousLcp = metric;
  });
}

function addMetricObserver(
  type,
  callback,
  instrumentFn,
  previousValue,
) {
  addHandler(type, callback);

  if (!instrument_instrumented[type]) {
    instrumentFn();
    instrument_instrumented[type] = true;
  }

  if (previousValue) {
    callback({ metric: previousValue });
  }

  return getCleanupCallback(type, callback);
}

function instrumentPerformanceObserver(type) {
  const options = {};

  // Special per-type options we want to use
  if (type === 'event') {
    options.durationThreshold = 0;
  }

  observe(
    type,
    entries => {
      instrument_triggerHandlers(type, { entries });
    },
    options,
  );
}

function addHandler(type, handler) {
  instrument_handlers[type] = instrument_handlers[type] || [];
  (instrument_handlers[type] ).push(handler);
}

// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(type, callback) {
  return () => {
    const typeHandlers = instrument_handlers[type];

    if (!typeHandlers) {
      return;
    }

    const index = typeHandlers.indexOf(callback);
    if (index !== -1) {
      typeHandlers.splice(index, 1);
    }
  };
}


//# sourceMappingURL=instrument.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js







/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

function getBrowserPerformanceAPI() {
  // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
  return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    if (performance.mark) {
      types_WINDOW.performance.mark('sentry-tracing-init');
    }
    const fidCallback = _trackFID();
    const clsCallback = _trackCLS();
    const lcpCallback = _trackLCP();

    return () => {
      fidCallback();
      clsCallback();
      lcpCallback();
    };
  }

  return () => undefined;
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  addPerformanceInstrumentationHandler('longtask', ({ entries }) => {
    for (const entry of entries) {
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }
      const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = msToSec(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        origin: 'auto.ui.browser.metrics',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  });
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  addPerformanceInstrumentationHandler('event', ({ entries }) => {
    for (const entry of entries) {
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }

      if (entry.name === 'click') {
        const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
        const duration = msToSec(entry.duration);

        transaction.startChild({
          description: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
          op: `ui.interaction.${entry.name}`,
          origin: 'auto.ui.browser.metrics',
          startTimestamp: startTime,
          endTimestamp: startTime + duration,
        });
      }
    }
  });
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  return addClsInstrumentationHandler(({ metric }) => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return addLcpInstrumentationHandler(({ metric }) => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  });
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  return addFidInstrumentationHandler(({ metric }) => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = msToSec(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types_WINDOW.performance.getEntries || !esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = msToSec(entry.startTime);
    const duration = msToSec(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + msToSec(entry.responseStart);
        requestStartTimestamp = timeOrigin + msToSec(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(types_WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + msToSec(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + msToSec(_measurements['fid'].value),
        op: 'ui.action',
        origin: 'auto.ui.browser.metrics',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    origin: 'auto.resource.browser.metrics',
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    origin: 'auto.browser.browser.metrics',
    description: description || event,
    startTimestamp: timeOrigin + msToSec(start),
    endTimestamp: timeOrigin + msToSec(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    origin: 'auto.browser.browser.metrics',
    description: 'request',
    startTimestamp: timeOrigin + msToSec(entry.requestStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    origin: 'auto.browser.browser.metrics',
    description: 'response',
    startTimestamp: timeOrigin + msToSec(entry.responseStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['http.response_transfer_size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['http.response_content_length'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['http.decoded_response_content_length'] = entry.decodedBodySize;
  }
  if ('renderBlockingStatus' in entry) {
    data['resource.render_blocking_status'] = entry.renderBlockingStatus;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    origin: 'auto.resource.browser.metrics',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types_WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js




/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\/(?!\/)/];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  enableHTTPTimings: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  const {
    traceFetch,
    traceXHR,
    // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets,
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins,
    shouldCreateSpanForRequest,
    enableHTTPTimings,
  } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    addInstrumentationHandler('fetch', (handlerData) => {
      const createdSpan = fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }

  if (traceXHR) {
    addInstrumentationHandler('xhr', (handlerData) => {
      const createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }
}

function isPerformanceResourceTiming(entry) {
  return (
    entry.entryType === 'resource' &&
    'initiatorType' in entry &&
    typeof (entry ).nextHopProtocol === 'string' &&
    (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest')
  );
}

/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */
function addHTTPTimings(span) {
  const url = span.data.url;

  if (!url) {
    return;
  }

  const cleanup = addPerformanceInstrumentationHandler('resource', ({ entries }) => {
    entries.forEach(entry => {
      if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
        const spanData = resourceTimingEntryToSpanData(entry);
        spanData.forEach(data => span.setData(...data));
        // In the next tick, clean this handler up
        // We have to wait here because otherwise this cleans itself up before it is fully done
        setTimeout(cleanup);
      }
    });
  });
}

/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */
function extractNetworkProtocol(nextHopProtocol) {
  let name = 'unknown';
  let version = 'unknown';
  let _name = '';
  for (const char of nextHopProtocol) {
    // http/1.1 etc.
    if (char === '/') {
      [name, version] = nextHopProtocol.split('/');
      break;
    }
    // h2, h3 etc.
    if (!isNaN(Number(char))) {
      name = _name === 'h' ? 'http' : _name;
      version = nextHopProtocol.split(_name)[1];
      break;
    }
    _name += char;
  }
  if (_name === nextHopProtocol) {
    // webrtc, ftp, etc.
    name = _name;
  }
  return { name, version };
}

function getAbsoluteTime(time = 0) {
  return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || performance.timeOrigin) + time) / 1000;
}

function resourceTimingEntryToSpanData(resourceTiming) {
  const { name, version } = extractNetworkProtocol(resourceTiming.nextHopProtocol);

  const timingSpanData = [];

  timingSpanData.push(['network.protocol.version', version], ['network.protocol.name', name]);

  if (!esm_time/* browserPerformanceTimeOrigin */.Z1) {
    return timingSpanData;
  }
  return [
    ...timingSpanData,
    ['http.request.redirect_start', getAbsoluteTime(resourceTiming.redirectStart)],
    ['http.request.fetch_start', getAbsoluteTime(resourceTiming.fetchStart)],
    ['http.request.domain_lookup_start', getAbsoluteTime(resourceTiming.domainLookupStart)],
    ['http.request.domain_lookup_end', getAbsoluteTime(resourceTiming.domainLookupEnd)],
    ['http.request.connect_start', getAbsoluteTime(resourceTiming.connectStart)],
    ['http.request.secure_connection_start', getAbsoluteTime(resourceTiming.secureConnectionStart)],
    ['http.request.connection_end', getAbsoluteTime(resourceTiming.connectEnd)],
    ['http.request.request_start', getAbsoluteTime(resourceTiming.requestStart)],
    ['http.request.response_start', getAbsoluteTime(resourceTiming.responseStart)],
    ['http.request.response_end', getAbsoluteTime(resourceTiming.responseEnd)],
  ];
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track fetch request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!hasTracingEnabled() || !handlerData.fetchData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);

  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);

        const contentLength =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');

        const contentLengthNum = parseInt(contentLength);
        if (contentLengthNum > 0) {
          span.setData('http.response_content_length', contentLengthNum);
        }
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  const client = hub.getClient();
  const parentSpan = scope.getSpan();

  const { method, url } = handlerData.fetchData;

  const span =
    shouldCreateSpanResult && parentSpan
      ? parentSpan.startChild({
          data: {
            url,
            type: 'fetch',
            'http.method': method,
          },
          description: `${method} ${url}`,
          op: 'http.client',
          origin: 'auto.http.browser',
        })
      : undefined;

  if (span) {
    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;
  }

  if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
    options.headers = addTracingHeadersToFetchRequest(request, client, scope, options, span);
  }

  return span;
}

/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */
function addTracingHeadersToFetchRequest(
  request, // unknown is actually type Request but we can't export DOM types from this package,
  client,
  scope,
  options

,
  requestSpan,
) {
  const span = requestSpan || scope.getSpan();

  const transaction = span && span.transaction;

  const { traceId, sampled, dsc } = scope.getPropagationContext();

  const sentryTraceHeader = span ? span.toTraceparent() : generateSentryTraceHeader(traceId, undefined, sampled);
  const dynamicSamplingContext = transaction
    ? transaction.getDynamicSamplingContext()
    : dsc
    ? dsc
    : getDynamicSamplingContextFromClient(traceId, client, scope);

  const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);

  const headers =
    typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended multiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([BAGGAGE_HEADER_NAME, sentryBaggageHeader]);
    }

    return newHeaders ;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
// eslint-disable-next-line complexity
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  const xhr = handlerData.xhr;
  const sentryXhrData = xhr && xhr[SENTRY_XHR_DATA_KEY];

  if (!hasTracingEnabled() || (xhr && xhr.__sentry_own_request__) || !xhr || !sentryXhrData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(sentryXhrData.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  const parentSpan = scope.getSpan();

  const span =
    shouldCreateSpanResult && parentSpan
      ? parentSpan.startChild({
          data: {
            ...sentryXhrData.data,
            type: 'xhr',
            'http.method': sentryXhrData.method,
            url: sentryXhrData.url,
          },
          description: `${sentryXhrData.method} ${sentryXhrData.url}`,
          op: 'http.client',
          origin: 'auto.http.browser',
        })
      : undefined;

  if (span) {
    xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
  }

  if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
    if (span) {
      const transaction = span && span.transaction;
      const dynamicSamplingContext = transaction && transaction.getDynamicSamplingContext();
      const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
      setHeaderOnXhr(xhr, span.toTraceparent(), sentryBaggageHeader);
    } else {
      const client = hub.getClient();
      const { traceId, sampled, dsc } = scope.getPropagationContext();
      const sentryTraceHeader = generateSentryTraceHeader(traceId, undefined, sampled);
      const dynamicSamplingContext =
        dsc || (client ? getDynamicSamplingContextFromClient(traceId, client, scope) : undefined);
      const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
      setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
  }

  return span;
}

function setHeaderOnXhr(
  xhr,
  sentryTraceHeader,
  sentryBaggageHeader,
) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
    if (sentryBaggageHeader) {
      // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
      // We can therefore simply set a baggage header without checking what was there before
      // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }
  } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types_WINDOW || !types_WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types_WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types_WINDOW.location.pathname,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      op: 'pageload',
      origin: 'auto.pageload.browser',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    addInstrumentationHandler('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: types_WINDOW.location.pathname,
          op: 'navigation',
          origin: 'auto.navigation.browser',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js








const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...TRACING_DEFAULTS,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  _experiments: {},
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */

   constructor(_options) {
    this.name = BROWSER_TRACING_INTEGRATION_ID;
    this._hasSetTracePropagationTargets = false;

    addTracingExtensions();

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      this._hasSetTracePropagationTargets = !!(
        _options &&
        // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins)
      );
    }

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    this._collectWebVitals = startTrackingWebVitals();
    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }
    if (this.options._experiments.enableInteractions) {
      startTrackingInteractions();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;
    const hub = getCurrentHub();
    const client = hub.getClient();
    const clientOptions = client && client.getOptions();

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
      _experiments,
    } = this.options;

    const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
    // There are three ways to configure tracePropagationTargets:
    // 1. via top level client option `tracePropagationTargets`
    // 2. via BrowserTracing option `tracePropagationTargets`
    // 3. via BrowserTracing option `tracingOrigins` (deprecated)
    //
    // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
    // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
    // This is done as it minimizes bundle size (we don't have to have undefined checks).
    //
    // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
    // eslint-disable-next-line deprecation/deprecation
    const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
      esm_logger/* logger.warn */.kg.warn(
        '[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.',
      );
    }

    instrumentRouting(
      (context) => {
        const transaction = this._createRouteTransaction(context);

        this.options._experiments.onStartRouteTransaction &&
          this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);

        return transaction;
      },
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const hub = this._getCurrentHub();

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTrace = isPageloadTransaction ? getMetaContent('sentry-trace') : '';
    const baggage = isPageloadTransaction ? getMetaContent('baggage') : '';
    const { traceparentData, dynamicSamplingContext, propagationContext } = tracingContextFromHeaders(
      sentryTrace,
      baggage,
    );

    const expandedContext = {
      ...context,
      ...traceparentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    this._latestRouteName = finalContext.name;
    this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const { location } = types_WINDOW;

    const idleTransaction = startIdleTransaction(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );

    const scope = hub.getScope();

    // If it's a pageload and there is a meta tag set
    // use the traceparentData as the propagation context
    if (isPageloadTransaction && traceparentData) {
      scope.setPropagationContext(propagationContext);
    } else {
      // Navigation transactions should set a new propagation context based on the
      // created idle transaction.
      scope.setPropagationContext({
        traceId: idleTransaction.traceId,
        spanId: idleTransaction.spanId,
        parentSpanId: idleTransaction.parentSpanId,
        sampled: idleTransaction.sampled,
      });
    }

    idleTransaction.registerBeforeFinishCallback(transaction => {
      this._collectWebVitals();
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;
      const op = 'ui.action.click';

      const currentTransaction = getActiveTransaction();
      if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.warn */.kg.warn(
            `[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`,
          );
        return undefined;
      }

      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.setFinishReason('interactionInterrupted');
        inflightInteractionTransaction.finish();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = types_WINDOW;

      const context = {
        name: this._latestRouteName,
        op,
        trimEnd: true,
        metadata: {
          source: this._latestRouteSource || 'url',
        },
      };

      inflightInteractionTransaction = startIdleTransaction(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    });
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : undefined;
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(83454);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}


//# sourceMappingURL=getVercelEnv.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: SDK_VERSION,
      })),
      version: SDK_VERSION,
    } );
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/appRouterRoutingInstrumentation.js



const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-app-router',
} ;

/**
 * Instruments the Next.js Clientside App Router.
 */
function appRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  // We keep track of the active transaction so we can finish it when we start a navigation transaction.
  let activeTransaction = undefined;

  // We keep track of the previous location name so we can set the `from` field on navigation transactions.
  // This is either a route or a pathname.
  let prevLocationName = helpers_WINDOW.location.pathname;

  if (startTransactionOnPageLoad) {
    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      origin: 'auto.pageload.nextjs.app_router_instrumentation',
      tags: DEFAULT_TAGS,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    addInstrumentationHandler('fetch', (handlerData) => {
      // The instrumentation handler is invoked twice - once for starting a request and once when the req finishes
      // We can use the existence of the end-timestamp to filter out "finishing"-events.
      if (handlerData.endTimestamp !== undefined) {
        return;
      }

      // Only GET requests can be navigating RSC requests
      if (handlerData.fetchData.method !== 'GET') {
        return;
      }

      const parsedNavigatingRscFetchArgs = parseNavigatingRscFetchArgs(handlerData.args);

      if (parsedNavigatingRscFetchArgs === null) {
        return;
      }

      const transactionName = parsedNavigatingRscFetchArgs.targetPathname;
      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      startTransactionCb({
        name: transactionName,
        op: 'navigation',
        origin: 'auto.navigation.nextjs.app_router_instrumentation',
        tags,
        metadata: { source: 'url' },
      });
    });
  }
}

function parseNavigatingRscFetchArgs(fetchArgs)

 {
  // Make sure the first arg is a URL object
  if (!fetchArgs[0] || typeof fetchArgs[0] !== 'object' || (fetchArgs[0] ).searchParams === undefined) {
    return null;
  }

  // Make sure the second argument is some kind of fetch config obj that contains headers
  if (!fetchArgs[1] || typeof fetchArgs[1] !== 'object' || !('headers' in fetchArgs[1])) {
    return null;
  }

  try {
    const url = fetchArgs[0] ;
    const headers = fetchArgs[1].headers ;

    // Not an RSC request
    if (headers['RSC'] !== '1') {
      return null;
    }

    // Prefetch requests are not navigating RSC requests
    if (headers['Next-Router-Prefetch'] === '1') {
      return null;
    }

    return {
      targetPathname: url.pathname,
    };
  } catch (e) {
    return null;
  }
}


//# sourceMappingURL=appRouterRoutingInstrumentation.js.map

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/pagesRouterRoutingInstrumentation.js





const globalObject = helpers_WINDOW

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    nextDataTagInfo.sentryTrace = props.pageProps._sentryTraceData;
    nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
  }

  return nextDataTagInfo;
}

const pagesRouterRoutingInstrumentation_DEFAULT_TAGS = {
  'routing.instrumentation': 'next-pages-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

/**
 * Instruments the Next.js pages router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function pagesRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, params, sentryTrace, baggage } = extractNextDataTagInformation();
  const { traceparentData, dynamicSamplingContext, propagationContext } = tracingContextFromHeaders(
    sentryTrace,
    baggage,
  );

  (0,esm_hub/* getCurrentHub */.Gd)().getScope().setPropagationContext(propagationContext);
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      origin: 'auto.pageload.nextjs.pages_router_instrumentation',
      tags: pagesRouterRoutingInstrumentation_DEFAULT_TAGS,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceparentData,
      metadata: {
        source,
        dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const strippedNavigationTarget = stripUrlQueryAndFragment(navigationTarget);
      const matchedRoute = getNextRouteFromPathname(strippedNavigationTarget);

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = strippedNavigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...pagesRouterRoutingInstrumentation_DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        origin: 'auto.navigation.nextjs.pages_router_instrumentation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          origin: 'auto.ui.nextjs.pages_router_instrumentation',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=pagesRouterRoutingInstrumentation.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/nextRoutingInstrumentation.js




/**
 * Instruments the Next.js Clientside Router.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const isAppRouter = !helpers_WINDOW.document.getElementById('__NEXT_DATA__');
  if (isAppRouter) {
    appRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange);
  } else {
    pagesRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange);
  }
}


//# sourceMappingURL=nextRoutingInstrumentation.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


const globalWithInjectedValues = __webpack_require__.g

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = dsnFromString(options.dsn);
    if (!dsnComponents) {
      return;
    }
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      options.tunnel = tunnelPath;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/index.js


























// Treeshakable guard to remove all code related to tracing

const client_globalWithInjectedValues = __webpack_require__.g

;

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  const opts = {
    environment: getVercelEnv(true) || "production",
    ...options,
  };

  applyTunnelRouteOption(opts);
  buildMetadata(opts, ['nextjs', 'react']);

  addClientIntegrations(opts);

  sdk_init(opts);

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);

    if (false) {}
  });
}

function addClientIntegrations(options) {
  let integrations = options.integrations || [];

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = client_globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  const defaultRewriteFramesIntegration = new RewriteFrames({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
      // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        frame.filename = decodeURI(frame.filename);
      }

      if (
        frame.filename &&
        frame.filename.match(
          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
        )
      ) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }

      return frame;
    },
  });
  integrations = addOrUpdateIntegration(defaultRewriteFramesIntegration, integrations);

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if (hasTracingEnabled(options)) {
      const defaultBrowserTracingIntegration = new BrowserTracing({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
        routingInstrumentation: nextRouterInstrumentation,
      });

      integrations = addOrUpdateIntegration(defaultBrowserTracingIntegration, integrations, {
        'options.routingInstrumentation': nextRouterInstrumentation,
      });
    }
  }

  options.integrations = integrations;
}

/**
 * Just a passthrough in case this is imported from the client.
 */
function withSentryConfig(exportedUserNextConfig) {
  return exportedUserNextConfig;
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./sentry.client.config.js
/* provided dependency */ var sentry_client_config_process = __webpack_require__(83454);
var _sentryCollisionFreeGlobalObject =  false ? 0 : window;

_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
  "id": "rPd1lA3vRa25UhmKWarNJ"
};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = ""; // This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/


var SENTRY_DSN = sentry_client_config_process.env.SENTRY_DSN || sentry_client_config_process.env.NEXT_PUBLIC_SENTRY_DSN;
var DISABLE_SENTRY = "true" === "true";
client_init({
  dsn: SENTRY_DSN || 'https://bab95c1235e441a99c861a99d8f13bc0@o1054791.ingest.sentry.io/6106954',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.05,
  sampleRate: 0.05,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  enabled: !DISABLE_SENTRY
});

/***/ }),

/***/ 44019:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || '';

function getDomainLocale(path, locale, locales, domainLocales) {
  if (true) {
    var normalizeLocalePath = (__webpack_require__(86340).normalizeLocalePath);

    var detectDomainLocale = (__webpack_require__(57565).detectDomainLocale);

    var target = locale || normalizeLocalePath(path, locales).detectedLocale;
    var domain = detectDomainLocale(domainLocales, undefined, target);

    if (domain) {
      var proto = "http".concat(domain.http ? '' : 's', "://");
      var finalLocale = target === domain.defaultLocale ? '' : "/".concat(target);
      return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
    }

    return false;
  } else {}
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 7942:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _router = __webpack_require__(64957);

var _addLocale = __webpack_require__(57995);

var _routerContext = __webpack_require__(30647);

var _appRouterContext = __webpack_require__(51992);

var _useIntersection = __webpack_require__(90639);

var _getDomainLocale = __webpack_require__(44019);

var _addBasePath = __webpack_require__(70227);

'client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options)).catch(function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push';
      router[method](href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react.default.startTransition(navigate);
  } else {
    navigate();
  }
}

var Link = /*#__PURE__*/_react.default.forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react.default.createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react.default.useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react.default.useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react.default.useRef(href);

  var previousAs = _react.default.useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react.default.Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react.default.useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react.default.useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react.default.cloneElement(child, childProps) : /*#__PURE__*/_react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 86340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.normalizeLocalePath = void 0;

var normalizeLocalePath = function normalizeLocalePath(pathname, locales) {
  if (true) {
    return (__webpack_require__(9625).normalizeLocalePath)(pathname, locales);
  }

  return {
    pathname: pathname,
    detectedLocale: undefined
  };
};

exports.normalizeLocalePath = normalizeLocalePath;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 90639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(67294);

var _requestIdleCallback = __webpack_require__(26286);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements.delete(element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 78000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AmpStateContext = _react.default.createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 9470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 51992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AppRouterContext = _react.default.createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react.default.createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react.default.createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react.default.createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 73579:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _loadable = _interop_require_default(__webpack_require__(23668));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable.default;
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if ( true && loadableOptions.suspense) {
    throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
  }

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

'client';
var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react.default.createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 72717:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _sideEffect = _interop_require_default(__webpack_require__(11585));

var _ampContext = __webpack_require__(78000);

var _headManagerContext = __webpack_require__(15850);

var _ampMode = __webpack_require__(9470);

var _utils = __webpack_require__(99475);

'client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react.default.createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react.default.createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react.default.Fragment) {
    return list.concat(_react.default.Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react.default.cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react.default.cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react.default.createElement(_sideEffect.default, {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 3982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var LoadableContext = _react.default.createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 23668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _loadableContext = __webpack_require__(3982);

var _ref =  false ? 0 : __webpack_require__(61688),
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react.default.lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react.default.useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react.default.useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react.default.useMemo(function () {
      if (state.loading || state.error) {
        return _react.default.createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react.default.createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react.default.createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react.default.forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      }).catch(function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks.delete(callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 11585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.delete(props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 14649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./styles/globals.scss
var globals = __webpack_require__(74831);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
// EXTERNAL MODULE: ./app/components/icons/Logo.tsx
var Logo = __webpack_require__(23583);
// EXTERNAL MODULE: ./app/components/header/header.module.scss
var header_module = __webpack_require__(96424);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/icons/Home.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Home = function Home(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 24",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.578 10L11.264 4 16.95 10h-.002v10H5.58V10h-.002zM3.685 12l-1.399 1.476-1.338-1.413 8.978-9.477c.739-.78 1.938-.78 2.677 0l8.978 9.477-1.339 1.414-1.399-1.478v8.003c0 1.104-.848 2-1.895 2H5.58c-1.046 0-1.895-.896-1.895-2v-8.002z",
      fill: "#fff"
    })
  }));
};

var MemoHome = /*#__PURE__*/react.memo(Home);
/* harmony default export */ var icons_Home = (MemoHome);
;// CONCATENATED MODULE: ./app/components/icons/Favorite.tsx


function Favorite_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Favorite_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Favorite_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Favorite_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Favorite = function Favorite(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Favorite_objectSpread(Favorite_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 21",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.418 0c-1.371 0-2.255.172-3.269.696a5.809 5.809 0 00-1.054.7 5.933 5.933 0 00-1.012-.668C9.05.188 8.121 0 6.798 0 3.257 0 .684 3.097.684 7.12c0 3.038 1.604 5.972 4.593 8.81 1.57 1.49 3.572 2.963 5.007 3.747l.82.45.821-.45c1.435-.784 3.438-2.258 5.007-3.747 2.989-2.838 4.594-5.772 4.594-8.81 0-3.98-2.598-7.105-6.108-7.12zm4.213 7.118c0 2.38-1.34 4.83-3.966 7.323-1.432 1.36-3.273 2.718-4.56 3.431-1.288-.713-3.129-2.071-4.561-3.43-2.626-2.494-3.966-4.944-3.966-7.324 0-2.972 1.785-5.12 4.22-5.12 1.052 0 1.7.132 2.445.521.44.23.83.534 1.166.913l.698.785.69-.791c.345-.395.74-.705 1.185-.935.724-.374 1.331-.493 2.432-.493 2.406.011 4.217 2.19 4.217 5.12z",
      fill: "#fff"
    })
  }));
};

var MemoFavorite = /*#__PURE__*/react.memo(Favorite);
/* harmony default export */ var icons_Favorite = (MemoFavorite);
;// CONCATENATED MODULE: ./app/components/icons/Discover.tsx


function Discover_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Discover_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Discover_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Discover_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Discover = function Discover(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Discover_objectSpread(Discover_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.473 12c0-6.624 5.376-12 12-12s12 5.376 12 12-5.376 12-12 12-12-5.376-12-12zm2.4 0c0 5.292 4.308 9.6 9.6 9.6s9.6-4.308 9.6-9.6-4.308-9.6-9.6-9.6-9.6 4.308-9.6 9.6zm3 6.6l9.012-4.188L19.073 5.4l-9.012 4.188L5.873 18.6zm7.92-6.6c0-.732-.588-1.32-1.32-1.32-.732 0-1.32.588-1.32 1.32 0 .732.588 1.32 1.32 1.32.732 0 1.32-.588 1.32-1.32z",
      fill: "#fff"
    })
  }));
};

var MemoDiscover = /*#__PURE__*/react.memo(Discover);
/* harmony default export */ var icons_Discover = (MemoDiscover);
// EXTERNAL MODULE: ./app/components/icons/OfflineOutline.tsx
var OfflineOutline = __webpack_require__(52659);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./app/components/icons/Settings.tsx


function Settings_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Settings_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Settings_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Settings_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Settings = function Settings(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Settings_objectSpread(Settings_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 27",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.8 0c.974 0 1.776.802 1.776 1.776v1.23c.35.123.693.258 1.027.417l.87-.87a1.78 1.78 0 012.506 0l2.507 2.507a1.79 1.79 0 010 2.516l-.87.87c.16.335.303.675.426 1.026h1.23c.974 0 1.777.803 1.777 1.776V14.8c0 .974-.803 1.776-1.776 1.776h-1.24c-.122.346-.26.687-.416 1.018l.87.87a1.79 1.79 0 010 2.515l-2.508 2.507a1.78 1.78 0 01-2.506 0l-.87-.87c-.334.159-.677.294-1.027.417v1.24c0 .973-.802 1.776-1.776 1.776h-3.552a1.785 1.785 0 01-1.776-1.776v-1.24c-.347-.123-.687-.26-1.017-.416l-.87.87a1.78 1.78 0 01-2.507 0l-2.516-2.508a1.79 1.79 0 010-2.516l.88-.878a10.68 10.68 0 01-.426-1.009h-1.24A1.785 1.785 0 010 14.8v-3.552c0-.973.802-1.776 1.776-1.776h1.24c.125-.35.267-.688.425-1.017l-.879-.879a1.791 1.791 0 010-2.516l2.516-2.507a1.78 1.78 0 012.507 0l.87.87c.33-.158.67-.294 1.017-.417v-1.23C9.472.802 10.275 0 11.248 0H14.8zm0 1.184h-3.552a.578.578 0 00-.592.592v1.628c0 .25-.177.49-.416.564-.576.178-1.127.4-1.646.675a.609.609 0 01-.694-.101L6.753 3.395a.584.584 0 00-.842 0L3.395 5.9a.573.573 0 000 .833L4.551 7.89a.61.61 0 01.111.703 9.369 9.369 0 00-.693 1.638.609.609 0 01-.565.425H1.776a.578.578 0 00-.592.592V14.8c0 .338.254.592.592.592h1.628c.25 0 .49.177.565.416a9.45 9.45 0 00.693 1.647.609.609 0 01-.11.693l-1.157 1.157a.573.573 0 000 .832l2.516 2.507c.24.239.603.239.842 0L7.9 21.497a.609.609 0 01.694-.102c.52.276 1.07.498 1.646.675a.61.61 0 01.416.574v1.628c0 .338.254.592.592.592H14.8a.578.578 0 00.592-.592v-1.628a.61.61 0 01.417-.574 9.403 9.403 0 001.655-.675.609.609 0 01.694.102l1.147 1.147c.239.239.602.239.842 0l2.507-2.507a.573.573 0 000-.832l-1.148-1.147a.609.609 0 01-.101-.694c.276-.52.497-1.076.675-1.656a.609.609 0 01.564-.416h1.628a.578.578 0 00.592-.592v-3.552a.578.578 0 00-.592-.592h-1.628a.61.61 0 01-.564-.425 9.297 9.297 0 00-.675-1.647.61.61 0 01.101-.703l1.148-1.147a.573.573 0 000-.832l-2.507-2.507a.584.584 0 00-.842 0l-1.147 1.147a.609.609 0 01-.694.102 9.395 9.395 0 00-1.655-.676.609.609 0 01-.417-.564V1.776a.578.578 0 00-.592-.592zm-1.776 5.92a5.929 5.929 0 015.92 5.92 5.929 5.929 0 01-5.92 5.92 5.929 5.929 0 01-5.92-5.92 5.929 5.929 0 015.92-5.92zm0 1.184a4.727 4.727 0 00-4.736 4.736 4.727 4.727 0 004.736 4.736 4.727 4.727 0 004.736-4.736 4.727 4.727 0 00-4.736-4.736z",
      fill: "#fff"
    })
  }));
};

var MemoSettings = /*#__PURE__*/react.memo(Settings);
/* harmony default export */ var icons_Settings = (MemoSettings);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
;// CONCATENATED MODULE: ./app/components/icons/Search.tsx


function Search_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Search_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Search_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Search_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Search = function Search(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Search_objectSpread(Search_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.898 19.086L15 14.19a8.375 8.375 0 001.9-5.309C16.9 4.26 13.14.5 8.522.5c-1.13 0-2.226.221-3.259.659A8.372 8.372 0 002.6 2.956 8.38 8.38 0 00.8 5.62a8.312 8.312 0 00-.66 3.26c0 4.622 3.759 8.38 8.378 8.38a8.364 8.364 0 005.306-1.9l4.895 4.897a.825.825 0 00.587.243.818.818 0 00.587-.243.824.824 0 00.004-1.17zM15.241 8.88a6.728 6.728 0 01-6.72 6.722c-3.707 0-6.72-3.016-6.72-6.722 0-3.705 3.015-6.722 6.72-6.722 3.704 0 6.72 3.017 6.72 6.722z",
      fill: "#fff"
    })
  }));
};

var MemoSearch = /*#__PURE__*/react.memo(Search);
/* harmony default export */ var icons_Search = (MemoSearch);
;// CONCATENATED MODULE: ./app/components/header/header.component.tsx



















var LazyPlayer = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4027), __webpack_require__.e(5675), __webpack_require__.e(2097), __webpack_require__.e(5413), __webpack_require__.e(7533), __webpack_require__.e(8576)]).then(__webpack_require__.bind(__webpack_require__, 16446));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(16446)];
    }
  }
});
var LazyPodcastPlayer = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4027), __webpack_require__.e(7573), __webpack_require__.e(2097), __webpack_require__.e(6423), __webpack_require__.e(5413), __webpack_require__.e(7533), __webpack_require__.e(6076)]).then(__webpack_require__.bind(__webpack_require__, 95345));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(95345)];
    }
  }
});

var isActiveLink = function isActiveLink(href, currentPathname) {
  var rawHref = href.replace(/\?(.)+$/g, "");

  if (rawHref === "/") {
    return rawHref === currentPathname;
  }

  return currentPathname.startsWith(rawHref);
};

var Header = function Header() {
  var router = (0,next_router.useRouter)();

  var _useRouter = (0,next_router.useRouter)(),
      push = _useRouter.push;

  var t = (0,lang/* useTranslate */.q)();

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      isCarMode = _useFeaturesContext.isCarMode;

  var onSearchCallback = function onSearchCallback(query) {
    push("/search?query=".concat(query));
  };

  var _useFeaturesContext2 = (0,features_context/* useFeaturesContext */.Pp)(),
      downloadEnabled = _useFeaturesContext2.downloadEnabled,
      demoVersion = _useFeaturesContext2.demoVersion;

  var links = (0,react.useMemo)(function () {
    var list = [{
      name: t("header.menu.home"),
      href: "/",
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Home, {
        className: (header_module_default()).menu_item_icon
      })
    }, {
      name: t("header.menu.favorites"),
      href: "/favorites",
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Favorite, {
        className: (header_module_default()).menu_item_icon
      })
    }, {
      name: t("header.menu.discover"),
      href: "/discover",
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Discover, {
        className: (header_module_default()).menu_item_icon
      })
    }];

    if (isCarMode) {
      list[0].href = "/discover"; // remove discover

      list.length = 2;
    }

    if (downloadEnabled) {
      list.push({
        name: t("header.menu.offline"),
        href: "/offline",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(OfflineOutline/* default */.Z, {
          className: (header_module_default()).menu_item_icon
        })
      });
    }

    return list;
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (header_module_default()).header,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (header_module_default()).inner_wrapper,
        "data-navigate-row": true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          passHref: true,
          href: "/settings",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (0,clsx_m/* default */.Z)((header_module_default()).profile, (header_module_default()).mobile),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: (header_module_default()).icon_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Settings, {
                className: (header_module_default()).icon
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (header_module_default()).logo_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: isCarMode ? "/discover" : "/",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((header_module_default()).logo)
              })
            })
          }), demoVersion && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (header_module_default()).demo_indicator,
            children: t("demo-version")
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (header_module_default()).player_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LazyPlayer, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(LazyPodcastPlayer, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (header_module_default()).side,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (header_module_default()).menu_items,
            children: [links.map(function (link, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                passHref: true,
                href: link.href,
                scroll: false,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                  "data-navigate-item": true,
                  className: (0,clsx_m/* default */.Z)((header_module_default()).menu_item, (0,defineProperty/* default */.Z)({}, (header_module_default()).active, isActiveLink(link.href, router.pathname))),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (header_module_default()).menu_item_icon_wrapper,
                    children: link.icon
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: link.name
                  })]
                })
              }, "header-link-".concat(link, "-").concat(index));
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              passHref: true,
              href: "/search?autofocus=true",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                "data-navigate-item": true,
                className: (0,clsx_m/* default */.Z)((header_module_default()).profile),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  className: (header_module_default()).icon_wrapper,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Search, {
                    className: (header_module_default()).icon
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              passHref: true,
              href: "/settings",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                "data-navigate-item": true,
                className: (0,clsx_m/* default */.Z)((header_module_default()).profile),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  className: (header_module_default()).icon_wrapper,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Settings, {
                    className: (header_module_default()).icon
                  })
                })
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (header_module_default()).search_mobile,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            passHref: true,
            href: "/search?autofocus=true",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (0,clsx_m/* default */.Z)((header_module_default()).profile, (header_module_default()).mobile),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (header_module_default()).icon_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Search, {
                  className: (header_module_default()).icon
                })
              })
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (header_module_default()).navigation_mobile,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (header_module_default()).navigation_mobile_inner,
        children: links.map(function (link, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            passHref: true,
            href: link.href,
            scroll: false,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              "data-navigate-item": true,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((header_module_default()).navigation_item, (0,defineProperty/* default */.Z)({}, (header_module_default()).active, isActiveLink(link.href, router.pathname))),
                children: [link.icon, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (header_module_default()).label,
                  children: link.name
                })]
              })
            })
          }, "header-link-mobile-".concat(link, "-").concat(index));
        })
      })
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./app/context/auth.context.tsx
var auth_context = __webpack_require__(92862);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./app/store/slices/user.ts
var user = __webpack_require__(38886);
// EXTERNAL MODULE: ./services-hooks/services.ts + 1 modules
var services = __webpack_require__(46725);
// EXTERNAL MODULE: ./app/store/slices/player.ts
var player = __webpack_require__(22564);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./app/components/toast/toast.component.tsx + 1 modules
var toast_component = __webpack_require__(53483);
// EXTERNAL MODULE: ./app/hooks/keyboard-navigation.hook.ts
var keyboard_navigation_hook = __webpack_require__(36158);
// EXTERNAL MODULE: ./app/components/footer/footer.module.scss
var footer_module = __webpack_require__(8541);
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);
;// CONCATENATED MODULE: ./app/components/footer/footer.component.tsx








var Footer = function Footer(_ref) {
  var _ref$showFooter = _ref.showFooter,
      showFooter = _ref$showFooter === void 0 ? true : _ref$showFooter;
  var t = (0,lang/* useTranslate */.q)();

  var onPrivacySettingsClick = function onPrivacySettingsClick(e) {
    try {
      window.__tcfapi("show", 2, console.log, {
        lazy: false
      });
    } catch (e) {}

    e.preventDefault();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
    className: (0,clsx_m/* default */.Z)((footer_module_default()).footer, (0,defineProperty/* default */.Z)({}, (footer_module_default()).no_background, !showFooter)),
    children: showFooter && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (footer_module_default()).inner_footer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((footer_module_default()).section, (footer_module_default()).menu),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (footer_module_default()).header,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Logo/* default */.Z, {
            className: (footer_module_default()).logo
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (footer_module_default()).prm,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://prm.radioline.co/",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                className: (footer_module_default()).alt_button,
                children: t("add-manage-you-station-or-podcast")
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (footer_module_default()).main,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (footer_module_default()).store_button,
            href: "https://apps.apple.com/app/radioline-radio-et-podcasts/id945478998",
            target: "_blank",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/App_Store.png"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (footer_module_default()).store_button,
            href: "https://appgallery.huawei.com/app/C102907973",
            target: "_blank",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/app_gallery.png"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (footer_module_default()).store_button,
            href: "https://play.google.com/store/apps/details?id=com.radioline.android.radioline",
            target: "_blank",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/Google_Play_Store.png"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (footer_module_default()).bottom,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("menu", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/privacy-policy",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: t("privacy-policy")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "#",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              onClick: onPrivacySettingsClick,
              children: t("privacy-settings")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/terms-of-use",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: t("terms-of-use")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "https://business.radioline.co/",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              target: "_blank",
              children: t("our-solutions")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/contact-us",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: t("contact")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/navigation-map",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: t("navigation-map")
            })
          })]
        })
      })]
    })
  });
};
// EXTERNAL MODULE: ./app/context/country.context.tsx
var country_context = __webpack_require__(91537);
// EXTERNAL MODULE: ./app/store/slices/app-version.ts
var app_version = __webpack_require__(8176);
// EXTERNAL MODULE: ./app/store/slices/radio.ts
var slices_radio = __webpack_require__(49624);
// EXTERNAL MODULE: ./node_modules/react-use/esm/misc/util.js
var util = __webpack_require__(76362);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useSessionStorage.js


var useSessionStorage = function (key, initialValue, raw) {
    if (!util/* isBrowser */.jU) {
        return [initialValue, function () { }];
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = (0,react.useState)(function () {
        try {
            var sessionStorageValue = sessionStorage.getItem(key);
            if (typeof sessionStorageValue !== 'string') {
                sessionStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
                return initialValue;
            }
            else {
                return raw ? sessionStorageValue : JSON.parse(sessionStorageValue || 'null');
            }
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // sessionStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useEffect)(function () {
        try {
            var serializedState = raw ? String(state) : JSON.stringify(state);
            sessionStorage.setItem(key, serializedState);
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // sessionStorage can throw. Also JSON.stringify can throw.
        }
    });
    return [state, setState];
};
/* harmony default export */ var esm_useSessionStorage = (useSessionStorage);

// EXTERNAL MODULE: ./node_modules/react-use/esm/useNetworkState.js
var useNetworkState = __webpack_require__(6765);
// EXTERNAL MODULE: ./app/context/player.context.tsx
var player_context = __webpack_require__(48346);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/_virtual/use-intl.esm.js
var use_intl_esm = __webpack_require__(50079);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/core/use-intl.esm5.js
var use_intl_esm5 = __webpack_require__(31954);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/react/use-intl.esm7.js
var use_intl_esm7 = __webpack_require__(31733);
;// CONCATENATED MODULE: ./node_modules/use-intl/dist/react/use-intl.esm.js






var _excluded = ["children", "onError", "getMessageFallback", "messages"];
function IntlProvider(_ref) {
  var children = _ref.children,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? use_intl_esm5/* defaultOnError */.h : _ref$onError,
      _ref$getMessageFallba = _ref.getMessageFallback,
      getMessageFallback = _ref$getMessageFallba === void 0 ? use_intl_esm5/* defaultGetMessageFallback */.i : _ref$getMessageFallba,
      messages = _ref.messages,
      contextValues = (0,use_intl_esm/* objectWithoutPropertiesLoose */.gK)(_ref, _excluded);

  if (false) {}

  return react.createElement(use_intl_esm7/* default.Provider */.Z.Provider, {
    value: (0,use_intl_esm/* extends */.gY)({}, contextValues, {
      messages: messages,
      onError: onError,
      getMessageFallback: getMessageFallback
    })
  }, children);
}


//# sourceMappingURL=use-intl.esm.js.map

;// CONCATENATED MODULE: ./node_modules/next-intl/dist/next-intl.esm.js





function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function NextIntlProvider(_ref) {
  var _useRouter;

  var locale = _ref.locale,
      rest = _objectWithoutPropertiesLoose(_ref, ["locale"]);

  // The router can be undefined if used in a context outside
  // of Next.js (e.g. unit tests, Storybook, ...)
  var nextLocale = (_useRouter = (0,next_router.useRouter)()) == null ? void 0 : _useRouter.locale;

  if (!locale && nextLocale) {
    locale = nextLocale;
  }

  if (!locale) {
    throw new Error( false ? 0 : undefined);
  }

  return react.createElement(IntlProvider, Object.assign({
    locale: locale
  }, rest));
}


//# sourceMappingURL=next-intl.esm.js.map

;// CONCATENATED MODULE: ./app/locales/ar.json
var ar_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | استمع• مباشرةً","seo_description_radio":"استمع إلى {var1} • مباشرةً ومجانًا على Radioline | البودكاست والإعادات | {var2}","seo_description_podcast":"استمع إلى البودكاست {var1} مجانًا على Radioline |  \\n{var2}","seo_title_category_RadioPage":"{var1} • محطات راديو مباشرة ومجانية على Radioline","seo_description_categoryRadioPage":"{var1} • استمع مباشرةً ومجانًا إلى محطات الراديو عبر الإنترنت (FM، AM، DAB، Webradios) على Radioline | حلقات البودكاست والإعادات","seo_title_podcast":"{var1} • {var2} بودكاست","seo_title_discoverRadio":"{var1} • محطات الراديو عبر الإنترنت مباشرة ومجانية","seo_description_discoverRadio":"استمع إلى {var1} محطات الراديو المباشرة المجانية عبر الإنترنت (FM، AM، DAB، Webradios) على Radioline","seo_title_discoverPodcast":"{var1} • تتوفر حلقات البودكاست مجانًا ويتم تصنيفها حسب الموضوع","seo_description_discoverPodcast":"استمع إلى حلقات البودكاست {var1} عبر الإنترنت مجانًا على Radioline","seo_title_home":"الراديو والبودكاست والإعادات من كل أنحاء العالم مجانًا | Radioline","seo_description_home":"اكتشف عالمًا من محطات الراديو وحلقات البودكاست مع Radioline. استمع إلى محطات الراديو المفضلة لديك (FM وAM وDAB وWebradio) والبودكاست من كل الأجهزة الخاصة بك من خلال الكتالوجات المحلية والوطنية والدولية الخاصة بنا.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"الصفحة الرئيسيسة","favorites":"المُفضلات","discover":"اكتشف","offline":"غير مُتصل"}},"tabs":{"podcasts":"برودكاست","stations":"محطات راديو","schedule":"البرنامج","all":"الكل","downloaded":"تم التنزيل","unplayed":"لم يتم تشغيله","playlist":"قائمة التشغيل"},"country-selector":"أختيار البلد","hq-stations":"محطات عالية الجودة","national-selection":"الاختيار الوطني","radioline":"Radioline","worlds-best":"أفضل محطات الموسيقى العالمية","thematics":"موضوعية","local-stations":"محطات محلية","log-in":"تسجيل الدخول","log-in-with-my-mobile":"اشبك من خلال الهاتف المحمول","log-in-with-facebook":"متابعة بحساب فيسبوك","sign-up":"أنشاء حساب","music-on-air":"موسيقى على الهواء","search":"بحث","email":"البريد الالكتروني","email-is-required":"البريد الإلكتروني مطلوب","could-not-sign-in-please-check-your-email-and-password":"البريد الالكتروني او/ كلمة المرور غير صالحة","password":"كلمة المرور","password-is-required":"Password required","forgot-password":"نسيت كلمة المرور؟","time":{"h":"دقيقة","min":"دقائق","s":"ثانية"},"navigation-map":"خريطة الموقع","privacy-policy":"سياسة الخصوصية","privacy-settings":"إعدادات الخصوصية","terms-of-use":"شروط الاستخدام","our-solutions":"حلولنا","contact":"الاتصال","install-app":"تحميل راديو اونلاين","add-manage-you-station-or-podcast":"إضافة / إدارة محطتك أو البودكاست الخاص بك","send":"ارسال","field-required":"هذه الخانة مطلوبه","subject":"الموضوع","your-message":"رسالتك","your-name":"اسمك","episodes":"الحلقات","go-to-podcast":"اذهب إلى بودكاست","mark-as-played":"التحديد على أنه تم الاستماع إليه","delete":"حذف","see-website":"مشاهدة موقع الويب","you-dont-have-favorites":"ليس لديك مُفضلات حتى الأن، لتسجيل مُفضلاتك، أنشئ حساب، هذا سهل وسريع","create-an-account":"إنشاء حساب","you-dont-have-podcasts":"لم تقم بتحميل حلقات بودكاست","to-downaload-episodes":"لتسجيل حلقات البودكاست، قم بإنشاء حساب، إنه سريع وسهل!","premium":{"download-podcasts":"تنزيل البودكاست والاستماع اليه دون الاتصال بالأنترنت","go-premium-for":"كُن مميزًا بـ {var1} دولار / سنة","automatically-play-last-radio":"يقوم تلقائيًا بتشغيل آخر محطة راديو أو بودكاست تم الاستماع إليه بمجرد بدء تشغيل التطبيق","worlds-best-music-stations":"أفضل محطات الراديو الموسيقية في العالم","local-and-worldwide":"كتالوجات منسقة محليًا وعالميًا (161 دولة)","scan-qr-code":"امسح رمز الاستجابة السريعة هذا ضوئيًا","no-ads":"لا توجد إعلانات مضافة","no-ads-desc":"لا توجد إعلانات مرئية وصوتية مضافة بواسطة راديو اونلاين (لا يزال بإمكانك مواجهة الإعلانات المضافة بواسطة المذيع)","export-to-playlist-desc":"Add the music live on radio to your playlist","worlds-best":"World\'s Best","worlds-best-desc":"We\'ve selected for you the best music stations worldwide for 17 musical genres","hq-stations-desc":"Discover music stations with high sound quality (MP3 - 320 Kbps)","after-payment-title":"We are processing your subscription, please wait","after-payment-support":"Subscription processing takes a little longer than expected. If you encounter any problem please contact support@radioline.co","premium":"premium","video-ad-description":"يتيح لنا إعلان الفيديو هذا الاستمتاع بالتطبيق مجانًا"},"back":"العودة","auth":{"or":"أو","save-your-favorites":"سجّل مُفضلاتك","synchronize-your-account":"مزامنة حسابك على جميع الأجهزة الخاصة بك","resume-playback":"شغل الموسيقى","resume-podcasts":"استأنف ملفات البودكاست من حيث توقفت واحفظ آخر محتوى تم تشغيله","offline-podcasts":"","download-podcasts":"تنزيل البودكاست والاستماع اليه دون الاتصال بالأنترنت","reset-password":"إعادة تعيين كلمة المرور","login-with-mobile":"اشبك من خلال الهاتف المحمول","step-1":"افتح رابط راديولين على الهاتف النقال","step-2":"في الإعدادات اختار - اضف جهاز ","step-3":"ادخل الرقم الظاهر على الشاشة ","account":"حساب","export-to-playlist":"الإضافة الي قائمة التشغيل","export-to-playlist-desc":"أضف الموسيقى الحية على الراديو إلى قائمة التشغيل الخاصة بك بلمسة واحدة (سبوتيفي ، ديزر)","sign-out":"أوقف الاتصال","reset-password-error":"لم نتمكن من إعادة تعيين كلمة المرور الخاصة بك ، يرجى المحاولة مرة أخرى","email-error":"البريد الإلكتروني مطلوب","reset-password-success":"تم إرسال كلمة مرورك الجديدة إلى {email}","instructions":"التعليمات","code-required":"رمز تسجيل الدخول مطلوب","add-device-meta-description":"Offline access - Radioline","change-my-password":"تغيير كلمة المرور الخاصة بي","current-password":"كلمة المرور الحالية","new-password":"كلمة المرور الجديدة","repeat-password":"كرر كلمة المرور الجديدة","password-change":{"success":"كلمة السر الخاصة بك تم تغييرها بنجاح"},"password-length-validation":"يجب أن تكون كلمة المرور الخاصة بك بين 8 و 30 حرفًا","password-mismatch-validation":"لقد أدخلت كلمتين من كلمات المرور المختلفة","password-old-passowrd-match-validation":"يجب أن تكون كلمة مرورك الجديدة مختلفة عن كلمة مرورك السابقة","email-exists-error":"هذا البريد الإلكتروني مستخدم بالفعل مع حساب Radioline"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"الإضافة الي قائمة التشغيل","autoplay":"تشغيل تلقائي","settings":{"link-account":"ربط حسابي","unlink-account":"إلغاء ربط حسابي","no-ads":"لا توجد إعلانات مضافة","no-ads-desc":"لا توجد إعلانات مرئية وصوتية مضافة بواسطة راديو اونلاين (لا يزال بإمكانك مواجهة الإعلانات المضافة بواسطة المذيع)","my-app":"تطبيقي","application-language":"اختيار اللغة","select-application-language":"اختيار اللغة","homepage-country":"شاشة الدولة الرئيسية","install-app":"تحميل راديو اونلاين","features":"المميزات","add-device":"اضف جهاز","app-version":"نسخة التطبيق","export-to-playlist-desc":"أضف الموسيقى الحية على الراديو إلى قائمة التشغيل الخاصة بك بلمسة واحدة","connected-to":"مرتبط بـ","settings":"الإعدادات","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"حسابي"},"continuity":{"popup-close-btn":"اغلاق","popup-play-btn":"تشغيل","popup-header":"سبق لك الاستماع إلى:"},"search-for-stations":"ابحث عن المحطات أو البرودكاست واضغط على أيقونة القلب لإضافتها هنا","search-for-a-radio-or-podcast":"ابحث عن محطة راديو أو بودكاست","close":"اغلاق","generic-error":"حدث خطأ","fallback":{"error":"هناك خطأ ما","button":"اعادة المحاولة"},"export":{"select-platform":"حدد منصة الموسيقى"},"demo-version":"Demo version","search-for-podcasts":"ابحث عن ملفات البرودكاست واضغط على أيقونة التنزيل لإضافة حلقة هنا","playback-error":"لم نتمكن من تشغيل هذا البث","offline":{"save-error-toast":"فشل تحميل الحلقة","remove-success-toast":"الحلقة المحذوفة","save-success-toast":"الحلقة التي تم تنزيلها","save-in-progress-toast":"جارٍ تنزيل الحلقة","download-episode":"تحميل هذه الحلقة","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"زيارة الموقع","radio":"الراديو","no-playlist":"الوصول إلى قائمة تشغيل محطة هذا الراديو غير متاح أو لا يقترح أيًا منها","no-program":"الوصول إلى برنامج محطة هذا الراديو غير متوفر أو لا يقترح أيًا منها","no-podcasts":"الوصول إلى ملفات بودكاست محطة هذا الراديو غير متاح أو لا يقترح أيًا منها"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"لم يتم التعرف على المسار. قد تجد هذا المسار من خلال النظر في سجل أغنية الراديو هذا إذا تم توفيره.","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"لم يتم التعرف على المسار. قد تجد هذا المسار من خلال النظر في سجل أغنية الراديو هذا إذا تم توفيره.","qr-tutorial":{"title":"كيفية ربط  حسابك في راديو اونلاين بمنصة بث الموسيقى:","step1":"افتح تطبيق راديو اونلاين للجوال أو انتقل إلى موقعنا على الإنترنت (www.radioline.co)","step2":"في الإعدادات ، اختر \\"ربط حسابي\\"","step3":"اختر نظام بث الموسيقى واتبع التعليمات"}},"favorites":{"no-favotites":"ليس لديك مُفضلات حتى الأن"},"podcast":"تدوين صوتي","search-results":{"try-again":"اعادة المحاولة","no-internet":"لا يوجد اتصال بالإنترنت","no-results":"لم يتم العثور على نتائج"},"network":{"connection-lost":"يبدو أنك فقدت اتصالك بالإنترنت","connection-slow":"يبدو أن اتصالك بالإنترنت بطيء. قد تواجه مشاكل في التشغيل","back-online":"تمت استعادة اتصالك بالإنترنت"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"شكرًا على تواصلك مع فريق الدعم الخاص بنا، وسنقوم بالرد عليك في أقرب وقت ممكن.","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"تبث هذه المحطة / البودكاست باستخدام بروتوكول قديم (http) نفضل عدم تشغيله لأسباب أمنية.","old-website":"الموقع السابق","accept-terms":"من خلال إنشاء حساب، فإنك تقبل الشروط العامة للاستخدام"}');
;// CONCATENATED MODULE: ./app/locales/de.json
var de_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Hören • LIVE","seo_description_radio":"Hören Sie {var1} • Live und kostenlos auf Radioline | Podcast und Wiederholungen | {var2}","seo_description_podcast":"Hören Sie den Podcast {var1} kostenlos auf Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Radios live und kostenlos auf Radioline","seo_description_categoryRadioPage":"{var1} • Hören Sie live und kostenlos Online-Radios (FM, AM, DAB, Webradios) auf Radioline | Podcasts und Wiederholungen","seo_title_podcast":"{var1} • {var2} Podcast","seo_title_discoverRadio":"{var1} • Online-Radios live und kostenlos","seo_description_discoverRadio":"Hören Sie {var1} kostenlos live Online-Radiosender (FM, AM, DAB, Webradios) auf Radioline","seo_title_discoverPodcast":"{var1} • Kostenlose und nach Themen sortierte Podcasts","seo_description_discoverPodcast":"Hören Sie sich {var1} Podcasts kostenlos online auf Radioline an","seo_title_home":"Kostenlose Radios, Podcasts und Wiederholungen aus der ganzen Welt | Radioline","seo_description_home":"Entdecken Sie die Welt der Radios und Podcasts mit Radioline. Hören Sie Ihre Lieblingsradiosender (FM, AM, DAB, Webradio) und Podcasts von all Ihren Geräten aus mit unseren lokalen, nationalen und internationalen Katalogen.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Homepage","favorites":"Favoriten","discover":"Entdecken","offline":"Offline"}},"tabs":{"podcasts":"Podcasts","stations":"Radiosender","schedule":"Plan","all":"Alle","downloaded":"Heruntergeladen","unplayed":"Ungespielt","playlist":"Playliste"},"country-selector":"Land auswählen","hq-stations":"HQ-Sender","national-selection":"Nationale Auswahl","radioline":"Radioline","worlds-best":"Weltbeste Musiksender","thematics":"Thematiken","local-stations":"Lokale Sender","log-in":"Einloggen","log-in-with-my-mobile":"Mit meinem Smartphone einloggen","log-in-with-facebook":"Weiter mit Facebook","sign-up":"Anmelden","music-on-air":"Live-Musik","search":"Suche","email":"E-mail","password":"Passwort","password-is-required":"Passwort erforderlich","email-is-required":"Bitte geben Sie eine korrekte E-Mail-Adresse ein","could-not-sign-in-please-check-your-email-and-password":"Falsche E-Mail und/oder falsches Passwort","forgot-password":"Passwort vergessen?","time":{"h":"Std","min":"Min","s":"Sek"},"navigation-map":"Seitenverzeichnis","privacy-policy":"Datenschutzrichtlinie","privacy-settings":"Datenschutzeinstellungen","terms-of-use":"Nutzungsbedingungen","our-solutions":"Unsere Lösungen","contact":"Kontakt","install-app":"Radioline herunterladen","add-manage-you-station-or-podcast":"Fügen Sie Ihren Sender oder Podcast hinzu / Verwalten Sie Ihren Sender oder Podcast","send":"Abschicken","field-required":"Dieses ist ein Pflichtfeld","subject":"Betreff","your-message":"Ihre Nachricht","your-name":"Ihr Name","episodes":"Folgen","go-to-podcast":"Zu Podcast gehen","mark-as-played":"Als abgespielt markieren","delete":"Löschen","see-website":"Siehe Website","you-dont-have-favorites":"Sie haben noch keine Favoriten. Um Ihre Favoriten zu speichern, müssen Sie ein Konto einrichten. Das geht ganz schnell und einfach!","create-an-account":"Ein Konto einrichten","you-dont-have-podcasts":"Sie haben noch keine Podcast-Folgen heruntergeladen.","to-downaload-episodes":"Um Podcast-Folgen herunterzuladen, müssen Sie ein Konto einrichten. Das geht ganz schnell und einfach!!","premium":{"download-podcasts":"Podcasts herunterladen und offline hören","go-premium-for":"Für {var1} zu Premium höherstufen","automatically-play-last-radio":"Spielt beim Starten der App automatisch Ihren letzten Radiosender oder Podcast ab","worlds-best-music-stations":"Weltbeste Musiksender","local-and-worldwide":"Lokal und weltweit kuratierte Kataloge (161 Länder)","scan-qr-code":"Scannen Sie diesen QR-Code","no-ads":"Keine zusätzlichen Werbeannoncen","no-ads-desc":"Es werden keine visuellen und Audio-Annoncen von Radioline hinzugefügt (Sie können dennoch Annoncen sehen, die von der Sendeanstalt hinzugefügt werden)","export-to-playlist-desc":"Fügen Sie die Musik mit einer Berührung live auf Radio zu Ihrer Spielliste hinzu (Spotify, Deezer)","worlds-best":"Beste Radiozenders ter Wereld","worlds-best-desc":"Wir haben für 17 Musikstile die besten Musiksender weltweit für Sie ausgewählt","hq-stations-desc":"Entdecken Sie Musikradiosender mit hoher Klangqualität (MP3 - 320 Kbps)","after-payment-title":"Wir bearbeiten Ihr Abonnement, bitte warten","after-payment-support":"Die Bearbeitung Ihres Abonnements dauert etwas länger als erwartet. Falls Sie ein Problem haben, kontaktieren Sie bitte support@radioline.co","premium":"premium","video-ad-description":"Diese Videoanzeige ermöglicht es uns, Ihnen die App kostenlos zur Verfügung zu stellen"},"back":"Zurück","auth":{"or":"ODER","save-your-favorites":"Ihre Favoriten speichern","synchronize-your-account":"Synchronisieren Sie Ihr Konto auf allen Ihren Geräten","resume-playback":"Wiedergabe fortsetzen","resume-podcasts":"Podcasts an der Stelle wiederaufnehmen, an der Sie sie unterbrochen haben und zuletzt abgespielten Inhalt speichern","offline-podcasts":"Offline-Podcasts","download-podcasts":"Podcasts herunterladen und offline hören","reset-password":"Passwort zurücksetzen","login-with-mobile":"Mit meinem Smartphone einloggen","step-1":"Die Radioline-App auf Ihrem Smartphone öffnen","step-2":"In den Einstellungen die Option „Ein Gerät hinzufügen“ auswählen","step-3":"Den auf dem Bildschirm angezeigten Code eingeben","account":"Konto","export-to-playlist":"In Playliste exportieren","export-to-playlist-desc":"Fügen Sie die Musik mit einer Berührung live auf Radio zu Ihrer Spielliste hinzu (Spotify, Deezer)","sign-out":"Ausloggen","reset-password-error":"Ihr Passwort konnte nicht zurückgesetzt werden. Bitte versuchen Sie es erneut..","email-error":"E-Mail erforderlich","reset-password-success":"Ihr neues Passwort wurde an folgende E-Mail-Adresse gesandt: {email}","instructions":"Anweisungen","code-required":"Login-Code erforderlich","add-device-meta-description":"Offline access - Radioline","change-my-password":"Mein Passwort ändern","current-password":"Aktuelles Passwort","new-password":"Neues Passwort","repeat-password":"Neues Passwort wiederholen","password-change":{"success":"Ihr Passwort wurde erfolgreich geändert"},"password-length-validation":"Ihr Passwort sollte zwischen 8 und 30 Zeichen lang sein","password-mismatch-validation":"Sie haben zwei verschiedene Passwörter eingegeben","password-old-passowrd-match-validation":"Ihr neues Passwort darf nicht mit Ihrem alten Passwort identisch sein","email-exists-error":"Diese E-Mail wird bereits mit einem Radioline-Konto verwendet"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"In Playliste exportieren","autoplay":"Autoplay","settings":{"link-account":"Mein Konto verbinden","unlink-account":"Mein Konto trennen","no-ads":"Keine zusätzlichen Werbeannoncen","no-ads-desc":"Es werden keine visuellen und Audio-Annoncen von Radioline hinzugefügt (Sie können dennoch Annoncen sehen, die von der Sendeanstalt hinzugefügt werden)","my-app":"Meine App","application-language":"Sprache wählen","select-application-language":"Sprache wählen","homepage-country":"Startbildschirm Land:","install-app":"Radioline herunterladen","features":"Features","add-device":"Ein Gerät hinzufügen","app-version":"App-Version","export-to-playlist-desc":"Fügen Sie die Musik mit einer Berührung live auf Radio zu Ihrer Spielliste hinzu","connected-to":"Verbunden mit","settings":"Einstellungen","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Mein Konto"},"continuity":{"popup-close-btn":"Schließen","popup-play-btn":"Abspielen","popup-header":"Sie haben zuvor gehört:"},"search-for-stations":"Um sie hier hinzuzufügen, suchen Sie nach Sendern oder Podcasts und tippen Sie das Herz-Symbol an","search-for-a-radio-or-podcast":"Nach einem Sender oder Podcast suchen","close":"Schließen","generic-error":"Es ist ein Fehler aufgetreten","fallback":{"error":"Es ist etwas schiefgelaufen","button":"Bitte erneut versuchen"},"export":{"select-platform":"Wählen Sie eine Musikplattform"},"demo-version":"Demo version","search-for-podcasts":"Um eine Folge hier hinzuzufügen, suchen Sie nach Podcasts und tippen Sie das Herunterladen-Symbol an","playback-error":"Dieser Stream konnte nicht wiedergegeben werden","offline":{"save-error-toast":"Download der Folge fehlgeschlagen","remove-success-toast":"Folge gelöscht","save-success-toast":"Folge heruntergeladen","save-in-progress-toast":"Folge wird heruntergeladen","download-episode":"Diese Folge herunterladen","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Website besuchen","radio":"Radiosender","no-playlist":"Der Zugriff auf die Playliste dieses Senders ist nicht verfügbar oder er bietet keine.","no-program":"Der Zugriff auf das Programm dieses Senders ist nicht verfügbar oder er bietet keins","no-podcasts":"Der Zugriff auf die Podcasts dieses Senders ist nicht verfügbar oder er bietet keine"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Titel nicht erkannt. Sie können diesen Titel eventuell finden, indem Sie in dieser Radiotitelhistorie schauen, sofern bereitgestellt.","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Titel nicht erkannt. Sie können diesen Titel eventuell finden, indem Sie in dieser Radiotitelhistorie schauen, sofern bereitgestellt.","qr-tutorial":{"title":"So verbinden Sie Ihr Radioline-Konto mit einer Musikstreaming-Plattform:","step1":"Öffnen Sie Ihre Radioline-Mobilgeräte-App oder gehen Sie auf unsere Website (www.radioline.co)","step2":"In den Einstellungen wählen Sie „Mein Konto verbinden“","step3":"Wählen Sie Ihre gewünschte Musikstreaming-Plattform aus und befolgen Sie die Anweisungen"}},"favorites":{"no-favotites":"Sie haben noch keine Favoriten"},"podcast":"Podcast","search-results":{"try-again":"Bitte erneut versuchen","no-internet":"Keine Internet-Verbindung","no-results":"Keine Suchergebnisse"},"network":{"connection-lost":"Es scheint, Sie haben momentan keine Internet-Verbindung","connection-slow":"Es scheint, Ihre Internet-Verbindung ist langsam. Dies könnte zu Problemen bei der Wiedergabe führen","back-online":"Ihre Internet-Verbindung ist wiederhergestellt"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Vielen Dank für Ihre Support-Anfrage. Wir antworten Ihnen so bald wie möglich","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"Dieser Sender/Podcast sendet mit einem veralteten Protokoll (http), das wir aus Sicherheitsgründen lieber nicht spielen möchten.","old-website":"Frühere Website","accept-terms":"Mit Ihrer Einrichtung eines Kontos erklären Sie sich mit den allgemeinen Nutzungsbedingungen und der Datenschutzrichtlinie einverstanden."}');
;// CONCATENATED MODULE: ./app/locales/en.json
var en_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Listen • LIVE","seo_description_radio":"Listen to {var1} • Live and free on Radioline | Podcast & Replays | {var2}","seo_description_podcast":"Listen to the podcast {var1} free on Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Radios live and free on Radioline","seo_description_categoryRadioPage":"{var1} • Listen live and free to online radios (FM, AM, DAB, Webradios) on Radioline | Podcasts & Replays","seo_title_podcast":"{var1} • {var2} Podcast","seo_title_discoverRadio":"{var1} • Online Radios live and free","seo_description_discoverRadio":"Listen to {var1} free live online radio stations (FM, AM, DAB, Webradios) on Radioline","seo_title_discoverPodcast":"{var1} • Podcasts available for free and sorted by theme","seo_description_discoverPodcast":"Listen to {var1} podcasts online for free on Radioline","seo_title_home":"Radios, Podcasts and Replays from around the world for free | Radioline","seo_description_home":"Discover a world of radios and podcasts with Radioline. Listen to your favorite radio stations (FM, AM, DAB, Webradio) and podcasts from all your devices with our local, national and international catalogs.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Home","favorites":"Favorites","discover":"Discover","offline":"Offline"}},"tabs":{"podcasts":"Podcasts","stations":"Stations","schedule":"Schedule","all":"All","downloaded":"Downloaded","unplayed":"Unplayed","playlist":"Playlist"},"country-selector":"Select country","hq-stations":"HQ Radio","worlds-best":"World\'s Best","thematics":"Thematics","national-selection":"National selection","radioline":"Radioline","local-stations":"Local stations","log-in-with-my-mobile":"Log in with my mobile","log-in-with-facebook":"Continue with Facebook","log-in":"Log in","sign-up":"Sign up","search":"Search","music-on-air":"Music on Air","forgot-password":"Forgot Password?","password":"Password","password-is-required":"Password required","email":"Email","email-is-required":"Please enter a correct email","could-not-sign-in-please-check-your-email-and-password":"Invalid email and/or password","time":{"h":"hr","min":"min","s":"sec"},"navigation-map":"Site map","privacy-policy":"Privacy policy","privacy-settings":"Privacy settings","terms-of-use":"Terms of use","our-solutions":"Our solutions","contact":"Contact","install-app":"Install App","add-manage-you-station-or-podcast":"Add/Manage your station or podcast","send":"Send","field-required":"This field is required","subject":"Title","your-message":"Your message","your-name":"Your name","episodes":"Episodes","go-to-podcast":"Go to Podcast","mark-as-played":"Mark as played","delete":"Delete","see-website":"See Website","you-dont-have-favorites":"You don\'t have any favorites yet. To save your favorites, create an account, it\'s easy and fast!","create-an-account":"Create an account","you-dont-have-podcasts":"You don\'t have any podcasts episodes downloaded yet.","to-downaload-episodes":"To download podcasts episodes, create an account, it\'s easy & fast!","premium":{"download-podcasts":"Download podcasts and listen to them offline","go-premium-for":"Go Premium for {var1}","automatically-play-last-radio":"Automatically play your last radio station or podcast at app launch","worlds-best-music-stations":"World\'s Best","local-and-worldwide":"Local and worldwide curated catalogs (161 countries)","scan-qr-code":"Scan this QR code","no-ads":"No added ads","no-ads-desc":"No display or audio ads added by Radioline. You may still encounter ads added by the broadcaster","export-to-playlist-desc":"Add the music on air to your playlist in one click (Spotify, Deezer)","worlds-best":"World\'s Best","worlds-best-desc":"We\'ve selected for you the best music stations worldwide for 17 musical genres","hq-stations-desc":"Discover music stations with high sound quality (MP3 - 320 Kbps)","after-payment-title":"We are processing your subscription, please wait","after-payment-support":"Subscription processing takes a little longer than expected. If you encounter any problem please contact support@radioline.co","premium":"premium","video-ad-description":"This ad helps us provide a free listening experience"},"back":"Go back","auth":{"or":"OR","save-your-favorites":"Save your favorites","synchronize-your-account":"Synchronize your account with compatible devices","resume-playback":"Resume Playback","resume-podcasts":"Resume podcasts from where you left off and save your last played content","offline-podcasts":"Offline Podcasts","download-podcasts":"Download podcasts episodes and listen to them offline","reset-password":"Reset password","login-with-mobile":"Log in with my mobile","step-1":"Open the Radioline app on your mobile","step-2":"In the Settings, select \\"Add a device\\"","step-3":"Enter the code displayed on the screen","account":"Account","export-to-playlist":"Export to playlist","export-to-playlist-desc":"Add the music on air to your playlist in one click (Spotify, Deezer)","sign-out":"Log out","reset-password-error":"We could not reset your password, please try again.","email-error":"Email required","reset-password-success":"Your new password has been sent to {email}","instructions":"Instructions","code-required":"Login code required","add-device-meta-description":"Offline access - Radioline","change-my-password":"Change my password","current-password":"Current password","new-password":"New password","repeat-password":"Repeat new password","password-change":{"success":"Your password has been successfully changed"},"password-length-validation":"Your password should be between 8 and 30 characters","password-mismatch-validation":"You entered two different passwords","password-old-passowrd-match-validation":"Your new password cannot be the same as your old password","email-exists-error":"This email is already used with a Radioline account"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Export to playlist","autoplay":"Autoplay","settings":{"link-account":"Link my account","unlink-account":"Unlink my account","no-ads":"No added ads","no-ads-desc":"No visual and audio ads added by Radioline (you can still encounter ads added by the broadcaster)","my-app":"My app","application-language":"Select language","select-application-language":"Select language","homepage-country":"Homepage country","install-app":"Install app","features":"Features","add-device":"Add a device","app-version":"App version","export-to-playlist-desc":"Add the music on air to your playlist in one click","connected-to":"Linked to","settings":"Settings","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"My account"},"continuity":{"popup-close-btn":"Close","popup-play-btn":"Play","popup-header":"You previously listened to:"},"search-for-stations":"Search for stations or podcasts and tap the heart icon to add them here","search-for-a-radio-or-podcast":"Search for a station or a podcast","close":"Close","an e":"An error occured","fallback":{"error":"Something went wrong","button":"Try again"},"export":{"select-platform":"Select a music platform"},"demo-version":"Demo version","search-for-podcasts":"Search for podcasts and tap the download icon to add an episode here","playback-error":"We could not play this stream","offline":{"save-error-toast":"Failed to download episode","remove-success-toast":"Episode removed","save-success-toast":"Episode downloaded","save-in-progress-toast":"Downloading episode","download-episode":"Download this episode","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Visit website","radio":"Radio","no-playlist":"Access to this station\'s playlist is not available or it does not provide any","no-program":"Access to this station\'s program is not available or it does not provide any","no-podcasts":"Access to this station\'s podcasts is not available or it does not provide any"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Track not recognized. You may find this track by looking into this radio playlist if one is provided.","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Track not recognized. You may find this track by looking into this radio playlist if one is provided.","qr-tutorial":{"title":"How to link your Radioline account with a music streaming platform:","step1":"Open your Radioline mobile app or go to our website (www.radioline.co)","step2":"In the settings, select \\"Link my account\\"","step3":"Select the music streaming platform of your choice and follow the instructions"}},"favorites":{"no-favotites":"You don\'t have any favorites yet"},"podcast":"Podcast","search-results":{"try-again":"Try again","no-internet":"No internet connection","no-results":"No search results"},"network":{"connection-lost":"It seems like you have lost connection to the internet","connection-slow":"It seems like your internet connection is slow. You might encounter playback issues","back-online":"Your internet connection has been restored"},"contact-us-success":"Thank you for contacting our support, we will answer you without undue delay","meta":{"description":"Discover a world of radios and podcasts with Radioline, and export music from a radio to your playlist (Spotify / Deezer) in one click!"},"http-error":"This station/podcast broadcasts with an outdated protocol (http) which we prefer not to play for security reasons.","old-website":"Former website","accept-terms":"By signing up, you accept the Terms of Services and Privacy Policy"}');
;// CONCATENATED MODULE: ./app/locales/es.json
var es_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Escuchar • EN DIRECTO","seo_description_radio":"Escucha {var1} • En directo y gratis en Radioline | Pódcast y repeticiones | {var2}","seo_description_podcast":"Escucha el pódcast {var1} gratis en Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Radios en directo y gratis en Radioline","seo_description_categoryRadioPage":"{var1} • Escucha en directo y gratis radios en línea (FM, AM, DAB, Webradios) en Radioline | Pódcast y repeticiones","seo_title_podcast":"{var1} • {var2} Pódcast","seo_title_discoverRadio":"{var1} • Radios en línea, en directo y gratis","seo_description_discoverRadio":"Escucha estaciones de radio en línea, en directo y gratis de {var1} (FM, AM, DAB, Webradios) en Radioline","seo_title_discoverPodcast":"{var1} • Pódcast disponibles de forma gratuita y ordenados por temas","seo_description_discoverPodcast":"Escuche {var1} pódcast en línea y gratis en Radioline","seo_title_home":"Radios, pódcast y repeticiones de todo el mundo gratis | Radioline","seo_description_home":"Descubre un mundo de radios y pódcast con Radioline. Escucha tus estaciones de radio favoritas (FM, AM, DAB, Webradio) y pódcast desde todos los dispositivos con nuestros catálogos locales, nacionales e internacionales.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Inicio","favorites":"Favoritos","discover":"Descubrir","offline":"Desconectado"}},"tabs":{"podcasts":"Podcasts","stations":"Emisoras","schedule":"Programación","all":"Todos","downloaded":"Descargado","unplayed":"No reproducido","playlist":"Lista de reproducción"},"country-selector":"Seleccionar país","hq-stations":"Emisoras HQ","national-selection":"Selección nacional","radioline":"Radioline","worlds-best":"Lo mejor del mundo","thematics":"Temáticas","local-stations":"Emisoras Locales","log-in":"Identificación","log-in-with-my-mobile":"Conectarme con mi móvil","log-in-with-facebook":"Continuar con Facebook","sign-up":"Crear una cuenta","music-on-air":"Música en directo","search":"Búsqueda","email":"Correo electrónico","password":"Contraseña","password-is-required":"Se requiere contraseña","email-is-required":"Correo electrónico obligatorio","could-not-sign-in-please-check-your-email-and-password":"Correo electrónico o contraseña no válidos","forgot-password":"¿Olvidaste la contraseña?","time":{"h":"hr","min":"min","s":"seg"},"navigation-map":"Mapa del sitio","privacy-policy":"Política de Privacidad","privacy-settings":"Ajustes de Privacidad","terms-of-use":"Condiciones de uso","our-solutions":"Nuestras Soluciones","contact":"Contacto","install-app":"Descargar Radioline","add-manage-you-station-or-podcast":"Añadir/Gestionar tu emisora o podcasts","send":"Enviar","field-required":"Este campo es obligatorio","subject":"Sujeto","your-message":"Tu mensaje","your-name":"Tu nombre","episodes":"Episodios","go-to-podcast":"Ir al Podcast","mark-as-played":"Marcar como escuchado","delete":"Borrar","see-website":"Ver el sitio web","you-dont-have-favorites":"Todavía no tiene favoritos. Para guardar sus favoritos, cree una cuenta, ¡es fácil y rápido!","create-an-account":"Crear una cuenta","you-dont-have-podcasts":"Todavía no tienes ningún episodio de podcast descargado.","to-downaload-episodes":"Para descargar episodios de podcast, crea una cuenta, ¡es fácil y rápido!","premium":{"download-podcasts":"Descargar Podcasts y escucharlos sin conexión","go-premium-for":"Convertirse en Premium {var1}","automatically-play-last-radio":"Reproduce automáticamente tu última emisora de radio o podcast al iniciar la aplicación","worlds-best-music-stations":"Las mejores emisoras musicales del mundo","local-and-worldwide":"Catálogos locales y mundiales (161 países)","scan-qr-code":"Escanea este Código QR","no-ads":"Sin anuncios añadidos","no-ads-desc":"No hay anuncios visuales ni sonoros añadidos por Radioline (todavía puede encontrar anuncios añadidos por la emisora)","export-to-playlist-desc":"Añade la música en directo de la radio a tu lista de reproducción en un solo toque (Spotify, Deezer)","worlds-best":"Lo mejor del mundo","worlds-best-desc":"Hemos seleccionado para ti las mejores emisoras musicales del mundo repartidas en 17 géneros musicales","hq-stations-desc":"Descubra emisoras de radio musicales con alta calidad de sonido (MP3 - 320 Kbps)","after-payment-title":"Estamos procesando tu suscripción, espera por favor","after-payment-support":"La suscripción está tardando más de lo previsto en procesarse. Si tienes algún problema ponte en contacto con support@radioline.co","premium":"premium","video-ad-description":"Este anuncio en vídeo nos permite ofrecerte acceso gratuito a la aplicación"},"back":"Volver","auth":{"or":"O","save-your-favorites":"Guarda tus favoritos","synchronize-your-account":"Sincroniza tu cuenta en todos tus dispositivos","resume-playback":"Continuar la lectura","resume-podcasts":"Reanuda los podcasts donde los dejaste en todos tus dispositivos","offline-podcasts":"Podcasts sin conexión","download-podcasts":"Descargar Podcasts y escucharlos sin conexión","reset-password":"Restablecer contraseña","login-with-mobile":"Conectarme con mi móvil","step-1":"Abra la aplicación Radioline sobre su móvil","step-2":"Dentro de configuración, seleccione « Añadir un dispositivo »","step-3":"Introduzca el código que aparece en la pantalla","account":"Cuenta","export-to-playlist":"Exportar a la lista de reproducción","export-to-playlist-desc":"Añade la música en directo de la radio a tu lista de reproducción en un solo toque (Spotify, Deezer)","sign-out":"Desconectarse","reset-password-error":"No hemos podido restablecer tu contraseña, inténtalo de nuevo","email-error":"Correo electrónico obligatorio","reset-password-success":"Tu nueva contraseña se ha enviado a {correo electrónico}","instructions":"Instrucciones","code-required":"Código de conexión obligatorio","add-device-meta-description":"Offline access - Radioline","change-my-password":"Cambiar mi contraseña","current-password":"Contraseña actual","new-password":"Nueva contraseña","repeat-password":"Repite la nueva contraseña","password-change":{"success":"Su contraseña ha sido cambiada exitosamente"},"password-length-validation":"Su contraseña debe tener entre 8 y 30 caracteres","password-mismatch-validation":"Has introducido dos contraseñas diferentes","password-old-passowrd-match-validation":"Su nueva contraseña no puede ser la misma que su contraseña anterior","email-exists-error":"Esta correo electrónico ya la utiliza una cuenta de Radioline"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Exportar a la lista de reproducción","autoplay":"Reproducción automática","settings":{"link-account":"Vincular mi cuenta","unlink-account":"Desvincular mi cuenta","no-ads":"Sin anuncios añadidos","no-ads-desc":"No hay anuncios visuales ni sonoros añadidos por Radioline (todavía puede encontrar anuncios añadidos por la emisora)","my-app":"Mi aplicación","application-language":"Elegir idioma","select-application-language":"Elegir idioma","homepage-country":"País de la pantalla de inicio","install-app":"Descargar Radioline","features":"Características","add-device":"Añadir un dispositivo","app-version":"Versión de la aplicación","export-to-playlist-desc":"Añade la música en directo de la radio a tu lista de reproducción en un solo toque","connected-to":"Vinculado a","settings":"Parámetros","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Mi cuenta"},"continuity":{"popup-close-btn":"Cerrar","popup-play-btn":"Reproducir","popup-header":"Has escuchado previamente"},"search-for-stations":"Busca emisoras o podcasts y toca el icono del corazón para añadirlos aquí","search-for-a-radio-or-podcast":"Buscar una emisora o podcast","close":"Cerrar","generic-error":"Se ha producido un error","fallback":{"error":"Se ha producido un error","button":"Vuelve a intentarlo"},"export":{"select-platform":"Selecciona una plataforma de música"},"demo-version":"Demo version","search-for-podcasts":"Busca podcasts y pulsa el icono de descarga para añadir un episodio aquí","playback-error":"No podemos reproducir esta transmisión","offline":{"save-error-toast":"No se ha podido descargar el episodio","remove-success-toast":"Episodio eliminado","save-success-toast":"Episodio descargado","save-in-progress-toast":"Episodio en proceso de descarga","download-episode":"Descargar este episodio","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Visite la página web","radio":"Emisora","no-playlist":"El acceso a la lista de reproducción de esta emisora no está disponible o no proporciona ninguna","no-program":"El acceso al programa de esta emisora no está disponible o la emisora no lo ofrece","no-podcasts":"El acceso a los podcasts de esta emisora no está disponible o la emisora no los ofrece"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Pista no reconocida. Puedes encontrar esta pista buscando en el historial de canciones de esta radio si se proporciona uno","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Pista no reconocida. Puedes encontrar esta pista buscando en el historial de canciones de esta radio si se proporciona uno","qr-tutorial":{"title":"Cómo vincular tu cuenta de Radioline con una plataforma de música en directo","step1":"Abre tu aplicación móvil Radioline o dirígete a nuestra página web (www.radioline.com)","step2":"En los ajustes, seleccione «Vincular mi cuenta»","step3":"Selecciona la plataforma de música en streaming que quieras y sigue las instrucciones"}},"favorites":{"no-favotites":"Todavía no tiene favoritos"},"podcast":"Podcast","search-results":{"try-again":"Vuelve a intentarlo","no-internet":"No hay conexión a Internet","no-results":"No se han encontrado resultados"},"network":{"connection-lost":"Parece que has perdido tu conexión a Internet","connection-slow":"Parece que tu conexión a Internet es lenta. Puedes tener problemas de lectura","back-online":"Se ha restablecido la conexión a Internet"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Gracias por ponerte en contacto con nuestro equipo de soporte, te responderemos lo antes posible","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"Esta emisora/podcast transmite con un protocolo obsoleto (http) que preferimos no reproducir por razones de seguridad","old-website":"Antiguo sitio web","accept-terms":"Al registrarte, aceptas las condiciones de servicio y la política de privacidad"}');
;// CONCATENATED MODULE: ./app/locales/fr.json
var fr_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Écouter • EN DIRECT","seo_description_radio":"Écouter {var1} • En direct et gratuitement sur Radioline | Podcasts et Replays | {var2}","seo_description_podcast":"Écouter le podcast {var1} gratuitement sur Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Radios en direct et gratuites sur Radioline","seo_description_categoryRadioPage":"{var1} • Écouter gratuitement et en direct des radios en ligne (FM, AM, DAB, Webradios) sur Radioline | Podcasts et Replays","seo_title_podcast":"{var1} • Podcast {var2}","seo_title_discoverRadio":"{var1} • Radios en ligne gratuites et en direct","seo_description_discoverRadio":"Écouter des radios en ligne de {var1} gratuitement et en direct (FM, AM, DAB, Webradios) sur Radioline","seo_title_discoverPodcast":"{var1} • Podcasts accessibles gratuitement et triés par thématiques","seo_description_discoverPodcast":"Écouter des podcasts en ligne de {var1} gratuitement sur Radioline","seo_title_home":"Radios, Podcasts et Replays du monde entier gratuitement | Radioline","seo_description_home":"Découvrez un monde de radios et de podcasts avec Radioline. Écoutez vos stations de radio préférées (FM, AM, DAB, Webradio) et vos podcasts sur tous vos appareils grâce à nos catalogues locaux, nationaux et internationaux.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Accueil","favorites":"Favoris","discover":"Découvrir","offline":"Hors Ligne"}},"tabs":{"podcasts":"Podcasts","stations":"Radios","schedule":"Programmes","all":"Tous","downloaded":"Téléchargés","unplayed":"Non lus","playlist":"Playlist"},"country-selector":"Choisir Pays","hq-stations":"Radios HQ","national-selection":"Sélection Nationale","radioline":"Radioline","worlds-best":"Best Of Monde","thematics":"Thématiques","local-stations":"Stations Locales","log-in":"Se connecter","log-in-with-my-mobile":"Se connecter avec mon mobile","log-in-with-facebook":"Continuer avec Facebook","sign-up":"Créer un compte","music-on-air":"Musique en Direct","search":"Rechercher","email":"E-mail","password":"Mot de Passe","password-is-required":"Password required","email-is-required":"Veuillez indiquer une adresse e-mail valide","could-not-sign-in-please-check-your-email-and-password":"Adresse e-mail et/ou mot de passe invalide","forgot-password":"Mot de Passe oublié ?","time":{"h":"h","min":"min","s":"s"},"navigation-map":"Plan du site","privacy-policy":"Politique de confidentialité","privacy-settings":"Paramètres de confidentialité","terms-of-use":"Conditions d\'utilisation","our-solutions":"Nos solutions","contact":"Contact","install-app":"Installer l\'app","add-manage-you-station-or-podcast":"Ajouter/Gérer votre radio ou podcast","send":"Envoyer","field-required":"Ce champ est requis","subject":"Sujet","your-message":"Votre message","your-name":"Votre nom","episodes":"Épisodes","go-to-podcast":"Aller au Podcast","mark-as-played":"Marquer comme écouté","delete":"Supprimer","see-website":"Voir le site web","you-dont-have-favorites":"Vous n\'avez pas encore de favoris. Pour sauvegarder vos favoris, créez un compte, c\'est simple et rapide !","create-an-account":"Créer un compte","you-dont-have-podcasts":"Vous n\'avez pas encore téléchargé d\'épisodes de podcasts.","to-downaload-episodes":"Pour enregistrer des épisodes de podcasts, créez un compte, c\'est simple et rapide !","premium":{"download-podcasts":"Téléchargez des podcasts et écoutez les hors ligne","go-premium-for":"Go Premium pour {var1}","automatically-play-last-radio":"Lire automatiquement la dernière station radio ou le dernier podcast écouté dès le lancement de l\'application","worlds-best-music-stations":"Best Of Monde","local-and-worldwide":"Catalogues locaux et internationaux (161 pays)","export-to-playlist-desc":"Ajoutez la musique qui passe à la radio à votre playlist en un clic (Spotify, Deezer)","no-ads":"Pas de pub ajoutée","no-ads-desc":"Aucune pub visuelle ou audio ajoutée par Radioline (vous pouvez toujours rencontrer des pubs ajoutées par le diffuseur)","worlds-best":"Best Of Monde","worlds-best-desc":"Nous sélectionnons pour vous les meilleures radios au monde réparties en 17 genres musicaux","hq-stations-desc":"Découvrez des radios diffusant avec une qualité audio élevée (MP3 - 320 Kbps)","scan-qr-code":"Scannez ce QR code","after-payment-title":"Nous traitons votre abonnement, veuillez patienter","after-payment-support":"Le traitement de votre abonnement est plus long que prévu. Si vous rencontrez un problème, veuillez contacter support@radioline.co","premium":"premium","video-ad-description":"Cette pub vidéo nous permet de vous faire profiter de l\'app gratuitement"},"back":"Retour","auth":{"or":"OU","save-your-favorites":"Sauvegarder vos favoris","synchronize-your-account":"Synchronisez votre compte avec vos appareils compatibles","resume-playback":"Reprendre la lecture","resume-podcasts":"Reprenez la lecture de vos podcasts là où vous l\'avez interrompue et sauvegardez votre dernier contenu écouté","offline-podcasts":"Podcasts hors ligne","download-podcasts":"Téléchargez des podcasts et écoutez les hors ligne","reset-password":"Réinitialiser le mot de passe","login-with-mobile":"Se connecter avec mon mobile","step-1":"Ouvrez l\'application Radioline sur votre mobile","step-2":"Dans les paramètres, sélectionnez \\"Ajouter un appareil\\"","step-3":"Entrez le code affiché à l\'écran","account":"Compte","export-to-playlist":"Exporter vers une playlist","export-to-playlist-desc":"Ajoutez la musique qui passe à la radio à votre playlist en un clic (Spotify, Deezer)","sign-out":"Se déconnecter","reset-password-error":"La réinitialisation du mot de passe a échouée, veuillez réessayer","email-error":"E-mail requis","reset-password-success":"Votre nouveau mot de passe a été envoyé à {email}","instructions":"Instructions","code-required":"Code de connexion requis","add-device-meta-description":"Offline access - Radioline","change-my-password":"Changer mon mot de passe","current-password":"Mot de passe actuel","new-password":"Nouveau mot de passe","repeat-password":"Répetez le nouveau mot de passe","password-change":{"success":"Votre mot de passe a été changé avec succès"},"password-length-validation":"Votre mot de passe doit comporter entre 8 et 30 caractères","password-mismatch-validation":"Vous avez entré 2 mots de passe différents","password-old-passowrd-match-validation":"Votre nouveau mot de passe doit être différent de votre ancien mot de passe","email-exists-error":"Cet email est déjà utilisé avec un compte Radioline"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Exporter vers une Playlist","autoplay":"Autoplay","settings":{"link-account":"Associer mon compte","unlink-account":"Dissocier mon compte","no-ads":"Pas de pub ajoutée","no-ads-desc":"Aucune pub visuelle ou audio ajoutée par Radioline (vous pouvez toujours rencontrer des pubs ajoutées par le diffuseur)","my-app":"Mon app","application-language":"Langue de l\'application","select-application-language":"Langue de l\'application","homepage-country":"Pays de l\'écran d\'accueil","install-app":"Installer l\'app","features":"Fonctionnalités","add-device":"Ajouter un appareil","app-version":"Version de l\'app","export-to-playlist-desc":"Ajoutez la musique qui passe à la radio à votre playlist en un clic","connected-to":"Associé à","settings":"Paramètres","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Mon compte"},"continuity":{"popup-close-btn":"Fermer","popup-play-btn":"Lire","popup-header":"Lu précédemment"},"search-for-stations":"Recherchez des radios ou des podcasts et appuyez sur l\'icône en forme de cœur pour les ajouter ici","search-for-a-radio-or-podcast":"Recherchez une radio ou un podcast","close":"Fermer","generic-error":"Une erreur s\'est produite","fallback":{"error":"Une erreur s\'est produite","button":"Veuillez réssayer"},"export":{"select-platform":"Sélectionnez une plateforme de streaming"},"demo-version":"Demo version","search-for-podcasts":"Recherchez des podcasts et appuyez sur l\'icône de téléchargement pour ajouter un épisode ici","playback-error":"Nous ne pouvons pas lire ce flux","offline":{"save-error-toast":"Échec du téléchargement de l\'épisode","remove-success-toast":"Épisode supprimé","save-success-toast":"Épisode télechargé","save-in-progress-toast":"Téléchargement de l\'épisode en cours","download-episode":"Télécharger cet épisode","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Visiter le site web","radio":"Radio","no-playlist":"L\'accès à la playlist de cette radio n’est pas disponible ou celle-ci n’en propose pas","no-program":"L\'accès au programme de cette radio n’est pas disponible ou celle-ci n’en propose pas","no-podcasts":"L\'accès aux podcasts de cette radio n’est pas disponible ou celle-ci n’en propose pas"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Titre non reconnu. Vous pouvez consulter la playlist de cette radio si elle est disponible.","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Titre non reconnu. Vous pouvez consulter la playlist de cette radio si elle est disponible.","qr-tutorial":{"title":"Comment associer votre compte Radioline avec un service de streaming musical","step1":"Ouvrez votre app mobile Radioline ou rendez vous sur notre site web (app.radioline.co)","step2":"Dans les paramètres, sélectionnez \\"Associer mon compte\\"","step3":"Choisissez votre service de streaming et suivez les instructions"}},"favorites":{"no-favotites":"Vous n\'avez pas encore de favoris"},"podcast":"Podcast","search-results":{"try-again":"Veuillez réessayer","no-internet":"Pas de connexion Internet","no-results":"Aucun résultat trouvé"},"network":{"connection-lost":"Il semble que vous ayez perdu votre connexion à Internet","connection-slow":"Il semble que votre connexion Internet soit lente. Vous pourriez rencontrer des problèmes de lecture","back-online":"Votre connexion Internet a été restaurée"},"homepage-meta-description":"110 000 Radios (FM, AM, Internet) et Podcasts !","contact-us-success":"Merci d\'avoir contacté notre support, nous vous répondrons dans les meilleurs délais","meta":{"description":"Découvrez un monde de Radios (FM, AM, Internet) et Podcasts avec Radioline. Exportez la musique qui passe à la radio vers votre playlist (Spotify/Deezer) en un clic !"},"http-error":"Cette radio/podcast émet avec un protocole obsolète (http) que nous préférons ne pas diffuser pour des raisons de sécurité.","old-website":"Ancien site web","accept-terms":"En créant un compte, vous acceptez les Conditions Générales d\'Utilisation et la Politique de Confidentialité"}');
;// CONCATENATED MODULE: ./app/locales/hi.json
var hi_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | LIVE • सुनें","seo_description_radio":"{var1} सुनें • Radioline पर लाइव और मुफ़्त | पॉडकास्ट और रिप्ले | {var2}","seo_description_podcast":"Radioline पर पॉडकास्ट {var1} मुफ़्त सुनें | {var2}","seo_title_category_RadioPage":"{var1} • Radioline पर रेडियो लाइव और मुफ़्त है","seo_description_categoryRadioPage":"{var1} • Radioline पर ऑनलाइन रेडियो (एफ.एम., ए.एम., डी.ए.बी., वेबरेडियो) लाइव और मुफ़्त सुनें | पॉडकास्ट और रिप्ले","seo_title_podcast":"{var1} • {var2} पॉडकास्ट","seo_title_discoverRadio":"{var1} • ऑनलाइन रेडियो लाइव और मुफ़्त","seo_description_discoverRadio":"Radioline पर {var1} मुफ़्त लाइव ऑनलाइन रेडियो स्टेशन (एफ.एम., ए.एम., डी.ए.बी., वेबरेडियो) सुनें","seo_title_discoverPodcast":"{var1} • पॉडकास्ट मुफ़्त में उपलब्ध है और थीम के अनुसार क्रमबद्ध है","seo_description_discoverPodcast":"Radioline पर {var1} पॉडकास्ट ऑनलाइन मुफ़्त में सुनें","seo_title_home":"दुनिया भर से रेडियो, पॉडकास्ट और रीप्ले मुफ़्त में | Radioline","seo_description_home":"Radioline के साथ रेडियो और पॉडकास्ट की दुनिया देखें. हमारे लोकल, राष्ट्रीय और अंतर्राष्ट्रीय कैटलॉग के साथ अपने सभी डिवाइस से अपने पसंदीदा रेडियो स्टेशन (एफ.एम., ए.एम., डी.ए.बी., वेबरेडियो) और पॉडकास्ट सुनें.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"घर","favorites":"पसंदीदा","discover":"खोज करना","offline":"असम्प्रक्त"}},"tabs":{"podcasts":"इन्टरनेट का रेडियो","stations":"बिना तार का यंत्र","schedule":"अनुसूची","all":"सभी","downloaded":"अधोभारण","unplayed":"नहीं चलाए गए","playlist":"श्रवण सूची"},"country-selector":"देश चुनें","hq-stations":"मुख्यालय रेडियो","worlds-best":"दुनिया के बेहतरीन","thematics":"विषय-वस्तु","national-selection":"राष्ट्रीय चयन","radioline":"Radioline","local-stations":"स्थानीय केन्द्र","log-in-with-my-mobile":"मेरे मोबाइल से लॉग इन करें","log-in-with-facebook":"Facebook के साथ जारी रखें","log-in":"में प्रवेश करें","sign-up":"साइन अप करें","search":"खोज","music-on-air":"जीवंत संगीत","forgot-password":"शब्दकूट भूल गए","password":"शब्दकूट","password-is-required":"कूट संकेत और/या मेल पता गायब है।","email":"ईमेल","email-is-required":"कृपया एक सही ईमेल दर्ज करें","could-not-sign-in-please-check-your-email-and-password":"गलत ईमेल / या शब्दकूट","time":{"h":"घंटा","min":"मिनट","s":"सेकंड"},"navigation-map":"साइट का नक्शा","privacy-policy":"गोपनीयता नीति","privacy-settings":"गोपनीय सेटिंग","terms-of-use":"उपयोग की शर्तें","our-solutions":"हमारे समाधान","contact":"संपर्क करना","install-app":"एप्लिकेशन इंस्टॉल करें","add-manage-you-station-or-podcast":"अपना स्टेशन या इन्टरनेट का रेडियो स्टेशन जोड़ें/प्रबंधित करें","send":"भेजना","field-required":"यह क्षेत्रक आवश्यक है","subject":"विषय","your-message":"आपका संदेश","your-name":"आपका नाम","episodes":"कड़ियों","go-to-podcast":"इन्टरनेट का रेडियो के पास जाओ","mark-as-played":"खेला गया के रूप में चिह्नित करें","delete":"मिटाना","see-website":"वेबसाइट देखें","you-dont-have-favorites":"आपके पास अभी तक कोई पसंदीदा नहीं है। अपने पसंदीदा को बचाने के लिए, एक खाता बनाएं, यह आसान और तेज़ है!","create-an-account":"खाता बनाएं","you-dont-have-podcasts":"आपने अभी तक कोई भी पॉडकास्ट एपिसोड डाउनलोड नहीं किया है।","to-downaload-episodes":"पॉडकास्ट एपिसोड डाउनलोड करने के लिए, एक खाता बनाएं, यह आसान और तेज़ है!","premium":{"download-podcasts":"पॉडकास्ट डाउनलोड करें और उन्हें ऑफ़लाइन सुनें","go-premium-for":"{var1} के लिए प्रीमियम","automatically-play-last-radio":"एप्लिकेशन लॉन्च होने पर अपना अंतिम रेडियो स्टेशन या इन्टरनेट का रेडियो स्टेशन स्वचालित रूप से चलाएं","worlds-best-music-stations":"दुनिया के बेहतरीन","local-and-worldwide":"स्थानीय और विश्वव्यापी क्यूरेटेड नामसूची (161 देश)","scan-qr-code":"इस क्यूआर कोड को स्कैन करें","no-ads":"कोई विज्ञापन नहीं जोड़ा","no-ads-desc":"रेडियोलाइन द्वारा कोई प्रदर्शन या ऑडियो विज्ञापन नहीं जोड़ा गया। आप अभी भी प्रसारक द्वारा जोड़े गए विज्ञापनों का सामना कर सकते हैं","export-to-playlist-desc":"एक क्लिक में अपनी प्लेलिस्ट में ऑन एयर संगीत जोड़ें (Spotify, Deezer)","worlds-best":"दुनिया के बेहतरीन","worlds-best-desc":"हमने आपके लिए 17 संगीत शैलियों के लिए दुनिया भर के सर्वश्रेष्ठ संगीत स्टेशनों का चयन किया है","hq-stations-desc":"उच्च ध्वनि गुणवत्ता वाले संगीत रेडियो स्टेशन खोजें (MP3 - 320 Kbps)","after-payment-title":"हम आपकी सदस्यता संसाधित कर रहे हैं, कृपया प्रतीक्षा करें","after-payment-support":"सदस्यता संसाधन अपेक्षा से थोड़ा अधिक समय लेता है। यदि आपको कोई समस्या आती है तो कृपया support@radioline.co . पर संपर्क करें","premium":"अधिमूल्य","video-ad-description":"यह वीडियो विज्ञापन हमें आपको निःशुल्क ऐप का आनंद लेने की अनुमति देता है"},"back":"वापस जाओ","auth":{"or":"OR","save-your-favorites":"अपने पसंदीदा सहेजें","synchronize-your-account":"अपने खाते को संगत उपकरणों के साथ सिंक्रनाइज़ करें","resume-playback":"प्लेबैक वापस चालू करें","resume-podcasts":"इन्टरनेट का रेडियो स्टेशन वहीं से शुरू करें जहां से आपने छोड़ा था और अपनी पिछली बार चलाई गई सामग्री को सेव करें","offline-podcasts":"ऑफलाइन इन्टरनेट का रेडियो स्टेशन","download-podcasts":"पॉडकास्ट डाउनलोड करें और उन्हें ऑफ़लाइन सुनें","reset-password":"फिर से शब्दकूट बनाना","login-with-mobile":"मेरे मोबाइल से लॉग इन करें","step-1":"अपने मोबाइल पर रेडियोलाइन एप्लिकेशन खोलें","step-2":"सेटिंग में, डिवाइस जोड़ें चुनें","step-3":"स्क्रीन पर प्रदर्शित कूट भाषा दर्ज करें","account":"खाता","export-to-playlist":"प्लेलिस्ट में निर्यात करें","export-to-playlist-desc":"एक क्लिक में अपनी प्लेलिस्ट में ऑन एयर संगीत जोड़ें (Spotify, Deezer)","sign-out":"लॉग आउट करो","reset-password-error":"हम आपका संकेत शब्द दोहरा नहीं कर सके, कृपया पुनः प्रयास करें","email-error":"ईमेल अनिवार्य","reset-password-success":"आपका नया पासवर्ड {email} पर भेज दिया गया है","instructions":"निर्देश","code-required":"लॉगिन कूट संकेत आवश्यक","add-device-meta-description":"Offline access - Radioline","change-my-password":"मेरा संकेत शब्द बदलो","current-password":"वर्तमान संकेत शब्द","new-password":"नया संकेत शब्द","repeat-password":"नया संकेत शब्द दोहराएँ","password-change":{"success":"आपका पासवर्ड सफलतापूर्वक बदला जा चुका है"},"password-length-validation":"आपका पासवर्ड 8 से 30 अक्षरों के बीच होना चाहिए","password-mismatch-validation":"आपने दो अलग-अलग पासवर्ड दर्ज किए हैं","password-old-passowrd-match-validation":"आपका नया पासवर्ड आपके पिछले पासवर्ड से अलग होना चाहिए","email-exists-error":"यह ईमेल पहले से ही रेडियोलाइन खाते के साथ प्रयोग किया जाता है"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"प्लेलिस्ट में निर्यात करें","autoplay":"स्वचालित","settings":{"link-account":"मेरा खाता लिंक करें","unlink-account":"मेरा खाता अनलिंक करें","no-ads":"कोई विज्ञापन नहीं जोड़ा","no-ads-desc":"रेडियोलाइन द्वारा कोई प्रदर्शन या ऑडियो विज्ञापन नहीं जोड़ा गया। आप अभी भी प्रसारक द्वारा जोड़े गए विज्ञापनों का सामना कर सकते हैं","my-app":"मेरे अनुप्रयोग","application-language":"भाषा का चयन करें","select-application-language":"भाषा का चयन करें","homepage-country":"मुखपृष्ठ देश","install-app":"एप्लिकेशन इंस्टॉल करें","features":"विशेषताएँ","add-device":"एक उपकरण जोड़ें","app-version":"एप्लिकेशन संस्करण","export-to-playlist-desc":"एक क्लिक में अपनी प्लेलिस्ट में ऑन एयर संगीत जोड़ें","connected-to":"से लिंक किया गया।","settings":"समायोजन","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"मेरा खाता"},"continuity":{"popup-close-btn":"बंद करे","popup-play-btn":"खेलना","popup-header":"आपने पहले सुना था:"},"search-for-stations":"स्टेशन या इन्टरनेट का रेडियो स्टेशन खोजें और उन्हें यहां जोड़ने के लिए दिल के आइकन पर टैप करें","search-for-a-radio-or-podcast":"रेडियो या इन्टरनेट का रेडियो स्टेशन खोजें","close":"बंद करे","generic-error":"एक त्रुटि पाई गई","fallback":{"error":"कुछ गलत हो गया","button":"पुनः प्रयास करें"},"export":{"select-platform":"एक संगीत मंच चुनें"},"demo-version":"Demo version","search-for-podcasts":"इन्टरनेट का रेडियो स्टेशन खोजें और यहां एक एपिसोड जोड़ने के लिए डाउनलोड आइकन पर टैप करें","playback-error":"हम यह स्ट्रीम नहीं चला सके","offline":{"save-error-toast":"एपिसोड डाउनलोड करने में विफल","remove-success-toast":"एपिसोड हटा दिया गया","save-success-toast":"एपिसोड डाउनलोड किया गया","save-in-progress-toast":"एपिसोड डाउनलोड हो रहा है","download-episode":"इस एपिसोड को डाउनलोड करें","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"वेबसाइट पर जाएँ","radio":"बिना तार का यंत्र","no-playlist":"इस स्टेशन की प्लेलिस्ट तक पहुंच उपलब्ध नहीं है या यह कोई भी प्रदान नहीं करता है","no-program":"इस स्टेशन के कार्यक्रम तक पहुंच उपलब्ध नहीं है या यह कोई प्रदान नहीं करता है","no-podcasts":"इस स्टेशन के इन्टरनेट का रेडियो तक पहुंच उपलब्ध नहीं है या यह कोई भी प्रदान नहीं करता है"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"ट्रैक पहचाना नहीं गया। यदि कोई उपलब्ध कराया गया है तो आप इस रेडियो प्लेलिस्ट को देखकर इस ट्रैक को ढूंढ सकते हैं।","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"ट्रैक पहचाना नहीं गया। यदि कोई उपलब्ध कराया गया है तो आप इस रेडियो प्लेलिस्ट को देखकर इस ट्रैक को ढूंढ सकते हैं।","qr-tutorial":{"title":"अपने रेडियोलाइन खाते को संगीत स्ट्रीमिंग प्लेटफॉर्म से कैसे लिंक करें:","step1":"अपना रेडियोलाइन मोबाइल एप्लिकेशन खोलें या हमारी वेबसाइट (www.radioline.co) पर जाएं।","step2":"सेटिंग्स में, \\"मेरा खाता लिंक करें\\" चुनें","step3":"अपनी पसंद के संगीत स्ट्रीमिंग प्लेटफॉर्म का चयन करें और निर्देशों का पालन करें"}},"favorites":{"no-favotites":"आपके पास अभी तक कोई पसंदीदा नहीं है।"},"podcast":"इन्टरनेट का रेडियो","search-results":{"try-again":"पुनः प्रयास करें","no-internet":"कोई इंटरनेट कनेक्शन नहीं","no-results":"खोजने पर कोई परिणाम नहीं मिला"},"network":{"connection-lost":"ऐसा लगता है कि आपने इंटरनेट से कनेक्शन खो दिया है","connection-slow":"ऐसा लगता है कि आपका इंटरनेट कनेक्शन धीमा है। आप प्लेबैक समस्याओं का सामना कर सकते हैं","back-online":"आपका इंटरनेट कनेक्शन बहाल कर दिया गया है"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"हमारे समर्थन से संपर्क करने के लिए धन्यवाद, हम बिना किसी देरी के आपको जवाब देंगे","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"यह स्टेशन/ इन्टरनेट का रेडियो स्टेशन पुराने संदेशाचार (http) के साथ प्रसारित होता है जिसे हम सुरक्षा कारणों से नहीं चलाना पसंद करते हैं।","old-website":"पूर्व वेबसाइट","accept-terms":"साइन अप करके, आप सेवा की शर्तों और गोपनीयता नीति को स्वीकार करते हैं"}');
;// CONCATENATED MODULE: ./app/locales/it.json
var it_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Ascolta • DAL VIVO","seo_description_radio":"Ascolta {var1} • In diretta e gratuitamente su Radioline | Podcast e riproduzioni | {var2}","seo_description_podcast":"Ascolta gratuitamente il podcast {var1} su Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Radio in diretta e gratuite su Radioline","seo_description_categoryRadioPage":"{var1} • Ascolta in diretta e gratuitamente le radio online (FM, AM, DAB, Webradio) su Radioline | Podcast e riproduzioni","seo_title_podcast":"{var1} • {var2} Podcast","seo_title_discoverRadio":"{var1} • Radio online dal vivo e gratuite","seo_description_discoverRadio":"Ascolta {var1} stazioni radio online, in diretta e gratuite (FM, AM, DAB, Webradio) su Radioline","seo_title_discoverPodcast":"{var1} • Podcast disponibili gratuitamente e ordinati per tema","seo_description_discoverPodcast":"Ascolta {var1} podcast online gratuitamente su Radioline","seo_title_home":"Radio, podcast e riproduzioni da tutto il mondo gratis | Radioline","seo_description_home":"Scopri un mondo di radio e podcast con Radioline. Ascolta le tue stazioni radio preferite (FM, AM, DAB, Webradio) e i tuoi podcast da tutti i tuoi dispositivi con i nostri cataloghi locali, nazionali e internazionali.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Home","favorites":"Preferiti","discover":"Scopri","offline":"Non in linea"}},"tabs":{"podcasts":"Podcast","stations":"Stazioni","schedule":"Programma","all":"Tutti","downloaded":"Scaricati","unplayed":"Non riprodotti","playlist":"Playlist"},"country-selector":"Seleziona paese","hq-stations":"Stazioni HQ","national-selection":"Selezione nazionale","radioline":"Radioline","worlds-best":"Il meglio del mondo","thematics":"Tematiche","local-stations":"Stazioni Locali","log-in":"Log-in","log-in-with-my-mobile":"Connessione con il dispositivo mobile","log-in-with-facebook":"Continua con Facebook","sign-up":"Crea un account","music-on-air":"Musica in diretta","search":"Ricerca","email":"E-mail","password":"Password","email-is-required":"E-mail obbligatoria","could-not-sign-in-please-check-your-email-and-password":"E-mail e/o password non valide","forgot-password":"Hai dimenticato la password?","time":{"h":"ore","min":"min","s":"sec"},"navigation-map":"Mappa del sito","privacy-policy":"Informativa sulla privacy","privacy-settings":"Impostazioni privacy","terms-of-use":"Condizioni d’uso","our-solutions":"Le nostre soluzioni","contact":"Contatti","install-app":"Scarica Radioline","add-manage-you-station-or-podcast":"Aggiungi/gestisci la tua stazione radio o il tuo podcast","send":"Invia","field-required":"Questo campo è obbligatorio","subject":"Oggetto","your-message":"Messaggio","your-name":"Nome","episodes":"Episodi","go-to-podcast":"Vai al podcast","mark-as-played":"Segna come già ascoltato","delete":"Elimina","see-website":"Vedi il sito","you-dont-have-favorites":"Non hai ancora nessun preferito. Per salvare i tuoi preferiti, devi prima creare un account: è semplice e veloce!","create-an-account":"Crea un account","you-dont-have-podcasts":"Non hai ancora scaricato nessun episodio di podcast.","to-downaload-episodes":"Per scaricare un episodio di podcast, devi prima creare un account: è semplice e veloce!","premium":{"download-podcasts":"Scarica i podcast e ascolta offline","go-premium-for":"Passa a Premium a {var1}","automatically-play-last-radio":"Riproduci automaticamente l’ultima stazione radio o l’ultimo podcast al lancio dell’app","worlds-best-music-stations":"Il meglio del mondo","local-and-worldwide":"Cataloghi curati locali e mondiali (161 paesi)","scan-qr-code":"Inquadra questo QR Code","no-ads":"Nessuna pubblicità aggiunta","no-ads-desc":"Nessuna pubblicità audio/video aggiunta da Radioline (potrai comunque ricevere pubblicità aggiunte dall’emittente)","export-to-playlist-desc":"Aggiungi la musica live in radio alla tua playlist con un tocco (Spotify, Deezer)","worlds-best":"Il meglio del mondo","worlds-best-desc":"Abbiamo scelto per te le migliori stazioni radio musicali al mondo per 17 generi diversi","hq-stations-desc":"Scopri le stazioni radio musicali che riproducono con audio di alta qualità (MP3 - 320 Kbps)","after-payment-title":"Stiamo elaborando il tuo abbonamento, ti preghiamo di attendere","after-payment-support":"L’elaborazione dell’abbonamento sta impiegando più del previsto. Per qualsiasi problema puoi contattare support@radioline.co","premium":"premium","video-ad-description":"Questo video pubblicitario ci consente di farvi godere dell\'applicazione gratuitamente"},"back":"Indietro","auth":{"or":"OPPURE","save-your-favorites":"Salva i tuoi preferiti","synchronize-your-account":"Sincronizza il tuo account in tutti i tuoi dispositivi","resume-playback":"Riprendi la riproduzione","resume-podcasts":"Riprendi il podcast da dove hai interrotto e salva l’ultimo contenuto riprodotto","offline-podcasts":"Podcast offline","download-podcasts":"Scarica i podcast e ascolta offline","reset-password":"Reimposta la password","login-with-mobile":"Connessione con il dispositivo mobile","step-1":"Apri l’app Radioline sul tuo dispositivo mobile","step-2":"Nelle impostazioni, seleziona \\"Aggiungi un dispositivo\\"","step-3":"Inserisci il codice visualizzato sullo schermo","account":"Account","export-to-playlist":"Esporta nella playlist","export-to-playlist-desc":"Aggiungi la musica live in radio alla tua playlist con un tocco (Spotify, Deezer)","sign-out":"Disconnessione","reset-password-error":"Non è stato possibile reimpostare la tua password. Ti preghiamo di riprovare","email-error":"E-mail obbligatoria","reset-password-success":"La tua nuova password è stata inviata a {email}","instructions":"Istruzioni","code-required":"Codice di login obbligatorio","add-device-meta-description":"Offline access - Radioline","change-my-password":"Cambia la mia password","current-password":"Password attuale","new-password":"Nuova password","repeat-password":"Ripeti la nuova password","password-change":{"success":"La tua password è stata cambiata con successo"},"password-length-validation":"La tua password deve contenere da 8 a 30 caratteri","password-mismatch-validation":"Hai inserito due password diverse","password-old-passowrd-match-validation":"La tua nuova password deve essere diversa dalla tua password precedente","email-exists-error":"Questa email è già utilizzata con un account Radioline"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Esporta nella playlist","autoplay":"Riproduzione automatica","settings":{"link-account":"Collega il mio account","unlink-account":"Scollega il mio account","no-ads":"Nessuna pubblicità aggiunta","no-ads-desc":"Nessuna pubblicità audio/video aggiunta da Radioline (potrai comunque ricevere pubblicità aggiunte dall’emittente)","my-app":"La mia app","application-language":"Seleziona lingua","select-application-language":"Seleziona lingua","homepage-country":"Paese della schermata Home:","install-app":"Scarica Radioline","features":"Caratteristiche","add-device":"Aggiungi un dispositivo","app-version":"Versione dell’app","export-to-playlist-desc":"Aggiungi la musica live in radio alla tua playlist con un tocco","connected-to":"Collegato a","settings":"Impostazioni","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Il mio account"},"continuity":{"popup-close-btn":"Chiudi","popup-play-btn":"Riproduci","popup-header":"Prima hai ascoltato:"},"search-for-stations":"Cerca le stazioni radio o i podcast e tocca l’icona a forma di cuore per aggiungerli qui","search-for-a-radio-or-podcast":"Cerca una radio o un podcast","close":"Chiudi","an e":"Si è verificato un errore","fallback":{"error":"Si è verificato un errore","button":"Riprova"},"export":{"select-platform":"Seleziona una piattaforma musicale"},"demo-version":"Demo version","search-for-podcasts":"Cerca i podcast e tocca l’icona di download per aggiungere qui un episodio","playback-error":"Impossibile riprodurre questo streaming","offline":{"save-error-toast":"Impossibile scaricare l’episodio","remove-success-toast":"Episodio eliminato","save-success-toast":"Episodio scaricato","save-in-progress-toast":"Scaricamento episodio in corso","download-episode":"Scarica questo episodio","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Visita il sito web","radio":"Radio","no-playlist":"L’accesso alla playlist di questa stazione non è disponibile o non propone","no-program":"L’accesso al programma di questa stazione non è disponibile o non propone","no-podcasts":"L’accesso ai podcast di questa stazione non è disponibile o non propone"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Brano non riconosciuto. Puoi trovare questo brano cercando nella cronologia delle canzoni di questa radio, se disponibile","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Brano non riconosciuto. Puoi trovare questo brano cercando nella cronologia delle canzoni di questa radio, se disponibile","qr-tutorial":{"title":"Come collegare il proprio account Radioline a una piattaforma di streaming musicale:","step1":"Apri l’app mobile Radioline o vai sul nostro sito (www.radioline.co)","step2":"Nelle impostazioni, seleziona “Collega il mio account”","step3":"Seleziona la piattaforma di streaming musicale di tua scelta e segui le istruzioni"}},"favorites":{"no-favotites":"Non hai ancora nessun preferito"},"podcast":"Podcast","search-results":{"try-again":"Riprova","no-internet":"Nessuna connessione a Internet","no-results":"Nessun risultato trovato"},"network":{"connection-lost":"Sembra che tu non sia più connesso a Internet","connection-slow":"Sembra che la tua connessione a Internet sia lenta. Potrebbero verificarsi problemi di riproduzione","back-online":"La tua connessione a Internet è stata ripristinata"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Grazie per aver contattato l’assistenza. Risponderemo quanto prima.","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"Questa stazione/podcast trasmette con un protocollo obsoleto (http) che preferiamo non riprodurre per ragioni di sicurezza.","old-website":"Ex sito web","accept-terms":"Creando un account, accetti le condizioni generali di servizio e l’informativa sulla privacy"}');
;// CONCATENATED MODULE: ./app/locales/ja.json
var ja_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | 聞く・ライブ","seo_description_radio":"{var1} を聴く • Radiolineで無料でライブ | ポッドキャストとリプレイ | {var2}","seo_description_podcast":"Radiolineでポッドキャスト {var1} を無料で聴く | {var2}","seo_title_category_RadioPage":"{var1} • Radiolineでラジオが無料でライブ","seo_description_categoryRadioPage":"{var1} • Radiolineでオンラインラジオ（FM、AM、DAB、Webradios）をライブで無料で聴くことができます | ポッドキャストとリプレイ","seo_title_podcast":"{var1} • {var2} ポッドキャスト","seo_title_discoverRadio":"{var1} • オンラインラジオが無料でライブ","seo_description_discoverRadio":"Radiolineで {var1} の無料のライブオンラインラジオ局（FM、AM、DAB、Webradios）を聴く","seo_title_discoverPodcast":"{var1} • 無料で利用できる、テーマごとに分類されたポッドキャスト","seo_description_discoverPodcast":"Radiolineで {var1} ポッドキャストをオンラインで無料で聴く","seo_title_home":"世界中のラジオ、ポッドキャスト、リプレイを無料で | Radioline","seo_description_home":"Radiolineでラジオとポッドキャストの世界を発見しましょう。地元、国内、海外のカタログを使用して、すべてのデバイスからお気に入りのラジオ局（FM、AM、DAB、Webradio）やポッドキャストを聴くことができます。","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"ホーム","favorites":"お気に入り","discover":"ディスカバー","offline":"オフライン"}},"tabs":{"podcasts":"ポッドキャスト","stations":"ラジオステーション","schedule":"スケジュール","all":"全てのエピソード","downloaded":"ダウンロード済み","unplayed":"未再生の曲","playlist":"プレイリスト"},"country-selector":"国を選択","hq-stations":"HQステーション","national-selection":"ナショナルチャンネルを選択","radioline":"Radioline","worlds-best":"世界のベスト音楽局","thematics":"テーマ別","local-stations":"ローカルステーション","log-in":"ログイン","log-in-with-my-mobile":"携帯電話からのログイン","log-in-with-facebook":"Facebookでログイン","sign-up":"登録","music-on-air":"ミュージック・オン・エア","search":"検索する","email":"Eメール","email-is-required":"電子メール必須","could-not-sign-in-please-check-your-email-and-password":"メールアドレスかパスワードに誤りがあります","password":"パスワード","password-is-required":"パスワードが必要","forgot-password":"パスワードをお忘れですか？","time":{"h":"時間","min":"分","s":"秒"},"navigation-map":"サイトマップ","privacy-policy":"個人情報の取り扱いについて","privacy-settings":"プライバシーに関する設定","terms-of-use":"ご利用規約","our-solutions":"当社のソリューション","contact":"お問合せ","install-app":"Radiolineをダウンロードする","add-manage-you-station-or-podcast":"放送局やポッドキャストの追加/管理","send":"送信","field-required":"この項目は必須です。","subject":"件名","your-message":"メッセージを入力","your-name":"お名前","episodes":"エピソード","go-to-podcast":"ポッドキャストを見る","mark-as-played":"再生済み表示","delete":"消去","see-website":"ウェブサイトを見る","you-dont-have-favorites":"お気に入りがまだありません。お気に入りを保存するには、アカウントを作成しましょう。簡単・すぐにできます！","create-an-account":"アカウントの作成","you-dont-have-podcasts":"ポッドキャストのエピソードがまだダウンロードされていません。","to-downaload-episodes":"ポッドキャストのエピソードは簡単・すぐにダウンロードできます！","premium":{"download-podcasts":"ポッドキャストをダウンロードしてオフラインで聴く","go-premium-for":"{var1} でプレミアムに登録","automatically-play-last-radio":"アプリの起動時に、キャストしたラジオ局やポッドキャストを自動的に再生します。","worlds-best-music-stations":"世界のベスト音楽局","local-and-worldwide":"ローカルおよびワールドワイドに監修されたカタログ（161カ国）","scan-qr-code":"このQRコードを読み込む","no-ads":"広告の表示なし","no-ads-desc":"Radiolineによる映像・音声広告の表示なし（放送局により追加された広告が表示されることはあります。）","export-to-playlist-desc":"ラジオで生放送されている音楽をワンタッチでプレイリストに追加（Spotify, Deezer）","worlds-best":"世界のベスト音楽局","worlds-best-desc":"17の音楽ジャンルから世界のベスト音楽ステーションを選びました","hq-stations-desc":"高音質（MP3 -320Kbps）の音楽ラジオ局が見つかります","after-payment-title":"会員登録手続き中です。お待ちください","after-payment-support":"会員登録手続きに時間がかかっています。問題がある場合は下記までご連絡ください。support@radioline.co","premium":"premium","video-ad-description":"このビデオ広告により、アプリへの無料アクセスが可能になります"},"back":"戻る","auth":{"or":"または","save-your-favorites":"お気に入りの保存","synchronize-your-account":"全てのデバイスでアカウントを同期化する","resume-playback":"再生を再開","resume-podcasts":"ポッドキャストを中断したところから再開し、最後に再生したコンテンツを保存する","offline-podcasts":"ポッドキャストをオフラインにする","download-podcasts":"ポッドキャストをダウンロードしてオフラインで聴く","reset-password":"パスワードをリセット","login-with-mobile":"携帯電話からのログイン","step-1":"携帯電話でRadiolineアプリを開く","step-2":"設定で「デバイスの追加」を選択","step-3":"画面に表示されたコードを入力","account":"アカウント","export-to-playlist":"プレイリストにエクスポート","export-to-playlist-desc":"ラジオで生放送されている音楽をワンタッチでプレイリストに追加（Spotify, Deezer)","sign-out":"ログアウト","reset-password-error":"パスワードのリセットに失敗しました。もう一度やり直してください","email-error":"電子メール必須","reset-password-success":"新しいパスワードが{email}に送信されました","instructions":"ご使用方法","code-required":"ログインコードが必要です","add-device-meta-description":"Offline access - Radioline","change-my-password":"パスワードを変更する","current-password":"現在のパスワード","new-password":"新しいパスワード","repeat-password":"新しいパスワードを再入力","password-change":{"success":"パスワードが正常に変更されました"},"password-length-validation":"パスワードは 8 ～ 30 文字である必要があります","password-mismatch-validation":"2 つの異なるパスワードを入力しました","password-old-passowrd-match-validation":"新しいパスワードは以前のパスワードとは異なる必要があります","email-exists-error":"このメールはすでに Radioline アカウントで使用されています"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"プレイリストにエクスポート","autoplay":"自動再生","settings":{"link-account":"アカウントにリンクする","unlink-account":"アカウントのリンクを解除する","no-ads":"広告の表示なし","no-ads-desc":"Radiolineによる映像・音声広告の表示なし（放送局により追加された広告が表示されることはあります。）","my-app":"マイ・アプリ","application-language":"言語を選択","select-application-language":"言語を選択","homepage-country":"ホーム画面の国","install-app":"Radiolineをダウンロードする","features":"機能","add-device":"デバイスを追加する","app-version":"アプリ版","export-to-playlist-desc":"ラジオで生放送されている音楽をワンタッチでプレイリストに追加","connected-to":"にリンクする","settings":"設定","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"マイアカウント"},"continuity":{"popup-close-btn":"閉じる","popup-play-btn":"再生","popup-header":"以前に聴いた曲："},"search-for-stations":"放送局やポッドキャストを検索して、ハートのアイコンをタップしてここに追加します。","search-for-a-radio-or-podcast":"ラジオまたはポッドキャストを探す","close":"閉じる","generic-error":"エラーが発生しました。","fallback":{"error":"問題が発生しました。","button":"再試行"},"export":{"select-platform":"音楽プラットフォームを選択する"},"demo-version":"Demo version","search-for-podcasts":"ポッドキャストを検索し、ダウンロードアイコンをタップして、ここにエピソードを追加します。","playback-error":"このストリームは再生できませんでした","offline":{"save-error-toast":"エピソードのダウンロードに失敗しました","remove-success-toast":"エピソードは消去されました","save-success-toast":"エピソードのダウンロード完了","save-in-progress-toast":"エピソードをダウンロードしています","download-episode":"このエピソードをダウンロードする","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"ウェブサイトを見る","radio":"ラジオ放送局","no-playlist":"この局のプレイリストにアクセスできない、またはこの局からの提供がありません。","no-program":"この局の番組にアクセスできない、またはこの番組からの提供がありません。","no-podcasts":"この局のポッドキャストにアクセスできない、またはこの局のポッドキャストが提供されていません。"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"トラックが認識されません。このラジオの歌の履歴がある場合は、それを調べるとこの歌が見つかるかもしれません。","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"トラックが認識されません。このラジオの歌の履歴がある場合は、それを調べるとこの歌が見つかるかもしれません。","qr-tutorial":{"title":"Radiolineのアカウントと音楽ストリーミングプラットフォームをリンクさせる方法：","step1":"Radiolineモバイルアプリを開くか、当社ウェブサイト（www.radioline.co）にアクセスします。","step2":"設定で\\"アカウントのリンク\\" を選択する。","step3":"ご希望の音楽配信プラットフォームを選択し、手順に従ってください。"}},"favorites":{"no-favotites":"お気に入りがまだありません"},"podcast":"ポッドキャスト","search-results":{"try-again":"再試行","no-internet":"インターネットに接続されていません","no-results":"検索結果なし"},"network":{"connection-lost":"インターネットに接続されていないようです","connection-slow":"インターネット接続が遅いようです。再生に問題が発生する可能性があります","back-online":"インターネット接続が復旧しました "},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"サポートチームへのご連絡をありがとうございます。できるだけ早く回答いたします","meta":{"description":"Radioline -  best radios and podcasts"},"http-error":"この放送局/ポッドキャストは期限切れの通信プロトコル（http）で放送しており、セキュリティ上の理由から再生しないことを希望しています。","old-website":"前のウェブサイト","accept-terms":"登録することで、サービスの利用規約とプライバシーポリシーに同意したことになります。"}');
;// CONCATENATED MODULE: ./app/locales/nb.json
var nb_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Hør • DIREKTE","seo_description_radio":"Lytt til {var1} • Direkte og gratis på Radioline | Podkast & Repriser | {var2}","seo_description_podcast":"Lytt til podkasten {var1} gratis på Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Radio direkte og gratis på Radioline","seo_description_categoryRadioPage":"{var1} • Lytt direkte og gratis til internettbasert radio (FM, AM, DAB, nettradio) på Radioline | Podkaster og Repriser","seo_title_podcast":"{var1} • {var2} Podkast","seo_title_discoverRadio":"{var1} • Internettbasert Radio direkte og gratis","seo_description_discoverRadio":"Lytt til {var1} gratis direkte radiostasjoner (FM, AM, DAB, nettradio) på Radioline","seo_title_discoverPodcast":"{var1} • Podkaster tilgjengelig gratis og sortert etter sjanger","seo_description_discoverPodcast":"Lytt til {var1} podkaster på nett gratis på Radioline","seo_title_home":"Radio, Podkast og Repriser fra hele verden gratis | Radioline","seo_description_home":"Oppdag en verden av radio og podkaster med Radioline. Lytt til dine favoritt radiokanaler (FM, AM, DAB, nettradio) og podkaster fra alle dine enheter med vår lokale, nasjonale og internasjonale kataloger.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Hjem","favorites":"Favoritter","discover":"Utforsk","offline":"Offline"}},"tabs":{"podcasts":"Podkaster","stations":"Radiostasjoner","schedule":"Programguide","all":"Alle","downloaded":"Nedlastet","unplayed":"Ulest","playlist":"Spillelisten"},"country-selector":"Velg land","hq-stations":"HQ-stasjoner","national-selection":"Nasjonalt utvalg","radioline":"Radioline","worlds-best":"Verdens beste","thematics":"Temaer","local-stations":"Lokale stasjoner","log-in":"Logg inn","log-in-with-my-mobile":"Logg inn med mobilen min","log-in-with-facebook":"Fortsett med Facebook","sign-up":"Opprett en konto","music-on-air":"Live-musikk","search":"Søk","email":"E-post","email-is-required":"E-post kreves","could-not-sign-in-please-check-your-email-and-password":"Ugyldig e-post og/eller passord","password":"Passord","password-is-required":"Password required","forgot-password":"Glemt passord?","time":{"h":"t","min":"min","s":"sek"},"navigation-map":"Nettstedskart","privacy-policy":"Personvernpolicy","privacy-settings":"Personverninnstillinger","terms-of-use":"Brukervilkår","our-solutions":"Våre løsninger","contact":"Kontakt","install-app":"Last ned Radioline","add-manage-you-station-or-podcast":"Legg til/endre stasjon eller podkast","send":"Send","field-required":"Dette feltet er obligatorisk","subject":"Emne","your-message":"Din melding","your-name":"Ditt navn","episodes":"Episoder","go-to-podcast":"Gå til podkast","mark-as-played":"Merk som lest","delete":"Slett","see-website":"Besøk webside","you-dont-have-favorites":"Du har ingen favoritter enda. Opprett en konto for å legge til favoritter, det er enkelt og raskt!","create-an-account":"Opprett en konto","you-dont-have-podcasts":"Du har ikke nedlastet podkast-episoder enda.","to-downaload-episodes":"Opprett en konto for å nedlaste podkast-episoder, det er enkelt og raskt!","premium":{"download-podcasts":"Last ned podkaster for å lytte offline","go-premium-for":"Velg Premium for {var1}","automatically-play-last-radio":"Automatisk avspilling av siste radiostasjon eller podkast ved lansering av appen","worlds-best-music-stations":"Verdens beste","local-and-worldwide":"Lokalt og globalt opprettede kataloger (161 land)","scan-qr-code":"Skann denne QR-koden","no-ads":"Ingen tilleggsannonser","no-ads-desc":"Ingen visuelle eller lydannonser tilføyd av Radioline (du kan fortsatt støte på annonser tilføyd av kringkastingsforetaket)","export-to-playlist-desc":"Legg til musikk som spilles på radioen i en spilleliste med ett trykk (Spotify, Deezer)","worlds-best":"Verdens beste","worlds-best-desc":"Vi har plukket ut de beste musikkstasjonene for deg over hele verden innen 17 musikksjangre","hq-stations-desc":"Utforsk musikkstasjoner som kringkaster med høy lydkvalitet (MP3 - 320 Kbps)","after-payment-title":"Vi behandler abonnementet ditt, vennligst vent","after-payment-support":"Abonnements behandling tar litt lenger tid enn forventet. Hvis du opplever problemer, kan du kontakte support@radioline.co","premium":"premium","video-ad-description":"Denne videoannonsen lar oss få deg til å nyte appen gratis"},"back":"Tilbake","auth":{"or":"ELLER","save-your-favorites":"Lagre dine favoritter","synchronize-your-account":"Synkroniser kontoen din på tvers av alle enhetene dine","resume-playback":"Gjenoppta avspilling","resume-podcasts":"Fortsett der du slapp i podkaster og lagre sist avspilte innhold","offline-podcasts":"Offline podkaster","download-podcasts":"Last ned podkaster for å lytte offline","reset-password":"Lag nytt passord","login-with-mobile":"Logg inn med mobilen min","step-1":"Åpne Radioline-appen på mobilen din","step-2":"I innstillingene velger du «Legg til en enhet»","step-3":"Tast inn koden som vises på skjermen","account":"Konto","export-to-playlist":"Legg til spillelisten","export-to-playlist-desc":"Legg til musikk som spilles på radioen i en spilleliste med ett trykk (Spotify, Deezer)","sign-out":"Logg ut","reset-password-error":"Vi kan ikke tilbakestille passordet. Prøv på nytt","email-error":"E-post kreves","reset-password-success":"Det nye passordet er sendt til {email}","instructions":"Veiledning","code-required":"Logging kode kreves","add-device-meta-description":"Offline access - Radioline","change-my-password":"Endre passordet mitt","current-password":"Gjeldende passord","new-password":"Nytt passord","repeat-password":"Gjenta nytt passord","password-change":{"success":"Ditt passord har blitt endret"},"password-length-validation":"Passordet ditt bør være mellom 8 og 30 tegn","password-mismatch-validation":"Du skrev inn to forskjellige passord","password-old-passowrd-match-validation":"Ditt nye passord må være forskjellig fra det forrige passordet ditt","email-exists-error":"Denne e-posten er allerede brukt med en Radioline-konto"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Legg til spillelisten","autoplay":"Automatisk avspilling","settings":{"link-account":"Koble kontoen min","unlink-account":"Frakoble kontoen min","no-ads":"Ingen tilleggsannonser","no-ads-desc":"Ingen visuelle eller lydannonser tilføyd av Radioline (du kan fortsatt støte på annonser tilføyd av kringkastingsforetaket)","my-app":"Min app","application-language":"Velg språk","select-application-language":"Velg språk","homepage-country":"Hjemmeskjerm land","install-app":"Last ned Radioline","features":"Funksjoner","add-device":"Legg til en enhet","app-version":"App versjon","export-to-playlist-desc":"Legg til musikk som spilles på radioen i en spilleliste med ett trykk","connected-to":"Koblet til","settings":"Innstillinger","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Min konto"},"continuity":{"popup-close-btn":"Lukk","popup-play-btn":"Spill av","popup-header":"Du hørte tidligere på:"},"search-for-stations":"Søk etter stasjoner eller podkaster og trykk på hjerteikonet for å legge dem til her","search-for-a-radio-or-podcast":"Søk etter en radiostasjon eller podkast","close":"Lukk","generic-error":"Det oppstod en feil","fallback":{"error":"Noe gikk galt","button":"Prøv på nytt"},"export":{"select-platform":"Velg en musikktjeneste"},"demo-version":"Demo version","search-for-podcasts":"Søk etter podkaster og trykk på nedlastingsikonet for å legge til en episode her","playback-error":"Vi kunne ikke spille denne stream","offline":{"save-error-toast":"Kunne ikke downloade episode","remove-success-toast":"Episode fjernet","save-success-toast":"Episode downloaded","save-in-progress-toast":"Downloading episode","download-episode":"Last ned denne episoden","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Besøk websiden","radio":"Radio","no-playlist":"Tilgang til playlisten på denne stasjonen er ikke mulig, eller gir ingen tilgang","no-program":"Tilgang til dette stasjonens program er ikke mulig eller gir ingen tilgang","no-podcasts":"Tilgang til podcastene på denne stasjonen er ikke mulig, eller gir ingen tilgang"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Sporet gjenkjennes ikke. Du kan finne dette sporet ved å sjekke eventuell radiosanglogg.","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Sporet gjenkjennes ikke. Du kan finne dette sporet ved å sjekke eventuell radiosanglogg.","qr-tutorial":{"title":"Hvordan kobler jeg Radioline kontoen min til en musikkstrømmetjeneste?","step1":"Åpne din Radioline mobilapp eller gå til websiden vår (www.radioline.co)","step2":"I innstillingene velger du «Koble kontoen min»","step3":"Velg den ønskede musikkstrømmetjenesten og følg veiledningen"}},"favorites":{"no-favotites":"Du har ingen favoritter enda"},"podcast":"Podkasten","search-results":{"try-again":"Prøv på nytt","no-internet":"Ingen internett-tilkobling","no-results":"Ingen søkeresultater"},"network":{"connection-lost":"Det virker som om du har mistet tilkoblingen til internett","connection-slow":"Det virker som din internett-tilkobling er treg. Det kan oppstå avspillingsproblemer","back-online":"Internett-tilkoblingen er gjenopprettet"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Takk for at du kontakter vår support, vi vil svare deg uten ugrunnet frist","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"Denne stasjonen/podkasten sender med en utdatert protokoll (http) som vi foretrekker ikke å spille av sikkerhetshensyn.","old-website":"Tidligere nettside","accept-terms":"Ved å opprette en konto aksepterer du Personvern og brukervilkårene"}');
;// CONCATENATED MODULE: ./app/locales/nl.json
var nl_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Luisteren • LIVE","seo_description_radio":"Luister naar {var1} • Live en gratis op Radioline | Podcast en herhalingen | {var2}","seo_description_podcast":"Luister gratis naar de podcast {var1} op Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Radio\'s live en gratis op Radioline","seo_description_categoryRadioPage":"{var1} • Luister live en gratis naar online radio\'s (FM, AM, DAB, webradio\'s) op Radioline | Podcasts en herhalingen","seo_title_podcast":"{var1} • {var2} Podcast","seo_title_discoverRadio":"{var1} • Online radio\'s live en gratis","seo_description_discoverRadio":"Luister naar {var1} gratis live online radiostations (FM, AM, DAB, webradio\'s) op Radioline","seo_title_discoverPodcast":"{var1} • Podcasts gratis beschikbaar en gesorteerd op thema","seo_description_discoverPodcast":"Luister gratis naar {var1} podcasts online op Radioline","seo_title_home":"Radio\'s, podcasts en herhalingen van over de hele wereld gratis | Radioline","seo_description_home":"Ontdek een wereld van radio\'s en podcasts met Radioline. Luister naar je favoriete radiostations (FM, AM, DAB, Webradio) en podcasts vanaf al je apparaten met onze lokale, nationale en internationale catalogi.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Home","favorites":"Favorieten","discover":"Ontdekken","offline":"Offline"}},"tabs":{"podcasts":"Podcasts","stations":"Radiozenders","schedule":"Programma","all":"Alle","downloaded":"Gedownload","unplayed":"Nog niet afgespeeld","playlist":"Playlist"},"country-selector":"Selecteer land","hq-stations":"HQ-Zenders","national-selection":"Nationale selectie","radioline":"Radioline","worlds-best":"Wereldtop","thematics":"Thema’s","local-stations":"Lokale Zenders","log-in":"Inloggen","log-in-with-my-mobile":"Inloggen met mijn mobiele telefoon","log-in-with-facebook":"Doorgaan met Facebook","sign-up":"Aanmelden","music-on-air":"Luister live","search":"Zoeken","email":"E-mail","password":"Wachtwoord","password-is-required":"Password required","email-is-required":"E-mail vereist","could-not-sign-in-please-check-your-email-and-password":"Ongeldig e-mailadres en/of wachtwoord","forgot-password":"Wachtwoord vergeten?","time":{"h":"uur","min":"min","s":"sec"},"navigation-map":"Plattegrond","privacy-policy":"Privacybeleid","privacy-settings":"Privacy-instellingen","terms-of-use":"Gebruiksvoorwaarden","our-solutions":"Onze Oplossingen","contact":"Contacteren","install-app":"Radioline downloaden","add-manage-you-station-or-podcast":"Jouw radiozender of podcast toevoegen/beheren","send":"Verzenden","field-required":"Dit veld is vereist","subject":"Onderwerp","your-message":"Uw bericht","your-name":"Uw naam","episodes":"Afleveringen","go-to-podcast":"Ga naar Podcast","mark-as-played":"Markeer als afgespeeld","delete":"Verwijderen","see-website":"Naar website","you-dont-have-favorites":"Je hebt nog geen favorieten. Maak een account aan om je favorieten op te slaan, dat is makkelijk en snel!","create-an-account":"Een account aanmaken","you-dont-have-podcasts":"Je hebt nog geen podcastafleveringen gedownload.","to-downaload-episodes":"Maak een account aan om podcastafleveringen te downloaden, dat is makkelijk & snel!","premium":{"download-podcasts":"Download Podcasts en beluister ze offline","go-premium-for":"Word Premium voor {var1}","automatically-play-last-radio":"Speel automatisch je laatste radiozender of podcast af bij het openen van de app","worlds-best-music-stations":"Beste Muziekzenders ter wereld","local-and-worldwide":"Lokale en wereldwijde geselecteerde catalogussen (161 landen)","scan-qr-code":"Scan deze QR-code.","no-ads":"Geen extra advertenties","no-ads-desc":"Geen visuele en audio-advertenties toegevoegd door Radioline (je kan wel advertenties tegenkomen toegevoegd door de zender)","export-to-playlist-desc":"Voeg de muziek live op de radio in één klik toe aan je afspeellijst (Spotify, Deezer)","worlds-best":"Wereldtop","worlds-best-desc":"We hebben de beste muziekzenders ter wereld voor jou geselecteerd in 17 muziekgenres","hq-stations-desc":"Ontdek radiozenders met hoge geluidskwaliteit (MP3 – 320 Kbps)","after-payment-title":"Even geduld, wij verwerken uw inschrijving.","after-payment-support":"Het verwerken van uw inschrijving duurt iets langer dan verwacht. Als u problemen ondervindt, gelieve support@radioline.co te contacteren.","premium":"premium","video-ad-description":"Met deze videoadvertentie kunnen we je gratis toegang geven tot de app"},"back":"Terug","auth":{"or":"OF","save-your-favorites":"Favorieten opslaan","synchronize-your-account":"Synchroniseer je account op al je toestellen","resume-playback":"Afspelen hervatten","resume-podcasts":"Herstart podcasts waar je gebleven bent op al je toestellen","offline-podcasts":"Offlinepodcasts","download-podcasts":"Download Podcasts en beluister ze offline","reset-password":"Wachtwoord resetten","login-with-mobile":"Inloggen met mijn mobiele telefoon","step-1":"Open de app Radioline op je mobiele telefoon","step-2":"In de instellingen, selecteer ‘Een toestel toevoegen’","step-3":"Voer de code in die op het scherm staat","account":"Account","export-to-playlist":"Exporteren naar Playlist","export-to-playlist-desc":"Voeg de muziek live op de radio in één klik toe aan je afspeellijst (Spotify, Deezer)","sign-out":"Uitloggen","reset-password-error":"We konden uw wachtwoord niet opnieuw instellen, gelieve opnieuw te proberen","email-error":"E-mail vereist","reset-password-success":"Uw nieuw wachtwoord werd verzonden naar {e-mail}","instructions":"Instructiess","code-required":"Logincode vereist","add-device-meta-description":"Offline access - Radioline","change-my-password":"Mijn wachtwoord wijzigen.","current-password":"Huidig wachtwoord.","new-password":"Nieuw wachtwoord.","repeat-password":"Nieuw wachtwoord herhalen.","password-change":{"success":"Uw wachtwoord is succesvol gewijzigd"},"password-length-validation":"Uw wachtwoord moet tussen de 8 en 30 tekens lang zijn","password-mismatch-validation":"U heeft twee verschillende wachtwoorden ingevoerd","password-old-passowrd-match-validation":"Uw nieuwe wachtwoord kan niet hetzelfde zijn als uw oude wachtwoord","email-exists-error":"Dit e-mailadres wordt al gebruikt met een Radioline-account"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Exporteren naar Playlist","autoplay":"Autoplay","settings":{"link-account":"Mijn account linken","unlink-account":"Mijn account loskoppelen","no-ads":"Geen extra advertenties","no-ads-desc":"Geen visuele en audio-advertenties toegevoegd door Radioline (je kan wel advertenties tegenkomen toegevoegd door de zender)","my-app":"Mijn app","application-language":"Elegir idioma","select-application-language":"Elegir idioma","homepage-country":"Startscherm land","install-app":"Radioline downloaden","features":"Functies","add-device":"Een toestel toevoegen","app-version":"App-versie","export-to-playlist-desc":"Voeg de muziek live op de radio in één klik toe aan je afspeellijst","connected-to":"Gekoppeld aan","settings":"Instellingen","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Mijn account"},"continuity":{"popup-close-btn":"Sluiten","popup-play-btn":"Afspelen","popup-header":"U hebt eerder geluisterd naar:"},"search-for-stations":"Zoek radiozenders of podcasts en klik op het harticoontje om ze hier toe te voegen","search-for-a-radio-or-podcast":"Een radio of podcast zoeken","close":"Sluiten","generic-error":"Er deed zich een fout voor.","fallback":{"error":"Er is iets misgelopen","button":"Probeer opnieuw"},"export":{"select-platform":"Selecteer een muziekplatform"},"demo-version":"Demo version","search-for-podcasts":"Zoek podcasts en klik op het downloadicoontje om hier een aflevering toe te voegen","playback-error":"We konden deze stream niet afspelen.","offline":{"save-error-toast":"Downloaden van deze aflevering mislukt.","remove-success-toast":"Aflevering verwijderd.","save-success-toast":"Aflevering gedownload.","save-in-progress-toast":"Aflevering aan het downloaden.","download-episode":"Deze aflevering downloaden","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Website bezoeken","radio":"Radio","no-playlist":"Toegang tot de playlist van deze radiozender is niet beschikbaar of er worden er geen aangeboden","no-program":"Toegang tot het programma van deze radiozender is niet beschikbaar of er worden er geen aangeboden","no-podcasts":"Toegang tot de podcasts van deze radiozender is niet beschikbaar of er worden er geen aangeboden"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Nummer niet herkend. Je kan dit nummer vinden in de nummergeschiedenis van deze radio als er één voorhanden is.","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Nummer niet herkend. Je kan dit nummer vinden in de nummergeschiedenis van deze radio als er één voorhanden is.","qr-tutorial":{"title":"Hoe je Radioline-account linken aan een muziekstreamingplatform:","step1":"Open je Radioline mobiele app of ga naar onze website (www.radioline.co)","step2":"Selecteer ‘Mijn account linken’ in de instellingen","step3":"Selecteer het muziekstreamingplatform van jouw keuze en volg de instructies"}},"favorites":{"no-favotites":"Je hebt nog geen favorieten"},"podcast":"Podcast","search-results":{"try-again":"Probeer opnieuw","no-internet":"Geen internetverbinding","no-results":"Geen zoekresultaten"},"network":{"connection-lost":"U lijkt niet meer verbonden te zijn met het internet","connection-slow":"U lijkt een trage internetverbinding te hebben. Het kan dat u afspeelproblemen ondervindt","back-online":"Uw internetverbinding is hersteld"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Bedankt dat u onze support heeft gecontacteerd, wij sturen u zo snel mogelijk een antwoord","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"Deze radiozender/podcast zendt uit met een verouderd protocol (http) dat we liever niet afspelen om veiligheidsredenen.","old-website":"Voormalige website","accept-terms":"Door je aan te melden aanvaard je de Algemene Voorwaarden en het Privacybeleid"}');
;// CONCATENATED MODULE: ./app/locales/pl.json
var pl_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Listen • LIVE","seo_description_radio":"Listen to {var1} • Live and free on Radioline | Podcast & Replays | {var2}","seo_title_podcast":"{var1} • {var2} Podcast","seo_description_podcast":"Listen to the podcast {var1} free on Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Radios live and free on Radioline","seo_description_categoryRadioPage":"{var1} • Listen live and free to online radios (FM, AM, DAB, Webradios) on Radioline | Podcasts & Replays","seo_title_discoverRadio":"{var1} • Online Radios live and free","seo_description_discoverRadio":"Listen to {var1} free live online radio stations (FM, AM, DAB, Webradios) on Radioline","seo_title_discoverPodcast":"{var1} • Podcasts available for free and sorted by theme","seo_description_discoverPodcast":"Listen to {var1} podcasts online for free on Radioline","seo_title_home":"Radios, Podcasts and Replays from around the world for free | Radioline","seo_description_home":"Discover a world of radios and podcasts with Radioline. Listen to your favorite radio stations (FM, AM, DAB, Webradio) and podcasts from all your devices with our local, national and international catalogs.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Główna","favorites":"Ulubione","discover":"Odkrywaj","offline":"Offline"}},"tabs":{"podcasts":"Podcasty","stations":"Radiostacje","schedule":"Harmonogram","all":"Wszystkie","downloaded":"Pobrane","unplayed":"Nieodtworzone","playlist":"Playlisty"},"country-selector":"Wybierz kraj","hq-stations":"Radio w wysokiej jakości","national-selection":"Wybór krajowy","radioline":"Radioline","worlds-best":"Najlepsze na świecie","thematics":"Tematy","local-stations":"Stacje lokalne","log-in":"Zaloguj się","log-in-with-my-mobile":"Zaloguj się na telefonie","log-in-with-facebook":"Kontynuuj przy użyciu Facebooka","sign-up":"Zarejestruj się","music-on-air":"Aktualnie nadawane","search":"Szukaj","email":"Email","email-is-required":"Email jest wymagany","could-not-sign-in-please-check-your-email-and-password":"Email i/lub hasło jest niepoprawne","password":"Hasło","password-is-required":"Password jest wymagane","forgot-password":"Zapomniałeś hasła?","time":{"h":"godz","min":"min","s":"sek"},"navigation-map":"Mapa strony","privacy-policy":"Polityka prywatności","privacy-settings":"Ustawienia prywatności","terms-of-use":"Zasady użytkowania","our-solutions":"Nasze rozwiązania","contact":"Kontakt","install-app":"Pobierz Radioline","add-manage-you-station-or-podcast":"Dodaj/zarządzaj swoją stacją lub podcastem","send":"Wyślij","field-required":"To pole jest wymagane","subject":"Temat","your-message":"Twoja wiadomość","your-name":"Twoje imię i nazwisko","episodes":"Odcinki","go-to-podcast":"Idź do Podcastów","mark-as-played":"Oznacz jako odsłuchane","delete":"Usuń","see-website":"Odwiedź stronę www","you-dont-have-favorites":"Obecnie nie masz żadnych ulubionych. Żeby zachować ulubione załóż konto. To bardzo proste i łatwe!","create-an-account":"Stwórz konto","you-dont-have-podcasts":"Obecnie nie masz żadnych pobranych podcastów. Żeby je pobrać musisz założyć konto. To bardzo proste i łatwe!","to-downaload-episodes":"Utwórz konto, żeby pobrać odcinki podcastu, to łatwe i szybkie!","premium":{"download-podcasts":"Pobierz podcasty i słuchaj ich offline","go-premium-for":"Kup Premium za {var1}","automatically-play-last-radio":"Automatycznie włącz ostanio słuchaną stację lub podcast","worlds-best-music-stations":"Najlepsze na Świecie","local-and-worldwide":"Lokalne i światowe wybrane katalogi (161 krajów)","scan-qr-code":"Zeskanuj ten kod QR","no-ads":"Brak dodatkowych reklam","no-ads-desc":"Bez graficznych i audio reklam dodanych przez Radioline (możesz wciąż spotkać reklamy dodane przez nadawcę)","export-to-playlist-desc":"Dodaj muzykę, którą słyszysz jednym kliknięciem do playlisty (Spotify, Deezer)","worlds-best":"Najlepsze na Świecie","worlds-best-desc":"Wybraliśmy dla Ciebie najlepsze stacje muzyczne w 17 kategoriach","hq-stations-desc":"Odkryj muzyczne radiostacje w wysokiej jakości dzięku (MP3-320kbps)","after-payment-title":"Rozatrujemy Twόj wniosek o subskrypcję, proszę czekać","after-payment-support":"Rozpatrzenie Twojego wniosku o subskrypcję zajmuje więcej czasu niż zakładano. Jeżeli napotkałeś na problem, napisz na adres support@radioline.co","premium":"premium","video-ad-description":"Ta reklama wideo pozwala nam zapewnić bezpłatny dostęp do aplikacji"},"back":"Cofnij się","auth":{"or":"ALBO","save-your-favorites":"Zachowaj swoje ulubione","synchronize-your-account":"Zsynchronizuj swoje konto z Twoimi urządzeniami","resume-playback":"Wznów odtwarzanie","resume-podcasts":"Wznów podcasty od momentu, w którym przestałeś je słuchać","offline-podcasts":"Podcasty offline","download-podcasts":"Pobierz podcasty i słuchaj ich offline","reset-password":"Zresetuj hasło","login-with-mobile":"Zaloguj się na telefonie","step-1":"Otwórz aplikację Radioline na telefonie","step-2":"Przejdź do ustawień i wybierz \\"Dodaj urządzenie\\"","step-3":"Wpisz kod wyświetlony na ekranie","account":"Konto","export-to-playlist":"Wyeksportuj do Playlisty","export-to-playlist-desc":"Dodaj muzykę, którą słyszysz jednym kliknięciem do playlisty (Spotify, Deezer)","sign-out":"Wyloguj się","reset-password-error":"Zresetowanie Twojego hasła nie powiodło się, sprόbuj ponownie","email-error":"Adres e-mail jest wymagany","reset-password-success":"Twoje nowe hasło zostało wysłane na {email}","instructions":"Instrukcje","code-required":"Kod logowania jest wymagany","add-device-meta-description":"Offline access - Radioline","change-my-password":"Zmień hasło","current-password":"Aktualne hasło","new-password":"Nowe hasło","repeat-password":"Powtόrz nowe hasło","password-change":{"success":"Twoje hasło zostało zmienione"},"password-length-validation":"Twoje hasło powinno mieć od 8 do 30 znaków","password-mismatch-validation":"Wpisałeś dwa różne hasła","password-old-passowrd-match-validation":"Twoje nowe hasło musi różnić się od poprzedniego hasła","email-exists-error":"Ten adres e-mail jest już używany z kontem Radioline"},"delete-account":{"button":"Usuń swoje konto","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Wyeksportuj do Playlisty","autoplay":"Automatyczne odtwarzanie","settings":{"link-account":"Połącz moje konta","unlink-account":"Rozłącz moje konta","no-ads":"Brak dodatkowych reklam","no-ads-desc":"Bez graficznych i audio reklam dodanych przez Radioline (możesz wciąż spotkać reklamy dodane przez nadawcę)","my-app":"Moja aplikacja","application-language":"Język aplikacji","select-application-language":"Wybierz język","homepage-country":"Kraj na stronie głównej","install-app":"Pobierz Radioline","features":"Funkcje","add-device":"Dodaj urządzenie","app-version":"Wersja aplikacji","export-to-playlist-desc":"Dodaj muzykę, którą słyszysz jednym kliknięciem do playlisty","connected-to":"Połącz z","settings":"Ustawienia","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Moje konto"},"continuity":{"popup-close-btn":"Zamknij","popup-play-btn":"Odtwórz","popup-header":"Ostatnio słuchane:"},"search-for-stations":"Szukaj stacji radiowych i kliknij w ikonę serca, żeby dodać stację tu","search-for-a-radio-or-podcast":"Szukaj stacji radiowych lub podcastów","close":"Zamknij","generic-error":"Wystąpił błąd","fallback":{"error":"Wystąpił błąd","button":"Sprόbuj ponownie"},"export":{"select-platform":"Wybierz platformę muzyczną"},"demo-version":"Demo version","search-for-podcasts":"Szukaj podcastów i kliknij w ikonę pobierania, żeby dodać odcinek tu","playback-error":"Odtworzenie strumienia nie powiodło się","offline":{"save-error-toast":"Nie udało się pobrać odcinka","remove-success-toast":"Odcinek usunięty","save-success-toast":"Odcinek pobrany","save-in-progress-toast":"Trwa pobieranie odcinka","download-episode":"Pobierz ten odcinek","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Odwiedź stronę internetową","radio":"Radiostacja","no-playlist":"Dostęp do playlisty tej radiostacji nie jest możliwy lub stacja nie ma playlisty w ofercie","no-program":"Dostęp do ramόwki tej radiostacji nie jest możliwy lub stacja nie proponuje dostępu do ramόwki","no-podcasts":"Dostęp do podcastόw tej stacji radiowej nie jest możliwy lub stacja nie ma podcastόw w ofercie"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Utwór nie rozpoznany. Możesz znaleźć ten utwór w historii utworów radia","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Utwór nie rozpoznany. Możesz znaleźć ten utwór w historii utworów radia","qr-tutorial":{"title":"Jak połączyć Twoje konto Radioline z platformami streamingowymi","step1":"Otwórz aplikację mobilną albo otwórz naszą stronę (www.radioline.co)","step2":"W ustawieniach wybierz \\"Połącz moje konta\\"","step3":"Wybierz platformę i podążaj za instrukcjami"}},"favorites":{"no-favotites":"Obecnie nie masz żadnych ulubionych"},"podcast":"Podcast","search-results":{"try-again":"Sprόbuj ponownie","no-internet":"Brak połączenia internetowego","no-results":"Brak wynikόw wyszukiwania"},"network":{"connection-lost":"Wygląda na to, że utraciłeś/-aś połączenie z Internetem","connection-slow":"Wygląda na to, że Twoje połączenie z Internetem działa wolno. Możesz mieć problem z odtwarzaniem","back-online":"Połączenie z Internetem zostało przywrόcone"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Dziękujemy za kontakt z Działem Wsparcia Klientόw. Odpowiemy możliwie jak najszybciej.","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"To radio/ten podcast stream działa na niezabezpieczonym kanale, dlatego nie możemy go odtwarzać ze względów bezpieczeństwa","old-website":"Poprzednia strona internetowa","accept-terms":"Rejestrując się akceptujesz nasz regulamin i zasady prywatności"}');
;// CONCATENATED MODULE: ./app/locales/pt-BR.json
var pt_BR_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Ouvir • AO VIVO","seo_description_radio":"Ouça {var1} • Ao vivo e de graça no Radioline | Podcasts e Reprises | {var2}","seo_description_podcast":"Ouça o podcast {var1} de graça no Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Rádios ao vivo e de graça no Radioline","seo_description_categoryRadioPage":"{var1} • Ouça rádios on-line ao vivo e de graça (FM, AM, DAB, web rádios) no Radioline | Podcasts e Reprises","seo_title_podcast":"{var1} • {var2} Podcast","seo_title_discoverRadio":"{var1} • Rádios on-line ao vivo e de graça","seo_description_discoverRadio":"Ouça estações de rádio (FM, AM, DAB, web rádios) on-line ao vivo e de graça de {var1} no Radioline","seo_title_discoverPodcast":"{var1} • Podcasts disponíveis de graça e organizados por tema","seo_description_discoverPodcast":"Ouça podcasts de {var1} on-line de graça no Radioline","seo_title_home":"Rádios, Podcasts e Reprises do mundo todo de graça | Radioline","seo_description_home":"Descubra um mundo de rádios e podcasts com o Radioline. Ouça suas estações de rádio favoritas (FM, AM, DAB, web rádio) e podcasts em todos os seus aparelhos com nossos catálogos locais, nacionais e internacionais.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Início","favorites":"Favoritos","discover":"Descobrir","offline":"Offline"}},"tabs":{"podcasts":"Podcasts","stations":"Rádios","schedule":"Calendário","all":"Tudo","downloaded":"Descarregado","unplayed":"Não reproduzido","playlist":"Playlist"},"country-selector":"Selecione o país","hq-stations":"Rádios HQ","national-selection":"Seleção nacional","radioline":"Radioline","worlds-best":"O Melhor do Mundo","thematics":"Temáticas","local-stations":"Estaçõoes locais","log-in":"Iniciar sessão","log-in-with-my-mobile":"Faça login com o seu celular","log-in-with-facebook":"Continuar com o Facebook","sign-up":"Criar uma conta","music-on-air":"Música ao vivo","search":"Pesquisa","email":"E-mail","email-is-required":"É necessário o e-mail","could-not-sign-in-please-check-your-email-and-password":"Endereço e-mail e/ou senha inválidos","password":"Senha","password-is-required":"Senha requerida","forgot-password":"Esqueceu sua senha?","time":{"h":"h","min":"min","s":"s"},"navigation-map":"Mapa do site","privacy-policy":"Política de Privacidade","privacy-settings":"Definições de Privacidade","terms-of-use":"Condições de Utilização","our-solutions":"Nossas soluções","contact":"Contactos","install-app":"Descarregar Radioline","add-manage-you-station-or-podcast":"Adicionar/Gerir sua estação ou podcast","send":"Enviar","field-required":"Campo de preenchimento obrigatório","subject":"Assunto","your-message":"Sua mensagem","your-name":"Seu nome","episodes":"Episódios","go-to-podcast":"Ir para o Podcast","mark-as-played":"Marcado como já ouvido","delete":"Excluir","see-website":"Ver website","you-dont-have-favorites":"Ainda não tem favoritos. Para salvar os seus favoritos, crie uma conta – é rápido e fácil!","create-an-account":"Criar uma conta","you-dont-have-podcasts":"Ainda não baixou nenhum episódio de podcast.","to-downaload-episodes":"Para salvar episódios de podcast, crie uma conta – é rápido e fácil!","premium":{"download-podcasts":"Baixar podcasts e ouvi-los offline","go-premium-for":"Tornar-se Premium por {var1}","automatically-play-last-radio":"Reproduz automaticamente a última estação de rádio ou podcast ouvido quando a aplicação é iniciada","worlds-best-music-stations":"O Melhor do Mundo","local-and-worldwide":"Catálogos selecionados, locais e mundiais (161 países)","scan-qr-code":"Leia este código QR","no-ads":"Sem publicidade","no-ads-desc":"Sem vídeos nem áudios publicitários inseridos pela Radioline (poderá ainda deparar com anúncios inseridos pela emissora)","export-to-playlist-desc":"Adicione a música emitida na rádio à sua playlist com um toque (Spotify, Deezer)","worlds-best":"O Melhor do Mundo","worlds-best-desc":"Selecionamos para você as melhores rádios do mundo em 17 géneros musicais","hq-stations-desc":"Descubra rádios com alta qualidade de áudio (MP3 – 320 Kbps)","after-payment-title":"Queira aguardar enquanto processamos sua subscrição","after-payment-support":"O processamento da subscrição demora um pouco mais que o previsto. Em caso de dificuldade, contate support@radioline.co","premium":"premium","video-ad-description":"Este anúncio em vídeo nos permite dar a você acesso gratuito ao aplicativo"},"back":"Voltar","auth":{"or":"OU","save-your-favorites":"Salvar seus favoritos","synchronize-your-account":"Sincronize sua conta em todos os seus dispositivos","resume-playback":"Reproduzir","resume-podcasts":"Reinicie os podcasts no ponto onde ficou e guarde o último conteúdo que reproduziu","offline-podcasts":"Podcasts offlline","download-podcasts":"Baixar podcasts e ouvi-los offline","reset-password":"Redefinir senha","login-with-mobile":"Faça login com o seu celular","step-1":"Abra a aplicação Radioline no seu celular","step-2":"Nas Definições, selecione \\"Adicionar um dispositivo\\".","step-3":"Digite o código apresentado na tela","account":"Conta","export-to-playlist":"Adicionar à Playlist","export-to-playlist-desc":"Adicione a música emitida na rádio à sua playlist com um toque (Spotify, Deezer)","sign-out":"Fechar sessão","reset-password-error":"Não foi possível repor a sua senha, tente de novo","email-error":"É necessário o e-mail","reset-password-success":"A sua nova senha foi enviada para {e-mail}","instructions":"Instruções","code-required":"É necessário o código de login","add-device-meta-description":"Offline access - Radioline","change-my-password":"Alterar a minha senha","current-password":"Senha atual","new-password":"Nova senha","repeat-password":"Repita a nova senha","password-change":{"success":"Sua senha foi alterada com sucesso"},"password-length-validation":"Sua senha deve ter entre 8 e 30 caracteres","password-mismatch-validation":"Você digitou duas senhas diferentes","password-old-passowrd-match-validation":"Sua nova senha deve ser diferente da senha anterior","email-exists-error":"Este e-mail já é usado com uma conta Radioline"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Adicionar à Playlist","autoplay":"Reprodução automática","settings":{"link-account":"Conectar minha conta","unlink-account":"Desconectar minha conta","no-ads":"Sem publicidade","no-ads-desc":"Sem vídeos nem áudios publicitários inseridos pela Radioline (poderá ainda deparar com anúncios inseridos pela emissora)","my-app":"Meu aplicativo","application-language":"Selecionar idioma","select-application-language":"Selecionar idioma","homepage-country":"País do Ecrã inicial","install-app":"Descarregar Radioline","features":"Funcionalidades","add-device":"Adicionar um dispositivo","app-version":"Versão do aplicativo","export-to-playlist-desc":"Adicione a música emitida na rádio à sua playlist com um toque","connected-to":"Ligado ao","settings":"Parâmetros","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Minha conta"},"continuity":{"popup-close-btn":"Fechar","popup-play-btn":"Reproduzir","popup-header":"Antes, você ouviu:"},"search-for-stations":"Busque estações ou podcasts e prima o ícone ‘coração’ para adicioná-los aqui","search-for-a-radio-or-podcast":"Buscar uma rádio ou um podcast","close":"Fechar","generic-error":"Ocorreu um erro","fallback":{"error":"Ocorreu um problema","button":"Tente de novo"},"export":{"select-platform":"Selecione uma plataforma de música"},"demo-version":"Demo version","search-for-podcasts":"Busque podcasts e prima o ícone de descarga para adicionar um episódio aqui","playback-error":"Não foi possível reproduzir esta emissão","offline":{"save-error-toast":"FFalha ao baixar o episódio","remove-success-toast":"Episódio removido","save-success-toast":"Episódio baixado","save-in-progress-toast":"A baixar episódio","download-episode":"Descarregar este episódio","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Visitar website","radio":"Rádio","no-playlist":"O acesso à lista de reprodução desta estação não está disponível ou não existe","no-program":"O acesso à programação desta estação não está disponível ou não existe","no-podcasts":"O acesso aos podcasts desta estação não está disponível ou não existe"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Faixa não reconhecida. Pode encontrar essa faixa pesquisando o histórico de canções dessa rádio, se existir","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Faixa não reconhecida. Pode encontrar essa faixa pesquisando o histórico de canções dessa rádio, se existir","qr-tutorial":{"title":"Como conectar a sua conta Radioline a uma plataforma de streaming de música:","step1":"Abra a sua aplicação móvel Radioline ou aceda ao nosso website (www.radioline.co)","step2":"Em Definições, seleccione “Conectar a minha conta”","step3":"Seleccione a plataforma de streaming de música pretendida e siga as instruções"}},"favorites":{"no-favotites":"Ainda não tem favoritos"},"podcast":"Podcast","search-results":{"try-again":"Tente de novo","no-internet":"Sem conexão à internet","no-results":"Sem resultados de pesquisa"},"network":{"connection-lost":"Parece ter perdido a conexão à internet","connection-slow":"A sua conexão à internet parece estar lenta. Poderão ocorrer problemas de reprodução","back-online":"A sua conexão à internet foi reposta"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Obrigado por contatar o serviço de apoio, iremos responder em breve","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"Esta estação/Este podcast emite com um protocolo (http) desatualizado, que preferimos não utilizar por razões de segurança.","old-website":"Site anterior","accept-terms":"Ao criar uma conta, você aceita as Condições Gerais de Utilização"}');
;// CONCATENATED MODULE: ./app/locales/pt.json
var pt_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Ouvir • EM DIRETO","seo_description_radio":"Ouça {var1} • Em direto e sem qualquer custo na Radioline | Podcast e Repetições | {var2}","seo_description_podcast":"Ouça o podcast {var1} gratuitamente na Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Rádios em direto e sem qualquer custo, na Radioline","seo_description_categoryRadioPage":"{var1} • Ouça rádios online em direto e sem qualquer custo (FM, AM, DAB, rádios Web) na Radioline | Podcasts e Repetições","seo_title_podcast":"{var1} • {var2} Podcast","seo_title_discoverRadio":"{var1} • Rádios online em direto e sem qualquer custo","seo_description_discoverRadio":"Ouça {var1} estações de rádio online em direto e sem qualquer custo (FM, AM, DAB, rádios Web) na Radioline","seo_title_discoverPodcast":"{var1} • Podcasts disponíveis gratuitamente e ordenados por tema","seo_description_discoverPodcast":"Ouça {var1} podcasts online gratuitamente, na Radioline","seo_title_home":"Rádios, Podcasts e Repetições de todo o mundo, sem qualquer custo | Radioline","seo_description_home":"Descubra um mundo de rádios e podcasts, com a Radioline. Ouça as suas estações de rádio favoritas (FM, AM, DAB, rádio Web) e os seus podcasts preferidos em todos os seus dispositivos, com os nossos catálogos locais, nacionais e internacionais.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Início","favorites":"Favoritos","discover":"Descubra","offline":"Offline"}},"tabs":{"podcasts":"Podcasts","stations":"Estações de rádio","schedule":"Calendário","all":"Tudo","downloaded":"Descarregado","unplayed":"Não reproduzido","playlist":"Playlist"},"country-selector":"Seleccione o país","hq-stations":"Estações HQ","national-selection":"Selecção nacional","radioline":"Radioline","worlds-best":"O Melhor do Mundo","thematics":"Temáticas","local-stations":"Estações Locais","log-in":"Iniciar sessão","log-in-with-my-mobile":"Ligar com o meu telemóvel","log-in-with-facebook":"Continuar com o Facebook","sign-up":"Criar uma conta","music-on-air":"Música em directo","search":"Pesquisa","email":"E-mail","email-is-required":"É necessário o e-mail","could-not-sign-in-please-check-your-email-and-password":"Endereço de e-mail e/ou palavra-passe inválidos","password":"Palavra-passe","forgot-password":"Esqueceu-se da sua palavra-passe?","time":{"h":"h","min":"min","s":"s"},"navigation-map":"Mapa do site","privacy-policy":"Política de Privacidade","privacy-settings":"Definições de Privacidade","terms-of-use":"Condições de Utilização","our-solutions":"As nossas soluções","contact":"Contactos","install-app":"Descarregar Radioline","add-manage-you-station-or-podcast":"Adicionar/Gerir a sua estação ou podcast","send":"Enviar","field-required":"Campo de preenchimento obrigatório","subject":"Assunto","your-message":"A sua mensagem","your-name":"O seu nome","episodes":"Episódios","go-to-podcast":"Ir para o Podcast","mark-as-played":"Marcado como já escutado","delete":"Eliminar","see-website":"Ver website","you-dont-have-favorites":"Ainda não tem favoritos. Para guardar os seus favoritos, crie uma conta – é rápido e fácil!","create-an-account":"Criar uma conta","you-dont-have-podcasts":"Ainda não descarregou nenhum episódio de podcast.","to-downaload-episodes":"Para guardar episódios de podcast, crie uma conta – é rápido e fácil!","premium":{"download-podcasts":"Descarregar podcasts e ouvi-los offline","go-premium-for":"Tornar-se Premium por {var1}","automatically-play-last-radio":"Reproduz automaticamente a última estação de rádio ou podcast ouvida quando a aplicação é iniciada","worlds-best-music-stations":"O Melhor do Mundo","local-and-worldwide":"Catálogos seleccionados, locais e mundiais (161 países)","scan-qr-code":"Leia este código QR","no-ads":"Nenhum anúncio adicionadoe","no-ads-desc":"Sem vídeos nem áudios publicitários inseridos pela Radioline (poderá ainda deparar com anúncios inseridos pela emissora)","export-to-playlist-desc":"Adicione a música emitida na rádio à sua playlist com um toque (Spotify, Deezer)","worlds-best":"O Melhor do Mundo","worlds-best-desc":"Seleccionámos para si as melhores estações de rádio do mundo, divididas em 17 géneros musicais","hq-stations-desc":"Descubra estações de rádio a emitir com alta qualidade de áudio (MP3 – 320 Kbps)","after-payment-title":"Queira aguardar enquanto processamos a sua subscrição","after-payment-support":"O processamento da subscrição demora um pouco mais do que o previsto. Em caso de dificuldade, contacte support@radioline.co","premium":"premium","video-ad-description":"Este anúncio em vídeo permite-nos oferecer-lhe acesso gratuito à aplicação"},"back":"Voltar","auth":{"or":"OU","save-your-favorites":"Guarde os seus favoritos","synchronize-your-account":"Sincronize a sua conta em todos os seus dispositivos","resume-playback":"Retomar a reprodução","resume-podcasts":"Reinicie os podcasts no ponto onde ficou e guarde o último conteúdo que reproduziu","offline-podcasts":"Podcasts offlline","download-podcasts":"Descarregar podcasts e ouvi-los offline","reset-password":"Redefinir palavra-passe","login-with-mobile":"Ligar com o meu telemóvel","step-1":"Abra a aplicação Radioline no seu telemóvel","step-2":"Nas Definições, seleccione \\"Adicionar um dispositivo\\".","step-3":"Introduza o código apresentado no ecrã","account":"Conta","export-to-playlist":"Adicionar à Playlist","export-to-playlist-desc":"Adicione a música emitida na rádio à sua playlist com um toque (Spotify, Deezer)","sign-out":"Terminar sessão","reset-password-error":"Não foi possível repor a sua palavra-passe, tente novamente","email-error":"É necessário o e-mail","reset-password-success":"A sua nova palavra-passe foi enviada para {e-mail}","instructions":"Instruções","code-required":"É necessário o código de início de sessão","add-device-meta-description":"Offline access - Radioline","change-my-password":"Alterar a minha palavra-passe","current-password":"Palavra-passe actual","new-password":"Nova palavra-passe","repeat-password":"Repita a nova palavra-passe","password-change":{"success":"Sua palavra-passe foi alterada com sucesso"},"password-length-validation":"Sua palavra-passe deve ter entre 8 e 30 caracteres","password-mismatch-validation":"Você digitou duas senhas diferentes","password-old-passowrd-match-validation":"Sua nova senha deve ser diferente da senha anterior","email-exists-error":"Este e-mail já é usado com uma conta Radioline"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Adicionar à Playlist","autoplay":"Reprodução automática","settings":{"link-account":"Conectar a minha conta","unlink-account":"Desconectar a minha conta","no-ads":"Nenhum anúncio adicionadoe","no-ads-desc":"Sem vídeos nem áudios publicitários inseridos pela Radioline (poderá ainda deparar com anúncios inseridos pela emissora)","my-app":"A minha Aplicação","application-language":"Seleccionar idioma","select-application-language":"Seleccionar idioma","homepage-country":"País do Ecrã inicial","install-app":"Descarregar Radioline","features":"Funcionalidades","add-device":"Adicionar um dispositivo","app-version":"Versão da aplicação","export-to-playlist-desc":"Adicione a música emitida na rádio à sua playlist com um toque","connected-to":"Ligado ao","settings":"Definições","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Minha conta"},"continuity":{"popup-close-btn":"Fechar","popup-play-btn":"Reproduzir","popup-header":"Anteriormente, ouviu:"},"search-for-stations":"Pesquise por estações ou podcasts e prima o ícone ‘coração’ para os adicionar aqui","search-for-a-radio-or-podcast":"Procurar uma estação de rádio ou um podcast","close":"Fechar","an e":"Ocorreu um erro","fallback":{"error":"Ocorreu um problema","button":"Tente novamente"},"export":{"select-platform":"Seleccione uma plataforma de música"},"demo-version":"Demo version","search-for-podcasts":"Pesquise por podcasts e prima o ícone de descarga para adicionar um episódio aqui","playback-error":"Não foi possível reproduzir esta emissão","offline":{"save-error-toast":"Falha ao descarregar o episódio","remove-success-toast":"Episódio removido","save-success-toast":"Episódio descarregado","save-in-progress-toast":"A descarregar episódio","download-episode":"Descarregar este episódio","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Visitar website","radio":"Estação de rádio","no-playlist":"O acesso à lista de reprodução desta estação não está disponível ou não existe","no-program":"O acesso à programação desta estação não está disponível ou não existe","no-podcasts":"O acesso aos podcasts desta estação não está disponível ou não existe"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Faixa não reconhecida. Pode encontrar esta faixa pesquisando o histórico de canções desta rádio, se existir","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Faixa não reconhecida. Pode encontrar esta faixa pesquisando o histórico de canções desta rádio, se existir","qr-tutorial":{"title":"Como conectar a sua conta Radioline a uma plataforma de streaming de música:","step1":"Abra a sua aplicação móvel Radioline ou aceda ao nosso website (www.radioline.co)","step2":"Em Definições, seleccione “Conectar a minha conta”","step3":"Seleccione a plataforma de streaming de música pretendida e siga as instruções"}},"favorites":{"no-favotites":"Ainda não tem favoritos"},"podcast":"Podcast","search-results":{"try-again":"Tente novamente","no-internet":"Sem ligação à internet","no-results":"Sem resultados de pesquisa"},"network":{"connection-lost":"Parece ter perdido a ligação à internet","connection-slow":"A sua ligação à internet parece estar lenta. Poderão ocorrer problemas de reprodução","back-online":"A sua ligação à internet foi reposta"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Obrigado por contactar o serviço de apoio, iremos responder-lhe em breve","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"Esta estação/Este podcast emite com um protocolo (http) desactualizado, o qual preferimos não utilizar por motivos de segurança","old-website":"Former website","accept-terms":"Ao criar uma conta, está a aceitar as Condições Gerais de Utilização"}');
;// CONCATENATED MODULE: ./app/locales/ro.json
var ro_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Ascultă - LIVE","seo_description_radio":"Ascultă {var1} • Live și gratuit pe Radioline | Podcast și reluări | {var2}","seo_description_podcast":"Ascultă podcastul {var1} gratuit pe Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Posturi de radio live și gratuit pe Radioline","seo_description_categoryRadioPage":"{var1} - Ascultă live și gratuit posturi de radio online (FM, AM, DAB, Webradios) pe Radioline | Podcasturi și reluări","seo_title_podcast":"{var1} • {var2} Podcast","seo_title_discoverRadio":"{var1} • Posturi de radio online live și gratuit","seo_description_discoverRadio":"Ascultă {var1} posturi de radio online live și gratuit (FM, AM, DAB, Webradios) pe Radioline","seo_title_discoverPodcast":"{var1} - Podcasturi disponibile gratuit și ordonate pe teme","seo_description_discoverPodcast":"Ascultă gratuit {var1} podcasturi online pe Radioline","seo_title_home":"Posturi de radio, podcasturi și reluări din întreaga lume, gratuit | Radioline","seo_description_home":"Descoperă o lume a posturilor de radio și a podcasturilor cu Radioline. Ascultă posturile de radio (FM, AM, DAB, Webradio) și podcasturile preferate de pe toate dispozitivele tale cu cataloagele noastre locale, naționale și internaționale.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Pagină principală","favorites":"Favoriți","discover":"Descoperă","offline":"Off-line"}},"tabs":{"podcasts":"Podcasturi","stations":"Posturi de radio","schedule":"Program","all":"Tot","downloaded":"Descarcă","unplayed":"Neredat","playlist":"Playlist"},"country-selector":"Alege țara","hq-stations":"Posturi HQ","national-selection":"Selecție națională","radioline":"Radioline","worlds-best":"Cele mai bune din lume","thematics":"Tematici","local-stations":"Posturi locale","log-in":"Intră în cont","log-in-with-my-mobile":"Conectare de pe mobil","log-in-with-facebook":"Continuă cu Facebook","sign-up":"Creează un cont","music-on-air":"Muzică în direct","search":"Căutare","email":"E-mail","email-is-required":"Adresă de e-mail obligatorie","could-not-sign-in-please-check-your-email-and-password":"Adresă de e-mail și/sau parolă greșită","password":"Parolă","password-is-required":"Password required","forgot-password":"Ai uitat parola?","time":{"h":"ore","min":"de minute","s":"de secunde"},"navigation-map":"Harta site-ului","privacy-policy":"Politica de confidențialitate","privacy-settings":"Parametri de confidențialitate","terms-of-use":"Condiții de utilizare","our-solutions":"Soluțiile noastre","contact":"Contact","install-app":"Descarcă Radioline","add-manage-you-station-or-podcast":"Adaugă/gestionează postul tău de radio sau podcastul","send":"Trimite","field-required":"Completarea acestei rubrici este obligatorie","subject":"Subiect","your-message":"Mesajul dvs.","your-name":"Numele dvs.","episodes":"Episoade","go-to-podcast":"Selecționează Podcast","mark-as-played":"Marchează ca ascultat","delete":"Șterge","see-website":"Consultă site-ul Internet","you-dont-have-favorites":"Încă nu ai niciun favorit. Pentru a înregistra favoriți, creează un cont. Este simplu și rapid!","create-an-account":"Creează un cont","you-dont-have-podcasts":"Încă nu ai descărcat niciun episod de podcast.","to-downaload-episodes":"Pentru a descărca episoade de podcasturi, creează un cont. Este simplu și rapid!","premium":{"download-podcasts":"Descarcă podcasturi și ascultă-le offline","go-premium-for":"Devii Premium pentru {var1}","automatically-play-last-radio":"Redă automat ultimul post de radio sau ultimul podcast ascultat, la deschiderea aplicației","worlds-best-music-stations":"Cele mai bune din lume","local-and-worldwide":"Cataloage locale și mondiale organizate (161 de țări)","scan-qr-code":"Scanați acest cod QR","no-ads":"Fără publicitate adăugată","no-ads-desc":"Fără publicitate vizuală sau audio adăugată de Radioline (poți totuși să mai întâlnești publicitate difuzată de postul de radio)","export-to-playlist-desc":"Adaugă muzica live de la radio la un playlist dintr-o singură atingere (Spotify, Deezer)","worlds-best":"Cele mai bune din lume","worlds-best-desc":"Am selecționat pentru tine cele mai bune posturi de radio muzicale din lume pentru 17 genuri de muzică","hq-stations-desc":"Descoperă posturile de radio muzicale cu sunet de înaltă calitate (MP3 - 320 Kbps)","after-payment-title":"Procesăm abonamentul dvs., vă rugăm să așteptați","after-payment-support":"Procesarea abonamentului dvs. durează mai mult decât prevăzut. Dacă întâmpinați vreo problemă, vă rugăm să ne contactați la adresa support@radioline.co","premium":"premium","video-ad-description":"Acest anunț video ne permite să vă facem să vă bucurați de aplicație gratuit"},"back":"Înapoi","auth":{"or":"SAU","save-your-favorites":"Înregistrează favoriții","synchronize-your-account":"Sincronizează-ți contul pe toate dispozitivele","resume-playback":"Reia ultima redare","resume-podcasts":"Continuă redarea podcastului de unde l-ai lăsat și înregistrează ultimul conținut ascultat","offline-podcasts":"Podcasturi off-line","download-podcasts":"Descarcă podcasturi și ascultă-le offline","reset-password":"Resetează parola","login-with-mobile":"Conectare de pe mobil","step-1":"Deschide aplicația Radioline pe mobilul tău","step-2":"În Parametri, selecționează „Adaugă un dispozitiv”","step-3":"Introdu codul afișat pe ecran","account":"Cont","export-to-playlist":"Adaugă la Playlist","export-to-playlist-desc":"Adaugă muzica live de la radio la un playlist dintr-o singură atingere (Spotify, Deezer)","sign-out":"Deconectare","reset-password-error":"Nu s-a putut reseta parola dvs., vă rugăm să reîncercați","email-error":"Adresă de e-mail obligatorie","reset-password-success":"Noua parolă v-a fost trimisă pe adresa {email}","instructions":"Instrucțiuni","code-required":"Codul de conectare este obligatoriu","add-device-meta-description":"Offline access - Radioline","change-my-password":"Schimbă parola","current-password":"Parola actuală","new-password":"Noua parolă","repeat-password":"Repetați noua parolă","password-change":{"success":"Parola ta a fost schimbată cu succes"},"password-length-validation":"Parola dvs. trebuie să aibă între 8 și 30 de caractere","password-mismatch-validation":"Ai introdus două parole diferite","password-old-passowrd-match-validation":"Noua ta parolă trebuie să fie diferită de parola anterioară","email-exists-error":"Acest e-mail este deja folosit cu un cont Radioline"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Adaugă la Playlist","autoplay":"Redare automată","settings":{"link-account":"Conectează-mi contul","unlink-account":"Deconectează-mi contul","no-ads":"Fără publicitate adăugată","no-ads-desc":"Fără publicitate vizuală sau audio adăugată de Radioline (poți totuși să mai întâlnești publicitate difuzată de postul de radio)","my-app":"Aplicația mea","application-language":"Alege limba","select-application-language":"Alege limba","homepage-country":"Țara ecranului principal:","install-app":"Descarcă Radioline","features":"Funcționalități","add-device":"Adaugă un dispozitiv","app-version":"Versiunea aplicației","export-to-playlist-desc":"Adaugă muzica live de la radio la un playlist dintr-o singură atingere","connected-to":"Conectat la","settings":"Parametri","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Contul meu"},"continuity":{"popup-close-btn":"Închide","popup-play-btn":"Redare","popup-header":"Anterior ați ascultat:"},"search-for-stations":"Caută posturi de radio sau podcasturi și atinge pictograma inimă pentru a adăuga un episod aici","search-for-a-radio-or-podcast":"Caută un podcast radio","close":"Închide","generic-error":"S-a produs o eroare","fallback":{"error":"S-a produs o eroare","button":"Reîncearcă"},"export":{"select-platform":"Selecționează o platformă de muzică"},"demo-version":"Demo version","search-for-podcasts":"Caută podcasturi și atinge pictograma de descărcare pentru a adăuga un episod aici","playback-error":"Nu s-a putut reda acest flux","offline":{"save-error-toast":"Nu s-a putut descărca episodul","remove-success-toast":"Episod șters","save-success-toast":"Episod descărcat","save-in-progress-toast":"Episod în curs de descărcare","download-episode":"Descarcă acest episod","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Vizitează site-ul web","radio":"Radio","no-playlist":"Accesul la playlist-ul acestui post de radio nu este posibil sau nu este propus de către acest post radio","no-program":"Accesul la programul acestui post de radio nu este posibil sau nu este propus de către acest post radio","no-podcasts":"Accesul la podcast-urile acestui post de radio nu este posibil sau nu este propus de către acest post radio"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Pistă nerecunoscută. Ai putea găsi această pistă verificând istoricul melodiilor acestui post de radio, dacă este furnizat.","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Pistă nerecunoscută. Ai putea găsi această pistă verificând istoricul melodiilor acestui post de radio, dacă este furnizat.","qr-tutorial":{"title":"Cum să-ți conectezi contul Radioline la o platformă de muzică prin streaming:","step1":"Deschide aplicația Radioline pe mobil sau intră pe site-ul nostru (www.radioline.co)","step2":"În Setări, selecționează „Conectează-mi contul”","step3":"Selecționează platforma de muzică prin streaming dorită și urmărește instrucțiunile"}},"favorites":{"no-favotites":"Încă nu ai niciun favorit"},"podcast":"Podcast","search-results":{"try-again":"Reîncearcă","no-internet":"Conexiune Internet pierdută","no-results":"Nu s-a găsit niciun rezultat"},"network":{"connection-lost":"Se pare că s-a pierdut conexiunea dvs. la Internet","connection-slow":"Conexiunea dvs. la Internet pare a fi prea lentă. Puteți întâmpina probleme de redare","back-online":"Conexiunea dvs. la Internet a fost restabilită"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Vă mulțumim că ați contactat serviciul nostru clienți, vă vom răspunde cât mai curând posibil.","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"Acest post de radio/podcast folosește un protocol de difuzare (http) învechit pe care preferăm să nu îl redăm din motive de securitate.","old-website":"Site-ul anterior","accept-terms":"Validând crearea contului accepți Condițiile de utilizare a serviciilor și Politica de confidențialitate"}');
;// CONCATENATED MODULE: ./app/locales/ru.json
var ru_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Слушать • В ЭФИРЕ","seo_description_radio":"Слушать {var1} • В прямом эфире бесплатно на Radioline | Подкасты и записи | {var2}","seo_description_podcast":"Слушать подкаст {var1} бесплатно на Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Прямые радиотрансляции бесплатно на Radioline","seo_description_categoryRadioPage":"{var1} • Слушать радио онлайн (FM, AM, DAB, интернет-радио) в прямом эфире и бесплатно на Radioline | Подкасты и записи","seo_title_podcast":"{var1} • Подкаст {var2}","seo_title_discoverRadio":"{var1} • Радио онлайн в прямом эфире и бесплатно","seo_description_discoverRadio":"Слушать онлайн-радиостанции (FM, AM, DAB, интернет-радио) из {var1} в прямом эфире бесплатно на Radioline","seo_title_discoverPodcast":"{var1} • Подкасты доступны бесплатно и отсортированы по темам","seo_description_discoverPodcast":"Слушать подкасты {var1} онлайн бесплатно на Radioline","seo_title_home":"Радиостанции, подкасты и записи со всего мира бесплатно | Radioline","seo_description_home":"Знакомьтесь с миром радиостанций и подкастов на Radioline. Слушайте любимые радиостанции (FM, AM, DAB, интернет-радио) и подкасты из наших региональных, национальных и международных каталогов на всех своих устройствах.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Главная","favorites":"Избранное","discover":"Послушать новое","offline":"Автономный режим"}},"tabs":{"podcasts":"Подкасты","stations":"Радио","schedule":"На этой неделе","all":"Всё","downloaded":"Загруженные","unplayed":"Не воспроизведено","playlist":"плейлист"},"country-selector":"Выбрать страну","hq-stations":"Высококачественные радиостанции","national-selection":"Национальный выбор","radioline":"Radioline","worlds-best":"Лучшие радиостанции мира","thematics":"Разделы","local-stations":"Местные радиостанции","log-in":"Войти","log-in-with-my-mobile":"Подключиться с моим мобильным телефоном","log-in-with-facebook":"Продолжить с аккаунтом Facebook","sign-up":"Зарегистрируйтесь","music-on-air":"Музыка в прямом эфире","search":"Поиск","email":"Электронный адрес","email-is-required":"Требуется электронный адрес","could-not-sign-in-please-check-your-email-and-password":"Неверный электронный адрес и/или пароль","password":"Пароль","password-is-required":"Password required","forgot-password":"Забыли пароль?","time":{"h":"ч.","min":"мин.","s":"сек."},"navigation-map":"карта сайта","privacy-policy":"Политика конфиденциальности","privacy-settings":"Настройки конфиденциальности","terms-of-use":"Условия использования","our-solutions":"Наши решения","contact":"Контакты","install-app":"Загрузить Radioline","add-manage-you-station-or-podcast":"Добавить/управлять радиостанцией или подкастом","send":"Отправить","field-required":"This field is required","subject":"Тема","your-message":"Ваше сообщение","your-name":"Ваше имя","episodes":"Эпизоды","go-to-podcast":"Перейти в раздел «Подкасты»","mark-as-played":"Отметить, как прослушанное","delete":"Удалить","see-website":"Перейти на сайт","you-dont-have-favorites":"В разделе «Избранное» ничего нет. Чтобы сохранить в «Избранном», зарегистрируйтесь, это быстро и просто!","create-an-account":"Зарегистрируйтесь","you-dont-have-podcasts":"У вас нет загруженных эпизодов подкастов.","to-downaload-episodes":"Чтобы загрузить эпизоды подкастов, зарегистрируйтесь, это быстро и просто!","premium":{"download-podcasts":"Загружайте подкасты и слушайте их в автономном режиме","go-premium-for":"Перейти в категорию Премиум за {var1}","automatically-play-last-radio":"Автоматическое воспроизведение последней радиостанции или подкаста при запуске приложения","worlds-best-music-stations":"Лучшее в мире","local-and-worldwide":"Местные и мировые каталоги (161 страна)","scan-qr-code":"Отсканируйте данный QR-код","no-ads":"Без рекламы","no-ads-desc":"Без визуальной и звуковой рекламы от Radioline (только реклама, добавленная вещательной компанией)","export-to-playlist-desc":"Добавьте музыку, звучащую в прямом эфире радиостанций, в свой плейлист одним касанием (Spotify, Deezer)","worlds-best":"Лучшее в мире","worlds-best-desc":"Мы отобрали для вас лучшие музыкальные радиостанции со всего мира в 17 музыкальных жанрах","hq-stations-desc":"Откройте для себя музыкальные радиостанции с высоким качеством звука (MP3 - 320 Кбит/с)","after-payment-title":"Идет процесс оформления вашей подписки. Пожалуйста, подождите","after-payment-support":"Процесс оформления подписки занимает немного больше времени, чем ожидалось. Если у вас возникли какие-либо проблемы, пожалуйста, отправьте сообщение по адресу support@radioline.co","premium":"Премиум","video-ad-description":"Эта видеореклама позволяет нам предоставить вам бесплатный доступ к приложению"},"back":"Вернуться назад","auth":{"or":"ИЛИ","save-your-favorites":"Сохранить в «Избранном»","synchronize-your-account":"Синхронизировать аккаунт на всех устройствах","resume-playback":"Возобновить считывание","resume-podcasts":"Продолжите прослушивание подкастов с того места, на котором вы остановились, и сохраните последний прослушанный контент","offline-podcasts":"Подкасты в режиме офлайн","download-podcasts":"Загружайте подкасты и слушайте их в автономном режиме","reset-password":"Изменить пароль","login-with-mobile":"Подключиться с моим мобильным телефоном","step-1":"Откройте программу Radioline на вашем мобильном телефоне","step-2":"В параметрах выберите «Добавить устройство»","step-3":"Откройте код, который высветился на экране","account":"Счет","export-to-playlist":"Добавить в плейлист","export-to-playlist-desc":"Добавьте музыку, звучащую в прямом эфире радиостанций, в свой плейлист одним касанием (Spotify, Deezer)","sign-out":"Выйти","reset-password-error":"Не удалось изменить пароль, просим вас попробовать еще раз","email-error":"Требуется электронный адрес","reset-password-success":"Ваш новый пароль был отправлен на {email}","instructions":"Инструкции","code-required":"Требуется код входа","add-device-meta-description":"Offline access - Radioline","change-my-password":"Изменить пароль","current-password":"Текущий пароль","new-password":"Новый пароль","repeat-password":"Повторите новый пароль","password-change":{"success":"Ваш пароль был успешно изменен"},"password-length-validation":"Ваш пароль должен содержать от 8 до 30 символов.","password-mismatch-validation":"Вы ввели два разных пароля","password-old-passowrd-match-validation":"Ваш новый пароль должен отличаться от вашего предыдущего пароля","email-exists-error":"Этот адрес электронной почты уже используется с учетной записью Radioline."},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Добавить в плейлист","autoplay":"Автоматическое воспроизведение","settings":{"link-account":"Связать мою учетную запись","unlink-account":"Отменить связь моей учетной записи","no-ads":"Без рекламы","no-ads-desc":"Без визуальной и звуковой рекламы от Radioline (только реклама, добавленная вещательной компанией)","my-app":"Мое приложение","application-language":"Выберите язык","select-application-language":"Выберите язык","homepage-country":"Страна главной страницы экрана","install-app":"Загрузить Radioline","features":"Характеристики","add-device":"Добавить устройство","app-version":"Версия приложения","export-to-playlist-desc":"Добавьте музыку, звучащую в прямом эфире радиостанций, в свой плейлист одним касанием","connected-to":"Ссылка на","settings":"Настройки","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"мою учетную"},"continuity":{"popup-close-btn":"Закрыть","popup-play-btn":"Воспроизвести","popup-header":"Вы ранее слушали:"},"search-for-stations":"Найдите радиостанции или подкасты и нажмите на кнопку с изображением сердца, чтобы добавить их сюда","search-for-a-radio-or-podcast":"Поиск радиостанции или подкаста","close":"Закрыть","generic-error":"Произошла ошибка","fallback":{"error":"Произошла ошибка","button":"Попробуйте еще раз"},"export":{"select-platform":"Выберите музыкальную платформу"},"demo-version":"Demo version","search-for-podcasts":"Найдите подкасты и нажмите на кнопку загрузки, чтобы добавить эпизод сюда","playback-error":"Не удалось воспроизвести данный поток","offline":{"save-error-toast":"Не удалось загрузить эпизод","remove-success-toast":"Эпизод удален","save-success-toast":"Эпизод загружен","save-in-progress-toast":"Загрузка эпизода","download-episode":"Скачать данный эпизод","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Посетить сайт","radio":"радио","no-playlist":"Доступ к списку воспроизведения данной радиостанции отсутствует или не предусмотрен","no-program":"Доступ к программе данной радиостанции отсутствует или не предусмотрен","no-podcasts":"Доступ к подкастам данной радиостанции отсутствует или не предусмотрен"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Трек не найден. Найти данный трек можно, просмотрев историю песен радиостанции, если таковая имеется.","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Трек не найден. Найти данный трек можно, просмотрев историю песен радиостанции, если таковая имеется.","qr-tutorial":{"title":"Как связать свою учетную запись Radioline с платформой потокового вещания музыки:","step1":"Откройте мобильное приложение Radioline или зайдите на наш сайт (www.radioline.co)","step2":"В настройках выберите «Связать мою учетную запись»","step3":"Выберите интересующую вас платформу потокового вещания музыки и следуйте инструкциям"}},"favorites":{"no-favotites":"В разделе «Избранное» ничего нет."},"podcast":"Подкаст","search-results":{"try-again":"Попробуйте еще раз","no-internet":"Отсутствует подключение к интернету","no-results":"По вашему запросу ничего не найдено"},"network":{"connection-lost":"Подключение к интернету прервано","connection-slow":"Низкая скорость подключения к интернету. При воспроизведении могут возникнуть проблемы","back-online":"Подключение к интернету восстановлено"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Благодарим вас за обращение в нашу службу поддержки. Мы ответим вам в ближайшее время.","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"Данная радиостанция/подкаст ведет вещание по устаревшему протоколу (http), который не воспроизводится из соображений безопасности.","old-website":"Бывший сайт","accept-terms":"Подписываясь, вы принимаете Условия предоставления услуг и Политику конфиденциальности"}');
;// CONCATENATED MODULE: ./app/locales/sv.json
var sv_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | Lyssna • LIVE","seo_description_radio":"Lyssna på {var1} • Live och gratis på Radioline | Poddar och repriser | {var2}","seo_description_podcast":"Lyssna på podden {var1} gratis på Radioline | {var2}","seo_title_category_RadioPage":"{var1} • Direktsänd radio gratis på Radioline","seo_description_categoryRadioPage":"{var1} • Lyssna gratis på direktsänd onlineradio (FM, AM, DAB och webbradio) på Radioline | Poddar och repriser","seo_title_podcast":"Podden {var1} • {var2}","seo_title_discoverRadio":"{var1} • Direktsänd onlineradio gratis","seo_description_discoverRadio":"Lyssna gratis på {var1} radiostationer (FM, AM, DAB och webbradio) på Radioline","seo_title_discoverPodcast":"{var1} • Poddar som är gratis att lyssna på och sorterade efter tema","seo_description_discoverPodcast":"Lyssna på {var1} poddar online gratis på Radioline","seo_title_home":"Radio, poddar och repriser från hela världen gratis | Radioline","seo_description_home":"Upptäck en värld av radio och poddar med Radioline. Lyssna på dina favoritstationer (FM, AM, DAB och webbradio) och poddar på alla dina enheter med våra kataloger på lokal nivå, riksnivå och internationell nivå.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"Start","favorites":"Favoriter","discover":"Upptäck","offline":"Offline"}},"tabs":{"podcasts":"Podcasts","stations":"Radiokanaler","schedule":"Schema","all":"Alla","downloaded":"Nedladdat","unplayed":"Ospelat","playlist":"Spellistan"},"country-selector":"Välj Land","hq-stations":"Högkvalitativa Radiokanaler","national-selection":"Nationellt Urval","radioline":"Radioline","worlds-best":"Världens Bästa","thematics":"Ämnen","local-stations":"Lokala Radiokanaler","log-in":"Logga in","log-in-with-my-mobile":"Ansluta med min mobil","log-in-with-facebook":"Fortsätt med Facebook","sign-up":"Skapa ett konto","music-on-air":"Livemusik","search":"Sök","email":"E-post","email-is-required":"E-postadress krävs","could-not-sign-in-please-check-your-email-and-password":"Ogiltig e-postadress och/eller ogiltigt lösenord","password":"Lösenord","password-is-required":"Password required","forgot-password":"Har du glömt ditt Lösenord?","time":{"h":"tim","min":"min","s":"sek"},"navigation-map":"Webbplatskarta","privacy-policy":"Sekretesspolicy","privacy-settings":"Sekretessinställningar","terms-of-use":"Användarvillkor","our-solutions":"Våra lösningar","contact":"Kontakta oss","install-app":"Ladda ner Radioline","add-manage-you-station-or-podcast":"Lägg till/Hantera din radiostation eller podcast","send":"Skicka","field-required":"Detta fält är obligatoriskt","subject":"Ämne","your-message":"Ditt meddelande","your-name":"Ditt namn","episodes":"Avsnitt","go-to-podcast":"Gå till Podcasten","mark-as-played":"Markera som spelad","delete":"Radera","see-website":"Se Hemsida","you-dont-have-favorites":"Du har inga favoriter ännu. Skapa ett konto om du vill spara dina favoriter, det går snabbt och enkelt!","create-an-account":"Skapa ett konto","you-dont-have-podcasts":"Du har ännu inte laddat ned några podcastavsnitt.","to-downaload-episodes":"Skapa ett konto för att spara podcastavsnitt, det går snabbt och enkelt!","premium":{"download-podcasts":"Ladda ner podcasts och lyssna på dem offline","go-premium-for":"Bli Premiummedlem för {var1}","automatically-play-last-radio":"Spela automatiskt den sista radiokanalen eller podcasten du lyssnade på när du öppnar appen","worlds-best-music-stations":"Världens Bästa","local-and-worldwide":"Lokala och globala kataloger (161 länder)","scan-qr-code":"Skanna denna QR kod","no-ads":"Inga annonser har lagts till","no-ads-desc":"Varken visuella annonser eller ljudannonser har lagts till av Radioline (du kan fortfarande stöta på annonser som lagts till av programföretaget)","export-to-playlist-desc":"Lägg till musik live på radion till din spellista med ett enda tryck (Spotify, Deezer)","worlds-best":"Världens Bästa","worlds-best-desc":"Vi har valt ut världens bästa radiostationer för dig, uppdelade på 17 musikgenrer.","hq-stations-desc":"Upptäck radiostationer som sänder med hög ljudkvalitet (MP3 - 320 Kbps).","after-payment-title":"Vi håller på att behandla din prenumeration, vänligen vänta","after-payment-support":"Behandlingen av prenumerationen tar lite längre tid än väntat. Om du stöter på några problem, vänligen kontakta support@radioline.co","premium":"Premiummedlem","video-ad-description":"Denna videoannons gör det möjligt för oss att ge dig gratis tillgång till appen"},"back":"Tillbaka","auth":{"or":"ELLER","save-your-favorites":"Spara dina favoriter","synchronize-your-account":"Synkronisera ditt konto på alla dina enheter","resume-playback":"Återuppta Uppspelningen","resume-podcasts":"Fortsätt med podcasts där du slutade och spara det senast spelade innehållet","offline-podcasts":"Podcasts offline","download-podcasts":"Ladda ner podcasts och lyssna på dem offline","reset-password":"Återställ ditt Lösenord","login-with-mobile":"Ansluta med min mobil","step-1":"Öppna Radioline-appen på din mobil","step-2":"Välj ”lägg till enhet” i inställningarna","step-3":"Ange den kod som visas på skärmen","account":"Konto","export-to-playlist":"Lägg till i Spellistan","export-to-playlist-desc":"Lägg till musik live på radion till din spellista med ett enda tryck (Spotify, Deezer).","sign-out":"Logga ut","reset-password-error":"Vi kunde inte återställa ditt lösenord, vänligen försök igen","email-error":"E-postadress krävs","reset-password-success":"Ditt nya lösenord har skickats till {e-post}","instructions":"Instruktioner","code-required":"Inloggningskod krävs","add-device-meta-description":"Offline access - Radioline","change-my-password":"Ändra mitt lösenord","current-password":"Nuvarande lösenord","new-password":"Nytt lösenord","repeat-password":"Repetera det nya lösenordet","password-change":{"success":"Ditt lösenord har ändrats"},"password-length-validation":"Ditt lösenord bör vara mellan 8 och 30 tecken","password-mismatch-validation":"Du angav två olika lösenord","password-old-passowrd-match-validation":"Ditt nya lösenord måste skilja sig från ditt tidigare lösenord","email-exists-error":"Denna e-postadress används redan med ett Radioline-konto"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"Lägg till i Spellistan","autoplay":"Automatisk Uppspelning","settings":{"link-account":"Länka mitt konto","unlink-account":"Avlänka mitt konto","no-ads":"Inga annonser har lagts till","no-ads-desc":"Varken visuella annonser eller ljudannonser har lagts till av Radioline (du kan fortfarande stöta på annonser som lagts till av programföretaget)","my-app":"Min app","application-language":"Välj språk","select-application-language":"Välj språk","homepage-country":"Land på Startsidan:","install-app":"Ladda ner Radioline","features":"Funktioner","add-device":"Lägga till en enhet","app-version":"App-version","export-to-playlist-desc":"Lägg till musik live på radion till din spellista med ett enda tryck","connected-to":"Länkad till","settings":"Inställningar","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"Mitt konto"},"continuity":{"popup-close-btn":"Stäng","popup-play-btn":"Spela","popup-header":"Du har tidigare lyssnat på:"},"search-for-stations":"Sök efter radiokanaler eller podcasts och tryck på hjärtikonen för att lägga till dem här","search-for-a-radio-or-podcast":"Sök efter en radiostation eller en podcast","close":"Stäng","generic-error":"Ett fel inträffade","fallback":{"error":"Något gick fel","button":"Försök igen"},"export":{"select-platform":"Välj en musikplattform"},"demo-version":"Demo version","search-for-podcasts":"Sök efter podcasts och tryck på nedladdningsikonen för att lägga till ett avsnitt här","playback-error":"Vi kunde inte spela upp den här strömningen","offline":{"save-error-toast":"Nedladdning av avsnittet misslyckades","remove-success-toast":"Avsnitt borttaget","save-success-toast":"Avsnitt nedladdat","save-in-progress-toast":"Nedladdning av avsnitt pågår","download-episode":"Ladda ner det här avsnittet","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"Besök webbplatsen","radio":"Radiostation","no-playlist":"Tillgång till den här radiostationens lyssningshistorik är ej tillgänglig eller den erbjuder ingen","no-program":"Tillgång till den här radiostationens program är ej tillgänglig eller den erbjuder inget","no-podcasts":"Tillgång till den här radiostationens podcasts är ej tillgänglig eller den erbjuder inga"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"Spåret känns inte igen. Du kan hitta det här spåret genom att titta i radiokanalens lyssningshistorik om en sådan finnes.","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"Spåret känns inte igen. Du kan hitta det här spåret genom att titta i radiokanalens lyssningshistorik om en sådan finnes.","qr-tutorial":{"title":"Så här kopplar du ditt Radiolinekonto till en plattform för musikströmning:","step1":"Öppna din Radioline mobilapp eller gå till vår webbplats (www.radioline.co)","step2":"I inställningar väljer du ”Länka mitt konto”","step3":"Välj valfri musikströmningsplattform och följ instruktionerna"}},"favorites":{"no-favotites":"Du har inga favoriter ännu"},"podcast":"Podcast","search-results":{"try-again":"Försök igen","no-internet":"Ingen internetuppkoppling","no-results":"Inga sökresultat"},"network":{"connection-lost":"Det verkar som om du har förlorat din internetanslutning","connection-slow":"Det verkar som om din internetuppkoppling är långsam. Du kan få problem med uppspelningen","back-online":"Din internetanslutning har återställts"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"Tack för att du kontaktar vår support, vi kommer att svara dig utan onödigt dröjsmål","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"Den här radiostationen/podcasten sänder med ett föråldrat protokoll (http) som vi föredrar att inte spela upp av säkerhetsskäl","old-website":"Tidigare webbplats","accept-terms":"Genom att skapa ett konto godkänner du Användarvillkoren."}');
;// CONCATENATED MODULE: ./app/locales/zh-CN.json
var zh_CN_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | 收听 - 直播","seo_description_radio":"在Radioline上免费收听 {var1} • 现场直播与重播 | 播客&重播 | {var2}","seo_description_podcast":"在Radioline上免费收听播客 {var1} | {var2}","seo_title_category_RadioPage":"在Radioline上免费收听电台 {var1}","seo_description_categoryRadioPage":"{var1} • 在 Radioline 上免费收听在线广播（FM、AM、DAB、网络广播） | 播客&重播","seo_title_podcast":"{var1} • {var2} 播客","seo_title_discoverRadio":"{var1} • 免费收听在线广播","seo_description_discoverRadio":"在 Radioline 上免费收听 {var1} 的在线广播电台（FM、AM、DAB、网络广播)","seo_title_discoverPodcast":"{var1} • 免费收听的按主题分类的播客","seo_description_discoverPodcast":"在 Radioline 上免费收听 {var1}播客","seo_title_home":"免费收听世界各地的广播、播客和回放 | Radioline","seo_description_home":"通过 Radioline 探索广播和播客世界。通过我们的本地、国内和国际目录，在您所有的设备上收听您喜爱的广播电台（FM、AM、DAB、网络广播）和播客。","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"首页","favorites":"收藏","discover":"发现","offline":"离线"}},"tabs":{"podcasts":"播客","stations":"电台","schedule":"定时","all":"所有电台","downloaded":"已下载","unplayed":"未播放","playlist":"播放列表"},"country-selector":"选择国家","hq-stations":"高音质电台","national-selection":"国家热门电台推荐","radioline":"Radioline","worlds-best":"世界节目精选","thematics":"主题","local-stations":"区域电台","log-in":"登录","log-in-with-my-mobile":"手机登录","log-in-with-facebook":"使用 Facebook 登录","sign-up":"注册","music-on-air":"正在直播的音乐","search":"搜索","email":"邮件","email-is-required":"请输入电子邮箱地址","could-not-sign-in-please-check-your-email-and-password":"邮箱地址或密码无效","password":"密码","password-is-required":"Password required","forgot-password":"忘记密码？","time":{"h":"小时","min":"分","s":"秒"},"navigation-map":"站点地图","privacy-policy":"隐私政策","privacy-settings":"隐私设置","terms-of-use":"使用条款","our-solutions":"解决方案","contact":"联系方式","install-app":"下载Radioline","add-manage-you-station-or-podcast":"添加/管理您的电台或播客","send":"发送","field-required":"此栏需填写","subject":"主题","your-message":"消息","your-name":"姓名","episodes":"集数","go-to-podcast":"打开该播客","mark-as-played":"已收听","delete":"删除","see-website":"访问网页版","you-dont-have-favorites":"您尚未设置我的收藏。如需设定我的收藏，请创建账户，这将使您的收听体验更快更便捷!","create-an-account":"创建账户","you-dont-have-podcasts":"您尚未下载任何播客。如需下载播客，","to-downaload-episodes":"要下载播客，请创建一个帐户，它既快速又简单！","premium":{"download-podcasts":"下载播客以便离线收听","go-premium-for":"高级订阅仅需 {var1}","automatically-play-last-radio":"在程序启动时自动播放上一次收听的电台或播客","worlds-best-music-stations":"世界节目精选","local-and-worldwide":"本地和全球精选目录（161国家）","scan-qr-code":"扫描二维码","no-ads":"去除广告","no-ads-desc":"去除Radioline的视频或者音频广告（您仍然可能会听到广播商的广告）","export-to-playlist-desc":"一键将现场广播音乐添加到您的播放列表（Spotify，Deezer）","worlds-best":"世界节目精选","worlds-best-desc":"我们为您挑选了涵盖17种音乐流派的全球最佳的音乐电台","hq-stations-desc":"探索高音质(MP3 - 320 Kbps) 的音乐电台","after-payment-title":"正在处理您的订阅，请稍等","after-payment-support":"订阅处理时间稍长，请联系support@radioline.co反馈问题","premium":"高級版","video-ad-description":"通過此視頻廣告，我們可以讓您免費享受該應用程序"},"back":"返回","auth":{"or":"或","save-your-favorites":"保存到我的收藏","synchronize-your-account":"同步我的账户到所有设备","resume-playback":"恢复播放","resume-podcasts":"同步最后一次播放的播客到所有设备","offline-podcasts":"离线播客","download-podcasts":"下载播客以便离线收听","reset-password":"重置密码","login-with-mobile":"手机登录","step-1":"在您的手机上打开Radioline 应用程序","step-2":"在设置中，选择 \\"添加设备\\"","step-3":"输入屏幕上显示的密码","account":"账户","export-to-playlist":"输出到播放列表","export-to-playlist-desc":"一键将现场广播音乐添加到您的播放列表（Spotify，Deezer）","sign-out":"退出登录","reset-password-error":"重设密码失败，请重试","email-error":"请输入电子邮箱地址","reset-password-success":"您的新密码已发至{email}","instructions":"操作提示","code-required":"请输入登录密码","add-device-meta-description":"Offline access - Radioline","change-my-password":"更改密码","current-password":"当前密码","new-password":"新密码","repeat-password":"再次输入新密码","password-change":{"success":"你已经成功更改密码"},"password-length-validation":"您的密码应介于 8 到 30 个字符之间","password-mismatch-validation":"您输入了两个不同的密码","password-old-passowrd-match-validation":"您的新密码必须与之前的密码不同","email-exists-error":"此电子邮件已用于 Radioline 帐户"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"输出到播放列表","autoplay":"自动播放","settings":{"link-account":"绑定账号","unlink-account":"解绑账号","no-ads":"去除广告","no-ads-desc":"去除Radioline的视频或者音频广告（您仍然可能会听到广播商的广告）","my-app":"我的应用","application-language":"选择语言","select-application-language":"选择语言","homepage-country":"主页屏幕国家","install-app":"下载Radioline","features":"特色服务","add-device":"添加设备","app-version":"应用版本","export-to-playlist-desc":"一键将现场广播音乐添加到您的播放列表","connected-to":"连接 账户","settings":"设置","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"我的帐户"},"continuity":{"popup-close-btn":"关闭","popup-play-btn":"播放","popup-header":"您之前听过："},"search-for-stations":"搜索电台或者播客，点击心型图标并添加在此","search-for-a-radio-or-podcast":"搜索电台或者播客","close":"关闭","generic-error":"发生错误","fallback":{"error":"出错啦","button":"重试"},"export":{"select-platform":"选择音乐平台"},"demo-version":"Demo version","search-for-podcasts":"搜索播客，点击下载图标并在此添加节目","playback-error":"不能播放该流媒体","offline":{"save-error-toast":"该集下载失败","remove-success-toast":"该集已删除","save-success-toast":"该集已下载","save-in-progress-toast":"该集正在下载","download-episode":"下载这一集","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"浏览网站","radio":"电台","no-playlist":"无法进入该电台播放列表或该电台无播放列表","no-program":"无法进入该电台节目或该电台无节目","no-podcasts":"无法进入该电台播客或该电台无播客"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"未识别曲目。请查询历史歌曲播放记录。","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"未识别曲目。请查询历史歌曲播放记录。","qr-tutorial":{"title":"如何将Radioline账号绑定音乐流媒体平台：","step1":"打开Radioline的应用或者浏览网站（www.radioline.co）","step2":"在设置页面，选择“绑定我的账号”","step3":"选择您想绑定的音乐流媒体平台，根据提示进行操作"}},"favorites":{"no-favotites":"您尚未设置我的收藏。"},"podcast":"播客","search-results":{"try-again":"重试","no-internet":"没有可用网络","no-results":"查询无结果"},"network":{"connection-lost":"网络连接已丢失","connection-slow":"网络连接速度慢，可能会遇到播放问题","back-online":"网络连接已经恢复"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"感谢联系客服，我们会尽快答复","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"该电台/播客配有过期的http协议，出于安全因素我们不进行播放。","old-website":"旧网站","accept-terms":"注册即表示您接收我们的服务条款与隐私政策"}');
;// CONCATENATED MODULE: ./app/locales/zh-TW.json
var zh_TW_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | 收聽 • 現場直播","seo_description_radio":"收聽 {var1} • 於 Radioline 免費現場直播 | 播客與重播 | {var2}","seo_description_podcast":"於 Radioline 免費收聽播客 {var1} | {var2}","seo_title_category_RadioPage":"{var1} • 於 Radioline 即時免費廣播","seo_description_categoryRadioPage":"{var1} • 於 Radioline 免費收聽即時線上廣播（FM、AM、DAB、網路廣播）| 播客與重播","seo_title_podcast":"{var1} • {var2} 播客","seo_title_discoverRadio":"{var1} • 免費即時線上廣播","seo_description_discoverRadio":"於 Radioline 收聽 {var1} 免費即時線上廣播電台（FM、AM、DAB、網路廣播）","seo_title_discoverPodcast":"{var1} • 免費提供播客並按主題排序","seo_description_discoverPodcast":"於 Radioline 免費線上收聽 {var1} 播客","seo_title_home":"免費收聽世界各地的廣播、播客與重播 | Radioline","seo_description_home":"透過 Radioline 探索廣播與播客的世界。使用當地、國家與國際目錄，在所有裝置上收聽您最喜愛的廣播電台（FM、AM、DAB、網路廣播）與播客。","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"首頁","favorites":"最愛","discover":"探索","offline":"離線"}},"tabs":{"podcasts":"播客","stations":"電臺","schedule":"定時","all":"所有電臺","downloaded":"已下載","unplayed":"未播放","playlist":"播放列表"},"country-selector":"選擇國家","hq-stations":"高音質電臺","national-selection":"熱門電臺","radioline":"Radioline","worlds-best":"世界節目精選","thematics":"主題","local-stations":"區域電臺","log-in":"登入","log-in-with-my-mobile":"手機登入","log-in-with-facebook":"以 Facebook 帳號繼續","sign-up":"註冊","music-on-air":"現在正在播放","search":"搜索","email":"電子郵件","email-is-required":"請輸入電子郵箱位址","could-not-sign-in-please-check-your-email-and-password":"無效的email和/或密碼","password":"密碼","password-is-required":"Password required","forgot-password":"忘記密碼","time":{"h":"小時","min":"分","s":"秒"},"navigation-map":"站點地圖","privacy-policy":"隱私政策","privacy-settings":"隱私設置","terms-of-use":"使用條款","our-solutions":"解決方案","contact":"聯繫方式","install-app":"下載Radioline","add-manage-you-station-or-podcast":"添加/管理您的電台或播客","send":"發送","field-required":"此欄需填寫","subject":"主題","your-message":"消息","your-name":"姓名","episodes":"集數","go-to-podcast":"打開該播客","mark-as-played":"已聽過","delete":"刪除","see-website":"參訪網頁","you-dont-have-favorites":"您尚未設定我的最愛。如需設定我的最愛，請開通帳戶，過程很容易又快速！","create-an-account":"開通帳戶","you-dont-have-podcasts":"您尚未下載任何的播客。如需下載播客,請開通帳戶。過程容易又快速！","to-downaload-episodes":"如需下載播客,請開通帳戶。過程容易又快速！","premium":{"download-podcasts":"下載podcast離線聆聽","go-premium-for":"高級版 {var1}","automatically-play-last-radio":"在應用程序啟動時自動播放上一個電台或播客","worlds-best-music-stations":"世界節目精選","local-and-worldwide":"本地和全球精選目錄（161國家）","scan-qr-code":"掃描二維碼","no-ads":"去除廣告","no-ads-desc":"去除Radioline的視頻或者音訊廣告（您仍然可能會聽到廣播商的廣告）","export-to-playlist-desc":"一鍵將現場廣播音樂添加到您的播放清單（Spotify，Deezer)","worlds-best":"世界節目精選","worlds-best-desc":"我們為您選擇了 17 種音樂流派的全球最佳音樂電台","hq-stations-desc":"發現具有高音質 (MP3 - 320 Kbps) 的音樂電台","after-payment-title":"正在處理您的訂閱，請稍等","after-payment-support":"訂閱處理時間稍長，請聯繫 support@radioline.co 反饋問題","premium":"高級版","video-ad-description":"这个视频广告使我们能够让你免费使用该应用程序"},"back":"回去","auth":{"or":"或","save-your-favorites":"存到我的最愛","synchronize-your-account":"同步我的帳戶到所有設備","resume-playback":"恢復播放","resume-podcasts":"從上一次停止播放的進度開始播放博客並保存最近播放的內容","offline-podcasts":"離線播客","download-podcasts":"下載podcast離線聆聽","reset-password":"重設密碼","login-with-mobile":"手機登入","step-1":"在您的手機上打開 Radioline 應用程式","step-2":"在設置中，選擇“添加設備”","step-3":"輸入屏幕上顯示的密碼","account":"帳戶","export-to-playlist":"輸出到播放列表","export-to-playlist-desc":"一鍵將現場廣播音樂添加到您的播放清單（Spotify，Deezer）","sign-out":"登出","reset-password-error":"重設密碼失敗，請重試","email-error":"請輸入電子郵箱位址","reset-password-success":"您的新密碼已發至{email}","instructions":"操作提示","code-required":"請輸入登錄密碼","add-device-meta-description":"Offline access - Radioline","change-my-password":"更改密碼","current-password":"當前密碼","new-password":"新密碼","repeat-password":"再次輸入新密碼","password-change":{"success":"你已經成功更改密碼"},"password-length-validation":"您的密碼應介於 8 到 30 個字符之間","password-mismatch-validation":"您輸入了兩個不同的密碼","password-old-passowrd-match-validation":"您的新密碼必須與之前的密碼不同","email-exists-error":"此電子郵件已用於 Radioline 帳戶"},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"輸出到播放列表","autoplay":"自動播放","settings":{"link-account":"綁定帳號","unlink-account":"解綁帳號","no-ads":"去除廣告","no-ads-desc":"去除Radioline的視頻或者音訊廣告（您仍然可能會聽到廣播商的廣告）","my-app":"我的應用","application-language":"選擇語言","select-application-language":"選擇語言","homepage-country":"主頁屏幕國家","install-app":"下載Radioline","features":"特色服務","add-device":"添加設備","app-version":"應用版本","export-to-playlist-desc":"一鍵將現場廣播音樂添加到您的播放清單（Spotify，Deezer）","connected-to":"連接帳戶","settings":"設定","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"我的帳戶"},"continuity":{"popup-close-btn":"關閉","popup-play-btn":"播放","popup-header":"您之前聽過："},"search-for-stations":"搜索電臺或者播客，點擊心型圖示並添加在此","search-for-a-radio-or-podcast":"搜索電臺或者播客","close":"關閉","generic-error":"發生錯誤","fallback":{"error":"出錯啦","button":"重試"},"export":{"select-platform":"選擇音樂平臺"},"demo-version":"Demo version","search-for-podcasts":"搜索播客，點擊下載圖示並在此添加節目","playback-error":"不能播放該流媒體","offline":{"save-error-toast":"該集下載失敗","remove-success-toast":"該集已刪除","save-success-toast":"該集已下載","save-in-progress-toast":"該集正在下載","download-episode":"下載這一集","meta-description":"Offline access - Radioline"},"radio":{"visit-website":"瀏覽網站","radio":"電臺","no-playlist":"無法進入該電臺播放清單或該電臺無播放清單","no-program":"無法進入該電台節目或該電臺無節目","no-podcasts":"無法進入該電臺播客或該電臺無播客"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"未識別曲目。 請查詢歷史歌曲播放記錄。","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"未識別曲目。 請查詢歷史歌曲播放記錄。","qr-tutorial":{"title":"如何將Radioline賬號綁定音樂流媒體平臺：","step1":"打開Radioline的應用或者瀏覽網站（www.radioline.co）","step2":"在設置頁面，選擇\\"綁定我的帳號\\"","step3":"選擇您想綁定的音樂流媒體平臺，根據提示進行操作"}},"favorites":{"no-favotites":"您尚未設定我的最愛。"},"podcast":"播客","search-results":{"try-again":"重試","no-internet":"沒有可用網路","no-results":"查詢無結果"},"network":{"connection-lost":"網路連接已丟失","connection-slow":"網路連接速度慢，可能會遇到播放問題","back-online":"網路連接已經恢復"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"感謝聯繫客服，我們會儘快答覆","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"該電臺/播客配有過期的HTTP協定，出於安全因素我們不進行播放。","old-website":"舊網站","accept-terms":"註冊即表示您接受服務條款和隱私政策"}');
;// CONCATENATED MODULE: ./app/locales/ko.json
var ko_namespaceObject = JSON.parse('{"seo_title_radio":"{var1} | 생방송 • 청취","seo_description_radio":"{var1} 청취 • Radioline에서 생방송 무료 청취 | 팟캐스트 및 다시 듣기 | {var2}","seo_description_podcast":"Radioline에서 {var1}  팟캐스트 무료 청취 | {var2}","seo_title_category_RadioPage":"{var1} • Radioline에서 라디오 생방송 무료 청취","seo_description_categoryRadioPage":"{var1} • Radioline에서 온라인 라디오 생방송(FM, AM, DAB, Webradios) 무료 청취 | 팟캐스트 및 다시 듣기","seo_title_podcast":"{var1} • {var2} 팟캐스트","seo_title_discoverRadio":"{var1} • 온라인 라디오 생방송 무료 청취","seo_description_discoverRadio":"Radioline에서 온라인 라디오 생방송(FM, AM, DAB, Webradios) 무료 청취","seo_title_discoverPodcast":"{var1} • 테마별로 분류된 팟캐스트 무료 청취","seo_description_discoverPodcast":"Radioline에서 {var1} 온라인 팟캐스트 무료 청취","seo_title_home":"전 세계 라디오, 팟캐스트, 다시 듣기 무료 청취 | Radioline","seo_description_home":"Radioline과 함께 라디오와 팟캐스트의 세계로 여행을 떠나보세요. 모든 기기에서 지역, 국가, 해외 카탈로그에 포함된 좋아하는 라디오 방송국(FM, AM, DAB, Webradio)과 팟캐스트를 청취하세요.","seo":{"navigation-map-index-title":"Navigation map","navigation-map-index-description":"Navigation map of Radioline website","navigation-map-country-title":"Navigation map - {country}","navigation-map-country-description":"List of stations and podcasts in {country}."},"header":{"menu":{"home":"홈","favorites":"즐겨찾기","discover":"검색","offline":"오프라인"}},"tabs":{"podcasts":"팟캐스트","stations":"방송","schedule":"스케줄","all":"전부","downloaded":"다운로드됨","unplayed":"듣지 않은","playlist":"재생 목록"},"country-selector":"국가 선택","hq-stations":"라디오 본사","worlds-best":"세계 최고 인기","thematics":"테마","national-selection":"국내 선발","radioline":"Radioline","local-stations":"지역 방송","log-in-with-my-mobile":"내 모바일로 로그인","log-in-with-facebook":"Facebook으로 계속하기","log-in":"로그인하기","sign-up":"계정 만들기","search":"검색","music-on-air":"생방송 음악","forgot-password":"비밀번호를 잊어버렸습니까 ?","password":"비밀번호","password-is-required":"비밀번호 필요","email":"이메일","email-is-required":"정확한 이메일 주소를 입력하세요","could-not-sign-in-please-check-your-email-and-password":"잘못된 이메일 주소 및/또는 비밀번호","time":{"h":"시간","min":"분","s":"초"},"navigation-map":"사이트 맵","privacy-policy":"개인 정보 정책","privacy-settings":"개인 정보 설정","terms-of-use":"이용 약관","our-solutions":"우리의 솔루션","contact":"문의하기","install-app":"앱 설치","add-manage-you-station-or-podcast":"라디오 또는 팟캐스트 추가/관리","send":"보내기","field-required":"이 필드는 필수 항목입니다.","subject":"주제","your-message":"귀하의 메시지","your-name":"귀하의 이름","episodes":"에피소드","go-to-podcast":"팟캐스트로 이동","mark-as-played":"청취로 표시","delete":"삭제","see-website":"웹사이트 보기","you-dont-have-favorites":"아직 즐겨찾기가 없습니다. 즐겨찾기를 저장하려면 계정을 만드세요. 빠르고 쉽습니다!","create-an-account":"계정 만들기","you-dont-have-podcasts":"아직 팟캐스트 에피소드를 다운로드하지 않았습니다.","to-downaload-episodes":"팟캐스트 에피소드를 녹음하려면 계정을 만드세요. 빠르고 쉽습니다!","premium":{"download-podcasts":"팟캐스트 다운로드 및 오프라인 듣기","go-premium-for":"{var1}에 프리미엄 이용","automatically-play-last-radio":"앱이 실행되는 즉시 마지막 라디오 방송국 또는 마지막으로 들은 팟캐스트를 자동으로 재생합니다.","worlds-best-music-stations":"세계 최고 인기","local-and-worldwide":"지역 및 전 세계 큐레이트 카탈로그(161개국)","scan-qr-code":"이 QR 코드를 스캔하세요","no-ads":"추가된 광고 없음","no-ads-desc":"Radioline에서 추가한 시각 또는 오디오 광고 없음(방송사에서 추가한 광고가 계속 표시될 수 있음)","export-to-playlist-desc":"한 번의 클릭으로 라디오에서 생 방송중인 음악을 재생 목록에 추가(Spotify, Deezer)하세요.","worlds-best":"세계 최고 인기","worlds-best-desc":"17가지 음악 장르로 나누어 세계 최고의 라디오 방송국을 선별했습니다.","hq-stations-desc":"고음질(MP3 - 320Kbps)의 음질을 제공하는 라디오 검색","after-payment-title":"구독을 처리하는 중입니다. 잠시만 기다려 주십시오.","after-payment-support":"구독을 처리하는 데 예상보다 시간이 오래 걸립니다. 문제가 있으면 support@radioline.co로 문의하십시오.","premium":"프리미엄","video-ad-description":"이 동영상 광고를 통해 앱에 무료로 액세스할 수 있습니다"},"back":"반품","auth":{"or":"아니면","save-your-favorites":"즐겨찾기 저장하기","synchronize-your-account":"호환되는 기기로 계정을 동기화하세요","resume-playback":"플레이백 다시 시작","resume-podcasts":"중단한 부분부터 팟캐스트를 다시 시작하고 마지막으로 들은 콘텐츠를 저장합니다.","offline-podcasts":"오프라인 팟캐스트","download-podcasts":"팟캐스트 에피소드를 다운로드하시고 오프라인으로 들으세요","reset-password":"암호를 재설정하세요","login-with-mobile":"내 모바일로 로그인","step-1":"모바일에서 Radioline 앱을 여세요.","step-2":"설정에서 \'장치 추가\' 선택하십시오.","step-3":"화면에 표시된 코드를 입력하세요.","account":"계정","export-to-playlist":"재생 목록으로 내보내기","export-to-playlist-desc":"한 번의 클릭으로 라디오에서 생 방송중인 음악을 재생 목록에 추가(Spotify, Deezer)하세요","sign-out":"로그아웃","reset-password-error":"비밀번호를 재설정할 수 없습니다. 다시 시도해 주세요","email-error":"이메일 주소 필요","reset-password-success":"새 비밀번호가 {email}(으)로 전송되었습니다","instructions":"지침","code-required":"로그인 코드 필요","add-device-meta-description":"Offline access - Radioline","change-my-password":"내 비밀번호 변경","current-password":"현재 비밀번호","new-password":"새 비밀번호","repeat-password":"새 비밀번호를 다시 입력하십시오","password-change":{"success":"비밀번호가 성공적으로 변경되었습니다"},"password-length-validation":"비밀번호는 8~30자 사이여야 합니다.","password-mismatch-validation":"두 개의 서로 다른 비밀번호를 입력했습니다.","password-old-passowrd-match-validation":"새 비밀번호는 이전 비밀번호와 달라야 합니다.","email-exists-error":"이 이메일은 이미 Radioline 계정에서 사용 중입니다."},"delete-account":{"button":"Delete my account","title":"Are you sure you want to delete your Radioline account permanently?","top-text":"By deleting your account, you understand that:","line-1":"Your Premium subscription will be lost and can’t be reused on another account","line-2":"Your favorites will be deleted","line-3":"Your listening progress on podcasts chapters will be lost","line-4":"It will impact all the devices on which this account is used","yes-button":"Yes, I want to delete my account","no-button":"No","confirm":"Are you sure you want to delete your account?","yes":"Yes","login-to-delete":"Log in to delete your account"},"export-to-playlist":"재생 목록으로 내보내기","autoplay":"자동 재생","settings":{"link-account":"내 계정 연결","unlink-account":"내 계정 연결 해제","no-ads":"추가된 광고 없음","no-ads-desc":"Radioline에서 추가한 시각 또는 오디오 광고 없음(방송사에서 추가한 광고가 계속 표시될 수 있음)","my-app":"나의 앱","application-language":"언어 선택","select-application-language":"언어 선택","homepage-country":"홈 화면 국가","install-app":"앱 설치","features":"특징","add-device":"기기 추가","app-version":"앱 버전","export-to-playlist-desc":"한 번의 클릭으로 라디오에서 생 방송중인 음악을 재생 목록에 추가 하세요","connected-to":"와 연결되었습니다.","settings":"설정","meta-description":"Settings page Radioline","deezer-meta-description":"Deezer page Radioline","facebook-meta-description":"Facebook page Radioline","my-account":"내 계정"},"continuity":{"popup-close-btn":"닫기","popup-play-btn":"재생","popup-header":"이전에 다음 곡을 들었습니다 :"},"search-for-stations":"라디오나 팟캐스트를 검색하고 하트 아이콘을 탭하여 여기에 추가하세요.","search-for-a-radio-or-podcast":"라디오 또는 팟캐스트 검색","close":"닫기","an e":"오류가 발생했습니다","fallback":{"error":"오류가 발생했습니다","button":"다시 시도하십시오"},"export":{"select-platform":"음악 플랫폼 선택"},"demo-version":"Demo version","search-for-podcasts":"팟캐스트를 검색하고 다운로드 아이콘을 탭하여 여기에 에피소드를 추가하세요.","playback-error":"이 스트림을 재생할 수 없습니다.","offline":{"save-error-toast":"에피소드 다운로드 실패","remove-success-toast":"삭제된 에피소드","save-success-toast":"다운로드한 에피소드","save-in-progress-toast":"에피소드 다운로드 중","download-episode":"에피소드 다운로드","meta-description":"Offline access Radioline"},"radio":{"visit-website":"웹사이트 방문","radio":"라디오"},"playlsit":{"spotify-success":"Track saved to your spotify radioline playlist","spotify-error":"제목을 인식할 수 없습니다. 제공된 경우 이 라디오의 재생 목록을 참조할 수 있습니다.","deezer-success":"Track saved to your deezer radioline playlist","deezer-error":"제목을 인식할 수 없습니다. 제공된 경우 이 라디오의 재생 목록을 참조할 수 있습니다.","qr-tutorial":{"title":"Radioline 계정을 음악 스트리밍 서비스와 연결하는 방법","step1":"Radioline 모바일 앱을 열거나 당사의 웹사이트(app.radioline.co)로 이동하십시오.","step2":"설정에서 \\"내 계정 연결\\"을 선택하십시오.","step3":"스트리밍 서비스를 선택하고 지침을 따르십시오."}},"favorites":{"no-favotites":"아직 즐겨찾기가 없습니다."},"podcast":"팟캐스트","search-results":{"try-again":"다시 시도하십시오","no-internet":"인터넷에 연결되지 않음","no-results":"검색된 결과가 없습니다"},"network":{"connection-lost":"인터넷 연결이 끊긴 것 같습니다","connection-slow":"인터넷 연결이 느린 것 같습니다. 플래이백 문제가 발생할 수 있습니다","back-online":"인터넷 연결이 복원되었습니다"},"homepage-meta-description":"Radioline - best radio and podcasts","contact-us-success":"지원팀에 문의해 주셔서 감사합니다. 최대한 빨리 답변해 드리겠습니다","meta":{"description":"Radioline - best radios and podcasts"},"http-error":"이 라디오/팟캐스트는 보안상의 이유로 재생하지 않는 것을 선호하는 구식 프로토콜(http)을 사용하여 방송합니다.","old-website":"이전 웹사이트","accept-terms":"계정을 만들면 서비스 약관 및 개인 정보 보호 정책에 동의하는 것입니다."}');
;// CONCATENATED MODULE: ./app/locales/index.ts



















var messages = {
  ar: ar_namespaceObject,
  de: de_namespaceObject,
  en: en_namespaceObject,
  es: es_namespaceObject,
  fr: fr_namespaceObject,
  hi: hi_namespaceObject,
  it: it_namespaceObject,
  ja: ja_namespaceObject,
  nb: nb_namespaceObject,
  nl: nl_namespaceObject,
  pl: pl_namespaceObject,
  "pt-BR": pt_BR_namespaceObject,
  pt: pt_namespaceObject,
  ro: ro_namespaceObject,
  ru: ru_namespaceObject,
  'se': sv_namespaceObject,
  "zh-CN": zh_CN_namespaceObject,
  "zh-TW": zh_TW_namespaceObject,
  ko: ko_namespaceObject
};
// EXTERNAL MODULE: ./app/context/offline.context.tsx
var offline_context = __webpack_require__(85889);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace-all.js
var es_string_replace_all = __webpack_require__(68757);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(35800);
// EXTERNAL MODULE: ./app/components/ui/button.component.tsx
var button_component = __webpack_require__(61947);
// EXTERNAL MODULE: ./app/components/error-fallback/error-fallback.module.scss
var error_fallback_module = __webpack_require__(86291);
var error_fallback_module_default = /*#__PURE__*/__webpack_require__.n(error_fallback_module);
;// CONCATENATED MODULE: ./app/components/error-fallback/error-fallback.component.tsx





var ErrorFallback = function ErrorFallback(_ref) {
  var error = _ref.error,
      resetErrorBoundary = _ref.resetErrorBoundary;
  var t = (0,lang/* useTranslate */.q)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "data-navigate-row": true,
    className: (error_fallback_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      children: t('fallback.error')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* Button */.zx, {
      "data-navigate-item": true,
      onClick: resetErrorBoundary,
      children: t('fallback.button')
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/scroll-behavior-polyfill/dist/index.js
var dist = __webpack_require__(8662);
;// CONCATENATED MODULE: ./app/hooks/vkplay-pause.hook.ts


var useVirtualPlayPauseEvent = function useVirtualPlayPauseEvent(onPlay, onPause, onPlayPause, onStop, enabled) {
  (0,react.useEffect)(function () {
    if (enabled) {
      var eventHandler = function eventHandler(event) {
        if (event.keyCode === keyboard_navigation_hook/* WEBOS_PLAY */.Uy || window["VK_PLAY"] && event.keyCode === window["VK_PLAY"]) {
          onPlay();
        }

        if (event.keyCode === keyboard_navigation_hook/* WEBOS_PAUSE */.b_ || window["VK_PAUSE"] && event.keyCode === window["VK_PAUSE"]) {
          onPause();
        }

        if (window["VK_PLAY_PAUSE"] && event.keyCode === window["VK_PLAY_PAUSE"]) {
          onPlayPause();
        }

        if (window["VK_STOP"] && event.keyCode === window["VK_STOP"]) {
          onStop();
        }
      };

      document.addEventListener("keydown", eventHandler);
      return function () {
        return document.removeEventListener("keydown", eventHandler);
      };
    }
  }, [onPlay, enabled]);
};
// EXTERNAL MODULE: ./node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__(66337);
// EXTERNAL MODULE: ./app/components/ui/portal.tsx + 1 modules
var portal = __webpack_require__(64263);
// EXTERNAL MODULE: ./app/components/previously-played/previously-played.module.scss
var previously_played_module = __webpack_require__(46743);
var previously_played_module_default = /*#__PURE__*/__webpack_require__.n(previously_played_module);
;// CONCATENATED MODULE: ./app/components/previously-played/previously-played.component.tsx


function previously_played_component_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function previously_played_component_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? previously_played_component_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : previously_played_component_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var PreviouslyPlayed = function PreviouslyPlayed() {
  var _previouslyPlaying$me;

  var t = (0,lang/* useTranslate */.q)();

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      previouslyPlaying = _useAppSelector.previouslyPlaying;

  var dispatch = (0,store/* useAppDispatch */.TL)();

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      setPlayerEnabled = _usePlayerContext.setPlayerEnabled;

  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)(!!(previouslyPlaying !== null && previouslyPlaying !== void 0 && previouslyPlaying.media) && !(previouslyPlaying !== null && previouslyPlaying !== void 0 && previouslyPlaying.dismissed));
  return previouslyPlaying !== null && previouslyPlaying !== void 0 && previouslyPlaying.media && !(previouslyPlaying !== null && previouslyPlaying !== void 0 && previouslyPlaying.dismissed) ? /*#__PURE__*/(0,jsx_runtime.jsx)(portal/* Portal */.h, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (previously_played_module_default()).wrapper,
      ref: wrapperRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (previously_played_module_default()).inner,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (previously_played_module_default()).header,
          children: t("continuity.popup-header")
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (previously_played_module_default()).info,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (previously_played_module_default()).category_info,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              className: (previously_played_module_default()).cover,
              src: previouslyPlaying.media.podcast ? previouslyPlaying.media.podcast.podcast.logo : previouslyPlaying.media.category ? (_previouslyPlaying$me = previouslyPlaying.media.category) === null || _previouslyPlaying$me === void 0 ? void 0 : _previouslyPlaying$me.logo : "",
              alt: ""
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (previously_played_module_default()).category_title,
                children: previouslyPlaying.media.podcast ? previouslyPlaying.media.podcast.podcast.name : previouslyPlaying.media.category ? previouslyPlaying.media.category.name : ""
              }), previouslyPlaying.media.podcast && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (previously_played_module_default()).category_subtitle,
                children: previouslyPlaying.media.podcast.podcastChapter.name
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (previously_played_module_default()).buttons,
            "data-navigate-row": true,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              "data-navigate-item": true,
              className: (previously_played_module_default()).button_close,
              onClick: function onClick() {
                dispatch(user/* userActions.setPreviouslyPlaying */.hI.setPreviouslyPlaying(previously_played_component_objectSpread(previously_played_component_objectSpread({}, previouslyPlaying), {}, {
                  dismissed: true
                })));
              },
              children: t("continuity.popup-close-btn")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              "data-navigate-item": true,
              className: (previously_played_module_default()).button_cta,
              onClick: function onClick() {
                var _previouslyPlaying$me2, _previouslyPlaying$me4;

                setPlayerEnabled(true);

                if ((_previouslyPlaying$me2 = previouslyPlaying.media) !== null && _previouslyPlaying$me2 !== void 0 && _previouslyPlaying$me2.category) {
                  var _previouslyPlaying$me3;

                  dispatch(player/* playerActions.setRadioQueue */.i9.setRadioQueue({
                    items: [(_previouslyPlaying$me3 = previouslyPlaying.media) === null || _previouslyPlaying$me3 === void 0 ? void 0 : _previouslyPlaying$me3.category],
                    activeIndex: 0
                  }));
                } else if ((_previouslyPlaying$me4 = previouslyPlaying.media) !== null && _previouslyPlaying$me4 !== void 0 && _previouslyPlaying$me4.podcast) {
                  var _previouslyPlaying$me5;

                  dispatch(player/* playerActions.setPodcastQueue */.i9.setPodcastQueue({
                    items: [(_previouslyPlaying$me5 = previouslyPlaying.media) === null || _previouslyPlaying$me5 === void 0 ? void 0 : _previouslyPlaying$me5.podcast.podcastChapter],
                    activeIndex: 0
                  }));
                }

                dispatch(player/* playerActions.selectTrack */.i9.selectTrack(previouslyPlaying.media));
                dispatch(user/* userActions.setPreviouslyPlaying */.hI.setPreviouslyPlaying(previously_played_component_objectSpread(previously_played_component_objectSpread({}, previouslyPlaying), {}, {
                  dismissed: true
                })));
              },
              children: t("continuity.popup-play-btn")
            })]
          })]
        })]
      })
    })
  }) : null;
};
;// CONCATENATED MODULE: ./app/utils/media-session.ts
var clearMediaSession = function clearMediaSession() {
  try {
    navigator.mediaSession.metadata = null;
    navigator.mediaSession.playbackState = "none";
  } catch (e) {}

  try {
    navigator.mediaSession.setActionHandler("play", null);
  } catch (e) {
    console.error(e);
  }

  try {
    navigator.mediaSession.setActionHandler("pause", null);
  } catch (e) {
    console.error(e);
  }

  try {
    navigator.mediaSession.setActionHandler("seekbackward", null);
  } catch (e) {
    console.error(e);
  }

  try {
    navigator.mediaSession.setActionHandler("seekforward", null);
  } catch (e) {
    console.error(e);
  }

  try {
    navigator.mediaSession.setActionHandler("stop", null);
  } catch (e) {
    console.error(e);
  }

  try {
    navigator.mediaSession.setActionHandler("previoustrack", null);
  } catch (e) {
    console.error(e);
  }

  try {
    navigator.mediaSession.setActionHandler("nexttrack", null);
  } catch (e) {
    console.error(e);
  }

  try {
    navigator.mediaSession.setActionHandler("favorite", null);
    navigator.mediaSession.setActionHandler("shuffle", null);
    navigator.mediaSession.setActionHandler("loopone", null);
    navigator.mediaSession.setActionHandler("loopall", null);
  } catch (e) {}
};
// EXTERNAL MODULE: ./app/context/navigation.context.tsx + 1 modules
var navigation_context = __webpack_require__(85655);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./app/utils/gtag.ts
var GA_TRACKING_ID = "G-3SE4PL8Q3G"; // https://developers.google.com/analytics/devguides/collection/gtagjs/pages

var pageview = function pageview(url) {
  try {
    window.gtag("config", GA_TRACKING_ID, {
      page_path: url
    });
  } catch (_unused) {}
}; // https://developers.google.com/analytics/devguides/collection/gtagjs/events

var gtag_event = function event(_ref) {
  var action = _ref.action,
      category = _ref.category,
      label = _ref.label,
      value = _ref.value;

  try {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value
    });
  } catch (_unused2) {}
};
// EXTERNAL MODULE: ./app/hooks/sticky-state.hook.ts
var sticky_state_hook = __webpack_require__(39428);
// EXTERNAL MODULE: ./app/components/virtual-keyboard/virtual-keyboard.module.scss
var virtual_keyboard_module = __webpack_require__(59992);
var virtual_keyboard_module_default = /*#__PURE__*/__webpack_require__.n(virtual_keyboard_module);
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/arabic.ts
/**
 * Layout: Arabic
 */
/* harmony default export */ var arabic = ({
  layout: {
    default: ["\u0630 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "\u0636 \u0635 \u062B \u0642 \u0641 \u063A \u0639 \u0647 \u062E \u062D \u062C \u062F \\", "\u0634 \u0633 \u064A \u0628 \u0644 \u0627 \u062A \u0646 \u0645 \u0643 \u0637", "{shift} \u0626 \u0621 \u0624 \u0631 \u0644\u0627 \u0649 \u0629 \u0648 \u0632 \u0638 {shift}", ".com @ {space} {enter}"],
    shift: ["\u0651 ! @ # $ % ^ & * ) ( _ + {bksp}", "\u064E \u064B \u064F \u064C \u0644\u0625 \u0625 \u2018 \xF7 \xD7 \u061B < > |", "\u0650 \u064D ] [ \u0644\u0623 \u0623 \u0640 \u060C / : \"", "{shift} ~ \u0652 } { \u0644\u0622 \u0622 \u2019 , . \u061F {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/english.ts
/**
 * Layout: English
 */
/* harmony default export */ var english = ({
  layout: {
    default: ["` 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "q w e r t y u i o p [ ] \\", "a s d f g h j k l ; '", "{shift} z x c v b n m , . / {shift}", ".com @ {space} {enter}"],
    shift: ["~ ! @ # $ % ^ & * ( ) _ + {bksp}", "Q W E R T Y U I O P { } |", 'A S D F G H J K L : "', "{shift} Z X C V B N M < > ? {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/russian.ts
/**
 * Layout: Russian
 */
/* harmony default export */ var russian = ({
  layout: {
    default: ["\u0451 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "\u0439 \u0446 \u0443 \u043A \u0435 \u043D \u0433 \u0448 \u0449 \u0437 \u0445 \u044A \\", "\u0444 \u044B \u0432 \u0430 \u043F \u0440 \u043E \u043B \u0434 \u0436 \u044D", "{shift} / \u044F \u0447 \u0441 \u043C \u0438 \u0442 \u044C \u0431 \u044E . {shift}", ".com @ {space} {enter}"],
    shift: ["\u0401 ! \" \u2116 ; % : ? * ( ) _ + {bksp}", "\u0419 \u0426 \u0423 \u041A \u0415 \u041D \u0413 \u0428 \u0429 \u0417 \u0425 \u042A /", "\u0424 \u042B \u0412 \u0410 \u041F \u0420 \u041E \u041B \u0414 \u0416 \u042D", "{shift} | \u042F \u0427 \u0421 \u041C \u0418 \u0422 \u042C \u0411 \u042E , {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/swedish.ts
/**
 * Layout: Swedish
 * Source: wpressdev (https://github.com/wpressdev)
 */
/* harmony default export */ var swedish = ({
  layout: {
    default: ["\xA7 1 2 3 4 5 6 7 8 9 0 + \xB4 {bksp}", "q w e r t y u i o p \xE5 \xA8", "a s d f g h j k l \xF6 \xE4 '", "{shift} < z x c v b n m , . - {shift}", ".com @ {space} {enter}"],
    shift: ["\xB0 ! \" # $ % & / ( ) = ? ` {bksp}", "Q W E R T Y U I O P \xC5 ^", "A S D F G H J K L \xD6 \xC4 *", "{shift} > Z X C V B N M ; : _ {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/brazilian.ts
/**
 * Layout: Brazilian
 */
/* harmony default export */ var brazilian = ({
  layout: {
    default: ["' 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "q w e r t y u i o p \xB4 [", "a s d f g h j k l \xE7 ~ ]", "{shift} \\ z x c v b n m , . ; / {shift}", ".com @ {space} {enter}"],
    shift: ["\" ! @ # $ % \u0308 & * ( ) _ + {bksp}", "Q W E R T Y U I O P ` {", "A S D F G H J K L \xC7 ^ }", "{shift} | Z X C V B N M < > : ? {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/korean.ts
/**
 * Layout: Korean
 */
/* harmony default export */ var korean = ({
  layout: {
    default: ["` 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "\u1107 \u110C \u1103 \u1100 \u1109 \u116D \u1167 \u1163 \u1162 \u1166 [ ] \\", "\u1106 \u1102 \u110B \u1105 \u1112 \u1169 \u1165 \u1161 \u1175 ; '", "{shift} \u110F \u1110 \u110E \u1111 \u1172 \u116E \u1173 , . / {shift}", ".com @ {space} {enter}"],
    shift: ["~ ! @ # $ % ^ & * ( ) _ + {bksp}", "\u1108 \u110D \u1104 \u1101 \u110A \u116D \u1167 \u1163 \u1164 \u1168 { } |", "\u1106 \u1102 \u110B \u1105 \u1112 \u1169 \u1165 \u1161 \u1175 : \"", "{shift} \u110F \u1110 \u110E \u1111 \u1172 \u116E \u1173 < > ? {shift}", ".com @ {space} {enter}"]
  },
  layoutCandidates: {
    가: "가",
    가ᄀ: "각",
    가ᄁ: "갂",
    가ᄀᄉ: "갃",
    가ᄂ: "간",
    가ᄂᄌ: "갅",
    가ᄂᄒ: "갆",
    가ᄃ: "갇",
    가ᄅ: "갈",
    가ᄅᄀ: "갉",
    가ᄅᄆ: "갊",
    가ᄅᄇ: "갋",
    가ᄅᄉ: "갌",
    가ᄅᄐ: "갍",
    가ᄅᄑ: "갎",
    가ᄅᄒ: "갏",
    가ᄆ: "감",
    가ᄇ: "갑",
    가ᄇᄉ: "값",
    가ᄉ: "갓",
    가ᄊ: "갔",
    가ᄋ: "강",
    가ᄌ: "갖",
    가ᄎ: "갗",
    가ᄏ: "갘",
    가ᄐ: "같",
    가ᄑ: "갚",
    가ᄒ: "갛",
    개: "개",
    개ᄀ: "객",
    개ᄁ: "갞",
    개ᄀᄉ: "갟",
    개ᄂ: "갠",
    개ᄂᄌ: "갡",
    개ᄂᄒ: "갢",
    개ᄃ: "갣",
    개ᄅ: "갤",
    개ᄅᄀ: "갥",
    개ᄅᄆ: "갦",
    개ᄅᄇ: "갧",
    개ᄅᄉ: "갨",
    개ᄅᄐ: "갩",
    개ᄅᄑ: "갪",
    개ᄅᄒ: "갫",
    개ᄆ: "갬",
    개ᄇ: "갭",
    개ᄇᄉ: "갮",
    개ᄉ: "갯",
    개ᄊ: "갰",
    개ᄋ: "갱",
    개ᄌ: "갲",
    개ᄎ: "갳",
    개ᄏ: "갴",
    개ᄐ: "갵",
    개ᄑ: "갶",
    개ᄒ: "갷",
    갸: "갸",
    갸ᄀ: "갹",
    갸ᄁ: "갺",
    갸ᄀᄉ: "갻",
    갸ᄂ: "갼",
    갸ᄂᄌ: "갽",
    갸ᄂᄒ: "갾",
    갸ᄃ: "갿",
    갸ᄅ: "걀",
    갸ᄅᄀ: "걁",
    갸ᄅᄆ: "걂",
    갸ᄅᄇ: "걃",
    갸ᄅᄉ: "걄",
    갸ᄅᄐ: "걅",
    갸ᄅᄑ: "걆",
    갸ᄅᄒ: "걇",
    갸ᄆ: "걈",
    갸ᄇ: "걉",
    갸ᄇᄉ: "걊",
    갸ᄉ: "걋",
    갸ᄊ: "걌",
    갸ᄋ: "걍",
    갸ᄌ: "걎",
    갸ᄎ: "걏",
    갸ᄏ: "걐",
    갸ᄐ: "걑",
    갸ᄑ: "걒",
    갸ᄒ: "걓",
    걔: "걔",
    걔ᄀ: "걕",
    걔ᄁ: "걖",
    걔ᄀᄉ: "걗",
    걔ᄂ: "걘",
    걔ᄂᄌ: "걙",
    걔ᄂᄒ: "걚",
    걔ᄃ: "걛",
    걔ᄅ: "걜",
    걔ᄅᄀ: "걝",
    걔ᄅᄆ: "걞",
    걔ᄅᄇ: "걟",
    걔ᄅᄉ: "걠",
    걔ᄅᄐ: "걡",
    걔ᄅᄑ: "걢",
    걔ᄅᄒ: "걣",
    걔ᄆ: "걤",
    걔ᄇ: "걥",
    걔ᄇᄉ: "걦",
    걔ᄉ: "걧",
    걔ᄊ: "걨",
    걔ᄋ: "걩",
    걔ᄌ: "걪",
    걔ᄎ: "걫",
    걔ᄏ: "걬",
    걔ᄐ: "걭",
    걔ᄑ: "걮",
    걔ᄒ: "걯",
    거: "거",
    거ᄀ: "걱",
    거ᄁ: "걲",
    거ᄀᄉ: "걳",
    거ᄂ: "건",
    거ᄂᄌ: "걵",
    거ᄂᄒ: "걶",
    거ᄃ: "걷",
    거ᄅ: "걸",
    거ᄅᄀ: "걹",
    거ᄅᄆ: "걺",
    거ᄅᄇ: "걻",
    거ᄅᄉ: "걼",
    거ᄅᄐ: "걽",
    거ᄅᄑ: "걾",
    거ᄅᄒ: "걿",
    거ᄆ: "검",
    거ᄇ: "겁",
    거ᄇᄉ: "겂",
    거ᄉ: "것",
    거ᄊ: "겄",
    거ᄋ: "겅",
    거ᄌ: "겆",
    거ᄎ: "겇",
    거ᄏ: "겈",
    거ᄐ: "겉",
    거ᄑ: "겊",
    거ᄒ: "겋",
    게: "게",
    게ᄀ: "겍",
    게ᄁ: "겎",
    게ᄀᄉ: "겏",
    게ᄂ: "겐",
    게ᄂᄌ: "겑",
    게ᄂᄒ: "겒",
    게ᄃ: "겓",
    게ᄅ: "겔",
    게ᄅᄀ: "겕",
    게ᄅᄆ: "겖",
    게ᄅᄇ: "겗",
    게ᄅᄉ: "겘",
    게ᄅᄐ: "겙",
    게ᄅᄑ: "겚",
    게ᄅᄒ: "겛",
    게ᄆ: "겜",
    게ᄇ: "겝",
    게ᄇᄉ: "겞",
    게ᄉ: "겟",
    게ᄊ: "겠",
    게ᄋ: "겡",
    게ᄌ: "겢",
    게ᄎ: "겣",
    게ᄏ: "겤",
    게ᄐ: "겥",
    게ᄑ: "겦",
    게ᄒ: "겧",
    겨: "겨",
    겨ᄀ: "격",
    겨ᄁ: "겪",
    겨ᄀᄉ: "겫",
    겨ᄂ: "견",
    겨ᄂᄌ: "겭",
    겨ᄂᄒ: "겮",
    겨ᄃ: "겯",
    겨ᄅ: "결",
    겨ᄅᄀ: "겱",
    겨ᄅᄆ: "겲",
    겨ᄅᄇ: "겳",
    겨ᄅᄉ: "겴",
    겨ᄅᄐ: "겵",
    겨ᄅᄑ: "겶",
    겨ᄅᄒ: "겷",
    겨ᄆ: "겸",
    겨ᄇ: "겹",
    겨ᄇᄉ: "겺",
    겨ᄉ: "겻",
    겨ᄊ: "겼",
    겨ᄋ: "경",
    겨ᄌ: "겾",
    겨ᄎ: "겿",
    겨ᄏ: "곀",
    겨ᄐ: "곁",
    겨ᄑ: "곂",
    겨ᄒ: "곃",
    계: "계",
    계ᄀ: "곅",
    계ᄁ: "곆",
    계ᄀᄉ: "곇",
    계ᄂ: "곈",
    계ᄂᄌ: "곉",
    계ᄂᄒ: "곊",
    계ᄃ: "곋",
    계ᄅ: "곌",
    계ᄅᄀ: "곍",
    계ᄅᄆ: "곎",
    계ᄅᄇ: "곏",
    계ᄅᄉ: "곐",
    계ᄅᄐ: "곑",
    계ᄅᄑ: "곒",
    계ᄅᄒ: "곓",
    계ᄆ: "곔",
    계ᄇ: "곕",
    계ᄇᄉ: "곖",
    계ᄉ: "곗",
    계ᄊ: "곘",
    계ᄋ: "곙",
    계ᄌ: "곚",
    계ᄎ: "곛",
    계ᄏ: "곜",
    계ᄐ: "곝",
    계ᄑ: "곞",
    계ᄒ: "곟",
    고: "고",
    고ᄀ: "곡",
    고ᄁ: "곢",
    고ᄀᄉ: "곣",
    고ᄂ: "곤",
    고ᄂᄌ: "곥",
    고ᄂᄒ: "곦",
    고ᄃ: "곧",
    고ᄅ: "골",
    고ᄅᄀ: "곩",
    고ᄅᄆ: "곪",
    고ᄅᄇ: "곫",
    고ᄅᄉ: "곬",
    고ᄅᄐ: "곭",
    고ᄅᄑ: "곮",
    고ᄅᄒ: "곯",
    고ᄆ: "곰",
    고ᄇ: "곱",
    고ᄇᄉ: "곲",
    고ᄉ: "곳",
    고ᄊ: "곴",
    고ᄋ: "공",
    고ᄌ: "곶",
    고ᄎ: "곷",
    고ᄏ: "곸",
    고ᄐ: "곹",
    고ᄑ: "곺",
    고ᄒ: "곻",
    고ᅡ: "과",
    고ᅡᄀ: "곽",
    고ᅡᄁ: "곾",
    고ᅡᄀᄉ: "곿",
    고ᅡᄂ: "관",
    고ᅡᄂᄌ: "괁",
    고ᅡᄂᄒ: "괂",
    고ᅡᄃ: "괃",
    고ᅡᄅ: "괄",
    고ᅡᄅᄀ: "괅",
    고ᅡᄅᄆ: "괆",
    고ᅡᄅᄇ: "괇",
    고ᅡᄅᄉ: "괈",
    고ᅡᄅᄐ: "괉",
    고ᅡᄅᄑ: "괊",
    고ᅡᄅᄒ: "괋",
    고ᅡᄆ: "괌",
    고ᅡᄇ: "괍",
    고ᅡᄇᄉ: "괎",
    고ᅡᄉ: "괏",
    고ᅡᄊ: "괐",
    고ᅡᄋ: "광",
    고ᅡᄌ: "괒",
    고ᅡᄎ: "괓",
    고ᅡᄏ: "괔",
    고ᅡᄐ: "괕",
    고ᅡᄑ: "괖",
    고ᅡᄒ: "괗",
    고ᅢ: "괘",
    고ᅢᄀ: "괙",
    고ᅢᄁ: "괚",
    고ᅢᄀᄉ: "괛",
    고ᅢᄂ: "괜",
    고ᅢᄂᄌ: "괝",
    고ᅢᄂᄒ: "괞",
    고ᅢᄃ: "괟",
    고ᅢᄅ: "괠",
    고ᅢᄅᄀ: "괡",
    고ᅢᄅᄆ: "괢",
    고ᅢᄅᄇ: "괣",
    고ᅢᄅᄉ: "괤",
    고ᅢᄅᄐ: "괥",
    고ᅢᄅᄑ: "괦",
    고ᅢᄅᄒ: "괧",
    고ᅢᄆ: "괨",
    고ᅢᄇ: "괩",
    고ᅢᄇᄉ: "괪",
    고ᅢᄉ: "괫",
    고ᅢᄊ: "괬",
    고ᅢᄋ: "괭",
    고ᅢᄌ: "괮",
    고ᅢᄎ: "괯",
    고ᅢᄏ: "괰",
    고ᅢᄐ: "괱",
    고ᅢᄑ: "괲",
    고ᅢᄒ: "괳",
    고ᅵ: "괴",
    고ᅵᄀ: "괵",
    고ᅵᄁ: "괶",
    고ᅵᄀᄉ: "괷",
    고ᅵᄂ: "괸",
    고ᅵᄂᄌ: "괹",
    고ᅵᄂᄒ: "괺",
    고ᅵᄃ: "괻",
    고ᅵᄅ: "괼",
    고ᅵᄅᄀ: "괽",
    고ᅵᄅᄆ: "괾",
    고ᅵᄅᄇ: "괿",
    고ᅵᄅᄉ: "굀",
    고ᅵᄅᄐ: "굁",
    고ᅵᄅᄑ: "굂",
    고ᅵᄅᄒ: "굃",
    고ᅵᄆ: "굄",
    고ᅵᄇ: "굅",
    고ᅵᄇᄉ: "굆",
    고ᅵᄉ: "굇",
    고ᅵᄊ: "굈",
    고ᅵᄋ: "굉",
    고ᅵᄌ: "굊",
    고ᅵᄎ: "굋",
    고ᅵᄏ: "굌",
    고ᅵᄐ: "굍",
    고ᅵᄑ: "굎",
    고ᅵᄒ: "굏",
    교: "교",
    교ᄀ: "굑",
    교ᄁ: "굒",
    교ᄀᄉ: "굓",
    교ᄂ: "굔",
    교ᄂᄌ: "굕",
    교ᄂᄒ: "굖",
    교ᄃ: "굗",
    교ᄅ: "굘",
    교ᄅᄀ: "굙",
    교ᄅᄆ: "굚",
    교ᄅᄇ: "굛",
    교ᄅᄉ: "굜",
    교ᄅᄐ: "굝",
    교ᄅᄑ: "굞",
    교ᄅᄒ: "굟",
    교ᄆ: "굠",
    교ᄇ: "굡",
    교ᄇᄉ: "굢",
    교ᄉ: "굣",
    교ᄊ: "굤",
    교ᄋ: "굥",
    교ᄌ: "굦",
    교ᄎ: "굧",
    교ᄏ: "굨",
    교ᄐ: "굩",
    교ᄑ: "굪",
    교ᄒ: "굫",
    구: "구",
    구ᄀ: "국",
    구ᄁ: "굮",
    구ᄀᄉ: "굯",
    구ᄂ: "군",
    구ᄂᄌ: "굱",
    구ᄂᄒ: "굲",
    구ᄃ: "굳",
    구ᄅ: "굴",
    구ᄅᄀ: "굵",
    구ᄅᄆ: "굶",
    구ᄅᄇ: "굷",
    구ᄅᄉ: "굸",
    구ᄅᄐ: "굹",
    구ᄅᄑ: "굺",
    구ᄅᄒ: "굻",
    구ᄆ: "굼",
    구ᄇ: "굽",
    구ᄇᄉ: "굾",
    구ᄉ: "굿",
    구ᄊ: "궀",
    구ᄋ: "궁",
    구ᄌ: "궂",
    구ᄎ: "궃",
    구ᄏ: "궄",
    구ᄐ: "궅",
    구ᄑ: "궆",
    구ᄒ: "궇",
    구ᅥ: "궈",
    구ᅥᄀ: "궉",
    구ᅥᄁ: "궊",
    구ᅥᄀᄉ: "궋",
    구ᅥᄂ: "권",
    구ᅥᄂᄌ: "궍",
    구ᅥᄂᄒ: "궎",
    구ᅥᄃ: "궏",
    구ᅥᄅ: "궐",
    구ᅥᄅᄀ: "궑",
    구ᅥᄅᄆ: "궒",
    구ᅥᄅᄇ: "궓",
    구ᅥᄅᄉ: "궔",
    구ᅥᄅᄐ: "궕",
    구ᅥᄅᄑ: "궖",
    구ᅥᄅᄒ: "궗",
    구ᅥᄆ: "궘",
    구ᅥᄇ: "궙",
    구ᅥᄇᄉ: "궚",
    구ᅥᄉ: "궛",
    구ᅥᄊ: "궜",
    구ᅥᄋ: "궝",
    구ᅥᄌ: "궞",
    구ᅥᄎ: "궟",
    구ᅥᄏ: "궠",
    구ᅥᄐ: "궡",
    구ᅥᄑ: "궢",
    구ᅥᄒ: "궣",
    구ᅦ: "궤",
    구ᅦᄀ: "궥",
    구ᅦᄁ: "궦",
    구ᅦᄀᄉ: "궧",
    구ᅦᄂ: "궨",
    구ᅦᄂᄌ: "궩",
    구ᅦᄂᄒ: "궪",
    구ᅦᄃ: "궫",
    구ᅦᄅ: "궬",
    구ᅦᄅᄀ: "궭",
    구ᅦᄅᄆ: "궮",
    구ᅦᄅᄇ: "궯",
    구ᅦᄅᄉ: "궰",
    구ᅦᄅᄐ: "궱",
    구ᅦᄅᄑ: "궲",
    구ᅦᄅᄒ: "궳",
    구ᅦᄆ: "궴",
    구ᅦᄇ: "궵",
    구ᅦᄇᄉ: "궶",
    구ᅦᄉ: "궷",
    구ᅦᄊ: "궸",
    구ᅦᄋ: "궹",
    구ᅦᄌ: "궺",
    구ᅦᄎ: "궻",
    구ᅦᄏ: "궼",
    구ᅦᄐ: "궽",
    구ᅦᄑ: "궾",
    구ᅦᄒ: "궿",
    구ᅵ: "귀",
    구ᅵᄀ: "귁",
    구ᅵᄁ: "귂",
    구ᅵᄀᄉ: "귃",
    구ᅵᄂ: "귄",
    구ᅵᄂᄌ: "귅",
    구ᅵᄂᄒ: "귆",
    구ᅵᄃ: "귇",
    구ᅵᄅ: "귈",
    구ᅵᄅᄀ: "귉",
    구ᅵᄅᄆ: "귊",
    구ᅵᄅᄇ: "귋",
    구ᅵᄅᄉ: "귌",
    구ᅵᄅᄐ: "귍",
    구ᅵᄅᄑ: "귎",
    구ᅵᄅᄒ: "귏",
    구ᅵᄆ: "귐",
    구ᅵᄇ: "귑",
    구ᅵᄇᄉ: "귒",
    구ᅵᄉ: "귓",
    구ᅵᄊ: "귔",
    구ᅵᄋ: "귕",
    구ᅵᄌ: "귖",
    구ᅵᄎ: "귗",
    구ᅵᄏ: "귘",
    구ᅵᄐ: "귙",
    구ᅵᄑ: "귚",
    구ᅵᄒ: "귛",
    규: "규",
    규ᄀ: "귝",
    규ᄁ: "귞",
    규ᄀᄉ: "귟",
    규ᄂ: "균",
    규ᄂᄌ: "귡",
    규ᄂᄒ: "귢",
    규ᄃ: "귣",
    규ᄅ: "귤",
    규ᄅᄀ: "귥",
    규ᄅᄆ: "귦",
    규ᄅᄇ: "귧",
    규ᄅᄉ: "귨",
    규ᄅᄐ: "귩",
    규ᄅᄑ: "귪",
    규ᄅᄒ: "귫",
    규ᄆ: "귬",
    규ᄇ: "귭",
    규ᄇᄉ: "귮",
    규ᄉ: "귯",
    규ᄊ: "귰",
    규ᄋ: "귱",
    규ᄌ: "귲",
    규ᄎ: "귳",
    규ᄏ: "귴",
    규ᄐ: "귵",
    규ᄑ: "귶",
    규ᄒ: "귷",
    그: "그",
    그ᄀ: "극",
    그ᄁ: "귺",
    그ᄀᄉ: "귻",
    그ᄂ: "근",
    그ᄂᄌ: "귽",
    그ᄂᄒ: "귾",
    그ᄃ: "귿",
    그ᄅ: "글",
    그ᄅᄀ: "긁",
    그ᄅᄆ: "긂",
    그ᄅᄇ: "긃",
    그ᄅᄉ: "긄",
    그ᄅᄐ: "긅",
    그ᄅᄑ: "긆",
    그ᄅᄒ: "긇",
    그ᄆ: "금",
    그ᄇ: "급",
    그ᄇᄉ: "긊",
    그ᄉ: "긋",
    그ᄊ: "긌",
    그ᄋ: "긍",
    그ᄌ: "긎",
    그ᄎ: "긏",
    그ᄏ: "긐",
    그ᄐ: "긑",
    그ᄑ: "긒",
    그ᄒ: "긓",
    그ᅵ: "긔",
    그ᅵᄀ: "긕",
    그ᅵᄁ: "긖",
    그ᅵᄀᄉ: "긗",
    그ᅵᄂ: "긘",
    그ᅵᄂᄌ: "긙",
    그ᅵᄂᄒ: "긚",
    그ᅵᄃ: "긛",
    그ᅵᄅ: "긜",
    그ᅵᄅᄀ: "긝",
    그ᅵᄅᄆ: "긞",
    그ᅵᄅᄇ: "긟",
    그ᅵᄅᄉ: "긠",
    그ᅵᄅᄐ: "긡",
    그ᅵᄅᄑ: "긢",
    그ᅵᄅᄒ: "긣",
    그ᅵᄆ: "긤",
    그ᅵᄇ: "긥",
    그ᅵᄇᄉ: "긦",
    그ᅵᄉ: "긧",
    그ᅵᄊ: "긨",
    그ᅵᄋ: "긩",
    그ᅵᄌ: "긪",
    그ᅵᄎ: "긫",
    그ᅵᄏ: "긬",
    그ᅵᄐ: "긭",
    그ᅵᄑ: "긮",
    그ᅵᄒ: "긯",
    기: "기",
    기ᄀ: "긱",
    기ᄁ: "긲",
    기ᄀᄉ: "긳",
    기ᄂ: "긴",
    기ᄂᄌ: "긵",
    기ᄂᄒ: "긶",
    기ᄃ: "긷",
    기ᄅ: "길",
    기ᄅᄀ: "긹",
    기ᄅᄆ: "긺",
    기ᄅᄇ: "긻",
    기ᄅᄉ: "긼",
    기ᄅᄐ: "긽",
    기ᄅᄑ: "긾",
    기ᄅᄒ: "긿",
    기ᄆ: "김",
    기ᄇ: "깁",
    기ᄇᄉ: "깂",
    기ᄉ: "깃",
    기ᄊ: "깄",
    기ᄋ: "깅",
    기ᄌ: "깆",
    기ᄎ: "깇",
    기ᄏ: "깈",
    기ᄐ: "깉",
    기ᄑ: "깊",
    기ᄒ: "깋",
    까: "까",
    까ᄀ: "깍",
    까ᄁ: "깎",
    까ᄀᄉ: "깏",
    까ᄂ: "깐",
    까ᄂᄌ: "깑",
    까ᄂᄒ: "깒",
    까ᄃ: "깓",
    까ᄅ: "깔",
    까ᄅᄀ: "깕",
    까ᄅᄆ: "깖",
    까ᄅᄇ: "깗",
    까ᄅᄉ: "깘",
    까ᄅᄐ: "깙",
    까ᄅᄑ: "깚",
    까ᄅᄒ: "깛",
    까ᄆ: "깜",
    까ᄇ: "깝",
    까ᄇᄉ: "깞",
    까ᄉ: "깟",
    까ᄊ: "깠",
    까ᄋ: "깡",
    까ᄌ: "깢",
    까ᄎ: "깣",
    까ᄏ: "깤",
    까ᄐ: "깥",
    까ᄑ: "깦",
    까ᄒ: "깧",
    깨: "깨",
    깨ᄀ: "깩",
    깨ᄁ: "깪",
    깨ᄀᄉ: "깫",
    깨ᄂ: "깬",
    깨ᄂᄌ: "깭",
    깨ᄂᄒ: "깮",
    깨ᄃ: "깯",
    깨ᄅ: "깰",
    깨ᄅᄀ: "깱",
    깨ᄅᄆ: "깲",
    깨ᄅᄇ: "깳",
    깨ᄅᄉ: "깴",
    깨ᄅᄐ: "깵",
    깨ᄅᄑ: "깶",
    깨ᄅᄒ: "깷",
    깨ᄆ: "깸",
    깨ᄇ: "깹",
    깨ᄇᄉ: "깺",
    깨ᄉ: "깻",
    깨ᄊ: "깼",
    깨ᄋ: "깽",
    깨ᄌ: "깾",
    깨ᄎ: "깿",
    깨ᄏ: "꺀",
    깨ᄐ: "꺁",
    깨ᄑ: "꺂",
    깨ᄒ: "꺃",
    꺄: "꺄",
    꺄ᄀ: "꺅",
    꺄ᄁ: "꺆",
    꺄ᄀᄉ: "꺇",
    꺄ᄂ: "꺈",
    꺄ᄂᄌ: "꺉",
    꺄ᄂᄒ: "꺊",
    꺄ᄃ: "꺋",
    꺄ᄅ: "꺌",
    꺄ᄅᄀ: "꺍",
    꺄ᄅᄆ: "꺎",
    꺄ᄅᄇ: "꺏",
    꺄ᄅᄉ: "꺐",
    꺄ᄅᄐ: "꺑",
    꺄ᄅᄑ: "꺒",
    꺄ᄅᄒ: "꺓",
    꺄ᄆ: "꺔",
    꺄ᄇ: "꺕",
    꺄ᄇᄉ: "꺖",
    꺄ᄉ: "꺗",
    꺄ᄊ: "꺘",
    꺄ᄋ: "꺙",
    꺄ᄌ: "꺚",
    꺄ᄎ: "꺛",
    꺄ᄏ: "꺜",
    꺄ᄐ: "꺝",
    꺄ᄑ: "꺞",
    꺄ᄒ: "꺟",
    꺠: "꺠",
    꺠ᄀ: "꺡",
    꺠ᄁ: "꺢",
    꺠ᄀᄉ: "꺣",
    꺠ᄂ: "꺤",
    꺠ᄂᄌ: "꺥",
    꺠ᄂᄒ: "꺦",
    꺠ᄃ: "꺧",
    꺠ᄅ: "꺨",
    꺠ᄅᄀ: "꺩",
    꺠ᄅᄆ: "꺪",
    꺠ᄅᄇ: "꺫",
    꺠ᄅᄉ: "꺬",
    꺠ᄅᄐ: "꺭",
    꺠ᄅᄑ: "꺮",
    꺠ᄅᄒ: "꺯",
    꺠ᄆ: "꺰",
    꺠ᄇ: "꺱",
    꺠ᄇᄉ: "꺲",
    꺠ᄉ: "꺳",
    꺠ᄊ: "꺴",
    꺠ᄋ: "꺵",
    꺠ᄌ: "꺶",
    꺠ᄎ: "꺷",
    꺠ᄏ: "꺸",
    꺠ᄐ: "꺹",
    꺠ᄑ: "꺺",
    꺠ᄒ: "꺻",
    꺼: "꺼",
    꺼ᄀ: "꺽",
    꺼ᄁ: "꺾",
    꺼ᄀᄉ: "꺿",
    꺼ᄂ: "껀",
    꺼ᄂᄌ: "껁",
    꺼ᄂᄒ: "껂",
    꺼ᄃ: "껃",
    꺼ᄅ: "껄",
    꺼ᄅᄀ: "껅",
    꺼ᄅᄆ: "껆",
    꺼ᄅᄇ: "껇",
    꺼ᄅᄉ: "껈",
    꺼ᄅᄐ: "껉",
    꺼ᄅᄑ: "껊",
    꺼ᄅᄒ: "껋",
    꺼ᄆ: "껌",
    꺼ᄇ: "껍",
    꺼ᄇᄉ: "껎",
    꺼ᄉ: "껏",
    꺼ᄊ: "껐",
    꺼ᄋ: "껑",
    꺼ᄌ: "껒",
    꺼ᄎ: "껓",
    꺼ᄏ: "껔",
    꺼ᄐ: "껕",
    꺼ᄑ: "껖",
    꺼ᄒ: "껗",
    께: "께",
    께ᄀ: "껙",
    께ᄁ: "껚",
    께ᄀᄉ: "껛",
    께ᄂ: "껜",
    께ᄂᄌ: "껝",
    께ᄂᄒ: "껞",
    께ᄃ: "껟",
    께ᄅ: "껠",
    께ᄅᄀ: "껡",
    께ᄅᄆ: "껢",
    께ᄅᄇ: "껣",
    께ᄅᄉ: "껤",
    께ᄅᄐ: "껥",
    께ᄅᄑ: "껦",
    께ᄅᄒ: "껧",
    께ᄆ: "껨",
    께ᄇ: "껩",
    께ᄇᄉ: "껪",
    께ᄉ: "껫",
    께ᄊ: "껬",
    께ᄋ: "껭",
    께ᄌ: "껮",
    께ᄎ: "껯",
    께ᄏ: "껰",
    께ᄐ: "껱",
    께ᄑ: "껲",
    께ᄒ: "껳",
    껴: "껴",
    껴ᄀ: "껵",
    껴ᄁ: "껶",
    껴ᄀᄉ: "껷",
    껴ᄂ: "껸",
    껴ᄂᄌ: "껹",
    껴ᄂᄒ: "껺",
    껴ᄃ: "껻",
    껴ᄅ: "껼",
    껴ᄅᄀ: "껽",
    껴ᄅᄆ: "껾",
    껴ᄅᄇ: "껿",
    껴ᄅᄉ: "꼀",
    껴ᄅᄐ: "꼁",
    껴ᄅᄑ: "꼂",
    껴ᄅᄒ: "꼃",
    껴ᄆ: "꼄",
    껴ᄇ: "꼅",
    껴ᄇᄉ: "꼆",
    껴ᄉ: "꼇",
    껴ᄊ: "꼈",
    껴ᄋ: "꼉",
    껴ᄌ: "꼊",
    껴ᄎ: "꼋",
    껴ᄏ: "꼌",
    껴ᄐ: "꼍",
    껴ᄑ: "꼎",
    껴ᄒ: "꼏",
    꼐: "꼐",
    꼐ᄀ: "꼑",
    꼐ᄁ: "꼒",
    꼐ᄀᄉ: "꼓",
    꼐ᄂ: "꼔",
    꼐ᄂᄌ: "꼕",
    꼐ᄂᄒ: "꼖",
    꼐ᄃ: "꼗",
    꼐ᄅ: "꼘",
    꼐ᄅᄀ: "꼙",
    꼐ᄅᄆ: "꼚",
    꼐ᄅᄇ: "꼛",
    꼐ᄅᄉ: "꼜",
    꼐ᄅᄐ: "꼝",
    꼐ᄅᄑ: "꼞",
    꼐ᄅᄒ: "꼟",
    꼐ᄆ: "꼠",
    꼐ᄇ: "꼡",
    꼐ᄇᄉ: "꼢",
    꼐ᄉ: "꼣",
    꼐ᄊ: "꼤",
    꼐ᄋ: "꼥",
    꼐ᄌ: "꼦",
    꼐ᄎ: "꼧",
    꼐ᄏ: "꼨",
    꼐ᄐ: "꼩",
    꼐ᄑ: "꼪",
    꼐ᄒ: "꼫",
    꼬: "꼬",
    꼬ᄀ: "꼭",
    꼬ᄁ: "꼮",
    꼬ᄀᄉ: "꼯",
    꼬ᄂ: "꼰",
    꼬ᄂᄌ: "꼱",
    꼬ᄂᄒ: "꼲",
    꼬ᄃ: "꼳",
    꼬ᄅ: "꼴",
    꼬ᄅᄀ: "꼵",
    꼬ᄅᄆ: "꼶",
    꼬ᄅᄇ: "꼷",
    꼬ᄅᄉ: "꼸",
    꼬ᄅᄐ: "꼹",
    꼬ᄅᄑ: "꼺",
    꼬ᄅᄒ: "꼻",
    꼬ᄆ: "꼼",
    꼬ᄇ: "꼽",
    꼬ᄇᄉ: "꼾",
    꼬ᄉ: "꼿",
    꼬ᄊ: "꽀",
    꼬ᄋ: "꽁",
    꼬ᄌ: "꽂",
    꼬ᄎ: "꽃",
    꼬ᄏ: "꽄",
    꼬ᄐ: "꽅",
    꼬ᄑ: "꽆",
    꼬ᄒ: "꽇",
    꼬ᅡ: "꽈",
    꼬ᅡᄀ: "꽉",
    꼬ᅡᄁ: "꽊",
    꼬ᅡᄀᄉ: "꽋",
    꼬ᅡᄂ: "꽌",
    꼬ᅡᄂᄌ: "꽍",
    꼬ᅡᄂᄒ: "꽎",
    꼬ᅡᄃ: "꽏",
    꼬ᅡᄅ: "꽐",
    꼬ᅡᄅᄀ: "꽑",
    꼬ᅡᄅᄆ: "꽒",
    꼬ᅡᄅᄇ: "꽓",
    꼬ᅡᄅᄉ: "꽔",
    꼬ᅡᄅᄐ: "꽕",
    꼬ᅡᄅᄑ: "꽖",
    꼬ᅡᄅᄒ: "꽗",
    꼬ᅡᄆ: "꽘",
    꼬ᅡᄇ: "꽙",
    꼬ᅡᄇᄉ: "꽚",
    꼬ᅡᄉ: "꽛",
    꼬ᅡᄊ: "꽜",
    꼬ᅡᄋ: "꽝",
    꼬ᅡᄌ: "꽞",
    꼬ᅡᄎ: "꽟",
    꼬ᅡᄏ: "꽠",
    꼬ᅡᄐ: "꽡",
    꼬ᅡᄑ: "꽢",
    꼬ᅡᄒ: "꽣",
    꼬ᅢ: "꽤",
    꼬ᅢᄀ: "꽥",
    꼬ᅢᄁ: "꽦",
    꼬ᅢᄀᄉ: "꽧",
    꼬ᅢᄂ: "꽨",
    꼬ᅢᄂᄌ: "꽩",
    꼬ᅢᄂᄒ: "꽪",
    꼬ᅢᄃ: "꽫",
    꼬ᅢᄅ: "꽬",
    꼬ᅢᄅᄀ: "꽭",
    꼬ᅢᄅᄆ: "꽮",
    꼬ᅢᄅᄇ: "꽯",
    꼬ᅢᄅᄉ: "꽰",
    꼬ᅢᄅᄐ: "꽱",
    꼬ᅢᄅᄑ: "꽲",
    꼬ᅢᄅᄒ: "꽳",
    꼬ᅢᄆ: "꽴",
    꼬ᅢᄇ: "꽵",
    꼬ᅢᄇᄉ: "꽶",
    꼬ᅢᄉ: "꽷",
    꼬ᅢᄊ: "꽸",
    꼬ᅢᄋ: "꽹",
    꼬ᅢᄌ: "꽺",
    꼬ᅢᄎ: "꽻",
    꼬ᅢᄏ: "꽼",
    꼬ᅢᄐ: "꽽",
    꼬ᅢᄑ: "꽾",
    꼬ᅢᄒ: "꽿",
    꼬ᅵ: "꾀",
    꼬ᅵᄀ: "꾁",
    꼬ᅵᄁ: "꾂",
    꼬ᅵᄀᄉ: "꾃",
    꼬ᅵᄂ: "꾄",
    꼬ᅵᄂᄌ: "꾅",
    꼬ᅵᄂᄒ: "꾆",
    꼬ᅵᄃ: "꾇",
    꼬ᅵᄅ: "꾈",
    꼬ᅵᄅᄀ: "꾉",
    꼬ᅵᄅᄆ: "꾊",
    꼬ᅵᄅᄇ: "꾋",
    꼬ᅵᄅᄉ: "꾌",
    꼬ᅵᄅᄐ: "꾍",
    꼬ᅵᄅᄑ: "꾎",
    꼬ᅵᄅᄒ: "꾏",
    꼬ᅵᄆ: "꾐",
    꼬ᅵᄇ: "꾑",
    꼬ᅵᄇᄉ: "꾒",
    꼬ᅵᄉ: "꾓",
    꼬ᅵᄊ: "꾔",
    꼬ᅵᄋ: "꾕",
    꼬ᅵᄌ: "꾖",
    꼬ᅵᄎ: "꾗",
    꼬ᅵᄏ: "꾘",
    꼬ᅵᄐ: "꾙",
    꼬ᅵᄑ: "꾚",
    꼬ᅵᄒ: "꾛",
    꾜: "꾜",
    꾜ᄀ: "꾝",
    꾜ᄁ: "꾞",
    꾜ᄀᄉ: "꾟",
    꾜ᄂ: "꾠",
    꾜ᄂᄌ: "꾡",
    꾜ᄂᄒ: "꾢",
    꾜ᄃ: "꾣",
    꾜ᄅ: "꾤",
    꾜ᄅᄀ: "꾥",
    꾜ᄅᄆ: "꾦",
    꾜ᄅᄇ: "꾧",
    꾜ᄅᄉ: "꾨",
    꾜ᄅᄐ: "꾩",
    꾜ᄅᄑ: "꾪",
    꾜ᄅᄒ: "꾫",
    꾜ᄆ: "꾬",
    꾜ᄇ: "꾭",
    꾜ᄇᄉ: "꾮",
    꾜ᄉ: "꾯",
    꾜ᄊ: "꾰",
    꾜ᄋ: "꾱",
    꾜ᄌ: "꾲",
    꾜ᄎ: "꾳",
    꾜ᄏ: "꾴",
    꾜ᄐ: "꾵",
    꾜ᄑ: "꾶",
    꾜ᄒ: "꾷",
    꾸: "꾸",
    꾸ᄀ: "꾹",
    꾸ᄁ: "꾺",
    꾸ᄀᄉ: "꾻",
    꾸ᄂ: "꾼",
    꾸ᄂᄌ: "꾽",
    꾸ᄂᄒ: "꾾",
    꾸ᄃ: "꾿",
    꾸ᄅ: "꿀",
    꾸ᄅᄀ: "꿁",
    꾸ᄅᄆ: "꿂",
    꾸ᄅᄇ: "꿃",
    꾸ᄅᄉ: "꿄",
    꾸ᄅᄐ: "꿅",
    꾸ᄅᄑ: "꿆",
    꾸ᄅᄒ: "꿇",
    꾸ᄆ: "꿈",
    꾸ᄇ: "꿉",
    꾸ᄇᄉ: "꿊",
    꾸ᄉ: "꿋",
    꾸ᄊ: "꿌",
    꾸ᄋ: "꿍",
    꾸ᄌ: "꿎",
    꾸ᄎ: "꿏",
    꾸ᄏ: "꿐",
    꾸ᄐ: "꿑",
    꾸ᄑ: "꿒",
    꾸ᄒ: "꿓",
    꾸ᅥ: "꿔",
    꾸ᅥᄀ: "꿕",
    꾸ᅥᄁ: "꿖",
    꾸ᅥᄀᄉ: "꿗",
    꾸ᅥᄂ: "꿘",
    꾸ᅥᄂᄌ: "꿙",
    꾸ᅥᄂᄒ: "꿚",
    꾸ᅥᄃ: "꿛",
    꾸ᅥᄅ: "꿜",
    꾸ᅥᄅᄀ: "꿝",
    꾸ᅥᄅᄆ: "꿞",
    꾸ᅥᄅᄇ: "꿟",
    꾸ᅥᄅᄉ: "꿠",
    꾸ᅥᄅᄐ: "꿡",
    꾸ᅥᄅᄑ: "꿢",
    꾸ᅥᄅᄒ: "꿣",
    꾸ᅥᄆ: "꿤",
    꾸ᅥᄇ: "꿥",
    꾸ᅥᄇᄉ: "꿦",
    꾸ᅥᄉ: "꿧",
    꾸ᅥᄊ: "꿨",
    꾸ᅥᄋ: "꿩",
    꾸ᅥᄌ: "꿪",
    꾸ᅥᄎ: "꿫",
    꾸ᅥᄏ: "꿬",
    꾸ᅥᄐ: "꿭",
    꾸ᅥᄑ: "꿮",
    꾸ᅥᄒ: "꿯",
    꾸ᅦ: "꿰",
    꾸ᅦᄀ: "꿱",
    꾸ᅦᄁ: "꿲",
    꾸ᅦᄀᄉ: "꿳",
    꾸ᅦᄂ: "꿴",
    꾸ᅦᄂᄌ: "꿵",
    꾸ᅦᄂᄒ: "꿶",
    꾸ᅦᄃ: "꿷",
    꾸ᅦᄅ: "꿸",
    꾸ᅦᄅᄀ: "꿹",
    꾸ᅦᄅᄆ: "꿺",
    꾸ᅦᄅᄇ: "꿻",
    꾸ᅦᄅᄉ: "꿼",
    꾸ᅦᄅᄐ: "꿽",
    꾸ᅦᄅᄑ: "꿾",
    꾸ᅦᄅᄒ: "꿿",
    꾸ᅦᄆ: "뀀",
    꾸ᅦᄇ: "뀁",
    꾸ᅦᄇᄉ: "뀂",
    꾸ᅦᄉ: "뀃",
    꾸ᅦᄊ: "뀄",
    꾸ᅦᄋ: "뀅",
    꾸ᅦᄌ: "뀆",
    꾸ᅦᄎ: "뀇",
    꾸ᅦᄏ: "뀈",
    꾸ᅦᄐ: "뀉",
    꾸ᅦᄑ: "뀊",
    꾸ᅦᄒ: "뀋",
    꾸ᅵ: "뀌",
    꾸ᅵᄀ: "뀍",
    꾸ᅵᄁ: "뀎",
    꾸ᅵᄀᄉ: "뀏",
    꾸ᅵᄂ: "뀐",
    꾸ᅵᄂᄌ: "뀑",
    꾸ᅵᄂᄒ: "뀒",
    꾸ᅵᄃ: "뀓",
    꾸ᅵᄅ: "뀔",
    꾸ᅵᄅᄀ: "뀕",
    꾸ᅵᄅᄆ: "뀖",
    꾸ᅵᄅᄇ: "뀗",
    꾸ᅵᄅᄉ: "뀘",
    꾸ᅵᄅᄐ: "뀙",
    꾸ᅵᄅᄑ: "뀚",
    꾸ᅵᄅᄒ: "뀛",
    꾸ᅵᄆ: "뀜",
    꾸ᅵᄇ: "뀝",
    꾸ᅵᄇᄉ: "뀞",
    꾸ᅵᄉ: "뀟",
    꾸ᅵᄊ: "뀠",
    꾸ᅵᄋ: "뀡",
    꾸ᅵᄌ: "뀢",
    꾸ᅵᄎ: "뀣",
    꾸ᅵᄏ: "뀤",
    꾸ᅵᄐ: "뀥",
    꾸ᅵᄑ: "뀦",
    꾸ᅵᄒ: "뀧",
    뀨: "뀨",
    뀨ᄀ: "뀩",
    뀨ᄁ: "뀪",
    뀨ᄀᄉ: "뀫",
    뀨ᄂ: "뀬",
    뀨ᄂᄌ: "뀭",
    뀨ᄂᄒ: "뀮",
    뀨ᄃ: "뀯",
    뀨ᄅ: "뀰",
    뀨ᄅᄀ: "뀱",
    뀨ᄅᄆ: "뀲",
    뀨ᄅᄇ: "뀳",
    뀨ᄅᄉ: "뀴",
    뀨ᄅᄐ: "뀵",
    뀨ᄅᄑ: "뀶",
    뀨ᄅᄒ: "뀷",
    뀨ᄆ: "뀸",
    뀨ᄇ: "뀹",
    뀨ᄇᄉ: "뀺",
    뀨ᄉ: "뀻",
    뀨ᄊ: "뀼",
    뀨ᄋ: "뀽",
    뀨ᄌ: "뀾",
    뀨ᄎ: "뀿",
    뀨ᄏ: "끀",
    뀨ᄐ: "끁",
    뀨ᄑ: "끂",
    뀨ᄒ: "끃",
    끄: "끄",
    끄ᄀ: "끅",
    끄ᄁ: "끆",
    끄ᄀᄉ: "끇",
    끄ᄂ: "끈",
    끄ᄂᄌ: "끉",
    끄ᄂᄒ: "끊",
    끄ᄃ: "끋",
    끄ᄅ: "끌",
    끄ᄅᄀ: "끍",
    끄ᄅᄆ: "끎",
    끄ᄅᄇ: "끏",
    끄ᄅᄉ: "끐",
    끄ᄅᄐ: "끑",
    끄ᄅᄑ: "끒",
    끄ᄅᄒ: "끓",
    끄ᄆ: "끔",
    끄ᄇ: "끕",
    끄ᄇᄉ: "끖",
    끄ᄉ: "끗",
    끄ᄊ: "끘",
    끄ᄋ: "끙",
    끄ᄌ: "끚",
    끄ᄎ: "끛",
    끄ᄏ: "끜",
    끄ᄐ: "끝",
    끄ᄑ: "끞",
    끄ᄒ: "끟",
    끄ᅵ: "끠",
    끄ᅵᄀ: "끡",
    끄ᅵᄁ: "끢",
    끄ᅵᄀᄉ: "끣",
    끄ᅵᄂ: "끤",
    끄ᅵᄂᄌ: "끥",
    끄ᅵᄂᄒ: "끦",
    끄ᅵᄃ: "끧",
    끄ᅵᄅ: "끨",
    끄ᅵᄅᄀ: "끩",
    끄ᅵᄅᄆ: "끪",
    끄ᅵᄅᄇ: "끫",
    끄ᅵᄅᄉ: "끬",
    끄ᅵᄅᄐ: "끭",
    끄ᅵᄅᄑ: "끮",
    끄ᅵᄅᄒ: "끯",
    끄ᅵᄆ: "끰",
    끄ᅵᄇ: "끱",
    끄ᅵᄇᄉ: "끲",
    끄ᅵᄉ: "끳",
    끄ᅵᄊ: "끴",
    끄ᅵᄋ: "끵",
    끄ᅵᄌ: "끶",
    끄ᅵᄎ: "끷",
    끄ᅵᄏ: "끸",
    끄ᅵᄐ: "끹",
    끄ᅵᄑ: "끺",
    끄ᅵᄒ: "끻",
    끼: "끼",
    끼ᄀ: "끽",
    끼ᄁ: "끾",
    끼ᄀᄉ: "끿",
    끼ᄂ: "낀",
    끼ᄂᄌ: "낁",
    끼ᄂᄒ: "낂",
    끼ᄃ: "낃",
    끼ᄅ: "낄",
    끼ᄅᄀ: "낅",
    끼ᄅᄆ: "낆",
    끼ᄅᄇ: "낇",
    끼ᄅᄉ: "낈",
    끼ᄅᄐ: "낉",
    끼ᄅᄑ: "낊",
    끼ᄅᄒ: "낋",
    끼ᄆ: "낌",
    끼ᄇ: "낍",
    끼ᄇᄉ: "낎",
    끼ᄉ: "낏",
    끼ᄊ: "낐",
    끼ᄋ: "낑",
    끼ᄌ: "낒",
    끼ᄎ: "낓",
    끼ᄏ: "낔",
    끼ᄐ: "낕",
    끼ᄑ: "낖",
    끼ᄒ: "낗",
    나: "나",
    나ᄀ: "낙",
    나ᄁ: "낚",
    나ᄀᄉ: "낛",
    나ᄂ: "난",
    나ᄂᄌ: "낝",
    나ᄂᄒ: "낞",
    나ᄃ: "낟",
    나ᄅ: "날",
    나ᄅᄀ: "낡",
    나ᄅᄆ: "낢",
    나ᄅᄇ: "낣",
    나ᄅᄉ: "낤",
    나ᄅᄐ: "낥",
    나ᄅᄑ: "낦",
    나ᄅᄒ: "낧",
    나ᄆ: "남",
    나ᄇ: "납",
    나ᄇᄉ: "낪",
    나ᄉ: "낫",
    나ᄊ: "났",
    나ᄋ: "낭",
    나ᄌ: "낮",
    나ᄎ: "낯",
    나ᄏ: "낰",
    나ᄐ: "낱",
    나ᄑ: "낲",
    나ᄒ: "낳",
    내: "내",
    내ᄀ: "낵",
    내ᄁ: "낶",
    내ᄀᄉ: "낷",
    내ᄂ: "낸",
    내ᄂᄌ: "낹",
    내ᄂᄒ: "낺",
    내ᄃ: "낻",
    내ᄅ: "낼",
    내ᄅᄀ: "낽",
    내ᄅᄆ: "낾",
    내ᄅᄇ: "낿",
    내ᄅᄉ: "냀",
    내ᄅᄐ: "냁",
    내ᄅᄑ: "냂",
    내ᄅᄒ: "냃",
    내ᄆ: "냄",
    내ᄇ: "냅",
    내ᄇᄉ: "냆",
    내ᄉ: "냇",
    내ᄊ: "냈",
    내ᄋ: "냉",
    내ᄌ: "냊",
    내ᄎ: "냋",
    내ᄏ: "냌",
    내ᄐ: "냍",
    내ᄑ: "냎",
    내ᄒ: "냏",
    냐: "냐",
    냐ᄀ: "냑",
    냐ᄁ: "냒",
    냐ᄀᄉ: "냓",
    냐ᄂ: "냔",
    냐ᄂᄌ: "냕",
    냐ᄂᄒ: "냖",
    냐ᄃ: "냗",
    냐ᄅ: "냘",
    냐ᄅᄀ: "냙",
    냐ᄅᄆ: "냚",
    냐ᄅᄇ: "냛",
    냐ᄅᄉ: "냜",
    냐ᄅᄐ: "냝",
    냐ᄅᄑ: "냞",
    냐ᄅᄒ: "냟",
    냐ᄆ: "냠",
    냐ᄇ: "냡",
    냐ᄇᄉ: "냢",
    냐ᄉ: "냣",
    냐ᄊ: "냤",
    냐ᄋ: "냥",
    냐ᄌ: "냦",
    냐ᄎ: "냧",
    냐ᄏ: "냨",
    냐ᄐ: "냩",
    냐ᄑ: "냪",
    냐ᄒ: "냫",
    냬: "냬",
    냬ᄀ: "냭",
    냬ᄁ: "냮",
    냬ᄀᄉ: "냯",
    냬ᄂ: "냰",
    냬ᄂᄌ: "냱",
    냬ᄂᄒ: "냲",
    냬ᄃ: "냳",
    냬ᄅ: "냴",
    냬ᄅᄀ: "냵",
    냬ᄅᄆ: "냶",
    냬ᄅᄇ: "냷",
    냬ᄅᄉ: "냸",
    냬ᄅᄐ: "냹",
    냬ᄅᄑ: "냺",
    냬ᄅᄒ: "냻",
    냬ᄆ: "냼",
    냬ᄇ: "냽",
    냬ᄇᄉ: "냾",
    냬ᄉ: "냿",
    냬ᄊ: "넀",
    냬ᄋ: "넁",
    냬ᄌ: "넂",
    냬ᄎ: "넃",
    냬ᄏ: "넄",
    냬ᄐ: "넅",
    냬ᄑ: "넆",
    냬ᄒ: "넇",
    너: "너",
    너ᄀ: "넉",
    너ᄁ: "넊",
    너ᄀᄉ: "넋",
    너ᄂ: "넌",
    너ᄂᄌ: "넍",
    너ᄂᄒ: "넎",
    너ᄃ: "넏",
    너ᄅ: "널",
    너ᄅᄀ: "넑",
    너ᄅᄆ: "넒",
    너ᄅᄇ: "넓",
    너ᄅᄉ: "넔",
    너ᄅᄐ: "넕",
    너ᄅᄑ: "넖",
    너ᄅᄒ: "넗",
    너ᄆ: "넘",
    너ᄇ: "넙",
    너ᄇᄉ: "넚",
    너ᄉ: "넛",
    너ᄊ: "넜",
    너ᄋ: "넝",
    너ᄌ: "넞",
    너ᄎ: "넟",
    너ᄏ: "넠",
    너ᄐ: "넡",
    너ᄑ: "넢",
    너ᄒ: "넣",
    네: "네",
    네ᄀ: "넥",
    네ᄁ: "넦",
    네ᄀᄉ: "넧",
    네ᄂ: "넨",
    네ᄂᄌ: "넩",
    네ᄂᄒ: "넪",
    네ᄃ: "넫",
    네ᄅ: "넬",
    네ᄅᄀ: "넭",
    네ᄅᄆ: "넮",
    네ᄅᄇ: "넯",
    네ᄅᄉ: "넰",
    네ᄅᄐ: "넱",
    네ᄅᄑ: "넲",
    네ᄅᄒ: "넳",
    네ᄆ: "넴",
    네ᄇ: "넵",
    네ᄇᄉ: "넶",
    네ᄉ: "넷",
    네ᄊ: "넸",
    네ᄋ: "넹",
    네ᄌ: "넺",
    네ᄎ: "넻",
    네ᄏ: "넼",
    네ᄐ: "넽",
    네ᄑ: "넾",
    네ᄒ: "넿",
    녀: "녀",
    녀ᄀ: "녁",
    녀ᄁ: "녂",
    녀ᄀᄉ: "녃",
    녀ᄂ: "년",
    녀ᄂᄌ: "녅",
    녀ᄂᄒ: "녆",
    녀ᄃ: "녇",
    녀ᄅ: "녈",
    녀ᄅᄀ: "녉",
    녀ᄅᄆ: "녊",
    녀ᄅᄇ: "녋",
    녀ᄅᄉ: "녌",
    녀ᄅᄐ: "녍",
    녀ᄅᄑ: "녎",
    녀ᄅᄒ: "녏",
    녀ᄆ: "념",
    녀ᄇ: "녑",
    녀ᄇᄉ: "녒",
    녀ᄉ: "녓",
    녀ᄊ: "녔",
    녀ᄋ: "녕",
    녀ᄌ: "녖",
    녀ᄎ: "녗",
    녀ᄏ: "녘",
    녀ᄐ: "녙",
    녀ᄑ: "녚",
    녀ᄒ: "녛",
    녜: "녜",
    녜ᄀ: "녝",
    녜ᄁ: "녞",
    녜ᄀᄉ: "녟",
    녜ᄂ: "녠",
    녜ᄂᄌ: "녡",
    녜ᄂᄒ: "녢",
    녜ᄃ: "녣",
    녜ᄅ: "녤",
    녜ᄅᄀ: "녥",
    녜ᄅᄆ: "녦",
    녜ᄅᄇ: "녧",
    녜ᄅᄉ: "녨",
    녜ᄅᄐ: "녩",
    녜ᄅᄑ: "녪",
    녜ᄅᄒ: "녫",
    녜ᄆ: "녬",
    녜ᄇ: "녭",
    녜ᄇᄉ: "녮",
    녜ᄉ: "녯",
    녜ᄊ: "녰",
    녜ᄋ: "녱",
    녜ᄌ: "녲",
    녜ᄎ: "녳",
    녜ᄏ: "녴",
    녜ᄐ: "녵",
    녜ᄑ: "녶",
    녜ᄒ: "녷",
    노: "노",
    노ᄀ: "녹",
    노ᄁ: "녺",
    노ᄀᄉ: "녻",
    노ᄂ: "논",
    노ᄂᄌ: "녽",
    노ᄂᄒ: "녾",
    노ᄃ: "녿",
    노ᄅ: "놀",
    노ᄅᄀ: "놁",
    노ᄅᄆ: "놂",
    노ᄅᄇ: "놃",
    노ᄅᄉ: "놄",
    노ᄅᄐ: "놅",
    노ᄅᄑ: "놆",
    노ᄅᄒ: "놇",
    노ᄆ: "놈",
    노ᄇ: "놉",
    노ᄇᄉ: "놊",
    노ᄉ: "놋",
    노ᄊ: "놌",
    노ᄋ: "농",
    노ᄌ: "놎",
    노ᄎ: "놏",
    노ᄏ: "놐",
    노ᄐ: "놑",
    노ᄑ: "높",
    노ᄒ: "놓",
    노ᅡ: "놔",
    노ᅡᄀ: "놕",
    노ᅡᄁ: "놖",
    노ᅡᄀᄉ: "놗",
    노ᅡᄂ: "놘",
    노ᅡᄂᄌ: "놙",
    노ᅡᄂᄒ: "놚",
    노ᅡᄃ: "놛",
    노ᅡᄅ: "놜",
    노ᅡᄅᄀ: "놝",
    노ᅡᄅᄆ: "놞",
    노ᅡᄅᄇ: "놟",
    노ᅡᄅᄉ: "놠",
    노ᅡᄅᄐ: "놡",
    노ᅡᄅᄑ: "놢",
    노ᅡᄅᄒ: "놣",
    노ᅡᄆ: "놤",
    노ᅡᄇ: "놥",
    노ᅡᄇᄉ: "놦",
    노ᅡᄉ: "놧",
    노ᅡᄊ: "놨",
    노ᅡᄋ: "놩",
    노ᅡᄌ: "놪",
    노ᅡᄎ: "놫",
    노ᅡᄏ: "놬",
    노ᅡᄐ: "놭",
    노ᅡᄑ: "놮",
    노ᅡᄒ: "놯",
    노ᅢ: "놰",
    노ᅢᄀ: "놱",
    노ᅢᄁ: "놲",
    노ᅢᄀᄉ: "놳",
    노ᅢᄂ: "놴",
    노ᅢᄂᄌ: "놵",
    노ᅢᄂᄒ: "놶",
    노ᅢᄃ: "놷",
    노ᅢᄅ: "놸",
    노ᅢᄅᄀ: "놹",
    노ᅢᄅᄆ: "놺",
    노ᅢᄅᄇ: "놻",
    노ᅢᄅᄉ: "놼",
    노ᅢᄅᄐ: "놽",
    노ᅢᄅᄑ: "놾",
    노ᅢᄅᄒ: "놿",
    노ᅢᄆ: "뇀",
    노ᅢᄇ: "뇁",
    노ᅢᄇᄉ: "뇂",
    노ᅢᄉ: "뇃",
    노ᅢᄊ: "뇄",
    노ᅢᄋ: "뇅",
    노ᅢᄌ: "뇆",
    노ᅢᄎ: "뇇",
    노ᅢᄏ: "뇈",
    노ᅢᄐ: "뇉",
    노ᅢᄑ: "뇊",
    노ᅢᄒ: "뇋",
    노ᅵ: "뇌",
    노ᅵᄀ: "뇍",
    노ᅵᄁ: "뇎",
    노ᅵᄀᄉ: "뇏",
    노ᅵᄂ: "뇐",
    노ᅵᄂᄌ: "뇑",
    노ᅵᄂᄒ: "뇒",
    노ᅵᄃ: "뇓",
    노ᅵᄅ: "뇔",
    노ᅵᄅᄀ: "뇕",
    노ᅵᄅᄆ: "뇖",
    노ᅵᄅᄇ: "뇗",
    노ᅵᄅᄉ: "뇘",
    노ᅵᄅᄐ: "뇙",
    노ᅵᄅᄑ: "뇚",
    노ᅵᄅᄒ: "뇛",
    노ᅵᄆ: "뇜",
    노ᅵᄇ: "뇝",
    노ᅵᄇᄉ: "뇞",
    노ᅵᄉ: "뇟",
    노ᅵᄊ: "뇠",
    노ᅵᄋ: "뇡",
    노ᅵᄌ: "뇢",
    노ᅵᄎ: "뇣",
    노ᅵᄏ: "뇤",
    노ᅵᄐ: "뇥",
    노ᅵᄑ: "뇦",
    노ᅵᄒ: "뇧",
    뇨: "뇨",
    뇨ᄀ: "뇩",
    뇨ᄁ: "뇪",
    뇨ᄀᄉ: "뇫",
    뇨ᄂ: "뇬",
    뇨ᄂᄌ: "뇭",
    뇨ᄂᄒ: "뇮",
    뇨ᄃ: "뇯",
    뇨ᄅ: "뇰",
    뇨ᄅᄀ: "뇱",
    뇨ᄅᄆ: "뇲",
    뇨ᄅᄇ: "뇳",
    뇨ᄅᄉ: "뇴",
    뇨ᄅᄐ: "뇵",
    뇨ᄅᄑ: "뇶",
    뇨ᄅᄒ: "뇷",
    뇨ᄆ: "뇸",
    뇨ᄇ: "뇹",
    뇨ᄇᄉ: "뇺",
    뇨ᄉ: "뇻",
    뇨ᄊ: "뇼",
    뇨ᄋ: "뇽",
    뇨ᄌ: "뇾",
    뇨ᄎ: "뇿",
    뇨ᄏ: "눀",
    뇨ᄐ: "눁",
    뇨ᄑ: "눂",
    뇨ᄒ: "눃",
    누: "누",
    누ᄀ: "눅",
    누ᄁ: "눆",
    누ᄀᄉ: "눇",
    누ᄂ: "눈",
    누ᄂᄌ: "눉",
    누ᄂᄒ: "눊",
    누ᄃ: "눋",
    누ᄅ: "눌",
    누ᄅᄀ: "눍",
    누ᄅᄆ: "눎",
    누ᄅᄇ: "눏",
    누ᄅᄉ: "눐",
    누ᄅᄐ: "눑",
    누ᄅᄑ: "눒",
    누ᄅᄒ: "눓",
    누ᄆ: "눔",
    누ᄇ: "눕",
    누ᄇᄉ: "눖",
    누ᄉ: "눗",
    누ᄊ: "눘",
    누ᄋ: "눙",
    누ᄌ: "눚",
    누ᄎ: "눛",
    누ᄏ: "눜",
    누ᄐ: "눝",
    누ᄑ: "눞",
    누ᄒ: "눟",
    누ᅥ: "눠",
    누ᅥᄀ: "눡",
    누ᅥᄁ: "눢",
    누ᅥᄀᄉ: "눣",
    누ᅥᄂ: "눤",
    누ᅥᄂᄌ: "눥",
    누ᅥᄂᄒ: "눦",
    누ᅥᄃ: "눧",
    누ᅥᄅ: "눨",
    누ᅥᄅᄀ: "눩",
    누ᅥᄅᄆ: "눪",
    누ᅥᄅᄇ: "눫",
    누ᅥᄅᄉ: "눬",
    누ᅥᄅᄐ: "눭",
    누ᅥᄅᄑ: "눮",
    누ᅥᄅᄒ: "눯",
    누ᅥᄆ: "눰",
    누ᅥᄇ: "눱",
    누ᅥᄇᄉ: "눲",
    누ᅥᄉ: "눳",
    누ᅥᄊ: "눴",
    누ᅥᄋ: "눵",
    누ᅥᄌ: "눶",
    누ᅥᄎ: "눷",
    누ᅥᄏ: "눸",
    누ᅥᄐ: "눹",
    누ᅥᄑ: "눺",
    누ᅥᄒ: "눻",
    누ᅦ: "눼",
    누ᅦᄀ: "눽",
    누ᅦᄁ: "눾",
    누ᅦᄀᄉ: "눿",
    누ᅦᄂ: "뉀",
    누ᅦᄂᄌ: "뉁",
    누ᅦᄂᄒ: "뉂",
    누ᅦᄃ: "뉃",
    누ᅦᄅ: "뉄",
    누ᅦᄅᄀ: "뉅",
    누ᅦᄅᄆ: "뉆",
    누ᅦᄅᄇ: "뉇",
    누ᅦᄅᄉ: "뉈",
    누ᅦᄅᄐ: "뉉",
    누ᅦᄅᄑ: "뉊",
    누ᅦᄅᄒ: "뉋",
    누ᅦᄆ: "뉌",
    누ᅦᄇ: "뉍",
    누ᅦᄇᄉ: "뉎",
    누ᅦᄉ: "뉏",
    누ᅦᄊ: "뉐",
    누ᅦᄋ: "뉑",
    누ᅦᄌ: "뉒",
    누ᅦᄎ: "뉓",
    누ᅦᄏ: "뉔",
    누ᅦᄐ: "뉕",
    누ᅦᄑ: "뉖",
    누ᅦᄒ: "뉗",
    누ᅵ: "뉘",
    누ᅵᄀ: "뉙",
    누ᅵᄁ: "뉚",
    누ᅵᄀᄉ: "뉛",
    누ᅵᄂ: "뉜",
    누ᅵᄂᄌ: "뉝",
    누ᅵᄂᄒ: "뉞",
    누ᅵᄃ: "뉟",
    누ᅵᄅ: "뉠",
    누ᅵᄅᄀ: "뉡",
    누ᅵᄅᄆ: "뉢",
    누ᅵᄅᄇ: "뉣",
    누ᅵᄅᄉ: "뉤",
    누ᅵᄅᄐ: "뉥",
    누ᅵᄅᄑ: "뉦",
    누ᅵᄅᄒ: "뉧",
    누ᅵᄆ: "뉨",
    누ᅵᄇ: "뉩",
    누ᅵᄇᄉ: "뉪",
    누ᅵᄉ: "뉫",
    누ᅵᄊ: "뉬",
    누ᅵᄋ: "뉭",
    누ᅵᄌ: "뉮",
    누ᅵᄎ: "뉯",
    누ᅵᄏ: "뉰",
    누ᅵᄐ: "뉱",
    누ᅵᄑ: "뉲",
    누ᅵᄒ: "뉳",
    뉴: "뉴",
    뉴ᄀ: "뉵",
    뉴ᄁ: "뉶",
    뉴ᄀᄉ: "뉷",
    뉴ᄂ: "뉸",
    뉴ᄂᄌ: "뉹",
    뉴ᄂᄒ: "뉺",
    뉴ᄃ: "뉻",
    뉴ᄅ: "뉼",
    뉴ᄅᄀ: "뉽",
    뉴ᄅᄆ: "뉾",
    뉴ᄅᄇ: "뉿",
    뉴ᄅᄉ: "늀",
    뉴ᄅᄐ: "늁",
    뉴ᄅᄑ: "늂",
    뉴ᄅᄒ: "늃",
    뉴ᄆ: "늄",
    뉴ᄇ: "늅",
    뉴ᄇᄉ: "늆",
    뉴ᄉ: "늇",
    뉴ᄊ: "늈",
    뉴ᄋ: "늉",
    뉴ᄌ: "늊",
    뉴ᄎ: "늋",
    뉴ᄏ: "늌",
    뉴ᄐ: "늍",
    뉴ᄑ: "늎",
    뉴ᄒ: "늏",
    느: "느",
    느ᄀ: "늑",
    느ᄁ: "늒",
    느ᄀᄉ: "늓",
    느ᄂ: "는",
    느ᄂᄌ: "늕",
    느ᄂᄒ: "늖",
    느ᄃ: "늗",
    느ᄅ: "늘",
    느ᄅᄀ: "늙",
    느ᄅᄆ: "늚",
    느ᄅᄇ: "늛",
    느ᄅᄉ: "늜",
    느ᄅᄐ: "늝",
    느ᄅᄑ: "늞",
    느ᄅᄒ: "늟",
    느ᄆ: "늠",
    느ᄇ: "늡",
    느ᄇᄉ: "늢",
    느ᄉ: "늣",
    느ᄊ: "늤",
    느ᄋ: "능",
    느ᄌ: "늦",
    느ᄎ: "늧",
    느ᄏ: "늨",
    느ᄐ: "늩",
    느ᄑ: "늪",
    느ᄒ: "늫",
    느ᅵ: "늬",
    느ᅵᄀ: "늭",
    느ᅵᄁ: "늮",
    느ᅵᄀᄉ: "늯",
    느ᅵᄂ: "늰",
    느ᅵᄂᄌ: "늱",
    느ᅵᄂᄒ: "늲",
    느ᅵᄃ: "늳",
    느ᅵᄅ: "늴",
    느ᅵᄅᄀ: "늵",
    느ᅵᄅᄆ: "늶",
    느ᅵᄅᄇ: "늷",
    느ᅵᄅᄉ: "늸",
    느ᅵᄅᄐ: "늹",
    느ᅵᄅᄑ: "늺",
    느ᅵᄅᄒ: "늻",
    느ᅵᄆ: "늼",
    느ᅵᄇ: "늽",
    느ᅵᄇᄉ: "늾",
    느ᅵᄉ: "늿",
    느ᅵᄊ: "닀",
    느ᅵᄋ: "닁",
    느ᅵᄌ: "닂",
    느ᅵᄎ: "닃",
    느ᅵᄏ: "닄",
    느ᅵᄐ: "닅",
    느ᅵᄑ: "닆",
    느ᅵᄒ: "닇",
    니: "니",
    니ᄀ: "닉",
    니ᄁ: "닊",
    니ᄀᄉ: "닋",
    니ᄂ: "닌",
    니ᄂᄌ: "닍",
    니ᄂᄒ: "닎",
    니ᄃ: "닏",
    니ᄅ: "닐",
    니ᄅᄀ: "닑",
    니ᄅᄆ: "닒",
    니ᄅᄇ: "닓",
    니ᄅᄉ: "닔",
    니ᄅᄐ: "닕",
    니ᄅᄑ: "닖",
    니ᄅᄒ: "닗",
    니ᄆ: "님",
    니ᄇ: "닙",
    니ᄇᄉ: "닚",
    니ᄉ: "닛",
    니ᄊ: "닜",
    니ᄋ: "닝",
    니ᄌ: "닞",
    니ᄎ: "닟",
    니ᄏ: "닠",
    니ᄐ: "닡",
    니ᄑ: "닢",
    니ᄒ: "닣",
    다: "다",
    다ᄀ: "닥",
    다ᄁ: "닦",
    다ᄀᄉ: "닧",
    다ᄂ: "단",
    다ᄂᄌ: "닩",
    다ᄂᄒ: "닪",
    다ᄃ: "닫",
    다ᄅ: "달",
    다ᄅᄀ: "닭",
    다ᄅᄆ: "닮",
    다ᄅᄇ: "닯",
    다ᄅᄉ: "닰",
    다ᄅᄐ: "닱",
    다ᄅᄑ: "닲",
    다ᄅᄒ: "닳",
    다ᄆ: "담",
    다ᄇ: "답",
    다ᄇᄉ: "닶",
    다ᄉ: "닷",
    다ᄊ: "닸",
    다ᄋ: "당",
    다ᄌ: "닺",
    다ᄎ: "닻",
    다ᄏ: "닼",
    다ᄐ: "닽",
    다ᄑ: "닾",
    다ᄒ: "닿",
    대: "대",
    대ᄀ: "댁",
    대ᄁ: "댂",
    대ᄀᄉ: "댃",
    대ᄂ: "댄",
    대ᄂᄌ: "댅",
    대ᄂᄒ: "댆",
    대ᄃ: "댇",
    대ᄅ: "댈",
    대ᄅᄀ: "댉",
    대ᄅᄆ: "댊",
    대ᄅᄇ: "댋",
    대ᄅᄉ: "댌",
    대ᄅᄐ: "댍",
    대ᄅᄑ: "댎",
    대ᄅᄒ: "댏",
    대ᄆ: "댐",
    대ᄇ: "댑",
    대ᄇᄉ: "댒",
    대ᄉ: "댓",
    대ᄊ: "댔",
    대ᄋ: "댕",
    대ᄌ: "댖",
    대ᄎ: "댗",
    대ᄏ: "댘",
    대ᄐ: "댙",
    대ᄑ: "댚",
    대ᄒ: "댛",
    댜: "댜",
    댜ᄀ: "댝",
    댜ᄁ: "댞",
    댜ᄀᄉ: "댟",
    댜ᄂ: "댠",
    댜ᄂᄌ: "댡",
    댜ᄂᄒ: "댢",
    댜ᄃ: "댣",
    댜ᄅ: "댤",
    댜ᄅᄀ: "댥",
    댜ᄅᄆ: "댦",
    댜ᄅᄇ: "댧",
    댜ᄅᄉ: "댨",
    댜ᄅᄐ: "댩",
    댜ᄅᄑ: "댪",
    댜ᄅᄒ: "댫",
    댜ᄆ: "댬",
    댜ᄇ: "댭",
    댜ᄇᄉ: "댮",
    댜ᄉ: "댯",
    댜ᄊ: "댰",
    댜ᄋ: "댱",
    댜ᄌ: "댲",
    댜ᄎ: "댳",
    댜ᄏ: "댴",
    댜ᄐ: "댵",
    댜ᄑ: "댶",
    댜ᄒ: "댷",
    댸: "댸",
    댸ᄀ: "댹",
    댸ᄁ: "댺",
    댸ᄀᄉ: "댻",
    댸ᄂ: "댼",
    댸ᄂᄌ: "댽",
    댸ᄂᄒ: "댾",
    댸ᄃ: "댿",
    댸ᄅ: "덀",
    댸ᄅᄀ: "덁",
    댸ᄅᄆ: "덂",
    댸ᄅᄇ: "덃",
    댸ᄅᄉ: "덄",
    댸ᄅᄐ: "덅",
    댸ᄅᄑ: "덆",
    댸ᄅᄒ: "덇",
    댸ᄆ: "덈",
    댸ᄇ: "덉",
    댸ᄇᄉ: "덊",
    댸ᄉ: "덋",
    댸ᄊ: "덌",
    댸ᄋ: "덍",
    댸ᄌ: "덎",
    댸ᄎ: "덏",
    댸ᄏ: "덐",
    댸ᄐ: "덑",
    댸ᄑ: "덒",
    댸ᄒ: "덓",
    더: "더",
    더ᄀ: "덕",
    더ᄁ: "덖",
    더ᄀᄉ: "덗",
    더ᄂ: "던",
    더ᄂᄌ: "덙",
    더ᄂᄒ: "덚",
    더ᄃ: "덛",
    더ᄅ: "덜",
    더ᄅᄀ: "덝",
    더ᄅᄆ: "덞",
    더ᄅᄇ: "덟",
    더ᄅᄉ: "덠",
    더ᄅᄐ: "덡",
    더ᄅᄑ: "덢",
    더ᄅᄒ: "덣",
    더ᄆ: "덤",
    더ᄇ: "덥",
    더ᄇᄉ: "덦",
    더ᄉ: "덧",
    더ᄊ: "덨",
    더ᄋ: "덩",
    더ᄌ: "덪",
    더ᄎ: "덫",
    더ᄏ: "덬",
    더ᄐ: "덭",
    더ᄑ: "덮",
    더ᄒ: "덯",
    데: "데",
    데ᄀ: "덱",
    데ᄁ: "덲",
    데ᄀᄉ: "덳",
    데ᄂ: "덴",
    데ᄂᄌ: "덵",
    데ᄂᄒ: "덶",
    데ᄃ: "덷",
    데ᄅ: "델",
    데ᄅᄀ: "덹",
    데ᄅᄆ: "덺",
    데ᄅᄇ: "덻",
    데ᄅᄉ: "덼",
    데ᄅᄐ: "덽",
    데ᄅᄑ: "덾",
    데ᄅᄒ: "덿",
    데ᄆ: "뎀",
    데ᄇ: "뎁",
    데ᄇᄉ: "뎂",
    데ᄉ: "뎃",
    데ᄊ: "뎄",
    데ᄋ: "뎅",
    데ᄌ: "뎆",
    데ᄎ: "뎇",
    데ᄏ: "뎈",
    데ᄐ: "뎉",
    데ᄑ: "뎊",
    데ᄒ: "뎋",
    뎌: "뎌",
    뎌ᄀ: "뎍",
    뎌ᄁ: "뎎",
    뎌ᄀᄉ: "뎏",
    뎌ᄂ: "뎐",
    뎌ᄂᄌ: "뎑",
    뎌ᄂᄒ: "뎒",
    뎌ᄃ: "뎓",
    뎌ᄅ: "뎔",
    뎌ᄅᄀ: "뎕",
    뎌ᄅᄆ: "뎖",
    뎌ᄅᄇ: "뎗",
    뎌ᄅᄉ: "뎘",
    뎌ᄅᄐ: "뎙",
    뎌ᄅᄑ: "뎚",
    뎌ᄅᄒ: "뎛",
    뎌ᄆ: "뎜",
    뎌ᄇ: "뎝",
    뎌ᄇᄉ: "뎞",
    뎌ᄉ: "뎟",
    뎌ᄊ: "뎠",
    뎌ᄋ: "뎡",
    뎌ᄌ: "뎢",
    뎌ᄎ: "뎣",
    뎌ᄏ: "뎤",
    뎌ᄐ: "뎥",
    뎌ᄑ: "뎦",
    뎌ᄒ: "뎧",
    뎨: "뎨",
    뎨ᄀ: "뎩",
    뎨ᄁ: "뎪",
    뎨ᄀᄉ: "뎫",
    뎨ᄂ: "뎬",
    뎨ᄂᄌ: "뎭",
    뎨ᄂᄒ: "뎮",
    뎨ᄃ: "뎯",
    뎨ᄅ: "뎰",
    뎨ᄅᄀ: "뎱",
    뎨ᄅᄆ: "뎲",
    뎨ᄅᄇ: "뎳",
    뎨ᄅᄉ: "뎴",
    뎨ᄅᄐ: "뎵",
    뎨ᄅᄑ: "뎶",
    뎨ᄅᄒ: "뎷",
    뎨ᄆ: "뎸",
    뎨ᄇ: "뎹",
    뎨ᄇᄉ: "뎺",
    뎨ᄉ: "뎻",
    뎨ᄊ: "뎼",
    뎨ᄋ: "뎽",
    뎨ᄌ: "뎾",
    뎨ᄎ: "뎿",
    뎨ᄏ: "돀",
    뎨ᄐ: "돁",
    뎨ᄑ: "돂",
    뎨ᄒ: "돃",
    도: "도",
    도ᄀ: "독",
    도ᄁ: "돆",
    도ᄀᄉ: "돇",
    도ᄂ: "돈",
    도ᄂᄌ: "돉",
    도ᄂᄒ: "돊",
    도ᄃ: "돋",
    도ᄅ: "돌",
    도ᄅᄀ: "돍",
    도ᄅᄆ: "돎",
    도ᄅᄇ: "돏",
    도ᄅᄉ: "돐",
    도ᄅᄐ: "돑",
    도ᄅᄑ: "돒",
    도ᄅᄒ: "돓",
    도ᄆ: "돔",
    도ᄇ: "돕",
    도ᄇᄉ: "돖",
    도ᄉ: "돗",
    도ᄊ: "돘",
    도ᄋ: "동",
    도ᄌ: "돚",
    도ᄎ: "돛",
    도ᄏ: "돜",
    도ᄐ: "돝",
    도ᄑ: "돞",
    도ᄒ: "돟",
    도ᅡ: "돠",
    도ᅡᄀ: "돡",
    도ᅡᄁ: "돢",
    도ᅡᄀᄉ: "돣",
    도ᅡᄂ: "돤",
    도ᅡᄂᄌ: "돥",
    도ᅡᄂᄒ: "돦",
    도ᅡᄃ: "돧",
    도ᅡᄅ: "돨",
    도ᅡᄅᄀ: "돩",
    도ᅡᄅᄆ: "돪",
    도ᅡᄅᄇ: "돫",
    도ᅡᄅᄉ: "돬",
    도ᅡᄅᄐ: "돭",
    도ᅡᄅᄑ: "돮",
    도ᅡᄅᄒ: "돯",
    도ᅡᄆ: "돰",
    도ᅡᄇ: "돱",
    도ᅡᄇᄉ: "돲",
    도ᅡᄉ: "돳",
    도ᅡᄊ: "돴",
    도ᅡᄋ: "돵",
    도ᅡᄌ: "돶",
    도ᅡᄎ: "돷",
    도ᅡᄏ: "돸",
    도ᅡᄐ: "돹",
    도ᅡᄑ: "돺",
    도ᅡᄒ: "돻",
    도ᅢ: "돼",
    도ᅢᄀ: "돽",
    도ᅢᄁ: "돾",
    도ᅢᄀᄉ: "돿",
    도ᅢᄂ: "됀",
    도ᅢᄂᄌ: "됁",
    도ᅢᄂᄒ: "됂",
    도ᅢᄃ: "됃",
    도ᅢᄅ: "됄",
    도ᅢᄅᄀ: "됅",
    도ᅢᄅᄆ: "됆",
    도ᅢᄅᄇ: "됇",
    도ᅢᄅᄉ: "됈",
    도ᅢᄅᄐ: "됉",
    도ᅢᄅᄑ: "됊",
    도ᅢᄅᄒ: "됋",
    도ᅢᄆ: "됌",
    도ᅢᄇ: "됍",
    도ᅢᄇᄉ: "됎",
    도ᅢᄉ: "됏",
    도ᅢᄊ: "됐",
    도ᅢᄋ: "됑",
    도ᅢᄌ: "됒",
    도ᅢᄎ: "됓",
    도ᅢᄏ: "됔",
    도ᅢᄐ: "됕",
    도ᅢᄑ: "됖",
    도ᅢᄒ: "됗",
    도ᅵ: "되",
    도ᅵᄀ: "됙",
    도ᅵᄁ: "됚",
    도ᅵᄀᄉ: "됛",
    도ᅵᄂ: "된",
    도ᅵᄂᄌ: "됝",
    도ᅵᄂᄒ: "됞",
    도ᅵᄃ: "됟",
    도ᅵᄅ: "될",
    도ᅵᄅᄀ: "됡",
    도ᅵᄅᄆ: "됢",
    도ᅵᄅᄇ: "됣",
    도ᅵᄅᄉ: "됤",
    도ᅵᄅᄐ: "됥",
    도ᅵᄅᄑ: "됦",
    도ᅵᄅᄒ: "됧",
    도ᅵᄆ: "됨",
    도ᅵᄇ: "됩",
    도ᅵᄇᄉ: "됪",
    도ᅵᄉ: "됫",
    도ᅵᄊ: "됬",
    도ᅵᄋ: "됭",
    도ᅵᄌ: "됮",
    도ᅵᄎ: "됯",
    도ᅵᄏ: "됰",
    도ᅵᄐ: "됱",
    도ᅵᄑ: "됲",
    도ᅵᄒ: "됳",
    됴: "됴",
    됴ᄀ: "됵",
    됴ᄁ: "됶",
    됴ᄀᄉ: "됷",
    됴ᄂ: "됸",
    됴ᄂᄌ: "됹",
    됴ᄂᄒ: "됺",
    됴ᄃ: "됻",
    됴ᄅ: "됼",
    됴ᄅᄀ: "됽",
    됴ᄅᄆ: "됾",
    됴ᄅᄇ: "됿",
    됴ᄅᄉ: "둀",
    됴ᄅᄐ: "둁",
    됴ᄅᄑ: "둂",
    됴ᄅᄒ: "둃",
    됴ᄆ: "둄",
    됴ᄇ: "둅",
    됴ᄇᄉ: "둆",
    됴ᄉ: "둇",
    됴ᄊ: "둈",
    됴ᄋ: "둉",
    됴ᄌ: "둊",
    됴ᄎ: "둋",
    됴ᄏ: "둌",
    됴ᄐ: "둍",
    됴ᄑ: "둎",
    됴ᄒ: "둏",
    두: "두",
    두ᄀ: "둑",
    두ᄁ: "둒",
    두ᄀᄉ: "둓",
    두ᄂ: "둔",
    두ᄂᄌ: "둕",
    두ᄂᄒ: "둖",
    두ᄃ: "둗",
    두ᄅ: "둘",
    두ᄅᄀ: "둙",
    두ᄅᄆ: "둚",
    두ᄅᄇ: "둛",
    두ᄅᄉ: "둜",
    두ᄅᄐ: "둝",
    두ᄅᄑ: "둞",
    두ᄅᄒ: "둟",
    두ᄆ: "둠",
    두ᄇ: "둡",
    두ᄇᄉ: "둢",
    두ᄉ: "둣",
    두ᄊ: "둤",
    두ᄋ: "둥",
    두ᄌ: "둦",
    두ᄎ: "둧",
    두ᄏ: "둨",
    두ᄐ: "둩",
    두ᄑ: "둪",
    두ᄒ: "둫",
    두ᅥ: "둬",
    두ᅥᄀ: "둭",
    두ᅥᄁ: "둮",
    두ᅥᄀᄉ: "둯",
    두ᅥᄂ: "둰",
    두ᅥᄂᄌ: "둱",
    두ᅥᄂᄒ: "둲",
    두ᅥᄃ: "둳",
    두ᅥᄅ: "둴",
    두ᅥᄅᄀ: "둵",
    두ᅥᄅᄆ: "둶",
    두ᅥᄅᄇ: "둷",
    두ᅥᄅᄉ: "둸",
    두ᅥᄅᄐ: "둹",
    두ᅥᄅᄑ: "둺",
    두ᅥᄅᄒ: "둻",
    두ᅥᄆ: "둼",
    두ᅥᄇ: "둽",
    두ᅥᄇᄉ: "둾",
    두ᅥᄉ: "둿",
    두ᅥᄊ: "뒀",
    두ᅥᄋ: "뒁",
    두ᅥᄌ: "뒂",
    두ᅥᄎ: "뒃",
    두ᅥᄏ: "뒄",
    두ᅥᄐ: "뒅",
    두ᅥᄑ: "뒆",
    두ᅥᄒ: "뒇",
    두ᅦ: "뒈",
    두ᅦᄀ: "뒉",
    두ᅦᄁ: "뒊",
    두ᅦᄀᄉ: "뒋",
    두ᅦᄂ: "뒌",
    두ᅦᄂᄌ: "뒍",
    두ᅦᄂᄒ: "뒎",
    두ᅦᄃ: "뒏",
    두ᅦᄅ: "뒐",
    두ᅦᄅᄀ: "뒑",
    두ᅦᄅᄆ: "뒒",
    두ᅦᄅᄇ: "뒓",
    두ᅦᄅᄉ: "뒔",
    두ᅦᄅᄐ: "뒕",
    두ᅦᄅᄑ: "뒖",
    두ᅦᄅᄒ: "뒗",
    두ᅦᄆ: "뒘",
    두ᅦᄇ: "뒙",
    두ᅦᄇᄉ: "뒚",
    두ᅦᄉ: "뒛",
    두ᅦᄊ: "뒜",
    두ᅦᄋ: "뒝",
    두ᅦᄌ: "뒞",
    두ᅦᄎ: "뒟",
    두ᅦᄏ: "뒠",
    두ᅦᄐ: "뒡",
    두ᅦᄑ: "뒢",
    두ᅦᄒ: "뒣",
    두ᅵ: "뒤",
    두ᅵᄀ: "뒥",
    두ᅵᄁ: "뒦",
    두ᅵᄀᄉ: "뒧",
    두ᅵᄂ: "뒨",
    두ᅵᄂᄌ: "뒩",
    두ᅵᄂᄒ: "뒪",
    두ᅵᄃ: "뒫",
    두ᅵᄅ: "뒬",
    두ᅵᄅᄀ: "뒭",
    두ᅵᄅᄆ: "뒮",
    두ᅵᄅᄇ: "뒯",
    두ᅵᄅᄉ: "뒰",
    두ᅵᄅᄐ: "뒱",
    두ᅵᄅᄑ: "뒲",
    두ᅵᄅᄒ: "뒳",
    두ᅵᄆ: "뒴",
    두ᅵᄇ: "뒵",
    두ᅵᄇᄉ: "뒶",
    두ᅵᄉ: "뒷",
    두ᅵᄊ: "뒸",
    두ᅵᄋ: "뒹",
    두ᅵᄌ: "뒺",
    두ᅵᄎ: "뒻",
    두ᅵᄏ: "뒼",
    두ᅵᄐ: "뒽",
    두ᅵᄑ: "뒾",
    두ᅵᄒ: "뒿",
    듀: "듀",
    듀ᄀ: "듁",
    듀ᄁ: "듂",
    듀ᄀᄉ: "듃",
    듀ᄂ: "듄",
    듀ᄂᄌ: "듅",
    듀ᄂᄒ: "듆",
    듀ᄃ: "듇",
    듀ᄅ: "듈",
    듀ᄅᄀ: "듉",
    듀ᄅᄆ: "듊",
    듀ᄅᄇ: "듋",
    듀ᄅᄉ: "듌",
    듀ᄅᄐ: "듍",
    듀ᄅᄑ: "듎",
    듀ᄅᄒ: "듏",
    듀ᄆ: "듐",
    듀ᄇ: "듑",
    듀ᄇᄉ: "듒",
    듀ᄉ: "듓",
    듀ᄊ: "듔",
    듀ᄋ: "듕",
    듀ᄌ: "듖",
    듀ᄎ: "듗",
    듀ᄏ: "듘",
    듀ᄐ: "듙",
    듀ᄑ: "듚",
    듀ᄒ: "듛",
    드: "드",
    드ᄀ: "득",
    드ᄁ: "듞",
    드ᄀᄉ: "듟",
    드ᄂ: "든",
    드ᄂᄌ: "듡",
    드ᄂᄒ: "듢",
    드ᄃ: "듣",
    드ᄅ: "들",
    드ᄅᄀ: "듥",
    드ᄅᄆ: "듦",
    드ᄅᄇ: "듧",
    드ᄅᄉ: "듨",
    드ᄅᄐ: "듩",
    드ᄅᄑ: "듪",
    드ᄅᄒ: "듫",
    드ᄆ: "듬",
    드ᄇ: "듭",
    드ᄇᄉ: "듮",
    드ᄉ: "듯",
    드ᄊ: "듰",
    드ᄋ: "등",
    드ᄌ: "듲",
    드ᄎ: "듳",
    드ᄏ: "듴",
    드ᄐ: "듵",
    드ᄑ: "듶",
    드ᄒ: "듷",
    드ᅵ: "듸",
    드ᅵᄀ: "듹",
    드ᅵᄁ: "듺",
    드ᅵᄀᄉ: "듻",
    드ᅵᄂ: "듼",
    드ᅵᄂᄌ: "듽",
    드ᅵᄂᄒ: "듾",
    드ᅵᄃ: "듿",
    드ᅵᄅ: "딀",
    드ᅵᄅᄀ: "딁",
    드ᅵᄅᄆ: "딂",
    드ᅵᄅᄇ: "딃",
    드ᅵᄅᄉ: "딄",
    드ᅵᄅᄐ: "딅",
    드ᅵᄅᄑ: "딆",
    드ᅵᄅᄒ: "딇",
    드ᅵᄆ: "딈",
    드ᅵᄇ: "딉",
    드ᅵᄇᄉ: "딊",
    드ᅵᄉ: "딋",
    드ᅵᄊ: "딌",
    드ᅵᄋ: "딍",
    드ᅵᄌ: "딎",
    드ᅵᄎ: "딏",
    드ᅵᄏ: "딐",
    드ᅵᄐ: "딑",
    드ᅵᄑ: "딒",
    드ᅵᄒ: "딓",
    디: "디",
    디ᄀ: "딕",
    디ᄁ: "딖",
    디ᄀᄉ: "딗",
    디ᄂ: "딘",
    디ᄂᄌ: "딙",
    디ᄂᄒ: "딚",
    디ᄃ: "딛",
    디ᄅ: "딜",
    디ᄅᄀ: "딝",
    디ᄅᄆ: "딞",
    디ᄅᄇ: "딟",
    디ᄅᄉ: "딠",
    디ᄅᄐ: "딡",
    디ᄅᄑ: "딢",
    디ᄅᄒ: "딣",
    디ᄆ: "딤",
    디ᄇ: "딥",
    디ᄇᄉ: "딦",
    디ᄉ: "딧",
    디ᄊ: "딨",
    디ᄋ: "딩",
    디ᄌ: "딪",
    디ᄎ: "딫",
    디ᄏ: "딬",
    디ᄐ: "딭",
    디ᄑ: "딮",
    디ᄒ: "딯",
    따: "따",
    따ᄀ: "딱",
    따ᄁ: "딲",
    따ᄀᄉ: "딳",
    따ᄂ: "딴",
    따ᄂᄌ: "딵",
    따ᄂᄒ: "딶",
    따ᄃ: "딷",
    따ᄅ: "딸",
    따ᄅᄀ: "딹",
    따ᄅᄆ: "딺",
    따ᄅᄇ: "딻",
    따ᄅᄉ: "딼",
    따ᄅᄐ: "딽",
    따ᄅᄑ: "딾",
    따ᄅᄒ: "딿",
    따ᄆ: "땀",
    따ᄇ: "땁",
    따ᄇᄉ: "땂",
    따ᄉ: "땃",
    따ᄊ: "땄",
    따ᄋ: "땅",
    따ᄌ: "땆",
    따ᄎ: "땇",
    따ᄏ: "땈",
    따ᄐ: "땉",
    따ᄑ: "땊",
    따ᄒ: "땋",
    때: "때",
    때ᄀ: "땍",
    때ᄁ: "땎",
    때ᄀᄉ: "땏",
    때ᄂ: "땐",
    때ᄂᄌ: "땑",
    때ᄂᄒ: "땒",
    때ᄃ: "땓",
    때ᄅ: "땔",
    때ᄅᄀ: "땕",
    때ᄅᄆ: "땖",
    때ᄅᄇ: "땗",
    때ᄅᄉ: "땘",
    때ᄅᄐ: "땙",
    때ᄅᄑ: "땚",
    때ᄅᄒ: "땛",
    때ᄆ: "땜",
    때ᄇ: "땝",
    때ᄇᄉ: "땞",
    때ᄉ: "땟",
    때ᄊ: "땠",
    때ᄋ: "땡",
    때ᄌ: "땢",
    때ᄎ: "땣",
    때ᄏ: "땤",
    때ᄐ: "땥",
    때ᄑ: "땦",
    때ᄒ: "땧",
    땨: "땨",
    땨ᄀ: "땩",
    땨ᄁ: "땪",
    땨ᄀᄉ: "땫",
    땨ᄂ: "땬",
    땨ᄂᄌ: "땭",
    땨ᄂᄒ: "땮",
    땨ᄃ: "땯",
    땨ᄅ: "땰",
    땨ᄅᄀ: "땱",
    땨ᄅᄆ: "땲",
    땨ᄅᄇ: "땳",
    땨ᄅᄉ: "땴",
    땨ᄅᄐ: "땵",
    땨ᄅᄑ: "땶",
    땨ᄅᄒ: "땷",
    땨ᄆ: "땸",
    땨ᄇ: "땹",
    땨ᄇᄉ: "땺",
    땨ᄉ: "땻",
    땨ᄊ: "땼",
    땨ᄋ: "땽",
    땨ᄌ: "땾",
    땨ᄎ: "땿",
    땨ᄏ: "떀",
    땨ᄐ: "떁",
    땨ᄑ: "떂",
    땨ᄒ: "떃",
    떄: "떄",
    떄ᄀ: "떅",
    떄ᄁ: "떆",
    떄ᄀᄉ: "떇",
    떄ᄂ: "떈",
    떄ᄂᄌ: "떉",
    떄ᄂᄒ: "떊",
    떄ᄃ: "떋",
    떄ᄅ: "떌",
    떄ᄅᄀ: "떍",
    떄ᄅᄆ: "떎",
    떄ᄅᄇ: "떏",
    떄ᄅᄉ: "떐",
    떄ᄅᄐ: "떑",
    떄ᄅᄑ: "떒",
    떄ᄅᄒ: "떓",
    떄ᄆ: "떔",
    떄ᄇ: "떕",
    떄ᄇᄉ: "떖",
    떄ᄉ: "떗",
    떄ᄊ: "떘",
    떄ᄋ: "떙",
    떄ᄌ: "떚",
    떄ᄎ: "떛",
    떄ᄏ: "떜",
    떄ᄐ: "떝",
    떄ᄑ: "떞",
    떄ᄒ: "떟",
    떠: "떠",
    떠ᄀ: "떡",
    떠ᄁ: "떢",
    떠ᄀᄉ: "떣",
    떠ᄂ: "떤",
    떠ᄂᄌ: "떥",
    떠ᄂᄒ: "떦",
    떠ᄃ: "떧",
    떠ᄅ: "떨",
    떠ᄅᄀ: "떩",
    떠ᄅᄆ: "떪",
    떠ᄅᄇ: "떫",
    떠ᄅᄉ: "떬",
    떠ᄅᄐ: "떭",
    떠ᄅᄑ: "떮",
    떠ᄅᄒ: "떯",
    떠ᄆ: "떰",
    떠ᄇ: "떱",
    떠ᄇᄉ: "떲",
    떠ᄉ: "떳",
    떠ᄊ: "떴",
    떠ᄋ: "떵",
    떠ᄌ: "떶",
    떠ᄎ: "떷",
    떠ᄏ: "떸",
    떠ᄐ: "떹",
    떠ᄑ: "떺",
    떠ᄒ: "떻",
    떼: "떼",
    떼ᄀ: "떽",
    떼ᄁ: "떾",
    떼ᄀᄉ: "떿",
    떼ᄂ: "뗀",
    떼ᄂᄌ: "뗁",
    떼ᄂᄒ: "뗂",
    떼ᄃ: "뗃",
    떼ᄅ: "뗄",
    떼ᄅᄀ: "뗅",
    떼ᄅᄆ: "뗆",
    떼ᄅᄇ: "뗇",
    떼ᄅᄉ: "뗈",
    떼ᄅᄐ: "뗉",
    떼ᄅᄑ: "뗊",
    떼ᄅᄒ: "뗋",
    떼ᄆ: "뗌",
    떼ᄇ: "뗍",
    떼ᄇᄉ: "뗎",
    떼ᄉ: "뗏",
    떼ᄊ: "뗐",
    떼ᄋ: "뗑",
    떼ᄌ: "뗒",
    떼ᄎ: "뗓",
    떼ᄏ: "뗔",
    떼ᄐ: "뗕",
    떼ᄑ: "뗖",
    떼ᄒ: "뗗",
    뗘: "뗘",
    뗘ᄀ: "뗙",
    뗘ᄁ: "뗚",
    뗘ᄀᄉ: "뗛",
    뗘ᄂ: "뗜",
    뗘ᄂᄌ: "뗝",
    뗘ᄂᄒ: "뗞",
    뗘ᄃ: "뗟",
    뗘ᄅ: "뗠",
    뗘ᄅᄀ: "뗡",
    뗘ᄅᄆ: "뗢",
    뗘ᄅᄇ: "뗣",
    뗘ᄅᄉ: "뗤",
    뗘ᄅᄐ: "뗥",
    뗘ᄅᄑ: "뗦",
    뗘ᄅᄒ: "뗧",
    뗘ᄆ: "뗨",
    뗘ᄇ: "뗩",
    뗘ᄇᄉ: "뗪",
    뗘ᄉ: "뗫",
    뗘ᄊ: "뗬",
    뗘ᄋ: "뗭",
    뗘ᄌ: "뗮",
    뗘ᄎ: "뗯",
    뗘ᄏ: "뗰",
    뗘ᄐ: "뗱",
    뗘ᄑ: "뗲",
    뗘ᄒ: "뗳",
    뗴: "뗴",
    뗴ᄀ: "뗵",
    뗴ᄁ: "뗶",
    뗴ᄀᄉ: "뗷",
    뗴ᄂ: "뗸",
    뗴ᄂᄌ: "뗹",
    뗴ᄂᄒ: "뗺",
    뗴ᄃ: "뗻",
    뗴ᄅ: "뗼",
    뗴ᄅᄀ: "뗽",
    뗴ᄅᄆ: "뗾",
    뗴ᄅᄇ: "뗿",
    뗴ᄅᄉ: "똀",
    뗴ᄅᄐ: "똁",
    뗴ᄅᄑ: "똂",
    뗴ᄅᄒ: "똃",
    뗴ᄆ: "똄",
    뗴ᄇ: "똅",
    뗴ᄇᄉ: "똆",
    뗴ᄉ: "똇",
    뗴ᄊ: "똈",
    뗴ᄋ: "똉",
    뗴ᄌ: "똊",
    뗴ᄎ: "똋",
    뗴ᄏ: "똌",
    뗴ᄐ: "똍",
    뗴ᄑ: "똎",
    뗴ᄒ: "똏",
    또: "또",
    또ᄀ: "똑",
    또ᄁ: "똒",
    또ᄀᄉ: "똓",
    또ᄂ: "똔",
    또ᄂᄌ: "똕",
    또ᄂᄒ: "똖",
    또ᄃ: "똗",
    또ᄅ: "똘",
    또ᄅᄀ: "똙",
    또ᄅᄆ: "똚",
    또ᄅᄇ: "똛",
    또ᄅᄉ: "똜",
    또ᄅᄐ: "똝",
    또ᄅᄑ: "똞",
    또ᄅᄒ: "똟",
    또ᄆ: "똠",
    또ᄇ: "똡",
    또ᄇᄉ: "똢",
    또ᄉ: "똣",
    또ᄊ: "똤",
    또ᄋ: "똥",
    또ᄌ: "똦",
    또ᄎ: "똧",
    또ᄏ: "똨",
    또ᄐ: "똩",
    또ᄑ: "똪",
    또ᄒ: "똫",
    또ᅡ: "똬",
    또ᅡᄀ: "똭",
    또ᅡᄁ: "똮",
    또ᅡᄀᄉ: "똯",
    또ᅡᄂ: "똰",
    또ᅡᄂᄌ: "똱",
    또ᅡᄂᄒ: "똲",
    또ᅡᄃ: "똳",
    또ᅡᄅ: "똴",
    또ᅡᄅᄀ: "똵",
    또ᅡᄅᄆ: "똶",
    또ᅡᄅᄇ: "똷",
    또ᅡᄅᄉ: "똸",
    또ᅡᄅᄐ: "똹",
    또ᅡᄅᄑ: "똺",
    또ᅡᄅᄒ: "똻",
    또ᅡᄆ: "똼",
    또ᅡᄇ: "똽",
    또ᅡᄇᄉ: "똾",
    또ᅡᄉ: "똿",
    또ᅡᄊ: "뙀",
    또ᅡᄋ: "뙁",
    또ᅡᄌ: "뙂",
    또ᅡᄎ: "뙃",
    또ᅡᄏ: "뙄",
    또ᅡᄐ: "뙅",
    또ᅡᄑ: "뙆",
    또ᅡᄒ: "뙇",
    또ᅢ: "뙈",
    또ᅢᄀ: "뙉",
    또ᅢᄁ: "뙊",
    또ᅢᄀᄉ: "뙋",
    또ᅢᄂ: "뙌",
    또ᅢᄂᄌ: "뙍",
    또ᅢᄂᄒ: "뙎",
    또ᅢᄃ: "뙏",
    또ᅢᄅ: "뙐",
    또ᅢᄅᄀ: "뙑",
    또ᅢᄅᄆ: "뙒",
    또ᅢᄅᄇ: "뙓",
    또ᅢᄅᄉ: "뙔",
    또ᅢᄅᄐ: "뙕",
    또ᅢᄅᄑ: "뙖",
    또ᅢᄅᄒ: "뙗",
    또ᅢᄆ: "뙘",
    또ᅢᄇ: "뙙",
    또ᅢᄇᄉ: "뙚",
    또ᅢᄉ: "뙛",
    또ᅢᄊ: "뙜",
    또ᅢᄋ: "뙝",
    또ᅢᄌ: "뙞",
    또ᅢᄎ: "뙟",
    또ᅢᄏ: "뙠",
    또ᅢᄐ: "뙡",
    또ᅢᄑ: "뙢",
    또ᅢᄒ: "뙣",
    또ᅵ: "뙤",
    또ᅵᄀ: "뙥",
    또ᅵᄁ: "뙦",
    또ᅵᄀᄉ: "뙧",
    또ᅵᄂ: "뙨",
    또ᅵᄂᄌ: "뙩",
    또ᅵᄂᄒ: "뙪",
    또ᅵᄃ: "뙫",
    또ᅵᄅ: "뙬",
    또ᅵᄅᄀ: "뙭",
    또ᅵᄅᄆ: "뙮",
    또ᅵᄅᄇ: "뙯",
    또ᅵᄅᄉ: "뙰",
    또ᅵᄅᄐ: "뙱",
    또ᅵᄅᄑ: "뙲",
    또ᅵᄅᄒ: "뙳",
    또ᅵᄆ: "뙴",
    또ᅵᄇ: "뙵",
    또ᅵᄇᄉ: "뙶",
    또ᅵᄉ: "뙷",
    또ᅵᄊ: "뙸",
    또ᅵᄋ: "뙹",
    또ᅵᄌ: "뙺",
    또ᅵᄎ: "뙻",
    또ᅵᄏ: "뙼",
    또ᅵᄐ: "뙽",
    또ᅵᄑ: "뙾",
    또ᅵᄒ: "뙿",
    뚀: "뚀",
    뚀ᄀ: "뚁",
    뚀ᄁ: "뚂",
    뚀ᄀᄉ: "뚃",
    뚀ᄂ: "뚄",
    뚀ᄂᄌ: "뚅",
    뚀ᄂᄒ: "뚆",
    뚀ᄃ: "뚇",
    뚀ᄅ: "뚈",
    뚀ᄅᄀ: "뚉",
    뚀ᄅᄆ: "뚊",
    뚀ᄅᄇ: "뚋",
    뚀ᄅᄉ: "뚌",
    뚀ᄅᄐ: "뚍",
    뚀ᄅᄑ: "뚎",
    뚀ᄅᄒ: "뚏",
    뚀ᄆ: "뚐",
    뚀ᄇ: "뚑",
    뚀ᄇᄉ: "뚒",
    뚀ᄉ: "뚓",
    뚀ᄊ: "뚔",
    뚀ᄋ: "뚕",
    뚀ᄌ: "뚖",
    뚀ᄎ: "뚗",
    뚀ᄏ: "뚘",
    뚀ᄐ: "뚙",
    뚀ᄑ: "뚚",
    뚀ᄒ: "뚛",
    뚜: "뚜",
    뚜ᄀ: "뚝",
    뚜ᄁ: "뚞",
    뚜ᄀᄉ: "뚟",
    뚜ᄂ: "뚠",
    뚜ᄂᄌ: "뚡",
    뚜ᄂᄒ: "뚢",
    뚜ᄃ: "뚣",
    뚜ᄅ: "뚤",
    뚜ᄅᄀ: "뚥",
    뚜ᄅᄆ: "뚦",
    뚜ᄅᄇ: "뚧",
    뚜ᄅᄉ: "뚨",
    뚜ᄅᄐ: "뚩",
    뚜ᄅᄑ: "뚪",
    뚜ᄅᄒ: "뚫",
    뚜ᄆ: "뚬",
    뚜ᄇ: "뚭",
    뚜ᄇᄉ: "뚮",
    뚜ᄉ: "뚯",
    뚜ᄊ: "뚰",
    뚜ᄋ: "뚱",
    뚜ᄌ: "뚲",
    뚜ᄎ: "뚳",
    뚜ᄏ: "뚴",
    뚜ᄐ: "뚵",
    뚜ᄑ: "뚶",
    뚜ᄒ: "뚷",
    뚜ᅥ: "뚸",
    뚜ᅥᄀ: "뚹",
    뚜ᅥᄁ: "뚺",
    뚜ᅥᄀᄉ: "뚻",
    뚜ᅥᄂ: "뚼",
    뚜ᅥᄂᄌ: "뚽",
    뚜ᅥᄂᄒ: "뚾",
    뚜ᅥᄃ: "뚿",
    뚜ᅥᄅ: "뛀",
    뚜ᅥᄅᄀ: "뛁",
    뚜ᅥᄅᄆ: "뛂",
    뚜ᅥᄅᄇ: "뛃",
    뚜ᅥᄅᄉ: "뛄",
    뚜ᅥᄅᄐ: "뛅",
    뚜ᅥᄅᄑ: "뛆",
    뚜ᅥᄅᄒ: "뛇",
    뚜ᅥᄆ: "뛈",
    뚜ᅥᄇ: "뛉",
    뚜ᅥᄇᄉ: "뛊",
    뚜ᅥᄉ: "뛋",
    뚜ᅥᄊ: "뛌",
    뚜ᅥᄋ: "뛍",
    뚜ᅥᄌ: "뛎",
    뚜ᅥᄎ: "뛏",
    뚜ᅥᄏ: "뛐",
    뚜ᅥᄐ: "뛑",
    뚜ᅥᄑ: "뛒",
    뚜ᅥᄒ: "뛓",
    뚜ᅦ: "뛔",
    뚜ᅦᄀ: "뛕",
    뚜ᅦᄁ: "뛖",
    뚜ᅦᄀᄉ: "뛗",
    뚜ᅦᄂ: "뛘",
    뚜ᅦᄂᄌ: "뛙",
    뚜ᅦᄂᄒ: "뛚",
    뚜ᅦᄃ: "뛛",
    뚜ᅦᄅ: "뛜",
    뚜ᅦᄅᄀ: "뛝",
    뚜ᅦᄅᄆ: "뛞",
    뚜ᅦᄅᄇ: "뛟",
    뚜ᅦᄅᄉ: "뛠",
    뚜ᅦᄅᄐ: "뛡",
    뚜ᅦᄅᄑ: "뛢",
    뚜ᅦᄅᄒ: "뛣",
    뚜ᅦᄆ: "뛤",
    뚜ᅦᄇ: "뛥",
    뚜ᅦᄇᄉ: "뛦",
    뚜ᅦᄉ: "뛧",
    뚜ᅦᄊ: "뛨",
    뚜ᅦᄋ: "뛩",
    뚜ᅦᄌ: "뛪",
    뚜ᅦᄎ: "뛫",
    뚜ᅦᄏ: "뛬",
    뚜ᅦᄐ: "뛭",
    뚜ᅦᄑ: "뛮",
    뚜ᅦᄒ: "뛯",
    뚜ᅵ: "뛰",
    뚜ᅵᄀ: "뛱",
    뚜ᅵᄁ: "뛲",
    뚜ᅵᄀᄉ: "뛳",
    뚜ᅵᄂ: "뛴",
    뚜ᅵᄂᄌ: "뛵",
    뚜ᅵᄂᄒ: "뛶",
    뚜ᅵᄃ: "뛷",
    뚜ᅵᄅ: "뛸",
    뚜ᅵᄅᄀ: "뛹",
    뚜ᅵᄅᄆ: "뛺",
    뚜ᅵᄅᄇ: "뛻",
    뚜ᅵᄅᄉ: "뛼",
    뚜ᅵᄅᄐ: "뛽",
    뚜ᅵᄅᄑ: "뛾",
    뚜ᅵᄅᄒ: "뛿",
    뚜ᅵᄆ: "뜀",
    뚜ᅵᄇ: "뜁",
    뚜ᅵᄇᄉ: "뜂",
    뚜ᅵᄉ: "뜃",
    뚜ᅵᄊ: "뜄",
    뚜ᅵᄋ: "뜅",
    뚜ᅵᄌ: "뜆",
    뚜ᅵᄎ: "뜇",
    뚜ᅵᄏ: "뜈",
    뚜ᅵᄐ: "뜉",
    뚜ᅵᄑ: "뜊",
    뚜ᅵᄒ: "뜋",
    뜌: "뜌",
    뜌ᄀ: "뜍",
    뜌ᄁ: "뜎",
    뜌ᄀᄉ: "뜏",
    뜌ᄂ: "뜐",
    뜌ᄂᄌ: "뜑",
    뜌ᄂᄒ: "뜒",
    뜌ᄃ: "뜓",
    뜌ᄅ: "뜔",
    뜌ᄅᄀ: "뜕",
    뜌ᄅᄆ: "뜖",
    뜌ᄅᄇ: "뜗",
    뜌ᄅᄉ: "뜘",
    뜌ᄅᄐ: "뜙",
    뜌ᄅᄑ: "뜚",
    뜌ᄅᄒ: "뜛",
    뜌ᄆ: "뜜",
    뜌ᄇ: "뜝",
    뜌ᄇᄉ: "뜞",
    뜌ᄉ: "뜟",
    뜌ᄊ: "뜠",
    뜌ᄋ: "뜡",
    뜌ᄌ: "뜢",
    뜌ᄎ: "뜣",
    뜌ᄏ: "뜤",
    뜌ᄐ: "뜥",
    뜌ᄑ: "뜦",
    뜌ᄒ: "뜧",
    뜨: "뜨",
    뜨ᄀ: "뜩",
    뜨ᄁ: "뜪",
    뜨ᄀᄉ: "뜫",
    뜨ᄂ: "뜬",
    뜨ᄂᄌ: "뜭",
    뜨ᄂᄒ: "뜮",
    뜨ᄃ: "뜯",
    뜨ᄅ: "뜰",
    뜨ᄅᄀ: "뜱",
    뜨ᄅᄆ: "뜲",
    뜨ᄅᄇ: "뜳",
    뜨ᄅᄉ: "뜴",
    뜨ᄅᄐ: "뜵",
    뜨ᄅᄑ: "뜶",
    뜨ᄅᄒ: "뜷",
    뜨ᄆ: "뜸",
    뜨ᄇ: "뜹",
    뜨ᄇᄉ: "뜺",
    뜨ᄉ: "뜻",
    뜨ᄊ: "뜼",
    뜨ᄋ: "뜽",
    뜨ᄌ: "뜾",
    뜨ᄎ: "뜿",
    뜨ᄏ: "띀",
    뜨ᄐ: "띁",
    뜨ᄑ: "띂",
    뜨ᄒ: "띃",
    뜨ᅵ: "띄",
    뜨ᅵᄀ: "띅",
    뜨ᅵᄁ: "띆",
    뜨ᅵᄀᄉ: "띇",
    뜨ᅵᄂ: "띈",
    뜨ᅵᄂᄌ: "띉",
    뜨ᅵᄂᄒ: "띊",
    뜨ᅵᄃ: "띋",
    뜨ᅵᄅ: "띌",
    뜨ᅵᄅᄀ: "띍",
    뜨ᅵᄅᄆ: "띎",
    뜨ᅵᄅᄇ: "띏",
    뜨ᅵᄅᄉ: "띐",
    뜨ᅵᄅᄐ: "띑",
    뜨ᅵᄅᄑ: "띒",
    뜨ᅵᄅᄒ: "띓",
    뜨ᅵᄆ: "띔",
    뜨ᅵᄇ: "띕",
    뜨ᅵᄇᄉ: "띖",
    뜨ᅵᄉ: "띗",
    뜨ᅵᄊ: "띘",
    뜨ᅵᄋ: "띙",
    뜨ᅵᄌ: "띚",
    뜨ᅵᄎ: "띛",
    뜨ᅵᄏ: "띜",
    뜨ᅵᄐ: "띝",
    뜨ᅵᄑ: "띞",
    뜨ᅵᄒ: "띟",
    띠: "띠",
    띠ᄀ: "띡",
    띠ᄁ: "띢",
    띠ᄀᄉ: "띣",
    띠ᄂ: "띤",
    띠ᄂᄌ: "띥",
    띠ᄂᄒ: "띦",
    띠ᄃ: "띧",
    띠ᄅ: "띨",
    띠ᄅᄀ: "띩",
    띠ᄅᄆ: "띪",
    띠ᄅᄇ: "띫",
    띠ᄅᄉ: "띬",
    띠ᄅᄐ: "띭",
    띠ᄅᄑ: "띮",
    띠ᄅᄒ: "띯",
    띠ᄆ: "띰",
    띠ᄇ: "띱",
    띠ᄇᄉ: "띲",
    띠ᄉ: "띳",
    띠ᄊ: "띴",
    띠ᄋ: "띵",
    띠ᄌ: "띶",
    띠ᄎ: "띷",
    띠ᄏ: "띸",
    띠ᄐ: "띹",
    띠ᄑ: "띺",
    띠ᄒ: "띻",
    라: "라",
    라ᄀ: "락",
    라ᄁ: "띾",
    라ᄀᄉ: "띿",
    라ᄂ: "란",
    라ᄂᄌ: "랁",
    라ᄂᄒ: "랂",
    라ᄃ: "랃",
    라ᄅ: "랄",
    라ᄅᄀ: "랅",
    라ᄅᄆ: "랆",
    라ᄅᄇ: "랇",
    라ᄅᄉ: "랈",
    라ᄅᄐ: "랉",
    라ᄅᄑ: "랊",
    라ᄅᄒ: "랋",
    라ᄆ: "람",
    라ᄇ: "랍",
    라ᄇᄉ: "랎",
    라ᄉ: "랏",
    라ᄊ: "랐",
    라ᄋ: "랑",
    라ᄌ: "랒",
    라ᄎ: "랓",
    라ᄏ: "랔",
    라ᄐ: "랕",
    라ᄑ: "랖",
    라ᄒ: "랗",
    래: "래",
    래ᄀ: "랙",
    래ᄁ: "랚",
    래ᄀᄉ: "랛",
    래ᄂ: "랜",
    래ᄂᄌ: "랝",
    래ᄂᄒ: "랞",
    래ᄃ: "랟",
    래ᄅ: "랠",
    래ᄅᄀ: "랡",
    래ᄅᄆ: "랢",
    래ᄅᄇ: "랣",
    래ᄅᄉ: "랤",
    래ᄅᄐ: "랥",
    래ᄅᄑ: "랦",
    래ᄅᄒ: "랧",
    래ᄆ: "램",
    래ᄇ: "랩",
    래ᄇᄉ: "랪",
    래ᄉ: "랫",
    래ᄊ: "랬",
    래ᄋ: "랭",
    래ᄌ: "랮",
    래ᄎ: "랯",
    래ᄏ: "랰",
    래ᄐ: "랱",
    래ᄑ: "랲",
    래ᄒ: "랳",
    랴: "랴",
    랴ᄀ: "략",
    랴ᄁ: "랶",
    랴ᄀᄉ: "랷",
    랴ᄂ: "랸",
    랴ᄂᄌ: "랹",
    랴ᄂᄒ: "랺",
    랴ᄃ: "랻",
    랴ᄅ: "랼",
    랴ᄅᄀ: "랽",
    랴ᄅᄆ: "랾",
    랴ᄅᄇ: "랿",
    랴ᄅᄉ: "럀",
    랴ᄅᄐ: "럁",
    랴ᄅᄑ: "럂",
    랴ᄅᄒ: "럃",
    랴ᄆ: "럄",
    랴ᄇ: "럅",
    랴ᄇᄉ: "럆",
    랴ᄉ: "럇",
    랴ᄊ: "럈",
    랴ᄋ: "량",
    랴ᄌ: "럊",
    랴ᄎ: "럋",
    랴ᄏ: "럌",
    랴ᄐ: "럍",
    랴ᄑ: "럎",
    랴ᄒ: "럏",
    럐: "럐",
    럐ᄀ: "럑",
    럐ᄁ: "럒",
    럐ᄀᄉ: "럓",
    럐ᄂ: "럔",
    럐ᄂᄌ: "럕",
    럐ᄂᄒ: "럖",
    럐ᄃ: "럗",
    럐ᄅ: "럘",
    럐ᄅᄀ: "럙",
    럐ᄅᄆ: "럚",
    럐ᄅᄇ: "럛",
    럐ᄅᄉ: "럜",
    럐ᄅᄐ: "럝",
    럐ᄅᄑ: "럞",
    럐ᄅᄒ: "럟",
    럐ᄆ: "럠",
    럐ᄇ: "럡",
    럐ᄇᄉ: "럢",
    럐ᄉ: "럣",
    럐ᄊ: "럤",
    럐ᄋ: "럥",
    럐ᄌ: "럦",
    럐ᄎ: "럧",
    럐ᄏ: "럨",
    럐ᄐ: "럩",
    럐ᄑ: "럪",
    럐ᄒ: "럫",
    러: "러",
    러ᄀ: "럭",
    러ᄁ: "럮",
    러ᄀᄉ: "럯",
    러ᄂ: "런",
    러ᄂᄌ: "럱",
    러ᄂᄒ: "럲",
    러ᄃ: "럳",
    러ᄅ: "럴",
    러ᄅᄀ: "럵",
    러ᄅᄆ: "럶",
    러ᄅᄇ: "럷",
    러ᄅᄉ: "럸",
    러ᄅᄐ: "럹",
    러ᄅᄑ: "럺",
    러ᄅᄒ: "럻",
    러ᄆ: "럼",
    러ᄇ: "럽",
    러ᄇᄉ: "럾",
    러ᄉ: "럿",
    러ᄊ: "렀",
    러ᄋ: "렁",
    러ᄌ: "렂",
    러ᄎ: "렃",
    러ᄏ: "렄",
    러ᄐ: "렅",
    러ᄑ: "렆",
    러ᄒ: "렇",
    레: "레",
    레ᄀ: "렉",
    레ᄁ: "렊",
    레ᄀᄉ: "렋",
    레ᄂ: "렌",
    레ᄂᄌ: "렍",
    레ᄂᄒ: "렎",
    레ᄃ: "렏",
    레ᄅ: "렐",
    레ᄅᄀ: "렑",
    레ᄅᄆ: "렒",
    레ᄅᄇ: "렓",
    레ᄅᄉ: "렔",
    레ᄅᄐ: "렕",
    레ᄅᄑ: "렖",
    레ᄅᄒ: "렗",
    레ᄆ: "렘",
    레ᄇ: "렙",
    레ᄇᄉ: "렚",
    레ᄉ: "렛",
    레ᄊ: "렜",
    레ᄋ: "렝",
    레ᄌ: "렞",
    레ᄎ: "렟",
    레ᄏ: "렠",
    레ᄐ: "렡",
    레ᄑ: "렢",
    레ᄒ: "렣",
    려: "려",
    려ᄀ: "력",
    려ᄁ: "렦",
    려ᄀᄉ: "렧",
    려ᄂ: "련",
    려ᄂᄌ: "렩",
    려ᄂᄒ: "렪",
    려ᄃ: "렫",
    려ᄅ: "렬",
    려ᄅᄀ: "렭",
    려ᄅᄆ: "렮",
    려ᄅᄇ: "렯",
    려ᄅᄉ: "렰",
    려ᄅᄐ: "렱",
    려ᄅᄑ: "렲",
    려ᄅᄒ: "렳",
    려ᄆ: "렴",
    려ᄇ: "렵",
    려ᄇᄉ: "렶",
    려ᄉ: "렷",
    려ᄊ: "렸",
    려ᄋ: "령",
    려ᄌ: "렺",
    려ᄎ: "렻",
    려ᄏ: "렼",
    려ᄐ: "렽",
    려ᄑ: "렾",
    려ᄒ: "렿",
    례: "례",
    례ᄀ: "롁",
    례ᄁ: "롂",
    례ᄀᄉ: "롃",
    례ᄂ: "롄",
    례ᄂᄌ: "롅",
    례ᄂᄒ: "롆",
    례ᄃ: "롇",
    례ᄅ: "롈",
    례ᄅᄀ: "롉",
    례ᄅᄆ: "롊",
    례ᄅᄇ: "롋",
    례ᄅᄉ: "롌",
    례ᄅᄐ: "롍",
    례ᄅᄑ: "롎",
    례ᄅᄒ: "롏",
    례ᄆ: "롐",
    례ᄇ: "롑",
    례ᄇᄉ: "롒",
    례ᄉ: "롓",
    례ᄊ: "롔",
    례ᄋ: "롕",
    례ᄌ: "롖",
    례ᄎ: "롗",
    례ᄏ: "롘",
    례ᄐ: "롙",
    례ᄑ: "롚",
    례ᄒ: "롛",
    로: "로",
    로ᄀ: "록",
    로ᄁ: "롞",
    로ᄀᄉ: "롟",
    로ᄂ: "론",
    로ᄂᄌ: "롡",
    로ᄂᄒ: "롢",
    로ᄃ: "롣",
    로ᄅ: "롤",
    로ᄅᄀ: "롥",
    로ᄅᄆ: "롦",
    로ᄅᄇ: "롧",
    로ᄅᄉ: "롨",
    로ᄅᄐ: "롩",
    로ᄅᄑ: "롪",
    로ᄅᄒ: "롫",
    로ᄆ: "롬",
    로ᄇ: "롭",
    로ᄇᄉ: "롮",
    로ᄉ: "롯",
    로ᄊ: "롰",
    로ᄋ: "롱",
    로ᄌ: "롲",
    로ᄎ: "롳",
    로ᄏ: "롴",
    로ᄐ: "롵",
    로ᄑ: "롶",
    로ᄒ: "롷",
    로ᅡ: "롸",
    로ᅡᄀ: "롹",
    로ᅡᄁ: "롺",
    로ᅡᄀᄉ: "롻",
    로ᅡᄂ: "롼",
    로ᅡᄂᄌ: "롽",
    로ᅡᄂᄒ: "롾",
    로ᅡᄃ: "롿",
    로ᅡᄅ: "뢀",
    로ᅡᄅᄀ: "뢁",
    로ᅡᄅᄆ: "뢂",
    로ᅡᄅᄇ: "뢃",
    로ᅡᄅᄉ: "뢄",
    로ᅡᄅᄐ: "뢅",
    로ᅡᄅᄑ: "뢆",
    로ᅡᄅᄒ: "뢇",
    로ᅡᄆ: "뢈",
    로ᅡᄇ: "뢉",
    로ᅡᄇᄉ: "뢊",
    로ᅡᄉ: "뢋",
    로ᅡᄊ: "뢌",
    로ᅡᄋ: "뢍",
    로ᅡᄌ: "뢎",
    로ᅡᄎ: "뢏",
    로ᅡᄏ: "뢐",
    로ᅡᄐ: "뢑",
    로ᅡᄑ: "뢒",
    로ᅡᄒ: "뢓",
    로ᅢ: "뢔",
    로ᅢᄀ: "뢕",
    로ᅢᄁ: "뢖",
    로ᅢᄀᄉ: "뢗",
    로ᅢᄂ: "뢘",
    로ᅢᄂᄌ: "뢙",
    로ᅢᄂᄒ: "뢚",
    로ᅢᄃ: "뢛",
    로ᅢᄅ: "뢜",
    로ᅢᄅᄀ: "뢝",
    로ᅢᄅᄆ: "뢞",
    로ᅢᄅᄇ: "뢟",
    로ᅢᄅᄉ: "뢠",
    로ᅢᄅᄐ: "뢡",
    로ᅢᄅᄑ: "뢢",
    로ᅢᄅᄒ: "뢣",
    로ᅢᄆ: "뢤",
    로ᅢᄇ: "뢥",
    로ᅢᄇᄉ: "뢦",
    로ᅢᄉ: "뢧",
    로ᅢᄊ: "뢨",
    로ᅢᄋ: "뢩",
    로ᅢᄌ: "뢪",
    로ᅢᄎ: "뢫",
    로ᅢᄏ: "뢬",
    로ᅢᄐ: "뢭",
    로ᅢᄑ: "뢮",
    로ᅢᄒ: "뢯",
    로ᅵ: "뢰",
    로ᅵᄀ: "뢱",
    로ᅵᄁ: "뢲",
    로ᅵᄀᄉ: "뢳",
    로ᅵᄂ: "뢴",
    로ᅵᄂᄌ: "뢵",
    로ᅵᄂᄒ: "뢶",
    로ᅵᄃ: "뢷",
    로ᅵᄅ: "뢸",
    로ᅵᄅᄀ: "뢹",
    로ᅵᄅᄆ: "뢺",
    로ᅵᄅᄇ: "뢻",
    로ᅵᄅᄉ: "뢼",
    로ᅵᄅᄐ: "뢽",
    로ᅵᄅᄑ: "뢾",
    로ᅵᄅᄒ: "뢿",
    로ᅵᄆ: "룀",
    로ᅵᄇ: "룁",
    로ᅵᄇᄉ: "룂",
    로ᅵᄉ: "룃",
    로ᅵᄊ: "룄",
    로ᅵᄋ: "룅",
    로ᅵᄌ: "룆",
    로ᅵᄎ: "룇",
    로ᅵᄏ: "룈",
    로ᅵᄐ: "룉",
    로ᅵᄑ: "룊",
    로ᅵᄒ: "룋",
    료: "료",
    료ᄀ: "룍",
    료ᄁ: "룎",
    료ᄀᄉ: "룏",
    료ᄂ: "룐",
    료ᄂᄌ: "룑",
    료ᄂᄒ: "룒",
    료ᄃ: "룓",
    료ᄅ: "룔",
    료ᄅᄀ: "룕",
    료ᄅᄆ: "룖",
    료ᄅᄇ: "룗",
    료ᄅᄉ: "룘",
    료ᄅᄐ: "룙",
    료ᄅᄑ: "룚",
    료ᄅᄒ: "룛",
    료ᄆ: "룜",
    료ᄇ: "룝",
    료ᄇᄉ: "룞",
    료ᄉ: "룟",
    료ᄊ: "룠",
    료ᄋ: "룡",
    료ᄌ: "룢",
    료ᄎ: "룣",
    료ᄏ: "룤",
    료ᄐ: "룥",
    료ᄑ: "룦",
    료ᄒ: "룧",
    루: "루",
    루ᄀ: "룩",
    루ᄁ: "룪",
    루ᄀᄉ: "룫",
    루ᄂ: "룬",
    루ᄂᄌ: "룭",
    루ᄂᄒ: "룮",
    루ᄃ: "룯",
    루ᄅ: "룰",
    루ᄅᄀ: "룱",
    루ᄅᄆ: "룲",
    루ᄅᄇ: "룳",
    루ᄅᄉ: "룴",
    루ᄅᄐ: "룵",
    루ᄅᄑ: "룶",
    루ᄅᄒ: "룷",
    루ᄆ: "룸",
    루ᄇ: "룹",
    루ᄇᄉ: "룺",
    루ᄉ: "룻",
    루ᄊ: "룼",
    루ᄋ: "룽",
    루ᄌ: "룾",
    루ᄎ: "룿",
    루ᄏ: "뤀",
    루ᄐ: "뤁",
    루ᄑ: "뤂",
    루ᄒ: "뤃",
    루ᅥ: "뤄",
    루ᅥᄀ: "뤅",
    루ᅥᄁ: "뤆",
    루ᅥᄀᄉ: "뤇",
    루ᅥᄂ: "뤈",
    루ᅥᄂᄌ: "뤉",
    루ᅥᄂᄒ: "뤊",
    루ᅥᄃ: "뤋",
    루ᅥᄅ: "뤌",
    루ᅥᄅᄀ: "뤍",
    루ᅥᄅᄆ: "뤎",
    루ᅥᄅᄇ: "뤏",
    루ᅥᄅᄉ: "뤐",
    루ᅥᄅᄐ: "뤑",
    루ᅥᄅᄑ: "뤒",
    루ᅥᄅᄒ: "뤓",
    루ᅥᄆ: "뤔",
    루ᅥᄇ: "뤕",
    루ᅥᄇᄉ: "뤖",
    루ᅥᄉ: "뤗",
    루ᅥᄊ: "뤘",
    루ᅥᄋ: "뤙",
    루ᅥᄌ: "뤚",
    루ᅥᄎ: "뤛",
    루ᅥᄏ: "뤜",
    루ᅥᄐ: "뤝",
    루ᅥᄑ: "뤞",
    루ᅥᄒ: "뤟",
    루ᅦ: "뤠",
    루ᅦᄀ: "뤡",
    루ᅦᄁ: "뤢",
    루ᅦᄀᄉ: "뤣",
    루ᅦᄂ: "뤤",
    루ᅦᄂᄌ: "뤥",
    루ᅦᄂᄒ: "뤦",
    루ᅦᄃ: "뤧",
    루ᅦᄅ: "뤨",
    루ᅦᄅᄀ: "뤩",
    루ᅦᄅᄆ: "뤪",
    루ᅦᄅᄇ: "뤫",
    루ᅦᄅᄉ: "뤬",
    루ᅦᄅᄐ: "뤭",
    루ᅦᄅᄑ: "뤮",
    루ᅦᄅᄒ: "뤯",
    루ᅦᄆ: "뤰",
    루ᅦᄇ: "뤱",
    루ᅦᄇᄉ: "뤲",
    루ᅦᄉ: "뤳",
    루ᅦᄊ: "뤴",
    루ᅦᄋ: "뤵",
    루ᅦᄌ: "뤶",
    루ᅦᄎ: "뤷",
    루ᅦᄏ: "뤸",
    루ᅦᄐ: "뤹",
    루ᅦᄑ: "뤺",
    루ᅦᄒ: "뤻",
    루ᅵ: "뤼",
    루ᅵᄀ: "뤽",
    루ᅵᄁ: "뤾",
    루ᅵᄀᄉ: "뤿",
    루ᅵᄂ: "륀",
    루ᅵᄂᄌ: "륁",
    루ᅵᄂᄒ: "륂",
    루ᅵᄃ: "륃",
    루ᅵᄅ: "륄",
    루ᅵᄅᄀ: "륅",
    루ᅵᄅᄆ: "륆",
    루ᅵᄅᄇ: "륇",
    루ᅵᄅᄉ: "륈",
    루ᅵᄅᄐ: "륉",
    루ᅵᄅᄑ: "륊",
    루ᅵᄅᄒ: "륋",
    루ᅵᄆ: "륌",
    루ᅵᄇ: "륍",
    루ᅵᄇᄉ: "륎",
    루ᅵᄉ: "륏",
    루ᅵᄊ: "륐",
    루ᅵᄋ: "륑",
    루ᅵᄌ: "륒",
    루ᅵᄎ: "륓",
    루ᅵᄏ: "륔",
    루ᅵᄐ: "륕",
    루ᅵᄑ: "륖",
    루ᅵᄒ: "륗",
    류: "류",
    류ᄀ: "륙",
    류ᄁ: "륚",
    류ᄀᄉ: "륛",
    류ᄂ: "륜",
    류ᄂᄌ: "륝",
    류ᄂᄒ: "륞",
    류ᄃ: "륟",
    류ᄅ: "률",
    류ᄅᄀ: "륡",
    류ᄅᄆ: "륢",
    류ᄅᄇ: "륣",
    류ᄅᄉ: "륤",
    류ᄅᄐ: "륥",
    류ᄅᄑ: "륦",
    류ᄅᄒ: "륧",
    류ᄆ: "륨",
    류ᄇ: "륩",
    류ᄇᄉ: "륪",
    류ᄉ: "륫",
    류ᄊ: "륬",
    류ᄋ: "륭",
    류ᄌ: "륮",
    류ᄎ: "륯",
    류ᄏ: "륰",
    류ᄐ: "륱",
    류ᄑ: "륲",
    류ᄒ: "륳",
    르: "르",
    르ᄀ: "륵",
    르ᄁ: "륶",
    르ᄀᄉ: "륷",
    르ᄂ: "른",
    르ᄂᄌ: "륹",
    르ᄂᄒ: "륺",
    르ᄃ: "륻",
    르ᄅ: "를",
    르ᄅᄀ: "륽",
    르ᄅᄆ: "륾",
    르ᄅᄇ: "륿",
    르ᄅᄉ: "릀",
    르ᄅᄐ: "릁",
    르ᄅᄑ: "릂",
    르ᄅᄒ: "릃",
    르ᄆ: "름",
    르ᄇ: "릅",
    르ᄇᄉ: "릆",
    르ᄉ: "릇",
    르ᄊ: "릈",
    르ᄋ: "릉",
    르ᄌ: "릊",
    르ᄎ: "릋",
    르ᄏ: "릌",
    르ᄐ: "릍",
    르ᄑ: "릎",
    르ᄒ: "릏",
    르ᅵ: "릐",
    르ᅵᄀ: "릑",
    르ᅵᄁ: "릒",
    르ᅵᄀᄉ: "릓",
    르ᅵᄂ: "릔",
    르ᅵᄂᄌ: "릕",
    르ᅵᄂᄒ: "릖",
    르ᅵᄃ: "릗",
    르ᅵᄅ: "릘",
    르ᅵᄅᄀ: "릙",
    르ᅵᄅᄆ: "릚",
    르ᅵᄅᄇ: "릛",
    르ᅵᄅᄉ: "릜",
    르ᅵᄅᄐ: "릝",
    르ᅵᄅᄑ: "릞",
    르ᅵᄅᄒ: "릟",
    르ᅵᄆ: "릠",
    르ᅵᄇ: "릡",
    르ᅵᄇᄉ: "릢",
    르ᅵᄉ: "릣",
    르ᅵᄊ: "릤",
    르ᅵᄋ: "릥",
    르ᅵᄌ: "릦",
    르ᅵᄎ: "릧",
    르ᅵᄏ: "릨",
    르ᅵᄐ: "릩",
    르ᅵᄑ: "릪",
    르ᅵᄒ: "릫",
    리: "리",
    리ᄀ: "릭",
    리ᄁ: "릮",
    리ᄀᄉ: "릯",
    리ᄂ: "린",
    리ᄂᄌ: "릱",
    리ᄂᄒ: "릲",
    리ᄃ: "릳",
    리ᄅ: "릴",
    리ᄅᄀ: "릵",
    리ᄅᄆ: "릶",
    리ᄅᄇ: "릷",
    리ᄅᄉ: "릸",
    리ᄅᄐ: "릹",
    리ᄅᄑ: "릺",
    리ᄅᄒ: "릻",
    리ᄆ: "림",
    리ᄇ: "립",
    리ᄇᄉ: "릾",
    리ᄉ: "릿",
    리ᄊ: "맀",
    리ᄋ: "링",
    리ᄌ: "맂",
    리ᄎ: "맃",
    리ᄏ: "맄",
    리ᄐ: "맅",
    리ᄑ: "맆",
    리ᄒ: "맇",
    마: "마",
    마ᄀ: "막",
    마ᄁ: "맊",
    마ᄀᄉ: "맋",
    마ᄂ: "만",
    마ᄂᄌ: "맍",
    마ᄂᄒ: "많",
    마ᄃ: "맏",
    마ᄅ: "말",
    마ᄅᄀ: "맑",
    마ᄅᄆ: "맒",
    마ᄅᄇ: "맓",
    마ᄅᄉ: "맔",
    마ᄅᄐ: "맕",
    마ᄅᄑ: "맖",
    마ᄅᄒ: "맗",
    마ᄆ: "맘",
    마ᄇ: "맙",
    마ᄇᄉ: "맚",
    마ᄉ: "맛",
    마ᄊ: "맜",
    마ᄋ: "망",
    마ᄌ: "맞",
    마ᄎ: "맟",
    마ᄏ: "맠",
    마ᄐ: "맡",
    마ᄑ: "맢",
    마ᄒ: "맣",
    매: "매",
    매ᄀ: "맥",
    매ᄁ: "맦",
    매ᄀᄉ: "맧",
    매ᄂ: "맨",
    매ᄂᄌ: "맩",
    매ᄂᄒ: "맪",
    매ᄃ: "맫",
    매ᄅ: "맬",
    매ᄅᄀ: "맭",
    매ᄅᄆ: "맮",
    매ᄅᄇ: "맯",
    매ᄅᄉ: "맰",
    매ᄅᄐ: "맱",
    매ᄅᄑ: "맲",
    매ᄅᄒ: "맳",
    매ᄆ: "맴",
    매ᄇ: "맵",
    매ᄇᄉ: "맶",
    매ᄉ: "맷",
    매ᄊ: "맸",
    매ᄋ: "맹",
    매ᄌ: "맺",
    매ᄎ: "맻",
    매ᄏ: "맼",
    매ᄐ: "맽",
    매ᄑ: "맾",
    매ᄒ: "맿",
    먀: "먀",
    먀ᄀ: "먁",
    먀ᄁ: "먂",
    먀ᄀᄉ: "먃",
    먀ᄂ: "먄",
    먀ᄂᄌ: "먅",
    먀ᄂᄒ: "먆",
    먀ᄃ: "먇",
    먀ᄅ: "먈",
    먀ᄅᄀ: "먉",
    먀ᄅᄆ: "먊",
    먀ᄅᄇ: "먋",
    먀ᄅᄉ: "먌",
    먀ᄅᄐ: "먍",
    먀ᄅᄑ: "먎",
    먀ᄅᄒ: "먏",
    먀ᄆ: "먐",
    먀ᄇ: "먑",
    먀ᄇᄉ: "먒",
    먀ᄉ: "먓",
    먀ᄊ: "먔",
    먀ᄋ: "먕",
    먀ᄌ: "먖",
    먀ᄎ: "먗",
    먀ᄏ: "먘",
    먀ᄐ: "먙",
    먀ᄑ: "먚",
    먀ᄒ: "먛",
    먜: "먜",
    먜ᄀ: "먝",
    먜ᄁ: "먞",
    먜ᄀᄉ: "먟",
    먜ᄂ: "먠",
    먜ᄂᄌ: "먡",
    먜ᄂᄒ: "먢",
    먜ᄃ: "먣",
    먜ᄅ: "먤",
    먜ᄅᄀ: "먥",
    먜ᄅᄆ: "먦",
    먜ᄅᄇ: "먧",
    먜ᄅᄉ: "먨",
    먜ᄅᄐ: "먩",
    먜ᄅᄑ: "먪",
    먜ᄅᄒ: "먫",
    먜ᄆ: "먬",
    먜ᄇ: "먭",
    먜ᄇᄉ: "먮",
    먜ᄉ: "먯",
    먜ᄊ: "먰",
    먜ᄋ: "먱",
    먜ᄌ: "먲",
    먜ᄎ: "먳",
    먜ᄏ: "먴",
    먜ᄐ: "먵",
    먜ᄑ: "먶",
    먜ᄒ: "먷",
    머: "머",
    머ᄀ: "먹",
    머ᄁ: "먺",
    머ᄀᄉ: "먻",
    머ᄂ: "먼",
    머ᄂᄌ: "먽",
    머ᄂᄒ: "먾",
    머ᄃ: "먿",
    머ᄅ: "멀",
    머ᄅᄀ: "멁",
    머ᄅᄆ: "멂",
    머ᄅᄇ: "멃",
    머ᄅᄉ: "멄",
    머ᄅᄐ: "멅",
    머ᄅᄑ: "멆",
    머ᄅᄒ: "멇",
    머ᄆ: "멈",
    머ᄇ: "멉",
    머ᄇᄉ: "멊",
    머ᄉ: "멋",
    머ᄊ: "멌",
    머ᄋ: "멍",
    머ᄌ: "멎",
    머ᄎ: "멏",
    머ᄏ: "멐",
    머ᄐ: "멑",
    머ᄑ: "멒",
    머ᄒ: "멓",
    메: "메",
    메ᄀ: "멕",
    메ᄁ: "멖",
    메ᄀᄉ: "멗",
    메ᄂ: "멘",
    메ᄂᄌ: "멙",
    메ᄂᄒ: "멚",
    메ᄃ: "멛",
    메ᄅ: "멜",
    메ᄅᄀ: "멝",
    메ᄅᄆ: "멞",
    메ᄅᄇ: "멟",
    메ᄅᄉ: "멠",
    메ᄅᄐ: "멡",
    메ᄅᄑ: "멢",
    메ᄅᄒ: "멣",
    메ᄆ: "멤",
    메ᄇ: "멥",
    메ᄇᄉ: "멦",
    메ᄉ: "멧",
    메ᄊ: "멨",
    메ᄋ: "멩",
    메ᄌ: "멪",
    메ᄎ: "멫",
    메ᄏ: "멬",
    메ᄐ: "멭",
    메ᄑ: "멮",
    메ᄒ: "멯",
    며: "며",
    며ᄀ: "멱",
    며ᄁ: "멲",
    며ᄀᄉ: "멳",
    며ᄂ: "면",
    며ᄂᄌ: "멵",
    며ᄂᄒ: "멶",
    며ᄃ: "멷",
    며ᄅ: "멸",
    며ᄅᄀ: "멹",
    며ᄅᄆ: "멺",
    며ᄅᄇ: "멻",
    며ᄅᄉ: "멼",
    며ᄅᄐ: "멽",
    며ᄅᄑ: "멾",
    며ᄅᄒ: "멿",
    며ᄆ: "몀",
    며ᄇ: "몁",
    며ᄇᄉ: "몂",
    며ᄉ: "몃",
    며ᄊ: "몄",
    며ᄋ: "명",
    며ᄌ: "몆",
    며ᄎ: "몇",
    며ᄏ: "몈",
    며ᄐ: "몉",
    며ᄑ: "몊",
    며ᄒ: "몋",
    몌: "몌",
    몌ᄀ: "몍",
    몌ᄁ: "몎",
    몌ᄀᄉ: "몏",
    몌ᄂ: "몐",
    몌ᄂᄌ: "몑",
    몌ᄂᄒ: "몒",
    몌ᄃ: "몓",
    몌ᄅ: "몔",
    몌ᄅᄀ: "몕",
    몌ᄅᄆ: "몖",
    몌ᄅᄇ: "몗",
    몌ᄅᄉ: "몘",
    몌ᄅᄐ: "몙",
    몌ᄅᄑ: "몚",
    몌ᄅᄒ: "몛",
    몌ᄆ: "몜",
    몌ᄇ: "몝",
    몌ᄇᄉ: "몞",
    몌ᄉ: "몟",
    몌ᄊ: "몠",
    몌ᄋ: "몡",
    몌ᄌ: "몢",
    몌ᄎ: "몣",
    몌ᄏ: "몤",
    몌ᄐ: "몥",
    몌ᄑ: "몦",
    몌ᄒ: "몧",
    모: "모",
    모ᄀ: "목",
    모ᄁ: "몪",
    모ᄀᄉ: "몫",
    모ᄂ: "몬",
    모ᄂᄌ: "몭",
    모ᄂᄒ: "몮",
    모ᄃ: "몯",
    모ᄅ: "몰",
    모ᄅᄀ: "몱",
    모ᄅᄆ: "몲",
    모ᄅᄇ: "몳",
    모ᄅᄉ: "몴",
    모ᄅᄐ: "몵",
    모ᄅᄑ: "몶",
    모ᄅᄒ: "몷",
    모ᄆ: "몸",
    모ᄇ: "몹",
    모ᄇᄉ: "몺",
    모ᄉ: "못",
    모ᄊ: "몼",
    모ᄋ: "몽",
    모ᄌ: "몾",
    모ᄎ: "몿",
    모ᄏ: "뫀",
    모ᄐ: "뫁",
    모ᄑ: "뫂",
    모ᄒ: "뫃",
    모ᅡ: "뫄",
    모ᅡᄀ: "뫅",
    모ᅡᄁ: "뫆",
    모ᅡᄀᄉ: "뫇",
    모ᅡᄂ: "뫈",
    모ᅡᄂᄌ: "뫉",
    모ᅡᄂᄒ: "뫊",
    모ᅡᄃ: "뫋",
    모ᅡᄅ: "뫌",
    모ᅡᄅᄀ: "뫍",
    모ᅡᄅᄆ: "뫎",
    모ᅡᄅᄇ: "뫏",
    모ᅡᄅᄉ: "뫐",
    모ᅡᄅᄐ: "뫑",
    모ᅡᄅᄑ: "뫒",
    모ᅡᄅᄒ: "뫓",
    모ᅡᄆ: "뫔",
    모ᅡᄇ: "뫕",
    모ᅡᄇᄉ: "뫖",
    모ᅡᄉ: "뫗",
    모ᅡᄊ: "뫘",
    모ᅡᄋ: "뫙",
    모ᅡᄌ: "뫚",
    모ᅡᄎ: "뫛",
    모ᅡᄏ: "뫜",
    모ᅡᄐ: "뫝",
    모ᅡᄑ: "뫞",
    모ᅡᄒ: "뫟",
    모ᅢ: "뫠",
    모ᅢᄀ: "뫡",
    모ᅢᄁ: "뫢",
    모ᅢᄀᄉ: "뫣",
    모ᅢᄂ: "뫤",
    모ᅢᄂᄌ: "뫥",
    모ᅢᄂᄒ: "뫦",
    모ᅢᄃ: "뫧",
    모ᅢᄅ: "뫨",
    모ᅢᄅᄀ: "뫩",
    모ᅢᄅᄆ: "뫪",
    모ᅢᄅᄇ: "뫫",
    모ᅢᄅᄉ: "뫬",
    모ᅢᄅᄐ: "뫭",
    모ᅢᄅᄑ: "뫮",
    모ᅢᄅᄒ: "뫯",
    모ᅢᄆ: "뫰",
    모ᅢᄇ: "뫱",
    모ᅢᄇᄉ: "뫲",
    모ᅢᄉ: "뫳",
    모ᅢᄊ: "뫴",
    모ᅢᄋ: "뫵",
    모ᅢᄌ: "뫶",
    모ᅢᄎ: "뫷",
    모ᅢᄏ: "뫸",
    모ᅢᄐ: "뫹",
    모ᅢᄑ: "뫺",
    모ᅢᄒ: "뫻",
    모ᅵ: "뫼",
    모ᅵᄀ: "뫽",
    모ᅵᄁ: "뫾",
    모ᅵᄀᄉ: "뫿",
    모ᅵᄂ: "묀",
    모ᅵᄂᄌ: "묁",
    모ᅵᄂᄒ: "묂",
    모ᅵᄃ: "묃",
    모ᅵᄅ: "묄",
    모ᅵᄅᄀ: "묅",
    모ᅵᄅᄆ: "묆",
    모ᅵᄅᄇ: "묇",
    모ᅵᄅᄉ: "묈",
    모ᅵᄅᄐ: "묉",
    모ᅵᄅᄑ: "묊",
    모ᅵᄅᄒ: "묋",
    모ᅵᄆ: "묌",
    모ᅵᄇ: "묍",
    모ᅵᄇᄉ: "묎",
    모ᅵᄉ: "묏",
    모ᅵᄊ: "묐",
    모ᅵᄋ: "묑",
    모ᅵᄌ: "묒",
    모ᅵᄎ: "묓",
    모ᅵᄏ: "묔",
    모ᅵᄐ: "묕",
    모ᅵᄑ: "묖",
    모ᅵᄒ: "묗",
    묘: "묘",
    묘ᄀ: "묙",
    묘ᄁ: "묚",
    묘ᄀᄉ: "묛",
    묘ᄂ: "묜",
    묘ᄂᄌ: "묝",
    묘ᄂᄒ: "묞",
    묘ᄃ: "묟",
    묘ᄅ: "묠",
    묘ᄅᄀ: "묡",
    묘ᄅᄆ: "묢",
    묘ᄅᄇ: "묣",
    묘ᄅᄉ: "묤",
    묘ᄅᄐ: "묥",
    묘ᄅᄑ: "묦",
    묘ᄅᄒ: "묧",
    묘ᄆ: "묨",
    묘ᄇ: "묩",
    묘ᄇᄉ: "묪",
    묘ᄉ: "묫",
    묘ᄊ: "묬",
    묘ᄋ: "묭",
    묘ᄌ: "묮",
    묘ᄎ: "묯",
    묘ᄏ: "묰",
    묘ᄐ: "묱",
    묘ᄑ: "묲",
    묘ᄒ: "묳",
    무: "무",
    무ᄀ: "묵",
    무ᄁ: "묶",
    무ᄀᄉ: "묷",
    무ᄂ: "문",
    무ᄂᄌ: "묹",
    무ᄂᄒ: "묺",
    무ᄃ: "묻",
    무ᄅ: "물",
    무ᄅᄀ: "묽",
    무ᄅᄆ: "묾",
    무ᄅᄇ: "묿",
    무ᄅᄉ: "뭀",
    무ᄅᄐ: "뭁",
    무ᄅᄑ: "뭂",
    무ᄅᄒ: "뭃",
    무ᄆ: "뭄",
    무ᄇ: "뭅",
    무ᄇᄉ: "뭆",
    무ᄉ: "뭇",
    무ᄊ: "뭈",
    무ᄋ: "뭉",
    무ᄌ: "뭊",
    무ᄎ: "뭋",
    무ᄏ: "뭌",
    무ᄐ: "뭍",
    무ᄑ: "뭎",
    무ᄒ: "뭏",
    무ᅥ: "뭐",
    무ᅥᄀ: "뭑",
    무ᅥᄁ: "뭒",
    무ᅥᄀᄉ: "뭓",
    무ᅥᄂ: "뭔",
    무ᅥᄂᄌ: "뭕",
    무ᅥᄂᄒ: "뭖",
    무ᅥᄃ: "뭗",
    무ᅥᄅ: "뭘",
    무ᅥᄅᄀ: "뭙",
    무ᅥᄅᄆ: "뭚",
    무ᅥᄅᄇ: "뭛",
    무ᅥᄅᄉ: "뭜",
    무ᅥᄅᄐ: "뭝",
    무ᅥᄅᄑ: "뭞",
    무ᅥᄅᄒ: "뭟",
    무ᅥᄆ: "뭠",
    무ᅥᄇ: "뭡",
    무ᅥᄇᄉ: "뭢",
    무ᅥᄉ: "뭣",
    무ᅥᄊ: "뭤",
    무ᅥᄋ: "뭥",
    무ᅥᄌ: "뭦",
    무ᅥᄎ: "뭧",
    무ᅥᄏ: "뭨",
    무ᅥᄐ: "뭩",
    무ᅥᄑ: "뭪",
    무ᅥᄒ: "뭫",
    무ᅦ: "뭬",
    무ᅦᄀ: "뭭",
    무ᅦᄁ: "뭮",
    무ᅦᄀᄉ: "뭯",
    무ᅦᄂ: "뭰",
    무ᅦᄂᄌ: "뭱",
    무ᅦᄂᄒ: "뭲",
    무ᅦᄃ: "뭳",
    무ᅦᄅ: "뭴",
    무ᅦᄅᄀ: "뭵",
    무ᅦᄅᄆ: "뭶",
    무ᅦᄅᄇ: "뭷",
    무ᅦᄅᄉ: "뭸",
    무ᅦᄅᄐ: "뭹",
    무ᅦᄅᄑ: "뭺",
    무ᅦᄅᄒ: "뭻",
    무ᅦᄆ: "뭼",
    무ᅦᄇ: "뭽",
    무ᅦᄇᄉ: "뭾",
    무ᅦᄉ: "뭿",
    무ᅦᄊ: "뮀",
    무ᅦᄋ: "뮁",
    무ᅦᄌ: "뮂",
    무ᅦᄎ: "뮃",
    무ᅦᄏ: "뮄",
    무ᅦᄐ: "뮅",
    무ᅦᄑ: "뮆",
    무ᅦᄒ: "뮇",
    무ᅵ: "뮈",
    무ᅵᄀ: "뮉",
    무ᅵᄁ: "뮊",
    무ᅵᄀᄉ: "뮋",
    무ᅵᄂ: "뮌",
    무ᅵᄂᄌ: "뮍",
    무ᅵᄂᄒ: "뮎",
    무ᅵᄃ: "뮏",
    무ᅵᄅ: "뮐",
    무ᅵᄅᄀ: "뮑",
    무ᅵᄅᄆ: "뮒",
    무ᅵᄅᄇ: "뮓",
    무ᅵᄅᄉ: "뮔",
    무ᅵᄅᄐ: "뮕",
    무ᅵᄅᄑ: "뮖",
    무ᅵᄅᄒ: "뮗",
    무ᅵᄆ: "뮘",
    무ᅵᄇ: "뮙",
    무ᅵᄇᄉ: "뮚",
    무ᅵᄉ: "뮛",
    무ᅵᄊ: "뮜",
    무ᅵᄋ: "뮝",
    무ᅵᄌ: "뮞",
    무ᅵᄎ: "뮟",
    무ᅵᄏ: "뮠",
    무ᅵᄐ: "뮡",
    무ᅵᄑ: "뮢",
    무ᅵᄒ: "뮣",
    뮤: "뮤",
    뮤ᄀ: "뮥",
    뮤ᄁ: "뮦",
    뮤ᄀᄉ: "뮧",
    뮤ᄂ: "뮨",
    뮤ᄂᄌ: "뮩",
    뮤ᄂᄒ: "뮪",
    뮤ᄃ: "뮫",
    뮤ᄅ: "뮬",
    뮤ᄅᄀ: "뮭",
    뮤ᄅᄆ: "뮮",
    뮤ᄅᄇ: "뮯",
    뮤ᄅᄉ: "뮰",
    뮤ᄅᄐ: "뮱",
    뮤ᄅᄑ: "뮲",
    뮤ᄅᄒ: "뮳",
    뮤ᄆ: "뮴",
    뮤ᄇ: "뮵",
    뮤ᄇᄉ: "뮶",
    뮤ᄉ: "뮷",
    뮤ᄊ: "뮸",
    뮤ᄋ: "뮹",
    뮤ᄌ: "뮺",
    뮤ᄎ: "뮻",
    뮤ᄏ: "뮼",
    뮤ᄐ: "뮽",
    뮤ᄑ: "뮾",
    뮤ᄒ: "뮿",
    므: "므",
    므ᄀ: "믁",
    므ᄁ: "믂",
    므ᄀᄉ: "믃",
    므ᄂ: "믄",
    므ᄂᄌ: "믅",
    므ᄂᄒ: "믆",
    므ᄃ: "믇",
    므ᄅ: "믈",
    므ᄅᄀ: "믉",
    므ᄅᄆ: "믊",
    므ᄅᄇ: "믋",
    므ᄅᄉ: "믌",
    므ᄅᄐ: "믍",
    므ᄅᄑ: "믎",
    므ᄅᄒ: "믏",
    므ᄆ: "믐",
    므ᄇ: "믑",
    므ᄇᄉ: "믒",
    므ᄉ: "믓",
    므ᄊ: "믔",
    므ᄋ: "믕",
    므ᄌ: "믖",
    므ᄎ: "믗",
    므ᄏ: "믘",
    므ᄐ: "믙",
    므ᄑ: "믚",
    므ᄒ: "믛",
    므ᅵ: "믜",
    므ᅵᄀ: "믝",
    므ᅵᄁ: "믞",
    므ᅵᄀᄉ: "믟",
    므ᅵᄂ: "믠",
    므ᅵᄂᄌ: "믡",
    므ᅵᄂᄒ: "믢",
    므ᅵᄃ: "믣",
    므ᅵᄅ: "믤",
    므ᅵᄅᄀ: "믥",
    므ᅵᄅᄆ: "믦",
    므ᅵᄅᄇ: "믧",
    므ᅵᄅᄉ: "믨",
    므ᅵᄅᄐ: "믩",
    므ᅵᄅᄑ: "믪",
    므ᅵᄅᄒ: "믫",
    므ᅵᄆ: "믬",
    므ᅵᄇ: "믭",
    므ᅵᄇᄉ: "믮",
    므ᅵᄉ: "믯",
    므ᅵᄊ: "믰",
    므ᅵᄋ: "믱",
    므ᅵᄌ: "믲",
    므ᅵᄎ: "믳",
    므ᅵᄏ: "믴",
    므ᅵᄐ: "믵",
    므ᅵᄑ: "믶",
    므ᅵᄒ: "믷",
    미: "미",
    미ᄀ: "믹",
    미ᄁ: "믺",
    미ᄀᄉ: "믻",
    미ᄂ: "민",
    미ᄂᄌ: "믽",
    미ᄂᄒ: "믾",
    미ᄃ: "믿",
    미ᄅ: "밀",
    미ᄅᄀ: "밁",
    미ᄅᄆ: "밂",
    미ᄅᄇ: "밃",
    미ᄅᄉ: "밄",
    미ᄅᄐ: "밅",
    미ᄅᄑ: "밆",
    미ᄅᄒ: "밇",
    미ᄆ: "밈",
    미ᄇ: "밉",
    미ᄇᄉ: "밊",
    미ᄉ: "밋",
    미ᄊ: "밌",
    미ᄋ: "밍",
    미ᄌ: "밎",
    미ᄎ: "및",
    미ᄏ: "밐",
    미ᄐ: "밑",
    미ᄑ: "밒",
    미ᄒ: "밓",
    바: "바",
    바ᄀ: "박",
    바ᄁ: "밖",
    바ᄀᄉ: "밗",
    바ᄂ: "반",
    바ᄂᄌ: "밙",
    바ᄂᄒ: "밚",
    바ᄃ: "받",
    바ᄅ: "발",
    바ᄅᄀ: "밝",
    바ᄅᄆ: "밞",
    바ᄅᄇ: "밟",
    바ᄅᄉ: "밠",
    바ᄅᄐ: "밡",
    바ᄅᄑ: "밢",
    바ᄅᄒ: "밣",
    바ᄆ: "밤",
    바ᄇ: "밥",
    바ᄇᄉ: "밦",
    바ᄉ: "밧",
    바ᄊ: "밨",
    바ᄋ: "방",
    바ᄌ: "밪",
    바ᄎ: "밫",
    바ᄏ: "밬",
    바ᄐ: "밭",
    바ᄑ: "밮",
    바ᄒ: "밯",
    배: "배",
    배ᄀ: "백",
    배ᄁ: "밲",
    배ᄀᄉ: "밳",
    배ᄂ: "밴",
    배ᄂᄌ: "밵",
    배ᄂᄒ: "밶",
    배ᄃ: "밷",
    배ᄅ: "밸",
    배ᄅᄀ: "밹",
    배ᄅᄆ: "밺",
    배ᄅᄇ: "밻",
    배ᄅᄉ: "밼",
    배ᄅᄐ: "밽",
    배ᄅᄑ: "밾",
    배ᄅᄒ: "밿",
    배ᄆ: "뱀",
    배ᄇ: "뱁",
    배ᄇᄉ: "뱂",
    배ᄉ: "뱃",
    배ᄊ: "뱄",
    배ᄋ: "뱅",
    배ᄌ: "뱆",
    배ᄎ: "뱇",
    배ᄏ: "뱈",
    배ᄐ: "뱉",
    배ᄑ: "뱊",
    배ᄒ: "뱋",
    뱌: "뱌",
    뱌ᄀ: "뱍",
    뱌ᄁ: "뱎",
    뱌ᄀᄉ: "뱏",
    뱌ᄂ: "뱐",
    뱌ᄂᄌ: "뱑",
    뱌ᄂᄒ: "뱒",
    뱌ᄃ: "뱓",
    뱌ᄅ: "뱔",
    뱌ᄅᄀ: "뱕",
    뱌ᄅᄆ: "뱖",
    뱌ᄅᄇ: "뱗",
    뱌ᄅᄉ: "뱘",
    뱌ᄅᄐ: "뱙",
    뱌ᄅᄑ: "뱚",
    뱌ᄅᄒ: "뱛",
    뱌ᄆ: "뱜",
    뱌ᄇ: "뱝",
    뱌ᄇᄉ: "뱞",
    뱌ᄉ: "뱟",
    뱌ᄊ: "뱠",
    뱌ᄋ: "뱡",
    뱌ᄌ: "뱢",
    뱌ᄎ: "뱣",
    뱌ᄏ: "뱤",
    뱌ᄐ: "뱥",
    뱌ᄑ: "뱦",
    뱌ᄒ: "뱧",
    뱨: "뱨",
    뱨ᄀ: "뱩",
    뱨ᄁ: "뱪",
    뱨ᄀᄉ: "뱫",
    뱨ᄂ: "뱬",
    뱨ᄂᄌ: "뱭",
    뱨ᄂᄒ: "뱮",
    뱨ᄃ: "뱯",
    뱨ᄅ: "뱰",
    뱨ᄅᄀ: "뱱",
    뱨ᄅᄆ: "뱲",
    뱨ᄅᄇ: "뱳",
    뱨ᄅᄉ: "뱴",
    뱨ᄅᄐ: "뱵",
    뱨ᄅᄑ: "뱶",
    뱨ᄅᄒ: "뱷",
    뱨ᄆ: "뱸",
    뱨ᄇ: "뱹",
    뱨ᄇᄉ: "뱺",
    뱨ᄉ: "뱻",
    뱨ᄊ: "뱼",
    뱨ᄋ: "뱽",
    뱨ᄌ: "뱾",
    뱨ᄎ: "뱿",
    뱨ᄏ: "벀",
    뱨ᄐ: "벁",
    뱨ᄑ: "벂",
    뱨ᄒ: "벃",
    버: "버",
    버ᄀ: "벅",
    버ᄁ: "벆",
    버ᄀᄉ: "벇",
    버ᄂ: "번",
    버ᄂᄌ: "벉",
    버ᄂᄒ: "벊",
    버ᄃ: "벋",
    버ᄅ: "벌",
    버ᄅᄀ: "벍",
    버ᄅᄆ: "벎",
    버ᄅᄇ: "벏",
    버ᄅᄉ: "벐",
    버ᄅᄐ: "벑",
    버ᄅᄑ: "벒",
    버ᄅᄒ: "벓",
    버ᄆ: "범",
    버ᄇ: "법",
    버ᄇᄉ: "벖",
    버ᄉ: "벗",
    버ᄊ: "벘",
    버ᄋ: "벙",
    버ᄌ: "벚",
    버ᄎ: "벛",
    버ᄏ: "벜",
    버ᄐ: "벝",
    버ᄑ: "벞",
    버ᄒ: "벟",
    베: "베",
    베ᄀ: "벡",
    베ᄁ: "벢",
    베ᄀᄉ: "벣",
    베ᄂ: "벤",
    베ᄂᄌ: "벥",
    베ᄂᄒ: "벦",
    베ᄃ: "벧",
    베ᄅ: "벨",
    베ᄅᄀ: "벩",
    베ᄅᄆ: "벪",
    베ᄅᄇ: "벫",
    베ᄅᄉ: "벬",
    베ᄅᄐ: "벭",
    베ᄅᄑ: "벮",
    베ᄅᄒ: "벯",
    베ᄆ: "벰",
    베ᄇ: "벱",
    베ᄇᄉ: "벲",
    베ᄉ: "벳",
    베ᄊ: "벴",
    베ᄋ: "벵",
    베ᄌ: "벶",
    베ᄎ: "벷",
    베ᄏ: "벸",
    베ᄐ: "벹",
    베ᄑ: "벺",
    베ᄒ: "벻",
    벼: "벼",
    벼ᄀ: "벽",
    벼ᄁ: "벾",
    벼ᄀᄉ: "벿",
    벼ᄂ: "변",
    벼ᄂᄌ: "볁",
    벼ᄂᄒ: "볂",
    벼ᄃ: "볃",
    벼ᄅ: "별",
    벼ᄅᄀ: "볅",
    벼ᄅᄆ: "볆",
    벼ᄅᄇ: "볇",
    벼ᄅᄉ: "볈",
    벼ᄅᄐ: "볉",
    벼ᄅᄑ: "볊",
    벼ᄅᄒ: "볋",
    벼ᄆ: "볌",
    벼ᄇ: "볍",
    벼ᄇᄉ: "볎",
    벼ᄉ: "볏",
    벼ᄊ: "볐",
    벼ᄋ: "병",
    벼ᄌ: "볒",
    벼ᄎ: "볓",
    벼ᄏ: "볔",
    벼ᄐ: "볕",
    벼ᄑ: "볖",
    벼ᄒ: "볗",
    볘: "볘",
    볘ᄀ: "볙",
    볘ᄁ: "볚",
    볘ᄀᄉ: "볛",
    볘ᄂ: "볜",
    볘ᄂᄌ: "볝",
    볘ᄂᄒ: "볞",
    볘ᄃ: "볟",
    볘ᄅ: "볠",
    볘ᄅᄀ: "볡",
    볘ᄅᄆ: "볢",
    볘ᄅᄇ: "볣",
    볘ᄅᄉ: "볤",
    볘ᄅᄐ: "볥",
    볘ᄅᄑ: "볦",
    볘ᄅᄒ: "볧",
    볘ᄆ: "볨",
    볘ᄇ: "볩",
    볘ᄇᄉ: "볪",
    볘ᄉ: "볫",
    볘ᄊ: "볬",
    볘ᄋ: "볭",
    볘ᄌ: "볮",
    볘ᄎ: "볯",
    볘ᄏ: "볰",
    볘ᄐ: "볱",
    볘ᄑ: "볲",
    볘ᄒ: "볳",
    보: "보",
    보ᄀ: "복",
    보ᄁ: "볶",
    보ᄀᄉ: "볷",
    보ᄂ: "본",
    보ᄂᄌ: "볹",
    보ᄂᄒ: "볺",
    보ᄃ: "볻",
    보ᄅ: "볼",
    보ᄅᄀ: "볽",
    보ᄅᄆ: "볾",
    보ᄅᄇ: "볿",
    보ᄅᄉ: "봀",
    보ᄅᄐ: "봁",
    보ᄅᄑ: "봂",
    보ᄅᄒ: "봃",
    보ᄆ: "봄",
    보ᄇ: "봅",
    보ᄇᄉ: "봆",
    보ᄉ: "봇",
    보ᄊ: "봈",
    보ᄋ: "봉",
    보ᄌ: "봊",
    보ᄎ: "봋",
    보ᄏ: "봌",
    보ᄐ: "봍",
    보ᄑ: "봎",
    보ᄒ: "봏",
    보ᅡ: "봐",
    보ᅡᄀ: "봑",
    보ᅡᄁ: "봒",
    보ᅡᄀᄉ: "봓",
    보ᅡᄂ: "봔",
    보ᅡᄂᄌ: "봕",
    보ᅡᄂᄒ: "봖",
    보ᅡᄃ: "봗",
    보ᅡᄅ: "봘",
    보ᅡᄅᄀ: "봙",
    보ᅡᄅᄆ: "봚",
    보ᅡᄅᄇ: "봛",
    보ᅡᄅᄉ: "봜",
    보ᅡᄅᄐ: "봝",
    보ᅡᄅᄑ: "봞",
    보ᅡᄅᄒ: "봟",
    보ᅡᄆ: "봠",
    보ᅡᄇ: "봡",
    보ᅡᄇᄉ: "봢",
    보ᅡᄉ: "봣",
    보ᅡᄊ: "봤",
    보ᅡᄋ: "봥",
    보ᅡᄌ: "봦",
    보ᅡᄎ: "봧",
    보ᅡᄏ: "봨",
    보ᅡᄐ: "봩",
    보ᅡᄑ: "봪",
    보ᅡᄒ: "봫",
    보ᅢ: "봬",
    보ᅢᄀ: "봭",
    보ᅢᄁ: "봮",
    보ᅢᄀᄉ: "봯",
    보ᅢᄂ: "봰",
    보ᅢᄂᄌ: "봱",
    보ᅢᄂᄒ: "봲",
    보ᅢᄃ: "봳",
    보ᅢᄅ: "봴",
    보ᅢᄅᄀ: "봵",
    보ᅢᄅᄆ: "봶",
    보ᅢᄅᄇ: "봷",
    보ᅢᄅᄉ: "봸",
    보ᅢᄅᄐ: "봹",
    보ᅢᄅᄑ: "봺",
    보ᅢᄅᄒ: "봻",
    보ᅢᄆ: "봼",
    보ᅢᄇ: "봽",
    보ᅢᄇᄉ: "봾",
    보ᅢᄉ: "봿",
    보ᅢᄊ: "뵀",
    보ᅢᄋ: "뵁",
    보ᅢᄌ: "뵂",
    보ᅢᄎ: "뵃",
    보ᅢᄏ: "뵄",
    보ᅢᄐ: "뵅",
    보ᅢᄑ: "뵆",
    보ᅢᄒ: "뵇",
    보ᅵ: "뵈",
    보ᅵᄀ: "뵉",
    보ᅵᄁ: "뵊",
    보ᅵᄀᄉ: "뵋",
    보ᅵᄂ: "뵌",
    보ᅵᄂᄌ: "뵍",
    보ᅵᄂᄒ: "뵎",
    보ᅵᄃ: "뵏",
    보ᅵᄅ: "뵐",
    보ᅵᄅᄀ: "뵑",
    보ᅵᄅᄆ: "뵒",
    보ᅵᄅᄇ: "뵓",
    보ᅵᄅᄉ: "뵔",
    보ᅵᄅᄐ: "뵕",
    보ᅵᄅᄑ: "뵖",
    보ᅵᄅᄒ: "뵗",
    보ᅵᄆ: "뵘",
    보ᅵᄇ: "뵙",
    보ᅵᄇᄉ: "뵚",
    보ᅵᄉ: "뵛",
    보ᅵᄊ: "뵜",
    보ᅵᄋ: "뵝",
    보ᅵᄌ: "뵞",
    보ᅵᄎ: "뵟",
    보ᅵᄏ: "뵠",
    보ᅵᄐ: "뵡",
    보ᅵᄑ: "뵢",
    보ᅵᄒ: "뵣",
    뵤: "뵤",
    뵤ᄀ: "뵥",
    뵤ᄁ: "뵦",
    뵤ᄀᄉ: "뵧",
    뵤ᄂ: "뵨",
    뵤ᄂᄌ: "뵩",
    뵤ᄂᄒ: "뵪",
    뵤ᄃ: "뵫",
    뵤ᄅ: "뵬",
    뵤ᄅᄀ: "뵭",
    뵤ᄅᄆ: "뵮",
    뵤ᄅᄇ: "뵯",
    뵤ᄅᄉ: "뵰",
    뵤ᄅᄐ: "뵱",
    뵤ᄅᄑ: "뵲",
    뵤ᄅᄒ: "뵳",
    뵤ᄆ: "뵴",
    뵤ᄇ: "뵵",
    뵤ᄇᄉ: "뵶",
    뵤ᄉ: "뵷",
    뵤ᄊ: "뵸",
    뵤ᄋ: "뵹",
    뵤ᄌ: "뵺",
    뵤ᄎ: "뵻",
    뵤ᄏ: "뵼",
    뵤ᄐ: "뵽",
    뵤ᄑ: "뵾",
    뵤ᄒ: "뵿",
    부: "부",
    부ᄀ: "북",
    부ᄁ: "붂",
    부ᄀᄉ: "붃",
    부ᄂ: "분",
    부ᄂᄌ: "붅",
    부ᄂᄒ: "붆",
    부ᄃ: "붇",
    부ᄅ: "불",
    부ᄅᄀ: "붉",
    부ᄅᄆ: "붊",
    부ᄅᄇ: "붋",
    부ᄅᄉ: "붌",
    부ᄅᄐ: "붍",
    부ᄅᄑ: "붎",
    부ᄅᄒ: "붏",
    부ᄆ: "붐",
    부ᄇ: "붑",
    부ᄇᄉ: "붒",
    부ᄉ: "붓",
    부ᄊ: "붔",
    부ᄋ: "붕",
    부ᄌ: "붖",
    부ᄎ: "붗",
    부ᄏ: "붘",
    부ᄐ: "붙",
    부ᄑ: "붚",
    부ᄒ: "붛",
    부ᅥ: "붜",
    부ᅥᄀ: "붝",
    부ᅥᄁ: "붞",
    부ᅥᄀᄉ: "붟",
    부ᅥᄂ: "붠",
    부ᅥᄂᄌ: "붡",
    부ᅥᄂᄒ: "붢",
    부ᅥᄃ: "붣",
    부ᅥᄅ: "붤",
    부ᅥᄅᄀ: "붥",
    부ᅥᄅᄆ: "붦",
    부ᅥᄅᄇ: "붧",
    부ᅥᄅᄉ: "붨",
    부ᅥᄅᄐ: "붩",
    부ᅥᄅᄑ: "붪",
    부ᅥᄅᄒ: "붫",
    부ᅥᄆ: "붬",
    부ᅥᄇ: "붭",
    부ᅥᄇᄉ: "붮",
    부ᅥᄉ: "붯",
    부ᅥᄊ: "붰",
    부ᅥᄋ: "붱",
    부ᅥᄌ: "붲",
    부ᅥᄎ: "붳",
    부ᅥᄏ: "붴",
    부ᅥᄐ: "붵",
    부ᅥᄑ: "붶",
    부ᅥᄒ: "붷",
    부ᅦ: "붸",
    부ᅦᄀ: "붹",
    부ᅦᄁ: "붺",
    부ᅦᄀᄉ: "붻",
    부ᅦᄂ: "붼",
    부ᅦᄂᄌ: "붽",
    부ᅦᄂᄒ: "붾",
    부ᅦᄃ: "붿",
    부ᅦᄅ: "뷀",
    부ᅦᄅᄀ: "뷁",
    부ᅦᄅᄆ: "뷂",
    부ᅦᄅᄇ: "뷃",
    부ᅦᄅᄉ: "뷄",
    부ᅦᄅᄐ: "뷅",
    부ᅦᄅᄑ: "뷆",
    부ᅦᄅᄒ: "뷇",
    부ᅦᄆ: "뷈",
    부ᅦᄇ: "뷉",
    부ᅦᄇᄉ: "뷊",
    부ᅦᄉ: "뷋",
    부ᅦᄊ: "뷌",
    부ᅦᄋ: "뷍",
    부ᅦᄌ: "뷎",
    부ᅦᄎ: "뷏",
    부ᅦᄏ: "뷐",
    부ᅦᄐ: "뷑",
    부ᅦᄑ: "뷒",
    부ᅦᄒ: "뷓",
    부ᅵ: "뷔",
    부ᅵᄀ: "뷕",
    부ᅵᄁ: "뷖",
    부ᅵᄀᄉ: "뷗",
    부ᅵᄂ: "뷘",
    부ᅵᄂᄌ: "뷙",
    부ᅵᄂᄒ: "뷚",
    부ᅵᄃ: "뷛",
    부ᅵᄅ: "뷜",
    부ᅵᄅᄀ: "뷝",
    부ᅵᄅᄆ: "뷞",
    부ᅵᄅᄇ: "뷟",
    부ᅵᄅᄉ: "뷠",
    부ᅵᄅᄐ: "뷡",
    부ᅵᄅᄑ: "뷢",
    부ᅵᄅᄒ: "뷣",
    부ᅵᄆ: "뷤",
    부ᅵᄇ: "뷥",
    부ᅵᄇᄉ: "뷦",
    부ᅵᄉ: "뷧",
    부ᅵᄊ: "뷨",
    부ᅵᄋ: "뷩",
    부ᅵᄌ: "뷪",
    부ᅵᄎ: "뷫",
    부ᅵᄏ: "뷬",
    부ᅵᄐ: "뷭",
    부ᅵᄑ: "뷮",
    부ᅵᄒ: "뷯",
    뷰: "뷰",
    뷰ᄀ: "뷱",
    뷰ᄁ: "뷲",
    뷰ᄀᄉ: "뷳",
    뷰ᄂ: "뷴",
    뷰ᄂᄌ: "뷵",
    뷰ᄂᄒ: "뷶",
    뷰ᄃ: "뷷",
    뷰ᄅ: "뷸",
    뷰ᄅᄀ: "뷹",
    뷰ᄅᄆ: "뷺",
    뷰ᄅᄇ: "뷻",
    뷰ᄅᄉ: "뷼",
    뷰ᄅᄐ: "뷽",
    뷰ᄅᄑ: "뷾",
    뷰ᄅᄒ: "뷿",
    뷰ᄆ: "븀",
    뷰ᄇ: "븁",
    뷰ᄇᄉ: "븂",
    뷰ᄉ: "븃",
    뷰ᄊ: "븄",
    뷰ᄋ: "븅",
    뷰ᄌ: "븆",
    뷰ᄎ: "븇",
    뷰ᄏ: "븈",
    뷰ᄐ: "븉",
    뷰ᄑ: "븊",
    뷰ᄒ: "븋",
    브: "브",
    브ᄀ: "븍",
    브ᄁ: "븎",
    브ᄀᄉ: "븏",
    브ᄂ: "븐",
    브ᄂᄌ: "븑",
    브ᄂᄒ: "븒",
    브ᄃ: "븓",
    브ᄅ: "블",
    브ᄅᄀ: "븕",
    브ᄅᄆ: "븖",
    브ᄅᄇ: "븗",
    브ᄅᄉ: "븘",
    브ᄅᄐ: "븙",
    브ᄅᄑ: "븚",
    브ᄅᄒ: "븛",
    브ᄆ: "븜",
    브ᄇ: "븝",
    브ᄇᄉ: "븞",
    브ᄉ: "븟",
    브ᄊ: "븠",
    브ᄋ: "븡",
    브ᄌ: "븢",
    브ᄎ: "븣",
    브ᄏ: "븤",
    브ᄐ: "븥",
    브ᄑ: "븦",
    브ᄒ: "븧",
    브ᅵ: "븨",
    브ᅵᄀ: "븩",
    브ᅵᄁ: "븪",
    브ᅵᄀᄉ: "븫",
    브ᅵᄂ: "븬",
    브ᅵᄂᄌ: "븭",
    브ᅵᄂᄒ: "븮",
    브ᅵᄃ: "븯",
    브ᅵᄅ: "븰",
    브ᅵᄅᄀ: "븱",
    브ᅵᄅᄆ: "븲",
    브ᅵᄅᄇ: "븳",
    브ᅵᄅᄉ: "븴",
    브ᅵᄅᄐ: "븵",
    브ᅵᄅᄑ: "븶",
    브ᅵᄅᄒ: "븷",
    브ᅵᄆ: "븸",
    브ᅵᄇ: "븹",
    브ᅵᄇᄉ: "븺",
    브ᅵᄉ: "븻",
    브ᅵᄊ: "븼",
    브ᅵᄋ: "븽",
    브ᅵᄌ: "븾",
    브ᅵᄎ: "븿",
    브ᅵᄏ: "빀",
    브ᅵᄐ: "빁",
    브ᅵᄑ: "빂",
    브ᅵᄒ: "빃",
    비: "비",
    비ᄀ: "빅",
    비ᄁ: "빆",
    비ᄀᄉ: "빇",
    비ᄂ: "빈",
    비ᄂᄌ: "빉",
    비ᄂᄒ: "빊",
    비ᄃ: "빋",
    비ᄅ: "빌",
    비ᄅᄀ: "빍",
    비ᄅᄆ: "빎",
    비ᄅᄇ: "빏",
    비ᄅᄉ: "빐",
    비ᄅᄐ: "빑",
    비ᄅᄑ: "빒",
    비ᄅᄒ: "빓",
    비ᄆ: "빔",
    비ᄇ: "빕",
    비ᄇᄉ: "빖",
    비ᄉ: "빗",
    비ᄊ: "빘",
    비ᄋ: "빙",
    비ᄌ: "빚",
    비ᄎ: "빛",
    비ᄏ: "빜",
    비ᄐ: "빝",
    비ᄑ: "빞",
    비ᄒ: "빟",
    빠: "빠",
    빠ᄀ: "빡",
    빠ᄁ: "빢",
    빠ᄀᄉ: "빣",
    빠ᄂ: "빤",
    빠ᄂᄌ: "빥",
    빠ᄂᄒ: "빦",
    빠ᄃ: "빧",
    빠ᄅ: "빨",
    빠ᄅᄀ: "빩",
    빠ᄅᄆ: "빪",
    빠ᄅᄇ: "빫",
    빠ᄅᄉ: "빬",
    빠ᄅᄐ: "빭",
    빠ᄅᄑ: "빮",
    빠ᄅᄒ: "빯",
    빠ᄆ: "빰",
    빠ᄇ: "빱",
    빠ᄇᄉ: "빲",
    빠ᄉ: "빳",
    빠ᄊ: "빴",
    빠ᄋ: "빵",
    빠ᄌ: "빶",
    빠ᄎ: "빷",
    빠ᄏ: "빸",
    빠ᄐ: "빹",
    빠ᄑ: "빺",
    빠ᄒ: "빻",
    빼: "빼",
    빼ᄀ: "빽",
    빼ᄁ: "빾",
    빼ᄀᄉ: "빿",
    빼ᄂ: "뺀",
    빼ᄂᄌ: "뺁",
    빼ᄂᄒ: "뺂",
    빼ᄃ: "뺃",
    빼ᄅ: "뺄",
    빼ᄅᄀ: "뺅",
    빼ᄅᄆ: "뺆",
    빼ᄅᄇ: "뺇",
    빼ᄅᄉ: "뺈",
    빼ᄅᄐ: "뺉",
    빼ᄅᄑ: "뺊",
    빼ᄅᄒ: "뺋",
    빼ᄆ: "뺌",
    빼ᄇ: "뺍",
    빼ᄇᄉ: "뺎",
    빼ᄉ: "뺏",
    빼ᄊ: "뺐",
    빼ᄋ: "뺑",
    빼ᄌ: "뺒",
    빼ᄎ: "뺓",
    빼ᄏ: "뺔",
    빼ᄐ: "뺕",
    빼ᄑ: "뺖",
    빼ᄒ: "뺗",
    뺘: "뺘",
    뺘ᄀ: "뺙",
    뺘ᄁ: "뺚",
    뺘ᄀᄉ: "뺛",
    뺘ᄂ: "뺜",
    뺘ᄂᄌ: "뺝",
    뺘ᄂᄒ: "뺞",
    뺘ᄃ: "뺟",
    뺘ᄅ: "뺠",
    뺘ᄅᄀ: "뺡",
    뺘ᄅᄆ: "뺢",
    뺘ᄅᄇ: "뺣",
    뺘ᄅᄉ: "뺤",
    뺘ᄅᄐ: "뺥",
    뺘ᄅᄑ: "뺦",
    뺘ᄅᄒ: "뺧",
    뺘ᄆ: "뺨",
    뺘ᄇ: "뺩",
    뺘ᄇᄉ: "뺪",
    뺘ᄉ: "뺫",
    뺘ᄊ: "뺬",
    뺘ᄋ: "뺭",
    뺘ᄌ: "뺮",
    뺘ᄎ: "뺯",
    뺘ᄏ: "뺰",
    뺘ᄐ: "뺱",
    뺘ᄑ: "뺲",
    뺘ᄒ: "뺳",
    뺴: "뺴",
    뺴ᄀ: "뺵",
    뺴ᄁ: "뺶",
    뺴ᄀᄉ: "뺷",
    뺴ᄂ: "뺸",
    뺴ᄂᄌ: "뺹",
    뺴ᄂᄒ: "뺺",
    뺴ᄃ: "뺻",
    뺴ᄅ: "뺼",
    뺴ᄅᄀ: "뺽",
    뺴ᄅᄆ: "뺾",
    뺴ᄅᄇ: "뺿",
    뺴ᄅᄉ: "뻀",
    뺴ᄅᄐ: "뻁",
    뺴ᄅᄑ: "뻂",
    뺴ᄅᄒ: "뻃",
    뺴ᄆ: "뻄",
    뺴ᄇ: "뻅",
    뺴ᄇᄉ: "뻆",
    뺴ᄉ: "뻇",
    뺴ᄊ: "뻈",
    뺴ᄋ: "뻉",
    뺴ᄌ: "뻊",
    뺴ᄎ: "뻋",
    뺴ᄏ: "뻌",
    뺴ᄐ: "뻍",
    뺴ᄑ: "뻎",
    뺴ᄒ: "뻏",
    뻐: "뻐",
    뻐ᄀ: "뻑",
    뻐ᄁ: "뻒",
    뻐ᄀᄉ: "뻓",
    뻐ᄂ: "뻔",
    뻐ᄂᄌ: "뻕",
    뻐ᄂᄒ: "뻖",
    뻐ᄃ: "뻗",
    뻐ᄅ: "뻘",
    뻐ᄅᄀ: "뻙",
    뻐ᄅᄆ: "뻚",
    뻐ᄅᄇ: "뻛",
    뻐ᄅᄉ: "뻜",
    뻐ᄅᄐ: "뻝",
    뻐ᄅᄑ: "뻞",
    뻐ᄅᄒ: "뻟",
    뻐ᄆ: "뻠",
    뻐ᄇ: "뻡",
    뻐ᄇᄉ: "뻢",
    뻐ᄉ: "뻣",
    뻐ᄊ: "뻤",
    뻐ᄋ: "뻥",
    뻐ᄌ: "뻦",
    뻐ᄎ: "뻧",
    뻐ᄏ: "뻨",
    뻐ᄐ: "뻩",
    뻐ᄑ: "뻪",
    뻐ᄒ: "뻫",
    뻬: "뻬",
    뻬ᄀ: "뻭",
    뻬ᄁ: "뻮",
    뻬ᄀᄉ: "뻯",
    뻬ᄂ: "뻰",
    뻬ᄂᄌ: "뻱",
    뻬ᄂᄒ: "뻲",
    뻬ᄃ: "뻳",
    뻬ᄅ: "뻴",
    뻬ᄅᄀ: "뻵",
    뻬ᄅᄆ: "뻶",
    뻬ᄅᄇ: "뻷",
    뻬ᄅᄉ: "뻸",
    뻬ᄅᄐ: "뻹",
    뻬ᄅᄑ: "뻺",
    뻬ᄅᄒ: "뻻",
    뻬ᄆ: "뻼",
    뻬ᄇ: "뻽",
    뻬ᄇᄉ: "뻾",
    뻬ᄉ: "뻿",
    뻬ᄊ: "뼀",
    뻬ᄋ: "뼁",
    뻬ᄌ: "뼂",
    뻬ᄎ: "뼃",
    뻬ᄏ: "뼄",
    뻬ᄐ: "뼅",
    뻬ᄑ: "뼆",
    뻬ᄒ: "뼇",
    뼈: "뼈",
    뼈ᄀ: "뼉",
    뼈ᄁ: "뼊",
    뼈ᄀᄉ: "뼋",
    뼈ᄂ: "뼌",
    뼈ᄂᄌ: "뼍",
    뼈ᄂᄒ: "뼎",
    뼈ᄃ: "뼏",
    뼈ᄅ: "뼐",
    뼈ᄅᄀ: "뼑",
    뼈ᄅᄆ: "뼒",
    뼈ᄅᄇ: "뼓",
    뼈ᄅᄉ: "뼔",
    뼈ᄅᄐ: "뼕",
    뼈ᄅᄑ: "뼖",
    뼈ᄅᄒ: "뼗",
    뼈ᄆ: "뼘",
    뼈ᄇ: "뼙",
    뼈ᄇᄉ: "뼚",
    뼈ᄉ: "뼛",
    뼈ᄊ: "뼜",
    뼈ᄋ: "뼝",
    뼈ᄌ: "뼞",
    뼈ᄎ: "뼟",
    뼈ᄏ: "뼠",
    뼈ᄐ: "뼡",
    뼈ᄑ: "뼢",
    뼈ᄒ: "뼣",
    뼤: "뼤",
    뼤ᄀ: "뼥",
    뼤ᄁ: "뼦",
    뼤ᄀᄉ: "뼧",
    뼤ᄂ: "뼨",
    뼤ᄂᄌ: "뼩",
    뼤ᄂᄒ: "뼪",
    뼤ᄃ: "뼫",
    뼤ᄅ: "뼬",
    뼤ᄅᄀ: "뼭",
    뼤ᄅᄆ: "뼮",
    뼤ᄅᄇ: "뼯",
    뼤ᄅᄉ: "뼰",
    뼤ᄅᄐ: "뼱",
    뼤ᄅᄑ: "뼲",
    뼤ᄅᄒ: "뼳",
    뼤ᄆ: "뼴",
    뼤ᄇ: "뼵",
    뼤ᄇᄉ: "뼶",
    뼤ᄉ: "뼷",
    뼤ᄊ: "뼸",
    뼤ᄋ: "뼹",
    뼤ᄌ: "뼺",
    뼤ᄎ: "뼻",
    뼤ᄏ: "뼼",
    뼤ᄐ: "뼽",
    뼤ᄑ: "뼾",
    뼤ᄒ: "뼿",
    뽀: "뽀",
    뽀ᄀ: "뽁",
    뽀ᄁ: "뽂",
    뽀ᄀᄉ: "뽃",
    뽀ᄂ: "뽄",
    뽀ᄂᄌ: "뽅",
    뽀ᄂᄒ: "뽆",
    뽀ᄃ: "뽇",
    뽀ᄅ: "뽈",
    뽀ᄅᄀ: "뽉",
    뽀ᄅᄆ: "뽊",
    뽀ᄅᄇ: "뽋",
    뽀ᄅᄉ: "뽌",
    뽀ᄅᄐ: "뽍",
    뽀ᄅᄑ: "뽎",
    뽀ᄅᄒ: "뽏",
    뽀ᄆ: "뽐",
    뽀ᄇ: "뽑",
    뽀ᄇᄉ: "뽒",
    뽀ᄉ: "뽓",
    뽀ᄊ: "뽔",
    뽀ᄋ: "뽕",
    뽀ᄌ: "뽖",
    뽀ᄎ: "뽗",
    뽀ᄏ: "뽘",
    뽀ᄐ: "뽙",
    뽀ᄑ: "뽚",
    뽀ᄒ: "뽛",
    뽀ᅡ: "뽜",
    뽀ᅡᄀ: "뽝",
    뽀ᅡᄁ: "뽞",
    뽀ᅡᄀᄉ: "뽟",
    뽀ᅡᄂ: "뽠",
    뽀ᅡᄂᄌ: "뽡",
    뽀ᅡᄂᄒ: "뽢",
    뽀ᅡᄃ: "뽣",
    뽀ᅡᄅ: "뽤",
    뽀ᅡᄅᄀ: "뽥",
    뽀ᅡᄅᄆ: "뽦",
    뽀ᅡᄅᄇ: "뽧",
    뽀ᅡᄅᄉ: "뽨",
    뽀ᅡᄅᄐ: "뽩",
    뽀ᅡᄅᄑ: "뽪",
    뽀ᅡᄅᄒ: "뽫",
    뽀ᅡᄆ: "뽬",
    뽀ᅡᄇ: "뽭",
    뽀ᅡᄇᄉ: "뽮",
    뽀ᅡᄉ: "뽯",
    뽀ᅡᄊ: "뽰",
    뽀ᅡᄋ: "뽱",
    뽀ᅡᄌ: "뽲",
    뽀ᅡᄎ: "뽳",
    뽀ᅡᄏ: "뽴",
    뽀ᅡᄐ: "뽵",
    뽀ᅡᄑ: "뽶",
    뽀ᅡᄒ: "뽷",
    뽀ᅢ: "뽸",
    뽀ᅢᄀ: "뽹",
    뽀ᅢᄁ: "뽺",
    뽀ᅢᄀᄉ: "뽻",
    뽀ᅢᄂ: "뽼",
    뽀ᅢᄂᄌ: "뽽",
    뽀ᅢᄂᄒ: "뽾",
    뽀ᅢᄃ: "뽿",
    뽀ᅢᄅ: "뾀",
    뽀ᅢᄅᄀ: "뾁",
    뽀ᅢᄅᄆ: "뾂",
    뽀ᅢᄅᄇ: "뾃",
    뽀ᅢᄅᄉ: "뾄",
    뽀ᅢᄅᄐ: "뾅",
    뽀ᅢᄅᄑ: "뾆",
    뽀ᅢᄅᄒ: "뾇",
    뽀ᅢᄆ: "뾈",
    뽀ᅢᄇ: "뾉",
    뽀ᅢᄇᄉ: "뾊",
    뽀ᅢᄉ: "뾋",
    뽀ᅢᄊ: "뾌",
    뽀ᅢᄋ: "뾍",
    뽀ᅢᄌ: "뾎",
    뽀ᅢᄎ: "뾏",
    뽀ᅢᄏ: "뾐",
    뽀ᅢᄐ: "뾑",
    뽀ᅢᄑ: "뾒",
    뽀ᅢᄒ: "뾓",
    뽀ᅵ: "뾔",
    뽀ᅵᄀ: "뾕",
    뽀ᅵᄁ: "뾖",
    뽀ᅵᄀᄉ: "뾗",
    뽀ᅵᄂ: "뾘",
    뽀ᅵᄂᄌ: "뾙",
    뽀ᅵᄂᄒ: "뾚",
    뽀ᅵᄃ: "뾛",
    뽀ᅵᄅ: "뾜",
    뽀ᅵᄅᄀ: "뾝",
    뽀ᅵᄅᄆ: "뾞",
    뽀ᅵᄅᄇ: "뾟",
    뽀ᅵᄅᄉ: "뾠",
    뽀ᅵᄅᄐ: "뾡",
    뽀ᅵᄅᄑ: "뾢",
    뽀ᅵᄅᄒ: "뾣",
    뽀ᅵᄆ: "뾤",
    뽀ᅵᄇ: "뾥",
    뽀ᅵᄇᄉ: "뾦",
    뽀ᅵᄉ: "뾧",
    뽀ᅵᄊ: "뾨",
    뽀ᅵᄋ: "뾩",
    뽀ᅵᄌ: "뾪",
    뽀ᅵᄎ: "뾫",
    뽀ᅵᄏ: "뾬",
    뽀ᅵᄐ: "뾭",
    뽀ᅵᄑ: "뾮",
    뽀ᅵᄒ: "뾯",
    뾰: "뾰",
    뾰ᄀ: "뾱",
    뾰ᄁ: "뾲",
    뾰ᄀᄉ: "뾳",
    뾰ᄂ: "뾴",
    뾰ᄂᄌ: "뾵",
    뾰ᄂᄒ: "뾶",
    뾰ᄃ: "뾷",
    뾰ᄅ: "뾸",
    뾰ᄅᄀ: "뾹",
    뾰ᄅᄆ: "뾺",
    뾰ᄅᄇ: "뾻",
    뾰ᄅᄉ: "뾼",
    뾰ᄅᄐ: "뾽",
    뾰ᄅᄑ: "뾾",
    뾰ᄅᄒ: "뾿",
    뾰ᄆ: "뿀",
    뾰ᄇ: "뿁",
    뾰ᄇᄉ: "뿂",
    뾰ᄉ: "뿃",
    뾰ᄊ: "뿄",
    뾰ᄋ: "뿅",
    뾰ᄌ: "뿆",
    뾰ᄎ: "뿇",
    뾰ᄏ: "뿈",
    뾰ᄐ: "뿉",
    뾰ᄑ: "뿊",
    뾰ᄒ: "뿋",
    뿌: "뿌",
    뿌ᄀ: "뿍",
    뿌ᄁ: "뿎",
    뿌ᄀᄉ: "뿏",
    뿌ᄂ: "뿐",
    뿌ᄂᄌ: "뿑",
    뿌ᄂᄒ: "뿒",
    뿌ᄃ: "뿓",
    뿌ᄅ: "뿔",
    뿌ᄅᄀ: "뿕",
    뿌ᄅᄆ: "뿖",
    뿌ᄅᄇ: "뿗",
    뿌ᄅᄉ: "뿘",
    뿌ᄅᄐ: "뿙",
    뿌ᄅᄑ: "뿚",
    뿌ᄅᄒ: "뿛",
    뿌ᄆ: "뿜",
    뿌ᄇ: "뿝",
    뿌ᄇᄉ: "뿞",
    뿌ᄉ: "뿟",
    뿌ᄊ: "뿠",
    뿌ᄋ: "뿡",
    뿌ᄌ: "뿢",
    뿌ᄎ: "뿣",
    뿌ᄏ: "뿤",
    뿌ᄐ: "뿥",
    뿌ᄑ: "뿦",
    뿌ᄒ: "뿧",
    뿌ᅥ: "뿨",
    뿌ᅥᄀ: "뿩",
    뿌ᅥᄁ: "뿪",
    뿌ᅥᄀᄉ: "뿫",
    뿌ᅥᄂ: "뿬",
    뿌ᅥᄂᄌ: "뿭",
    뿌ᅥᄂᄒ: "뿮",
    뿌ᅥᄃ: "뿯",
    뿌ᅥᄅ: "뿰",
    뿌ᅥᄅᄀ: "뿱",
    뿌ᅥᄅᄆ: "뿲",
    뿌ᅥᄅᄇ: "뿳",
    뿌ᅥᄅᄉ: "뿴",
    뿌ᅥᄅᄐ: "뿵",
    뿌ᅥᄅᄑ: "뿶",
    뿌ᅥᄅᄒ: "뿷",
    뿌ᅥᄆ: "뿸",
    뿌ᅥᄇ: "뿹",
    뿌ᅥᄇᄉ: "뿺",
    뿌ᅥᄉ: "뿻",
    뿌ᅥᄊ: "뿼",
    뿌ᅥᄋ: "뿽",
    뿌ᅥᄌ: "뿾",
    뿌ᅥᄎ: "뿿",
    뿌ᅥᄏ: "쀀",
    뿌ᅥᄐ: "쀁",
    뿌ᅥᄑ: "쀂",
    뿌ᅥᄒ: "쀃",
    뿌ᅦ: "쀄",
    뿌ᅦᄀ: "쀅",
    뿌ᅦᄁ: "쀆",
    뿌ᅦᄀᄉ: "쀇",
    뿌ᅦᄂ: "쀈",
    뿌ᅦᄂᄌ: "쀉",
    뿌ᅦᄂᄒ: "쀊",
    뿌ᅦᄃ: "쀋",
    뿌ᅦᄅ: "쀌",
    뿌ᅦᄅᄀ: "쀍",
    뿌ᅦᄅᄆ: "쀎",
    뿌ᅦᄅᄇ: "쀏",
    뿌ᅦᄅᄉ: "쀐",
    뿌ᅦᄅᄐ: "쀑",
    뿌ᅦᄅᄑ: "쀒",
    뿌ᅦᄅᄒ: "쀓",
    뿌ᅦᄆ: "쀔",
    뿌ᅦᄇ: "쀕",
    뿌ᅦᄇᄉ: "쀖",
    뿌ᅦᄉ: "쀗",
    뿌ᅦᄊ: "쀘",
    뿌ᅦᄋ: "쀙",
    뿌ᅦᄌ: "쀚",
    뿌ᅦᄎ: "쀛",
    뿌ᅦᄏ: "쀜",
    뿌ᅦᄐ: "쀝",
    뿌ᅦᄑ: "쀞",
    뿌ᅦᄒ: "쀟",
    뿌ᅵ: "쀠",
    뿌ᅵᄀ: "쀡",
    뿌ᅵᄁ: "쀢",
    뿌ᅵᄀᄉ: "쀣",
    뿌ᅵᄂ: "쀤",
    뿌ᅵᄂᄌ: "쀥",
    뿌ᅵᄂᄒ: "쀦",
    뿌ᅵᄃ: "쀧",
    뿌ᅵᄅ: "쀨",
    뿌ᅵᄅᄀ: "쀩",
    뿌ᅵᄅᄆ: "쀪",
    뿌ᅵᄅᄇ: "쀫",
    뿌ᅵᄅᄉ: "쀬",
    뿌ᅵᄅᄐ: "쀭",
    뿌ᅵᄅᄑ: "쀮",
    뿌ᅵᄅᄒ: "쀯",
    뿌ᅵᄆ: "쀰",
    뿌ᅵᄇ: "쀱",
    뿌ᅵᄇᄉ: "쀲",
    뿌ᅵᄉ: "쀳",
    뿌ᅵᄊ: "쀴",
    뿌ᅵᄋ: "쀵",
    뿌ᅵᄌ: "쀶",
    뿌ᅵᄎ: "쀷",
    뿌ᅵᄏ: "쀸",
    뿌ᅵᄐ: "쀹",
    뿌ᅵᄑ: "쀺",
    뿌ᅵᄒ: "쀻",
    쀼: "쀼",
    쀼ᄀ: "쀽",
    쀼ᄁ: "쀾",
    쀼ᄀᄉ: "쀿",
    쀼ᄂ: "쁀",
    쀼ᄂᄌ: "쁁",
    쀼ᄂᄒ: "쁂",
    쀼ᄃ: "쁃",
    쀼ᄅ: "쁄",
    쀼ᄅᄀ: "쁅",
    쀼ᄅᄆ: "쁆",
    쀼ᄅᄇ: "쁇",
    쀼ᄅᄉ: "쁈",
    쀼ᄅᄐ: "쁉",
    쀼ᄅᄑ: "쁊",
    쀼ᄅᄒ: "쁋",
    쀼ᄆ: "쁌",
    쀼ᄇ: "쁍",
    쀼ᄇᄉ: "쁎",
    쀼ᄉ: "쁏",
    쀼ᄊ: "쁐",
    쀼ᄋ: "쁑",
    쀼ᄌ: "쁒",
    쀼ᄎ: "쁓",
    쀼ᄏ: "쁔",
    쀼ᄐ: "쁕",
    쀼ᄑ: "쁖",
    쀼ᄒ: "쁗",
    쁘: "쁘",
    쁘ᄀ: "쁙",
    쁘ᄁ: "쁚",
    쁘ᄀᄉ: "쁛",
    쁘ᄂ: "쁜",
    쁘ᄂᄌ: "쁝",
    쁘ᄂᄒ: "쁞",
    쁘ᄃ: "쁟",
    쁘ᄅ: "쁠",
    쁘ᄅᄀ: "쁡",
    쁘ᄅᄆ: "쁢",
    쁘ᄅᄇ: "쁣",
    쁘ᄅᄉ: "쁤",
    쁘ᄅᄐ: "쁥",
    쁘ᄅᄑ: "쁦",
    쁘ᄅᄒ: "쁧",
    쁘ᄆ: "쁨",
    쁘ᄇ: "쁩",
    쁘ᄇᄉ: "쁪",
    쁘ᄉ: "쁫",
    쁘ᄊ: "쁬",
    쁘ᄋ: "쁭",
    쁘ᄌ: "쁮",
    쁘ᄎ: "쁯",
    쁘ᄏ: "쁰",
    쁘ᄐ: "쁱",
    쁘ᄑ: "쁲",
    쁘ᄒ: "쁳",
    쁘ᅵ: "쁴",
    쁘ᅵᄀ: "쁵",
    쁘ᅵᄁ: "쁶",
    쁘ᅵᄀᄉ: "쁷",
    쁘ᅵᄂ: "쁸",
    쁘ᅵᄂᄌ: "쁹",
    쁘ᅵᄂᄒ: "쁺",
    쁘ᅵᄃ: "쁻",
    쁘ᅵᄅ: "쁼",
    쁘ᅵᄅᄀ: "쁽",
    쁘ᅵᄅᄆ: "쁾",
    쁘ᅵᄅᄇ: "쁿",
    쁘ᅵᄅᄉ: "삀",
    쁘ᅵᄅᄐ: "삁",
    쁘ᅵᄅᄑ: "삂",
    쁘ᅵᄅᄒ: "삃",
    쁘ᅵᄆ: "삄",
    쁘ᅵᄇ: "삅",
    쁘ᅵᄇᄉ: "삆",
    쁘ᅵᄉ: "삇",
    쁘ᅵᄊ: "삈",
    쁘ᅵᄋ: "삉",
    쁘ᅵᄌ: "삊",
    쁘ᅵᄎ: "삋",
    쁘ᅵᄏ: "삌",
    쁘ᅵᄐ: "삍",
    쁘ᅵᄑ: "삎",
    쁘ᅵᄒ: "삏",
    삐: "삐",
    삐ᄀ: "삑",
    삐ᄁ: "삒",
    삐ᄀᄉ: "삓",
    삐ᄂ: "삔",
    삐ᄂᄌ: "삕",
    삐ᄂᄒ: "삖",
    삐ᄃ: "삗",
    삐ᄅ: "삘",
    삐ᄅᄀ: "삙",
    삐ᄅᄆ: "삚",
    삐ᄅᄇ: "삛",
    삐ᄅᄉ: "삜",
    삐ᄅᄐ: "삝",
    삐ᄅᄑ: "삞",
    삐ᄅᄒ: "삟",
    삐ᄆ: "삠",
    삐ᄇ: "삡",
    삐ᄇᄉ: "삢",
    삐ᄉ: "삣",
    삐ᄊ: "삤",
    삐ᄋ: "삥",
    삐ᄌ: "삦",
    삐ᄎ: "삧",
    삐ᄏ: "삨",
    삐ᄐ: "삩",
    삐ᄑ: "삪",
    삐ᄒ: "삫",
    사: "사",
    사ᄀ: "삭",
    사ᄁ: "삮",
    사ᄀᄉ: "삯",
    사ᄂ: "산",
    사ᄂᄌ: "삱",
    사ᄂᄒ: "삲",
    사ᄃ: "삳",
    사ᄅ: "살",
    사ᄅᄀ: "삵",
    사ᄅᄆ: "삶",
    사ᄅᄇ: "삷",
    사ᄅᄉ: "삸",
    사ᄅᄐ: "삹",
    사ᄅᄑ: "삺",
    사ᄅᄒ: "삻",
    사ᄆ: "삼",
    사ᄇ: "삽",
    사ᄇᄉ: "삾",
    사ᄉ: "삿",
    사ᄊ: "샀",
    사ᄋ: "상",
    사ᄌ: "샂",
    사ᄎ: "샃",
    사ᄏ: "샄",
    사ᄐ: "샅",
    사ᄑ: "샆",
    사ᄒ: "샇",
    새: "새",
    새ᄀ: "색",
    새ᄁ: "샊",
    새ᄀᄉ: "샋",
    새ᄂ: "샌",
    새ᄂᄌ: "샍",
    새ᄂᄒ: "샎",
    새ᄃ: "샏",
    새ᄅ: "샐",
    새ᄅᄀ: "샑",
    새ᄅᄆ: "샒",
    새ᄅᄇ: "샓",
    새ᄅᄉ: "샔",
    새ᄅᄐ: "샕",
    새ᄅᄑ: "샖",
    새ᄅᄒ: "샗",
    새ᄆ: "샘",
    새ᄇ: "샙",
    새ᄇᄉ: "샚",
    새ᄉ: "샛",
    새ᄊ: "샜",
    새ᄋ: "생",
    새ᄌ: "샞",
    새ᄎ: "샟",
    새ᄏ: "샠",
    새ᄐ: "샡",
    새ᄑ: "샢",
    새ᄒ: "샣",
    샤: "샤",
    샤ᄀ: "샥",
    샤ᄁ: "샦",
    샤ᄀᄉ: "샧",
    샤ᄂ: "샨",
    샤ᄂᄌ: "샩",
    샤ᄂᄒ: "샪",
    샤ᄃ: "샫",
    샤ᄅ: "샬",
    샤ᄅᄀ: "샭",
    샤ᄅᄆ: "샮",
    샤ᄅᄇ: "샯",
    샤ᄅᄉ: "샰",
    샤ᄅᄐ: "샱",
    샤ᄅᄑ: "샲",
    샤ᄅᄒ: "샳",
    샤ᄆ: "샴",
    샤ᄇ: "샵",
    샤ᄇᄉ: "샶",
    샤ᄉ: "샷",
    샤ᄊ: "샸",
    샤ᄋ: "샹",
    샤ᄌ: "샺",
    샤ᄎ: "샻",
    샤ᄏ: "샼",
    샤ᄐ: "샽",
    샤ᄑ: "샾",
    샤ᄒ: "샿",
    섀: "섀",
    섀ᄀ: "섁",
    섀ᄁ: "섂",
    섀ᄀᄉ: "섃",
    섀ᄂ: "섄",
    섀ᄂᄌ: "섅",
    섀ᄂᄒ: "섆",
    섀ᄃ: "섇",
    섀ᄅ: "섈",
    섀ᄅᄀ: "섉",
    섀ᄅᄆ: "섊",
    섀ᄅᄇ: "섋",
    섀ᄅᄉ: "섌",
    섀ᄅᄐ: "섍",
    섀ᄅᄑ: "섎",
    섀ᄅᄒ: "섏",
    섀ᄆ: "섐",
    섀ᄇ: "섑",
    섀ᄇᄉ: "섒",
    섀ᄉ: "섓",
    섀ᄊ: "섔",
    섀ᄋ: "섕",
    섀ᄌ: "섖",
    섀ᄎ: "섗",
    섀ᄏ: "섘",
    섀ᄐ: "섙",
    섀ᄑ: "섚",
    섀ᄒ: "섛",
    서: "서",
    서ᄀ: "석",
    서ᄁ: "섞",
    서ᄀᄉ: "섟",
    서ᄂ: "선",
    서ᄂᄌ: "섡",
    서ᄂᄒ: "섢",
    서ᄃ: "섣",
    서ᄅ: "설",
    서ᄅᄀ: "섥",
    서ᄅᄆ: "섦",
    서ᄅᄇ: "섧",
    서ᄅᄉ: "섨",
    서ᄅᄐ: "섩",
    서ᄅᄑ: "섪",
    서ᄅᄒ: "섫",
    서ᄆ: "섬",
    서ᄇ: "섭",
    서ᄇᄉ: "섮",
    서ᄉ: "섯",
    서ᄊ: "섰",
    서ᄋ: "성",
    서ᄌ: "섲",
    서ᄎ: "섳",
    서ᄏ: "섴",
    서ᄐ: "섵",
    서ᄑ: "섶",
    서ᄒ: "섷",
    세: "세",
    세ᄀ: "섹",
    세ᄁ: "섺",
    세ᄀᄉ: "섻",
    세ᄂ: "센",
    세ᄂᄌ: "섽",
    세ᄂᄒ: "섾",
    세ᄃ: "섿",
    세ᄅ: "셀",
    세ᄅᄀ: "셁",
    세ᄅᄆ: "셂",
    세ᄅᄇ: "셃",
    세ᄅᄉ: "셄",
    세ᄅᄐ: "셅",
    세ᄅᄑ: "셆",
    세ᄅᄒ: "셇",
    세ᄆ: "셈",
    세ᄇ: "셉",
    세ᄇᄉ: "셊",
    세ᄉ: "셋",
    세ᄊ: "셌",
    세ᄋ: "셍",
    세ᄌ: "셎",
    세ᄎ: "셏",
    세ᄏ: "셐",
    세ᄐ: "셑",
    세ᄑ: "셒",
    세ᄒ: "셓",
    셔: "셔",
    셔ᄀ: "셕",
    셔ᄁ: "셖",
    셔ᄀᄉ: "셗",
    셔ᄂ: "션",
    셔ᄂᄌ: "셙",
    셔ᄂᄒ: "셚",
    셔ᄃ: "셛",
    셔ᄅ: "셜",
    셔ᄅᄀ: "셝",
    셔ᄅᄆ: "셞",
    셔ᄅᄇ: "셟",
    셔ᄅᄉ: "셠",
    셔ᄅᄐ: "셡",
    셔ᄅᄑ: "셢",
    셔ᄅᄒ: "셣",
    셔ᄆ: "셤",
    셔ᄇ: "셥",
    셔ᄇᄉ: "셦",
    셔ᄉ: "셧",
    셔ᄊ: "셨",
    셔ᄋ: "셩",
    셔ᄌ: "셪",
    셔ᄎ: "셫",
    셔ᄏ: "셬",
    셔ᄐ: "셭",
    셔ᄑ: "셮",
    셔ᄒ: "셯",
    셰: "셰",
    셰ᄀ: "셱",
    셰ᄁ: "셲",
    셰ᄀᄉ: "셳",
    셰ᄂ: "셴",
    셰ᄂᄌ: "셵",
    셰ᄂᄒ: "셶",
    셰ᄃ: "셷",
    셰ᄅ: "셸",
    셰ᄅᄀ: "셹",
    셰ᄅᄆ: "셺",
    셰ᄅᄇ: "셻",
    셰ᄅᄉ: "셼",
    셰ᄅᄐ: "셽",
    셰ᄅᄑ: "셾",
    셰ᄅᄒ: "셿",
    셰ᄆ: "솀",
    셰ᄇ: "솁",
    셰ᄇᄉ: "솂",
    셰ᄉ: "솃",
    셰ᄊ: "솄",
    셰ᄋ: "솅",
    셰ᄌ: "솆",
    셰ᄎ: "솇",
    셰ᄏ: "솈",
    셰ᄐ: "솉",
    셰ᄑ: "솊",
    셰ᄒ: "솋",
    소: "소",
    소ᄀ: "속",
    소ᄁ: "솎",
    소ᄀᄉ: "솏",
    소ᄂ: "손",
    소ᄂᄌ: "솑",
    소ᄂᄒ: "솒",
    소ᄃ: "솓",
    소ᄅ: "솔",
    소ᄅᄀ: "솕",
    소ᄅᄆ: "솖",
    소ᄅᄇ: "솗",
    소ᄅᄉ: "솘",
    소ᄅᄐ: "솙",
    소ᄅᄑ: "솚",
    소ᄅᄒ: "솛",
    소ᄆ: "솜",
    소ᄇ: "솝",
    소ᄇᄉ: "솞",
    소ᄉ: "솟",
    소ᄊ: "솠",
    소ᄋ: "송",
    소ᄌ: "솢",
    소ᄎ: "솣",
    소ᄏ: "솤",
    소ᄐ: "솥",
    소ᄑ: "솦",
    소ᄒ: "솧",
    소ᅡ: "솨",
    소ᅡᄀ: "솩",
    소ᅡᄁ: "솪",
    소ᅡᄀᄉ: "솫",
    소ᅡᄂ: "솬",
    소ᅡᄂᄌ: "솭",
    소ᅡᄂᄒ: "솮",
    소ᅡᄃ: "솯",
    소ᅡᄅ: "솰",
    소ᅡᄅᄀ: "솱",
    소ᅡᄅᄆ: "솲",
    소ᅡᄅᄇ: "솳",
    소ᅡᄅᄉ: "솴",
    소ᅡᄅᄐ: "솵",
    소ᅡᄅᄑ: "솶",
    소ᅡᄅᄒ: "솷",
    소ᅡᄆ: "솸",
    소ᅡᄇ: "솹",
    소ᅡᄇᄉ: "솺",
    소ᅡᄉ: "솻",
    소ᅡᄊ: "솼",
    소ᅡᄋ: "솽",
    소ᅡᄌ: "솾",
    소ᅡᄎ: "솿",
    소ᅡᄏ: "쇀",
    소ᅡᄐ: "쇁",
    소ᅡᄑ: "쇂",
    소ᅡᄒ: "쇃",
    소ᅢ: "쇄",
    소ᅢᄀ: "쇅",
    소ᅢᄁ: "쇆",
    소ᅢᄀᄉ: "쇇",
    소ᅢᄂ: "쇈",
    소ᅢᄂᄌ: "쇉",
    소ᅢᄂᄒ: "쇊",
    소ᅢᄃ: "쇋",
    소ᅢᄅ: "쇌",
    소ᅢᄅᄀ: "쇍",
    소ᅢᄅᄆ: "쇎",
    소ᅢᄅᄇ: "쇏",
    소ᅢᄅᄉ: "쇐",
    소ᅢᄅᄐ: "쇑",
    소ᅢᄅᄑ: "쇒",
    소ᅢᄅᄒ: "쇓",
    소ᅢᄆ: "쇔",
    소ᅢᄇ: "쇕",
    소ᅢᄇᄉ: "쇖",
    소ᅢᄉ: "쇗",
    소ᅢᄊ: "쇘",
    소ᅢᄋ: "쇙",
    소ᅢᄌ: "쇚",
    소ᅢᄎ: "쇛",
    소ᅢᄏ: "쇜",
    소ᅢᄐ: "쇝",
    소ᅢᄑ: "쇞",
    소ᅢᄒ: "쇟",
    소ᅵ: "쇠",
    소ᅵᄀ: "쇡",
    소ᅵᄁ: "쇢",
    소ᅵᄀᄉ: "쇣",
    소ᅵᄂ: "쇤",
    소ᅵᄂᄌ: "쇥",
    소ᅵᄂᄒ: "쇦",
    소ᅵᄃ: "쇧",
    소ᅵᄅ: "쇨",
    소ᅵᄅᄀ: "쇩",
    소ᅵᄅᄆ: "쇪",
    소ᅵᄅᄇ: "쇫",
    소ᅵᄅᄉ: "쇬",
    소ᅵᄅᄐ: "쇭",
    소ᅵᄅᄑ: "쇮",
    소ᅵᄅᄒ: "쇯",
    소ᅵᄆ: "쇰",
    소ᅵᄇ: "쇱",
    소ᅵᄇᄉ: "쇲",
    소ᅵᄉ: "쇳",
    소ᅵᄊ: "쇴",
    소ᅵᄋ: "쇵",
    소ᅵᄌ: "쇶",
    소ᅵᄎ: "쇷",
    소ᅵᄏ: "쇸",
    소ᅵᄐ: "쇹",
    소ᅵᄑ: "쇺",
    소ᅵᄒ: "쇻",
    쇼: "쇼",
    쇼ᄀ: "쇽",
    쇼ᄁ: "쇾",
    쇼ᄀᄉ: "쇿",
    쇼ᄂ: "숀",
    쇼ᄂᄌ: "숁",
    쇼ᄂᄒ: "숂",
    쇼ᄃ: "숃",
    쇼ᄅ: "숄",
    쇼ᄅᄀ: "숅",
    쇼ᄅᄆ: "숆",
    쇼ᄅᄇ: "숇",
    쇼ᄅᄉ: "숈",
    쇼ᄅᄐ: "숉",
    쇼ᄅᄑ: "숊",
    쇼ᄅᄒ: "숋",
    쇼ᄆ: "숌",
    쇼ᄇ: "숍",
    쇼ᄇᄉ: "숎",
    쇼ᄉ: "숏",
    쇼ᄊ: "숐",
    쇼ᄋ: "숑",
    쇼ᄌ: "숒",
    쇼ᄎ: "숓",
    쇼ᄏ: "숔",
    쇼ᄐ: "숕",
    쇼ᄑ: "숖",
    쇼ᄒ: "숗",
    수: "수",
    수ᄀ: "숙",
    수ᄁ: "숚",
    수ᄀᄉ: "숛",
    수ᄂ: "순",
    수ᄂᄌ: "숝",
    수ᄂᄒ: "숞",
    수ᄃ: "숟",
    수ᄅ: "술",
    수ᄅᄀ: "숡",
    수ᄅᄆ: "숢",
    수ᄅᄇ: "숣",
    수ᄅᄉ: "숤",
    수ᄅᄐ: "숥",
    수ᄅᄑ: "숦",
    수ᄅᄒ: "숧",
    수ᄆ: "숨",
    수ᄇ: "숩",
    수ᄇᄉ: "숪",
    수ᄉ: "숫",
    수ᄊ: "숬",
    수ᄋ: "숭",
    수ᄌ: "숮",
    수ᄎ: "숯",
    수ᄏ: "숰",
    수ᄐ: "숱",
    수ᄑ: "숲",
    수ᄒ: "숳",
    수ᅥ: "숴",
    수ᅥᄀ: "숵",
    수ᅥᄁ: "숶",
    수ᅥᄀᄉ: "숷",
    수ᅥᄂ: "숸",
    수ᅥᄂᄌ: "숹",
    수ᅥᄂᄒ: "숺",
    수ᅥᄃ: "숻",
    수ᅥᄅ: "숼",
    수ᅥᄅᄀ: "숽",
    수ᅥᄅᄆ: "숾",
    수ᅥᄅᄇ: "숿",
    수ᅥᄅᄉ: "쉀",
    수ᅥᄅᄐ: "쉁",
    수ᅥᄅᄑ: "쉂",
    수ᅥᄅᄒ: "쉃",
    수ᅥᄆ: "쉄",
    수ᅥᄇ: "쉅",
    수ᅥᄇᄉ: "쉆",
    수ᅥᄉ: "쉇",
    수ᅥᄊ: "쉈",
    수ᅥᄋ: "쉉",
    수ᅥᄌ: "쉊",
    수ᅥᄎ: "쉋",
    수ᅥᄏ: "쉌",
    수ᅥᄐ: "쉍",
    수ᅥᄑ: "쉎",
    수ᅥᄒ: "쉏",
    수ᅦ: "쉐",
    수ᅦᄀ: "쉑",
    수ᅦᄁ: "쉒",
    수ᅦᄀᄉ: "쉓",
    수ᅦᄂ: "쉔",
    수ᅦᄂᄌ: "쉕",
    수ᅦᄂᄒ: "쉖",
    수ᅦᄃ: "쉗",
    수ᅦᄅ: "쉘",
    수ᅦᄅᄀ: "쉙",
    수ᅦᄅᄆ: "쉚",
    수ᅦᄅᄇ: "쉛",
    수ᅦᄅᄉ: "쉜",
    수ᅦᄅᄐ: "쉝",
    수ᅦᄅᄑ: "쉞",
    수ᅦᄅᄒ: "쉟",
    수ᅦᄆ: "쉠",
    수ᅦᄇ: "쉡",
    수ᅦᄇᄉ: "쉢",
    수ᅦᄉ: "쉣",
    수ᅦᄊ: "쉤",
    수ᅦᄋ: "쉥",
    수ᅦᄌ: "쉦",
    수ᅦᄎ: "쉧",
    수ᅦᄏ: "쉨",
    수ᅦᄐ: "쉩",
    수ᅦᄑ: "쉪",
    수ᅦᄒ: "쉫",
    수ᅵ: "쉬",
    수ᅵᄀ: "쉭",
    수ᅵᄁ: "쉮",
    수ᅵᄀᄉ: "쉯",
    수ᅵᄂ: "쉰",
    수ᅵᄂᄌ: "쉱",
    수ᅵᄂᄒ: "쉲",
    수ᅵᄃ: "쉳",
    수ᅵᄅ: "쉴",
    수ᅵᄅᄀ: "쉵",
    수ᅵᄅᄆ: "쉶",
    수ᅵᄅᄇ: "쉷",
    수ᅵᄅᄉ: "쉸",
    수ᅵᄅᄐ: "쉹",
    수ᅵᄅᄑ: "쉺",
    수ᅵᄅᄒ: "쉻",
    수ᅵᄆ: "쉼",
    수ᅵᄇ: "쉽",
    수ᅵᄇᄉ: "쉾",
    수ᅵᄉ: "쉿",
    수ᅵᄊ: "슀",
    수ᅵᄋ: "슁",
    수ᅵᄌ: "슂",
    수ᅵᄎ: "슃",
    수ᅵᄏ: "슄",
    수ᅵᄐ: "슅",
    수ᅵᄑ: "슆",
    수ᅵᄒ: "슇",
    슈: "슈",
    슈ᄀ: "슉",
    슈ᄁ: "슊",
    슈ᄀᄉ: "슋",
    슈ᄂ: "슌",
    슈ᄂᄌ: "슍",
    슈ᄂᄒ: "슎",
    슈ᄃ: "슏",
    슈ᄅ: "슐",
    슈ᄅᄀ: "슑",
    슈ᄅᄆ: "슒",
    슈ᄅᄇ: "슓",
    슈ᄅᄉ: "슔",
    슈ᄅᄐ: "슕",
    슈ᄅᄑ: "슖",
    슈ᄅᄒ: "슗",
    슈ᄆ: "슘",
    슈ᄇ: "슙",
    슈ᄇᄉ: "슚",
    슈ᄉ: "슛",
    슈ᄊ: "슜",
    슈ᄋ: "슝",
    슈ᄌ: "슞",
    슈ᄎ: "슟",
    슈ᄏ: "슠",
    슈ᄐ: "슡",
    슈ᄑ: "슢",
    슈ᄒ: "슣",
    스: "스",
    스ᄀ: "슥",
    스ᄁ: "슦",
    스ᄀᄉ: "슧",
    스ᄂ: "슨",
    스ᄂᄌ: "슩",
    스ᄂᄒ: "슪",
    스ᄃ: "슫",
    스ᄅ: "슬",
    스ᄅᄀ: "슭",
    스ᄅᄆ: "슮",
    스ᄅᄇ: "슯",
    스ᄅᄉ: "슰",
    스ᄅᄐ: "슱",
    스ᄅᄑ: "슲",
    스ᄅᄒ: "슳",
    스ᄆ: "슴",
    스ᄇ: "습",
    스ᄇᄉ: "슶",
    스ᄉ: "슷",
    스ᄊ: "슸",
    스ᄋ: "승",
    스ᄌ: "슺",
    스ᄎ: "슻",
    스ᄏ: "슼",
    스ᄐ: "슽",
    스ᄑ: "슾",
    스ᄒ: "슿",
    스ᅵ: "싀",
    스ᅵᄀ: "싁",
    스ᅵᄁ: "싂",
    스ᅵᄀᄉ: "싃",
    스ᅵᄂ: "싄",
    스ᅵᄂᄌ: "싅",
    스ᅵᄂᄒ: "싆",
    스ᅵᄃ: "싇",
    스ᅵᄅ: "싈",
    스ᅵᄅᄀ: "싉",
    스ᅵᄅᄆ: "싊",
    스ᅵᄅᄇ: "싋",
    스ᅵᄅᄉ: "싌",
    스ᅵᄅᄐ: "싍",
    스ᅵᄅᄑ: "싎",
    스ᅵᄅᄒ: "싏",
    스ᅵᄆ: "싐",
    스ᅵᄇ: "싑",
    스ᅵᄇᄉ: "싒",
    스ᅵᄉ: "싓",
    스ᅵᄊ: "싔",
    스ᅵᄋ: "싕",
    스ᅵᄌ: "싖",
    스ᅵᄎ: "싗",
    스ᅵᄏ: "싘",
    스ᅵᄐ: "싙",
    스ᅵᄑ: "싚",
    스ᅵᄒ: "싛",
    시: "시",
    시ᄀ: "식",
    시ᄁ: "싞",
    시ᄀᄉ: "싟",
    시ᄂ: "신",
    시ᄂᄌ: "싡",
    시ᄂᄒ: "싢",
    시ᄃ: "싣",
    시ᄅ: "실",
    시ᄅᄀ: "싥",
    시ᄅᄆ: "싦",
    시ᄅᄇ: "싧",
    시ᄅᄉ: "싨",
    시ᄅᄐ: "싩",
    시ᄅᄑ: "싪",
    시ᄅᄒ: "싫",
    시ᄆ: "심",
    시ᄇ: "십",
    시ᄇᄉ: "싮",
    시ᄉ: "싯",
    시ᄊ: "싰",
    시ᄋ: "싱",
    시ᄌ: "싲",
    시ᄎ: "싳",
    시ᄏ: "싴",
    시ᄐ: "싵",
    시ᄑ: "싶",
    시ᄒ: "싷",
    싸: "싸",
    싸ᄀ: "싹",
    싸ᄁ: "싺",
    싸ᄀᄉ: "싻",
    싸ᄂ: "싼",
    싸ᄂᄌ: "싽",
    싸ᄂᄒ: "싾",
    싸ᄃ: "싿",
    싸ᄅ: "쌀",
    싸ᄅᄀ: "쌁",
    싸ᄅᄆ: "쌂",
    싸ᄅᄇ: "쌃",
    싸ᄅᄉ: "쌄",
    싸ᄅᄐ: "쌅",
    싸ᄅᄑ: "쌆",
    싸ᄅᄒ: "쌇",
    싸ᄆ: "쌈",
    싸ᄇ: "쌉",
    싸ᄇᄉ: "쌊",
    싸ᄉ: "쌋",
    싸ᄊ: "쌌",
    싸ᄋ: "쌍",
    싸ᄌ: "쌎",
    싸ᄎ: "쌏",
    싸ᄏ: "쌐",
    싸ᄐ: "쌑",
    싸ᄑ: "쌒",
    싸ᄒ: "쌓",
    쌔: "쌔",
    쌔ᄀ: "쌕",
    쌔ᄁ: "쌖",
    쌔ᄀᄉ: "쌗",
    쌔ᄂ: "쌘",
    쌔ᄂᄌ: "쌙",
    쌔ᄂᄒ: "쌚",
    쌔ᄃ: "쌛",
    쌔ᄅ: "쌜",
    쌔ᄅᄀ: "쌝",
    쌔ᄅᄆ: "쌞",
    쌔ᄅᄇ: "쌟",
    쌔ᄅᄉ: "쌠",
    쌔ᄅᄐ: "쌡",
    쌔ᄅᄑ: "쌢",
    쌔ᄅᄒ: "쌣",
    쌔ᄆ: "쌤",
    쌔ᄇ: "쌥",
    쌔ᄇᄉ: "쌦",
    쌔ᄉ: "쌧",
    쌔ᄊ: "쌨",
    쌔ᄋ: "쌩",
    쌔ᄌ: "쌪",
    쌔ᄎ: "쌫",
    쌔ᄏ: "쌬",
    쌔ᄐ: "쌭",
    쌔ᄑ: "쌮",
    쌔ᄒ: "쌯",
    쌰: "쌰",
    쌰ᄀ: "쌱",
    쌰ᄁ: "쌲",
    쌰ᄀᄉ: "쌳",
    쌰ᄂ: "쌴",
    쌰ᄂᄌ: "쌵",
    쌰ᄂᄒ: "쌶",
    쌰ᄃ: "쌷",
    쌰ᄅ: "쌸",
    쌰ᄅᄀ: "쌹",
    쌰ᄅᄆ: "쌺",
    쌰ᄅᄇ: "쌻",
    쌰ᄅᄉ: "쌼",
    쌰ᄅᄐ: "쌽",
    쌰ᄅᄑ: "쌾",
    쌰ᄅᄒ: "쌿",
    쌰ᄆ: "썀",
    쌰ᄇ: "썁",
    쌰ᄇᄉ: "썂",
    쌰ᄉ: "썃",
    쌰ᄊ: "썄",
    쌰ᄋ: "썅",
    쌰ᄌ: "썆",
    쌰ᄎ: "썇",
    쌰ᄏ: "썈",
    쌰ᄐ: "썉",
    쌰ᄑ: "썊",
    쌰ᄒ: "썋",
    썌: "썌",
    썌ᄀ: "썍",
    썌ᄁ: "썎",
    썌ᄀᄉ: "썏",
    썌ᄂ: "썐",
    썌ᄂᄌ: "썑",
    썌ᄂᄒ: "썒",
    썌ᄃ: "썓",
    썌ᄅ: "썔",
    썌ᄅᄀ: "썕",
    썌ᄅᄆ: "썖",
    썌ᄅᄇ: "썗",
    썌ᄅᄉ: "썘",
    썌ᄅᄐ: "썙",
    썌ᄅᄑ: "썚",
    썌ᄅᄒ: "썛",
    썌ᄆ: "썜",
    썌ᄇ: "썝",
    썌ᄇᄉ: "썞",
    썌ᄉ: "썟",
    썌ᄊ: "썠",
    썌ᄋ: "썡",
    썌ᄌ: "썢",
    썌ᄎ: "썣",
    썌ᄏ: "썤",
    썌ᄐ: "썥",
    썌ᄑ: "썦",
    썌ᄒ: "썧",
    써: "써",
    써ᄀ: "썩",
    써ᄁ: "썪",
    써ᄀᄉ: "썫",
    써ᄂ: "썬",
    써ᄂᄌ: "썭",
    써ᄂᄒ: "썮",
    써ᄃ: "썯",
    써ᄅ: "썰",
    써ᄅᄀ: "썱",
    써ᄅᄆ: "썲",
    써ᄅᄇ: "썳",
    써ᄅᄉ: "썴",
    써ᄅᄐ: "썵",
    써ᄅᄑ: "썶",
    써ᄅᄒ: "썷",
    써ᄆ: "썸",
    써ᄇ: "썹",
    써ᄇᄉ: "썺",
    써ᄉ: "썻",
    써ᄊ: "썼",
    써ᄋ: "썽",
    써ᄌ: "썾",
    써ᄎ: "썿",
    써ᄏ: "쎀",
    써ᄐ: "쎁",
    써ᄑ: "쎂",
    써ᄒ: "쎃",
    쎄: "쎄",
    쎄ᄀ: "쎅",
    쎄ᄁ: "쎆",
    쎄ᄀᄉ: "쎇",
    쎄ᄂ: "쎈",
    쎄ᄂᄌ: "쎉",
    쎄ᄂᄒ: "쎊",
    쎄ᄃ: "쎋",
    쎄ᄅ: "쎌",
    쎄ᄅᄀ: "쎍",
    쎄ᄅᄆ: "쎎",
    쎄ᄅᄇ: "쎏",
    쎄ᄅᄉ: "쎐",
    쎄ᄅᄐ: "쎑",
    쎄ᄅᄑ: "쎒",
    쎄ᄅᄒ: "쎓",
    쎄ᄆ: "쎔",
    쎄ᄇ: "쎕",
    쎄ᄇᄉ: "쎖",
    쎄ᄉ: "쎗",
    쎄ᄊ: "쎘",
    쎄ᄋ: "쎙",
    쎄ᄌ: "쎚",
    쎄ᄎ: "쎛",
    쎄ᄏ: "쎜",
    쎄ᄐ: "쎝",
    쎄ᄑ: "쎞",
    쎄ᄒ: "쎟",
    쎠: "쎠",
    쎠ᄀ: "쎡",
    쎠ᄁ: "쎢",
    쎠ᄀᄉ: "쎣",
    쎠ᄂ: "쎤",
    쎠ᄂᄌ: "쎥",
    쎠ᄂᄒ: "쎦",
    쎠ᄃ: "쎧",
    쎠ᄅ: "쎨",
    쎠ᄅᄀ: "쎩",
    쎠ᄅᄆ: "쎪",
    쎠ᄅᄇ: "쎫",
    쎠ᄅᄉ: "쎬",
    쎠ᄅᄐ: "쎭",
    쎠ᄅᄑ: "쎮",
    쎠ᄅᄒ: "쎯",
    쎠ᄆ: "쎰",
    쎠ᄇ: "쎱",
    쎠ᄇᄉ: "쎲",
    쎠ᄉ: "쎳",
    쎠ᄊ: "쎴",
    쎠ᄋ: "쎵",
    쎠ᄌ: "쎶",
    쎠ᄎ: "쎷",
    쎠ᄏ: "쎸",
    쎠ᄐ: "쎹",
    쎠ᄑ: "쎺",
    쎠ᄒ: "쎻",
    쎼: "쎼",
    쎼ᄀ: "쎽",
    쎼ᄁ: "쎾",
    쎼ᄀᄉ: "쎿",
    쎼ᄂ: "쏀",
    쎼ᄂᄌ: "쏁",
    쎼ᄂᄒ: "쏂",
    쎼ᄃ: "쏃",
    쎼ᄅ: "쏄",
    쎼ᄅᄀ: "쏅",
    쎼ᄅᄆ: "쏆",
    쎼ᄅᄇ: "쏇",
    쎼ᄅᄉ: "쏈",
    쎼ᄅᄐ: "쏉",
    쎼ᄅᄑ: "쏊",
    쎼ᄅᄒ: "쏋",
    쎼ᄆ: "쏌",
    쎼ᄇ: "쏍",
    쎼ᄇᄉ: "쏎",
    쎼ᄉ: "쏏",
    쎼ᄊ: "쏐",
    쎼ᄋ: "쏑",
    쎼ᄌ: "쏒",
    쎼ᄎ: "쏓",
    쎼ᄏ: "쏔",
    쎼ᄐ: "쏕",
    쎼ᄑ: "쏖",
    쎼ᄒ: "쏗",
    쏘: "쏘",
    쏘ᄀ: "쏙",
    쏘ᄁ: "쏚",
    쏘ᄀᄉ: "쏛",
    쏘ᄂ: "쏜",
    쏘ᄂᄌ: "쏝",
    쏘ᄂᄒ: "쏞",
    쏘ᄃ: "쏟",
    쏘ᄅ: "쏠",
    쏘ᄅᄀ: "쏡",
    쏘ᄅᄆ: "쏢",
    쏘ᄅᄇ: "쏣",
    쏘ᄅᄉ: "쏤",
    쏘ᄅᄐ: "쏥",
    쏘ᄅᄑ: "쏦",
    쏘ᄅᄒ: "쏧",
    쏘ᄆ: "쏨",
    쏘ᄇ: "쏩",
    쏘ᄇᄉ: "쏪",
    쏘ᄉ: "쏫",
    쏘ᄊ: "쏬",
    쏘ᄋ: "쏭",
    쏘ᄌ: "쏮",
    쏘ᄎ: "쏯",
    쏘ᄏ: "쏰",
    쏘ᄐ: "쏱",
    쏘ᄑ: "쏲",
    쏘ᄒ: "쏳",
    쏘ᅡ: "쏴",
    쏘ᅡᄀ: "쏵",
    쏘ᅡᄁ: "쏶",
    쏘ᅡᄀᄉ: "쏷",
    쏘ᅡᄂ: "쏸",
    쏘ᅡᄂᄌ: "쏹",
    쏘ᅡᄂᄒ: "쏺",
    쏘ᅡᄃ: "쏻",
    쏘ᅡᄅ: "쏼",
    쏘ᅡᄅᄀ: "쏽",
    쏘ᅡᄅᄆ: "쏾",
    쏘ᅡᄅᄇ: "쏿",
    쏘ᅡᄅᄉ: "쐀",
    쏘ᅡᄅᄐ: "쐁",
    쏘ᅡᄅᄑ: "쐂",
    쏘ᅡᄅᄒ: "쐃",
    쏘ᅡᄆ: "쐄",
    쏘ᅡᄇ: "쐅",
    쏘ᅡᄇᄉ: "쐆",
    쏘ᅡᄉ: "쐇",
    쏘ᅡᄊ: "쐈",
    쏘ᅡᄋ: "쐉",
    쏘ᅡᄌ: "쐊",
    쏘ᅡᄎ: "쐋",
    쏘ᅡᄏ: "쐌",
    쏘ᅡᄐ: "쐍",
    쏘ᅡᄑ: "쐎",
    쏘ᅡᄒ: "쐏",
    쏘ᅢ: "쐐",
    쏘ᅢᄀ: "쐑",
    쏘ᅢᄁ: "쐒",
    쏘ᅢᄀᄉ: "쐓",
    쏘ᅢᄂ: "쐔",
    쏘ᅢᄂᄌ: "쐕",
    쏘ᅢᄂᄒ: "쐖",
    쏘ᅢᄃ: "쐗",
    쏘ᅢᄅ: "쐘",
    쏘ᅢᄅᄀ: "쐙",
    쏘ᅢᄅᄆ: "쐚",
    쏘ᅢᄅᄇ: "쐛",
    쏘ᅢᄅᄉ: "쐜",
    쏘ᅢᄅᄐ: "쐝",
    쏘ᅢᄅᄑ: "쐞",
    쏘ᅢᄅᄒ: "쐟",
    쏘ᅢᄆ: "쐠",
    쏘ᅢᄇ: "쐡",
    쏘ᅢᄇᄉ: "쐢",
    쏘ᅢᄉ: "쐣",
    쏘ᅢᄊ: "쐤",
    쏘ᅢᄋ: "쐥",
    쏘ᅢᄌ: "쐦",
    쏘ᅢᄎ: "쐧",
    쏘ᅢᄏ: "쐨",
    쏘ᅢᄐ: "쐩",
    쏘ᅢᄑ: "쐪",
    쏘ᅢᄒ: "쐫",
    쏘ᅵ: "쐬",
    쏘ᅵᄀ: "쐭",
    쏘ᅵᄁ: "쐮",
    쏘ᅵᄀᄉ: "쐯",
    쏘ᅵᄂ: "쐰",
    쏘ᅵᄂᄌ: "쐱",
    쏘ᅵᄂᄒ: "쐲",
    쏘ᅵᄃ: "쐳",
    쏘ᅵᄅ: "쐴",
    쏘ᅵᄅᄀ: "쐵",
    쏘ᅵᄅᄆ: "쐶",
    쏘ᅵᄅᄇ: "쐷",
    쏘ᅵᄅᄉ: "쐸",
    쏘ᅵᄅᄐ: "쐹",
    쏘ᅵᄅᄑ: "쐺",
    쏘ᅵᄅᄒ: "쐻",
    쏘ᅵᄆ: "쐼",
    쏘ᅵᄇ: "쐽",
    쏘ᅵᄇᄉ: "쐾",
    쏘ᅵᄉ: "쐿",
    쏘ᅵᄊ: "쑀",
    쏘ᅵᄋ: "쑁",
    쏘ᅵᄌ: "쑂",
    쏘ᅵᄎ: "쑃",
    쏘ᅵᄏ: "쑄",
    쏘ᅵᄐ: "쑅",
    쏘ᅵᄑ: "쑆",
    쏘ᅵᄒ: "쑇",
    쑈: "쑈",
    쑈ᄀ: "쑉",
    쑈ᄁ: "쑊",
    쑈ᄀᄉ: "쑋",
    쑈ᄂ: "쑌",
    쑈ᄂᄌ: "쑍",
    쑈ᄂᄒ: "쑎",
    쑈ᄃ: "쑏",
    쑈ᄅ: "쑐",
    쑈ᄅᄀ: "쑑",
    쑈ᄅᄆ: "쑒",
    쑈ᄅᄇ: "쑓",
    쑈ᄅᄉ: "쑔",
    쑈ᄅᄐ: "쑕",
    쑈ᄅᄑ: "쑖",
    쑈ᄅᄒ: "쑗",
    쑈ᄆ: "쑘",
    쑈ᄇ: "쑙",
    쑈ᄇᄉ: "쑚",
    쑈ᄉ: "쑛",
    쑈ᄊ: "쑜",
    쑈ᄋ: "쑝",
    쑈ᄌ: "쑞",
    쑈ᄎ: "쑟",
    쑈ᄏ: "쑠",
    쑈ᄐ: "쑡",
    쑈ᄑ: "쑢",
    쑈ᄒ: "쑣",
    쑤: "쑤",
    쑤ᄀ: "쑥",
    쑤ᄁ: "쑦",
    쑤ᄀᄉ: "쑧",
    쑤ᄂ: "쑨",
    쑤ᄂᄌ: "쑩",
    쑤ᄂᄒ: "쑪",
    쑤ᄃ: "쑫",
    쑤ᄅ: "쑬",
    쑤ᄅᄀ: "쑭",
    쑤ᄅᄆ: "쑮",
    쑤ᄅᄇ: "쑯",
    쑤ᄅᄉ: "쑰",
    쑤ᄅᄐ: "쑱",
    쑤ᄅᄑ: "쑲",
    쑤ᄅᄒ: "쑳",
    쑤ᄆ: "쑴",
    쑤ᄇ: "쑵",
    쑤ᄇᄉ: "쑶",
    쑤ᄉ: "쑷",
    쑤ᄊ: "쑸",
    쑤ᄋ: "쑹",
    쑤ᄌ: "쑺",
    쑤ᄎ: "쑻",
    쑤ᄏ: "쑼",
    쑤ᄐ: "쑽",
    쑤ᄑ: "쑾",
    쑤ᄒ: "쑿",
    쑤ᅥ: "쒀",
    쑤ᅥᄀ: "쒁",
    쑤ᅥᄁ: "쒂",
    쑤ᅥᄀᄉ: "쒃",
    쑤ᅥᄂ: "쒄",
    쑤ᅥᄂᄌ: "쒅",
    쑤ᅥᄂᄒ: "쒆",
    쑤ᅥᄃ: "쒇",
    쑤ᅥᄅ: "쒈",
    쑤ᅥᄅᄀ: "쒉",
    쑤ᅥᄅᄆ: "쒊",
    쑤ᅥᄅᄇ: "쒋",
    쑤ᅥᄅᄉ: "쒌",
    쑤ᅥᄅᄐ: "쒍",
    쑤ᅥᄅᄑ: "쒎",
    쑤ᅥᄅᄒ: "쒏",
    쑤ᅥᄆ: "쒐",
    쑤ᅥᄇ: "쒑",
    쑤ᅥᄇᄉ: "쒒",
    쑤ᅥᄉ: "쒓",
    쑤ᅥᄊ: "쒔",
    쑤ᅥᄋ: "쒕",
    쑤ᅥᄌ: "쒖",
    쑤ᅥᄎ: "쒗",
    쑤ᅥᄏ: "쒘",
    쑤ᅥᄐ: "쒙",
    쑤ᅥᄑ: "쒚",
    쑤ᅥᄒ: "쒛",
    쑤ᅦ: "쒜",
    쑤ᅦᄀ: "쒝",
    쑤ᅦᄁ: "쒞",
    쑤ᅦᄀᄉ: "쒟",
    쑤ᅦᄂ: "쒠",
    쑤ᅦᄂᄌ: "쒡",
    쑤ᅦᄂᄒ: "쒢",
    쑤ᅦᄃ: "쒣",
    쑤ᅦᄅ: "쒤",
    쑤ᅦᄅᄀ: "쒥",
    쑤ᅦᄅᄆ: "쒦",
    쑤ᅦᄅᄇ: "쒧",
    쑤ᅦᄅᄉ: "쒨",
    쑤ᅦᄅᄐ: "쒩",
    쑤ᅦᄅᄑ: "쒪",
    쑤ᅦᄅᄒ: "쒫",
    쑤ᅦᄆ: "쒬",
    쑤ᅦᄇ: "쒭",
    쑤ᅦᄇᄉ: "쒮",
    쑤ᅦᄉ: "쒯",
    쑤ᅦᄊ: "쒰",
    쑤ᅦᄋ: "쒱",
    쑤ᅦᄌ: "쒲",
    쑤ᅦᄎ: "쒳",
    쑤ᅦᄏ: "쒴",
    쑤ᅦᄐ: "쒵",
    쑤ᅦᄑ: "쒶",
    쑤ᅦᄒ: "쒷",
    쑤ᅵ: "쒸",
    쑤ᅵᄀ: "쒹",
    쑤ᅵᄁ: "쒺",
    쑤ᅵᄀᄉ: "쒻",
    쑤ᅵᄂ: "쒼",
    쑤ᅵᄂᄌ: "쒽",
    쑤ᅵᄂᄒ: "쒾",
    쑤ᅵᄃ: "쒿",
    쑤ᅵᄅ: "쓀",
    쑤ᅵᄅᄀ: "쓁",
    쑤ᅵᄅᄆ: "쓂",
    쑤ᅵᄅᄇ: "쓃",
    쑤ᅵᄅᄉ: "쓄",
    쑤ᅵᄅᄐ: "쓅",
    쑤ᅵᄅᄑ: "쓆",
    쑤ᅵᄅᄒ: "쓇",
    쑤ᅵᄆ: "쓈",
    쑤ᅵᄇ: "쓉",
    쑤ᅵᄇᄉ: "쓊",
    쑤ᅵᄉ: "쓋",
    쑤ᅵᄊ: "쓌",
    쑤ᅵᄋ: "쓍",
    쑤ᅵᄌ: "쓎",
    쑤ᅵᄎ: "쓏",
    쑤ᅵᄏ: "쓐",
    쑤ᅵᄐ: "쓑",
    쑤ᅵᄑ: "쓒",
    쑤ᅵᄒ: "쓓",
    쓔: "쓔",
    쓔ᄀ: "쓕",
    쓔ᄁ: "쓖",
    쓔ᄀᄉ: "쓗",
    쓔ᄂ: "쓘",
    쓔ᄂᄌ: "쓙",
    쓔ᄂᄒ: "쓚",
    쓔ᄃ: "쓛",
    쓔ᄅ: "쓜",
    쓔ᄅᄀ: "쓝",
    쓔ᄅᄆ: "쓞",
    쓔ᄅᄇ: "쓟",
    쓔ᄅᄉ: "쓠",
    쓔ᄅᄐ: "쓡",
    쓔ᄅᄑ: "쓢",
    쓔ᄅᄒ: "쓣",
    쓔ᄆ: "쓤",
    쓔ᄇ: "쓥",
    쓔ᄇᄉ: "쓦",
    쓔ᄉ: "쓧",
    쓔ᄊ: "쓨",
    쓔ᄋ: "쓩",
    쓔ᄌ: "쓪",
    쓔ᄎ: "쓫",
    쓔ᄏ: "쓬",
    쓔ᄐ: "쓭",
    쓔ᄑ: "쓮",
    쓔ᄒ: "쓯",
    쓰: "쓰",
    쓰ᄀ: "쓱",
    쓰ᄁ: "쓲",
    쓰ᄀᄉ: "쓳",
    쓰ᄂ: "쓴",
    쓰ᄂᄌ: "쓵",
    쓰ᄂᄒ: "쓶",
    쓰ᄃ: "쓷",
    쓰ᄅ: "쓸",
    쓰ᄅᄀ: "쓹",
    쓰ᄅᄆ: "쓺",
    쓰ᄅᄇ: "쓻",
    쓰ᄅᄉ: "쓼",
    쓰ᄅᄐ: "쓽",
    쓰ᄅᄑ: "쓾",
    쓰ᄅᄒ: "쓿",
    쓰ᄆ: "씀",
    쓰ᄇ: "씁",
    쓰ᄇᄉ: "씂",
    쓰ᄉ: "씃",
    쓰ᄊ: "씄",
    쓰ᄋ: "씅",
    쓰ᄌ: "씆",
    쓰ᄎ: "씇",
    쓰ᄏ: "씈",
    쓰ᄐ: "씉",
    쓰ᄑ: "씊",
    쓰ᄒ: "씋",
    쓰ᅵ: "씌",
    쓰ᅵᄀ: "씍",
    쓰ᅵᄁ: "씎",
    쓰ᅵᄀᄉ: "씏",
    쓰ᅵᄂ: "씐",
    쓰ᅵᄂᄌ: "씑",
    쓰ᅵᄂᄒ: "씒",
    쓰ᅵᄃ: "씓",
    쓰ᅵᄅ: "씔",
    쓰ᅵᄅᄀ: "씕",
    쓰ᅵᄅᄆ: "씖",
    쓰ᅵᄅᄇ: "씗",
    쓰ᅵᄅᄉ: "씘",
    쓰ᅵᄅᄐ: "씙",
    쓰ᅵᄅᄑ: "씚",
    쓰ᅵᄅᄒ: "씛",
    쓰ᅵᄆ: "씜",
    쓰ᅵᄇ: "씝",
    쓰ᅵᄇᄉ: "씞",
    쓰ᅵᄉ: "씟",
    쓰ᅵᄊ: "씠",
    쓰ᅵᄋ: "씡",
    쓰ᅵᄌ: "씢",
    쓰ᅵᄎ: "씣",
    쓰ᅵᄏ: "씤",
    쓰ᅵᄐ: "씥",
    쓰ᅵᄑ: "씦",
    쓰ᅵᄒ: "씧",
    씨: "씨",
    씨ᄀ: "씩",
    씨ᄁ: "씪",
    씨ᄀᄉ: "씫",
    씨ᄂ: "씬",
    씨ᄂᄌ: "씭",
    씨ᄂᄒ: "씮",
    씨ᄃ: "씯",
    씨ᄅ: "씰",
    씨ᄅᄀ: "씱",
    씨ᄅᄆ: "씲",
    씨ᄅᄇ: "씳",
    씨ᄅᄉ: "씴",
    씨ᄅᄐ: "씵",
    씨ᄅᄑ: "씶",
    씨ᄅᄒ: "씷",
    씨ᄆ: "씸",
    씨ᄇ: "씹",
    씨ᄇᄉ: "씺",
    씨ᄉ: "씻",
    씨ᄊ: "씼",
    씨ᄋ: "씽",
    씨ᄌ: "씾",
    씨ᄎ: "씿",
    씨ᄏ: "앀",
    씨ᄐ: "앁",
    씨ᄑ: "앂",
    씨ᄒ: "앃",
    아: "아",
    아ᄀ: "악",
    아ᄁ: "앆",
    아ᄀᄉ: "앇",
    아ᄂ: "안",
    아ᄂᄌ: "앉",
    아ᄂᄒ: "않",
    아ᄃ: "앋",
    아ᄅ: "알",
    아ᄅᄀ: "앍",
    아ᄅᄆ: "앎",
    아ᄅᄇ: "앏",
    아ᄅᄉ: "앐",
    아ᄅᄐ: "앑",
    아ᄅᄑ: "앒",
    아ᄅᄒ: "앓",
    아ᄆ: "암",
    아ᄇ: "압",
    아ᄇᄉ: "앖",
    아ᄉ: "앗",
    아ᄊ: "았",
    아ᄋ: "앙",
    아ᄌ: "앚",
    아ᄎ: "앛",
    아ᄏ: "앜",
    아ᄐ: "앝",
    아ᄑ: "앞",
    아ᄒ: "앟",
    애: "애",
    애ᄀ: "액",
    애ᄁ: "앢",
    애ᄀᄉ: "앣",
    애ᄂ: "앤",
    애ᄂᄌ: "앥",
    애ᄂᄒ: "앦",
    애ᄃ: "앧",
    애ᄅ: "앨",
    애ᄅᄀ: "앩",
    애ᄅᄆ: "앪",
    애ᄅᄇ: "앫",
    애ᄅᄉ: "앬",
    애ᄅᄐ: "앭",
    애ᄅᄑ: "앮",
    애ᄅᄒ: "앯",
    애ᄆ: "앰",
    애ᄇ: "앱",
    애ᄇᄉ: "앲",
    애ᄉ: "앳",
    애ᄊ: "앴",
    애ᄋ: "앵",
    애ᄌ: "앶",
    애ᄎ: "앷",
    애ᄏ: "앸",
    애ᄐ: "앹",
    애ᄑ: "앺",
    애ᄒ: "앻",
    야: "야",
    야ᄀ: "약",
    야ᄁ: "앾",
    야ᄀᄉ: "앿",
    야ᄂ: "얀",
    야ᄂᄌ: "얁",
    야ᄂᄒ: "얂",
    야ᄃ: "얃",
    야ᄅ: "얄",
    야ᄅᄀ: "얅",
    야ᄅᄆ: "얆",
    야ᄅᄇ: "얇",
    야ᄅᄉ: "얈",
    야ᄅᄐ: "얉",
    야ᄅᄑ: "얊",
    야ᄅᄒ: "얋",
    야ᄆ: "얌",
    야ᄇ: "얍",
    야ᄇᄉ: "얎",
    야ᄉ: "얏",
    야ᄊ: "얐",
    야ᄋ: "양",
    야ᄌ: "얒",
    야ᄎ: "얓",
    야ᄏ: "얔",
    야ᄐ: "얕",
    야ᄑ: "얖",
    야ᄒ: "얗",
    얘: "얘",
    얘ᄀ: "얙",
    얘ᄁ: "얚",
    얘ᄀᄉ: "얛",
    얘ᄂ: "얜",
    얘ᄂᄌ: "얝",
    얘ᄂᄒ: "얞",
    얘ᄃ: "얟",
    얘ᄅ: "얠",
    얘ᄅᄀ: "얡",
    얘ᄅᄆ: "얢",
    얘ᄅᄇ: "얣",
    얘ᄅᄉ: "얤",
    얘ᄅᄐ: "얥",
    얘ᄅᄑ: "얦",
    얘ᄅᄒ: "얧",
    얘ᄆ: "얨",
    얘ᄇ: "얩",
    얘ᄇᄉ: "얪",
    얘ᄉ: "얫",
    얘ᄊ: "얬",
    얘ᄋ: "얭",
    얘ᄌ: "얮",
    얘ᄎ: "얯",
    얘ᄏ: "얰",
    얘ᄐ: "얱",
    얘ᄑ: "얲",
    얘ᄒ: "얳",
    어: "어",
    어ᄀ: "억",
    어ᄁ: "얶",
    어ᄀᄉ: "얷",
    어ᄂ: "언",
    어ᄂᄌ: "얹",
    어ᄂᄒ: "얺",
    어ᄃ: "얻",
    어ᄅ: "얼",
    어ᄅᄀ: "얽",
    어ᄅᄆ: "얾",
    어ᄅᄇ: "얿",
    어ᄅᄉ: "엀",
    어ᄅᄐ: "엁",
    어ᄅᄑ: "엂",
    어ᄅᄒ: "엃",
    어ᄆ: "엄",
    어ᄇ: "업",
    어ᄇᄉ: "없",
    어ᄉ: "엇",
    어ᄊ: "었",
    어ᄋ: "엉",
    어ᄌ: "엊",
    어ᄎ: "엋",
    어ᄏ: "엌",
    어ᄐ: "엍",
    어ᄑ: "엎",
    어ᄒ: "엏",
    에: "에",
    에ᄀ: "엑",
    에ᄁ: "엒",
    에ᄀᄉ: "엓",
    에ᄂ: "엔",
    에ᄂᄌ: "엕",
    에ᄂᄒ: "엖",
    에ᄃ: "엗",
    에ᄅ: "엘",
    에ᄅᄀ: "엙",
    에ᄅᄆ: "엚",
    에ᄅᄇ: "엛",
    에ᄅᄉ: "엜",
    에ᄅᄐ: "엝",
    에ᄅᄑ: "엞",
    에ᄅᄒ: "엟",
    에ᄆ: "엠",
    에ᄇ: "엡",
    에ᄇᄉ: "엢",
    에ᄉ: "엣",
    에ᄊ: "엤",
    에ᄋ: "엥",
    에ᄌ: "엦",
    에ᄎ: "엧",
    에ᄏ: "엨",
    에ᄐ: "엩",
    에ᄑ: "엪",
    에ᄒ: "엫",
    여: "여",
    여ᄀ: "역",
    여ᄁ: "엮",
    여ᄀᄉ: "엯",
    여ᄂ: "연",
    여ᄂᄌ: "엱",
    여ᄂᄒ: "엲",
    여ᄃ: "엳",
    여ᄅ: "열",
    여ᄅᄀ: "엵",
    여ᄅᄆ: "엶",
    여ᄅᄇ: "엷",
    여ᄅᄉ: "엸",
    여ᄅᄐ: "엹",
    여ᄅᄑ: "엺",
    여ᄅᄒ: "엻",
    여ᄆ: "염",
    여ᄇ: "엽",
    여ᄇᄉ: "엾",
    여ᄉ: "엿",
    여ᄊ: "였",
    여ᄋ: "영",
    여ᄌ: "옂",
    여ᄎ: "옃",
    여ᄏ: "옄",
    여ᄐ: "옅",
    여ᄑ: "옆",
    여ᄒ: "옇",
    예: "예",
    예ᄀ: "옉",
    예ᄁ: "옊",
    예ᄀᄉ: "옋",
    예ᄂ: "옌",
    예ᄂᄌ: "옍",
    예ᄂᄒ: "옎",
    예ᄃ: "옏",
    예ᄅ: "옐",
    예ᄅᄀ: "옑",
    예ᄅᄆ: "옒",
    예ᄅᄇ: "옓",
    예ᄅᄉ: "옔",
    예ᄅᄐ: "옕",
    예ᄅᄑ: "옖",
    예ᄅᄒ: "옗",
    예ᄆ: "옘",
    예ᄇ: "옙",
    예ᄇᄉ: "옚",
    예ᄉ: "옛",
    예ᄊ: "옜",
    예ᄋ: "옝",
    예ᄌ: "옞",
    예ᄎ: "옟",
    예ᄏ: "옠",
    예ᄐ: "옡",
    예ᄑ: "옢",
    예ᄒ: "옣",
    오: "오",
    오ᄀ: "옥",
    오ᄁ: "옦",
    오ᄀᄉ: "옧",
    오ᄂ: "온",
    오ᄂᄌ: "옩",
    오ᄂᄒ: "옪",
    오ᄃ: "옫",
    오ᄅ: "올",
    오ᄅᄀ: "옭",
    오ᄅᄆ: "옮",
    오ᄅᄇ: "옯",
    오ᄅᄉ: "옰",
    오ᄅᄐ: "옱",
    오ᄅᄑ: "옲",
    오ᄅᄒ: "옳",
    오ᄆ: "옴",
    오ᄇ: "옵",
    오ᄇᄉ: "옶",
    오ᄉ: "옷",
    오ᄊ: "옸",
    오ᄋ: "옹",
    오ᄌ: "옺",
    오ᄎ: "옻",
    오ᄏ: "옼",
    오ᄐ: "옽",
    오ᄑ: "옾",
    오ᄒ: "옿",
    오ᅡ: "와",
    오ᅡᄀ: "왁",
    오ᅡᄁ: "왂",
    오ᅡᄀᄉ: "왃",
    오ᅡᄂ: "완",
    오ᅡᄂᄌ: "왅",
    오ᅡᄂᄒ: "왆",
    오ᅡᄃ: "왇",
    오ᅡᄅ: "왈",
    오ᅡᄅᄀ: "왉",
    오ᅡᄅᄆ: "왊",
    오ᅡᄅᄇ: "왋",
    오ᅡᄅᄉ: "왌",
    오ᅡᄅᄐ: "왍",
    오ᅡᄅᄑ: "왎",
    오ᅡᄅᄒ: "왏",
    오ᅡᄆ: "왐",
    오ᅡᄇ: "왑",
    오ᅡᄇᄉ: "왒",
    오ᅡᄉ: "왓",
    오ᅡᄊ: "왔",
    오ᅡᄋ: "왕",
    오ᅡᄌ: "왖",
    오ᅡᄎ: "왗",
    오ᅡᄏ: "왘",
    오ᅡᄐ: "왙",
    오ᅡᄑ: "왚",
    오ᅡᄒ: "왛",
    오ᅢ: "왜",
    오ᅢᄀ: "왝",
    오ᅢᄁ: "왞",
    오ᅢᄀᄉ: "왟",
    오ᅢᄂ: "왠",
    오ᅢᄂᄌ: "왡",
    오ᅢᄂᄒ: "왢",
    오ᅢᄃ: "왣",
    오ᅢᄅ: "왤",
    오ᅢᄅᄀ: "왥",
    오ᅢᄅᄆ: "왦",
    오ᅢᄅᄇ: "왧",
    오ᅢᄅᄉ: "왨",
    오ᅢᄅᄐ: "왩",
    오ᅢᄅᄑ: "왪",
    오ᅢᄅᄒ: "왫",
    오ᅢᄆ: "왬",
    오ᅢᄇ: "왭",
    오ᅢᄇᄉ: "왮",
    오ᅢᄉ: "왯",
    오ᅢᄊ: "왰",
    오ᅢᄋ: "왱",
    오ᅢᄌ: "왲",
    오ᅢᄎ: "왳",
    오ᅢᄏ: "왴",
    오ᅢᄐ: "왵",
    오ᅢᄑ: "왶",
    오ᅢᄒ: "왷",
    오ᅵ: "외",
    오ᅵᄀ: "왹",
    오ᅵᄁ: "왺",
    오ᅵᄀᄉ: "왻",
    오ᅵᄂ: "왼",
    오ᅵᄂᄌ: "왽",
    오ᅵᄂᄒ: "왾",
    오ᅵᄃ: "왿",
    오ᅵᄅ: "욀",
    오ᅵᄅᄀ: "욁",
    오ᅵᄅᄆ: "욂",
    오ᅵᄅᄇ: "욃",
    오ᅵᄅᄉ: "욄",
    오ᅵᄅᄐ: "욅",
    오ᅵᄅᄑ: "욆",
    오ᅵᄅᄒ: "욇",
    오ᅵᄆ: "욈",
    오ᅵᄇ: "욉",
    오ᅵᄇᄉ: "욊",
    오ᅵᄉ: "욋",
    오ᅵᄊ: "욌",
    오ᅵᄋ: "욍",
    오ᅵᄌ: "욎",
    오ᅵᄎ: "욏",
    오ᅵᄏ: "욐",
    오ᅵᄐ: "욑",
    오ᅵᄑ: "욒",
    오ᅵᄒ: "욓",
    요: "요",
    요ᄀ: "욕",
    요ᄁ: "욖",
    요ᄀᄉ: "욗",
    요ᄂ: "욘",
    요ᄂᄌ: "욙",
    요ᄂᄒ: "욚",
    요ᄃ: "욛",
    요ᄅ: "욜",
    요ᄅᄀ: "욝",
    요ᄅᄆ: "욞",
    요ᄅᄇ: "욟",
    요ᄅᄉ: "욠",
    요ᄅᄐ: "욡",
    요ᄅᄑ: "욢",
    요ᄅᄒ: "욣",
    요ᄆ: "욤",
    요ᄇ: "욥",
    요ᄇᄉ: "욦",
    요ᄉ: "욧",
    요ᄊ: "욨",
    요ᄋ: "용",
    요ᄌ: "욪",
    요ᄎ: "욫",
    요ᄏ: "욬",
    요ᄐ: "욭",
    요ᄑ: "욮",
    요ᄒ: "욯",
    우: "우",
    우ᄀ: "욱",
    우ᄁ: "욲",
    우ᄀᄉ: "욳",
    우ᄂ: "운",
    우ᄂᄌ: "욵",
    우ᄂᄒ: "욶",
    우ᄃ: "욷",
    우ᄅ: "울",
    우ᄅᄀ: "욹",
    우ᄅᄆ: "욺",
    우ᄅᄇ: "욻",
    우ᄅᄉ: "욼",
    우ᄅᄐ: "욽",
    우ᄅᄑ: "욾",
    우ᄅᄒ: "욿",
    우ᄆ: "움",
    우ᄇ: "웁",
    우ᄇᄉ: "웂",
    우ᄉ: "웃",
    우ᄊ: "웄",
    우ᄋ: "웅",
    우ᄌ: "웆",
    우ᄎ: "웇",
    우ᄏ: "웈",
    우ᄐ: "웉",
    우ᄑ: "웊",
    우ᄒ: "웋",
    우ᅥ: "워",
    우ᅥᄀ: "웍",
    우ᅥᄁ: "웎",
    우ᅥᄀᄉ: "웏",
    우ᅥᄂ: "원",
    우ᅥᄂᄌ: "웑",
    우ᅥᄂᄒ: "웒",
    우ᅥᄃ: "웓",
    우ᅥᄅ: "월",
    우ᅥᄅᄀ: "웕",
    우ᅥᄅᄆ: "웖",
    우ᅥᄅᄇ: "웗",
    우ᅥᄅᄉ: "웘",
    우ᅥᄅᄐ: "웙",
    우ᅥᄅᄑ: "웚",
    우ᅥᄅᄒ: "웛",
    우ᅥᄆ: "웜",
    우ᅥᄇ: "웝",
    우ᅥᄇᄉ: "웞",
    우ᅥᄉ: "웟",
    우ᅥᄊ: "웠",
    우ᅥᄋ: "웡",
    우ᅥᄌ: "웢",
    우ᅥᄎ: "웣",
    우ᅥᄏ: "웤",
    우ᅥᄐ: "웥",
    우ᅥᄑ: "웦",
    우ᅥᄒ: "웧",
    우ᅦ: "웨",
    우ᅦᄀ: "웩",
    우ᅦᄁ: "웪",
    우ᅦᄀᄉ: "웫",
    우ᅦᄂ: "웬",
    우ᅦᄂᄌ: "웭",
    우ᅦᄂᄒ: "웮",
    우ᅦᄃ: "웯",
    우ᅦᄅ: "웰",
    우ᅦᄅᄀ: "웱",
    우ᅦᄅᄆ: "웲",
    우ᅦᄅᄇ: "웳",
    우ᅦᄅᄉ: "웴",
    우ᅦᄅᄐ: "웵",
    우ᅦᄅᄑ: "웶",
    우ᅦᄅᄒ: "웷",
    우ᅦᄆ: "웸",
    우ᅦᄇ: "웹",
    우ᅦᄇᄉ: "웺",
    우ᅦᄉ: "웻",
    우ᅦᄊ: "웼",
    우ᅦᄋ: "웽",
    우ᅦᄌ: "웾",
    우ᅦᄎ: "웿",
    우ᅦᄏ: "윀",
    우ᅦᄐ: "윁",
    우ᅦᄑ: "윂",
    우ᅦᄒ: "윃",
    우ᅵ: "위",
    우ᅵᄀ: "윅",
    우ᅵᄁ: "윆",
    우ᅵᄀᄉ: "윇",
    우ᅵᄂ: "윈",
    우ᅵᄂᄌ: "윉",
    우ᅵᄂᄒ: "윊",
    우ᅵᄃ: "윋",
    우ᅵᄅ: "윌",
    우ᅵᄅᄀ: "윍",
    우ᅵᄅᄆ: "윎",
    우ᅵᄅᄇ: "윏",
    우ᅵᄅᄉ: "윐",
    우ᅵᄅᄐ: "윑",
    우ᅵᄅᄑ: "윒",
    우ᅵᄅᄒ: "윓",
    우ᅵᄆ: "윔",
    우ᅵᄇ: "윕",
    우ᅵᄇᄉ: "윖",
    우ᅵᄉ: "윗",
    우ᅵᄊ: "윘",
    우ᅵᄋ: "윙",
    우ᅵᄌ: "윚",
    우ᅵᄎ: "윛",
    우ᅵᄏ: "윜",
    우ᅵᄐ: "윝",
    우ᅵᄑ: "윞",
    우ᅵᄒ: "윟",
    유: "유",
    유ᄀ: "육",
    유ᄁ: "윢",
    유ᄀᄉ: "윣",
    유ᄂ: "윤",
    유ᄂᄌ: "윥",
    유ᄂᄒ: "윦",
    유ᄃ: "윧",
    유ᄅ: "율",
    유ᄅᄀ: "윩",
    유ᄅᄆ: "윪",
    유ᄅᄇ: "윫",
    유ᄅᄉ: "윬",
    유ᄅᄐ: "윭",
    유ᄅᄑ: "윮",
    유ᄅᄒ: "윯",
    유ᄆ: "윰",
    유ᄇ: "윱",
    유ᄇᄉ: "윲",
    유ᄉ: "윳",
    유ᄊ: "윴",
    유ᄋ: "융",
    유ᄌ: "윶",
    유ᄎ: "윷",
    유ᄏ: "윸",
    유ᄐ: "윹",
    유ᄑ: "윺",
    유ᄒ: "윻",
    으: "으",
    으ᄀ: "윽",
    으ᄁ: "윾",
    으ᄀᄉ: "윿",
    으ᄂ: "은",
    으ᄂᄌ: "읁",
    으ᄂᄒ: "읂",
    으ᄃ: "읃",
    으ᄅ: "을",
    으ᄅᄀ: "읅",
    으ᄅᄆ: "읆",
    으ᄅᄇ: "읇",
    으ᄅᄉ: "읈",
    으ᄅᄐ: "읉",
    으ᄅᄑ: "읊",
    으ᄅᄒ: "읋",
    으ᄆ: "음",
    으ᄇ: "읍",
    으ᄇᄉ: "읎",
    으ᄉ: "읏",
    으ᄊ: "읐",
    으ᄋ: "응",
    으ᄌ: "읒",
    으ᄎ: "읓",
    으ᄏ: "읔",
    으ᄐ: "읕",
    으ᄑ: "읖",
    으ᄒ: "읗",
    으ᅵ: "의",
    으ᅵᄀ: "읙",
    으ᅵᄁ: "읚",
    으ᅵᄀᄉ: "읛",
    으ᅵᄂ: "읜",
    으ᅵᄂᄌ: "읝",
    으ᅵᄂᄒ: "읞",
    으ᅵᄃ: "읟",
    으ᅵᄅ: "읠",
    으ᅵᄅᄀ: "읡",
    으ᅵᄅᄆ: "읢",
    으ᅵᄅᄇ: "읣",
    으ᅵᄅᄉ: "읤",
    으ᅵᄅᄐ: "읥",
    으ᅵᄅᄑ: "읦",
    으ᅵᄅᄒ: "읧",
    으ᅵᄆ: "읨",
    으ᅵᄇ: "읩",
    으ᅵᄇᄉ: "읪",
    으ᅵᄉ: "읫",
    으ᅵᄊ: "읬",
    으ᅵᄋ: "읭",
    으ᅵᄌ: "읮",
    으ᅵᄎ: "읯",
    으ᅵᄏ: "읰",
    으ᅵᄐ: "읱",
    으ᅵᄑ: "읲",
    으ᅵᄒ: "읳",
    이: "이",
    이ᄀ: "익",
    이ᄁ: "읶",
    이ᄀᄉ: "읷",
    이ᄂ: "인",
    이ᄂᄌ: "읹",
    이ᄂᄒ: "읺",
    이ᄃ: "읻",
    이ᄅ: "일",
    이ᄅᄀ: "읽",
    이ᄅᄆ: "읾",
    이ᄅᄇ: "읿",
    이ᄅᄉ: "잀",
    이ᄅᄐ: "잁",
    이ᄅᄑ: "잂",
    이ᄅᄒ: "잃",
    이ᄆ: "임",
    이ᄇ: "입",
    이ᄇᄉ: "잆",
    이ᄉ: "잇",
    이ᄊ: "있",
    이ᄋ: "잉",
    이ᄌ: "잊",
    이ᄎ: "잋",
    이ᄏ: "잌",
    이ᄐ: "잍",
    이ᄑ: "잎",
    이ᄒ: "잏",
    자: "자",
    자ᄀ: "작",
    자ᄁ: "잒",
    자ᄀᄉ: "잓",
    자ᄂ: "잔",
    자ᄂᄌ: "잕",
    자ᄂᄒ: "잖",
    자ᄃ: "잗",
    자ᄅ: "잘",
    자ᄅᄀ: "잙",
    자ᄅᄆ: "잚",
    자ᄅᄇ: "잛",
    자ᄅᄉ: "잜",
    자ᄅᄐ: "잝",
    자ᄅᄑ: "잞",
    자ᄅᄒ: "잟",
    자ᄆ: "잠",
    자ᄇ: "잡",
    자ᄇᄉ: "잢",
    자ᄉ: "잣",
    자ᄊ: "잤",
    자ᄋ: "장",
    자ᄌ: "잦",
    자ᄎ: "잧",
    자ᄏ: "잨",
    자ᄐ: "잩",
    자ᄑ: "잪",
    자ᄒ: "잫",
    재: "재",
    재ᄀ: "잭",
    재ᄁ: "잮",
    재ᄀᄉ: "잯",
    재ᄂ: "잰",
    재ᄂᄌ: "잱",
    재ᄂᄒ: "잲",
    재ᄃ: "잳",
    재ᄅ: "잴",
    재ᄅᄀ: "잵",
    재ᄅᄆ: "잶",
    재ᄅᄇ: "잷",
    재ᄅᄉ: "잸",
    재ᄅᄐ: "잹",
    재ᄅᄑ: "잺",
    재ᄅᄒ: "잻",
    재ᄆ: "잼",
    재ᄇ: "잽",
    재ᄇᄉ: "잾",
    재ᄉ: "잿",
    재ᄊ: "쟀",
    재ᄋ: "쟁",
    재ᄌ: "쟂",
    재ᄎ: "쟃",
    재ᄏ: "쟄",
    재ᄐ: "쟅",
    재ᄑ: "쟆",
    재ᄒ: "쟇",
    쟈: "쟈",
    쟈ᄀ: "쟉",
    쟈ᄁ: "쟊",
    쟈ᄀᄉ: "쟋",
    쟈ᄂ: "쟌",
    쟈ᄂᄌ: "쟍",
    쟈ᄂᄒ: "쟎",
    쟈ᄃ: "쟏",
    쟈ᄅ: "쟐",
    쟈ᄅᄀ: "쟑",
    쟈ᄅᄆ: "쟒",
    쟈ᄅᄇ: "쟓",
    쟈ᄅᄉ: "쟔",
    쟈ᄅᄐ: "쟕",
    쟈ᄅᄑ: "쟖",
    쟈ᄅᄒ: "쟗",
    쟈ᄆ: "쟘",
    쟈ᄇ: "쟙",
    쟈ᄇᄉ: "쟚",
    쟈ᄉ: "쟛",
    쟈ᄊ: "쟜",
    쟈ᄋ: "쟝",
    쟈ᄌ: "쟞",
    쟈ᄎ: "쟟",
    쟈ᄏ: "쟠",
    쟈ᄐ: "쟡",
    쟈ᄑ: "쟢",
    쟈ᄒ: "쟣",
    쟤: "쟤",
    쟤ᄀ: "쟥",
    쟤ᄁ: "쟦",
    쟤ᄀᄉ: "쟧",
    쟤ᄂ: "쟨",
    쟤ᄂᄌ: "쟩",
    쟤ᄂᄒ: "쟪",
    쟤ᄃ: "쟫",
    쟤ᄅ: "쟬",
    쟤ᄅᄀ: "쟭",
    쟤ᄅᄆ: "쟮",
    쟤ᄅᄇ: "쟯",
    쟤ᄅᄉ: "쟰",
    쟤ᄅᄐ: "쟱",
    쟤ᄅᄑ: "쟲",
    쟤ᄅᄒ: "쟳",
    쟤ᄆ: "쟴",
    쟤ᄇ: "쟵",
    쟤ᄇᄉ: "쟶",
    쟤ᄉ: "쟷",
    쟤ᄊ: "쟸",
    쟤ᄋ: "쟹",
    쟤ᄌ: "쟺",
    쟤ᄎ: "쟻",
    쟤ᄏ: "쟼",
    쟤ᄐ: "쟽",
    쟤ᄑ: "쟾",
    쟤ᄒ: "쟿",
    저: "저",
    저ᄀ: "적",
    저ᄁ: "젂",
    저ᄀᄉ: "젃",
    저ᄂ: "전",
    저ᄂᄌ: "젅",
    저ᄂᄒ: "젆",
    저ᄃ: "젇",
    저ᄅ: "절",
    저ᄅᄀ: "젉",
    저ᄅᄆ: "젊",
    저ᄅᄇ: "젋",
    저ᄅᄉ: "젌",
    저ᄅᄐ: "젍",
    저ᄅᄑ: "젎",
    저ᄅᄒ: "젏",
    저ᄆ: "점",
    저ᄇ: "접",
    저ᄇᄉ: "젒",
    저ᄉ: "젓",
    저ᄊ: "젔",
    저ᄋ: "정",
    저ᄌ: "젖",
    저ᄎ: "젗",
    저ᄏ: "젘",
    저ᄐ: "젙",
    저ᄑ: "젚",
    저ᄒ: "젛",
    제: "제",
    제ᄀ: "젝",
    제ᄁ: "젞",
    제ᄀᄉ: "젟",
    제ᄂ: "젠",
    제ᄂᄌ: "젡",
    제ᄂᄒ: "젢",
    제ᄃ: "젣",
    제ᄅ: "젤",
    제ᄅᄀ: "젥",
    제ᄅᄆ: "젦",
    제ᄅᄇ: "젧",
    제ᄅᄉ: "젨",
    제ᄅᄐ: "젩",
    제ᄅᄑ: "젪",
    제ᄅᄒ: "젫",
    제ᄆ: "젬",
    제ᄇ: "젭",
    제ᄇᄉ: "젮",
    제ᄉ: "젯",
    제ᄊ: "젰",
    제ᄋ: "젱",
    제ᄌ: "젲",
    제ᄎ: "젳",
    제ᄏ: "젴",
    제ᄐ: "젵",
    제ᄑ: "젶",
    제ᄒ: "젷",
    져: "져",
    져ᄀ: "젹",
    져ᄁ: "젺",
    져ᄀᄉ: "젻",
    져ᄂ: "젼",
    져ᄂᄌ: "젽",
    져ᄂᄒ: "젾",
    져ᄃ: "젿",
    져ᄅ: "졀",
    져ᄅᄀ: "졁",
    져ᄅᄆ: "졂",
    져ᄅᄇ: "졃",
    져ᄅᄉ: "졄",
    져ᄅᄐ: "졅",
    져ᄅᄑ: "졆",
    져ᄅᄒ: "졇",
    져ᄆ: "졈",
    져ᄇ: "졉",
    져ᄇᄉ: "졊",
    져ᄉ: "졋",
    져ᄊ: "졌",
    져ᄋ: "졍",
    져ᄌ: "졎",
    져ᄎ: "졏",
    져ᄏ: "졐",
    져ᄐ: "졑",
    져ᄑ: "졒",
    져ᄒ: "졓",
    졔: "졔",
    졔ᄀ: "졕",
    졔ᄁ: "졖",
    졔ᄀᄉ: "졗",
    졔ᄂ: "졘",
    졔ᄂᄌ: "졙",
    졔ᄂᄒ: "졚",
    졔ᄃ: "졛",
    졔ᄅ: "졜",
    졔ᄅᄀ: "졝",
    졔ᄅᄆ: "졞",
    졔ᄅᄇ: "졟",
    졔ᄅᄉ: "졠",
    졔ᄅᄐ: "졡",
    졔ᄅᄑ: "졢",
    졔ᄅᄒ: "졣",
    졔ᄆ: "졤",
    졔ᄇ: "졥",
    졔ᄇᄉ: "졦",
    졔ᄉ: "졧",
    졔ᄊ: "졨",
    졔ᄋ: "졩",
    졔ᄌ: "졪",
    졔ᄎ: "졫",
    졔ᄏ: "졬",
    졔ᄐ: "졭",
    졔ᄑ: "졮",
    졔ᄒ: "졯",
    조: "조",
    조ᄀ: "족",
    조ᄁ: "졲",
    조ᄀᄉ: "졳",
    조ᄂ: "존",
    조ᄂᄌ: "졵",
    조ᄂᄒ: "졶",
    조ᄃ: "졷",
    조ᄅ: "졸",
    조ᄅᄀ: "졹",
    조ᄅᄆ: "졺",
    조ᄅᄇ: "졻",
    조ᄅᄉ: "졼",
    조ᄅᄐ: "졽",
    조ᄅᄑ: "졾",
    조ᄅᄒ: "졿",
    조ᄆ: "좀",
    조ᄇ: "좁",
    조ᄇᄉ: "좂",
    조ᄉ: "좃",
    조ᄊ: "좄",
    조ᄋ: "종",
    조ᄌ: "좆",
    조ᄎ: "좇",
    조ᄏ: "좈",
    조ᄐ: "좉",
    조ᄑ: "좊",
    조ᄒ: "좋",
    조ᅡ: "좌",
    조ᅡᄀ: "좍",
    조ᅡᄁ: "좎",
    조ᅡᄀᄉ: "좏",
    조ᅡᄂ: "좐",
    조ᅡᄂᄌ: "좑",
    조ᅡᄂᄒ: "좒",
    조ᅡᄃ: "좓",
    조ᅡᄅ: "좔",
    조ᅡᄅᄀ: "좕",
    조ᅡᄅᄆ: "좖",
    조ᅡᄅᄇ: "좗",
    조ᅡᄅᄉ: "좘",
    조ᅡᄅᄐ: "좙",
    조ᅡᄅᄑ: "좚",
    조ᅡᄅᄒ: "좛",
    조ᅡᄆ: "좜",
    조ᅡᄇ: "좝",
    조ᅡᄇᄉ: "좞",
    조ᅡᄉ: "좟",
    조ᅡᄊ: "좠",
    조ᅡᄋ: "좡",
    조ᅡᄌ: "좢",
    조ᅡᄎ: "좣",
    조ᅡᄏ: "좤",
    조ᅡᄐ: "좥",
    조ᅡᄑ: "좦",
    조ᅡᄒ: "좧",
    조ᅢ: "좨",
    조ᅢᄀ: "좩",
    조ᅢᄁ: "좪",
    조ᅢᄀᄉ: "좫",
    조ᅢᄂ: "좬",
    조ᅢᄂᄌ: "좭",
    조ᅢᄂᄒ: "좮",
    조ᅢᄃ: "좯",
    조ᅢᄅ: "좰",
    조ᅢᄅᄀ: "좱",
    조ᅢᄅᄆ: "좲",
    조ᅢᄅᄇ: "좳",
    조ᅢᄅᄉ: "좴",
    조ᅢᄅᄐ: "좵",
    조ᅢᄅᄑ: "좶",
    조ᅢᄅᄒ: "좷",
    조ᅢᄆ: "좸",
    조ᅢᄇ: "좹",
    조ᅢᄇᄉ: "좺",
    조ᅢᄉ: "좻",
    조ᅢᄊ: "좼",
    조ᅢᄋ: "좽",
    조ᅢᄌ: "좾",
    조ᅢᄎ: "좿",
    조ᅢᄏ: "죀",
    조ᅢᄐ: "죁",
    조ᅢᄑ: "죂",
    조ᅢᄒ: "죃",
    조ᅵ: "죄",
    조ᅵᄀ: "죅",
    조ᅵᄁ: "죆",
    조ᅵᄀᄉ: "죇",
    조ᅵᄂ: "죈",
    조ᅵᄂᄌ: "죉",
    조ᅵᄂᄒ: "죊",
    조ᅵᄃ: "죋",
    조ᅵᄅ: "죌",
    조ᅵᄅᄀ: "죍",
    조ᅵᄅᄆ: "죎",
    조ᅵᄅᄇ: "죏",
    조ᅵᄅᄉ: "죐",
    조ᅵᄅᄐ: "죑",
    조ᅵᄅᄑ: "죒",
    조ᅵᄅᄒ: "죓",
    조ᅵᄆ: "죔",
    조ᅵᄇ: "죕",
    조ᅵᄇᄉ: "죖",
    조ᅵᄉ: "죗",
    조ᅵᄊ: "죘",
    조ᅵᄋ: "죙",
    조ᅵᄌ: "죚",
    조ᅵᄎ: "죛",
    조ᅵᄏ: "죜",
    조ᅵᄐ: "죝",
    조ᅵᄑ: "죞",
    조ᅵᄒ: "죟",
    죠: "죠",
    죠ᄀ: "죡",
    죠ᄁ: "죢",
    죠ᄀᄉ: "죣",
    죠ᄂ: "죤",
    죠ᄂᄌ: "죥",
    죠ᄂᄒ: "죦",
    죠ᄃ: "죧",
    죠ᄅ: "죨",
    죠ᄅᄀ: "죩",
    죠ᄅᄆ: "죪",
    죠ᄅᄇ: "죫",
    죠ᄅᄉ: "죬",
    죠ᄅᄐ: "죭",
    죠ᄅᄑ: "죮",
    죠ᄅᄒ: "죯",
    죠ᄆ: "죰",
    죠ᄇ: "죱",
    죠ᄇᄉ: "죲",
    죠ᄉ: "죳",
    죠ᄊ: "죴",
    죠ᄋ: "죵",
    죠ᄌ: "죶",
    죠ᄎ: "죷",
    죠ᄏ: "죸",
    죠ᄐ: "죹",
    죠ᄑ: "죺",
    죠ᄒ: "죻",
    주: "주",
    주ᄀ: "죽",
    주ᄁ: "죾",
    주ᄀᄉ: "죿",
    주ᄂ: "준",
    주ᄂᄌ: "줁",
    주ᄂᄒ: "줂",
    주ᄃ: "줃",
    주ᄅ: "줄",
    주ᄅᄀ: "줅",
    주ᄅᄆ: "줆",
    주ᄅᄇ: "줇",
    주ᄅᄉ: "줈",
    주ᄅᄐ: "줉",
    주ᄅᄑ: "줊",
    주ᄅᄒ: "줋",
    주ᄆ: "줌",
    주ᄇ: "줍",
    주ᄇᄉ: "줎",
    주ᄉ: "줏",
    주ᄊ: "줐",
    주ᄋ: "중",
    주ᄌ: "줒",
    주ᄎ: "줓",
    주ᄏ: "줔",
    주ᄐ: "줕",
    주ᄑ: "줖",
    주ᄒ: "줗",
    주ᅥ: "줘",
    주ᅥᄀ: "줙",
    주ᅥᄁ: "줚",
    주ᅥᄀᄉ: "줛",
    주ᅥᄂ: "줜",
    주ᅥᄂᄌ: "줝",
    주ᅥᄂᄒ: "줞",
    주ᅥᄃ: "줟",
    주ᅥᄅ: "줠",
    주ᅥᄅᄀ: "줡",
    주ᅥᄅᄆ: "줢",
    주ᅥᄅᄇ: "줣",
    주ᅥᄅᄉ: "줤",
    주ᅥᄅᄐ: "줥",
    주ᅥᄅᄑ: "줦",
    주ᅥᄅᄒ: "줧",
    주ᅥᄆ: "줨",
    주ᅥᄇ: "줩",
    주ᅥᄇᄉ: "줪",
    주ᅥᄉ: "줫",
    주ᅥᄊ: "줬",
    주ᅥᄋ: "줭",
    주ᅥᄌ: "줮",
    주ᅥᄎ: "줯",
    주ᅥᄏ: "줰",
    주ᅥᄐ: "줱",
    주ᅥᄑ: "줲",
    주ᅥᄒ: "줳",
    주ᅦ: "줴",
    주ᅦᄀ: "줵",
    주ᅦᄁ: "줶",
    주ᅦᄀᄉ: "줷",
    주ᅦᄂ: "줸",
    주ᅦᄂᄌ: "줹",
    주ᅦᄂᄒ: "줺",
    주ᅦᄃ: "줻",
    주ᅦᄅ: "줼",
    주ᅦᄅᄀ: "줽",
    주ᅦᄅᄆ: "줾",
    주ᅦᄅᄇ: "줿",
    주ᅦᄅᄉ: "쥀",
    주ᅦᄅᄐ: "쥁",
    주ᅦᄅᄑ: "쥂",
    주ᅦᄅᄒ: "쥃",
    주ᅦᄆ: "쥄",
    주ᅦᄇ: "쥅",
    주ᅦᄇᄉ: "쥆",
    주ᅦᄉ: "쥇",
    주ᅦᄊ: "쥈",
    주ᅦᄋ: "쥉",
    주ᅦᄌ: "쥊",
    주ᅦᄎ: "쥋",
    주ᅦᄏ: "쥌",
    주ᅦᄐ: "쥍",
    주ᅦᄑ: "쥎",
    주ᅦᄒ: "쥏",
    주ᅵ: "쥐",
    주ᅵᄀ: "쥑",
    주ᅵᄁ: "쥒",
    주ᅵᄀᄉ: "쥓",
    주ᅵᄂ: "쥔",
    주ᅵᄂᄌ: "쥕",
    주ᅵᄂᄒ: "쥖",
    주ᅵᄃ: "쥗",
    주ᅵᄅ: "쥘",
    주ᅵᄅᄀ: "쥙",
    주ᅵᄅᄆ: "쥚",
    주ᅵᄅᄇ: "쥛",
    주ᅵᄅᄉ: "쥜",
    주ᅵᄅᄐ: "쥝",
    주ᅵᄅᄑ: "쥞",
    주ᅵᄅᄒ: "쥟",
    주ᅵᄆ: "쥠",
    주ᅵᄇ: "쥡",
    주ᅵᄇᄉ: "쥢",
    주ᅵᄉ: "쥣",
    주ᅵᄊ: "쥤",
    주ᅵᄋ: "쥥",
    주ᅵᄌ: "쥦",
    주ᅵᄎ: "쥧",
    주ᅵᄏ: "쥨",
    주ᅵᄐ: "쥩",
    주ᅵᄑ: "쥪",
    주ᅵᄒ: "쥫",
    쥬: "쥬",
    쥬ᄀ: "쥭",
    쥬ᄁ: "쥮",
    쥬ᄀᄉ: "쥯",
    쥬ᄂ: "쥰",
    쥬ᄂᄌ: "쥱",
    쥬ᄂᄒ: "쥲",
    쥬ᄃ: "쥳",
    쥬ᄅ: "쥴",
    쥬ᄅᄀ: "쥵",
    쥬ᄅᄆ: "쥶",
    쥬ᄅᄇ: "쥷",
    쥬ᄅᄉ: "쥸",
    쥬ᄅᄐ: "쥹",
    쥬ᄅᄑ: "쥺",
    쥬ᄅᄒ: "쥻",
    쥬ᄆ: "쥼",
    쥬ᄇ: "쥽",
    쥬ᄇᄉ: "쥾",
    쥬ᄉ: "쥿",
    쥬ᄊ: "즀",
    쥬ᄋ: "즁",
    쥬ᄌ: "즂",
    쥬ᄎ: "즃",
    쥬ᄏ: "즄",
    쥬ᄐ: "즅",
    쥬ᄑ: "즆",
    쥬ᄒ: "즇",
    즈: "즈",
    즈ᄀ: "즉",
    즈ᄁ: "즊",
    즈ᄀᄉ: "즋",
    즈ᄂ: "즌",
    즈ᄂᄌ: "즍",
    즈ᄂᄒ: "즎",
    즈ᄃ: "즏",
    즈ᄅ: "즐",
    즈ᄅᄀ: "즑",
    즈ᄅᄆ: "즒",
    즈ᄅᄇ: "즓",
    즈ᄅᄉ: "즔",
    즈ᄅᄐ: "즕",
    즈ᄅᄑ: "즖",
    즈ᄅᄒ: "즗",
    즈ᄆ: "즘",
    즈ᄇ: "즙",
    즈ᄇᄉ: "즚",
    즈ᄉ: "즛",
    즈ᄊ: "즜",
    즈ᄋ: "증",
    즈ᄌ: "즞",
    즈ᄎ: "즟",
    즈ᄏ: "즠",
    즈ᄐ: "즡",
    즈ᄑ: "즢",
    즈ᄒ: "즣",
    즈ᅵ: "즤",
    즈ᅵᄀ: "즥",
    즈ᅵᄁ: "즦",
    즈ᅵᄀᄉ: "즧",
    즈ᅵᄂ: "즨",
    즈ᅵᄂᄌ: "즩",
    즈ᅵᄂᄒ: "즪",
    즈ᅵᄃ: "즫",
    즈ᅵᄅ: "즬",
    즈ᅵᄅᄀ: "즭",
    즈ᅵᄅᄆ: "즮",
    즈ᅵᄅᄇ: "즯",
    즈ᅵᄅᄉ: "즰",
    즈ᅵᄅᄐ: "즱",
    즈ᅵᄅᄑ: "즲",
    즈ᅵᄅᄒ: "즳",
    즈ᅵᄆ: "즴",
    즈ᅵᄇ: "즵",
    즈ᅵᄇᄉ: "즶",
    즈ᅵᄉ: "즷",
    즈ᅵᄊ: "즸",
    즈ᅵᄋ: "즹",
    즈ᅵᄌ: "즺",
    즈ᅵᄎ: "즻",
    즈ᅵᄏ: "즼",
    즈ᅵᄐ: "즽",
    즈ᅵᄑ: "즾",
    즈ᅵᄒ: "즿",
    지: "지",
    지ᄀ: "직",
    지ᄁ: "짂",
    지ᄀᄉ: "짃",
    지ᄂ: "진",
    지ᄂᄌ: "짅",
    지ᄂᄒ: "짆",
    지ᄃ: "짇",
    지ᄅ: "질",
    지ᄅᄀ: "짉",
    지ᄅᄆ: "짊",
    지ᄅᄇ: "짋",
    지ᄅᄉ: "짌",
    지ᄅᄐ: "짍",
    지ᄅᄑ: "짎",
    지ᄅᄒ: "짏",
    지ᄆ: "짐",
    지ᄇ: "집",
    지ᄇᄉ: "짒",
    지ᄉ: "짓",
    지ᄊ: "짔",
    지ᄋ: "징",
    지ᄌ: "짖",
    지ᄎ: "짗",
    지ᄏ: "짘",
    지ᄐ: "짙",
    지ᄑ: "짚",
    지ᄒ: "짛",
    짜: "짜",
    짜ᄀ: "짝",
    짜ᄁ: "짞",
    짜ᄀᄉ: "짟",
    짜ᄂ: "짠",
    짜ᄂᄌ: "짡",
    짜ᄂᄒ: "짢",
    짜ᄃ: "짣",
    짜ᄅ: "짤",
    짜ᄅᄀ: "짥",
    짜ᄅᄆ: "짦",
    짜ᄅᄇ: "짧",
    짜ᄅᄉ: "짨",
    짜ᄅᄐ: "짩",
    짜ᄅᄑ: "짪",
    짜ᄅᄒ: "짫",
    짜ᄆ: "짬",
    짜ᄇ: "짭",
    짜ᄇᄉ: "짮",
    짜ᄉ: "짯",
    짜ᄊ: "짰",
    짜ᄋ: "짱",
    짜ᄌ: "짲",
    짜ᄎ: "짳",
    짜ᄏ: "짴",
    짜ᄐ: "짵",
    짜ᄑ: "짶",
    짜ᄒ: "짷",
    째: "째",
    째ᄀ: "짹",
    째ᄁ: "짺",
    째ᄀᄉ: "짻",
    째ᄂ: "짼",
    째ᄂᄌ: "짽",
    째ᄂᄒ: "짾",
    째ᄃ: "짿",
    째ᄅ: "쨀",
    째ᄅᄀ: "쨁",
    째ᄅᄆ: "쨂",
    째ᄅᄇ: "쨃",
    째ᄅᄉ: "쨄",
    째ᄅᄐ: "쨅",
    째ᄅᄑ: "쨆",
    째ᄅᄒ: "쨇",
    째ᄆ: "쨈",
    째ᄇ: "쨉",
    째ᄇᄉ: "쨊",
    째ᄉ: "쨋",
    째ᄊ: "쨌",
    째ᄋ: "쨍",
    째ᄌ: "쨎",
    째ᄎ: "쨏",
    째ᄏ: "쨐",
    째ᄐ: "쨑",
    째ᄑ: "쨒",
    째ᄒ: "쨓",
    쨔: "쨔",
    쨔ᄀ: "쨕",
    쨔ᄁ: "쨖",
    쨔ᄀᄉ: "쨗",
    쨔ᄂ: "쨘",
    쨔ᄂᄌ: "쨙",
    쨔ᄂᄒ: "쨚",
    쨔ᄃ: "쨛",
    쨔ᄅ: "쨜",
    쨔ᄅᄀ: "쨝",
    쨔ᄅᄆ: "쨞",
    쨔ᄅᄇ: "쨟",
    쨔ᄅᄉ: "쨠",
    쨔ᄅᄐ: "쨡",
    쨔ᄅᄑ: "쨢",
    쨔ᄅᄒ: "쨣",
    쨔ᄆ: "쨤",
    쨔ᄇ: "쨥",
    쨔ᄇᄉ: "쨦",
    쨔ᄉ: "쨧",
    쨔ᄊ: "쨨",
    쨔ᄋ: "쨩",
    쨔ᄌ: "쨪",
    쨔ᄎ: "쨫",
    쨔ᄏ: "쨬",
    쨔ᄐ: "쨭",
    쨔ᄑ: "쨮",
    쨔ᄒ: "쨯",
    쨰: "쨰",
    쨰ᄀ: "쨱",
    쨰ᄁ: "쨲",
    쨰ᄀᄉ: "쨳",
    쨰ᄂ: "쨴",
    쨰ᄂᄌ: "쨵",
    쨰ᄂᄒ: "쨶",
    쨰ᄃ: "쨷",
    쨰ᄅ: "쨸",
    쨰ᄅᄀ: "쨹",
    쨰ᄅᄆ: "쨺",
    쨰ᄅᄇ: "쨻",
    쨰ᄅᄉ: "쨼",
    쨰ᄅᄐ: "쨽",
    쨰ᄅᄑ: "쨾",
    쨰ᄅᄒ: "쨿",
    쨰ᄆ: "쩀",
    쨰ᄇ: "쩁",
    쨰ᄇᄉ: "쩂",
    쨰ᄉ: "쩃",
    쨰ᄊ: "쩄",
    쨰ᄋ: "쩅",
    쨰ᄌ: "쩆",
    쨰ᄎ: "쩇",
    쨰ᄏ: "쩈",
    쨰ᄐ: "쩉",
    쨰ᄑ: "쩊",
    쨰ᄒ: "쩋",
    쩌: "쩌",
    쩌ᄀ: "쩍",
    쩌ᄁ: "쩎",
    쩌ᄀᄉ: "쩏",
    쩌ᄂ: "쩐",
    쩌ᄂᄌ: "쩑",
    쩌ᄂᄒ: "쩒",
    쩌ᄃ: "쩓",
    쩌ᄅ: "쩔",
    쩌ᄅᄀ: "쩕",
    쩌ᄅᄆ: "쩖",
    쩌ᄅᄇ: "쩗",
    쩌ᄅᄉ: "쩘",
    쩌ᄅᄐ: "쩙",
    쩌ᄅᄑ: "쩚",
    쩌ᄅᄒ: "쩛",
    쩌ᄆ: "쩜",
    쩌ᄇ: "쩝",
    쩌ᄇᄉ: "쩞",
    쩌ᄉ: "쩟",
    쩌ᄊ: "쩠",
    쩌ᄋ: "쩡",
    쩌ᄌ: "쩢",
    쩌ᄎ: "쩣",
    쩌ᄏ: "쩤",
    쩌ᄐ: "쩥",
    쩌ᄑ: "쩦",
    쩌ᄒ: "쩧",
    쩨: "쩨",
    쩨ᄀ: "쩩",
    쩨ᄁ: "쩪",
    쩨ᄀᄉ: "쩫",
    쩨ᄂ: "쩬",
    쩨ᄂᄌ: "쩭",
    쩨ᄂᄒ: "쩮",
    쩨ᄃ: "쩯",
    쩨ᄅ: "쩰",
    쩨ᄅᄀ: "쩱",
    쩨ᄅᄆ: "쩲",
    쩨ᄅᄇ: "쩳",
    쩨ᄅᄉ: "쩴",
    쩨ᄅᄐ: "쩵",
    쩨ᄅᄑ: "쩶",
    쩨ᄅᄒ: "쩷",
    쩨ᄆ: "쩸",
    쩨ᄇ: "쩹",
    쩨ᄇᄉ: "쩺",
    쩨ᄉ: "쩻",
    쩨ᄊ: "쩼",
    쩨ᄋ: "쩽",
    쩨ᄌ: "쩾",
    쩨ᄎ: "쩿",
    쩨ᄏ: "쪀",
    쩨ᄐ: "쪁",
    쩨ᄑ: "쪂",
    쩨ᄒ: "쪃",
    쪄: "쪄",
    쪄ᄀ: "쪅",
    쪄ᄁ: "쪆",
    쪄ᄀᄉ: "쪇",
    쪄ᄂ: "쪈",
    쪄ᄂᄌ: "쪉",
    쪄ᄂᄒ: "쪊",
    쪄ᄃ: "쪋",
    쪄ᄅ: "쪌",
    쪄ᄅᄀ: "쪍",
    쪄ᄅᄆ: "쪎",
    쪄ᄅᄇ: "쪏",
    쪄ᄅᄉ: "쪐",
    쪄ᄅᄐ: "쪑",
    쪄ᄅᄑ: "쪒",
    쪄ᄅᄒ: "쪓",
    쪄ᄆ: "쪔",
    쪄ᄇ: "쪕",
    쪄ᄇᄉ: "쪖",
    쪄ᄉ: "쪗",
    쪄ᄊ: "쪘",
    쪄ᄋ: "쪙",
    쪄ᄌ: "쪚",
    쪄ᄎ: "쪛",
    쪄ᄏ: "쪜",
    쪄ᄐ: "쪝",
    쪄ᄑ: "쪞",
    쪄ᄒ: "쪟",
    쪠: "쪠",
    쪠ᄀ: "쪡",
    쪠ᄁ: "쪢",
    쪠ᄀᄉ: "쪣",
    쪠ᄂ: "쪤",
    쪠ᄂᄌ: "쪥",
    쪠ᄂᄒ: "쪦",
    쪠ᄃ: "쪧",
    쪠ᄅ: "쪨",
    쪠ᄅᄀ: "쪩",
    쪠ᄅᄆ: "쪪",
    쪠ᄅᄇ: "쪫",
    쪠ᄅᄉ: "쪬",
    쪠ᄅᄐ: "쪭",
    쪠ᄅᄑ: "쪮",
    쪠ᄅᄒ: "쪯",
    쪠ᄆ: "쪰",
    쪠ᄇ: "쪱",
    쪠ᄇᄉ: "쪲",
    쪠ᄉ: "쪳",
    쪠ᄊ: "쪴",
    쪠ᄋ: "쪵",
    쪠ᄌ: "쪶",
    쪠ᄎ: "쪷",
    쪠ᄏ: "쪸",
    쪠ᄐ: "쪹",
    쪠ᄑ: "쪺",
    쪠ᄒ: "쪻",
    쪼: "쪼",
    쪼ᄀ: "쪽",
    쪼ᄁ: "쪾",
    쪼ᄀᄉ: "쪿",
    쪼ᄂ: "쫀",
    쪼ᄂᄌ: "쫁",
    쪼ᄂᄒ: "쫂",
    쪼ᄃ: "쫃",
    쪼ᄅ: "쫄",
    쪼ᄅᄀ: "쫅",
    쪼ᄅᄆ: "쫆",
    쪼ᄅᄇ: "쫇",
    쪼ᄅᄉ: "쫈",
    쪼ᄅᄐ: "쫉",
    쪼ᄅᄑ: "쫊",
    쪼ᄅᄒ: "쫋",
    쪼ᄆ: "쫌",
    쪼ᄇ: "쫍",
    쪼ᄇᄉ: "쫎",
    쪼ᄉ: "쫏",
    쪼ᄊ: "쫐",
    쪼ᄋ: "쫑",
    쪼ᄌ: "쫒",
    쪼ᄎ: "쫓",
    쪼ᄏ: "쫔",
    쪼ᄐ: "쫕",
    쪼ᄑ: "쫖",
    쪼ᄒ: "쫗",
    쪼ᅡ: "쫘",
    쪼ᅡᄀ: "쫙",
    쪼ᅡᄁ: "쫚",
    쪼ᅡᄀᄉ: "쫛",
    쪼ᅡᄂ: "쫜",
    쪼ᅡᄂᄌ: "쫝",
    쪼ᅡᄂᄒ: "쫞",
    쪼ᅡᄃ: "쫟",
    쪼ᅡᄅ: "쫠",
    쪼ᅡᄅᄀ: "쫡",
    쪼ᅡᄅᄆ: "쫢",
    쪼ᅡᄅᄇ: "쫣",
    쪼ᅡᄅᄉ: "쫤",
    쪼ᅡᄅᄐ: "쫥",
    쪼ᅡᄅᄑ: "쫦",
    쪼ᅡᄅᄒ: "쫧",
    쪼ᅡᄆ: "쫨",
    쪼ᅡᄇ: "쫩",
    쪼ᅡᄇᄉ: "쫪",
    쪼ᅡᄉ: "쫫",
    쪼ᅡᄊ: "쫬",
    쪼ᅡᄋ: "쫭",
    쪼ᅡᄌ: "쫮",
    쪼ᅡᄎ: "쫯",
    쪼ᅡᄏ: "쫰",
    쪼ᅡᄐ: "쫱",
    쪼ᅡᄑ: "쫲",
    쪼ᅡᄒ: "쫳",
    쪼ᅢ: "쫴",
    쪼ᅢᄀ: "쫵",
    쪼ᅢᄁ: "쫶",
    쪼ᅢᄀᄉ: "쫷",
    쪼ᅢᄂ: "쫸",
    쪼ᅢᄂᄌ: "쫹",
    쪼ᅢᄂᄒ: "쫺",
    쪼ᅢᄃ: "쫻",
    쪼ᅢᄅ: "쫼",
    쪼ᅢᄅᄀ: "쫽",
    쪼ᅢᄅᄆ: "쫾",
    쪼ᅢᄅᄇ: "쫿",
    쪼ᅢᄅᄉ: "쬀",
    쪼ᅢᄅᄐ: "쬁",
    쪼ᅢᄅᄑ: "쬂",
    쪼ᅢᄅᄒ: "쬃",
    쪼ᅢᄆ: "쬄",
    쪼ᅢᄇ: "쬅",
    쪼ᅢᄇᄉ: "쬆",
    쪼ᅢᄉ: "쬇",
    쪼ᅢᄊ: "쬈",
    쪼ᅢᄋ: "쬉",
    쪼ᅢᄌ: "쬊",
    쪼ᅢᄎ: "쬋",
    쪼ᅢᄏ: "쬌",
    쪼ᅢᄐ: "쬍",
    쪼ᅢᄑ: "쬎",
    쪼ᅢᄒ: "쬏",
    쪼ᅵ: "쬐",
    쪼ᅵᄀ: "쬑",
    쪼ᅵᄁ: "쬒",
    쪼ᅵᄀᄉ: "쬓",
    쪼ᅵᄂ: "쬔",
    쪼ᅵᄂᄌ: "쬕",
    쪼ᅵᄂᄒ: "쬖",
    쪼ᅵᄃ: "쬗",
    쪼ᅵᄅ: "쬘",
    쪼ᅵᄅᄀ: "쬙",
    쪼ᅵᄅᄆ: "쬚",
    쪼ᅵᄅᄇ: "쬛",
    쪼ᅵᄅᄉ: "쬜",
    쪼ᅵᄅᄐ: "쬝",
    쪼ᅵᄅᄑ: "쬞",
    쪼ᅵᄅᄒ: "쬟",
    쪼ᅵᄆ: "쬠",
    쪼ᅵᄇ: "쬡",
    쪼ᅵᄇᄉ: "쬢",
    쪼ᅵᄉ: "쬣",
    쪼ᅵᄊ: "쬤",
    쪼ᅵᄋ: "쬥",
    쪼ᅵᄌ: "쬦",
    쪼ᅵᄎ: "쬧",
    쪼ᅵᄏ: "쬨",
    쪼ᅵᄐ: "쬩",
    쪼ᅵᄑ: "쬪",
    쪼ᅵᄒ: "쬫",
    쬬: "쬬",
    쬬ᄀ: "쬭",
    쬬ᄁ: "쬮",
    쬬ᄀᄉ: "쬯",
    쬬ᄂ: "쬰",
    쬬ᄂᄌ: "쬱",
    쬬ᄂᄒ: "쬲",
    쬬ᄃ: "쬳",
    쬬ᄅ: "쬴",
    쬬ᄅᄀ: "쬵",
    쬬ᄅᄆ: "쬶",
    쬬ᄅᄇ: "쬷",
    쬬ᄅᄉ: "쬸",
    쬬ᄅᄐ: "쬹",
    쬬ᄅᄑ: "쬺",
    쬬ᄅᄒ: "쬻",
    쬬ᄆ: "쬼",
    쬬ᄇ: "쬽",
    쬬ᄇᄉ: "쬾",
    쬬ᄉ: "쬿",
    쬬ᄊ: "쭀",
    쬬ᄋ: "쭁",
    쬬ᄌ: "쭂",
    쬬ᄎ: "쭃",
    쬬ᄏ: "쭄",
    쬬ᄐ: "쭅",
    쬬ᄑ: "쭆",
    쬬ᄒ: "쭇",
    쭈: "쭈",
    쭈ᄀ: "쭉",
    쭈ᄁ: "쭊",
    쭈ᄀᄉ: "쭋",
    쭈ᄂ: "쭌",
    쭈ᄂᄌ: "쭍",
    쭈ᄂᄒ: "쭎",
    쭈ᄃ: "쭏",
    쭈ᄅ: "쭐",
    쭈ᄅᄀ: "쭑",
    쭈ᄅᄆ: "쭒",
    쭈ᄅᄇ: "쭓",
    쭈ᄅᄉ: "쭔",
    쭈ᄅᄐ: "쭕",
    쭈ᄅᄑ: "쭖",
    쭈ᄅᄒ: "쭗",
    쭈ᄆ: "쭘",
    쭈ᄇ: "쭙",
    쭈ᄇᄉ: "쭚",
    쭈ᄉ: "쭛",
    쭈ᄊ: "쭜",
    쭈ᄋ: "쭝",
    쭈ᄌ: "쭞",
    쭈ᄎ: "쭟",
    쭈ᄏ: "쭠",
    쭈ᄐ: "쭡",
    쭈ᄑ: "쭢",
    쭈ᄒ: "쭣",
    쭈ᅥ: "쭤",
    쭈ᅥᄀ: "쭥",
    쭈ᅥᄁ: "쭦",
    쭈ᅥᄀᄉ: "쭧",
    쭈ᅥᄂ: "쭨",
    쭈ᅥᄂᄌ: "쭩",
    쭈ᅥᄂᄒ: "쭪",
    쭈ᅥᄃ: "쭫",
    쭈ᅥᄅ: "쭬",
    쭈ᅥᄅᄀ: "쭭",
    쭈ᅥᄅᄆ: "쭮",
    쭈ᅥᄅᄇ: "쭯",
    쭈ᅥᄅᄉ: "쭰",
    쭈ᅥᄅᄐ: "쭱",
    쭈ᅥᄅᄑ: "쭲",
    쭈ᅥᄅᄒ: "쭳",
    쭈ᅥᄆ: "쭴",
    쭈ᅥᄇ: "쭵",
    쭈ᅥᄇᄉ: "쭶",
    쭈ᅥᄉ: "쭷",
    쭈ᅥᄊ: "쭸",
    쭈ᅥᄋ: "쭹",
    쭈ᅥᄌ: "쭺",
    쭈ᅥᄎ: "쭻",
    쭈ᅥᄏ: "쭼",
    쭈ᅥᄐ: "쭽",
    쭈ᅥᄑ: "쭾",
    쭈ᅥᄒ: "쭿",
    쭈ᅦ: "쮀",
    쭈ᅦᄀ: "쮁",
    쭈ᅦᄁ: "쮂",
    쭈ᅦᄀᄉ: "쮃",
    쭈ᅦᄂ: "쮄",
    쭈ᅦᄂᄌ: "쮅",
    쭈ᅦᄂᄒ: "쮆",
    쭈ᅦᄃ: "쮇",
    쭈ᅦᄅ: "쮈",
    쭈ᅦᄅᄀ: "쮉",
    쭈ᅦᄅᄆ: "쮊",
    쭈ᅦᄅᄇ: "쮋",
    쭈ᅦᄅᄉ: "쮌",
    쭈ᅦᄅᄐ: "쮍",
    쭈ᅦᄅᄑ: "쮎",
    쭈ᅦᄅᄒ: "쮏",
    쭈ᅦᄆ: "쮐",
    쭈ᅦᄇ: "쮑",
    쭈ᅦᄇᄉ: "쮒",
    쭈ᅦᄉ: "쮓",
    쭈ᅦᄊ: "쮔",
    쭈ᅦᄋ: "쮕",
    쭈ᅦᄌ: "쮖",
    쭈ᅦᄎ: "쮗",
    쭈ᅦᄏ: "쮘",
    쭈ᅦᄐ: "쮙",
    쭈ᅦᄑ: "쮚",
    쭈ᅦᄒ: "쮛",
    쭈ᅵ: "쮜",
    쭈ᅵᄀ: "쮝",
    쭈ᅵᄁ: "쮞",
    쭈ᅵᄀᄉ: "쮟",
    쭈ᅵᄂ: "쮠",
    쭈ᅵᄂᄌ: "쮡",
    쭈ᅵᄂᄒ: "쮢",
    쭈ᅵᄃ: "쮣",
    쭈ᅵᄅ: "쮤",
    쭈ᅵᄅᄀ: "쮥",
    쭈ᅵᄅᄆ: "쮦",
    쭈ᅵᄅᄇ: "쮧",
    쭈ᅵᄅᄉ: "쮨",
    쭈ᅵᄅᄐ: "쮩",
    쭈ᅵᄅᄑ: "쮪",
    쭈ᅵᄅᄒ: "쮫",
    쭈ᅵᄆ: "쮬",
    쭈ᅵᄇ: "쮭",
    쭈ᅵᄇᄉ: "쮮",
    쭈ᅵᄉ: "쮯",
    쭈ᅵᄊ: "쮰",
    쭈ᅵᄋ: "쮱",
    쭈ᅵᄌ: "쮲",
    쭈ᅵᄎ: "쮳",
    쭈ᅵᄏ: "쮴",
    쭈ᅵᄐ: "쮵",
    쭈ᅵᄑ: "쮶",
    쭈ᅵᄒ: "쮷",
    쮸: "쮸",
    쮸ᄀ: "쮹",
    쮸ᄁ: "쮺",
    쮸ᄀᄉ: "쮻",
    쮸ᄂ: "쮼",
    쮸ᄂᄌ: "쮽",
    쮸ᄂᄒ: "쮾",
    쮸ᄃ: "쮿",
    쮸ᄅ: "쯀",
    쮸ᄅᄀ: "쯁",
    쮸ᄅᄆ: "쯂",
    쮸ᄅᄇ: "쯃",
    쮸ᄅᄉ: "쯄",
    쮸ᄅᄐ: "쯅",
    쮸ᄅᄑ: "쯆",
    쮸ᄅᄒ: "쯇",
    쮸ᄆ: "쯈",
    쮸ᄇ: "쯉",
    쮸ᄇᄉ: "쯊",
    쮸ᄉ: "쯋",
    쮸ᄊ: "쯌",
    쮸ᄋ: "쯍",
    쮸ᄌ: "쯎",
    쮸ᄎ: "쯏",
    쮸ᄏ: "쯐",
    쮸ᄐ: "쯑",
    쮸ᄑ: "쯒",
    쮸ᄒ: "쯓",
    쯔: "쯔",
    쯔ᄀ: "쯕",
    쯔ᄁ: "쯖",
    쯔ᄀᄉ: "쯗",
    쯔ᄂ: "쯘",
    쯔ᄂᄌ: "쯙",
    쯔ᄂᄒ: "쯚",
    쯔ᄃ: "쯛",
    쯔ᄅ: "쯜",
    쯔ᄅᄀ: "쯝",
    쯔ᄅᄆ: "쯞",
    쯔ᄅᄇ: "쯟",
    쯔ᄅᄉ: "쯠",
    쯔ᄅᄐ: "쯡",
    쯔ᄅᄑ: "쯢",
    쯔ᄅᄒ: "쯣",
    쯔ᄆ: "쯤",
    쯔ᄇ: "쯥",
    쯔ᄇᄉ: "쯦",
    쯔ᄉ: "쯧",
    쯔ᄊ: "쯨",
    쯔ᄋ: "쯩",
    쯔ᄌ: "쯪",
    쯔ᄎ: "쯫",
    쯔ᄏ: "쯬",
    쯔ᄐ: "쯭",
    쯔ᄑ: "쯮",
    쯔ᄒ: "쯯",
    쯔ᅵ: "쯰",
    쯔ᅵᄀ: "쯱",
    쯔ᅵᄁ: "쯲",
    쯔ᅵᄀᄉ: "쯳",
    쯔ᅵᄂ: "쯴",
    쯔ᅵᄂᄌ: "쯵",
    쯔ᅵᄂᄒ: "쯶",
    쯔ᅵᄃ: "쯷",
    쯔ᅵᄅ: "쯸",
    쯔ᅵᄅᄀ: "쯹",
    쯔ᅵᄅᄆ: "쯺",
    쯔ᅵᄅᄇ: "쯻",
    쯔ᅵᄅᄉ: "쯼",
    쯔ᅵᄅᄐ: "쯽",
    쯔ᅵᄅᄑ: "쯾",
    쯔ᅵᄅᄒ: "쯿",
    쯔ᅵᄆ: "찀",
    쯔ᅵᄇ: "찁",
    쯔ᅵᄇᄉ: "찂",
    쯔ᅵᄉ: "찃",
    쯔ᅵᄊ: "찄",
    쯔ᅵᄋ: "찅",
    쯔ᅵᄌ: "찆",
    쯔ᅵᄎ: "찇",
    쯔ᅵᄏ: "찈",
    쯔ᅵᄐ: "찉",
    쯔ᅵᄑ: "찊",
    쯔ᅵᄒ: "찋",
    찌: "찌",
    찌ᄀ: "찍",
    찌ᄁ: "찎",
    찌ᄀᄉ: "찏",
    찌ᄂ: "찐",
    찌ᄂᄌ: "찑",
    찌ᄂᄒ: "찒",
    찌ᄃ: "찓",
    찌ᄅ: "찔",
    찌ᄅᄀ: "찕",
    찌ᄅᄆ: "찖",
    찌ᄅᄇ: "찗",
    찌ᄅᄉ: "찘",
    찌ᄅᄐ: "찙",
    찌ᄅᄑ: "찚",
    찌ᄅᄒ: "찛",
    찌ᄆ: "찜",
    찌ᄇ: "찝",
    찌ᄇᄉ: "찞",
    찌ᄉ: "찟",
    찌ᄊ: "찠",
    찌ᄋ: "찡",
    찌ᄌ: "찢",
    찌ᄎ: "찣",
    찌ᄏ: "찤",
    찌ᄐ: "찥",
    찌ᄑ: "찦",
    찌ᄒ: "찧",
    차: "차",
    차ᄀ: "착",
    차ᄁ: "찪",
    차ᄀᄉ: "찫",
    차ᄂ: "찬",
    차ᄂᄌ: "찭",
    차ᄂᄒ: "찮",
    차ᄃ: "찯",
    차ᄅ: "찰",
    차ᄅᄀ: "찱",
    차ᄅᄆ: "찲",
    차ᄅᄇ: "찳",
    차ᄅᄉ: "찴",
    차ᄅᄐ: "찵",
    차ᄅᄑ: "찶",
    차ᄅᄒ: "찷",
    차ᄆ: "참",
    차ᄇ: "찹",
    차ᄇᄉ: "찺",
    차ᄉ: "찻",
    차ᄊ: "찼",
    차ᄋ: "창",
    차ᄌ: "찾",
    차ᄎ: "찿",
    차ᄏ: "챀",
    차ᄐ: "챁",
    차ᄑ: "챂",
    차ᄒ: "챃",
    채: "채",
    채ᄀ: "책",
    채ᄁ: "챆",
    채ᄀᄉ: "챇",
    채ᄂ: "챈",
    채ᄂᄌ: "챉",
    채ᄂᄒ: "챊",
    채ᄃ: "챋",
    채ᄅ: "챌",
    채ᄅᄀ: "챍",
    채ᄅᄆ: "챎",
    채ᄅᄇ: "챏",
    채ᄅᄉ: "챐",
    채ᄅᄐ: "챑",
    채ᄅᄑ: "챒",
    채ᄅᄒ: "챓",
    채ᄆ: "챔",
    채ᄇ: "챕",
    채ᄇᄉ: "챖",
    채ᄉ: "챗",
    채ᄊ: "챘",
    채ᄋ: "챙",
    채ᄌ: "챚",
    채ᄎ: "챛",
    채ᄏ: "챜",
    채ᄐ: "챝",
    채ᄑ: "챞",
    채ᄒ: "챟",
    챠: "챠",
    챠ᄀ: "챡",
    챠ᄁ: "챢",
    챠ᄀᄉ: "챣",
    챠ᄂ: "챤",
    챠ᄂᄌ: "챥",
    챠ᄂᄒ: "챦",
    챠ᄃ: "챧",
    챠ᄅ: "챨",
    챠ᄅᄀ: "챩",
    챠ᄅᄆ: "챪",
    챠ᄅᄇ: "챫",
    챠ᄅᄉ: "챬",
    챠ᄅᄐ: "챭",
    챠ᄅᄑ: "챮",
    챠ᄅᄒ: "챯",
    챠ᄆ: "챰",
    챠ᄇ: "챱",
    챠ᄇᄉ: "챲",
    챠ᄉ: "챳",
    챠ᄊ: "챴",
    챠ᄋ: "챵",
    챠ᄌ: "챶",
    챠ᄎ: "챷",
    챠ᄏ: "챸",
    챠ᄐ: "챹",
    챠ᄑ: "챺",
    챠ᄒ: "챻",
    챼: "챼",
    챼ᄀ: "챽",
    챼ᄁ: "챾",
    챼ᄀᄉ: "챿",
    챼ᄂ: "첀",
    챼ᄂᄌ: "첁",
    챼ᄂᄒ: "첂",
    챼ᄃ: "첃",
    챼ᄅ: "첄",
    챼ᄅᄀ: "첅",
    챼ᄅᄆ: "첆",
    챼ᄅᄇ: "첇",
    챼ᄅᄉ: "첈",
    챼ᄅᄐ: "첉",
    챼ᄅᄑ: "첊",
    챼ᄅᄒ: "첋",
    챼ᄆ: "첌",
    챼ᄇ: "첍",
    챼ᄇᄉ: "첎",
    챼ᄉ: "첏",
    챼ᄊ: "첐",
    챼ᄋ: "첑",
    챼ᄌ: "첒",
    챼ᄎ: "첓",
    챼ᄏ: "첔",
    챼ᄐ: "첕",
    챼ᄑ: "첖",
    챼ᄒ: "첗",
    처: "처",
    처ᄀ: "척",
    처ᄁ: "첚",
    처ᄀᄉ: "첛",
    처ᄂ: "천",
    처ᄂᄌ: "첝",
    처ᄂᄒ: "첞",
    처ᄃ: "첟",
    처ᄅ: "철",
    처ᄅᄀ: "첡",
    처ᄅᄆ: "첢",
    처ᄅᄇ: "첣",
    처ᄅᄉ: "첤",
    처ᄅᄐ: "첥",
    처ᄅᄑ: "첦",
    처ᄅᄒ: "첧",
    처ᄆ: "첨",
    처ᄇ: "첩",
    처ᄇᄉ: "첪",
    처ᄉ: "첫",
    처ᄊ: "첬",
    처ᄋ: "청",
    처ᄌ: "첮",
    처ᄎ: "첯",
    처ᄏ: "첰",
    처ᄐ: "첱",
    처ᄑ: "첲",
    처ᄒ: "첳",
    체: "체",
    체ᄀ: "첵",
    체ᄁ: "첶",
    체ᄀᄉ: "첷",
    체ᄂ: "첸",
    체ᄂᄌ: "첹",
    체ᄂᄒ: "첺",
    체ᄃ: "첻",
    체ᄅ: "첼",
    체ᄅᄀ: "첽",
    체ᄅᄆ: "첾",
    체ᄅᄇ: "첿",
    체ᄅᄉ: "쳀",
    체ᄅᄐ: "쳁",
    체ᄅᄑ: "쳂",
    체ᄅᄒ: "쳃",
    체ᄆ: "쳄",
    체ᄇ: "쳅",
    체ᄇᄉ: "쳆",
    체ᄉ: "쳇",
    체ᄊ: "쳈",
    체ᄋ: "쳉",
    체ᄌ: "쳊",
    체ᄎ: "쳋",
    체ᄏ: "쳌",
    체ᄐ: "쳍",
    체ᄑ: "쳎",
    체ᄒ: "쳏",
    쳐: "쳐",
    쳐ᄀ: "쳑",
    쳐ᄁ: "쳒",
    쳐ᄀᄉ: "쳓",
    쳐ᄂ: "쳔",
    쳐ᄂᄌ: "쳕",
    쳐ᄂᄒ: "쳖",
    쳐ᄃ: "쳗",
    쳐ᄅ: "쳘",
    쳐ᄅᄀ: "쳙",
    쳐ᄅᄆ: "쳚",
    쳐ᄅᄇ: "쳛",
    쳐ᄅᄉ: "쳜",
    쳐ᄅᄐ: "쳝",
    쳐ᄅᄑ: "쳞",
    쳐ᄅᄒ: "쳟",
    쳐ᄆ: "쳠",
    쳐ᄇ: "쳡",
    쳐ᄇᄉ: "쳢",
    쳐ᄉ: "쳣",
    쳐ᄊ: "쳤",
    쳐ᄋ: "쳥",
    쳐ᄌ: "쳦",
    쳐ᄎ: "쳧",
    쳐ᄏ: "쳨",
    쳐ᄐ: "쳩",
    쳐ᄑ: "쳪",
    쳐ᄒ: "쳫",
    쳬: "쳬",
    쳬ᄀ: "쳭",
    쳬ᄁ: "쳮",
    쳬ᄀᄉ: "쳯",
    쳬ᄂ: "쳰",
    쳬ᄂᄌ: "쳱",
    쳬ᄂᄒ: "쳲",
    쳬ᄃ: "쳳",
    쳬ᄅ: "쳴",
    쳬ᄅᄀ: "쳵",
    쳬ᄅᄆ: "쳶",
    쳬ᄅᄇ: "쳷",
    쳬ᄅᄉ: "쳸",
    쳬ᄅᄐ: "쳹",
    쳬ᄅᄑ: "쳺",
    쳬ᄅᄒ: "쳻",
    쳬ᄆ: "쳼",
    쳬ᄇ: "쳽",
    쳬ᄇᄉ: "쳾",
    쳬ᄉ: "쳿",
    쳬ᄊ: "촀",
    쳬ᄋ: "촁",
    쳬ᄌ: "촂",
    쳬ᄎ: "촃",
    쳬ᄏ: "촄",
    쳬ᄐ: "촅",
    쳬ᄑ: "촆",
    쳬ᄒ: "촇",
    초: "초",
    초ᄀ: "촉",
    초ᄁ: "촊",
    초ᄀᄉ: "촋",
    초ᄂ: "촌",
    초ᄂᄌ: "촍",
    초ᄂᄒ: "촎",
    초ᄃ: "촏",
    초ᄅ: "촐",
    초ᄅᄀ: "촑",
    초ᄅᄆ: "촒",
    초ᄅᄇ: "촓",
    초ᄅᄉ: "촔",
    초ᄅᄐ: "촕",
    초ᄅᄑ: "촖",
    초ᄅᄒ: "촗",
    초ᄆ: "촘",
    초ᄇ: "촙",
    초ᄇᄉ: "촚",
    초ᄉ: "촛",
    초ᄊ: "촜",
    초ᄋ: "총",
    초ᄌ: "촞",
    초ᄎ: "촟",
    초ᄏ: "촠",
    초ᄐ: "촡",
    초ᄑ: "촢",
    초ᄒ: "촣",
    초ᅡ: "촤",
    초ᅡᄀ: "촥",
    초ᅡᄁ: "촦",
    초ᅡᄀᄉ: "촧",
    초ᅡᄂ: "촨",
    초ᅡᄂᄌ: "촩",
    초ᅡᄂᄒ: "촪",
    초ᅡᄃ: "촫",
    초ᅡᄅ: "촬",
    초ᅡᄅᄀ: "촭",
    초ᅡᄅᄆ: "촮",
    초ᅡᄅᄇ: "촯",
    초ᅡᄅᄉ: "촰",
    초ᅡᄅᄐ: "촱",
    초ᅡᄅᄑ: "촲",
    초ᅡᄅᄒ: "촳",
    초ᅡᄆ: "촴",
    초ᅡᄇ: "촵",
    초ᅡᄇᄉ: "촶",
    초ᅡᄉ: "촷",
    초ᅡᄊ: "촸",
    초ᅡᄋ: "촹",
    초ᅡᄌ: "촺",
    초ᅡᄎ: "촻",
    초ᅡᄏ: "촼",
    초ᅡᄐ: "촽",
    초ᅡᄑ: "촾",
    초ᅡᄒ: "촿",
    초ᅢ: "쵀",
    초ᅢᄀ: "쵁",
    초ᅢᄁ: "쵂",
    초ᅢᄀᄉ: "쵃",
    초ᅢᄂ: "쵄",
    초ᅢᄂᄌ: "쵅",
    초ᅢᄂᄒ: "쵆",
    초ᅢᄃ: "쵇",
    초ᅢᄅ: "쵈",
    초ᅢᄅᄀ: "쵉",
    초ᅢᄅᄆ: "쵊",
    초ᅢᄅᄇ: "쵋",
    초ᅢᄅᄉ: "쵌",
    초ᅢᄅᄐ: "쵍",
    초ᅢᄅᄑ: "쵎",
    초ᅢᄅᄒ: "쵏",
    초ᅢᄆ: "쵐",
    초ᅢᄇ: "쵑",
    초ᅢᄇᄉ: "쵒",
    초ᅢᄉ: "쵓",
    초ᅢᄊ: "쵔",
    초ᅢᄋ: "쵕",
    초ᅢᄌ: "쵖",
    초ᅢᄎ: "쵗",
    초ᅢᄏ: "쵘",
    초ᅢᄐ: "쵙",
    초ᅢᄑ: "쵚",
    초ᅢᄒ: "쵛",
    초ᅵ: "최",
    초ᅵᄀ: "쵝",
    초ᅵᄁ: "쵞",
    초ᅵᄀᄉ: "쵟",
    초ᅵᄂ: "쵠",
    초ᅵᄂᄌ: "쵡",
    초ᅵᄂᄒ: "쵢",
    초ᅵᄃ: "쵣",
    초ᅵᄅ: "쵤",
    초ᅵᄅᄀ: "쵥",
    초ᅵᄅᄆ: "쵦",
    초ᅵᄅᄇ: "쵧",
    초ᅵᄅᄉ: "쵨",
    초ᅵᄅᄐ: "쵩",
    초ᅵᄅᄑ: "쵪",
    초ᅵᄅᄒ: "쵫",
    초ᅵᄆ: "쵬",
    초ᅵᄇ: "쵭",
    초ᅵᄇᄉ: "쵮",
    초ᅵᄉ: "쵯",
    초ᅵᄊ: "쵰",
    초ᅵᄋ: "쵱",
    초ᅵᄌ: "쵲",
    초ᅵᄎ: "쵳",
    초ᅵᄏ: "쵴",
    초ᅵᄐ: "쵵",
    초ᅵᄑ: "쵶",
    초ᅵᄒ: "쵷",
    쵸: "쵸",
    쵸ᄀ: "쵹",
    쵸ᄁ: "쵺",
    쵸ᄀᄉ: "쵻",
    쵸ᄂ: "쵼",
    쵸ᄂᄌ: "쵽",
    쵸ᄂᄒ: "쵾",
    쵸ᄃ: "쵿",
    쵸ᄅ: "춀",
    쵸ᄅᄀ: "춁",
    쵸ᄅᄆ: "춂",
    쵸ᄅᄇ: "춃",
    쵸ᄅᄉ: "춄",
    쵸ᄅᄐ: "춅",
    쵸ᄅᄑ: "춆",
    쵸ᄅᄒ: "춇",
    쵸ᄆ: "춈",
    쵸ᄇ: "춉",
    쵸ᄇᄉ: "춊",
    쵸ᄉ: "춋",
    쵸ᄊ: "춌",
    쵸ᄋ: "춍",
    쵸ᄌ: "춎",
    쵸ᄎ: "춏",
    쵸ᄏ: "춐",
    쵸ᄐ: "춑",
    쵸ᄑ: "춒",
    쵸ᄒ: "춓",
    추: "추",
    추ᄀ: "축",
    추ᄁ: "춖",
    추ᄀᄉ: "춗",
    추ᄂ: "춘",
    추ᄂᄌ: "춙",
    추ᄂᄒ: "춚",
    추ᄃ: "춛",
    추ᄅ: "출",
    추ᄅᄀ: "춝",
    추ᄅᄆ: "춞",
    추ᄅᄇ: "춟",
    추ᄅᄉ: "춠",
    추ᄅᄐ: "춡",
    추ᄅᄑ: "춢",
    추ᄅᄒ: "춣",
    추ᄆ: "춤",
    추ᄇ: "춥",
    추ᄇᄉ: "춦",
    추ᄉ: "춧",
    추ᄊ: "춨",
    추ᄋ: "충",
    추ᄌ: "춪",
    추ᄎ: "춫",
    추ᄏ: "춬",
    추ᄐ: "춭",
    추ᄑ: "춮",
    추ᄒ: "춯",
    추ᅥ: "춰",
    추ᅥᄀ: "춱",
    추ᅥᄁ: "춲",
    추ᅥᄀᄉ: "춳",
    추ᅥᄂ: "춴",
    추ᅥᄂᄌ: "춵",
    추ᅥᄂᄒ: "춶",
    추ᅥᄃ: "춷",
    추ᅥᄅ: "춸",
    추ᅥᄅᄀ: "춹",
    추ᅥᄅᄆ: "춺",
    추ᅥᄅᄇ: "춻",
    추ᅥᄅᄉ: "춼",
    추ᅥᄅᄐ: "춽",
    추ᅥᄅᄑ: "춾",
    추ᅥᄅᄒ: "춿",
    추ᅥᄆ: "췀",
    추ᅥᄇ: "췁",
    추ᅥᄇᄉ: "췂",
    추ᅥᄉ: "췃",
    추ᅥᄊ: "췄",
    추ᅥᄋ: "췅",
    추ᅥᄌ: "췆",
    추ᅥᄎ: "췇",
    추ᅥᄏ: "췈",
    추ᅥᄐ: "췉",
    추ᅥᄑ: "췊",
    추ᅥᄒ: "췋",
    추ᅦ: "췌",
    추ᅦᄀ: "췍",
    추ᅦᄁ: "췎",
    추ᅦᄀᄉ: "췏",
    추ᅦᄂ: "췐",
    추ᅦᄂᄌ: "췑",
    추ᅦᄂᄒ: "췒",
    추ᅦᄃ: "췓",
    추ᅦᄅ: "췔",
    추ᅦᄅᄀ: "췕",
    추ᅦᄅᄆ: "췖",
    추ᅦᄅᄇ: "췗",
    추ᅦᄅᄉ: "췘",
    추ᅦᄅᄐ: "췙",
    추ᅦᄅᄑ: "췚",
    추ᅦᄅᄒ: "췛",
    추ᅦᄆ: "췜",
    추ᅦᄇ: "췝",
    추ᅦᄇᄉ: "췞",
    추ᅦᄉ: "췟",
    추ᅦᄊ: "췠",
    추ᅦᄋ: "췡",
    추ᅦᄌ: "췢",
    추ᅦᄎ: "췣",
    추ᅦᄏ: "췤",
    추ᅦᄐ: "췥",
    추ᅦᄑ: "췦",
    추ᅦᄒ: "췧",
    추ᅵ: "취",
    추ᅵᄀ: "췩",
    추ᅵᄁ: "췪",
    추ᅵᄀᄉ: "췫",
    추ᅵᄂ: "췬",
    추ᅵᄂᄌ: "췭",
    추ᅵᄂᄒ: "췮",
    추ᅵᄃ: "췯",
    추ᅵᄅ: "췰",
    추ᅵᄅᄀ: "췱",
    추ᅵᄅᄆ: "췲",
    추ᅵᄅᄇ: "췳",
    추ᅵᄅᄉ: "췴",
    추ᅵᄅᄐ: "췵",
    추ᅵᄅᄑ: "췶",
    추ᅵᄅᄒ: "췷",
    추ᅵᄆ: "췸",
    추ᅵᄇ: "췹",
    추ᅵᄇᄉ: "췺",
    추ᅵᄉ: "췻",
    추ᅵᄊ: "췼",
    추ᅵᄋ: "췽",
    추ᅵᄌ: "췾",
    추ᅵᄎ: "췿",
    추ᅵᄏ: "츀",
    추ᅵᄐ: "츁",
    추ᅵᄑ: "츂",
    추ᅵᄒ: "츃",
    츄: "츄",
    츄ᄀ: "츅",
    츄ᄁ: "츆",
    츄ᄀᄉ: "츇",
    츄ᄂ: "츈",
    츄ᄂᄌ: "츉",
    츄ᄂᄒ: "츊",
    츄ᄃ: "츋",
    츄ᄅ: "츌",
    츄ᄅᄀ: "츍",
    츄ᄅᄆ: "츎",
    츄ᄅᄇ: "츏",
    츄ᄅᄉ: "츐",
    츄ᄅᄐ: "츑",
    츄ᄅᄑ: "츒",
    츄ᄅᄒ: "츓",
    츄ᄆ: "츔",
    츄ᄇ: "츕",
    츄ᄇᄉ: "츖",
    츄ᄉ: "츗",
    츄ᄊ: "츘",
    츄ᄋ: "츙",
    츄ᄌ: "츚",
    츄ᄎ: "츛",
    츄ᄏ: "츜",
    츄ᄐ: "츝",
    츄ᄑ: "츞",
    츄ᄒ: "츟",
    츠: "츠",
    츠ᄀ: "측",
    츠ᄁ: "츢",
    츠ᄀᄉ: "츣",
    츠ᄂ: "츤",
    츠ᄂᄌ: "츥",
    츠ᄂᄒ: "츦",
    츠ᄃ: "츧",
    츠ᄅ: "츨",
    츠ᄅᄀ: "츩",
    츠ᄅᄆ: "츪",
    츠ᄅᄇ: "츫",
    츠ᄅᄉ: "츬",
    츠ᄅᄐ: "츭",
    츠ᄅᄑ: "츮",
    츠ᄅᄒ: "츯",
    츠ᄆ: "츰",
    츠ᄇ: "츱",
    츠ᄇᄉ: "츲",
    츠ᄉ: "츳",
    츠ᄊ: "츴",
    츠ᄋ: "층",
    츠ᄌ: "츶",
    츠ᄎ: "츷",
    츠ᄏ: "츸",
    츠ᄐ: "츹",
    츠ᄑ: "츺",
    츠ᄒ: "츻",
    츠ᅵ: "츼",
    츠ᅵᄀ: "츽",
    츠ᅵᄁ: "츾",
    츠ᅵᄀᄉ: "츿",
    츠ᅵᄂ: "칀",
    츠ᅵᄂᄌ: "칁",
    츠ᅵᄂᄒ: "칂",
    츠ᅵᄃ: "칃",
    츠ᅵᄅ: "칄",
    츠ᅵᄅᄀ: "칅",
    츠ᅵᄅᄆ: "칆",
    츠ᅵᄅᄇ: "칇",
    츠ᅵᄅᄉ: "칈",
    츠ᅵᄅᄐ: "칉",
    츠ᅵᄅᄑ: "칊",
    츠ᅵᄅᄒ: "칋",
    츠ᅵᄆ: "칌",
    츠ᅵᄇ: "칍",
    츠ᅵᄇᄉ: "칎",
    츠ᅵᄉ: "칏",
    츠ᅵᄊ: "칐",
    츠ᅵᄋ: "칑",
    츠ᅵᄌ: "칒",
    츠ᅵᄎ: "칓",
    츠ᅵᄏ: "칔",
    츠ᅵᄐ: "칕",
    츠ᅵᄑ: "칖",
    츠ᅵᄒ: "칗",
    치: "치",
    치ᄀ: "칙",
    치ᄁ: "칚",
    치ᄀᄉ: "칛",
    치ᄂ: "친",
    치ᄂᄌ: "칝",
    치ᄂᄒ: "칞",
    치ᄃ: "칟",
    치ᄅ: "칠",
    치ᄅᄀ: "칡",
    치ᄅᄆ: "칢",
    치ᄅᄇ: "칣",
    치ᄅᄉ: "칤",
    치ᄅᄐ: "칥",
    치ᄅᄑ: "칦",
    치ᄅᄒ: "칧",
    치ᄆ: "침",
    치ᄇ: "칩",
    치ᄇᄉ: "칪",
    치ᄉ: "칫",
    치ᄊ: "칬",
    치ᄋ: "칭",
    치ᄌ: "칮",
    치ᄎ: "칯",
    치ᄏ: "칰",
    치ᄐ: "칱",
    치ᄑ: "칲",
    치ᄒ: "칳",
    카: "카",
    카ᄀ: "칵",
    카ᄁ: "칶",
    카ᄀᄉ: "칷",
    카ᄂ: "칸",
    카ᄂᄌ: "칹",
    카ᄂᄒ: "칺",
    카ᄃ: "칻",
    카ᄅ: "칼",
    카ᄅᄀ: "칽",
    카ᄅᄆ: "칾",
    카ᄅᄇ: "칿",
    카ᄅᄉ: "캀",
    카ᄅᄐ: "캁",
    카ᄅᄑ: "캂",
    카ᄅᄒ: "캃",
    카ᄆ: "캄",
    카ᄇ: "캅",
    카ᄇᄉ: "캆",
    카ᄉ: "캇",
    카ᄊ: "캈",
    카ᄋ: "캉",
    카ᄌ: "캊",
    카ᄎ: "캋",
    카ᄏ: "캌",
    카ᄐ: "캍",
    카ᄑ: "캎",
    카ᄒ: "캏",
    캐: "캐",
    캐ᄀ: "캑",
    캐ᄁ: "캒",
    캐ᄀᄉ: "캓",
    캐ᄂ: "캔",
    캐ᄂᄌ: "캕",
    캐ᄂᄒ: "캖",
    캐ᄃ: "캗",
    캐ᄅ: "캘",
    캐ᄅᄀ: "캙",
    캐ᄅᄆ: "캚",
    캐ᄅᄇ: "캛",
    캐ᄅᄉ: "캜",
    캐ᄅᄐ: "캝",
    캐ᄅᄑ: "캞",
    캐ᄅᄒ: "캟",
    캐ᄆ: "캠",
    캐ᄇ: "캡",
    캐ᄇᄉ: "캢",
    캐ᄉ: "캣",
    캐ᄊ: "캤",
    캐ᄋ: "캥",
    캐ᄌ: "캦",
    캐ᄎ: "캧",
    캐ᄏ: "캨",
    캐ᄐ: "캩",
    캐ᄑ: "캪",
    캐ᄒ: "캫",
    캬: "캬",
    캬ᄀ: "캭",
    캬ᄁ: "캮",
    캬ᄀᄉ: "캯",
    캬ᄂ: "캰",
    캬ᄂᄌ: "캱",
    캬ᄂᄒ: "캲",
    캬ᄃ: "캳",
    캬ᄅ: "캴",
    캬ᄅᄀ: "캵",
    캬ᄅᄆ: "캶",
    캬ᄅᄇ: "캷",
    캬ᄅᄉ: "캸",
    캬ᄅᄐ: "캹",
    캬ᄅᄑ: "캺",
    캬ᄅᄒ: "캻",
    캬ᄆ: "캼",
    캬ᄇ: "캽",
    캬ᄇᄉ: "캾",
    캬ᄉ: "캿",
    캬ᄊ: "컀",
    캬ᄋ: "컁",
    캬ᄌ: "컂",
    캬ᄎ: "컃",
    캬ᄏ: "컄",
    캬ᄐ: "컅",
    캬ᄑ: "컆",
    캬ᄒ: "컇",
    컈: "컈",
    컈ᄀ: "컉",
    컈ᄁ: "컊",
    컈ᄀᄉ: "컋",
    컈ᄂ: "컌",
    컈ᄂᄌ: "컍",
    컈ᄂᄒ: "컎",
    컈ᄃ: "컏",
    컈ᄅ: "컐",
    컈ᄅᄀ: "컑",
    컈ᄅᄆ: "컒",
    컈ᄅᄇ: "컓",
    컈ᄅᄉ: "컔",
    컈ᄅᄐ: "컕",
    컈ᄅᄑ: "컖",
    컈ᄅᄒ: "컗",
    컈ᄆ: "컘",
    컈ᄇ: "컙",
    컈ᄇᄉ: "컚",
    컈ᄉ: "컛",
    컈ᄊ: "컜",
    컈ᄋ: "컝",
    컈ᄌ: "컞",
    컈ᄎ: "컟",
    컈ᄏ: "컠",
    컈ᄐ: "컡",
    컈ᄑ: "컢",
    컈ᄒ: "컣",
    커: "커",
    커ᄀ: "컥",
    커ᄁ: "컦",
    커ᄀᄉ: "컧",
    커ᄂ: "컨",
    커ᄂᄌ: "컩",
    커ᄂᄒ: "컪",
    커ᄃ: "컫",
    커ᄅ: "컬",
    커ᄅᄀ: "컭",
    커ᄅᄆ: "컮",
    커ᄅᄇ: "컯",
    커ᄅᄉ: "컰",
    커ᄅᄐ: "컱",
    커ᄅᄑ: "컲",
    커ᄅᄒ: "컳",
    커ᄆ: "컴",
    커ᄇ: "컵",
    커ᄇᄉ: "컶",
    커ᄉ: "컷",
    커ᄊ: "컸",
    커ᄋ: "컹",
    커ᄌ: "컺",
    커ᄎ: "컻",
    커ᄏ: "컼",
    커ᄐ: "컽",
    커ᄑ: "컾",
    커ᄒ: "컿",
    케: "케",
    케ᄀ: "켁",
    케ᄁ: "켂",
    케ᄀᄉ: "켃",
    케ᄂ: "켄",
    케ᄂᄌ: "켅",
    케ᄂᄒ: "켆",
    케ᄃ: "켇",
    케ᄅ: "켈",
    케ᄅᄀ: "켉",
    케ᄅᄆ: "켊",
    케ᄅᄇ: "켋",
    케ᄅᄉ: "켌",
    케ᄅᄐ: "켍",
    케ᄅᄑ: "켎",
    케ᄅᄒ: "켏",
    케ᄆ: "켐",
    케ᄇ: "켑",
    케ᄇᄉ: "켒",
    케ᄉ: "켓",
    케ᄊ: "켔",
    케ᄋ: "켕",
    케ᄌ: "켖",
    케ᄎ: "켗",
    케ᄏ: "켘",
    케ᄐ: "켙",
    케ᄑ: "켚",
    케ᄒ: "켛",
    켜: "켜",
    켜ᄀ: "켝",
    켜ᄁ: "켞",
    켜ᄀᄉ: "켟",
    켜ᄂ: "켠",
    켜ᄂᄌ: "켡",
    켜ᄂᄒ: "켢",
    켜ᄃ: "켣",
    켜ᄅ: "켤",
    켜ᄅᄀ: "켥",
    켜ᄅᄆ: "켦",
    켜ᄅᄇ: "켧",
    켜ᄅᄉ: "켨",
    켜ᄅᄐ: "켩",
    켜ᄅᄑ: "켪",
    켜ᄅᄒ: "켫",
    켜ᄆ: "켬",
    켜ᄇ: "켭",
    켜ᄇᄉ: "켮",
    켜ᄉ: "켯",
    켜ᄊ: "켰",
    켜ᄋ: "켱",
    켜ᄌ: "켲",
    켜ᄎ: "켳",
    켜ᄏ: "켴",
    켜ᄐ: "켵",
    켜ᄑ: "켶",
    켜ᄒ: "켷",
    켸: "켸",
    켸ᄀ: "켹",
    켸ᄁ: "켺",
    켸ᄀᄉ: "켻",
    켸ᄂ: "켼",
    켸ᄂᄌ: "켽",
    켸ᄂᄒ: "켾",
    켸ᄃ: "켿",
    켸ᄅ: "콀",
    켸ᄅᄀ: "콁",
    켸ᄅᄆ: "콂",
    켸ᄅᄇ: "콃",
    켸ᄅᄉ: "콄",
    켸ᄅᄐ: "콅",
    켸ᄅᄑ: "콆",
    켸ᄅᄒ: "콇",
    켸ᄆ: "콈",
    켸ᄇ: "콉",
    켸ᄇᄉ: "콊",
    켸ᄉ: "콋",
    켸ᄊ: "콌",
    켸ᄋ: "콍",
    켸ᄌ: "콎",
    켸ᄎ: "콏",
    켸ᄏ: "콐",
    켸ᄐ: "콑",
    켸ᄑ: "콒",
    켸ᄒ: "콓",
    코: "코",
    코ᄀ: "콕",
    코ᄁ: "콖",
    코ᄀᄉ: "콗",
    코ᄂ: "콘",
    코ᄂᄌ: "콙",
    코ᄂᄒ: "콚",
    코ᄃ: "콛",
    코ᄅ: "콜",
    코ᄅᄀ: "콝",
    코ᄅᄆ: "콞",
    코ᄅᄇ: "콟",
    코ᄅᄉ: "콠",
    코ᄅᄐ: "콡",
    코ᄅᄑ: "콢",
    코ᄅᄒ: "콣",
    코ᄆ: "콤",
    코ᄇ: "콥",
    코ᄇᄉ: "콦",
    코ᄉ: "콧",
    코ᄊ: "콨",
    코ᄋ: "콩",
    코ᄌ: "콪",
    코ᄎ: "콫",
    코ᄏ: "콬",
    코ᄐ: "콭",
    코ᄑ: "콮",
    코ᄒ: "콯",
    코ᅡ: "콰",
    코ᅡᄀ: "콱",
    코ᅡᄁ: "콲",
    코ᅡᄀᄉ: "콳",
    코ᅡᄂ: "콴",
    코ᅡᄂᄌ: "콵",
    코ᅡᄂᄒ: "콶",
    코ᅡᄃ: "콷",
    코ᅡᄅ: "콸",
    코ᅡᄅᄀ: "콹",
    코ᅡᄅᄆ: "콺",
    코ᅡᄅᄇ: "콻",
    코ᅡᄅᄉ: "콼",
    코ᅡᄅᄐ: "콽",
    코ᅡᄅᄑ: "콾",
    코ᅡᄅᄒ: "콿",
    코ᅡᄆ: "쾀",
    코ᅡᄇ: "쾁",
    코ᅡᄇᄉ: "쾂",
    코ᅡᄉ: "쾃",
    코ᅡᄊ: "쾄",
    코ᅡᄋ: "쾅",
    코ᅡᄌ: "쾆",
    코ᅡᄎ: "쾇",
    코ᅡᄏ: "쾈",
    코ᅡᄐ: "쾉",
    코ᅡᄑ: "쾊",
    코ᅡᄒ: "쾋",
    코ᅢ: "쾌",
    코ᅢᄀ: "쾍",
    코ᅢᄁ: "쾎",
    코ᅢᄀᄉ: "쾏",
    코ᅢᄂ: "쾐",
    코ᅢᄂᄌ: "쾑",
    코ᅢᄂᄒ: "쾒",
    코ᅢᄃ: "쾓",
    코ᅢᄅ: "쾔",
    코ᅢᄅᄀ: "쾕",
    코ᅢᄅᄆ: "쾖",
    코ᅢᄅᄇ: "쾗",
    코ᅢᄅᄉ: "쾘",
    코ᅢᄅᄐ: "쾙",
    코ᅢᄅᄑ: "쾚",
    코ᅢᄅᄒ: "쾛",
    코ᅢᄆ: "쾜",
    코ᅢᄇ: "쾝",
    코ᅢᄇᄉ: "쾞",
    코ᅢᄉ: "쾟",
    코ᅢᄊ: "쾠",
    코ᅢᄋ: "쾡",
    코ᅢᄌ: "쾢",
    코ᅢᄎ: "쾣",
    코ᅢᄏ: "쾤",
    코ᅢᄐ: "쾥",
    코ᅢᄑ: "쾦",
    코ᅢᄒ: "쾧",
    코ᅵ: "쾨",
    코ᅵᄀ: "쾩",
    코ᅵᄁ: "쾪",
    코ᅵᄀᄉ: "쾫",
    코ᅵᄂ: "쾬",
    코ᅵᄂᄌ: "쾭",
    코ᅵᄂᄒ: "쾮",
    코ᅵᄃ: "쾯",
    코ᅵᄅ: "쾰",
    코ᅵᄅᄀ: "쾱",
    코ᅵᄅᄆ: "쾲",
    코ᅵᄅᄇ: "쾳",
    코ᅵᄅᄉ: "쾴",
    코ᅵᄅᄐ: "쾵",
    코ᅵᄅᄑ: "쾶",
    코ᅵᄅᄒ: "쾷",
    코ᅵᄆ: "쾸",
    코ᅵᄇ: "쾹",
    코ᅵᄇᄉ: "쾺",
    코ᅵᄉ: "쾻",
    코ᅵᄊ: "쾼",
    코ᅵᄋ: "쾽",
    코ᅵᄌ: "쾾",
    코ᅵᄎ: "쾿",
    코ᅵᄏ: "쿀",
    코ᅵᄐ: "쿁",
    코ᅵᄑ: "쿂",
    코ᅵᄒ: "쿃",
    쿄: "쿄",
    쿄ᄀ: "쿅",
    쿄ᄁ: "쿆",
    쿄ᄀᄉ: "쿇",
    쿄ᄂ: "쿈",
    쿄ᄂᄌ: "쿉",
    쿄ᄂᄒ: "쿊",
    쿄ᄃ: "쿋",
    쿄ᄅ: "쿌",
    쿄ᄅᄀ: "쿍",
    쿄ᄅᄆ: "쿎",
    쿄ᄅᄇ: "쿏",
    쿄ᄅᄉ: "쿐",
    쿄ᄅᄐ: "쿑",
    쿄ᄅᄑ: "쿒",
    쿄ᄅᄒ: "쿓",
    쿄ᄆ: "쿔",
    쿄ᄇ: "쿕",
    쿄ᄇᄉ: "쿖",
    쿄ᄉ: "쿗",
    쿄ᄊ: "쿘",
    쿄ᄋ: "쿙",
    쿄ᄌ: "쿚",
    쿄ᄎ: "쿛",
    쿄ᄏ: "쿜",
    쿄ᄐ: "쿝",
    쿄ᄑ: "쿞",
    쿄ᄒ: "쿟",
    쿠: "쿠",
    쿠ᄀ: "쿡",
    쿠ᄁ: "쿢",
    쿠ᄀᄉ: "쿣",
    쿠ᄂ: "쿤",
    쿠ᄂᄌ: "쿥",
    쿠ᄂᄒ: "쿦",
    쿠ᄃ: "쿧",
    쿠ᄅ: "쿨",
    쿠ᄅᄀ: "쿩",
    쿠ᄅᄆ: "쿪",
    쿠ᄅᄇ: "쿫",
    쿠ᄅᄉ: "쿬",
    쿠ᄅᄐ: "쿭",
    쿠ᄅᄑ: "쿮",
    쿠ᄅᄒ: "쿯",
    쿠ᄆ: "쿰",
    쿠ᄇ: "쿱",
    쿠ᄇᄉ: "쿲",
    쿠ᄉ: "쿳",
    쿠ᄊ: "쿴",
    쿠ᄋ: "쿵",
    쿠ᄌ: "쿶",
    쿠ᄎ: "쿷",
    쿠ᄏ: "쿸",
    쿠ᄐ: "쿹",
    쿠ᄑ: "쿺",
    쿠ᄒ: "쿻",
    쿠ᅥ: "쿼",
    쿠ᅥᄀ: "쿽",
    쿠ᅥᄁ: "쿾",
    쿠ᅥᄀᄉ: "쿿",
    쿠ᅥᄂ: "퀀",
    쿠ᅥᄂᄌ: "퀁",
    쿠ᅥᄂᄒ: "퀂",
    쿠ᅥᄃ: "퀃",
    쿠ᅥᄅ: "퀄",
    쿠ᅥᄅᄀ: "퀅",
    쿠ᅥᄅᄆ: "퀆",
    쿠ᅥᄅᄇ: "퀇",
    쿠ᅥᄅᄉ: "퀈",
    쿠ᅥᄅᄐ: "퀉",
    쿠ᅥᄅᄑ: "퀊",
    쿠ᅥᄅᄒ: "퀋",
    쿠ᅥᄆ: "퀌",
    쿠ᅥᄇ: "퀍",
    쿠ᅥᄇᄉ: "퀎",
    쿠ᅥᄉ: "퀏",
    쿠ᅥᄊ: "퀐",
    쿠ᅥᄋ: "퀑",
    쿠ᅥᄌ: "퀒",
    쿠ᅥᄎ: "퀓",
    쿠ᅥᄏ: "퀔",
    쿠ᅥᄐ: "퀕",
    쿠ᅥᄑ: "퀖",
    쿠ᅥᄒ: "퀗",
    쿠ᅦ: "퀘",
    쿠ᅦᄀ: "퀙",
    쿠ᅦᄁ: "퀚",
    쿠ᅦᄀᄉ: "퀛",
    쿠ᅦᄂ: "퀜",
    쿠ᅦᄂᄌ: "퀝",
    쿠ᅦᄂᄒ: "퀞",
    쿠ᅦᄃ: "퀟",
    쿠ᅦᄅ: "퀠",
    쿠ᅦᄅᄀ: "퀡",
    쿠ᅦᄅᄆ: "퀢",
    쿠ᅦᄅᄇ: "퀣",
    쿠ᅦᄅᄉ: "퀤",
    쿠ᅦᄅᄐ: "퀥",
    쿠ᅦᄅᄑ: "퀦",
    쿠ᅦᄅᄒ: "퀧",
    쿠ᅦᄆ: "퀨",
    쿠ᅦᄇ: "퀩",
    쿠ᅦᄇᄉ: "퀪",
    쿠ᅦᄉ: "퀫",
    쿠ᅦᄊ: "퀬",
    쿠ᅦᄋ: "퀭",
    쿠ᅦᄌ: "퀮",
    쿠ᅦᄎ: "퀯",
    쿠ᅦᄏ: "퀰",
    쿠ᅦᄐ: "퀱",
    쿠ᅦᄑ: "퀲",
    쿠ᅦᄒ: "퀳",
    쿠ᅵ: "퀴",
    쿠ᅵᄀ: "퀵",
    쿠ᅵᄁ: "퀶",
    쿠ᅵᄀᄉ: "퀷",
    쿠ᅵᄂ: "퀸",
    쿠ᅵᄂᄌ: "퀹",
    쿠ᅵᄂᄒ: "퀺",
    쿠ᅵᄃ: "퀻",
    쿠ᅵᄅ: "퀼",
    쿠ᅵᄅᄀ: "퀽",
    쿠ᅵᄅᄆ: "퀾",
    쿠ᅵᄅᄇ: "퀿",
    쿠ᅵᄅᄉ: "큀",
    쿠ᅵᄅᄐ: "큁",
    쿠ᅵᄅᄑ: "큂",
    쿠ᅵᄅᄒ: "큃",
    쿠ᅵᄆ: "큄",
    쿠ᅵᄇ: "큅",
    쿠ᅵᄇᄉ: "큆",
    쿠ᅵᄉ: "큇",
    쿠ᅵᄊ: "큈",
    쿠ᅵᄋ: "큉",
    쿠ᅵᄌ: "큊",
    쿠ᅵᄎ: "큋",
    쿠ᅵᄏ: "큌",
    쿠ᅵᄐ: "큍",
    쿠ᅵᄑ: "큎",
    쿠ᅵᄒ: "큏",
    큐: "큐",
    큐ᄀ: "큑",
    큐ᄁ: "큒",
    큐ᄀᄉ: "큓",
    큐ᄂ: "큔",
    큐ᄂᄌ: "큕",
    큐ᄂᄒ: "큖",
    큐ᄃ: "큗",
    큐ᄅ: "큘",
    큐ᄅᄀ: "큙",
    큐ᄅᄆ: "큚",
    큐ᄅᄇ: "큛",
    큐ᄅᄉ: "큜",
    큐ᄅᄐ: "큝",
    큐ᄅᄑ: "큞",
    큐ᄅᄒ: "큟",
    큐ᄆ: "큠",
    큐ᄇ: "큡",
    큐ᄇᄉ: "큢",
    큐ᄉ: "큣",
    큐ᄊ: "큤",
    큐ᄋ: "큥",
    큐ᄌ: "큦",
    큐ᄎ: "큧",
    큐ᄏ: "큨",
    큐ᄐ: "큩",
    큐ᄑ: "큪",
    큐ᄒ: "큫",
    크: "크",
    크ᄀ: "큭",
    크ᄁ: "큮",
    크ᄀᄉ: "큯",
    크ᄂ: "큰",
    크ᄂᄌ: "큱",
    크ᄂᄒ: "큲",
    크ᄃ: "큳",
    크ᄅ: "클",
    크ᄅᄀ: "큵",
    크ᄅᄆ: "큶",
    크ᄅᄇ: "큷",
    크ᄅᄉ: "큸",
    크ᄅᄐ: "큹",
    크ᄅᄑ: "큺",
    크ᄅᄒ: "큻",
    크ᄆ: "큼",
    크ᄇ: "큽",
    크ᄇᄉ: "큾",
    크ᄉ: "큿",
    크ᄊ: "킀",
    크ᄋ: "킁",
    크ᄌ: "킂",
    크ᄎ: "킃",
    크ᄏ: "킄",
    크ᄐ: "킅",
    크ᄑ: "킆",
    크ᄒ: "킇",
    크ᅵ: "킈",
    크ᅵᄀ: "킉",
    크ᅵᄁ: "킊",
    크ᅵᄀᄉ: "킋",
    크ᅵᄂ: "킌",
    크ᅵᄂᄌ: "킍",
    크ᅵᄂᄒ: "킎",
    크ᅵᄃ: "킏",
    크ᅵᄅ: "킐",
    크ᅵᄅᄀ: "킑",
    크ᅵᄅᄆ: "킒",
    크ᅵᄅᄇ: "킓",
    크ᅵᄅᄉ: "킔",
    크ᅵᄅᄐ: "킕",
    크ᅵᄅᄑ: "킖",
    크ᅵᄅᄒ: "킗",
    크ᅵᄆ: "킘",
    크ᅵᄇ: "킙",
    크ᅵᄇᄉ: "킚",
    크ᅵᄉ: "킛",
    크ᅵᄊ: "킜",
    크ᅵᄋ: "킝",
    크ᅵᄌ: "킞",
    크ᅵᄎ: "킟",
    크ᅵᄏ: "킠",
    크ᅵᄐ: "킡",
    크ᅵᄑ: "킢",
    크ᅵᄒ: "킣",
    키: "키",
    키ᄀ: "킥",
    키ᄁ: "킦",
    키ᄀᄉ: "킧",
    키ᄂ: "킨",
    키ᄂᄌ: "킩",
    키ᄂᄒ: "킪",
    키ᄃ: "킫",
    키ᄅ: "킬",
    키ᄅᄀ: "킭",
    키ᄅᄆ: "킮",
    키ᄅᄇ: "킯",
    키ᄅᄉ: "킰",
    키ᄅᄐ: "킱",
    키ᄅᄑ: "킲",
    키ᄅᄒ: "킳",
    키ᄆ: "킴",
    키ᄇ: "킵",
    키ᄇᄉ: "킶",
    키ᄉ: "킷",
    키ᄊ: "킸",
    키ᄋ: "킹",
    키ᄌ: "킺",
    키ᄎ: "킻",
    키ᄏ: "킼",
    키ᄐ: "킽",
    키ᄑ: "킾",
    키ᄒ: "킿",
    타: "타",
    타ᄀ: "탁",
    타ᄁ: "탂",
    타ᄀᄉ: "탃",
    타ᄂ: "탄",
    타ᄂᄌ: "탅",
    타ᄂᄒ: "탆",
    타ᄃ: "탇",
    타ᄅ: "탈",
    타ᄅᄀ: "탉",
    타ᄅᄆ: "탊",
    타ᄅᄇ: "탋",
    타ᄅᄉ: "탌",
    타ᄅᄐ: "탍",
    타ᄅᄑ: "탎",
    타ᄅᄒ: "탏",
    타ᄆ: "탐",
    타ᄇ: "탑",
    타ᄇᄉ: "탒",
    타ᄉ: "탓",
    타ᄊ: "탔",
    타ᄋ: "탕",
    타ᄌ: "탖",
    타ᄎ: "탗",
    타ᄏ: "탘",
    타ᄐ: "탙",
    타ᄑ: "탚",
    타ᄒ: "탛",
    태: "태",
    태ᄀ: "택",
    태ᄁ: "탞",
    태ᄀᄉ: "탟",
    태ᄂ: "탠",
    태ᄂᄌ: "탡",
    태ᄂᄒ: "탢",
    태ᄃ: "탣",
    태ᄅ: "탤",
    태ᄅᄀ: "탥",
    태ᄅᄆ: "탦",
    태ᄅᄇ: "탧",
    태ᄅᄉ: "탨",
    태ᄅᄐ: "탩",
    태ᄅᄑ: "탪",
    태ᄅᄒ: "탫",
    태ᄆ: "탬",
    태ᄇ: "탭",
    태ᄇᄉ: "탮",
    태ᄉ: "탯",
    태ᄊ: "탰",
    태ᄋ: "탱",
    태ᄌ: "탲",
    태ᄎ: "탳",
    태ᄏ: "탴",
    태ᄐ: "탵",
    태ᄑ: "탶",
    태ᄒ: "탷",
    탸: "탸",
    탸ᄀ: "탹",
    탸ᄁ: "탺",
    탸ᄀᄉ: "탻",
    탸ᄂ: "탼",
    탸ᄂᄌ: "탽",
    탸ᄂᄒ: "탾",
    탸ᄃ: "탿",
    탸ᄅ: "턀",
    탸ᄅᄀ: "턁",
    탸ᄅᄆ: "턂",
    탸ᄅᄇ: "턃",
    탸ᄅᄉ: "턄",
    탸ᄅᄐ: "턅",
    탸ᄅᄑ: "턆",
    탸ᄅᄒ: "턇",
    탸ᄆ: "턈",
    탸ᄇ: "턉",
    탸ᄇᄉ: "턊",
    탸ᄉ: "턋",
    탸ᄊ: "턌",
    탸ᄋ: "턍",
    탸ᄌ: "턎",
    탸ᄎ: "턏",
    탸ᄏ: "턐",
    탸ᄐ: "턑",
    탸ᄑ: "턒",
    탸ᄒ: "턓",
    턔: "턔",
    턔ᄀ: "턕",
    턔ᄁ: "턖",
    턔ᄀᄉ: "턗",
    턔ᄂ: "턘",
    턔ᄂᄌ: "턙",
    턔ᄂᄒ: "턚",
    턔ᄃ: "턛",
    턔ᄅ: "턜",
    턔ᄅᄀ: "턝",
    턔ᄅᄆ: "턞",
    턔ᄅᄇ: "턟",
    턔ᄅᄉ: "턠",
    턔ᄅᄐ: "턡",
    턔ᄅᄑ: "턢",
    턔ᄅᄒ: "턣",
    턔ᄆ: "턤",
    턔ᄇ: "턥",
    턔ᄇᄉ: "턦",
    턔ᄉ: "턧",
    턔ᄊ: "턨",
    턔ᄋ: "턩",
    턔ᄌ: "턪",
    턔ᄎ: "턫",
    턔ᄏ: "턬",
    턔ᄐ: "턭",
    턔ᄑ: "턮",
    턔ᄒ: "턯",
    터: "터",
    터ᄀ: "턱",
    터ᄁ: "턲",
    터ᄀᄉ: "턳",
    터ᄂ: "턴",
    터ᄂᄌ: "턵",
    터ᄂᄒ: "턶",
    터ᄃ: "턷",
    터ᄅ: "털",
    터ᄅᄀ: "턹",
    터ᄅᄆ: "턺",
    터ᄅᄇ: "턻",
    터ᄅᄉ: "턼",
    터ᄅᄐ: "턽",
    터ᄅᄑ: "턾",
    터ᄅᄒ: "턿",
    터ᄆ: "텀",
    터ᄇ: "텁",
    터ᄇᄉ: "텂",
    터ᄉ: "텃",
    터ᄊ: "텄",
    터ᄋ: "텅",
    터ᄌ: "텆",
    터ᄎ: "텇",
    터ᄏ: "텈",
    터ᄐ: "텉",
    터ᄑ: "텊",
    터ᄒ: "텋",
    테: "테",
    테ᄀ: "텍",
    테ᄁ: "텎",
    테ᄀᄉ: "텏",
    테ᄂ: "텐",
    테ᄂᄌ: "텑",
    테ᄂᄒ: "텒",
    테ᄃ: "텓",
    테ᄅ: "텔",
    테ᄅᄀ: "텕",
    테ᄅᄆ: "텖",
    테ᄅᄇ: "텗",
    테ᄅᄉ: "텘",
    테ᄅᄐ: "텙",
    테ᄅᄑ: "텚",
    테ᄅᄒ: "텛",
    테ᄆ: "템",
    테ᄇ: "텝",
    테ᄇᄉ: "텞",
    테ᄉ: "텟",
    테ᄊ: "텠",
    테ᄋ: "텡",
    테ᄌ: "텢",
    테ᄎ: "텣",
    테ᄏ: "텤",
    테ᄐ: "텥",
    테ᄑ: "텦",
    테ᄒ: "텧",
    텨: "텨",
    텨ᄀ: "텩",
    텨ᄁ: "텪",
    텨ᄀᄉ: "텫",
    텨ᄂ: "텬",
    텨ᄂᄌ: "텭",
    텨ᄂᄒ: "텮",
    텨ᄃ: "텯",
    텨ᄅ: "텰",
    텨ᄅᄀ: "텱",
    텨ᄅᄆ: "텲",
    텨ᄅᄇ: "텳",
    텨ᄅᄉ: "텴",
    텨ᄅᄐ: "텵",
    텨ᄅᄑ: "텶",
    텨ᄅᄒ: "텷",
    텨ᄆ: "텸",
    텨ᄇ: "텹",
    텨ᄇᄉ: "텺",
    텨ᄉ: "텻",
    텨ᄊ: "텼",
    텨ᄋ: "텽",
    텨ᄌ: "텾",
    텨ᄎ: "텿",
    텨ᄏ: "톀",
    텨ᄐ: "톁",
    텨ᄑ: "톂",
    텨ᄒ: "톃",
    톄: "톄",
    톄ᄀ: "톅",
    톄ᄁ: "톆",
    톄ᄀᄉ: "톇",
    톄ᄂ: "톈",
    톄ᄂᄌ: "톉",
    톄ᄂᄒ: "톊",
    톄ᄃ: "톋",
    톄ᄅ: "톌",
    톄ᄅᄀ: "톍",
    톄ᄅᄆ: "톎",
    톄ᄅᄇ: "톏",
    톄ᄅᄉ: "톐",
    톄ᄅᄐ: "톑",
    톄ᄅᄑ: "톒",
    톄ᄅᄒ: "톓",
    톄ᄆ: "톔",
    톄ᄇ: "톕",
    톄ᄇᄉ: "톖",
    톄ᄉ: "톗",
    톄ᄊ: "톘",
    톄ᄋ: "톙",
    톄ᄌ: "톚",
    톄ᄎ: "톛",
    톄ᄏ: "톜",
    톄ᄐ: "톝",
    톄ᄑ: "톞",
    톄ᄒ: "톟",
    토: "토",
    토ᄀ: "톡",
    토ᄁ: "톢",
    토ᄀᄉ: "톣",
    토ᄂ: "톤",
    토ᄂᄌ: "톥",
    토ᄂᄒ: "톦",
    토ᄃ: "톧",
    토ᄅ: "톨",
    토ᄅᄀ: "톩",
    토ᄅᄆ: "톪",
    토ᄅᄇ: "톫",
    토ᄅᄉ: "톬",
    토ᄅᄐ: "톭",
    토ᄅᄑ: "톮",
    토ᄅᄒ: "톯",
    토ᄆ: "톰",
    토ᄇ: "톱",
    토ᄇᄉ: "톲",
    토ᄉ: "톳",
    토ᄊ: "톴",
    토ᄋ: "통",
    토ᄌ: "톶",
    토ᄎ: "톷",
    토ᄏ: "톸",
    토ᄐ: "톹",
    토ᄑ: "톺",
    토ᄒ: "톻",
    토ᅡ: "톼",
    토ᅡᄀ: "톽",
    토ᅡᄁ: "톾",
    토ᅡᄀᄉ: "톿",
    토ᅡᄂ: "퇀",
    토ᅡᄂᄌ: "퇁",
    토ᅡᄂᄒ: "퇂",
    토ᅡᄃ: "퇃",
    토ᅡᄅ: "퇄",
    토ᅡᄅᄀ: "퇅",
    토ᅡᄅᄆ: "퇆",
    토ᅡᄅᄇ: "퇇",
    토ᅡᄅᄉ: "퇈",
    토ᅡᄅᄐ: "퇉",
    토ᅡᄅᄑ: "퇊",
    토ᅡᄅᄒ: "퇋",
    토ᅡᄆ: "퇌",
    토ᅡᄇ: "퇍",
    토ᅡᄇᄉ: "퇎",
    토ᅡᄉ: "퇏",
    토ᅡᄊ: "퇐",
    토ᅡᄋ: "퇑",
    토ᅡᄌ: "퇒",
    토ᅡᄎ: "퇓",
    토ᅡᄏ: "퇔",
    토ᅡᄐ: "퇕",
    토ᅡᄑ: "퇖",
    토ᅡᄒ: "퇗",
    토ᅢ: "퇘",
    토ᅢᄀ: "퇙",
    토ᅢᄁ: "퇚",
    토ᅢᄀᄉ: "퇛",
    토ᅢᄂ: "퇜",
    토ᅢᄂᄌ: "퇝",
    토ᅢᄂᄒ: "퇞",
    토ᅢᄃ: "퇟",
    토ᅢᄅ: "퇠",
    토ᅢᄅᄀ: "퇡",
    토ᅢᄅᄆ: "퇢",
    토ᅢᄅᄇ: "퇣",
    토ᅢᄅᄉ: "퇤",
    토ᅢᄅᄐ: "퇥",
    토ᅢᄅᄑ: "퇦",
    토ᅢᄅᄒ: "퇧",
    토ᅢᄆ: "퇨",
    토ᅢᄇ: "퇩",
    토ᅢᄇᄉ: "퇪",
    토ᅢᄉ: "퇫",
    토ᅢᄊ: "퇬",
    토ᅢᄋ: "퇭",
    토ᅢᄌ: "퇮",
    토ᅢᄎ: "퇯",
    토ᅢᄏ: "퇰",
    토ᅢᄐ: "퇱",
    토ᅢᄑ: "퇲",
    토ᅢᄒ: "퇳",
    토ᅵ: "퇴",
    토ᅵᄀ: "퇵",
    토ᅵᄁ: "퇶",
    토ᅵᄀᄉ: "퇷",
    토ᅵᄂ: "퇸",
    토ᅵᄂᄌ: "퇹",
    토ᅵᄂᄒ: "퇺",
    토ᅵᄃ: "퇻",
    토ᅵᄅ: "퇼",
    토ᅵᄅᄀ: "퇽",
    토ᅵᄅᄆ: "퇾",
    토ᅵᄅᄇ: "퇿",
    토ᅵᄅᄉ: "툀",
    토ᅵᄅᄐ: "툁",
    토ᅵᄅᄑ: "툂",
    토ᅵᄅᄒ: "툃",
    토ᅵᄆ: "툄",
    토ᅵᄇ: "툅",
    토ᅵᄇᄉ: "툆",
    토ᅵᄉ: "툇",
    토ᅵᄊ: "툈",
    토ᅵᄋ: "툉",
    토ᅵᄌ: "툊",
    토ᅵᄎ: "툋",
    토ᅵᄏ: "툌",
    토ᅵᄐ: "툍",
    토ᅵᄑ: "툎",
    토ᅵᄒ: "툏",
    툐: "툐",
    툐ᄀ: "툑",
    툐ᄁ: "툒",
    툐ᄀᄉ: "툓",
    툐ᄂ: "툔",
    툐ᄂᄌ: "툕",
    툐ᄂᄒ: "툖",
    툐ᄃ: "툗",
    툐ᄅ: "툘",
    툐ᄅᄀ: "툙",
    툐ᄅᄆ: "툚",
    툐ᄅᄇ: "툛",
    툐ᄅᄉ: "툜",
    툐ᄅᄐ: "툝",
    툐ᄅᄑ: "툞",
    툐ᄅᄒ: "툟",
    툐ᄆ: "툠",
    툐ᄇ: "툡",
    툐ᄇᄉ: "툢",
    툐ᄉ: "툣",
    툐ᄊ: "툤",
    툐ᄋ: "툥",
    툐ᄌ: "툦",
    툐ᄎ: "툧",
    툐ᄏ: "툨",
    툐ᄐ: "툩",
    툐ᄑ: "툪",
    툐ᄒ: "툫",
    투: "투",
    투ᄀ: "툭",
    투ᄁ: "툮",
    투ᄀᄉ: "툯",
    투ᄂ: "툰",
    투ᄂᄌ: "툱",
    투ᄂᄒ: "툲",
    투ᄃ: "툳",
    투ᄅ: "툴",
    투ᄅᄀ: "툵",
    투ᄅᄆ: "툶",
    투ᄅᄇ: "툷",
    투ᄅᄉ: "툸",
    투ᄅᄐ: "툹",
    투ᄅᄑ: "툺",
    투ᄅᄒ: "툻",
    투ᄆ: "툼",
    투ᄇ: "툽",
    투ᄇᄉ: "툾",
    투ᄉ: "툿",
    투ᄊ: "퉀",
    투ᄋ: "퉁",
    투ᄌ: "퉂",
    투ᄎ: "퉃",
    투ᄏ: "퉄",
    투ᄐ: "퉅",
    투ᄑ: "퉆",
    투ᄒ: "퉇",
    투ᅥ: "퉈",
    투ᅥᄀ: "퉉",
    투ᅥᄁ: "퉊",
    투ᅥᄀᄉ: "퉋",
    투ᅥᄂ: "퉌",
    투ᅥᄂᄌ: "퉍",
    투ᅥᄂᄒ: "퉎",
    투ᅥᄃ: "퉏",
    투ᅥᄅ: "퉐",
    투ᅥᄅᄀ: "퉑",
    투ᅥᄅᄆ: "퉒",
    투ᅥᄅᄇ: "퉓",
    투ᅥᄅᄉ: "퉔",
    투ᅥᄅᄐ: "퉕",
    투ᅥᄅᄑ: "퉖",
    투ᅥᄅᄒ: "퉗",
    투ᅥᄆ: "퉘",
    투ᅥᄇ: "퉙",
    투ᅥᄇᄉ: "퉚",
    투ᅥᄉ: "퉛",
    투ᅥᄊ: "퉜",
    투ᅥᄋ: "퉝",
    투ᅥᄌ: "퉞",
    투ᅥᄎ: "퉟",
    투ᅥᄏ: "퉠",
    투ᅥᄐ: "퉡",
    투ᅥᄑ: "퉢",
    투ᅥᄒ: "퉣",
    투ᅦ: "퉤",
    투ᅦᄀ: "퉥",
    투ᅦᄁ: "퉦",
    투ᅦᄀᄉ: "퉧",
    투ᅦᄂ: "퉨",
    투ᅦᄂᄌ: "퉩",
    투ᅦᄂᄒ: "퉪",
    투ᅦᄃ: "퉫",
    투ᅦᄅ: "퉬",
    투ᅦᄅᄀ: "퉭",
    투ᅦᄅᄆ: "퉮",
    투ᅦᄅᄇ: "퉯",
    투ᅦᄅᄉ: "퉰",
    투ᅦᄅᄐ: "퉱",
    투ᅦᄅᄑ: "퉲",
    투ᅦᄅᄒ: "퉳",
    투ᅦᄆ: "퉴",
    투ᅦᄇ: "퉵",
    투ᅦᄇᄉ: "퉶",
    투ᅦᄉ: "퉷",
    투ᅦᄊ: "퉸",
    투ᅦᄋ: "퉹",
    투ᅦᄌ: "퉺",
    투ᅦᄎ: "퉻",
    투ᅦᄏ: "퉼",
    투ᅦᄐ: "퉽",
    투ᅦᄑ: "퉾",
    투ᅦᄒ: "퉿",
    투ᅵ: "튀",
    투ᅵᄀ: "튁",
    투ᅵᄁ: "튂",
    투ᅵᄀᄉ: "튃",
    투ᅵᄂ: "튄",
    투ᅵᄂᄌ: "튅",
    투ᅵᄂᄒ: "튆",
    투ᅵᄃ: "튇",
    투ᅵᄅ: "튈",
    투ᅵᄅᄀ: "튉",
    투ᅵᄅᄆ: "튊",
    투ᅵᄅᄇ: "튋",
    투ᅵᄅᄉ: "튌",
    투ᅵᄅᄐ: "튍",
    투ᅵᄅᄑ: "튎",
    투ᅵᄅᄒ: "튏",
    투ᅵᄆ: "튐",
    투ᅵᄇ: "튑",
    투ᅵᄇᄉ: "튒",
    투ᅵᄉ: "튓",
    투ᅵᄊ: "튔",
    투ᅵᄋ: "튕",
    투ᅵᄌ: "튖",
    투ᅵᄎ: "튗",
    투ᅵᄏ: "튘",
    투ᅵᄐ: "튙",
    투ᅵᄑ: "튚",
    투ᅵᄒ: "튛",
    튜: "튜",
    튜ᄀ: "튝",
    튜ᄁ: "튞",
    튜ᄀᄉ: "튟",
    튜ᄂ: "튠",
    튜ᄂᄌ: "튡",
    튜ᄂᄒ: "튢",
    튜ᄃ: "튣",
    튜ᄅ: "튤",
    튜ᄅᄀ: "튥",
    튜ᄅᄆ: "튦",
    튜ᄅᄇ: "튧",
    튜ᄅᄉ: "튨",
    튜ᄅᄐ: "튩",
    튜ᄅᄑ: "튪",
    튜ᄅᄒ: "튫",
    튜ᄆ: "튬",
    튜ᄇ: "튭",
    튜ᄇᄉ: "튮",
    튜ᄉ: "튯",
    튜ᄊ: "튰",
    튜ᄋ: "튱",
    튜ᄌ: "튲",
    튜ᄎ: "튳",
    튜ᄏ: "튴",
    튜ᄐ: "튵",
    튜ᄑ: "튶",
    튜ᄒ: "튷",
    트: "트",
    트ᄀ: "특",
    트ᄁ: "튺",
    트ᄀᄉ: "튻",
    트ᄂ: "튼",
    트ᄂᄌ: "튽",
    트ᄂᄒ: "튾",
    트ᄃ: "튿",
    트ᄅ: "틀",
    트ᄅᄀ: "틁",
    트ᄅᄆ: "틂",
    트ᄅᄇ: "틃",
    트ᄅᄉ: "틄",
    트ᄅᄐ: "틅",
    트ᄅᄑ: "틆",
    트ᄅᄒ: "틇",
    트ᄆ: "틈",
    트ᄇ: "틉",
    트ᄇᄉ: "틊",
    트ᄉ: "틋",
    트ᄊ: "틌",
    트ᄋ: "틍",
    트ᄌ: "틎",
    트ᄎ: "틏",
    트ᄏ: "틐",
    트ᄐ: "틑",
    트ᄑ: "틒",
    트ᄒ: "틓",
    트ᅵ: "틔",
    트ᅵᄀ: "틕",
    트ᅵᄁ: "틖",
    트ᅵᄀᄉ: "틗",
    트ᅵᄂ: "틘",
    트ᅵᄂᄌ: "틙",
    트ᅵᄂᄒ: "틚",
    트ᅵᄃ: "틛",
    트ᅵᄅ: "틜",
    트ᅵᄅᄀ: "틝",
    트ᅵᄅᄆ: "틞",
    트ᅵᄅᄇ: "틟",
    트ᅵᄅᄉ: "틠",
    트ᅵᄅᄐ: "틡",
    트ᅵᄅᄑ: "틢",
    트ᅵᄅᄒ: "틣",
    트ᅵᄆ: "틤",
    트ᅵᄇ: "틥",
    트ᅵᄇᄉ: "틦",
    트ᅵᄉ: "틧",
    트ᅵᄊ: "틨",
    트ᅵᄋ: "틩",
    트ᅵᄌ: "틪",
    트ᅵᄎ: "틫",
    트ᅵᄏ: "틬",
    트ᅵᄐ: "틭",
    트ᅵᄑ: "틮",
    트ᅵᄒ: "틯",
    티: "티",
    티ᄀ: "틱",
    티ᄁ: "틲",
    티ᄀᄉ: "틳",
    티ᄂ: "틴",
    티ᄂᄌ: "틵",
    티ᄂᄒ: "틶",
    티ᄃ: "틷",
    티ᄅ: "틸",
    티ᄅᄀ: "틹",
    티ᄅᄆ: "틺",
    티ᄅᄇ: "틻",
    티ᄅᄉ: "틼",
    티ᄅᄐ: "틽",
    티ᄅᄑ: "틾",
    티ᄅᄒ: "틿",
    티ᄆ: "팀",
    티ᄇ: "팁",
    티ᄇᄉ: "팂",
    티ᄉ: "팃",
    티ᄊ: "팄",
    티ᄋ: "팅",
    티ᄌ: "팆",
    티ᄎ: "팇",
    티ᄏ: "팈",
    티ᄐ: "팉",
    티ᄑ: "팊",
    티ᄒ: "팋",
    파: "파",
    파ᄀ: "팍",
    파ᄁ: "팎",
    파ᄀᄉ: "팏",
    파ᄂ: "판",
    파ᄂᄌ: "팑",
    파ᄂᄒ: "팒",
    파ᄃ: "팓",
    파ᄅ: "팔",
    파ᄅᄀ: "팕",
    파ᄅᄆ: "팖",
    파ᄅᄇ: "팗",
    파ᄅᄉ: "팘",
    파ᄅᄐ: "팙",
    파ᄅᄑ: "팚",
    파ᄅᄒ: "팛",
    파ᄆ: "팜",
    파ᄇ: "팝",
    파ᄇᄉ: "팞",
    파ᄉ: "팟",
    파ᄊ: "팠",
    파ᄋ: "팡",
    파ᄌ: "팢",
    파ᄎ: "팣",
    파ᄏ: "팤",
    파ᄐ: "팥",
    파ᄑ: "팦",
    파ᄒ: "팧",
    패: "패",
    패ᄀ: "팩",
    패ᄁ: "팪",
    패ᄀᄉ: "팫",
    패ᄂ: "팬",
    패ᄂᄌ: "팭",
    패ᄂᄒ: "팮",
    패ᄃ: "팯",
    패ᄅ: "팰",
    패ᄅᄀ: "팱",
    패ᄅᄆ: "팲",
    패ᄅᄇ: "팳",
    패ᄅᄉ: "팴",
    패ᄅᄐ: "팵",
    패ᄅᄑ: "팶",
    패ᄅᄒ: "팷",
    패ᄆ: "팸",
    패ᄇ: "팹",
    패ᄇᄉ: "팺",
    패ᄉ: "팻",
    패ᄊ: "팼",
    패ᄋ: "팽",
    패ᄌ: "팾",
    패ᄎ: "팿",
    패ᄏ: "퍀",
    패ᄐ: "퍁",
    패ᄑ: "퍂",
    패ᄒ: "퍃",
    퍄: "퍄",
    퍄ᄀ: "퍅",
    퍄ᄁ: "퍆",
    퍄ᄀᄉ: "퍇",
    퍄ᄂ: "퍈",
    퍄ᄂᄌ: "퍉",
    퍄ᄂᄒ: "퍊",
    퍄ᄃ: "퍋",
    퍄ᄅ: "퍌",
    퍄ᄅᄀ: "퍍",
    퍄ᄅᄆ: "퍎",
    퍄ᄅᄇ: "퍏",
    퍄ᄅᄉ: "퍐",
    퍄ᄅᄐ: "퍑",
    퍄ᄅᄑ: "퍒",
    퍄ᄅᄒ: "퍓",
    퍄ᄆ: "퍔",
    퍄ᄇ: "퍕",
    퍄ᄇᄉ: "퍖",
    퍄ᄉ: "퍗",
    퍄ᄊ: "퍘",
    퍄ᄋ: "퍙",
    퍄ᄌ: "퍚",
    퍄ᄎ: "퍛",
    퍄ᄏ: "퍜",
    퍄ᄐ: "퍝",
    퍄ᄑ: "퍞",
    퍄ᄒ: "퍟",
    퍠: "퍠",
    퍠ᄀ: "퍡",
    퍠ᄁ: "퍢",
    퍠ᄀᄉ: "퍣",
    퍠ᄂ: "퍤",
    퍠ᄂᄌ: "퍥",
    퍠ᄂᄒ: "퍦",
    퍠ᄃ: "퍧",
    퍠ᄅ: "퍨",
    퍠ᄅᄀ: "퍩",
    퍠ᄅᄆ: "퍪",
    퍠ᄅᄇ: "퍫",
    퍠ᄅᄉ: "퍬",
    퍠ᄅᄐ: "퍭",
    퍠ᄅᄑ: "퍮",
    퍠ᄅᄒ: "퍯",
    퍠ᄆ: "퍰",
    퍠ᄇ: "퍱",
    퍠ᄇᄉ: "퍲",
    퍠ᄉ: "퍳",
    퍠ᄊ: "퍴",
    퍠ᄋ: "퍵",
    퍠ᄌ: "퍶",
    퍠ᄎ: "퍷",
    퍠ᄏ: "퍸",
    퍠ᄐ: "퍹",
    퍠ᄑ: "퍺",
    퍠ᄒ: "퍻",
    퍼: "퍼",
    퍼ᄀ: "퍽",
    퍼ᄁ: "퍾",
    퍼ᄀᄉ: "퍿",
    퍼ᄂ: "펀",
    퍼ᄂᄌ: "펁",
    퍼ᄂᄒ: "펂",
    퍼ᄃ: "펃",
    퍼ᄅ: "펄",
    퍼ᄅᄀ: "펅",
    퍼ᄅᄆ: "펆",
    퍼ᄅᄇ: "펇",
    퍼ᄅᄉ: "펈",
    퍼ᄅᄐ: "펉",
    퍼ᄅᄑ: "펊",
    퍼ᄅᄒ: "펋",
    퍼ᄆ: "펌",
    퍼ᄇ: "펍",
    퍼ᄇᄉ: "펎",
    퍼ᄉ: "펏",
    퍼ᄊ: "펐",
    퍼ᄋ: "펑",
    퍼ᄌ: "펒",
    퍼ᄎ: "펓",
    퍼ᄏ: "펔",
    퍼ᄐ: "펕",
    퍼ᄑ: "펖",
    퍼ᄒ: "펗",
    페: "페",
    페ᄀ: "펙",
    페ᄁ: "펚",
    페ᄀᄉ: "펛",
    페ᄂ: "펜",
    페ᄂᄌ: "펝",
    페ᄂᄒ: "펞",
    페ᄃ: "펟",
    페ᄅ: "펠",
    페ᄅᄀ: "펡",
    페ᄅᄆ: "펢",
    페ᄅᄇ: "펣",
    페ᄅᄉ: "펤",
    페ᄅᄐ: "펥",
    페ᄅᄑ: "펦",
    페ᄅᄒ: "펧",
    페ᄆ: "펨",
    페ᄇ: "펩",
    페ᄇᄉ: "펪",
    페ᄉ: "펫",
    페ᄊ: "펬",
    페ᄋ: "펭",
    페ᄌ: "펮",
    페ᄎ: "펯",
    페ᄏ: "펰",
    페ᄐ: "펱",
    페ᄑ: "펲",
    페ᄒ: "펳",
    펴: "펴",
    펴ᄀ: "펵",
    펴ᄁ: "펶",
    펴ᄀᄉ: "펷",
    펴ᄂ: "편",
    펴ᄂᄌ: "펹",
    펴ᄂᄒ: "펺",
    펴ᄃ: "펻",
    펴ᄅ: "펼",
    펴ᄅᄀ: "펽",
    펴ᄅᄆ: "펾",
    펴ᄅᄇ: "펿",
    펴ᄅᄉ: "폀",
    펴ᄅᄐ: "폁",
    펴ᄅᄑ: "폂",
    펴ᄅᄒ: "폃",
    펴ᄆ: "폄",
    펴ᄇ: "폅",
    펴ᄇᄉ: "폆",
    펴ᄉ: "폇",
    펴ᄊ: "폈",
    펴ᄋ: "평",
    펴ᄌ: "폊",
    펴ᄎ: "폋",
    펴ᄏ: "폌",
    펴ᄐ: "폍",
    펴ᄑ: "폎",
    펴ᄒ: "폏",
    폐: "폐",
    폐ᄀ: "폑",
    폐ᄁ: "폒",
    폐ᄀᄉ: "폓",
    폐ᄂ: "폔",
    폐ᄂᄌ: "폕",
    폐ᄂᄒ: "폖",
    폐ᄃ: "폗",
    폐ᄅ: "폘",
    폐ᄅᄀ: "폙",
    폐ᄅᄆ: "폚",
    폐ᄅᄇ: "폛",
    폐ᄅᄉ: "폜",
    폐ᄅᄐ: "폝",
    폐ᄅᄑ: "폞",
    폐ᄅᄒ: "폟",
    폐ᄆ: "폠",
    폐ᄇ: "폡",
    폐ᄇᄉ: "폢",
    폐ᄉ: "폣",
    폐ᄊ: "폤",
    폐ᄋ: "폥",
    폐ᄌ: "폦",
    폐ᄎ: "폧",
    폐ᄏ: "폨",
    폐ᄐ: "폩",
    폐ᄑ: "폪",
    폐ᄒ: "폫",
    포: "포",
    포ᄀ: "폭",
    포ᄁ: "폮",
    포ᄀᄉ: "폯",
    포ᄂ: "폰",
    포ᄂᄌ: "폱",
    포ᄂᄒ: "폲",
    포ᄃ: "폳",
    포ᄅ: "폴",
    포ᄅᄀ: "폵",
    포ᄅᄆ: "폶",
    포ᄅᄇ: "폷",
    포ᄅᄉ: "폸",
    포ᄅᄐ: "폹",
    포ᄅᄑ: "폺",
    포ᄅᄒ: "폻",
    포ᄆ: "폼",
    포ᄇ: "폽",
    포ᄇᄉ: "폾",
    포ᄉ: "폿",
    포ᄊ: "퐀",
    포ᄋ: "퐁",
    포ᄌ: "퐂",
    포ᄎ: "퐃",
    포ᄏ: "퐄",
    포ᄐ: "퐅",
    포ᄑ: "퐆",
    포ᄒ: "퐇",
    포ᅡ: "퐈",
    포ᅡᄀ: "퐉",
    포ᅡᄁ: "퐊",
    포ᅡᄀᄉ: "퐋",
    포ᅡᄂ: "퐌",
    포ᅡᄂᄌ: "퐍",
    포ᅡᄂᄒ: "퐎",
    포ᅡᄃ: "퐏",
    포ᅡᄅ: "퐐",
    포ᅡᄅᄀ: "퐑",
    포ᅡᄅᄆ: "퐒",
    포ᅡᄅᄇ: "퐓",
    포ᅡᄅᄉ: "퐔",
    포ᅡᄅᄐ: "퐕",
    포ᅡᄅᄑ: "퐖",
    포ᅡᄅᄒ: "퐗",
    포ᅡᄆ: "퐘",
    포ᅡᄇ: "퐙",
    포ᅡᄇᄉ: "퐚",
    포ᅡᄉ: "퐛",
    포ᅡᄊ: "퐜",
    포ᅡᄋ: "퐝",
    포ᅡᄌ: "퐞",
    포ᅡᄎ: "퐟",
    포ᅡᄏ: "퐠",
    포ᅡᄐ: "퐡",
    포ᅡᄑ: "퐢",
    포ᅡᄒ: "퐣",
    포ᅢ: "퐤",
    포ᅢᄀ: "퐥",
    포ᅢᄁ: "퐦",
    포ᅢᄀᄉ: "퐧",
    포ᅢᄂ: "퐨",
    포ᅢᄂᄌ: "퐩",
    포ᅢᄂᄒ: "퐪",
    포ᅢᄃ: "퐫",
    포ᅢᄅ: "퐬",
    포ᅢᄅᄀ: "퐭",
    포ᅢᄅᄆ: "퐮",
    포ᅢᄅᄇ: "퐯",
    포ᅢᄅᄉ: "퐰",
    포ᅢᄅᄐ: "퐱",
    포ᅢᄅᄑ: "퐲",
    포ᅢᄅᄒ: "퐳",
    포ᅢᄆ: "퐴",
    포ᅢᄇ: "퐵",
    포ᅢᄇᄉ: "퐶",
    포ᅢᄉ: "퐷",
    포ᅢᄊ: "퐸",
    포ᅢᄋ: "퐹",
    포ᅢᄌ: "퐺",
    포ᅢᄎ: "퐻",
    포ᅢᄏ: "퐼",
    포ᅢᄐ: "퐽",
    포ᅢᄑ: "퐾",
    포ᅢᄒ: "퐿",
    포ᅵ: "푀",
    포ᅵᄀ: "푁",
    포ᅵᄁ: "푂",
    포ᅵᄀᄉ: "푃",
    포ᅵᄂ: "푄",
    포ᅵᄂᄌ: "푅",
    포ᅵᄂᄒ: "푆",
    포ᅵᄃ: "푇",
    포ᅵᄅ: "푈",
    포ᅵᄅᄀ: "푉",
    포ᅵᄅᄆ: "푊",
    포ᅵᄅᄇ: "푋",
    포ᅵᄅᄉ: "푌",
    포ᅵᄅᄐ: "푍",
    포ᅵᄅᄑ: "푎",
    포ᅵᄅᄒ: "푏",
    포ᅵᄆ: "푐",
    포ᅵᄇ: "푑",
    포ᅵᄇᄉ: "푒",
    포ᅵᄉ: "푓",
    포ᅵᄊ: "푔",
    포ᅵᄋ: "푕",
    포ᅵᄌ: "푖",
    포ᅵᄎ: "푗",
    포ᅵᄏ: "푘",
    포ᅵᄐ: "푙",
    포ᅵᄑ: "푚",
    포ᅵᄒ: "푛",
    표: "표",
    표ᄀ: "푝",
    표ᄁ: "푞",
    표ᄀᄉ: "푟",
    표ᄂ: "푠",
    표ᄂᄌ: "푡",
    표ᄂᄒ: "푢",
    표ᄃ: "푣",
    표ᄅ: "푤",
    표ᄅᄀ: "푥",
    표ᄅᄆ: "푦",
    표ᄅᄇ: "푧",
    표ᄅᄉ: "푨",
    표ᄅᄐ: "푩",
    표ᄅᄑ: "푪",
    표ᄅᄒ: "푫",
    표ᄆ: "푬",
    표ᄇ: "푭",
    표ᄇᄉ: "푮",
    표ᄉ: "푯",
    표ᄊ: "푰",
    표ᄋ: "푱",
    표ᄌ: "푲",
    표ᄎ: "푳",
    표ᄏ: "푴",
    표ᄐ: "푵",
    표ᄑ: "푶",
    표ᄒ: "푷",
    푸: "푸",
    푸ᄀ: "푹",
    푸ᄁ: "푺",
    푸ᄀᄉ: "푻",
    푸ᄂ: "푼",
    푸ᄂᄌ: "푽",
    푸ᄂᄒ: "푾",
    푸ᄃ: "푿",
    푸ᄅ: "풀",
    푸ᄅᄀ: "풁",
    푸ᄅᄆ: "풂",
    푸ᄅᄇ: "풃",
    푸ᄅᄉ: "풄",
    푸ᄅᄐ: "풅",
    푸ᄅᄑ: "풆",
    푸ᄅᄒ: "풇",
    푸ᄆ: "품",
    푸ᄇ: "풉",
    푸ᄇᄉ: "풊",
    푸ᄉ: "풋",
    푸ᄊ: "풌",
    푸ᄋ: "풍",
    푸ᄌ: "풎",
    푸ᄎ: "풏",
    푸ᄏ: "풐",
    푸ᄐ: "풑",
    푸ᄑ: "풒",
    푸ᄒ: "풓",
    푸ᅥ: "풔",
    푸ᅥᄀ: "풕",
    푸ᅥᄁ: "풖",
    푸ᅥᄀᄉ: "풗",
    푸ᅥᄂ: "풘",
    푸ᅥᄂᄌ: "풙",
    푸ᅥᄂᄒ: "풚",
    푸ᅥᄃ: "풛",
    푸ᅥᄅ: "풜",
    푸ᅥᄅᄀ: "풝",
    푸ᅥᄅᄆ: "풞",
    푸ᅥᄅᄇ: "풟",
    푸ᅥᄅᄉ: "풠",
    푸ᅥᄅᄐ: "풡",
    푸ᅥᄅᄑ: "풢",
    푸ᅥᄅᄒ: "풣",
    푸ᅥᄆ: "풤",
    푸ᅥᄇ: "풥",
    푸ᅥᄇᄉ: "풦",
    푸ᅥᄉ: "풧",
    푸ᅥᄊ: "풨",
    푸ᅥᄋ: "풩",
    푸ᅥᄌ: "풪",
    푸ᅥᄎ: "풫",
    푸ᅥᄏ: "풬",
    푸ᅥᄐ: "풭",
    푸ᅥᄑ: "풮",
    푸ᅥᄒ: "풯",
    푸ᅦ: "풰",
    푸ᅦᄀ: "풱",
    푸ᅦᄁ: "풲",
    푸ᅦᄀᄉ: "풳",
    푸ᅦᄂ: "풴",
    푸ᅦᄂᄌ: "풵",
    푸ᅦᄂᄒ: "풶",
    푸ᅦᄃ: "풷",
    푸ᅦᄅ: "풸",
    푸ᅦᄅᄀ: "풹",
    푸ᅦᄅᄆ: "풺",
    푸ᅦᄅᄇ: "풻",
    푸ᅦᄅᄉ: "풼",
    푸ᅦᄅᄐ: "풽",
    푸ᅦᄅᄑ: "풾",
    푸ᅦᄅᄒ: "풿",
    푸ᅦᄆ: "퓀",
    푸ᅦᄇ: "퓁",
    푸ᅦᄇᄉ: "퓂",
    푸ᅦᄉ: "퓃",
    푸ᅦᄊ: "퓄",
    푸ᅦᄋ: "퓅",
    푸ᅦᄌ: "퓆",
    푸ᅦᄎ: "퓇",
    푸ᅦᄏ: "퓈",
    푸ᅦᄐ: "퓉",
    푸ᅦᄑ: "퓊",
    푸ᅦᄒ: "퓋",
    푸ᅵ: "퓌",
    푸ᅵᄀ: "퓍",
    푸ᅵᄁ: "퓎",
    푸ᅵᄀᄉ: "퓏",
    푸ᅵᄂ: "퓐",
    푸ᅵᄂᄌ: "퓑",
    푸ᅵᄂᄒ: "퓒",
    푸ᅵᄃ: "퓓",
    푸ᅵᄅ: "퓔",
    푸ᅵᄅᄀ: "퓕",
    푸ᅵᄅᄆ: "퓖",
    푸ᅵᄅᄇ: "퓗",
    푸ᅵᄅᄉ: "퓘",
    푸ᅵᄅᄐ: "퓙",
    푸ᅵᄅᄑ: "퓚",
    푸ᅵᄅᄒ: "퓛",
    푸ᅵᄆ: "퓜",
    푸ᅵᄇ: "퓝",
    푸ᅵᄇᄉ: "퓞",
    푸ᅵᄉ: "퓟",
    푸ᅵᄊ: "퓠",
    푸ᅵᄋ: "퓡",
    푸ᅵᄌ: "퓢",
    푸ᅵᄎ: "퓣",
    푸ᅵᄏ: "퓤",
    푸ᅵᄐ: "퓥",
    푸ᅵᄑ: "퓦",
    푸ᅵᄒ: "퓧",
    퓨: "퓨",
    퓨ᄀ: "퓩",
    퓨ᄁ: "퓪",
    퓨ᄀᄉ: "퓫",
    퓨ᄂ: "퓬",
    퓨ᄂᄌ: "퓭",
    퓨ᄂᄒ: "퓮",
    퓨ᄃ: "퓯",
    퓨ᄅ: "퓰",
    퓨ᄅᄀ: "퓱",
    퓨ᄅᄆ: "퓲",
    퓨ᄅᄇ: "퓳",
    퓨ᄅᄉ: "퓴",
    퓨ᄅᄐ: "퓵",
    퓨ᄅᄑ: "퓶",
    퓨ᄅᄒ: "퓷",
    퓨ᄆ: "퓸",
    퓨ᄇ: "퓹",
    퓨ᄇᄉ: "퓺",
    퓨ᄉ: "퓻",
    퓨ᄊ: "퓼",
    퓨ᄋ: "퓽",
    퓨ᄌ: "퓾",
    퓨ᄎ: "퓿",
    퓨ᄏ: "픀",
    퓨ᄐ: "픁",
    퓨ᄑ: "픂",
    퓨ᄒ: "픃",
    프: "프",
    프ᄀ: "픅",
    프ᄁ: "픆",
    프ᄀᄉ: "픇",
    프ᄂ: "픈",
    프ᄂᄌ: "픉",
    프ᄂᄒ: "픊",
    프ᄃ: "픋",
    프ᄅ: "플",
    프ᄅᄀ: "픍",
    프ᄅᄆ: "픎",
    프ᄅᄇ: "픏",
    프ᄅᄉ: "픐",
    프ᄅᄐ: "픑",
    프ᄅᄑ: "픒",
    프ᄅᄒ: "픓",
    프ᄆ: "픔",
    프ᄇ: "픕",
    프ᄇᄉ: "픖",
    프ᄉ: "픗",
    프ᄊ: "픘",
    프ᄋ: "픙",
    프ᄌ: "픚",
    프ᄎ: "픛",
    프ᄏ: "픜",
    프ᄐ: "픝",
    프ᄑ: "픞",
    프ᄒ: "픟",
    프ᅵ: "픠",
    프ᅵᄀ: "픡",
    프ᅵᄁ: "픢",
    프ᅵᄀᄉ: "픣",
    프ᅵᄂ: "픤",
    프ᅵᄂᄌ: "픥",
    프ᅵᄂᄒ: "픦",
    프ᅵᄃ: "픧",
    프ᅵᄅ: "픨",
    프ᅵᄅᄀ: "픩",
    프ᅵᄅᄆ: "픪",
    프ᅵᄅᄇ: "픫",
    프ᅵᄅᄉ: "픬",
    프ᅵᄅᄐ: "픭",
    프ᅵᄅᄑ: "픮",
    프ᅵᄅᄒ: "픯",
    프ᅵᄆ: "픰",
    프ᅵᄇ: "픱",
    프ᅵᄇᄉ: "픲",
    프ᅵᄉ: "픳",
    프ᅵᄊ: "픴",
    프ᅵᄋ: "픵",
    프ᅵᄌ: "픶",
    프ᅵᄎ: "픷",
    프ᅵᄏ: "픸",
    프ᅵᄐ: "픹",
    프ᅵᄑ: "픺",
    프ᅵᄒ: "픻",
    피: "피",
    피ᄀ: "픽",
    피ᄁ: "픾",
    피ᄀᄉ: "픿",
    피ᄂ: "핀",
    피ᄂᄌ: "핁",
    피ᄂᄒ: "핂",
    피ᄃ: "핃",
    피ᄅ: "필",
    피ᄅᄀ: "핅",
    피ᄅᄆ: "핆",
    피ᄅᄇ: "핇",
    피ᄅᄉ: "핈",
    피ᄅᄐ: "핉",
    피ᄅᄑ: "핊",
    피ᄅᄒ: "핋",
    피ᄆ: "핌",
    피ᄇ: "핍",
    피ᄇᄉ: "핎",
    피ᄉ: "핏",
    피ᄊ: "핐",
    피ᄋ: "핑",
    피ᄌ: "핒",
    피ᄎ: "핓",
    피ᄏ: "핔",
    피ᄐ: "핕",
    피ᄑ: "핖",
    피ᄒ: "핗",
    하: "하",
    하ᄀ: "학",
    하ᄁ: "핚",
    하ᄀᄉ: "핛",
    하ᄂ: "한",
    하ᄂᄌ: "핝",
    하ᄂᄒ: "핞",
    하ᄃ: "핟",
    하ᄅ: "할",
    하ᄅᄀ: "핡",
    하ᄅᄆ: "핢",
    하ᄅᄇ: "핣",
    하ᄅᄉ: "핤",
    하ᄅᄐ: "핥",
    하ᄅᄑ: "핦",
    하ᄅᄒ: "핧",
    하ᄆ: "함",
    하ᄇ: "합",
    하ᄇᄉ: "핪",
    하ᄉ: "핫",
    하ᄊ: "핬",
    하ᄋ: "항",
    하ᄌ: "핮",
    하ᄎ: "핯",
    하ᄏ: "핰",
    하ᄐ: "핱",
    하ᄑ: "핲",
    하ᄒ: "핳",
    해: "해",
    해ᄀ: "핵",
    해ᄁ: "핶",
    해ᄀᄉ: "핷",
    해ᄂ: "핸",
    해ᄂᄌ: "핹",
    해ᄂᄒ: "핺",
    해ᄃ: "핻",
    해ᄅ: "핼",
    해ᄅᄀ: "핽",
    해ᄅᄆ: "핾",
    해ᄅᄇ: "핿",
    해ᄅᄉ: "햀",
    해ᄅᄐ: "햁",
    해ᄅᄑ: "햂",
    해ᄅᄒ: "햃",
    해ᄆ: "햄",
    해ᄇ: "햅",
    해ᄇᄉ: "햆",
    해ᄉ: "햇",
    해ᄊ: "했",
    해ᄋ: "행",
    해ᄌ: "햊",
    해ᄎ: "햋",
    해ᄏ: "햌",
    해ᄐ: "햍",
    해ᄑ: "햎",
    해ᄒ: "햏",
    햐: "햐",
    햐ᄀ: "햑",
    햐ᄁ: "햒",
    햐ᄀᄉ: "햓",
    햐ᄂ: "햔",
    햐ᄂᄌ: "햕",
    햐ᄂᄒ: "햖",
    햐ᄃ: "햗",
    햐ᄅ: "햘",
    햐ᄅᄀ: "햙",
    햐ᄅᄆ: "햚",
    햐ᄅᄇ: "햛",
    햐ᄅᄉ: "햜",
    햐ᄅᄐ: "햝",
    햐ᄅᄑ: "햞",
    햐ᄅᄒ: "햟",
    햐ᄆ: "햠",
    햐ᄇ: "햡",
    햐ᄇᄉ: "햢",
    햐ᄉ: "햣",
    햐ᄊ: "햤",
    햐ᄋ: "향",
    햐ᄌ: "햦",
    햐ᄎ: "햧",
    햐ᄏ: "햨",
    햐ᄐ: "햩",
    햐ᄑ: "햪",
    햐ᄒ: "햫",
    햬: "햬",
    햬ᄀ: "햭",
    햬ᄁ: "햮",
    햬ᄀᄉ: "햯",
    햬ᄂ: "햰",
    햬ᄂᄌ: "햱",
    햬ᄂᄒ: "햲",
    햬ᄃ: "햳",
    햬ᄅ: "햴",
    햬ᄅᄀ: "햵",
    햬ᄅᄆ: "햶",
    햬ᄅᄇ: "햷",
    햬ᄅᄉ: "햸",
    햬ᄅᄐ: "햹",
    햬ᄅᄑ: "햺",
    햬ᄅᄒ: "햻",
    햬ᄆ: "햼",
    햬ᄇ: "햽",
    햬ᄇᄉ: "햾",
    햬ᄉ: "햿",
    햬ᄊ: "헀",
    햬ᄋ: "헁",
    햬ᄌ: "헂",
    햬ᄎ: "헃",
    햬ᄏ: "헄",
    햬ᄐ: "헅",
    햬ᄑ: "헆",
    햬ᄒ: "헇",
    허: "허",
    허ᄀ: "헉",
    허ᄁ: "헊",
    허ᄀᄉ: "헋",
    허ᄂ: "헌",
    허ᄂᄌ: "헍",
    허ᄂᄒ: "헎",
    허ᄃ: "헏",
    허ᄅ: "헐",
    허ᄅᄀ: "헑",
    허ᄅᄆ: "헒",
    허ᄅᄇ: "헓",
    허ᄅᄉ: "헔",
    허ᄅᄐ: "헕",
    허ᄅᄑ: "헖",
    허ᄅᄒ: "헗",
    허ᄆ: "험",
    허ᄇ: "헙",
    허ᄇᄉ: "헚",
    허ᄉ: "헛",
    허ᄊ: "헜",
    허ᄋ: "헝",
    허ᄌ: "헞",
    허ᄎ: "헟",
    허ᄏ: "헠",
    허ᄐ: "헡",
    허ᄑ: "헢",
    허ᄒ: "헣",
    헤: "헤",
    헤ᄀ: "헥",
    헤ᄁ: "헦",
    헤ᄀᄉ: "헧",
    헤ᄂ: "헨",
    헤ᄂᄌ: "헩",
    헤ᄂᄒ: "헪",
    헤ᄃ: "헫",
    헤ᄅ: "헬",
    헤ᄅᄀ: "헭",
    헤ᄅᄆ: "헮",
    헤ᄅᄇ: "헯",
    헤ᄅᄉ: "헰",
    헤ᄅᄐ: "헱",
    헤ᄅᄑ: "헲",
    헤ᄅᄒ: "헳",
    헤ᄆ: "헴",
    헤ᄇ: "헵",
    헤ᄇᄉ: "헶",
    헤ᄉ: "헷",
    헤ᄊ: "헸",
    헤ᄋ: "헹",
    헤ᄌ: "헺",
    헤ᄎ: "헻",
    헤ᄏ: "헼",
    헤ᄐ: "헽",
    헤ᄑ: "헾",
    헤ᄒ: "헿",
    혀: "혀",
    혀ᄀ: "혁",
    혀ᄁ: "혂",
    혀ᄀᄉ: "혃",
    혀ᄂ: "현",
    혀ᄂᄌ: "혅",
    혀ᄂᄒ: "혆",
    혀ᄃ: "혇",
    혀ᄅ: "혈",
    혀ᄅᄀ: "혉",
    혀ᄅᄆ: "혊",
    혀ᄅᄇ: "혋",
    혀ᄅᄉ: "혌",
    혀ᄅᄐ: "혍",
    혀ᄅᄑ: "혎",
    혀ᄅᄒ: "혏",
    혀ᄆ: "혐",
    혀ᄇ: "협",
    혀ᄇᄉ: "혒",
    혀ᄉ: "혓",
    혀ᄊ: "혔",
    혀ᄋ: "형",
    혀ᄌ: "혖",
    혀ᄎ: "혗",
    혀ᄏ: "혘",
    혀ᄐ: "혙",
    혀ᄑ: "혚",
    혀ᄒ: "혛",
    혜: "혜",
    혜ᄀ: "혝",
    혜ᄁ: "혞",
    혜ᄀᄉ: "혟",
    혜ᄂ: "혠",
    혜ᄂᄌ: "혡",
    혜ᄂᄒ: "혢",
    혜ᄃ: "혣",
    혜ᄅ: "혤",
    혜ᄅᄀ: "혥",
    혜ᄅᄆ: "혦",
    혜ᄅᄇ: "혧",
    혜ᄅᄉ: "혨",
    혜ᄅᄐ: "혩",
    혜ᄅᄑ: "혪",
    혜ᄅᄒ: "혫",
    혜ᄆ: "혬",
    혜ᄇ: "혭",
    혜ᄇᄉ: "혮",
    혜ᄉ: "혯",
    혜ᄊ: "혰",
    혜ᄋ: "혱",
    혜ᄌ: "혲",
    혜ᄎ: "혳",
    혜ᄏ: "혴",
    혜ᄐ: "혵",
    혜ᄑ: "혶",
    혜ᄒ: "혷",
    호: "호",
    호ᄀ: "혹",
    호ᄁ: "혺",
    호ᄀᄉ: "혻",
    호ᄂ: "혼",
    호ᄂᄌ: "혽",
    호ᄂᄒ: "혾",
    호ᄃ: "혿",
    호ᄅ: "홀",
    호ᄅᄀ: "홁",
    호ᄅᄆ: "홂",
    호ᄅᄇ: "홃",
    호ᄅᄉ: "홄",
    호ᄅᄐ: "홅",
    호ᄅᄑ: "홆",
    호ᄅᄒ: "홇",
    호ᄆ: "홈",
    호ᄇ: "홉",
    호ᄇᄉ: "홊",
    호ᄉ: "홋",
    호ᄊ: "홌",
    호ᄋ: "홍",
    호ᄌ: "홎",
    호ᄎ: "홏",
    호ᄏ: "홐",
    호ᄐ: "홑",
    호ᄑ: "홒",
    호ᄒ: "홓",
    호ᅡ: "화",
    호ᅡᄀ: "확",
    호ᅡᄁ: "홖",
    호ᅡᄀᄉ: "홗",
    호ᅡᄂ: "환",
    호ᅡᄂᄌ: "홙",
    호ᅡᄂᄒ: "홚",
    호ᅡᄃ: "홛",
    호ᅡᄅ: "활",
    호ᅡᄅᄀ: "홝",
    호ᅡᄅᄆ: "홞",
    호ᅡᄅᄇ: "홟",
    호ᅡᄅᄉ: "홠",
    호ᅡᄅᄐ: "홡",
    호ᅡᄅᄑ: "홢",
    호ᅡᄅᄒ: "홣",
    호ᅡᄆ: "홤",
    호ᅡᄇ: "홥",
    호ᅡᄇᄉ: "홦",
    호ᅡᄉ: "홧",
    호ᅡᄊ: "홨",
    호ᅡᄋ: "황",
    호ᅡᄌ: "홪",
    호ᅡᄎ: "홫",
    호ᅡᄏ: "홬",
    호ᅡᄐ: "홭",
    호ᅡᄑ: "홮",
    호ᅡᄒ: "홯",
    호ᅢ: "홰",
    호ᅢᄀ: "홱",
    호ᅢᄁ: "홲",
    호ᅢᄀᄉ: "홳",
    호ᅢᄂ: "홴",
    호ᅢᄂᄌ: "홵",
    호ᅢᄂᄒ: "홶",
    호ᅢᄃ: "홷",
    호ᅢᄅ: "홸",
    호ᅢᄅᄀ: "홹",
    호ᅢᄅᄆ: "홺",
    호ᅢᄅᄇ: "홻",
    호ᅢᄅᄉ: "홼",
    호ᅢᄅᄐ: "홽",
    호ᅢᄅᄑ: "홾",
    호ᅢᄅᄒ: "홿",
    호ᅢᄆ: "횀",
    호ᅢᄇ: "횁",
    호ᅢᄇᄉ: "횂",
    호ᅢᄉ: "횃",
    호ᅢᄊ: "횄",
    호ᅢᄋ: "횅",
    호ᅢᄌ: "횆",
    호ᅢᄎ: "횇",
    호ᅢᄏ: "횈",
    호ᅢᄐ: "횉",
    호ᅢᄑ: "횊",
    호ᅢᄒ: "횋",
    호ᅵ: "회",
    호ᅵᄀ: "획",
    호ᅵᄁ: "횎",
    호ᅵᄀᄉ: "횏",
    호ᅵᄂ: "횐",
    호ᅵᄂᄌ: "횑",
    호ᅵᄂᄒ: "횒",
    호ᅵᄃ: "횓",
    호ᅵᄅ: "횔",
    호ᅵᄅᄀ: "횕",
    호ᅵᄅᄆ: "횖",
    호ᅵᄅᄇ: "횗",
    호ᅵᄅᄉ: "횘",
    호ᅵᄅᄐ: "횙",
    호ᅵᄅᄑ: "횚",
    호ᅵᄅᄒ: "횛",
    호ᅵᄆ: "횜",
    호ᅵᄇ: "횝",
    호ᅵᄇᄉ: "횞",
    호ᅵᄉ: "횟",
    호ᅵᄊ: "횠",
    호ᅵᄋ: "횡",
    호ᅵᄌ: "횢",
    호ᅵᄎ: "횣",
    호ᅵᄏ: "횤",
    호ᅵᄐ: "횥",
    호ᅵᄑ: "횦",
    호ᅵᄒ: "횧",
    효: "효",
    효ᄀ: "횩",
    효ᄁ: "횪",
    효ᄀᄉ: "횫",
    효ᄂ: "횬",
    효ᄂᄌ: "횭",
    효ᄂᄒ: "횮",
    효ᄃ: "횯",
    효ᄅ: "횰",
    효ᄅᄀ: "횱",
    효ᄅᄆ: "횲",
    효ᄅᄇ: "횳",
    효ᄅᄉ: "횴",
    효ᄅᄐ: "횵",
    효ᄅᄑ: "횶",
    효ᄅᄒ: "횷",
    효ᄆ: "횸",
    효ᄇ: "횹",
    효ᄇᄉ: "횺",
    효ᄉ: "횻",
    효ᄊ: "횼",
    효ᄋ: "횽",
    효ᄌ: "횾",
    효ᄎ: "횿",
    효ᄏ: "훀",
    효ᄐ: "훁",
    효ᄑ: "훂",
    효ᄒ: "훃",
    후: "후",
    후ᄀ: "훅",
    후ᄁ: "훆",
    후ᄀᄉ: "훇",
    후ᄂ: "훈",
    후ᄂᄌ: "훉",
    후ᄂᄒ: "훊",
    후ᄃ: "훋",
    후ᄅ: "훌",
    후ᄅᄀ: "훍",
    후ᄅᄆ: "훎",
    후ᄅᄇ: "훏",
    후ᄅᄉ: "훐",
    후ᄅᄐ: "훑",
    후ᄅᄑ: "훒",
    후ᄅᄒ: "훓",
    후ᄆ: "훔",
    후ᄇ: "훕",
    후ᄇᄉ: "훖",
    후ᄉ: "훗",
    후ᄊ: "훘",
    후ᄋ: "훙",
    후ᄌ: "훚",
    후ᄎ: "훛",
    후ᄏ: "훜",
    후ᄐ: "훝",
    후ᄑ: "훞",
    후ᄒ: "훟",
    후ᅥ: "훠",
    후ᅥᄀ: "훡",
    후ᅥᄁ: "훢",
    후ᅥᄀᄉ: "훣",
    후ᅥᄂ: "훤",
    후ᅥᄂᄌ: "훥",
    후ᅥᄂᄒ: "훦",
    후ᅥᄃ: "훧",
    후ᅥᄅ: "훨",
    후ᅥᄅᄀ: "훩",
    후ᅥᄅᄆ: "훪",
    후ᅥᄅᄇ: "훫",
    후ᅥᄅᄉ: "훬",
    후ᅥᄅᄐ: "훭",
    후ᅥᄅᄑ: "훮",
    후ᅥᄅᄒ: "훯",
    후ᅥᄆ: "훰",
    후ᅥᄇ: "훱",
    후ᅥᄇᄉ: "훲",
    후ᅥᄉ: "훳",
    후ᅥᄊ: "훴",
    후ᅥᄋ: "훵",
    후ᅥᄌ: "훶",
    후ᅥᄎ: "훷",
    후ᅥᄏ: "훸",
    후ᅥᄐ: "훹",
    후ᅥᄑ: "훺",
    후ᅥᄒ: "훻",
    후ᅦ: "훼",
    후ᅦᄀ: "훽",
    후ᅦᄁ: "훾",
    후ᅦᄀᄉ: "훿",
    후ᅦᄂ: "휀",
    후ᅦᄂᄌ: "휁",
    후ᅦᄂᄒ: "휂",
    후ᅦᄃ: "휃",
    후ᅦᄅ: "휄",
    후ᅦᄅᄀ: "휅",
    후ᅦᄅᄆ: "휆",
    후ᅦᄅᄇ: "휇",
    후ᅦᄅᄉ: "휈",
    후ᅦᄅᄐ: "휉",
    후ᅦᄅᄑ: "휊",
    후ᅦᄅᄒ: "휋",
    후ᅦᄆ: "휌",
    후ᅦᄇ: "휍",
    후ᅦᄇᄉ: "휎",
    후ᅦᄉ: "휏",
    후ᅦᄊ: "휐",
    후ᅦᄋ: "휑",
    후ᅦᄌ: "휒",
    후ᅦᄎ: "휓",
    후ᅦᄏ: "휔",
    후ᅦᄐ: "휕",
    후ᅦᄑ: "휖",
    후ᅦᄒ: "휗",
    후ᅵ: "휘",
    후ᅵᄀ: "휙",
    후ᅵᄁ: "휚",
    후ᅵᄀᄉ: "휛",
    후ᅵᄂ: "휜",
    후ᅵᄂᄌ: "휝",
    후ᅵᄂᄒ: "휞",
    후ᅵᄃ: "휟",
    후ᅵᄅ: "휠",
    후ᅵᄅᄀ: "휡",
    후ᅵᄅᄆ: "휢",
    후ᅵᄅᄇ: "휣",
    후ᅵᄅᄉ: "휤",
    후ᅵᄅᄐ: "휥",
    후ᅵᄅᄑ: "휦",
    후ᅵᄅᄒ: "휧",
    후ᅵᄆ: "휨",
    후ᅵᄇ: "휩",
    후ᅵᄇᄉ: "휪",
    후ᅵᄉ: "휫",
    후ᅵᄊ: "휬",
    후ᅵᄋ: "휭",
    후ᅵᄌ: "휮",
    후ᅵᄎ: "휯",
    후ᅵᄏ: "휰",
    후ᅵᄐ: "휱",
    후ᅵᄑ: "휲",
    후ᅵᄒ: "휳",
    휴: "휴",
    휴ᄀ: "휵",
    휴ᄁ: "휶",
    휴ᄀᄉ: "휷",
    휴ᄂ: "휸",
    휴ᄂᄌ: "휹",
    휴ᄂᄒ: "휺",
    휴ᄃ: "휻",
    휴ᄅ: "휼",
    휴ᄅᄀ: "휽",
    휴ᄅᄆ: "휾",
    휴ᄅᄇ: "휿",
    휴ᄅᄉ: "흀",
    휴ᄅᄐ: "흁",
    휴ᄅᄑ: "흂",
    휴ᄅᄒ: "흃",
    휴ᄆ: "흄",
    휴ᄇ: "흅",
    휴ᄇᄉ: "흆",
    휴ᄉ: "흇",
    휴ᄊ: "흈",
    휴ᄋ: "흉",
    휴ᄌ: "흊",
    휴ᄎ: "흋",
    휴ᄏ: "흌",
    휴ᄐ: "흍",
    휴ᄑ: "흎",
    휴ᄒ: "흏",
    흐: "흐",
    흐ᄀ: "흑",
    흐ᄁ: "흒",
    흐ᄀᄉ: "흓",
    흐ᄂ: "흔",
    흐ᄂᄌ: "흕",
    흐ᄂᄒ: "흖",
    흐ᄃ: "흗",
    흐ᄅ: "흘",
    흐ᄅᄀ: "흙",
    흐ᄅᄆ: "흚",
    흐ᄅᄇ: "흛",
    흐ᄅᄉ: "흜",
    흐ᄅᄐ: "흝",
    흐ᄅᄑ: "흞",
    흐ᄅᄒ: "흟",
    흐ᄆ: "흠",
    흐ᄇ: "흡",
    흐ᄇᄉ: "흢",
    흐ᄉ: "흣",
    흐ᄊ: "흤",
    흐ᄋ: "흥",
    흐ᄌ: "흦",
    흐ᄎ: "흧",
    흐ᄏ: "흨",
    흐ᄐ: "흩",
    흐ᄑ: "흪",
    흐ᄒ: "흫",
    흐ᅵ: "희",
    흐ᅵᄀ: "흭",
    흐ᅵᄁ: "흮",
    흐ᅵᄀᄉ: "흯",
    흐ᅵᄂ: "흰",
    흐ᅵᄂᄌ: "흱",
    흐ᅵᄂᄒ: "흲",
    흐ᅵᄃ: "흳",
    흐ᅵᄅ: "흴",
    흐ᅵᄅᄀ: "흵",
    흐ᅵᄅᄆ: "흶",
    흐ᅵᄅᄇ: "흷",
    흐ᅵᄅᄉ: "흸",
    흐ᅵᄅᄐ: "흹",
    흐ᅵᄅᄑ: "흺",
    흐ᅵᄅᄒ: "흻",
    흐ᅵᄆ: "흼",
    흐ᅵᄇ: "흽",
    흐ᅵᄇᄉ: "흾",
    흐ᅵᄉ: "흿",
    흐ᅵᄊ: "힀",
    흐ᅵᄋ: "힁",
    흐ᅵᄌ: "힂",
    흐ᅵᄎ: "힃",
    흐ᅵᄏ: "힄",
    흐ᅵᄐ: "힅",
    흐ᅵᄑ: "힆",
    흐ᅵᄒ: "힇",
    히: "히",
    히ᄀ: "힉",
    히ᄁ: "힊",
    히ᄀᄉ: "힋",
    히ᄂ: "힌",
    히ᄂᄌ: "힍",
    히ᄂᄒ: "힎",
    히ᄃ: "힏",
    히ᄅ: "힐",
    히ᄅᄀ: "힑",
    히ᄅᄆ: "힒",
    히ᄅᄇ: "힓",
    히ᄅᄉ: "힔",
    히ᄅᄐ: "힕",
    히ᄅᄑ: "힖",
    히ᄅᄒ: "힗",
    히ᄆ: "힘",
    히ᄇ: "힙",
    히ᄇᄉ: "힚",
    히ᄉ: "힛",
    히ᄊ: "힜",
    히ᄋ: "힝",
    히ᄌ: "힞",
    히ᄎ: "힟",
    히ᄏ: "힠",
    히ᄐ: "힡",
    히ᄑ: "힢",
    히ᄒ: "힣"
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/chinese.ts
/**
 * Layout: Chinese
 * Source: https://github.com/sxei/pinyinjs
 */
/* harmony default export */ var chinese = ({
  layout: {
    default: ["` 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "q w e r t y u i o p [ ] \\", "a s d f g h j k l ; '", "{shift} z x c v b n m . - / {shift}", ".com @ {space} {enter}"],
    shift: ["~ ! @ # $ % ^ & * ) ( _ + {bksp}", "Q W E R T Y U I O P { } |", 'A S D F G H J K L : "', "{shift} Z X C V B N M < > ? {shift}", ".com @ {space} {enter}"]
  },
  layoutCandidates: {
    a: "阿 啊 呵 腌 嗄 吖 锕",
    e: "额 阿 俄 恶 鹅 遏 鄂 厄 饿 峨 扼 娥 鳄 哦 蛾 噩 愕 讹 锷 垩 婀 鹗 萼 谔 莪 腭 锇 颚 呃 阏 屙 苊 轭",
    ai: "爱 埃 艾 碍 癌 哀 挨 矮 隘 蔼 唉 皑 哎 霭 捱 暧 嫒 嗳 瑷 嗌 锿 砹",
    ei: "诶",
    xi: "系 西 席 息 希 习 吸 喜 细 析 戏 洗 悉 锡 溪 惜 稀 袭 夕 洒 晰 昔 牺 腊 烯 熙 媳 栖 膝 隙 犀 蹊 硒 兮 熄 曦 禧 嬉 玺 奚 汐 徙 羲 铣 淅 嘻 歙 熹 矽 蟋 郗 唏 皙 隰 樨 浠 忾 蜥 檄 郄 翕 阋 鳃 舾 屣 葸 螅 咭 粞 觋 欷 僖 醯 鼷 裼 穸 饩 舄 禊 诶 菥 蓰",
    yi: "一 以 已 意 议 义 益 亿 易 医 艺 食 依 移 衣 异 伊 仪 宜 射 遗 疑 毅 谊 亦 疫 役 忆 抑 尾 乙 译 翼 蛇 溢 椅 沂 泄 逸 蚁 夷 邑 怡 绎 彝 裔 姨 熠 贻 矣 屹 颐 倚 诣 胰 奕 翌 疙 弈 轶 蛾 驿 壹 猗 臆 弋 铱 旖 漪 迤 佚 翊 诒 怿 痍 懿 饴 峄 揖 眙 镒 仡 黟 肄 咿 翳 挹 缢 呓 刈 咦 嶷 羿 钇 殪 荑 薏 蜴 镱 噫 癔 苡 悒 嗌 瘗 衤 佾 埸 圯 舣 酏 劓",
    an: "安 案 按 岸 暗 鞍 氨 俺 胺 铵 谙 庵 黯 鹌 桉 埯 犴 揞 厂 广",
    han: "厂 汉 韩 含 旱 寒 汗 涵 函 喊 憾 罕 焊 翰 邯 撼 瀚 憨 捍 酣 悍 鼾 邗 颔 蚶 晗 菡 旰 顸 犴 焓 撖",
    ang: "昂 仰 盎 肮",
    ao: "奥 澳 傲 熬 凹 鳌 敖 遨 鏖 袄 坳 翱 嗷 拗 懊 岙 螯 骜 獒 鏊 艹 媪 廒 聱",
    wa: "瓦 挖 娃 洼 袜 蛙 凹 哇 佤 娲 呙 腽",
    yu: "于 与 育 余 预 域 予 遇 奥 语 誉 玉 鱼 雨 渔 裕 愈 娱 欲 吁 舆 宇 羽 逾 豫 郁 寓 吾 狱 喻 御 浴 愉 禹 俞 邪 榆 愚 渝 尉 淤 虞 屿 峪 粥 驭 瑜 禺 毓 钰 隅 芋 熨 瘀 迂 煜 昱 汩 於 臾 盂 聿 竽 萸 妪 腴 圄 谕 觎 揄 龉 谀 俣 馀 庾 妤 瘐 鬻 欤 鹬 阈 嵛 雩 鹆 圉 蜮 伛 纡 窬 窳 饫 蓣 狳 肀 舁 蝓 燠",
    niu: "牛 纽 扭 钮 拗 妞 忸 狃",
    o: "哦 噢 喔",
    ba: "把 八 巴 拔 伯 吧 坝 爸 霸 罢 芭 跋 扒 叭 靶 疤 笆 耙 鲅 粑 岜 灞 钯 捌 菝 魃 茇",
    pa: "怕 帕 爬 扒 趴 琶 啪 葩 耙 杷 钯 筢",
    pi: "被 批 副 否 皮 坏 辟 啤 匹 披 疲 罢 僻 毗 坯 脾 譬 劈 媲 屁 琵 邳 裨 痞 癖 陂 丕 枇 噼 霹 吡 纰 砒 铍 淠 郫 埤 濞 睥 芘 蚍 圮 鼙 罴 蜱 疋 貔 仳 庀 擗 甓 陴",
    bi: "比 必 币 笔 毕 秘 避 闭 佛 辟 壁 弊 彼 逼 碧 鼻 臂 蔽 拂 泌 璧 庇 痹 毙 弼 匕 鄙 陛 裨 贲 敝 蓖 吡 篦 纰 俾 铋 毖 筚 荸 薜 婢 哔 跸 濞 秕 荜 愎 睥 妣 芘 箅 髀 畀 滗 狴 萆 嬖 襞 舭",
    bai: "百 白 败 摆 伯 拜 柏 佰 掰 呗 擘 捭 稗",
    bo: "波 博 播 勃 拨 薄 佛 伯 玻 搏 柏 泊 舶 剥 渤 卜 驳 簿 脖 膊 簸 菠 礴 箔 铂 亳 钵 帛 擘 饽 跛 钹 趵 檗 啵 鹁 擗 踣",
    bei: "北 被 备 倍 背 杯 勃 贝 辈 悲 碑 臂 卑 悖 惫 蓓 陂 钡 狈 呗 焙 碚 褙 庳 鞴 孛 鹎 邶 鐾",
    ban: "办 版 半 班 般 板 颁 伴 搬 斑 扮 拌 扳 瓣 坂 阪 绊 钣 瘢 舨 癍",
    pan: "判 盘 番 潘 攀 盼 拚 畔 胖 叛 拌 蹒 磐 爿 蟠 泮 袢 襻 丬",
    bin: "份 宾 频 滨 斌 彬 濒 殡 缤 鬓 槟 摈 膑 玢 镔 豳 髌 傧",
    bang: "帮 邦 彭 旁 榜 棒 膀 镑 绑 傍 磅 蚌 谤 梆 浜 蒡",
    pang: "旁 庞 乓 磅 螃 彷 滂 逄 耪",
    beng: "泵 崩 蚌 蹦 迸 绷 甭 嘣 甏 堋",
    bao: "报 保 包 宝 暴 胞 薄 爆 炮 饱 抱 堡 剥 鲍 曝 葆 瀑 豹 刨 褒 雹 孢 苞 煲 褓 趵 鸨 龅 勹",
    bu: "不 部 步 布 补 捕 堡 埔 卜 埠 簿 哺 怖 钚 卟 瓿 逋 晡 醭 钸",
    pu: "普 暴 铺 浦 朴 堡 葡 谱 埔 扑 仆 蒲 曝 瀑 溥 莆 圃 璞 濮 菩 蹼 匍 噗 氆 攵 镨 攴 镤",
    mian: "面 棉 免 绵 缅 勉 眠 冕 娩 腼 渑 湎 沔 黾 宀 眄",
    po: "破 繁 坡 迫 颇 朴 泊 婆 泼 魄 粕 鄱 珀 陂 叵 笸 泺 皤 钋 钷",
    fan: "反 范 犯 繁 饭 泛 翻 凡 返 番 贩 烦 拚 帆 樊 藩 矾 梵 蕃 钒 幡 畈 蘩 蹯 燔",
    fu: "府 服 副 负 富 复 福 夫 妇 幅 付 扶 父 符 附 腐 赴 佛 浮 覆 辅 傅 伏 抚 赋 辐 腹 弗 肤 阜 袱 缚 甫 氟 斧 孚 敷 俯 拂 俘 咐 腑 孵 芙 涪 釜 脯 茯 馥 宓 绂 讣 呋 罘 麸 蝠 匐 芾 蜉 跗 凫 滏 蝮 驸 绋 蚨 砩 桴 赙 菔 呒 趺 苻 拊 阝 鲋 怫 稃 郛 莩 幞 祓 艴 黻 黼 鳆",
    ben: "本 体 奔 苯 笨 夯 贲 锛 畚 坌",
    feng: "风 丰 封 峰 奉 凤 锋 冯 逢 缝 蜂 枫 疯 讽 烽 俸 沣 酆 砜 葑 唪",
    bian: "变 便 边 编 遍 辩 鞭 辨 贬 匾 扁 卞 汴 辫 砭 苄 蝙 鳊 弁 窆 笾 煸 褊 碥 忭 缏",
    pian: "便 片 篇 偏 骗 翩 扁 骈 胼 蹁 谝 犏 缏",
    zhen: "镇 真 针 圳 振 震 珍 阵 诊 填 侦 臻 贞 枕 桢 赈 祯 帧 甄 斟 缜 箴 疹 砧 榛 鸩 轸 稹 溱 蓁 胗 椹 朕 畛 浈",
    biao: "表 标 彪 镖 裱 飚 膘 飙 镳 婊 骠 飑 杓 髟 鳔 灬 瘭",
    piao: "票 朴 漂 飘 嫖 瓢 剽 缥 殍 瞟 骠 嘌 莩 螵",
    huo: "和 活 或 货 获 火 伙 惑 霍 祸 豁 嚯 藿 锪 蠖 钬 耠 镬 夥 灬 劐 攉",
    bie: "别 鳖 憋 瘪 蹩",
    min: "民 敏 闽 闵 皿 泯 岷 悯 珉 抿 黾 缗 玟 愍 苠 鳘",
    fen: "分 份 纷 奋 粉 氛 芬 愤 粪 坟 汾 焚 酚 吩 忿 棼 玢 鼢 瀵 偾 鲼",
    bing: "并 病 兵 冰 屏 饼 炳 秉 丙 摒 柄 槟 禀 枋 邴 冫",
    geng: "更 耕 颈 庚 耿 梗 埂 羹 哽 赓 绠 鲠",
    fang: "方 放 房 防 访 纺 芳 仿 坊 妨 肪 邡 舫 彷 枋 鲂 匚 钫",
    xian: "现 先 县 见 线 限 显 险 献 鲜 洗 宪 纤 陷 闲 贤 仙 衔 掀 咸 嫌 掺 羡 弦 腺 痫 娴 舷 馅 酰 铣 冼 涎 暹 籼 锨 苋 蚬 跹 岘 藓 燹 鹇 氙 莶 霰 跣 猃 彡 祆 筅",
    fou: "不 否 缶",
    ca: "拆 擦 嚓 礤",
    cha: "查 察 差 茶 插 叉 刹 茬 楂 岔 诧 碴 嚓 喳 姹 杈 汊 衩 搽 槎 镲 苴 檫 馇 锸 猹",
    cai: "才 采 财 材 菜 彩 裁 蔡 猜 踩 睬",
    can: "参 残 餐 灿 惨 蚕 掺 璨 惭 粲 孱 骖 黪",
    shen: "信 深 参 身 神 什 审 申 甚 沈 伸 慎 渗 肾 绅 莘 呻 婶 娠 砷 蜃 哂 椹 葚 吲 糁 渖 诜 谂 矧 胂",
    cen: "参 岑 涔",
    san: "三 参 散 伞 叁 糁 馓 毵",
    cang: "藏 仓 苍 沧 舱 臧 伧",
    zang: "藏 脏 葬 赃 臧 奘 驵",
    chen: "称 陈 沈 沉 晨 琛 臣 尘 辰 衬 趁 忱 郴 宸 谌 碜 嗔 抻 榇 伧 谶 龀 肜",
    cao: "草 操 曹 槽 糙 嘈 漕 螬 艚 屮",
    ce: "策 测 册 侧 厕 栅 恻",
    ze: "责 则 泽 择 侧 咋 啧 仄 箦 赜 笮 舴 昃 迮 帻",
    zhai: "债 择 齐 宅 寨 侧 摘 窄 斋 祭 翟 砦 瘵 哜",
    dao: "到 道 导 岛 倒 刀 盗 稻 蹈 悼 捣 叨 祷 焘 氘 纛 刂 帱 忉",
    ceng: "层 曾 蹭 噌",
    zha: "查 扎 炸 诈 闸 渣 咋 乍 榨 楂 札 栅 眨 咤 柞 喳 喋 铡 蚱 吒 怍 砟 揸 痄 哳 齄",
    chai: "差 拆 柴 钗 豺 侪 虿 瘥",
    ci: "次 此 差 词 辞 刺 瓷 磁 兹 慈 茨 赐 祠 伺 雌 疵 鹚 糍 呲 粢",
    zi: "资 自 子 字 齐 咨 滋 仔 姿 紫 兹 孜 淄 籽 梓 鲻 渍 姊 吱 秭 恣 甾 孳 訾 滓 锱 辎 趑 龇 赀 眦 缁 呲 笫 谘 嵫 髭 茈 粢 觜 耔",
    cuo: "措 错 磋 挫 搓 撮 蹉 锉 厝 嵯 痤 矬 瘥 脞 鹾",
    chan: "产 单 阐 崭 缠 掺 禅 颤 铲 蝉 搀 潺 蟾 馋 忏 婵 孱 觇 廛 谄 谗 澶 骣 羼 躔 蒇 冁",
    shan: "山 单 善 陕 闪 衫 擅 汕 扇 掺 珊 禅 删 膳 缮 赡 鄯 栅 煽 姗 跚 鳝 嬗 潸 讪 舢 苫 疝 掸 膻 钐 剡 蟮 芟 埏 彡 骟",
    zhan: "展 战 占 站 崭 粘 湛 沾 瞻 颤 詹 斩 盏 辗 绽 毡 栈 蘸 旃 谵 搌",
    xin: "新 心 信 辛 欣 薪 馨 鑫 芯 锌 忻 莘 昕 衅 歆 囟 忄 镡",
    lian: "联 连 练 廉 炼 脸 莲 恋 链 帘 怜 涟 敛 琏 镰 濂 楝 鲢 殓 潋 裢 裣 臁 奁 莶 蠊 蔹",
    chang: "场 长 厂 常 偿 昌 唱 畅 倡 尝 肠 敞 倘 猖 娼 淌 裳 徜 昶 怅 嫦 菖 鲳 阊 伥 苌 氅 惝 鬯",
    zhang: "长 张 章 障 涨 掌 帐 胀 彰 丈 仗 漳 樟 账 杖 璋 嶂 仉 瘴 蟑 獐 幛 鄣 嫜",
    chao: "超 朝 潮 炒 钞 抄 巢 吵 剿 绰 嘲 晁 焯 耖 怊",
    zhao: "着 照 招 找 召 朝 赵 兆 昭 肇 罩 钊 沼 嘲 爪 诏 濯 啁 棹 笊",
    zhou: "调 州 周 洲 舟 骤 轴 昼 宙 粥 皱 肘 咒 帚 胄 绉 纣 妯 啁 诌 繇 碡 籀 酎 荮",
    che: "车 彻 撤 尺 扯 澈 掣 坼 砗 屮",
    ju: "车 局 据 具 举 且 居 剧 巨 聚 渠 距 句 拒 俱 柜 菊 拘 炬 桔 惧 矩 鞠 驹 锯 踞 咀 瞿 枸 掬 沮 莒 橘 飓 疽 钜 趄 踽 遽 琚 龃 椐 苣 裾 榘 狙 倨 榉 苴 讵 雎 锔 窭 鞫 犋 屦 醵",
    cheng: "成 程 城 承 称 盛 抢 乘 诚 呈 净 惩 撑 澄 秤 橙 骋 逞 瞠 丞 晟 铛 埕 塍 蛏 柽 铖 酲 裎 枨",
    rong: "容 荣 融 绒 溶 蓉 熔 戎 榕 茸 冗 嵘 肜 狨 蝾",
    sheng: "生 声 升 胜 盛 乘 圣 剩 牲 甸 省 绳 笙 甥 嵊 晟 渑 眚",
    deng: "等 登 邓 灯 澄 凳 瞪 蹬 噔 磴 嶝 镫 簦 戥",
    zhi: "制 之 治 质 职 只 志 至 指 织 支 值 知 识 直 致 执 置 止 植 纸 拓 智 殖 秩 旨 址 滞 氏 枝 芝 脂 帜 汁 肢 挚 稚 酯 掷 峙 炙 栉 侄 芷 窒 咫 吱 趾 痔 蜘 郅 桎 雉 祉 郦 陟 痣 蛭 帙 枳 踯 徵 胝 栀 贽 祗 豸 鸷 摭 轵 卮 轾 彘 觯 絷 跖 埴 夂 黹 忮 骘 膣 踬",
    zheng: "政 正 证 争 整 征 郑 丁 症 挣 蒸 睁 铮 筝 拯 峥 怔 诤 狰 徵 钲",
    tang: "堂 唐 糖 汤 塘 躺 趟 倘 棠 烫 淌 膛 搪 镗 傥 螳 溏 帑 羰 樘 醣 螗 耥 铴 瑭",
    chi: "持 吃 池 迟 赤 驰 尺 斥 齿 翅 匙 痴 耻 炽 侈 弛 叱 啻 坻 眙 嗤 墀 哧 茌 豉 敕 笞 饬 踟 蚩 柢 媸 魑 篪 褫 彳 鸱 螭 瘛 眵 傺",
    shi: "是 时 实 事 市 十 使 世 施 式 势 视 识 师 史 示 石 食 始 士 失 适 试 什 泽 室 似 诗 饰 殖 释 驶 氏 硕 逝 湿 蚀 狮 誓 拾 尸 匙 仕 柿 矢 峙 侍 噬 嗜 栅 拭 嘘 屎 恃 轼 虱 耆 舐 莳 铈 谥 炻 豕 鲥 饣 螫 酾 筮 埘 弑 礻 蓍 鲺 贳",
    qi: "企 其 起 期 气 七 器 汽 奇 齐 启 旗 棋 妻 弃 揭 枝 歧 欺 骑 契 迄 亟 漆 戚 岂 稽 岐 琦 栖 缉 琪 泣 乞 砌 祁 崎 绮 祺 祈 凄 淇 杞 脐 麒 圻 憩 芪 伎 俟 畦 耆 葺 沏 萋 骐 鳍 綦 讫 蕲 屺 颀 亓 碛 柒 啐 汔 綮 萁 嘁 蛴 槭 欹 芑 桤 丌 蜞",
    chuai: "揣 踹 啜 搋 膪",
    tuo: "托 脱 拓 拖 妥 驼 陀 沱 鸵 驮 唾 椭 坨 佗 砣 跎 庹 柁 橐 乇 铊 沲 酡 鼍 箨 柝",
    duo: "多 度 夺 朵 躲 铎 隋 咄 堕 舵 垛 惰 哆 踱 跺 掇 剁 柁 缍 沲 裰 哚 隳",
    xue: "学 血 雪 削 薛 穴 靴 谑 噱 鳕 踅 泶 彐",
    chong: "重 种 充 冲 涌 崇 虫 宠 忡 憧 舂 茺 铳 艟",
    chou: "筹 抽 绸 酬 愁 丑 臭 仇 畴 稠 瞅 踌 惆 俦 瘳 雠 帱",
    qiu: "求 球 秋 丘 邱 仇 酋 裘 龟 囚 遒 鳅 虬 蚯 泅 楸 湫 犰 逑 巯 艽 俅 蝤 赇 鼽 糗",
    xiu: "修 秀 休 宿 袖 绣 臭 朽 锈 羞 嗅 岫 溴 庥 馐 咻 髹 鸺 貅",
    chu: "出 处 础 初 助 除 储 畜 触 楚 厨 雏 矗 橱 锄 滁 躇 怵 绌 搐 刍 蜍 黜 杵 蹰 亍 樗 憷 楮",
    tuan: "团 揣 湍 疃 抟 彖",
    zhui: "追 坠 缀 揣 椎 锥 赘 惴 隹 骓 缒",
    chuan: "传 川 船 穿 串 喘 椽 舛 钏 遄 氚 巛 舡",
    zhuan: "专 转 传 赚 砖 撰 篆 馔 啭 颛",
    yuan: "元 员 院 原 源 远 愿 园 援 圆 缘 袁 怨 渊 苑 宛 冤 媛 猿 垣 沅 塬 垸 鸳 辕 鸢 瑗 圜 爰 芫 鼋 橼 螈 眢 箢 掾",
    cuan: "窜 攒 篡 蹿 撺 爨 汆 镩",
    chuang: "创 床 窗 闯 幢 疮 怆",
    zhuang: "装 状 庄 壮 撞 妆 幢 桩 奘 僮 戆",
    chui: "吹 垂 锤 炊 椎 陲 槌 捶 棰",
    chun: "春 纯 醇 淳 唇 椿 蠢 鹑 朐 莼 肫 蝽",
    zhun: "准 屯 淳 谆 肫 窀",
    cu: "促 趋 趣 粗 簇 醋 卒 蹴 猝 蹙 蔟 殂 徂",
    dun: "吨 顿 盾 敦 蹲 墩 囤 沌 钝 炖 盹 遁 趸 砘 礅",
    qu: "区 去 取 曲 趋 渠 趣 驱 屈 躯 衢 娶 祛 瞿 岖 龋 觑 朐 蛐 癯 蛆 苣 阒 诎 劬 蕖 蘧 氍 黢 蠼 璩 麴 鸲 磲",
    xu: "需 许 续 须 序 徐 休 蓄 畜 虚 吁 绪 叙 旭 邪 恤 墟 栩 絮 圩 婿 戌 胥 嘘 浒 煦 酗 诩 朐 盱 蓿 溆 洫 顼 勖 糈 砉 醑",
    chuo: "辍 绰 戳 淖 啜 龊 踔 辶",
    zu: "组 族 足 祖 租 阻 卒 俎 诅 镞 菹",
    ji: "济 机 其 技 基 记 计 系 期 际 及 集 级 几 给 积 极 己 纪 即 继 击 既 激 绩 急 奇 吉 季 齐 疾 迹 鸡 剂 辑 籍 寄 挤 圾 冀 亟 寂 暨 脊 跻 肌 稽 忌 饥 祭 缉 棘 矶 汲 畸 姬 藉 瘠 骥 羁 妓 讥 稷 蓟 悸 嫉 岌 叽 伎 鲫 诘 楫 荠 戟 箕 霁 嵇 觊 麂 畿 玑 笈 犄 芨 唧 屐 髻 戢 佶 偈 笄 跽 蒺 乩 咭 赍 嵴 虮 掎 齑 殛 鲚 剞 洎 丌 墼 蕺 彐 芰 哜",
    cong: "从 丛 匆 聪 葱 囱 琮 淙 枞 骢 苁 璁",
    zong: "总 从 综 宗 纵 踪 棕 粽 鬃 偬 枞 腙",
    cou: "凑 辏 腠 楱",
    cui: "衰 催 崔 脆 翠 萃 粹 摧 璀 瘁 悴 淬 啐 隹 毳 榱",
    wei: "为 位 委 未 维 卫 围 违 威 伟 危 味 微 唯 谓 伪 慰 尾 魏 韦 胃 畏 帷 喂 巍 萎 蔚 纬 潍 尉 渭 惟 薇 苇 炜 圩 娓 诿 玮 崴 桅 偎 逶 倭 猥 囗 葳 隗 痿 猬 涠 嵬 韪 煨 艉 隹 帏 闱 洧 沩 隈 鲔 軎",
    cun: "村 存 寸 忖 皴",
    zuo: "作 做 座 左 坐 昨 佐 琢 撮 祚 柞 唑 嘬 酢 怍 笮 阼 胙",
    zuan: "钻 纂 攥 缵 躜",
    da: "大 达 打 答 搭 沓 瘩 惮 嗒 哒 耷 鞑 靼 褡 笪 怛 妲",
    dai: "大 代 带 待 贷 毒 戴 袋 歹 呆 隶 逮 岱 傣 棣 怠 殆 黛 甙 埭 诒 绐 玳 呔 迨",
    tai: "大 台 太 态 泰 抬 胎 汰 钛 苔 薹 肽 跆 邰 鲐 酞 骀 炱",
    ta: "他 它 她 拓 塔 踏 塌 榻 沓 漯 獭 嗒 挞 蹋 趿 遢 铊 鳎 溻 闼",
    dan: "但 单 石 担 丹 胆 旦 弹 蛋 淡 诞 氮 郸 耽 殚 惮 儋 眈 疸 澹 掸 膻 啖 箪 聃 萏 瘅 赕",
    lu: "路 六 陆 录 绿 露 鲁 卢 炉 鹿 禄 赂 芦 庐 碌 麓 颅 泸 卤 潞 鹭 辘 虏 璐 漉 噜 戮 鲈 掳 橹 轳 逯 渌 蓼 撸 鸬 栌 氇 胪 镥 簏 舻 辂 垆",
    tan: "谈 探 坦 摊 弹 炭 坛 滩 贪 叹 谭 潭 碳 毯 瘫 檀 痰 袒 坍 覃 忐 昙 郯 澹 钽 锬",
    ren: "人 任 认 仁 忍 韧 刃 纫 饪 妊 荏 稔 壬 仞 轫 亻 衽",
    jie: "家 结 解 价 界 接 节 她 届 介 阶 街 借 杰 洁 截 姐 揭 捷 劫 戒 皆 竭 桔 诫 楷 秸 睫 藉 拮 芥 诘 碣 嗟 颉 蚧 孑 婕 疖 桀 讦 疥 偈 羯 袷 哜 喈 卩 鲒 骱",
    yan: "研 严 验 演 言 眼 烟 沿 延 盐 炎 燕 岩 宴 艳 颜 殷 彦 掩 淹 阎 衍 铅 雁 咽 厌 焰 堰 砚 唁 焉 晏 檐 蜒 奄 俨 腌 妍 谚 兖 筵 焱 偃 闫 嫣 鄢 湮 赝 胭 琰 滟 阉 魇 酽 郾 恹 崦 芫 剡 鼹 菸 餍 埏 谳 讠 厣 罨",
    dang: "当 党 档 荡 挡 宕 砀 铛 裆 凼 菪 谠",
    tao: "套 讨 跳 陶 涛 逃 桃 萄 淘 掏 滔 韬 叨 洮 啕 绦 饕 鼗",
    tiao: "条 调 挑 跳 迢 眺 苕 窕 笤 佻 啁 粜 髫 铫 祧 龆 蜩 鲦",
    te: "特 忑 忒 铽 慝",
    de: "的 地 得 德 底 锝",
    dei: "得",
    di: "的 地 第 提 低 底 抵 弟 迪 递 帝 敌 堤 蒂 缔 滴 涤 翟 娣 笛 棣 荻 谛 狄 邸 嘀 砥 坻 诋 嫡 镝 碲 骶 氐 柢 籴 羝 睇 觌",
    ti: "体 提 题 弟 替 梯 踢 惕 剔 蹄 棣 啼 屉 剃 涕 锑 倜 悌 逖 嚏 荑 醍 绨 鹈 缇 裼",
    tui: "推 退 弟 腿 褪 颓 蜕 忒 煺",
    you: "有 由 又 优 游 油 友 右 邮 尤 忧 幼 犹 诱 悠 幽 佑 釉 柚 铀 鱿 囿 酉 攸 黝 莠 猷 蝣 疣 呦 蚴 莸 莜 铕 宥 繇 卣 牖 鼬 尢 蚰 侑",
    dian: "电 点 店 典 奠 甸 碘 淀 殿 垫 颠 滇 癫 巅 惦 掂 癜 玷 佃 踮 靛 钿 簟 坫 阽",
    tian: "天 田 添 填 甜 甸 恬 腆 佃 舔 钿 阗 忝 殄 畋 栝 掭",
    zhu: "主 术 住 注 助 属 逐 宁 著 筑 驻 朱 珠 祝 猪 诸 柱 竹 铸 株 瞩 嘱 贮 煮 烛 苎 褚 蛛 拄 铢 洙 竺 蛀 渚 伫 杼 侏 澍 诛 茱 箸 炷 躅 翥 潴 邾 槠 舳 橥 丶 瘃 麈 疰",
    nian: "年 念 酿 辗 碾 廿 捻 撵 拈 蔫 鲶 埝 鲇 辇 黏",
    diao: "调 掉 雕 吊 钓 刁 貂 凋 碉 鲷 叼 铫 铞",
    yao: "要 么 约 药 邀 摇 耀 腰 遥 姚 窑 瑶 咬 尧 钥 谣 肴 夭 侥 吆 疟 妖 幺 杳 舀 窕 窈 曜 鹞 爻 繇 徭 轺 铫 鳐 崾 珧",
    die: "跌 叠 蝶 迭 碟 爹 谍 牒 耋 佚 喋 堞 瓞 鲽 垤 揲 蹀",
    she: "设 社 摄 涉 射 折 舍 蛇 拾 舌 奢 慑 赦 赊 佘 麝 歙 畲 厍 猞 揲 滠",
    ye: "业 也 夜 叶 射 野 液 冶 喝 页 爷 耶 邪 咽 椰 烨 掖 拽 曳 晔 谒 腋 噎 揶 靥 邺 铘 揲",
    xie: "些 解 协 写 血 叶 谢 械 鞋 胁 斜 携 懈 契 卸 谐 泄 蟹 邪 歇 泻 屑 挟 燮 榭 蝎 撷 偕 亵 楔 颉 缬 邂 鲑 瀣 勰 榍 薤 绁 渫 廨 獬 躞",
    zhe: "这 者 着 著 浙 折 哲 蔗 遮 辙 辄 柘 锗 褶 蜇 蛰 鹧 谪 赭 摺 乇 磔 螫",
    ding: "定 订 顶 丁 鼎 盯 钉 锭 叮 仃 铤 町 酊 啶 碇 腚 疔 玎 耵",
    diu: "丢 铥",
    ting: "听 庭 停 厅 廷 挺 亭 艇 婷 汀 铤 烃 霆 町 蜓 葶 梃 莛",
    dong: "动 东 董 冬 洞 懂 冻 栋 侗 咚 峒 氡 恫 胴 硐 垌 鸫 岽 胨",
    tong: "同 通 统 童 痛 铜 桶 桐 筒 彤 侗 佟 潼 捅 酮 砼 瞳 恸 峒 仝 嗵 僮 垌 茼",
    zhong: "中 重 种 众 终 钟 忠 仲 衷 肿 踵 冢 盅 蚣 忪 锺 舯 螽 夂",
    dou: "都 斗 读 豆 抖 兜 陡 逗 窦 渎 蚪 痘 蔸 钭 篼",
    du: "度 都 独 督 读 毒 渡 杜 堵 赌 睹 肚 镀 渎 笃 竺 嘟 犊 妒 牍 蠹 椟 黩 芏 髑",
    duan: "断 段 短 端 锻 缎 煅 椴 簖",
    dui: "对 队 追 敦 兑 堆 碓 镦 怼 憝",
    rui: "瑞 兑 锐 睿 芮 蕊 蕤 蚋 枘",
    yue: "月 说 约 越 乐 跃 兑 阅 岳 粤 悦 曰 钥 栎 钺 樾 瀹 龠 哕 刖",
    tun: "吞 屯 囤 褪 豚 臀 饨 暾 氽",
    hui: "会 回 挥 汇 惠 辉 恢 徽 绘 毁 慧 灰 贿 卉 悔 秽 溃 荟 晖 彗 讳 诲 珲 堕 诙 蕙 晦 睢 麾 烩 茴 喙 桧 蛔 洄 浍 虺 恚 蟪 咴 隳 缋 哕",
    wu: "务 物 无 五 武 午 吴 舞 伍 污 乌 误 亡 恶 屋 晤 悟 吾 雾 芜 梧 勿 巫 侮 坞 毋 诬 呜 钨 邬 捂 鹜 兀 婺 妩 於 戊 鹉 浯 蜈 唔 骛 仵 焐 芴 鋈 庑 鼯 牾 怃 圬 忤 痦 迕 杌 寤 阢",
    ya: "亚 压 雅 牙 押 鸭 呀 轧 涯 崖 邪 芽 哑 讶 鸦 娅 衙 丫 蚜 碣 垭 伢 氩 桠 琊 揠 吖 睚 痖 疋 迓 岈 砑",
    he: "和 合 河 何 核 盖 贺 喝 赫 荷 盒 鹤 吓 呵 苛 禾 菏 壑 褐 涸 阂 阖 劾 诃 颌 嗬 貉 曷 翮 纥 盍",
    wo: "我 握 窝 沃 卧 挝 涡 斡 渥 幄 蜗 喔 倭 莴 龌 肟 硪",
    en: "恩 摁 蒽",
    n: "嗯 唔",
    er: "而 二 尔 儿 耳 迩 饵 洱 贰 铒 珥 佴 鸸 鲕",
    fa: "发 法 罚 乏 伐 阀 筏 砝 垡 珐",
    quan: "全 权 券 泉 圈 拳 劝 犬 铨 痊 诠 荃 醛 蜷 颧 绻 犭 筌 鬈 悛 辁 畎",
    fei: "费 非 飞 肥 废 菲 肺 啡 沸 匪 斐 蜚 妃 诽 扉 翡 霏 吠 绯 腓 痱 芾 淝 悱 狒 榧 砩 鲱 篚 镄",
    pei: "配 培 坏 赔 佩 陪 沛 裴 胚 妃 霈 淠 旆 帔 呸 醅 辔 锫",
    ping: "平 评 凭 瓶 冯 屏 萍 苹 乒 坪 枰 娉 俜 鲆",
    fo: "佛",
    hu: "和 护 许 户 核 湖 互 乎 呼 胡 戏 忽 虎 沪 糊 壶 葫 狐 蝴 弧 瑚 浒 鹄 琥 扈 唬 滹 惚 祜 囫 斛 笏 芴 醐 猢 怙 唿 戽 槲 觳 煳 鹕 冱 瓠 虍 岵 鹱 烀 轷",
    ga: "夹 咖 嘎 尬 噶 旮 伽 尕 钆 尜",
    ge: "个 合 各 革 格 歌 哥 盖 隔 割 阁 戈 葛 鸽 搁 胳 舸 疙 铬 骼 蛤 咯 圪 镉 颌 仡 硌 嗝 鬲 膈 纥 袼 搿 塥 哿 虼",
    ha: "哈 蛤 铪",
    xia: "下 夏 峡 厦 辖 霞 夹 虾 狭 吓 侠 暇 遐 瞎 匣 瑕 唬 呷 黠 硖 罅 狎 瘕 柙",
    gai: "改 该 盖 概 溉 钙 丐 芥 赅 垓 陔 戤",
    hai: "海 还 害 孩 亥 咳 骸 骇 氦 嗨 胲 醢",
    gan: "干 感 赶 敢 甘 肝 杆 赣 乾 柑 尴 竿 秆 橄 矸 淦 苷 擀 酐 绀 泔 坩 旰 疳 澉",
    gang: "港 钢 刚 岗 纲 冈 杠 缸 扛 肛 罡 戆 筻",
    jiang: "将 强 江 港 奖 讲 降 疆 蒋 姜 浆 匠 酱 僵 桨 绛 缰 犟 豇 礓 洚 茳 糨 耩",
    hang: "行 航 杭 巷 夯 吭 桁 沆 绗 颃",
    gong: "工 公 共 供 功 红 贡 攻 宫 巩 龚 恭 拱 躬 弓 汞 蚣 珙 觥 肱 廾",
    hong: "红 宏 洪 轰 虹 鸿 弘 哄 烘 泓 訇 蕻 闳 讧 荭 黉 薨",
    guang: "广 光 逛 潢 犷 胱 咣 桄",
    qiong: "穷 琼 穹 邛 茕 筇 跫 蛩 銎",
    gao: "高 告 搞 稿 膏 糕 镐 皋 羔 锆 杲 郜 睾 诰 藁 篙 缟 槁 槔",
    hao: "好 号 毫 豪 耗 浩 郝 皓 昊 皋 蒿 壕 灏 嚎 濠 蚝 貉 颢 嗥 薅 嚆",
    li: "理 力 利 立 里 李 历 例 离 励 礼 丽 黎 璃 厉 厘 粒 莉 梨 隶 栗 荔 沥 犁 漓 哩 狸 藜 罹 篱 鲤 砺 吏 澧 俐 骊 溧 砾 莅 锂 笠 蠡 蛎 痢 雳 俪 傈 醴 栎 郦 俚 枥 喱 逦 娌 鹂 戾 砬 唳 坜 疠 蜊 黧 猁 鬲 粝 蓠 呖 跞 疬 缡 鲡 鳢 嫠 詈 悝 苈 篥 轹",
    jia: "家 加 价 假 佳 架 甲 嘉 贾 驾 嫁 夹 稼 钾 挟 拮 迦 伽 颊 浃 枷 戛 荚 痂 颉 镓 笳 珈 岬 胛 袈 郏 葭 袷 瘕 铗 跏 蛱 恝 哿",
    luo: "落 罗 络 洛 逻 螺 锣 骆 萝 裸 漯 烙 摞 骡 咯 箩 珞 捋 荦 硌 雒 椤 镙 跞 瘰 泺 脶 猡 倮 蠃",
    ke: "可 科 克 客 刻 课 颗 渴 壳 柯 棵 呵 坷 恪 苛 咳 磕 珂 稞 瞌 溘 轲 窠 嗑 疴 蝌 岢 铪 颏 髁 蚵 缂 氪 骒 钶 锞",
    qia: "卡 恰 洽 掐 髂 袷 咭 葜",
    gei: "给",
    gen: "根 跟 亘 艮 哏 茛",
    hen: "很 狠 恨 痕 哏",
    gou: "构 购 够 句 沟 狗 钩 拘 勾 苟 垢 枸 篝 佝 媾 诟 岣 彀 缑 笱 鞲 觏 遘",
    kou: "口 扣 寇 叩 抠 佝 蔻 芤 眍 筘",
    gu: "股 古 顾 故 固 鼓 骨 估 谷 贾 姑 孤 雇 辜 菇 沽 咕 呱 锢 钴 箍 汩 梏 痼 崮 轱 鸪 牯 蛊 诂 毂 鹘 菰 罟 嘏 臌 觚 瞽 蛄 酤 牿 鲴",
    pai: "牌 排 派 拍 迫 徘 湃 俳 哌 蒎",
    gua: "括 挂 瓜 刮 寡 卦 呱 褂 剐 胍 诖 鸹 栝 呙",
    tou: "投 头 透 偷 愉 骰 亠",
    guai: "怪 拐 乖",
    kuai: "会 快 块 筷 脍 蒯 侩 浍 郐 蒉 狯 哙",
    guan: "关 管 观 馆 官 贯 冠 惯 灌 罐 莞 纶 棺 斡 矜 倌 鹳 鳏 盥 掼 涫",
    wan: "万 完 晚 湾 玩 碗 顽 挽 弯 蔓 丸 莞 皖 宛 婉 腕 蜿 惋 烷 琬 畹 豌 剜 纨 绾 脘 菀 芄 箢",
    ne: "呢 哪 呐 讷 疒",
    gui: "规 贵 归 轨 桂 柜 圭 鬼 硅 瑰 跪 龟 匮 闺 诡 癸 鳜 桧 皈 鲑 刽 晷 傀 眭 妫 炅 庋 簋 刿 宄 匦",
    jun: "军 均 俊 君 峻 菌 竣 钧 骏 龟 浚 隽 郡 筠 皲 麇 捃",
    jiong: "窘 炯 迥 炅 冂 扃",
    jue: "决 绝 角 觉 掘 崛 诀 獗 抉 爵 嚼 倔 厥 蕨 攫 珏 矍 蹶 谲 镢 鳜 噱 桷 噘 撅 橛 孓 觖 劂 爝",
    gun: "滚 棍 辊 衮 磙 鲧 绲 丨",
    hun: "婚 混 魂 浑 昏 棍 珲 荤 馄 诨 溷 阍",
    guo: "国 过 果 郭 锅 裹 帼 涡 椁 囗 蝈 虢 聒 埚 掴 猓 崞 蜾 呙 馘",
    hei: "黑 嘿 嗨",
    kan: "看 刊 勘 堪 坎 砍 侃 嵌 槛 瞰 阚 龛 戡 凵 莰",
    heng: "衡 横 恒 亨 哼 珩 桁 蘅",
    mo: "万 没 么 模 末 冒 莫 摩 墨 默 磨 摸 漠 脉 膜 魔 沫 陌 抹 寞 蘑 摹 蓦 馍 茉 嘿 谟 秣 蟆 貉 嫫 镆 殁 耱 嬷 麽 瘼 貊 貘",
    peng: "鹏 朋 彭 膨 蓬 碰 苹 棚 捧 亨 烹 篷 澎 抨 硼 怦 砰 嘭 蟛 堋",
    hou: "后 候 厚 侯 猴 喉 吼 逅 篌 糇 骺 後 鲎 瘊 堠",
    hua: "化 华 划 话 花 画 滑 哗 豁 骅 桦 猾 铧 砉",
    huai: "怀 坏 淮 徊 槐 踝",
    huan: "还 环 换 欢 患 缓 唤 焕 幻 痪 桓 寰 涣 宦 垸 洹 浣 豢 奂 郇 圜 獾 鲩 鬟 萑 逭 漶 锾 缳 擐",
    xun: "讯 训 迅 孙 寻 询 循 旬 巡 汛 勋 逊 熏 徇 浚 殉 驯 鲟 薰 荀 浔 洵 峋 埙 巽 郇 醺 恂 荨 窨 蕈 曛 獯",
    huang: "黄 荒 煌 皇 凰 慌 晃 潢 谎 惶 簧 璜 恍 幌 湟 蝗 磺 隍 徨 遑 肓 篁 鳇 蟥 癀",
    nai: "能 乃 奶 耐 奈 鼐 萘 氖 柰 佴 艿",
    luan: "乱 卵 滦 峦 鸾 栾 銮 挛 孪 脔 娈",
    qie: "切 且 契 窃 茄 砌 锲 怯 伽 惬 妾 趄 挈 郄 箧 慊",
    jian: "建 间 件 见 坚 检 健 监 减 简 艰 践 兼 鉴 键 渐 柬 剑 尖 肩 舰 荐 箭 浅 剪 俭 碱 茧 奸 歼 拣 捡 煎 贱 溅 槛 涧 堑 笺 谏 饯 锏 缄 睑 謇 蹇 腱 菅 翦 戬 毽 笕 犍 硷 鞯 牮 枧 湔 鲣 囝 裥 踺 搛 缣 鹣 蒹 谫 僭 戋 趼 楗",
    nan: "南 难 男 楠 喃 囡 赧 腩 囝 蝻",
    qian: "前 千 钱 签 潜 迁 欠 纤 牵 浅 遣 谦 乾 铅 歉 黔 谴 嵌 倩 钳 茜 虔 堑 钎 骞 阡 掮 钤 扦 芊 犍 荨 仟 芡 悭 缱 佥 愆 褰 凵 肷 岍 搴 箝 慊 椠",
    qiang: "强 抢 疆 墙 枪 腔 锵 呛 羌 蔷 襁 羟 跄 樯 戕 嫱 戗 炝 镪 锖 蜣",
    xiang: "向 项 相 想 乡 象 响 香 降 像 享 箱 羊 祥 湘 详 橡 巷 翔 襄 厢 镶 飨 饷 缃 骧 芗 庠 鲞 葙 蟓",
    jiao: "教 交 较 校 角 觉 叫 脚 缴 胶 轿 郊 焦 骄 浇 椒 礁 佼 蕉 娇 矫 搅 绞 酵 剿 嚼 饺 窖 跤 蛟 侥 狡 姣 皎 茭 峤 铰 醮 鲛 湫 徼 鹪 僬 噍 艽 挢 敫",
    zhuo: "着 著 缴 桌 卓 捉 琢 灼 浊 酌 拙 茁 涿 镯 淖 啄 濯 焯 倬 擢 斫 棹 诼 浞 禚",
    qiao: "桥 乔 侨 巧 悄 敲 俏 壳 雀 瞧 翘 窍 峭 锹 撬 荞 跷 樵 憔 鞘 橇 峤 诮 谯 愀 鞒 硗 劁 缲",
    xiao: "小 效 销 消 校 晓 笑 肖 削 孝 萧 俏 潇 硝 宵 啸 嚣 霄 淆 哮 筱 逍 姣 箫 骁 枭 哓 绡 蛸 崤 枵 魈",
    si: "司 四 思 斯 食 私 死 似 丝 饲 寺 肆 撕 泗 伺 嗣 祀 厮 驷 嘶 锶 俟 巳 蛳 咝 耜 笥 纟 糸 鸶 缌 澌 姒 汜 厶 兕",
    kai: "开 凯 慨 岂 楷 恺 揩 锴 铠 忾 垲 剀 锎 蒈",
    jin: "进 金 今 近 仅 紧 尽 津 斤 禁 锦 劲 晋 谨 筋 巾 浸 襟 靳 瑾 烬 缙 钅 矜 觐 堇 馑 荩 噤 廑 妗 槿 赆 衿 卺",
    qin: "亲 勤 侵 秦 钦 琴 禽 芹 沁 寝 擒 覃 噙 矜 嗪 揿 溱 芩 衾 廑 锓 吣 檎 螓",
    jing: "经 京 精 境 竞 景 警 竟 井 惊 径 静 劲 敬 净 镜 睛 晶 颈 荆 兢 靖 泾 憬 鲸 茎 腈 菁 胫 阱 旌 粳 靓 痉 箐 儆 迳 婧 肼 刭 弪 獍",
    ying: "应 营 影 英 景 迎 映 硬 盈 赢 颖 婴 鹰 荧 莹 樱 瑛 蝇 萦 莺 颍 膺 缨 瀛 楹 罂 荥 萤 鹦 滢 蓥 郢 茔 嘤 璎 嬴 瘿 媵 撄 潆",
    jiu: "就 究 九 酒 久 救 旧 纠 舅 灸 疚 揪 咎 韭 玖 臼 柩 赳 鸠 鹫 厩 啾 阄 桕 僦 鬏",
    zui: "最 罪 嘴 醉 咀 蕞 觜",
    juan: "卷 捐 圈 眷 娟 倦 绢 隽 镌 涓 鹃 鄄 蠲 狷 锩 桊",
    suan: "算 酸 蒜 狻",
    yun: "员 运 云 允 孕 蕴 韵 酝 耘 晕 匀 芸 陨 纭 郧 筠 恽 韫 郓 氲 殒 愠 昀 菀 狁",
    qun: "群 裙 逡 麇",
    ka: "卡 喀 咖 咔 咯 佧 胩",
    kang: "康 抗 扛 慷 炕 亢 糠 伉 钪 闶",
    keng: "坑 铿 吭",
    kao: "考 靠 烤 拷 铐 栲 尻 犒",
    ken: "肯 垦 恳 啃 龈 裉",
    yin: "因 引 银 印 音 饮 阴 隐 姻 殷 淫 尹 荫 吟 瘾 寅 茵 圻 垠 鄞 湮 蚓 氤 胤 龈 窨 喑 铟 洇 狺 夤 廴 吲 霪 茚 堙",
    kong: "空 控 孔 恐 倥 崆 箜",
    ku: "苦 库 哭 酷 裤 枯 窟 挎 骷 堀 绔 刳 喾",
    kua: "跨 夸 垮 挎 胯 侉",
    kui: "亏 奎 愧 魁 馈 溃 匮 葵 窥 盔 逵 睽 馗 聩 喟 夔 篑 岿 喹 揆 隗 傀 暌 跬 蒉 愦 悝 蝰",
    kuan: "款 宽 髋",
    kuang: "况 矿 框 狂 旷 眶 匡 筐 邝 圹 哐 贶 夼 诳 诓 纩",
    que: "确 却 缺 雀 鹊 阙 瘸 榷 炔 阕 悫",
    kun: "困 昆 坤 捆 琨 锟 鲲 醌 髡 悃 阃",
    kuo: "扩 括 阔 廓 蛞",
    la: "拉 落 垃 腊 啦 辣 蜡 喇 剌 旯 砬 邋 瘌",
    lai: "来 莱 赖 睐 徕 籁 涞 赉 濑 癞 崃 疠 铼",
    lan: "兰 览 蓝 篮 栏 岚 烂 滥 缆 揽 澜 拦 懒 榄 斓 婪 阑 褴 罱 啉 谰 镧 漤",
    lin: "林 临 邻 赁 琳 磷 淋 麟 霖 鳞 凛 拎 遴 蔺 吝 粼 嶙 躏 廪 檩 啉 辚 膦 瞵 懔",
    lang: "浪 朗 郎 廊 狼 琅 榔 螂 阆 锒 莨 啷 蒗 稂",
    liang: "量 两 粮 良 辆 亮 梁 凉 谅 粱 晾 靓 踉 莨 椋 魉 墚",
    lao: "老 劳 落 络 牢 捞 涝 烙 姥 佬 崂 唠 酪 潦 痨 醪 铑 铹 栳 耢",
    mu: "目 模 木 亩 幕 母 牧 莫 穆 姆 墓 慕 牟 牡 募 睦 缪 沐 暮 拇 姥 钼 苜 仫 毪 坶",
    le: "了 乐 勒 肋 叻 鳓 嘞 仂 泐",
    lei: "类 累 雷 勒 泪 蕾 垒 磊 擂 镭 肋 羸 耒 儡 嫘 缧 酹 嘞 诔 檑",
    sui: "随 岁 虽 碎 尿 隧 遂 髓 穗 绥 隋 邃 睢 祟 濉 燧 谇 眭 荽",
    lie: "列 烈 劣 裂 猎 冽 咧 趔 洌 鬣 埒 捩 躐",
    leng: "冷 愣 棱 楞 塄",
    ling: "领 令 另 零 灵 龄 陵 岭 凌 玲 铃 菱 棱 伶 羚 苓 聆 翎 泠 瓴 囹 绫 呤 棂 蛉 酃 鲮 柃",
    lia: "俩",
    liao: "了 料 疗 辽 廖 聊 寥 缪 僚 燎 缭 撂 撩 嘹 潦 镣 寮 蓼 獠 钌 尥 鹩",
    liu: "流 刘 六 留 柳 瘤 硫 溜 碌 浏 榴 琉 馏 遛 鎏 骝 绺 镏 旒 熘 鹨 锍",
    lun: "论 轮 伦 仑 纶 沦 抡 囵",
    lv: "率 律 旅 绿 虑 履 吕 铝 屡 氯 缕 滤 侣 驴 榈 闾 偻 褛 捋 膂 稆",
    lou: "楼 露 漏 陋 娄 搂 篓 喽 镂 偻 瘘 髅 耧 蝼 嵝 蒌",
    mao: "贸 毛 矛 冒 貌 茂 茅 帽 猫 髦 锚 懋 袤 牦 卯 铆 耄 峁 瑁 蟊 茆 蝥 旄 泖 昴 瞀",
    long: "龙 隆 弄 垄 笼 拢 聋 陇 胧 珑 窿 茏 咙 砻 垅 泷 栊 癃",
    nong: "农 浓 弄 脓 侬 哝",
    shuang: "双 爽 霜 孀 泷",
    shu: "术 书 数 属 树 输 束 述 署 朱 熟 殊 蔬 舒 疏 鼠 淑 叔 暑 枢 墅 俞 曙 抒 竖 蜀 薯 梳 戍 恕 孰 沭 赎 庶 漱 塾 倏 澍 纾 姝 菽 黍 腧 秫 毹 殳 疋 摅",
    shuai: "率 衰 帅 摔 甩 蟀",
    lve: "略 掠 锊",
    ma: "么 马 吗 摩 麻 码 妈 玛 嘛 骂 抹 蚂 唛 蟆 犸 杩",
    me: "么 麽",
    mai: "买 卖 麦 迈 脉 埋 霾 荬 劢",
    man: "满 慢 曼 漫 埋 蔓 瞒 蛮 鳗 馒 幔 谩 螨 熳 缦 镘 颟 墁 鞔",
    mi: "米 密 秘 迷 弥 蜜 谜 觅 靡 泌 眯 麋 猕 谧 咪 糜 宓 汨 醚 嘧 弭 脒 冖 幂 祢 縻 蘼 芈 糸 敉",
    men: "们 门 闷 瞒 汶 扪 焖 懑 鞔 钔",
    mang: "忙 盲 茫 芒 氓 莽 蟒 邙 硭 漭",
    meng: "蒙 盟 梦 猛 孟 萌 氓 朦 锰 檬 勐 懵 蟒 蜢 虻 黾 蠓 艨 甍 艋 瞢 礞",
    miao: "苗 秒 妙 描 庙 瞄 缪 渺 淼 藐 缈 邈 鹋 杪 眇 喵",
    mou: "某 谋 牟 缪 眸 哞 鍪 蛑 侔 厶",
    miu: "缪 谬",
    mei: "美 没 每 煤 梅 媒 枚 妹 眉 魅 霉 昧 媚 玫 酶 镁 湄 寐 莓 袂 楣 糜 嵋 镅 浼 猸 鹛",
    wen: "文 问 闻 稳 温 纹 吻 蚊 雯 紊 瘟 汶 韫 刎 璺 玟 阌",
    mie: "灭 蔑 篾 乜 咩 蠛",
    ming: "明 名 命 鸣 铭 冥 茗 溟 酩 瞑 螟 暝",
    na: "内 南 那 纳 拿 哪 娜 钠 呐 捺 衲 镎 肭",
    nei: "内 那 哪 馁",
    nuo: "难 诺 挪 娜 糯 懦 傩 喏 搦 锘",
    ruo: "若 弱 偌 箬",
    nang: "囊 馕 囔 曩 攮",
    nao: "脑 闹 恼 挠 瑙 淖 孬 垴 铙 桡 呶 硇 猱 蛲",
    ni: "你 尼 呢 泥 疑 拟 逆 倪 妮 腻 匿 霓 溺 旎 昵 坭 铌 鲵 伲 怩 睨 猊",
    nen: "嫩 恁",
    neng: "能",
    nin: "您 恁",
    niao: "鸟 尿 溺 袅 脲 茑 嬲",
    nie: "摄 聂 捏 涅 镍 孽 捻 蘖 啮 蹑 嗫 臬 镊 颞 乜 陧",
    niang: "娘 酿",
    ning: "宁 凝 拧 泞 柠 咛 狞 佞 聍 甯",
    nu: "努 怒 奴 弩 驽 帑 孥 胬",
    nv: "女 钕 衄 恧",
    ru: "入 如 女 乳 儒 辱 汝 茹 褥 孺 濡 蠕 嚅 缛 溽 铷 洳 薷 襦 颥 蓐",
    nuan: "暖",
    nve: "虐 疟",
    re: "热 若 惹 喏",
    ou: "区 欧 偶 殴 呕 禺 藕 讴 鸥 瓯 沤 耦 怄",
    pao: "跑 炮 泡 抛 刨 袍 咆 疱 庖 狍 匏 脬",
    pou: "剖 掊 裒",
    pen: "喷 盆 湓",
    pie: "瞥 撇 苤 氕 丿",
    pin: "品 贫 聘 频 拼 拚 颦 姘 嫔 榀 牝",
    se: "色 塞 瑟 涩 啬 穑 铯 槭",
    qing: "情 青 清 请 亲 轻 庆 倾 顷 卿 晴 氢 擎 氰 罄 磬 蜻 箐 鲭 綮 苘 黥 圊 檠 謦",
    zan: "赞 暂 攒 堑 昝 簪 糌 瓒 錾 趱 拶",
    shao: "少 绍 召 烧 稍 邵 哨 韶 捎 勺 梢 鞘 芍 苕 劭 艄 筲 杓 潲",
    sao: "扫 骚 嫂 梢 缫 搔 瘙 臊 埽 缲 鳋",
    sha: "沙 厦 杀 纱 砂 啥 莎 刹 杉 傻 煞 鲨 霎 嗄 痧 裟 挲 铩 唼 歃",
    xuan: "县 选 宣 券 旋 悬 轩 喧 玄 绚 渲 璇 炫 萱 癣 漩 眩 暄 煊 铉 楦 泫 谖 痃 碹 揎 镟 儇",
    ran: "然 染 燃 冉 苒 髯 蚺",
    rang: "让 壤 攘 嚷 瓤 穰 禳",
    rao: "绕 扰 饶 娆 桡 荛",
    reng: "仍 扔",
    ri: "日",
    rou: "肉 柔 揉 糅 鞣 蹂",
    ruan: "软 阮 朊",
    run: "润 闰",
    sa: "萨 洒 撒 飒 卅 仨 脎",
    suo: "所 些 索 缩 锁 莎 梭 琐 嗦 唆 唢 娑 蓑 羧 挲 桫 嗍 睃",
    sai: "思 赛 塞 腮 噻 鳃",
    shui: "说 水 税 谁 睡 氵",
    sang: "桑 丧 嗓 搡 颡 磉",
    sen: "森",
    seng: "僧",
    shai: "筛 晒",
    shang: "上 商 尚 伤 赏 汤 裳 墒 晌 垧 觞 殇 熵 绱",
    xing: "行 省 星 腥 猩 惺 兴 刑 型 形 邢 饧 醒 幸 杏 性 姓 陉 荇 荥 擤 悻 硎",
    shou: "收 手 受 首 售 授 守 寿 瘦 兽 狩 绶 艏 扌",
    shuo: "说 数 硕 烁 朔 铄 妁 槊 蒴 搠",
    su: "速 素 苏 诉 缩 塑 肃 俗 宿 粟 溯 酥 夙 愫 簌 稣 僳 谡 涑 蔌 嗉 觫",
    shua: "刷 耍 唰",
    shuan: "栓 拴 涮 闩",
    shun: "顺 瞬 舜 吮",
    song: "送 松 宋 讼 颂 耸 诵 嵩 淞 怂 悚 崧 凇 忪 竦 菘",
    sou: "艘 搜 擞 嗽 嗖 叟 馊 薮 飕 嗾 溲 锼 螋 瞍",
    sun: "损 孙 笋 荪 榫 隼 狲 飧",
    teng: "腾 疼 藤 滕 誊",
    tie: "铁 贴 帖 餮 萜",
    tu: "土 突 图 途 徒 涂 吐 屠 兔 秃 凸 荼 钍 菟 堍 酴",
    wai: "外 歪 崴",
    wang: "王 望 往 网 忘 亡 旺 汪 枉 妄 惘 罔 辋 魍",
    weng: "翁 嗡 瓮 蓊 蕹",
    zhua: "抓 挝 爪",
    yang: "样 养 央 阳 洋 扬 杨 羊 详 氧 仰 秧 痒 漾 疡 泱 殃 恙 鸯 徉 佯 怏 炀 烊 鞅 蛘",
    xiong: "雄 兄 熊 胸 凶 匈 汹 芎",
    yo: "哟 唷",
    yong: "用 永 拥 勇 涌 泳 庸 俑 踊 佣 咏 雍 甬 镛 臃 邕 蛹 恿 慵 壅 痈 鳙 墉 饔 喁",
    za: "杂 扎 咱 砸 咋 匝 咂 拶",
    zai: "在 再 灾 载 栽 仔 宰 哉 崽 甾",
    zao: "造 早 遭 枣 噪 灶 燥 糟 凿 躁 藻 皂 澡 蚤 唣",
    zei: "贼",
    zen: "怎 谮",
    zeng: "增 曾 综 赠 憎 锃 甑 罾 缯",
    zhei: "这",
    zou: "走 邹 奏 揍 诹 驺 陬 楱 鄹 鲰",
    zhuai: "转 拽",
    zun: "尊 遵 鳟 樽 撙",
    dia: "嗲",
    nou: "耨"
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/polish.ts
/**
 * Layout: Polish
 * Source: maciej-sielski (https://github.com/maciej-sielski)
 */
/* harmony default export */ var polish = ({
  layout: {
    default: ["\u02DB 1 2 3 4 5 6 7 8 9 0 + ' {bksp}", "q w e \u0119 r t y u i o \xF3 p", "a \u0105 s \u015B d f g h j k l \u0142", "{shift} < z \u017C \u017A x c \u0107 v b n \u0144 m , . - {shift}", ".com @ {space} {enter}"],
    shift: ["\xB7 ! \" # \xA4 % & / ( ) = ? * {bksp}", "Q W E \u0118 R T Y U I O \xD3 P", "A \u0104 S \u015A D F G H J K L \u0141", "{shift} > Z \u017B \u0179 X C \u0106 V B N \u0143 M ; : _ {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/japanese.ts
/**
 * Layout: Japanese
 */
/* harmony default export */ var japanese = ({
  layout: {
    default: ["1 2 3 4 5 6 7 8 9 0 - ^ \xA5 {bksp}", "\u305F \u3066 \u3044 \u3059 \u304B \u3093 \u306A \u306B \u3089 \u305B \u309B \u309C \u3080", "\u3061 \u3068 \u3057 \u306F \u304D \u304F \u307E \u306E \u308A \u308C \u3051", "{shift} \u3064 \u3055 \u305D \u3072 \u3053 \u307F \u3082 \u306D \u308B \u3081 {shift}", ".com @ {space} {enter}"],
    shift: ["! \" # $ % & ' ( ) \u0301 = ~ | {bksp}", "\u305F \u3066 \u3043 \u3059 \u304B \u3093 \u306A \u306B \u3089 \u305B \u300C \u300D \u3080", "\u3061 \u3068 \u3057 \u306F \u304D \u304F \u307E \u306E \u308A \u308C \u3051", "{shift} \u3063 \u3055 \u305D \u3072 \u3053 \u307F \u3082 \u3001 \u3002 \u30FB {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/hindi.ts
/**
 * Layout: Hindi
 */
/* harmony default export */ var hindi = ({
  layout: {
    default: ["` \u090D \u0945 \u094D\u0930 \u0930\u094D \u091C\u094D\u091E \u0924\u094D\u0930 \u0915\u094D\u0937 \u0936\u094D\u0930 \u096F \u0966 - \u0943 {bksp}", "\u094C \u0948 \u093E \u0940 \u0942 \u092C \u0939 \u0917 \u0926 \u091C \u0921 \u093C \u0949 \\", "\u094B \u0947 \u094D \u093F \u0941 \u092A \u0930 \u0915 \u0924 \u091A \u091F", "{shift} \u0902 \u092E \u0928 \u0935 \u0932 \u0938 , . \u092F {shift}", ".com @ {space} {enter}"],
    shift: ["~ \u0967 \u0968 \u0969 \u096A \u096B \u096C \u096D \u096E \u096F \u0966 \u0903 \u090B {bksp}", "\u0914 \u0910 \u0906 \u0908 \u090A \u092D \u0919 \u0918 \u0927 \u091D \u0922 \u091E \u0911", "\u0913 \u090F \u0905 \u0907 \u0909 \u092B \u0931 \u0916 \u0925 \u091B \u0920", "{shift} \"\" \u0901 \u0923 \u0928 \u0935 \u0933 \u0936 \u0937 \u0964 \u095F {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/french.ts
/**
 * Layout: French
 */
/* harmony default export */ var french = ({
  layout: {
    default: ["` 1 2 3 4 5 6 7 8 9 0 \xB0 + {bksp}", "a z e r t y u i o p ^ $", "q s d f g h j k l m \xF9 *", "{shift} < w x c v b n , ; : ! {shift}", ".com @ {space} {enter}"],
    shift: ["\xB2 & \xE9 \" ' ( - \xE8 _ \xE7 \xE0 ) = {bksp}", "A Z E R T Y U I O P \xA8 \xA3", "Q S D F G H J K L M % \xB5", "{shift} > W X C V B N ? . / \xA7 {shift}", ".com @ {space} {enter}"]
  }
});
// EXTERNAL MODULE: ./app/context/virtual-keyboard.context.tsx
var virtual_keyboard_context = __webpack_require__(5451);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/spanish.ts
/**
 * Layout: Spanish
 * Source: Paco Alcantara (https://github.com/pacoalcantara)
 *         Based on: http://ascii-table.com/keyboard.php/171
 *         and http://ascii-table.com/keyboard.php/071-2
 */
/* harmony default export */ var spanish = ({
  layout: {
    default: ["| 1 2 3 4 5 6 7 8 9 0 ' \xBF {bksp}", "q w e r t y u i o p \u0301 +", "a s d f g h j k l \xF1 { }", "{shift} < z x c v b n m , . - {shift}", ".com @ {space} {enter}"],
    shift: ["\xB0 ! \" # $ % & / ( ) = ? \xA1 {bksp}", "Q W E R T Y U I O P \u0308 *", "A S D F G H J K L \xD1 [ ]", "{shift} > Z X C V B N M ; : _ {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/german.ts
/**
 * Layout: German
 */
/* harmony default export */ var german = ({
  layout: {
    default: ["^ 1 2 3 4 5 6 7 8 9 0 \xDF \xB4 {bksp}", "q w e r t z u i o p \xFC +", "a s d f g h j k l \xF6 \xE4 #", "{shift} < y x c v b n m , . - {shift}", ".com @ {space} {enter}"],
    shift: ["\xB0 ! \" \xA7 $ % & / ( ) = ? ` {bksp}", "Q W E R T Z U I O P \xDC *", "A S D F G H J K L \xD6 \xC4 '", "{shift} > Y X C V B N M ; : _ {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/italian.ts
/**
 * Layout: Italian
 */
/* harmony default export */ var italian = ({
  layout: {
    default: ["\\ 1 2 3 4 5 6 7 8 9 0 ' \xEC {bksp}", "q w e r t y u i o p \xE8 +", "a s d f g h j k l \xF2 \xE0 \xF9", "{shift} < z x c v b n m , . - {shift}", ".com @ {space} {enter}"],
    shift: ["| ! \" \xA3 $ % & / ( ) = ? ^ {bksp}", "Q W E R T Y U I O P \xE9 *", "A S D F G H J K L \xE7 \xB0 \xA7", "{shift} > Z X C V B N M ; : _ {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/layouts/norwegian.ts
/**
 * Layout: Nigerian
 * Source: Benson Muite (https://github.com/bkmgit)
 */
/* harmony default export */ var norwegian = ({
  layout: {
    default: ["\xA7 1 2 3 4 5 6 7 8 9 0 + \xB4 {bksp}", "q w e r t y u i o p \xE5 \xA8", "a s d f g h j k l \xF8 \xE6 '", "{shift} < z x c v b n m , . - {shift}", ".com @ {space} {enter}"],
    shift: ["\xB0 ! \" # $ % & / ( ) = ? ` {bksp}", "Q W E R T Y U I O P \xC5 ^", "A S D F G H J K L \xD8 \xC6 *", "{shift} > Z X C V B N M ; : _ {shift}", ".com @ {space} {enter}"]
  }
});
;// CONCATENATED MODULE: ./app/components/virtual-keyboard/virtual-keyboard.component.tsx
























var localeLayouts = {
  de: german,
  en: english,
  es: spanish,
  fr: french,
  it: italian,
  ro: english,
  nl: english,
  nb: norwegian,
  pl: polish,
  pt: brazilian,
  "pt-BR": brazilian,
  ru: russian,
  se: swedish,
  ja: japanese,
  ko: korean,
  "zh-TW": chinese,
  "zh-CN": chinese,
  hi: hindi,
  ar: arabic
};
var VirtualKeyboard = function VirtualKeyboard() {
  var router = (0,next_router.useRouter)();
  var locale = router.locale !== "defaultLang" ? router.locale || "en" : "en";

  var _useVirtualKeyboardCo = (0,virtual_keyboard_context/* useVirtualKeyboardContext */.z)(),
      activeInput = _useVirtualKeyboardCo.activeInput,
      setActiveInput = _useVirtualKeyboardCo.setActiveInput;

  var _useState = (0,react.useState)("default"),
      activeLayout = _useState[0],
      setActiveLayout = _useState[1];

  var blurInputCallback = (0,react.useCallback)(function () {
    setActiveInput(null);
  }, [setActiveInput]);
  (0,go_back_hook/* useGoBackEvent */.H)("VirtualKeyboard", blurInputCallback, !!activeInput, true);
  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)(!!activeInput);

  var renderKeyCap = function renderKeyCap(key) {
    switch (key) {
      case "{shift}":
        return "\u21E7";

      case "{close}":
        return "\u2715";

      case "{enter}":
        return "\u23CE";

      case "{space}":
        return "\u2423";

      case "{bksp}":
        return "\u232B";

      default:
        return key;
    }
  };

  var setInputValue = function setInputValue(newValue) {
    if (activeInput) {
      var _Object$getOwnPropert;

      //https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js
      var nativeInputValueSetter = (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.set;
      nativeInputValueSetter === null || nativeInputValueSetter === void 0 ? void 0 : nativeInputValueSetter.call(activeInput, newValue);
      var event = new Event("input", {
        bubbles: true
      });
      activeInput.dispatchEvent(event);
    }
  };

  var handleClick = function handleClick(key) {
    return function () {
      switch (key) {
        case "{shift}":
          setActiveLayout(activeLayout === "default" ? "shift" : "default");
          break;

        case "{enter}":
          if (activeInput) {
            var form = (activeInput === null || activeInput === void 0 ? void 0 : activeInput.form) || null;

            if (form) {
              var formInputs = Array.from(form.querySelectorAll("input"));
              var inputIndex = formInputs.indexOf(activeInput);

              if (inputIndex < formInputs.length - 1) {
                setActiveInput(formInputs[inputIndex + 1]);
                setTimeout(function () {
                  formInputs[inputIndex + 1].scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                  });
                }, 100);
              } else {
                var _form$querySelector;

                setActiveInput(null);
                (_form$querySelector = form.querySelector('button[type="submit"]')) === null || _form$querySelector === void 0 ? void 0 : _form$querySelector.focus();
              }
            } else {
              setActiveInput(null);
            }
          }

          break;

        case "{space}":
          if (activeInput) {
            setInputValue("".concat(activeInput.value, " "));
          }

          break;

        case "{bksp}":
          if (activeInput) {
            setInputValue(activeInput.value.slice(0, -1));
          }

          break;

        default:
          if (activeLayout === "shift") {
            setActiveLayout("default");
          }

          if (activeInput) {
            setInputValue("".concat(activeInput.value).concat(key));
          }

      }
    };
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: !!activeInput && /*#__PURE__*/(0,jsx_runtime.jsx)(portal/* Portal */.h, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (virtual_keyboard_module_default()).wrapper,
        ref: wrapperRef,
        "data-navigate-grid": true,
        children: localeLayouts[locale].layout[activeLayout].map(function (row) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (virtual_keyboard_module_default()).row,
            "data-navigate-row": true,
            children: row.split(" ").map(function (keyCap) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (virtual_keyboard_module_default()).keycap,
                "data-navigate-item": true,
                onClick: handleClick(keyCap),
                children: renderKeyCap(keyCap)
              });
            })
          });
        })
      })
    })
  });
};
// EXTERNAL MODULE: ./node_modules/@formatjs/intl-locale/polyfill.js
var polyfill = __webpack_require__(31942);
// EXTERNAL MODULE: ./node_modules/@formatjs/intl-getcanonicallocales/polyfill.js
var intl_getcanonicallocales_polyfill = __webpack_require__(71692);
// EXTERNAL MODULE: ./app/components/station-player/vlyby-container.component.tsx
var vlyby_container_component = __webpack_require__(17812);
// EXTERNAL MODULE: ./app/hooks/navigation.hook.ts
var navigation_hook = __webpack_require__(26793);
;// CONCATENATED MODULE: ./pages/_app.tsx






function _app_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _app_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _app_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _app_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


























var queryClient = new react_query_es.QueryClient();


























function MyApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps,
      router = _ref.router;

  var _useSessionStorage = esm_useSessionStorage(navigation_hook/* HISTORY_STACK_KEY */.bj, []),
      _useSessionStorage2 = (0,slicedToArray/* default */.Z)(_useSessionStorage, 2),
      historyStack = _useSessionStorage2[0],
      setHistoryStack = _useSessionStorage2[1];

  (0,react.useEffect)(function () {
    var _document$querySelect;

    var dir = router.locale == "ar" ? "rtl" : "ltr";
    (_document$querySelect = document.querySelector("html")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.setAttribute("dir", dir);
  }, [router.locale]);

  var _useStickyState = (0,sticky_state_hook/* useStickyState */.u)(country_context/* LOCAL_STORAGE_LOCALE_OVERRIDE_KEY */.jY, null),
      _useStickyState2 = (0,slicedToArray/* default */.Z)(_useStickyState, 1),
      localeOverride = _useStickyState2[0];

  var handleRouteChange = (0,react.useCallback)(function (url) {
    var newHistoryStack = (0,toConsumableArray/* default */.Z)(historyStack);

    if (historyStack[historyStack.length - 1] !== url) {
      newHistoryStack.push(url);
    }

    setHistoryStack(newHistoryStack.slice(-3));
    pageview(url);
  }, [historyStack]);
  (0,react.useEffect)(function () {
    router.events.on("routeChangeComplete", handleRouteChange);
    router.events.on("hashChangeComplete", handleRouteChange);
    return function () {
      router.events.off("routeChangeComplete", handleRouteChange);
      router.events.off("hashChangeComplete", handleRouteChange);
    };
  }, [router.events, handleRouteChange]);
  (0,react.useEffect)(function () {
    if (window.navigator && navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var _iterator = _createForOfIteratorHelper(registrations),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var registration = _step.value;
            registration.unregister();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }, []);
  (0,react.useEffect)(function () {
    if (localeOverride !== null && router.locale !== localeOverride) {
      var pathname = router.pathname,
          asPath = router.asPath,
          query = router.query;
      router.replace({
        pathname: pathname,
        query: query
      }, asPath, {
        locale: localeOverride
      });
    }
  }, [localeOverride, router.locale]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "initial-scale=1.0, width=device-width, viewport-fit=cover"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        content: "html"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        href: "public/apple-icon-180.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "apple-mobile-web-app-capable",
        content: "yes"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2048-2732.jpg",
        media: "(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2732-2048.jpg",
        media: "(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1668-2388.jpg",
        media: "(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2388-1668.jpg",
        media: "(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1536-2048.jpg",
        media: "(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2048-1536.jpg",
        media: "(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1668-2224.jpg",
        media: "(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2224-1668.jpg",
        media: "(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1620-2160.jpg",
        media: "(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2160-1620.jpg",
        media: "(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1284-2778.jpg",
        media: "(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2778-1284.jpg",
        media: "(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1170-2532.jpg",
        media: "(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2532-1170.jpg",
        media: "(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1125-2436.jpg",
        media: "(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2436-1125.jpg",
        media: "(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1242-2688.jpg",
        media: "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2688-1242.jpg",
        media: "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-828-1792.jpg",
        media: "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1792-828.jpg",
        media: "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1242-2208.jpg",
        media: "(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-2208-1242.jpg",
        media: "(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-750-1334.jpg",
        media: "(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1334-750.jpg",
        media: "(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-640-1136.jpg",
        media: "(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-startup-image",
        href: "public/apple-splash-1136-640.jpg",
        media: "(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
      })]
    }), GA_TRACKING_ID && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        strategy: "afterInteractive",
        src: "https://www.googletagmanager.com/gtag/js?id=".concat(GA_TRACKING_ID)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        id: "gtag-init",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: "\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n          gtag('config', '".concat(GA_TRACKING_ID, "', {\n            page_path: window.location.pathname,\n          });\n          ")
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "sfbx-config",
      dangerouslySetInnerHTML: {
        __html: "\n            const configSFBXAppConsent = {\n              appKey: 'ea160580-4436-4b42-b9eb-964636634b92'\n            }\n            "
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      defer: true,
      async: true,
      src: "https://cdn.appconsent.io/tcf2-clear/current/core.bundle.js"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      src: "/consent-manager.js"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "sfbx-config",
      dangerouslySetInnerHTML: {
        __html: "\n            window.dataLayer = window.dataLayer || [];\n            if (typeof gtag === 'function') {\n              window.isGtagInitBeforeAppConsent = true\n            } else {\n              function gtag() {\n                dataLayer.push(arguments);\n              }\n            }\n            (window.adsbygoogle = window.adsbygoogle || []).pauseAdRequests = 1;\n            gtag('consent', 'default', {\n              'analytics_storage': 'denied',\n              'ad_user_data': 'denied',\n              'ad_personalization': 'denied',\n              'functionality_storage': 'denied',\n              'security_storage': 'granted',\n              'personalization_storage': 'denied',\n              'ad_storage': 'denied',\n              'wait_for_update': 500\n            });\n          "
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NextIntlProvider, {
      locale: localeOverride ? localeOverride : router.locale !== router.defaultLocale ? router.locale : "en",
      messages: messages[localeOverride ? localeOverride : router.locale !== router.defaultLocale ? router.locale : "en"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(toast_component/* ToastProvider */.VW, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_query_es.QueryClientProvider, {
          client: queryClient,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_query_es.QueryErrorResetBoundary, {
            children: function children(_ref2) {
              var reset = _ref2.reset;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
                onReset: reset,
                fallbackRender: ErrorFallback,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* Provider */.zt, {
                  store: store/* default */.ZP,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(OuterMyApp, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(auth_context/* AuthUserProvider */.s, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(features_context/* FeaturesContextProvider */.mO, {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(offline_context/* OfflineContextProvider */.dU, {
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(player_context/* PlayerContextProvider */.QM, {
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(country_context/* CountryContextProvider */.IF, {
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)(navigation_context/* NavigationContextProvider */.j$, {
                                children: /*#__PURE__*/(0,jsx_runtime.jsx)(virtual_keyboard_context/* VirtualKeyboardContextProvider */.k, {
                                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(InnerMyApp, {
                                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header, {}), /*#__PURE__*/(0,react.createElement)(Component, _app_objectSpread(_app_objectSpread({}, pageProps), {}, {
                                      key: router.route
                                    })), /*#__PURE__*/(0,jsx_runtime.jsx)(toast_component/* ToastRenderer */.Ty, {})]
                                  })
                                })
                              })
                            })
                          })
                        })
                      })
                    })
                  })
                })
              });
            }
          })
        })
      })
    }, localeOverride ? localeOverride : router.locale !== router.defaultLocale ? router.locale : "en"), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      async: true,
      defer: true,
      src: "https://play.adtonos.com/attc-3Kx24kdRpatbdYQGN.min.js"
    })]
  });
}

var OuterMyApp = function OuterMyApp(_ref3) {
  var children = _ref3.children;

  var _useAppSelector = (0,store/* useAppSelector */.CG)(app_version/* selectAppVersionState */.pu),
      version = _useAppSelector.version;

  var dispatch = (0,store/* useAppDispatch */.TL)();

  var resetAndReload = function resetAndReload() {
    dispatch(player/* playerActions.reset */.i9.reset());
    dispatch(slices_radio/* radioActions.reset */.xF.reset());
    dispatch(user/* userActions.reset */.hI.reset());
    window.location.reload();
  };

  (0,react.useEffect)(function () {
    if (version !== "1.0") {
      dispatch(player/* playerActions.reset */.i9.reset());
      dispatch(slices_radio/* radioActions.reset */.xF.reset());
    }

    dispatch(app_version/* appVersionActions.setAppVersion */.TE.setAppVersion({
      version: "1.0" || 0
    }));
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
    FallbackComponent: ErrorFallback,
    onReset: function onReset() {
      resetAndReload();
    },
    children: children
  });
};

var InnerMyApp = function InnerMyApp(props) {
  var _session$user2, _session$user4;

  var _useAppSelector2 = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector2.session;

  var _useAppSelector3 = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA),
      activeMedia = _useAppSelector3.activeMedia;

  var _useAppSelector4 = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      previouslyPlaying = _useAppSelector4.previouslyPlaying;

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      setIsMediaLoading = _usePlayerContext.setIsMediaLoading,
      setPlayerEnabled = _usePlayerContext.setPlayerEnabled,
      setIsPlaying = _usePlayerContext.setIsPlaying,
      isPlaying = _usePlayerContext.isPlaying;

  var _useState = (0,react.useState)(false),
      continuityLoaded = _useState[0],
      setContinuityLoaded = _useState[1];

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      showFooter = _useFeaturesContext.showFooter,
      arrowNavigationEnabled = _useFeaturesContext.arrowNavigationEnabled,
      customVirtualKeyboardEnabled = _useFeaturesContext.customVirtualKeyboardEnabled,
      forceAutoplay = _useFeaturesContext.forceAutoplay,
      hideScrollbars = _useFeaturesContext.hideScrollbars,
      vlybyPublisherId = _useFeaturesContext.vlybyPublisherId,
      premiumVersion = _useFeaturesContext.premiumVersion,
      isHTTPModeEnabled = _useFeaturesContext.isHTTPModeEnabled;

  (0,keyboard_navigation_hook/* useArrowKeyNavigation */.Jz)(arrowNavigationEnabled);
  var dispatch = (0,store/* useAppDispatch */.TL)();
  var networkState = (0,useNetworkState/* default */.Z)();

  var _useState2 = (0,react.useState)(false),
      slowConnectionDetected = _useState2[0],
      setSlowConnectionDetected = _useState2[1];

  var t = (0,lang/* useTranslate */.q)();
  var router = (0,next_router.useRouter)();
  var showOfflineError = (0,toast_component/* useErrorToast */.cM)({
    content: t("network.connection-lost")
  });
  var showSlowNetworkError = (0,toast_component/* useToast */.pm)({
    content: t("network.connection-slow")
  });
  var showOnlineToast = (0,toast_component/* useToast */.pm)({
    content: t("network.back-online")
  });
  (0,react.useEffect)(function () {
    if (!networkState.online) {
      showOfflineError();
    }
  }, [networkState.online]);
  (0,react.useEffect)(function () {
    if (networkState.online && networkState.previous === false) {
      showOnlineToast();
    }
  }, [networkState.online, networkState.previous]);
  (0,react.useEffect)(function () {
    if (!slowConnectionDetected && networkState.effectiveType && ["2g", "slow-2g"].includes(networkState.effectiveType)) {
      showSlowNetworkError();
      setSlowConnectionDetected(true);
    }

    if (slowConnectionDetected && networkState.effectiveType && ["4g", "3g"].includes(networkState.effectiveType)) {
      setSlowConnectionDetected(false);
    }
  }, [slowConnectionDetected, networkState.effectiveType]);
  (0,react.useEffect)(function () {
    if (forceAutoplay) {
      setPlayerEnabled(true);
    }

    setIsMediaLoading(false);
  }, [forceAutoplay]);
  (0,react.useEffect)(function () {
    if (hideScrollbars && document && document.body) {
      var _document$body$parent;

      document.body.classList.add("hide_scrollbars");
      (_document$body$parent = document.body.parentElement) === null || _document$body$parent === void 0 ? void 0 : _document$body$parent.classList.add("hide_scrollbars");
    }
  }, [hideScrollbars]);
  (0,react.useEffect)(function () {
    var _session$user;

    var fetchData = /*#__PURE__*/function () {
      var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _continuityResponse$d, _continuityResponse$d2, continuityResponse, _continuityResponse$d3, _continuityResponse$d4, _result$data$body, result, continuityCategory, _activeMedia$category, _previouslyPlaying$me, _previouslyPlaying$me2, _activeMedia$podcast, _previouslyPlaying$me3, _previouslyPlaying$me4, isDifferentThanActive, isDifferentThanDismissed, _result$data$body2, _result, _result$data$body3;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0,services/* getAccountUsersMeContinuity */.Q9)();

              case 3:
                continuityResponse = _context.sent;

                if (!((_continuityResponse$d = continuityResponse.data.body) !== null && _continuityResponse$d !== void 0 && (_continuityResponse$d2 = _continuityResponse$d.content) !== null && _continuityResponse$d2 !== void 0 && _continuityResponse$d2.listen)) {
                  _context.next = 22;
                  break;
                }

                _context.next = 7;
                return (0,services/* getPillowCategoryPath */.it)((_continuityResponse$d3 = continuityResponse.data.body) === null || _continuityResponse$d3 === void 0 ? void 0 : (_continuityResponse$d4 = _continuityResponse$d3.content) === null || _continuityResponse$d4 === void 0 ? void 0 : _continuityResponse$d4.listen, {});

              case 7:
                result = _context.sent;
                continuityCategory = (_result$data$body = result.data.body) === null || _result$data$body === void 0 ? void 0 : _result$data$body.content;

                if (!continuityCategory) {
                  _context.next = 22;
                  break;
                }

                if (!((continuityCategory === null || continuityCategory === void 0 ? void 0 : continuityCategory.type) === "radio")) {
                  _context.next = 14;
                  break;
                }

                if ((activeMedia === null || activeMedia === void 0 ? void 0 : (_activeMedia$category = activeMedia.category) === null || _activeMedia$category === void 0 ? void 0 : _activeMedia$category.permalink) !== continuityCategory.permalink && (previouslyPlaying === null || previouslyPlaying === void 0 ? void 0 : (_previouslyPlaying$me = previouslyPlaying.media) === null || _previouslyPlaying$me === void 0 ? void 0 : (_previouslyPlaying$me2 = _previouslyPlaying$me.category) === null || _previouslyPlaying$me2 === void 0 ? void 0 : _previouslyPlaying$me2.permalink) !== continuityCategory.permalink) {
                  dispatch(user/* userActions.setPreviouslyPlaying */.hI.setPreviouslyPlaying({
                    dismissed: false,
                    media: {
                      podcast: null,
                      category: continuityCategory
                    }
                  }));
                }

                _context.next = 22;
                break;

              case 14:
                if (!(continuityCategory.type === "chapter")) {
                  _context.next = 22;
                  break;
                }

                isDifferentThanActive = (activeMedia === null || activeMedia === void 0 ? void 0 : (_activeMedia$podcast = activeMedia.podcast) === null || _activeMedia$podcast === void 0 ? void 0 : _activeMedia$podcast.podcastChapter.permalink) !== continuityCategory.permalink;
                isDifferentThanDismissed = (previouslyPlaying === null || previouslyPlaying === void 0 ? void 0 : (_previouslyPlaying$me3 = previouslyPlaying.media) === null || _previouslyPlaying$me3 === void 0 ? void 0 : (_previouslyPlaying$me4 = _previouslyPlaying$me3.podcast) === null || _previouslyPlaying$me4 === void 0 ? void 0 : _previouslyPlaying$me4.podcastChapter) !== continuityCategory.permalink;

                if (!(isDifferentThanActive && isDifferentThanDismissed)) {
                  _context.next = 22;
                  break;
                }

                _context.next = 20;
                return (0,services/* getPillowCategoryPath */.it)(continuityCategory.podcastPermalink, {});

              case 20:
                _result = _context.sent;

                if ((_result$data$body2 = _result.data.body) !== null && _result$data$body2 !== void 0 && _result$data$body2.content) {
                  dispatch(user/* userActions.setPreviouslyPlaying */.hI.setPreviouslyPlaying({
                    dismissed: false,
                    media: {
                      podcast: {
                        podcast: (_result$data$body3 = _result.data.body) === null || _result$data$body3 === void 0 ? void 0 : _result$data$body3.content,
                        podcastChapter: continuityCategory
                      },
                      category: null
                    }
                  }));
                }

              case 22:
                setContinuityLoaded(true);
                _context.next = 29;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](0);
                esm_exports/* captureException */.Tb(_context.t0);
                console.error("Could not play last played item");

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 25]]);
      }));

      return function fetchData() {
        return _ref4.apply(this, arguments);
      };
    }();

    if (session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.id && !continuityLoaded) {
      fetchData();
    }
  }, [session === null || session === void 0 ? void 0 : (_session$user2 = session.user) === null || _session$user2 === void 0 ? void 0 : _session$user2.id, continuityLoaded]);
  useVirtualPlayPauseEvent(function () {
    setIsPlaying(true);
  }, function () {
    setIsPlaying(false);
  }, function () {
    setIsPlaying(!isPlaying);
  }, function () {
    setIsPlaying(false); // reset player completely

    dispatch(player/* playerActions.reset */.i9.reset());
    dispatch(slices_radio/* radioActions.reset */.xF.reset());
  }, arrowNavigationEnabled);
  (0,react.useEffect)(function () {
    if (!activeMedia) {
      clearMediaSession();
    }
  }, [activeMedia]); // HTTP mode is only allowed on the /player/[permalink] page.

  (0,react.useEffect)(function () {
    if ( true && window.location.protocol === "http:" && !router.pathname.startsWith("/player/") && isHTTPModeEnabled) {
      window.location.href = "https://".concat(window.location.host, "/"); // window.location.href = `https://localhost:3001/`; // test
    }
  }, []);

  var _useState3 = (0,react.useState)(!!vlybyPublisherId),
      enableVlyby = _useState3[0],
      setEnableVlyby = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      videoAdActive = _useState4[0],
      setVideoAdActive = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      closedAdTimeout = _useState5[0],
      setClosedAdTimeout = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isAdblockDetected = _useState6[0],
      setIsAdblockDetected = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isPageVisible = _useState7[0],
      setIsPageVisible = _useState7[1];

  var _useCountryContext = (0,country_context/* useCountryContext */.o)(),
      country = _useCountryContext.country;

  var timeoutId = (0,react.useRef)();
  var adHideTimeoutId = (0,react.useRef)();
  var getIsPageVisible = (0,react.useCallback)(function () {
    if (true) {
      return window.document.visibilityState === "visible";
    }

    return true;
  }, []);

  var closeVideoAds = function closeVideoAds() {
    stopVlybyVideoAds();
    setEnableVlyby(false);
    setClosedAdTimeout(true);
    setVideoAdActive(false);
    timeoutId.current = setTimeout(function () {
      setClosedAdTimeout(false);
      setEnableVlyby(!!vlybyPublisherId);
    }, 5 * 60000);
  };

  (0,react.useEffect)(function () {
    var onblur = function onblur() {
      setIsPageVisible(window.document.visibilityState === "visible");
    };

    var onfocus = function onfocus() {
      setIsPageVisible(window.document.visibilityState === "visible");
    };

    var onvisibilitychange = function onvisibilitychange() {
      setIsPageVisible(window.document.visibilityState === "visible");
    };

    try {
      if (true) {
        window.mainVlybyAdClosedByUser = function () {
          closeVideoAds();
          window.mainIsVlybyAdReady = false;
        };

        window.mainHideVlybyPlayer = function () {
          stopVlybyVideoAds();
          timeoutId.current = setTimeout(function () {
            setEnableVlyby(!!vlybyPublisherId);
          }, 10000);
        };

        window.mainVlybyAdReady = function () {
          window.mainIsVlybyAdReady = true;
          clearTimeout(timeoutId.current);
          clearTimeout(adHideTimeoutId.current);
          setVideoAdActive(true);
        };

        window.addEventListener("blur", onblur);
        window.addEventListener("focus", onfocus);

        if (typeof window.document.addEventListener !== "undefined") {
          window.document.addEventListener("visibilitychange", onvisibilitychange);
        }
      }
    } catch (error) {}

    return function () {
      try {
        if (true) {
          delete window.mainHideVlybyPlayer;
          delete window.mainVlybyAdReady;
          delete window.mainIsVlybyAdReady;
          window.removeEventListener("blur", onblur);
          window.removeEventListener("focus", onfocus);

          if (typeof window.document.addEventListener !== "undefined") {
            window.removeEventListener("visibilitychange", onvisibilitychange);
          }
        }

        clearTimeout(timeoutId.current);
      } catch (error) {}
    };
  }, []); // test adblock

  (0,react.useEffect)(function () {
    if (true) {
      var _window$getComputedSt;

      var adBoxEl = window.document.querySelector(".ad-box");
      var hasAdBlock = !!adBoxEl && ((_window$getComputedSt = window.getComputedStyle(adBoxEl)) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.display) === "none";
      setIsAdblockDetected(hasAdBlock);
    }
  }, []);
  var showVlyby = (0,react.useMemo)(function () {
    var _session$user3;

    return enableVlyby && getIsPageVisible() && country.countryCode !== "de" && !premiumVersion && !(session !== null && session !== void 0 && (_session$user3 = session.user) !== null && _session$user3 !== void 0 && _session$user3.premium) && !router.pathname.includes("settings") && !router.pathname.includes("log-in") && !router.pathname.includes("get-premium") && !router.pathname.includes("contact-us") && !router.pathname.includes("terms-of-use") && !router.pathname.includes("privacy-policy") && !isAdblockDetected;
  }, [enableVlyby, session === null || session === void 0 ? void 0 : (_session$user4 = session.user) === null || _session$user4 === void 0 ? void 0 : _session$user4.premium, router.pathname, isAdblockDetected, isPageVisible]);
  var activeCategory = activeMedia === null || activeMedia === void 0 ? void 0 : activeMedia.category;
  var hideTimeout = (0,react.useMemo)(function () {
    if (networkState.effectiveType) {
      if (["2g", "slow-2g"].includes(networkState.effectiveType)) {
        return 30000;
      }

      if (["3g"].includes(networkState.effectiveType)) {
        return 20000;
      }
    }

    return 10000;
  }, [networkState]);

  var stopVlybyVideoAds = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              clearTimeout(timeoutId.current);
              clearTimeout(adHideTimeoutId.current);
              setVideoAdActive(false);
              setEnableVlyby(false);
              window.mainIsVlybyAdReady = false;

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function stopVlybyVideoAds() {
      return _ref5.apply(this, arguments);
    };
  }();

  var startLoadingVlyby = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!videoAdActive && !closedAdTimeout) {
                setEnableVlyby(!!vlybyPublisherId);
                clearTimeout(timeoutId.current);
                clearTimeout(adHideTimeoutId.current);
                timeoutId.current = setTimeout(function () {
                  if (true) {
                    if (!window.mainIsVlybyAdReady) {
                      stopVlybyVideoAds();
                      adHideTimeoutId.current = setTimeout(function () {
                        setEnableVlyby(!!vlybyPublisherId);
                      }, player_context/* VLYBY_AD_ERROR_TIMEOUT */.Ld);
                    }
                  }
                }, hideTimeout);
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function startLoadingVlyby() {
      return _ref6.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (enableVlyby) {
      startLoadingVlyby();
    }
  }, [enableVlyby]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [props.children, /*#__PURE__*/(0,jsx_runtime.jsx)(PreviouslyPlayed, {}), arrowNavigationEnabled && customVirtualKeyboardEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(VirtualKeyboard, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {
      showFooter: showFooter
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "ad-box",
      style: {
        position: "fixed",
        top: 0,
        left: 0
      },
      "aria-hidden": true,
      children: "\xA0"
    }), showVlyby && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)("vlyby_container_main", {
        vlyby_mini_player_active: !!activeCategory
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "vlyby_container_main_inner",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "vlyby_container_main_content",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(vlyby_container_component/* VlybyContainer */.L, {
            width: "100%",
            height: "100%",
            variant: "floating"
          })
        })
      })
    })]
  });
};

/* harmony default export */ var _app = (MyApp);

/***/ }),

/***/ 48788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ RequestError; },
  "H": function() { return /* binding */ getAxiosInstance; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(90607);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,getPrototypeOf/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,setPrototypeOf/* default */.Z)(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./app/store/slices/user.ts
var user = __webpack_require__(38886);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
// EXTERNAL MODULE: ./app/utils/language.ts + 105 modules
var language = __webpack_require__(79490);
// EXTERNAL MODULE: ./app/utils/db.ts
var utils_db = __webpack_require__(43007);
// EXTERNAL MODULE: ./services-hooks/services.ts + 1 modules
var services = __webpack_require__(46725);
;// CONCATENATED MODULE: ./app/services/auth.service.ts





var auth_service_refreshToken = function refreshToken(_refreshToken) {
  return (0,services/* postPillowSessionV2SessionRefresh */.sM)({
    client_id: "meAyv7NWFskWa7JLubMgf3ewckHqdsKETsVaopnw",
    client_key: "HNEKMPbPyxHxdzjTzTVepWwTurnEVPsYfWYxjAtCXzgjueaavwHKmzjXPjcJcoyzEU3rWRqtMbEudyNnNwsTM4sJ9Noqbn7ujyavrFWeqqrrrxsPePagLrE4LXYWbdnX",
    refresh_token: _refreshToken
  });
};
var signIn = function signIn(deviceId) {
  console.log('signIn', deviceId);
  return (0,services/* postPillowSessionV2SessionCreate */.K2)({
    client_id: "meAyv7NWFskWa7JLubMgf3ewckHqdsKETsVaopnw",
    client_key: "HNEKMPbPyxHxdzjTzTVepWwTurnEVPsYfWYxjAtCXzgjueaavwHKmzjXPjcJcoyzEU3rWRqtMbEudyNnNwsTM4sJ9Noqbn7ujyavrFWeqqrrrxsPePagLrE4LXYWbdnX",
    device_serial: deviceId
  });
};
var signOut = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!db.isOpen()) {
              _context.next = 4;
              break;
            }

            _context.next = 4;
            return db.offlineChapters.clear();

          case 4:
            _context.next = 6;
            return postPillowSessionV2SessionLogout();

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            Sentry.captureException(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function signOut() {
    return _ref.apply(this, arguments);
  };
}()));
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./services-hooks/config.ts










function _createSuper(Derived) { var hasNativeReflectConstruct = config_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function config_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



/**
 * You can modify this file
 *
 * @version 5
 */








var shouldIntercept = function shouldIntercept(error) {
  try {
    var _error$response;

    return error.config.url !== "/Pillow/session/v2/session/refresh" && error.config.url !== "/Pillow/session/v2/session/create" && ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401;
  } catch (e) {
    return false;
  }
};

var processQueue = function processQueue(error) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  failedQueue.forEach(function (prom) {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

var handleError = function handleError(error) {
  if (error.response) {
    return Promise.reject(new RequestError(error.response.data, error.response.status, error.response));
  }

  if (error.isAxiosError) {
    return Promise.reject(new RequestError("noInternetConnection"));
  }

  return Promise.reject(error);
};

var attachTokenToRequest = function attachTokenToRequest(request, token) {
  request.headers["Authorization"] = "Bearer " + token;
};

var baseConfig = {
  baseURL: "https://web-wco4z9.api.radioline.fr",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json-patch+json"
  },
  paramsSerializer: function paramsSerializer(param) {
    return lib_default().stringify(param, {
      indices: false
    });
  }
};
var isRefreshing = false;
var failedQueue = [];
var axiosInstance;

function getAxiosInstance(security) {
  if (!axiosInstance) {
    axiosInstance = axios_default().create(baseConfig); // Response interceptor

    axiosInstance.interceptors.response.use( /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(response) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", response);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(error) {
        var state, session, deviceId, refreshToken, originalRequest, refreshTokenResponse, newAccessToken, _response, _newAccessToken, _deviceId, _response2, _newAccessToken2;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = store/* default.getState */.ZP.getState();
                session = state.user.session;
                deviceId = state.user.deviceId;
                refreshToken = session === null || session === void 0 ? void 0 : session.refresh_token.key;

                if (shouldIntercept(error)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", handleError(error));

              case 6:
                if (!(error.config._retry || error.config._queued)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", Promise.reject(error));

              case 8:
                originalRequest = error.config;

                if (!isRefreshing) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  failedQueue.push({
                    resolve: resolve,
                    reject: reject
                  });
                }).then(function (token) {
                  originalRequest._queued = true;
                  attachTokenToRequest(originalRequest, token);
                  return axiosInstance.request(originalRequest);
                }).catch(function () {
                  return handleError(error); // Ignore refresh token request's "err" and return actual "error" for the original request
                }));

              case 13:
                originalRequest._retry = true;
                isRefreshing = true;

                if (!refreshToken) {
                  _context2.next = 36;
                  break;
                }

                _context2.prev = 16;
                _context2.next = 19;
                return auth_service_refreshToken(refreshToken);

              case 19:
                refreshTokenResponse = _context2.sent;
                newAccessToken = refreshTokenResponse.data.data.access_token.key;
                attachTokenToRequest(originalRequest, newAccessToken);
                store/* default.dispatch */.ZP.dispatch(user/* userActions.setSession */.hI.setSession(refreshTokenResponse.data.data));
                processQueue(null, newAccessToken);
                return _context2.abrupt("return", axiosInstance.request(originalRequest));

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2["catch"](16);
                console.log("HANDLED", _context2.t0);
                processQueue(_context2.t0, null);
                store/* default.dispatch */.ZP.dispatch(user/* userActions.logout */.hI.logout());
                return _context2.abrupt("return", handleError(error));

              case 33:
                _context2.prev = 33;
                isRefreshing = false;
                return _context2.finish(33);

              case 36:
                if (session) {
                  _context2.next = 54;
                  break;
                }

                _context2.prev = 37;
                _context2.next = 40;
                return signIn(deviceId);

              case 40:
                _response = _context2.sent;
                store/* default.dispatch */.ZP.dispatch(user/* userActions.setSession */.hI.setSession(_response.data.data));
                _newAccessToken = _response.data.data.access_token.key;
                processQueue(null, _newAccessToken);
                _context2.next = 52;
                break;

              case 46:
                _context2.prev = 46;
                _context2.t1 = _context2["catch"](37);
                processQueue(_context2.t1, null);
                console.error(_context2.t1);
                esm_exports/* captureException */.Tb(_context2.t1);
                return _context2.abrupt("return", handleError(error));

              case 52:
                _context2.next = 74;
                break;

              case 54:
                _deviceId = state.user.deviceId;
                _context2.prev = 55;
                _context2.next = 58;
                return signIn(_deviceId);

              case 58:
                _response2 = _context2.sent;
                _newAccessToken2 = _response2.data.data.access_token.key;
                attachTokenToRequest(originalRequest, _newAccessToken2);
                store/* default.dispatch */.ZP.dispatch(user/* userActions.setSession */.hI.setSession(_response2.data.data));
                processQueue(null, _newAccessToken2);
                _context2.next = 71;
                break;

              case 65:
                _context2.prev = 65;
                _context2.t2 = _context2["catch"](55);
                console.log("HANDLED", _context2.t2);
                processQueue(_context2.t2, null);
                store/* default.dispatch */.ZP.dispatch(user/* userActions.logout */.hI.logout());
                return _context2.abrupt("return", handleError(error));

              case 71:
                _context2.prev = 71;
                isRefreshing = false;
                return _context2.finish(71);

              case 74:
                return _context2.abrupt("return", handleError(error));

              case 75:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[16, 27, 33, 36], [37, 46], [55, 65, 71, 74]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  } // ًًRequest interceptor


  axiosInstance.interceptors.request.use( /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(requestConfig) {
      var _state$user$session;

      var state;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = store/* default.getState */.ZP.getState();

              if (!requestConfig.headers) {
                requestConfig.headers = {};
              }

              if (!requestConfig.headers["X-PillowLocale"]) {
                requestConfig.headers["X-PillowLocale"] = (0,language/* getNavigatorLanguage */.BE)();
              }

              requestConfig.headers["X-Pillow-Serial"] = state.user.deviceId;

              if ((_state$user$session = state.user.session) !== null && _state$user$session !== void 0 && _state$user$session.access_token.key) {
                requestConfig.headers.authorization = "Bearer ".concat(state.user.session.access_token.key);
              }

              return _context3.abrupt("return", requestConfig);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), function (error) {
    // Do something with request error
    return Promise.reject(error);
  });
  return axiosInstance;
}

var RequestError = /*#__PURE__*/function (_Error) {
  (0,inherits/* default */.Z)(RequestError, _Error);

  var _super = _createSuper(RequestError);

  function RequestError(message, status, response) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, RequestError);

    _this = _super.call(this, message);
    _this.message = message;
    _this.status = status;
    _this.response = response;

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "isApiException", true);

    return _this;
  }

  return (0,createClass/* default */.Z)(RequestError);
}( /*#__PURE__*/_wrapNativeSuper(Error));



/***/ }),

/***/ 90413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$$": function() { return /* binding */ useDeleteAccountUsersMePresets; },
  "v": function() { return /* binding */ useDeletePillowUserV2UsersMe; },
  "_Q": function() { return /* binding */ useDeletePillowUserV2UsersMeDeezer; },
  "me": function() { return /* binding */ useDeletePillowUserV2UsersMeSpotify; },
  "Rj": function() { return /* binding */ useGetPillowAdvertisingTargetspot; },
  "jd": function() { return /* binding */ useGetPillowBillingStripeV2Price; },
  "Bs": function() { return /* binding */ useGetPillowCategoriesPath; },
  "gn": function() { return /* binding */ useGetPillowCategoryPath; },
  "Xv": function() { return /* binding */ useGetPillowListenV2ProgressChapter_id; },
  "KN": function() { return /* binding */ useGetPillowListenV2ProgressPodcast; },
  "vf": function() { return /* binding */ useGetPillowPodcastChapters; },
  "lk": function() { return /* binding */ useGetPillowPodcastchapterPlay; },
  "FM": function() { return /* binding */ useGetPillowRadio; },
  "bF": function() { return /* binding */ useGetPillowRadioHistory; },
  "pE": function() { return /* binding */ useGetPillowRadioLive; },
  "jN": function() { return /* binding */ useGetPillowRadioPlay; },
  "hz": function() { return /* binding */ useGetPillowRadioPodcasts; },
  "y2": function() { return /* binding */ useGetPillowRadioSchedulesToday; },
  "HT": function() { return /* binding */ useGetPillowSearch; },
  "GZ": function() { return /* binding */ useGetPillowSessionV2Login_code; },
  "WQ": function() { return /* binding */ useGetPillowV2Country; },
  "Ww": function() { return /* binding */ usePostAccountUsersMePresets; },
  "re": function() { return /* binding */ usePostPillowBillingStripeV2Payment_link; },
  "yF": function() { return /* binding */ usePostPillowDeezerV2DeezerTrack_addRadio_id; },
  "ZH": function() { return /* binding */ usePostPillowListenV2ProgressChapter_id; },
  "eN": function() { return /* binding */ usePostPillowSpotifyV2SpotifyTrack_addRadio_id; },
  "_Z": function() { return /* binding */ usePostPillowUserV2UsersMePassword; }
});

// UNUSED EXPORTS: useDeleteAccountUsersMePresetsOffline, useGetAccountUsersMeContinuity, useGetAccountUsersMePresets, useGetPillowCategories, useGetPillowChapterLive, useGetPillowMetadataHistorySearch, useGetPillowMetadataLiveSearch, useGetPillowPodcast, useGetPillowPodcastLatest, useGetPillowPodcastRadio, useGetPillowPodcastSimilar, useGetPillowPodcastchapter, useGetPillowRadioHistorySearch, useGetPillowRadioSimilar, useGetPillowSessionV2SessionInfo, useGetPillowSuggestTypeQuery, useGetPillowTags, useGetPillowTagsTag, useGetPillowUserV2UsersMe, useGetPillowWall, usePostAccountUsersMePresetsOffline, usePostAccountUsersMeSupport, usePostPillowAdvertisementV2Seen_coupons, usePostPillowSessionSupport, usePostPillowSessionV2Login_codeAccept, usePostPillowSessionV2SessionCreate, usePostPillowSessionV2SessionExternalAppleid, usePostPillowSessionV2SessionExternalFacebook, usePostPillowSessionV2SessionLogin_token, usePostPillowSessionV2SessionLogout, usePostPillowSessionV2SessionRefresh, usePostPillowUserV2UsersMeDeezer, usePostPillowUserV2UsersMeSpotify, usePostPillowUserV2UsersPasswordReset, usePostPillowUserV2UsersRegister, usePutAccountUsersMePresets

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
;// CONCATENATED MODULE: ./services-hooks/hooksConfig.ts


/**
 * You can modify this file
 *
 * @version 5
 */
var paginationFlattenData = function paginationFlattenData(pages) {
  return pages === null || pages === void 0 ? void 0 : pages.flatMap(function (page) {
    var _page$data, _page$data2;

    return Array.isArray(page.data) ? page.data : Array.isArray((_page$data = page.data) === null || _page$data === void 0 ? void 0 : _page$data.data) ? page.data.data : Array.isArray((_page$data2 = page.data) === null || _page$data2 === void 0 ? void 0 : _page$data2.list) ? page.data.list : [];
  });
};

var getTotal = function getTotal(pages) {
  var _pages, _pages$data;

  return pages && ((_pages = pages[pages.length - 1]) === null || _pages === void 0 ? void 0 : (_pages$data = _pages.data) === null || _pages$data === void 0 ? void 0 : _pages$data.total);
};

var getPageSize = function getPageSize(queryParams) {
  var pageSize = Object.entries(queryParams || {}).find(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        key = _ref2[0],
        _value = _ref2[1];

    if (key.toLowerCase() === "pagesize" || key.toLowerCase() === "pagenumber") {
      return true;
    }

    return false;
  });
  return (pageSize === null || pageSize === void 0 ? void 0 : pageSize[1]) || 10;
};


// EXTERNAL MODULE: ./services-hooks/services.ts + 1 modules
var services = __webpack_require__(46725);
;// CONCATENATED MODULE: ./services-hooks/hooks.ts


var _excluded = ["data", "data"],
    _excluded2 = ["data", "data"],
    _excluded3 = ["data", "data"],
    _excluded4 = ["data", "data"],
    _excluded5 = ["data", "data"],
    _excluded6 = ["data", "data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
* AUTO_GENERATED Do not change this file directly, use config.ts file instead
*
* @version 5
*/




var useHasMore = function useHasMore(pages, list, queryParams) {
  return (0,react.useMemo)(function () {
    var _paginationFlattenDat;

    if (!pages || pages && pages.length < 1) {
      return false;
    }

    var total = getTotal(pages);

    if (total !== undefined) {
      if (list && list.length < total) {
        return true;
      }

      return false;
    }

    if (((_paginationFlattenDat = paginationFlattenData([pages[pages.length - 1]])) === null || _paginationFlattenDat === void 0 ? void 0 : _paginationFlattenDat.length) === getPageSize(queryParams)) {
      return true;
    }

    return false;
  }, [pages, list, queryParams]);
};


/**
 * delete presets from user
 */

var useDeleteAccountUsersMePresets = function useDeleteAccountUsersMePresets(options, configOverride) {
  return (0,es.useMutation)(function (_ref) {
    var requestBody = _ref.requestBody,
        queryParams = _ref.queryParams;
    return (0,services/* deleteAccountUsersMePresets */.yE)(requestBody, queryParams, configOverride);
  }, options);
};
/**
 * set a preset not offline
 */

var useDeleteAccountUsersMePresetsOffline = function useDeleteAccountUsersMePresetsOffline(options, configOverride) {
  return useMutation(function (_ref2) {
    var queryParams = _ref2.queryParams;
    return deleteAccountUsersMePresetsOffline(queryParams, configOverride);
  }, options);
};
/**
 * Delete user info.
 */

var useDeletePillowUserV2UsersMe = function useDeletePillowUserV2UsersMe(options, configOverride) {
  return (0,es.useMutation)(function () {
    return (0,services/* deletePillowUserV2UsersMe */.w_)(configOverride);
  }, options);
};
/**
 * Disconnect Deezer user.
 */

var useDeletePillowUserV2UsersMeDeezer = function useDeletePillowUserV2UsersMeDeezer(options, configOverride) {
  return (0,es.useMutation)(function () {
    return (0,services/* deletePillowUserV2UsersMeDeezer */.DI)(configOverride);
  }, options);
};
/**
 * Disconnect Spotify user.
 */

var useDeletePillowUserV2UsersMeSpotify = function useDeletePillowUserV2UsersMeSpotify(options, configOverride) {
  return (0,es.useMutation)(function () {
    return (0,services/* deletePillowUserV2UsersMeSpotify */.tb)(configOverride);
  }, options);
};
/**
 * get continuity
 */

var useGetAccountUsersMeContinuity = function useGetAccountUsersMeContinuity(options, configOverride) {
  var _useGetAccountUsersMe = useGetAccountUsersMeContinuity.info(options, configOverride),
      key = _useGetAccountUsersMe.key,
      fun = _useGetAccountUsersMe.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetAccountUsersMeContinuity.info = function (options, configOverride) {
  return {
    key: [services/* getAccountUsersMeContinuity.key */.Q9.key],
    fun: function fun() {
      return (0,services/* getAccountUsersMeContinuity */.Q9)(configOverride);
    }
  };
};

useGetAccountUsersMeContinuity.prefetch = function (client, options, configOverride) {
  var _useGetAccountUsersMe2 = useGetAccountUsersMeContinuity.info(options, configOverride),
      key = _useGetAccountUsersMe2.key,
      fun = _useGetAccountUsersMe2.fun;

  return client.getQueryData([services/* getAccountUsersMeContinuity.key */.Q9.key]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get user presets
 */


var useGetAccountUsersMePresets = function useGetAccountUsersMePresets(queryParams, options, configOverride) {
  var _useGetAccountUsersMe3 = useGetAccountUsersMePresets.info(queryParams, options, configOverride),
      key = _useGetAccountUsersMe3.key,
      fun = _useGetAccountUsersMe3.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetAccountUsersMePresets.info = function (queryParams, options, configOverride) {
  return {
    key: [services/* getAccountUsersMePresets.key */.Zn.key, queryParams],
    fun: function fun(_param) {
      return (0,services/* getAccountUsersMePresets */.Zn)(queryParams, configOverride);
    }
  };
};

useGetAccountUsersMePresets.prefetch = function (client, queryParams, options, configOverride) {
  var _useGetAccountUsersMe4 = useGetAccountUsersMePresets.info(queryParams, options, configOverride),
      key = _useGetAccountUsersMe4.key,
      fun = _useGetAccountUsersMe4.fun;

  return client.getQueryData([services/* getAccountUsersMePresets.key */.Zn.key, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get Targetspot config
 */


var useGetPillowAdvertisingTargetspot = function useGetPillowAdvertisingTargetspot(options, configOverride) {
  var _useGetPillowAdvertis = useGetPillowAdvertisingTargetspot.info(options, configOverride),
      key = _useGetPillowAdvertis.key,
      fun = _useGetPillowAdvertis.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowAdvertisingTargetspot.info = function (options, configOverride) {
  return {
    key: [services/* getPillowAdvertisingTargetspot.key */.rw.key],
    fun: function fun() {
      return (0,services/* getPillowAdvertisingTargetspot */.rw)(configOverride);
    }
  };
};

useGetPillowAdvertisingTargetspot.prefetch = function (client, options, configOverride) {
  var _useGetPillowAdvertis2 = useGetPillowAdvertisingTargetspot.info(options, configOverride),
      key = _useGetPillowAdvertis2.key,
      fun = _useGetPillowAdvertis2.fun;

  return client.getQueryData([services/* getPillowAdvertisingTargetspot.key */.rw.key]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get Targetspot config
 */


var useGetPillowBillingStripeV2Price = function useGetPillowBillingStripeV2Price(options, configOverride) {
  var _useGetPillowBillingS = useGetPillowBillingStripeV2Price.info(options, configOverride),
      key = _useGetPillowBillingS.key,
      fun = _useGetPillowBillingS.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowBillingStripeV2Price.info = function (options, configOverride) {
  return {
    key: [services/* getPillowBillingStripeV2Price.key */.Wf.key],
    fun: function fun() {
      return (0,services/* getPillowBillingStripeV2Price */.Wf)(configOverride);
    }
  };
};

useGetPillowBillingStripeV2Price.prefetch = function (client, options, configOverride) {
  var _useGetPillowBillingS2 = useGetPillowBillingStripeV2Price.info(options, configOverride),
      key = _useGetPillowBillingS2.key,
      fun = _useGetPillowBillingS2.fun;

  return client.getQueryData([services/* getPillowBillingStripeV2Price.key */.Wf.key]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get the root categories
 */


var useGetPillowCategories = function useGetPillowCategories(options, configOverride) {
  var _useGetPillowCategori = useGetPillowCategories.info(options, configOverride),
      key = _useGetPillowCategori.key,
      fun = _useGetPillowCategori.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowCategories.info = function (options, configOverride) {
  return {
    key: [services/* getPillowCategories.key */._Y.key],
    fun: function fun() {
      return (0,services/* getPillowCategories */._Y)(configOverride);
    }
  };
};

useGetPillowCategories.prefetch = function (client, options, configOverride) {
  var _useGetPillowCategori2 = useGetPillowCategories.info(options, configOverride),
      key = _useGetPillowCategori2.key,
      fun = _useGetPillowCategori2.fun;

  return client.getQueryData([services/* getPillowCategories.key */._Y.key]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a path
 */


var useGetPillowCategoriesPath = function useGetPillowCategoriesPath(path, queryParams, options, configOverride) {
  var _useGetPillowCategori3 = useGetPillowCategoriesPath.info(path, queryParams, options, configOverride),
      key = _useGetPillowCategori3.key,
      fun = _useGetPillowCategori3.fun;

  var _useInfiniteQuery = (0,es.useInfiniteQuery)(key, function (_ref3) {
    var _ref3$pageParam = _ref3.pageParam,
        pageParam = _ref3$pageParam === void 0 ? 1 : _ref3$pageParam;
    return fun({
      page: pageParam
    });
  }, _objectSpread({
    getNextPageParam: function getNextPageParam(_lastPage, allPages) {
      return allPages.length + 1;
    }
  }, options)),
      _useInfiniteQuery$dat = _useInfiniteQuery.data;

  _useInfiniteQuery$dat = _useInfiniteQuery$dat === void 0 ? {} : _useInfiniteQuery$dat;

  var pages = _useInfiniteQuery$dat.pages,
      data = _useInfiniteQuery.data,
      rest = (0,objectWithoutProperties/* default */.Z)(_useInfiniteQuery, _excluded);

  var list = (0,react.useMemo)(function () {
    return paginationFlattenData(pages);
  }, [pages]);
  var hasMore = useHasMore(pages, list, queryParams);
  return _objectSpread(_objectSpread({}, rest), {}, {
    data: data,
    list: list,
    hasMore: hasMore
  });
};

useGetPillowCategoriesPath.info = function (path, queryParams, options, configOverride) {
  return {
    key: [services/* getPillowCategoriesPath.key */.Gj.key, path, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowCategoriesPath */.Gj)(path, _objectSpread(_objectSpread({}, _param), queryParams), configOverride);
    }
  };
};

useGetPillowCategoriesPath.prefetch = function (client, path, queryParams, options, configOverride) {
  var _useGetPillowCategori4 = useGetPillowCategoriesPath.info(path, queryParams, options, configOverride),
      key = _useGetPillowCategori4.key,
      fun = _useGetPillowCategori4.fun;

  return client.getQueryData([services/* getPillowCategoriesPath.key */.Gj.key, path, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a path
 */


var useGetPillowCategoryPath = function useGetPillowCategoryPath(categoryPath, queryParams, options, configOverride) {
  var _useGetPillowCategory = useGetPillowCategoryPath.info(categoryPath, queryParams, options, configOverride),
      key = _useGetPillowCategory.key,
      fun = _useGetPillowCategory.fun;

  var _useInfiniteQuery2 = (0,es.useInfiniteQuery)(key, function (_ref4) {
    var _ref4$pageParam = _ref4.pageParam,
        pageParam = _ref4$pageParam === void 0 ? 1 : _ref4$pageParam;
    return fun({
      page: pageParam
    });
  }, _objectSpread({
    getNextPageParam: function getNextPageParam(_lastPage, allPages) {
      return allPages.length + 1;
    }
  }, options)),
      _useInfiniteQuery2$da = _useInfiniteQuery2.data;

  _useInfiniteQuery2$da = _useInfiniteQuery2$da === void 0 ? {} : _useInfiniteQuery2$da;

  var pages = _useInfiniteQuery2$da.pages,
      data = _useInfiniteQuery2.data,
      rest = (0,objectWithoutProperties/* default */.Z)(_useInfiniteQuery2, _excluded2);

  var list = (0,react.useMemo)(function () {
    return paginationFlattenData(pages);
  }, [pages]);
  var hasMore = useHasMore(pages, list, queryParams);
  return _objectSpread(_objectSpread({}, rest), {}, {
    data: data,
    list: list,
    hasMore: hasMore
  });
};

useGetPillowCategoryPath.info = function (categoryPath, queryParams, options, configOverride) {
  return {
    key: [services/* getPillowCategoryPath.key */.it.key, categoryPath, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowCategoryPath */.it)(categoryPath, _objectSpread(_objectSpread({}, _param), queryParams), configOverride);
    }
  };
};

useGetPillowCategoryPath.prefetch = function (client, categoryPath, queryParams, options, configOverride) {
  var _useGetPillowCategory2 = useGetPillowCategoryPath.info(categoryPath, queryParams, options, configOverride),
      key = _useGetPillowCategory2.key,
      fun = _useGetPillowCategory2.fun;

  return client.getQueryData([services/* getPillowCategoryPath.key */.it.key, categoryPath, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a chapter track
 */


var useGetPillowChapterLive = function useGetPillowChapterLive(chapter, queryParams, options, configOverride) {
  var _useGetPillowChapterL = useGetPillowChapterLive.info(chapter, queryParams, options, configOverride),
      key = _useGetPillowChapterL.key,
      fun = _useGetPillowChapterL.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowChapterLive.info = function (chapter, queryParams, options, configOverride) {
  return {
    key: [services/* getPillowChapterLive.key */.bj.key, chapter, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowChapterLive */.bj)(chapter, queryParams, configOverride);
    }
  };
};

useGetPillowChapterLive.prefetch = function (client, chapter, queryParams, options, configOverride) {
  var _useGetPillowChapterL2 = useGetPillowChapterLive.info(chapter, queryParams, options, configOverride),
      key = _useGetPillowChapterL2.key,
      fun = _useGetPillowChapterL2.fun;

  return client.getQueryData([services/* getPillowChapterLive.key */.bj.key, chapter, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * Read chapter progress.
 */


var useGetPillowListenV2ProgressChapter_id = function useGetPillowListenV2ProgressChapter_id(chapter_id, options, configOverride) {
  var _useGetPillowListenV = useGetPillowListenV2ProgressChapter_id.info(chapter_id, options, configOverride),
      key = _useGetPillowListenV.key,
      fun = _useGetPillowListenV.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowListenV2ProgressChapter_id.info = function (chapter_id, options, configOverride) {
  return {
    key: [services/* getPillowListenV2ProgressChapter_id.key */.rk.key, chapter_id],
    fun: function fun() {
      return (0,services/* getPillowListenV2ProgressChapter_id */.rk)(chapter_id, configOverride);
    }
  };
};

useGetPillowListenV2ProgressChapter_id.prefetch = function (client, chapter_id, options, configOverride) {
  var _useGetPillowListenV2 = useGetPillowListenV2ProgressChapter_id.info(chapter_id, options, configOverride),
      key = _useGetPillowListenV2.key,
      fun = _useGetPillowListenV2.fun;

  return client.getQueryData([services/* getPillowListenV2ProgressChapter_id.key */.rk.key, chapter_id]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * Read podcast chapters progress.
 */


var useGetPillowListenV2ProgressPodcast = function useGetPillowListenV2ProgressPodcast(podcast, options, configOverride) {
  var _useGetPillowListenV3 = useGetPillowListenV2ProgressPodcast.info(podcast, options, configOverride),
      key = _useGetPillowListenV3.key,
      fun = _useGetPillowListenV3.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowListenV2ProgressPodcast.info = function (podcast, options, configOverride) {
  return {
    key: [services/* getPillowListenV2ProgressPodcast.key */.$v.key, podcast],
    fun: function fun() {
      return (0,services/* getPillowListenV2ProgressPodcast */.$v)(podcast, configOverride);
    }
  };
};

useGetPillowListenV2ProgressPodcast.prefetch = function (client, podcast, options, configOverride) {
  var _useGetPillowListenV4 = useGetPillowListenV2ProgressPodcast.info(podcast, options, configOverride),
      key = _useGetPillowListenV4.key,
      fun = _useGetPillowListenV4.fun;

  return client.getQueryData([services/* getPillowListenV2ProgressPodcast.key */.$v.key, podcast]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * find metadata in radio history
 */


var useGetPillowMetadataHistorySearch = function useGetPillowMetadataHistorySearch(queryParams, options, configOverride) {
  var _useGetPillowMetadata = useGetPillowMetadataHistorySearch.info(queryParams, options, configOverride),
      key = _useGetPillowMetadata.key,
      fun = _useGetPillowMetadata.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowMetadataHistorySearch.info = function (queryParams, options, configOverride) {
  return {
    key: [services/* getPillowMetadataHistorySearch.key */.yv.key, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowMetadataHistorySearch */.yv)(queryParams, configOverride);
    }
  };
};

useGetPillowMetadataHistorySearch.prefetch = function (client, queryParams, options, configOverride) {
  var _useGetPillowMetadata2 = useGetPillowMetadataHistorySearch.info(queryParams, options, configOverride),
      key = _useGetPillowMetadata2.key,
      fun = _useGetPillowMetadata2.fun;

  return client.getQueryData([services/* getPillowMetadataHistorySearch.key */.yv.key, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * find metadata live on radios
 */


var useGetPillowMetadataLiveSearch = function useGetPillowMetadataLiveSearch(queryParams, options, configOverride) {
  var _useGetPillowMetadata3 = useGetPillowMetadataLiveSearch.info(queryParams, options, configOverride),
      key = _useGetPillowMetadata3.key,
      fun = _useGetPillowMetadata3.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowMetadataLiveSearch.info = function (queryParams, options, configOverride) {
  return {
    key: [services/* getPillowMetadataLiveSearch.key */.du.key, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowMetadataLiveSearch */.du)(queryParams, configOverride);
    }
  };
};

useGetPillowMetadataLiveSearch.prefetch = function (client, queryParams, options, configOverride) {
  var _useGetPillowMetadata4 = useGetPillowMetadataLiveSearch.info(queryParams, options, configOverride),
      key = _useGetPillowMetadata4.key,
      fun = _useGetPillowMetadata4.fun;

  return client.getQueryData([services/* getPillowMetadataLiveSearch.key */.du.key, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a podcast
 */


var useGetPillowPodcast = function useGetPillowPodcast(podcast, options, configOverride) {
  var _useGetPillowPodcast$ = useGetPillowPodcast.info(podcast, options, configOverride),
      key = _useGetPillowPodcast$.key,
      fun = _useGetPillowPodcast$.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowPodcast.info = function (podcast, options, configOverride) {
  return {
    key: [services/* getPillowPodcast.key */.FR.key, podcast],
    fun: function fun() {
      return (0,services/* getPillowPodcast */.FR)(podcast, configOverride);
    }
  };
};

useGetPillowPodcast.prefetch = function (client, podcast, options, configOverride) {
  var _useGetPillowPodcast$2 = useGetPillowPodcast.info(podcast, options, configOverride),
      key = _useGetPillowPodcast$2.key,
      fun = _useGetPillowPodcast$2.fun;

  return client.getQueryData([services/* getPillowPodcast.key */.FR.key, podcast]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a podcast chapters
 */


var useGetPillowPodcastChapters = function useGetPillowPodcastChapters(podcast, queryParams, options, configOverride) {
  var _useGetPillowPodcastC = useGetPillowPodcastChapters.info(podcast, queryParams, options, configOverride),
      key = _useGetPillowPodcastC.key,
      fun = _useGetPillowPodcastC.fun;

  var _useInfiniteQuery3 = (0,es.useInfiniteQuery)(key, function (_ref5) {
    var _ref5$pageParam = _ref5.pageParam,
        pageParam = _ref5$pageParam === void 0 ? 1 : _ref5$pageParam;
    return fun({
      page: pageParam
    });
  }, _objectSpread({
    getNextPageParam: function getNextPageParam(_lastPage, allPages) {
      return allPages.length + 1;
    }
  }, options)),
      _useInfiniteQuery3$da = _useInfiniteQuery3.data;

  _useInfiniteQuery3$da = _useInfiniteQuery3$da === void 0 ? {} : _useInfiniteQuery3$da;

  var pages = _useInfiniteQuery3$da.pages,
      data = _useInfiniteQuery3.data,
      rest = (0,objectWithoutProperties/* default */.Z)(_useInfiniteQuery3, _excluded3);

  var list = (0,react.useMemo)(function () {
    return paginationFlattenData(pages);
  }, [pages]);
  var hasMore = useHasMore(pages, list, queryParams);
  return _objectSpread(_objectSpread({}, rest), {}, {
    data: data,
    list: list,
    hasMore: hasMore
  });
};

useGetPillowPodcastChapters.info = function (podcast, queryParams, options, configOverride) {
  return {
    key: [services/* getPillowPodcastChapters.key */.Il.key, podcast, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowPodcastChapters */.Il)(podcast, _objectSpread(_objectSpread({}, _param), queryParams), configOverride);
    }
  };
};

useGetPillowPodcastChapters.prefetch = function (client, podcast, queryParams, options, configOverride) {
  var _useGetPillowPodcastC2 = useGetPillowPodcastChapters.info(podcast, queryParams, options, configOverride),
      key = _useGetPillowPodcastC2.key,
      fun = _useGetPillowPodcastC2.fun;

  return client.getQueryData([services/* getPillowPodcastChapters.key */.Il.key, podcast, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a podcast radio
 */


var useGetPillowPodcastLatest = function useGetPillowPodcastLatest(podcast, options, configOverride) {
  var _useGetPillowPodcastL = useGetPillowPodcastLatest.info(podcast, options, configOverride),
      key = _useGetPillowPodcastL.key,
      fun = _useGetPillowPodcastL.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowPodcastLatest.info = function (podcast, options, configOverride) {
  return {
    key: [services/* getPillowPodcastLatest.key */.xt.key, podcast],
    fun: function fun() {
      return (0,services/* getPillowPodcastLatest */.xt)(podcast, configOverride);
    }
  };
};

useGetPillowPodcastLatest.prefetch = function (client, podcast, options, configOverride) {
  var _useGetPillowPodcastL2 = useGetPillowPodcastLatest.info(podcast, options, configOverride),
      key = _useGetPillowPodcastL2.key,
      fun = _useGetPillowPodcastL2.fun;

  return client.getQueryData([services/* getPillowPodcastLatest.key */.xt.key, podcast]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a podcast radio
 */


var useGetPillowPodcastRadio = function useGetPillowPodcastRadio(podcast, options, configOverride) {
  var _useGetPillowPodcastR = useGetPillowPodcastRadio.info(podcast, options, configOverride),
      key = _useGetPillowPodcastR.key,
      fun = _useGetPillowPodcastR.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowPodcastRadio.info = function (podcast, options, configOverride) {
  return {
    key: [services/* getPillowPodcastRadio.key */.rI.key, podcast],
    fun: function fun() {
      return (0,services/* getPillowPodcastRadio */.rI)(podcast, configOverride);
    }
  };
};

useGetPillowPodcastRadio.prefetch = function (client, podcast, options, configOverride) {
  var _useGetPillowPodcastR2 = useGetPillowPodcastRadio.info(podcast, options, configOverride),
      key = _useGetPillowPodcastR2.key,
      fun = _useGetPillowPodcastR2.fun;

  return client.getQueryData([services/* getPillowPodcastRadio.key */.rI.key, podcast]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a podcast radio
 */


var useGetPillowPodcastSimilar = function useGetPillowPodcastSimilar(podcast, options, configOverride) {
  var _useGetPillowPodcastS = useGetPillowPodcastSimilar.info(podcast, options, configOverride),
      key = _useGetPillowPodcastS.key,
      fun = _useGetPillowPodcastS.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowPodcastSimilar.info = function (podcast, options, configOverride) {
  return {
    key: [services/* getPillowPodcastSimilar.key */.nN.key, podcast],
    fun: function fun() {
      return (0,services/* getPillowPodcastSimilar */.nN)(podcast, configOverride);
    }
  };
};

useGetPillowPodcastSimilar.prefetch = function (client, podcast, options, configOverride) {
  var _useGetPillowPodcastS2 = useGetPillowPodcastSimilar.info(podcast, options, configOverride),
      key = _useGetPillowPodcastS2.key,
      fun = _useGetPillowPodcastS2.fun;

  return client.getQueryData([services/* getPillowPodcastSimilar.key */.nN.key, podcast]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a chapter
 */


var useGetPillowPodcastchapter = function useGetPillowPodcastchapter(podcastchapter, options, configOverride) {
  var _useGetPillowPodcastc = useGetPillowPodcastchapter.info(podcastchapter, options, configOverride),
      key = _useGetPillowPodcastc.key,
      fun = _useGetPillowPodcastc.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowPodcastchapter.info = function (podcastchapter, options, configOverride) {
  return {
    key: [services/* getPillowPodcastchapter.key */.kW.key, podcastchapter],
    fun: function fun() {
      return (0,services/* getPillowPodcastchapter */.kW)(podcastchapter, configOverride);
    }
  };
};

useGetPillowPodcastchapter.prefetch = function (client, podcastchapter, options, configOverride) {
  var _useGetPillowPodcastc2 = useGetPillowPodcastchapter.info(podcastchapter, options, configOverride),
      key = _useGetPillowPodcastc2.key,
      fun = _useGetPillowPodcastc2.fun;

  return client.getQueryData([services/* getPillowPodcastchapter.key */.kW.key, podcastchapter]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a chapter streams
 */


var useGetPillowPodcastchapterPlay = function useGetPillowPodcastchapterPlay(podcastchapter, options, configOverride) {
  var _useGetPillowPodcastc3 = useGetPillowPodcastchapterPlay.info(podcastchapter, options, configOverride),
      key = _useGetPillowPodcastc3.key,
      fun = _useGetPillowPodcastc3.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowPodcastchapterPlay.info = function (podcastchapter, options, configOverride) {
  return {
    key: [services/* getPillowPodcastchapterPlay.key */.nU.key, podcastchapter],
    fun: function fun() {
      return (0,services/* getPillowPodcastchapterPlay */.nU)(podcastchapter, configOverride);
    }
  };
};

useGetPillowPodcastchapterPlay.prefetch = function (client, podcastchapter, options, configOverride) {
  var _useGetPillowPodcastc4 = useGetPillowPodcastchapterPlay.info(podcastchapter, options, configOverride),
      key = _useGetPillowPodcastc4.key,
      fun = _useGetPillowPodcastc4.fun;

  return client.getQueryData([services/* getPillowPodcastchapterPlay.key */.nU.key, podcastchapter]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a radio
 */


var useGetPillowRadio = function useGetPillowRadio(radio, options, configOverride) {
  var _useGetPillowRadio$in = useGetPillowRadio.info(radio, options, configOverride),
      key = _useGetPillowRadio$in.key,
      fun = _useGetPillowRadio$in.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowRadio.info = function (radio, options, configOverride) {
  return {
    key: [services/* getPillowRadio.key */.O5.key, radio],
    fun: function fun() {
      return (0,services/* getPillowRadio */.O5)(radio, configOverride);
    }
  };
};

useGetPillowRadio.prefetch = function (client, radio, options, configOverride) {
  var _useGetPillowRadio$in2 = useGetPillowRadio.info(radio, options, configOverride),
      key = _useGetPillowRadio$in2.key,
      fun = _useGetPillowRadio$in2.fun;

  return client.getQueryData([services/* getPillowRadio.key */.O5.key, radio]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * Get the last 10 tracks from a given radio
 */


var useGetPillowRadioHistory = function useGetPillowRadioHistory(radio, options, configOverride) {
  var _useGetPillowRadioHis = useGetPillowRadioHistory.info(radio, options, configOverride),
      key = _useGetPillowRadioHis.key,
      fun = _useGetPillowRadioHis.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowRadioHistory.info = function (radio, options, configOverride) {
  return {
    key: [services/* getPillowRadioHistory.key */.co.key, radio],
    fun: function fun() {
      return (0,services/* getPillowRadioHistory */.co)(radio, configOverride);
    }
  };
};

useGetPillowRadioHistory.prefetch = function (client, radio, options, configOverride) {
  var _useGetPillowRadioHis2 = useGetPillowRadioHistory.info(radio, options, configOverride),
      key = _useGetPillowRadioHis2.key,
      fun = _useGetPillowRadioHis2.fun;

  return client.getQueryData([services/* getPillowRadioHistory.key */.co.key, radio]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * find metadata in radio history
 */


var useGetPillowRadioHistorySearch = function useGetPillowRadioHistorySearch(radio, queryParams, options, configOverride) {
  var _useGetPillowRadioHis3 = useGetPillowRadioHistorySearch.info(radio, queryParams, options, configOverride),
      key = _useGetPillowRadioHis3.key,
      fun = _useGetPillowRadioHis3.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowRadioHistorySearch.info = function (radio, queryParams, options, configOverride) {
  return {
    key: [services/* getPillowRadioHistorySearch.key */.m1.key, radio, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowRadioHistorySearch */.m1)(radio, queryParams, configOverride);
    }
  };
};

useGetPillowRadioHistorySearch.prefetch = function (client, radio, queryParams, options, configOverride) {
  var _useGetPillowRadioHis4 = useGetPillowRadioHistorySearch.info(radio, queryParams, options, configOverride),
      key = _useGetPillowRadioHis4.key,
      fun = _useGetPillowRadioHis4.fun;

  return client.getQueryData([services/* getPillowRadioHistorySearch.key */.m1.key, radio, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * the current state hash of the radio
 */


var useGetPillowRadioLive = function useGetPillowRadioLive(radio, queryParams, options, configOverride) {
  var _useGetPillowRadioLiv = useGetPillowRadioLive.info(radio, queryParams, options, configOverride),
      key = _useGetPillowRadioLiv.key,
      fun = _useGetPillowRadioLiv.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowRadioLive.info = function (radio, queryParams, options, configOverride) {
  return {
    key: [services/* getPillowRadioLive.key */.Lg.key, radio, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowRadioLive */.Lg)(radio, queryParams, configOverride);
    }
  };
};

useGetPillowRadioLive.prefetch = function (client, radio, queryParams, options, configOverride) {
  var _useGetPillowRadioLiv2 = useGetPillowRadioLive.info(radio, queryParams, options, configOverride),
      key = _useGetPillowRadioLiv2.key,
      fun = _useGetPillowRadioLiv2.fun;

  return client.getQueryData([services/* getPillowRadioLive.key */.Lg.key, radio, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get the streams of a radio
 */


var useGetPillowRadioPlay = function useGetPillowRadioPlay(radio, options, configOverride) {
  var _useGetPillowRadioPla = useGetPillowRadioPlay.info(radio, options, configOverride),
      key = _useGetPillowRadioPla.key,
      fun = _useGetPillowRadioPla.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowRadioPlay.info = function (radio, options, configOverride) {
  return {
    key: [services/* getPillowRadioPlay.key */.t8.key, radio],
    fun: function fun() {
      return (0,services/* getPillowRadioPlay */.t8)(radio, configOverride);
    }
  };
};

useGetPillowRadioPlay.prefetch = function (client, radio, options, configOverride) {
  var _useGetPillowRadioPla2 = useGetPillowRadioPlay.info(radio, options, configOverride),
      key = _useGetPillowRadioPla2.key,
      fun = _useGetPillowRadioPla2.fun;

  return client.getQueryData([services/* getPillowRadioPlay.key */.t8.key, radio]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get the podcasts of a radio
 */


var useGetPillowRadioPodcasts = function useGetPillowRadioPodcasts(radio, queryParams, options, configOverride) {
  var _useGetPillowRadioPod = useGetPillowRadioPodcasts.info(radio, queryParams, options, configOverride),
      key = _useGetPillowRadioPod.key,
      fun = _useGetPillowRadioPod.fun;

  var _useInfiniteQuery4 = (0,es.useInfiniteQuery)(key, function (_ref6) {
    var _ref6$pageParam = _ref6.pageParam,
        pageParam = _ref6$pageParam === void 0 ? 1 : _ref6$pageParam;
    return fun({
      page: pageParam
    });
  }, _objectSpread({
    getNextPageParam: function getNextPageParam(_lastPage, allPages) {
      return allPages.length + 1;
    }
  }, options)),
      _useInfiniteQuery4$da = _useInfiniteQuery4.data;

  _useInfiniteQuery4$da = _useInfiniteQuery4$da === void 0 ? {} : _useInfiniteQuery4$da;

  var pages = _useInfiniteQuery4$da.pages,
      data = _useInfiniteQuery4.data,
      rest = (0,objectWithoutProperties/* default */.Z)(_useInfiniteQuery4, _excluded4);

  var list = (0,react.useMemo)(function () {
    return paginationFlattenData(pages);
  }, [pages]);
  var hasMore = useHasMore(pages, list, queryParams);
  return _objectSpread(_objectSpread({}, rest), {}, {
    data: data,
    list: list,
    hasMore: hasMore
  });
};

useGetPillowRadioPodcasts.info = function (radio, queryParams, options, configOverride) {
  return {
    key: [services/* getPillowRadioPodcasts.key */.Fu.key, radio, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowRadioPodcasts */.Fu)(radio, _objectSpread(_objectSpread({}, _param), queryParams), configOverride);
    }
  };
};

useGetPillowRadioPodcasts.prefetch = function (client, radio, queryParams, options, configOverride) {
  var _useGetPillowRadioPod2 = useGetPillowRadioPodcasts.info(radio, queryParams, options, configOverride),
      key = _useGetPillowRadioPod2.key,
      fun = _useGetPillowRadioPod2.fun;

  return client.getQueryData([services/* getPillowRadioPodcasts.key */.Fu.key, radio, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get radio's schedule for today
 */


var useGetPillowRadioSchedulesToday = function useGetPillowRadioSchedulesToday(radio, queryParams, options, configOverride) {
  var _useGetPillowRadioSch = useGetPillowRadioSchedulesToday.info(radio, queryParams, options, configOverride),
      key = _useGetPillowRadioSch.key,
      fun = _useGetPillowRadioSch.fun;

  var _useInfiniteQuery5 = (0,es.useInfiniteQuery)(key, function (_ref7) {
    var _ref7$pageParam = _ref7.pageParam,
        pageParam = _ref7$pageParam === void 0 ? 1 : _ref7$pageParam;
    return fun({
      page: pageParam
    });
  }, _objectSpread({
    getNextPageParam: function getNextPageParam(_lastPage, allPages) {
      return allPages.length + 1;
    }
  }, options)),
      _useInfiniteQuery5$da = _useInfiniteQuery5.data;

  _useInfiniteQuery5$da = _useInfiniteQuery5$da === void 0 ? {} : _useInfiniteQuery5$da;

  var pages = _useInfiniteQuery5$da.pages,
      data = _useInfiniteQuery5.data,
      rest = (0,objectWithoutProperties/* default */.Z)(_useInfiniteQuery5, _excluded5);

  var list = (0,react.useMemo)(function () {
    return paginationFlattenData(pages);
  }, [pages]);
  var hasMore = useHasMore(pages, list, queryParams);
  return _objectSpread(_objectSpread({}, rest), {}, {
    data: data,
    list: list,
    hasMore: hasMore
  });
};

useGetPillowRadioSchedulesToday.info = function (radio, queryParams, options, configOverride) {
  return {
    key: [services/* getPillowRadioSchedulesToday.key */.kO.key, radio, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowRadioSchedulesToday */.kO)(radio, _objectSpread(_objectSpread({}, _param), queryParams), configOverride);
    }
  };
};

useGetPillowRadioSchedulesToday.prefetch = function (client, radio, queryParams, options, configOverride) {
  var _useGetPillowRadioSch2 = useGetPillowRadioSchedulesToday.info(radio, queryParams, options, configOverride),
      key = _useGetPillowRadioSch2.key,
      fun = _useGetPillowRadioSch2.fun;

  return client.getQueryData([services/* getPillowRadioSchedulesToday.key */.kO.key, radio, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a podcast radio
 */


var useGetPillowRadioSimilar = function useGetPillowRadioSimilar(radio, options, configOverride) {
  var _useGetPillowRadioSim = useGetPillowRadioSimilar.info(radio, options, configOverride),
      key = _useGetPillowRadioSim.key,
      fun = _useGetPillowRadioSim.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowRadioSimilar.info = function (radio, options, configOverride) {
  return {
    key: [services/* getPillowRadioSimilar.key */.w5.key, radio],
    fun: function fun() {
      return (0,services/* getPillowRadioSimilar */.w5)(radio, configOverride);
    }
  };
};

useGetPillowRadioSimilar.prefetch = function (client, radio, options, configOverride) {
  var _useGetPillowRadioSim2 = useGetPillowRadioSimilar.info(radio, options, configOverride),
      key = _useGetPillowRadioSim2.key,
      fun = _useGetPillowRadioSim2.fun;

  return client.getQueryData([services/* getPillowRadioSimilar.key */.w5.key, radio]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * Search or filter radios and podcasts
 */


var useGetPillowSearch = function useGetPillowSearch(queryParams, options, configOverride) {
  var _useGetPillowSearch$i = useGetPillowSearch.info(queryParams, options, configOverride),
      key = _useGetPillowSearch$i.key,
      fun = _useGetPillowSearch$i.fun;

  var _useInfiniteQuery6 = (0,es.useInfiniteQuery)(key, function (_ref8) {
    var _ref8$pageParam = _ref8.pageParam,
        pageParam = _ref8$pageParam === void 0 ? 1 : _ref8$pageParam;
    return fun({
      page: pageParam
    });
  }, _objectSpread({
    getNextPageParam: function getNextPageParam(_lastPage, allPages) {
      return allPages.length + 1;
    }
  }, options)),
      _useInfiniteQuery6$da = _useInfiniteQuery6.data;

  _useInfiniteQuery6$da = _useInfiniteQuery6$da === void 0 ? {} : _useInfiniteQuery6$da;

  var pages = _useInfiniteQuery6$da.pages,
      data = _useInfiniteQuery6.data,
      rest = (0,objectWithoutProperties/* default */.Z)(_useInfiniteQuery6, _excluded6);

  var list = (0,react.useMemo)(function () {
    return paginationFlattenData(pages);
  }, [pages]);
  var hasMore = useHasMore(pages, list, queryParams);
  return _objectSpread(_objectSpread({}, rest), {}, {
    data: data,
    list: list,
    hasMore: hasMore
  });
};

useGetPillowSearch.info = function (queryParams, options, configOverride) {
  return {
    key: [services/* getPillowSearch.key */.wi.key, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowSearch */.wi)(_objectSpread(_objectSpread({}, _param), queryParams), configOverride);
    }
  };
};

useGetPillowSearch.prefetch = function (client, queryParams, options, configOverride) {
  var _useGetPillowSearch$i2 = useGetPillowSearch.info(queryParams, options, configOverride),
      key = _useGetPillowSearch$i2.key,
      fun = _useGetPillowSearch$i2.fun;

  return client.getQueryData([services/* getPillowSearch.key */.wi.key, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * Get login code for display in device and check it's status.
 */


var useGetPillowSessionV2Login_code = function useGetPillowSessionV2Login_code(options, configOverride) {
  var _useGetPillowSessionV = useGetPillowSessionV2Login_code.info(options, configOverride),
      key = _useGetPillowSessionV.key,
      fun = _useGetPillowSessionV.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowSessionV2Login_code.info = function (options, configOverride) {
  return {
    key: [services/* getPillowSessionV2Login_code.key */.gR.key],
    fun: function fun() {
      return (0,services/* getPillowSessionV2Login_code */.gR)(configOverride);
    }
  };
};

useGetPillowSessionV2Login_code.prefetch = function (client, options, configOverride) {
  var _useGetPillowSessionV2 = useGetPillowSessionV2Login_code.info(options, configOverride),
      key = _useGetPillowSessionV2.key,
      fun = _useGetPillowSessionV2.fun;

  return client.getQueryData([services/* getPillowSessionV2Login_code.key */.gR.key]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * Session info.
 */


var useGetPillowSessionV2SessionInfo = function useGetPillowSessionV2SessionInfo(options, configOverride) {
  var _useGetPillowSessionV3 = useGetPillowSessionV2SessionInfo.info(options, configOverride),
      key = _useGetPillowSessionV3.key,
      fun = _useGetPillowSessionV3.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowSessionV2SessionInfo.info = function (options, configOverride) {
  return {
    key: [services/* getPillowSessionV2SessionInfo.key */.eE.key],
    fun: function fun() {
      return (0,services/* getPillowSessionV2SessionInfo */.eE)(configOverride);
    }
  };
};

useGetPillowSessionV2SessionInfo.prefetch = function (client, options, configOverride) {
  var _useGetPillowSessionV4 = useGetPillowSessionV2SessionInfo.info(options, configOverride),
      key = _useGetPillowSessionV4.key,
      fun = _useGetPillowSessionV4.fun;

  return client.getQueryData([services/* getPillowSessionV2SessionInfo.key */.eE.key]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};

var useGetPillowSuggestTypeQuery = function useGetPillowSuggestTypeQuery(type, query, options, configOverride) {
  var _useGetPillowSuggestT = useGetPillowSuggestTypeQuery.info(type, query, options, configOverride),
      key = _useGetPillowSuggestT.key,
      fun = _useGetPillowSuggestT.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowSuggestTypeQuery.info = function (type, query, options, configOverride) {
  return {
    key: [services/* getPillowSuggestTypeQuery.key */.MV.key, type, query],
    fun: function fun() {
      return (0,services/* getPillowSuggestTypeQuery */.MV)(type, query, configOverride);
    }
  };
};

useGetPillowSuggestTypeQuery.prefetch = function (client, type, query, options, configOverride) {
  var _useGetPillowSuggestT2 = useGetPillowSuggestTypeQuery.info(type, query, options, configOverride),
      key = _useGetPillowSuggestT2.key,
      fun = _useGetPillowSuggestT2.fun;

  return client.getQueryData([services/* getPillowSuggestTypeQuery.key */.MV.key, type, query]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get all tag of a type
 */


var useGetPillowTags = function useGetPillowTags(queryParams, options, configOverride) {
  var _useGetPillowTags$inf = useGetPillowTags.info(queryParams, options, configOverride),
      key = _useGetPillowTags$inf.key,
      fun = _useGetPillowTags$inf.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowTags.info = function (queryParams, options, configOverride) {
  return {
    key: [services/* getPillowTags.key */.O4.key, queryParams],
    fun: function fun(_param) {
      return (0,services/* getPillowTags */.O4)(queryParams, configOverride);
    }
  };
};

useGetPillowTags.prefetch = function (client, queryParams, options, configOverride) {
  var _useGetPillowTags$inf2 = useGetPillowTags.info(queryParams, options, configOverride),
      key = _useGetPillowTags$inf2.key,
      fun = _useGetPillowTags$inf2.fun;

  return client.getQueryData([services/* getPillowTags.key */.O4.key, queryParams]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get a tag
 */


var useGetPillowTagsTag = function useGetPillowTagsTag(tag, options, configOverride) {
  var _useGetPillowTagsTag$ = useGetPillowTagsTag.info(tag, options, configOverride),
      key = _useGetPillowTagsTag$.key,
      fun = _useGetPillowTagsTag$.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowTagsTag.info = function (tag, options, configOverride) {
  return {
    key: [services/* getPillowTagsTag.key */.G4.key, tag],
    fun: function fun() {
      return (0,services/* getPillowTagsTag */.G4)(tag, configOverride);
    }
  };
};

useGetPillowTagsTag.prefetch = function (client, tag, options, configOverride) {
  var _useGetPillowTagsTag$2 = useGetPillowTagsTag.info(tag, options, configOverride),
      key = _useGetPillowTagsTag$2.key,
      fun = _useGetPillowTagsTag$2.fun;

  return client.getQueryData([services/* getPillowTagsTag.key */.G4.key, tag]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * Read user info.
 */


var useGetPillowUserV2UsersMe = function useGetPillowUserV2UsersMe(options, configOverride) {
  var _useGetPillowUserV2Us = useGetPillowUserV2UsersMe.info(options, configOverride),
      key = _useGetPillowUserV2Us.key,
      fun = _useGetPillowUserV2Us.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowUserV2UsersMe.info = function (options, configOverride) {
  return {
    key: [services/* getPillowUserV2UsersMe.key */.Zj.key],
    fun: function fun() {
      return (0,services/* getPillowUserV2UsersMe */.Zj)(configOverride);
    }
  };
};

useGetPillowUserV2UsersMe.prefetch = function (client, options, configOverride) {
  var _useGetPillowUserV2Us2 = useGetPillowUserV2UsersMe.info(options, configOverride),
      key = _useGetPillowUserV2Us2.key,
      fun = _useGetPillowUserV2Us2.fun;

  return client.getQueryData([services/* getPillowUserV2UsersMe.key */.Zj.key]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get your IP's country code, WARNING it can be empty string
 */


var useGetPillowV2Country = function useGetPillowV2Country(options, configOverride) {
  var _useGetPillowV2Countr = useGetPillowV2Country.info(options, configOverride),
      key = _useGetPillowV2Countr.key,
      fun = _useGetPillowV2Countr.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowV2Country.info = function (options, configOverride) {
  return {
    key: [services/* getPillowV2Country.key */.Xb.key],
    fun: function fun() {
      return (0,services/* getPillowV2Country */.Xb)(configOverride);
    }
  };
};

useGetPillowV2Country.prefetch = function (client, options, configOverride) {
  var _useGetPillowV2Countr2 = useGetPillowV2Country.info(options, configOverride),
      key = _useGetPillowV2Countr2.key,
      fun = _useGetPillowV2Countr2.fun;

  return client.getQueryData([services/* getPillowV2Country.key */.Xb.key]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * get live wall
 */


var useGetPillowWall = function useGetPillowWall(options, configOverride) {
  var _useGetPillowWall$inf = useGetPillowWall.info(options, configOverride),
      key = _useGetPillowWall$inf.key,
      fun = _useGetPillowWall$inf.fun;

  return (0,es.useQuery)(key, function () {
    return fun();
  }, options);
};

useGetPillowWall.info = function (options, configOverride) {
  return {
    key: [services/* getPillowWall.key */.a2.key],
    fun: function fun() {
      return (0,services/* getPillowWall */.a2)(configOverride);
    }
  };
};

useGetPillowWall.prefetch = function (client, options, configOverride) {
  var _useGetPillowWall$inf2 = useGetPillowWall.info(options, configOverride),
      key = _useGetPillowWall$inf2.key,
      fun = _useGetPillowWall$inf2.fun;

  return client.getQueryData([services/* getPillowWall.key */.a2.key]) ? Promise.resolve() : client.prefetchQuery(key, function () {
    return fun();
  }, options);
};
/**
 * add presets to user
 */


var usePostAccountUsersMePresets = function usePostAccountUsersMePresets(options, configOverride) {
  return (0,es.useMutation)(function (_ref9) {
    var requestBody = _ref9.requestBody,
        queryParams = _ref9.queryParams;
    return (0,services/* postAccountUsersMePresets */.Jj)(requestBody, queryParams, configOverride);
  }, options);
};
/**
 * set a preset offline property
 */

var usePostAccountUsersMePresetsOffline = function usePostAccountUsersMePresetsOffline(options, configOverride) {
  return useMutation(function (_ref10) {
    var requestBody = _ref10.requestBody,
        queryParams = _ref10.queryParams;
    return postAccountUsersMePresetsOffline(requestBody, queryParams, configOverride);
  }, options);
};
var usePostAccountUsersMeSupport = function usePostAccountUsersMeSupport(options, configOverride) {
  return useMutation(function (_ref11) {
    var requestBody = _ref11.requestBody;
    return postAccountUsersMeSupport(requestBody, configOverride);
  }, options);
};
/**
 * Create seen coupon. Send email to the user.
 */

var usePostPillowAdvertisementV2Seen_coupons = function usePostPillowAdvertisementV2Seen_coupons(options, configOverride) {
  return useMutation(function (_ref12) {
    var requestBody = _ref12.requestBody;
    return postPillowAdvertisementV2Seen_coupons(requestBody, configOverride);
  }, options);
};
/**
 * Create payment link for logged in user.
 */

var usePostPillowBillingStripeV2Payment_link = function usePostPillowBillingStripeV2Payment_link(options, configOverride) {
  return (0,es.useMutation)(function (_ref13) {
    var requestBody = _ref13.requestBody;
    return (0,services/* postPillowBillingStripeV2Payment_link */.Z_)(requestBody, configOverride);
  }, options);
};
/**
 * Add to Deezer playlist track currently played in radio.
 */

var usePostPillowDeezerV2DeezerTrack_addRadio_id = function usePostPillowDeezerV2DeezerTrack_addRadio_id(options, configOverride) {
  return (0,es.useMutation)(function (_ref14) {
    var radio_id = _ref14.radio_id;
    return (0,services/* postPillowDeezerV2DeezerTrack_addRadio_id */.Vp)(radio_id, configOverride);
  }, options);
};
/**
 * Update chapter progress.
 */

var usePostPillowListenV2ProgressChapter_id = function usePostPillowListenV2ProgressChapter_id(options, configOverride) {
  return (0,es.useMutation)(function (_ref15) {
    var chapter_id = _ref15.chapter_id,
        requestBody = _ref15.requestBody;
    return (0,services/* postPillowListenV2ProgressChapter_id */.Ij)(chapter_id, requestBody, configOverride);
  }, options);
};
var usePostPillowSessionSupport = function usePostPillowSessionSupport(options, configOverride) {
  return useMutation(function (_ref16) {
    var requestBody = _ref16.requestBody;
    return postPillowSessionSupport(requestBody, configOverride);
  }, options);
};
/**
 * Accept login code.
 */

var usePostPillowSessionV2Login_codeAccept = function usePostPillowSessionV2Login_codeAccept(options, configOverride) {
  return useMutation(function (_ref17) {
    var requestBody = _ref17.requestBody;
    return postPillowSessionV2Login_codeAccept(requestBody, configOverride);
  }, options);
};
/**
 * Create session and obtain access token.
 */

var usePostPillowSessionV2SessionCreate = function usePostPillowSessionV2SessionCreate(options, configOverride) {
  return useMutation(function (_ref18) {
    var requestBody = _ref18.requestBody;
    return postPillowSessionV2SessionCreate(requestBody, configOverride);
  }, options);
};
/**
 * Login with Apple ID.
 */

var usePostPillowSessionV2SessionExternalAppleid = function usePostPillowSessionV2SessionExternalAppleid(options, configOverride) {
  return useMutation(function (_ref19) {
    var requestBody = _ref19.requestBody;
    return postPillowSessionV2SessionExternalAppleid(requestBody, configOverride);
  }, options);
};
/**
 * Login with Facebook.
 */

var usePostPillowSessionV2SessionExternalFacebook = function usePostPillowSessionV2SessionExternalFacebook(options, configOverride) {
  return useMutation(function (_ref20) {
    var requestBody = _ref20.requestBody;
    return postPillowSessionV2SessionExternalFacebook(requestBody, configOverride);
  }, options);
};
/**
 * Login with token.
 */

var usePostPillowSessionV2SessionLogin_token = function usePostPillowSessionV2SessionLogin_token(options, configOverride) {
  return useMutation(function (_ref21) {
    var requestBody = _ref21.requestBody;
    return postPillowSessionV2SessionLogin_token(requestBody, configOverride);
  }, options);
};
/**
 * Logout session.
 */

var usePostPillowSessionV2SessionLogout = function usePostPillowSessionV2SessionLogout(options, configOverride) {
  return useMutation(function () {
    return postPillowSessionV2SessionLogout(configOverride);
  }, options);
};
/**
 * Session refresh.
 */

var usePostPillowSessionV2SessionRefresh = function usePostPillowSessionV2SessionRefresh(options, configOverride) {
  return useMutation(function (_ref22) {
    var requestBody = _ref22.requestBody;
    return postPillowSessionV2SessionRefresh(requestBody, configOverride);
  }, options);
};
/**
 * Add to Spotify playlist track currently played in radio.
 */

var usePostPillowSpotifyV2SpotifyTrack_addRadio_id = function usePostPillowSpotifyV2SpotifyTrack_addRadio_id(options, configOverride) {
  return (0,es.useMutation)(function (_ref23) {
    var radio_id = _ref23.radio_id;
    return (0,services/* postPillowSpotifyV2SpotifyTrack_addRadio_id */.Gr)(radio_id, configOverride);
  }, options);
};
/**
 * Connect Deezer user.
 */

var usePostPillowUserV2UsersMeDeezer = function usePostPillowUserV2UsersMeDeezer(options, configOverride) {
  return useMutation(function (_ref24) {
    var requestBody = _ref24.requestBody;
    return postPillowUserV2UsersMeDeezer(requestBody, configOverride);
  }, options);
};
/**
 * Change logged-in user password.
 */

var usePostPillowUserV2UsersMePassword = function usePostPillowUserV2UsersMePassword(options, configOverride) {
  return (0,es.useMutation)(function (_ref25) {
    var requestBody = _ref25.requestBody;
    return (0,services/* postPillowUserV2UsersMePassword */.Rh)(requestBody, configOverride);
  }, options);
};
/**
 * Connect spotify user.
 */

var usePostPillowUserV2UsersMeSpotify = function usePostPillowUserV2UsersMeSpotify(options, configOverride) {
  return useMutation(function (_ref26) {
    var requestBody = _ref26.requestBody;
    return postPillowUserV2UsersMeSpotify(requestBody, configOverride);
  }, options);
};
/**
 * Password reset.
 */

var usePostPillowUserV2UsersPasswordReset = function usePostPillowUserV2UsersPasswordReset(options, configOverride) {
  return useMutation(function (_ref27) {
    var requestBody = _ref27.requestBody;
    return postPillowUserV2UsersPasswordReset(requestBody, configOverride);
  }, options);
};
/**
 * Register user.
 */

var usePostPillowUserV2UsersRegister = function usePostPillowUserV2UsersRegister(options, configOverride) {
  return useMutation(function (_ref28) {
    var requestBody = _ref28.requestBody;
    return postPillowUserV2UsersRegister(requestBody, configOverride);
  }, options);
};
/**
 * set list of presets of the user
 */

var usePutAccountUsersMePresets = function usePutAccountUsersMePresets(options, configOverride) {
  return useMutation(function (_ref29) {
    var requestBody = _ref29.requestBody,
        queryParams = _ref29.queryParams;
    return putAccountUsersMePresets(requestBody, queryParams, configOverride);
  }, options);
};

/***/ }),

/***/ 46725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yE": function() { return /* binding */ deleteAccountUsersMePresets; },
  "w_": function() { return /* binding */ deletePillowUserV2UsersMe; },
  "DI": function() { return /* binding */ deletePillowUserV2UsersMeDeezer; },
  "tb": function() { return /* binding */ deletePillowUserV2UsersMeSpotify; },
  "Q9": function() { return /* binding */ getAccountUsersMeContinuity; },
  "Zn": function() { return /* binding */ getAccountUsersMePresets; },
  "rw": function() { return /* binding */ getPillowAdvertisingTargetspot; },
  "Wf": function() { return /* binding */ getPillowBillingStripeV2Price; },
  "_Y": function() { return /* binding */ getPillowCategories; },
  "Gj": function() { return /* binding */ getPillowCategoriesPath; },
  "it": function() { return /* binding */ getPillowCategoryPath; },
  "bj": function() { return /* binding */ getPillowChapterLive; },
  "rk": function() { return /* binding */ getPillowListenV2ProgressChapter_id; },
  "$v": function() { return /* binding */ getPillowListenV2ProgressPodcast; },
  "yv": function() { return /* binding */ getPillowMetadataHistorySearch; },
  "du": function() { return /* binding */ getPillowMetadataLiveSearch; },
  "FR": function() { return /* binding */ getPillowPodcast; },
  "Il": function() { return /* binding */ getPillowPodcastChapters; },
  "xt": function() { return /* binding */ getPillowPodcastLatest; },
  "rI": function() { return /* binding */ getPillowPodcastRadio; },
  "nN": function() { return /* binding */ getPillowPodcastSimilar; },
  "kW": function() { return /* binding */ getPillowPodcastchapter; },
  "nU": function() { return /* binding */ getPillowPodcastchapterPlay; },
  "O5": function() { return /* binding */ getPillowRadio; },
  "co": function() { return /* binding */ getPillowRadioHistory; },
  "m1": function() { return /* binding */ getPillowRadioHistorySearch; },
  "Lg": function() { return /* binding */ getPillowRadioLive; },
  "t8": function() { return /* binding */ getPillowRadioPlay; },
  "Fu": function() { return /* binding */ getPillowRadioPodcasts; },
  "kO": function() { return /* binding */ getPillowRadioSchedulesToday; },
  "w5": function() { return /* binding */ getPillowRadioSimilar; },
  "wi": function() { return /* binding */ getPillowSearch; },
  "gR": function() { return /* binding */ getPillowSessionV2Login_code; },
  "eE": function() { return /* binding */ getPillowSessionV2SessionInfo; },
  "MV": function() { return /* binding */ getPillowSuggestTypeQuery; },
  "O4": function() { return /* binding */ getPillowTags; },
  "G4": function() { return /* binding */ getPillowTagsTag; },
  "Zj": function() { return /* binding */ getPillowUserV2UsersMe; },
  "Xb": function() { return /* binding */ getPillowV2Country; },
  "a2": function() { return /* binding */ getPillowWall; },
  "Jj": function() { return /* binding */ postAccountUsersMePresets; },
  "Pv": function() { return /* binding */ postAccountUsersMeSupport; },
  "Z_": function() { return /* binding */ postPillowBillingStripeV2Payment_link; },
  "Vp": function() { return /* binding */ postPillowDeezerV2DeezerTrack_addRadio_id; },
  "Ij": function() { return /* binding */ postPillowListenV2ProgressChapter_id; },
  "AD": function() { return /* binding */ postPillowSessionSupport; },
  "is": function() { return /* binding */ postPillowSessionV2Login_codeAccept; },
  "K2": function() { return /* binding */ postPillowSessionV2SessionCreate; },
  "xR": function() { return /* binding */ postPillowSessionV2SessionExternalFacebook; },
  "BT": function() { return /* binding */ postPillowSessionV2SessionLogin_token; },
  "Qf": function() { return /* binding */ postPillowSessionV2SessionLogout; },
  "sM": function() { return /* binding */ postPillowSessionV2SessionRefresh; },
  "Gr": function() { return /* binding */ postPillowSpotifyV2SpotifyTrack_addRadio_id; },
  "oQ": function() { return /* binding */ postPillowUserV2UsersMeDeezer; },
  "Rh": function() { return /* binding */ postPillowUserV2UsersMePassword; },
  "Xw": function() { return /* binding */ postPillowUserV2UsersMeSpotify; },
  "PJ": function() { return /* binding */ postPillowUserV2UsersPasswordReset; },
  "GK": function() { return /* binding */ postPillowUserV2UsersRegister; }
});

// UNUSED EXPORTS: _CONSTANT0, _CONSTANT1, deleteAccountUsersMePresetsOffline, postAccountUsersMePresetsOffline, postPillowAdvertisementV2Seen_coupons, postPillowSessionV2SessionExternalAppleid, putAccountUsersMePresets, template

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./services-hooks/config.ts + 5 modules
var config = __webpack_require__(48788);
;// CONCATENATED MODULE: ./services-hooks/httpRequest.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * AUTO_GENERATED Do not change this file directly, use config.ts file instead
 *
 * @version 5
 */


/**
 * Cancellation handled here, you can cancel request by call promise.cancel()
 *
 * @example
 *   const promise = getUsers();
 *   setTimeout(() => promise.cancel(), 30000);
 *   const { data } = await promise;
 *
 * @param getPromise
 * @returns
 */

function cancellation(getPromise) {
  var source = axios_default().CancelToken.source();
  var promise = getPromise(source.token); //@ts-ignore

  promise.cancel = function () {
    source.cancel("request canceled");
  };

  return promise;
}

var Http = {
  getRequest: function getRequest(url, queryParams, //@ts-ignore
  _requestBody, security, configOverride) {
    return cancellation(function (cancelToken) {
      return (0,config/* getAxiosInstance */.H)(security).get(url, _objectSpread({
        cancelToken: cancelToken,
        params: queryParams
      }, configOverride));
    });
  },
  postRequest: function postRequest(url, queryParams, requestBody, security, configOverride) {
    return cancellation(function (cancelToken) {
      return (0,config/* getAxiosInstance */.H)(security).post(url, requestBody, _objectSpread({
        cancelToken: cancelToken,
        params: queryParams
      }, configOverride));
    });
  },
  putRequest: function putRequest(url, queryParams, requestBody, security, configOverride) {
    return cancellation(function (cancelToken) {
      return (0,config/* getAxiosInstance */.H)(security).put(url, requestBody, _objectSpread({
        cancelToken: cancelToken,
        params: queryParams
      }, configOverride));
    });
  },
  patchRequest: function patchRequest(url, queryParams, requestBody, security, configOverride) {
    return cancellation(function (cancelToken) {
      return (0,config/* getAxiosInstance */.H)(security).patch(url, requestBody, _objectSpread({
        cancelToken: cancelToken,
        params: queryParams
      }, configOverride));
    });
  },
  deleteRequest: function deleteRequest(url, queryParams, requestBody, security, configOverride) {
    return cancellation(function (cancelToken) {
      return (0,config/* getAxiosInstance */.H)(security).delete(url, _objectSpread({
        data: requestBody,
        cancelToken: cancelToken,
        params: queryParams
      }, configOverride));
    });
  }
};
;// CONCATENATED MODULE: ./services-hooks/services.ts



function services_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function services_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? services_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : services_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
* AUTO_GENERATED Do not change this file directly, use config.ts file instead
*
* @version 5
*/

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var __DEV__ = false; // eslint-disable-next-line @typescript-eslint/no-unused-vars

function overrideConfig(config, configOverride) {
  return services_objectSpread(services_objectSpread(services_objectSpread({}, config), configOverride), {}, {
    headers: services_objectSpread(services_objectSpread({}, config === null || config === void 0 ? void 0 : config.headers), configOverride === null || configOverride === void 0 ? void 0 : configOverride.headers)
  });
} // eslint-disable-next-line @typescript-eslint/no-unused-vars


function template(path) {
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.keys(obj).forEach(function (key) {
    var re = new RegExp("{".concat(key, "}"), "i");
    path = path.replace(re, obj[key]);
  });
  return path;
} // eslint-disable-next-line @typescript-eslint/no-unused-vars

function objToForm(requestBody) {
  var formData = new FormData();
  Object.entries(requestBody).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    value && formData.append(key, value);
  });
  return formData;
}
/**
 * delete presets from user
 */


var deleteAccountUsersMePresets = function deleteAccountUsersMePresets(requestBody, queryParams, configOverride) {
  return Http.deleteRequest(deleteAccountUsersMePresets.key, queryParams, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

deleteAccountUsersMePresets.key = "/account/users/me/presets";
/**
 * set a preset not offline
 */

var deleteAccountUsersMePresetsOffline = function deleteAccountUsersMePresetsOffline(queryParams, configOverride) {
  return Http.deleteRequest(deleteAccountUsersMePresetsOffline.key, queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

deleteAccountUsersMePresetsOffline.key = "/account/users/me/presets/offline";
/**
 * Delete user info.
 */

var deletePillowUserV2UsersMe = function deletePillowUserV2UsersMe(configOverride) {
  return Http.deleteRequest(deletePillowUserV2UsersMe.key, undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

deletePillowUserV2UsersMe.key = "/Pillow/user/v2/users/me";
/**
 * Disconnect Deezer user.
 */

var deletePillowUserV2UsersMeDeezer = function deletePillowUserV2UsersMeDeezer(configOverride) {
  return Http.deleteRequest(deletePillowUserV2UsersMeDeezer.key, undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

deletePillowUserV2UsersMeDeezer.key = "/Pillow/user/v2/users/me/deezer";
/**
 * Disconnect Spotify user.
 */

var deletePillowUserV2UsersMeSpotify = function deletePillowUserV2UsersMeSpotify(configOverride) {
  return Http.deleteRequest(deletePillowUserV2UsersMeSpotify.key, undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

deletePillowUserV2UsersMeSpotify.key = "/Pillow/user/v2/users/me/spotify";
/**
 * get continuity
 */

var getAccountUsersMeContinuity = function getAccountUsersMeContinuity(configOverride) {
  return Http.getRequest(getAccountUsersMeContinuity.key, undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getAccountUsersMeContinuity.key = "/account/users/me/continuity";
/**
 * get user presets
 */

var getAccountUsersMePresets = function getAccountUsersMePresets(queryParams, configOverride) {
  return Http.getRequest(getAccountUsersMePresets.key, queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getAccountUsersMePresets.key = "/account/users/me/presets";
/**
 * get Targetspot config
 */

var getPillowAdvertisingTargetspot = function getPillowAdvertisingTargetspot(configOverride) {
  return Http.getRequest(getPillowAdvertisingTargetspot.key, undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowAdvertisingTargetspot.key = "/Pillow/advertising/targetspot";
/**
 * get Targetspot config
 */

var getPillowBillingStripeV2Price = function getPillowBillingStripeV2Price(configOverride) {
  return Http.getRequest(getPillowBillingStripeV2Price.key, undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowBillingStripeV2Price.key = "/Pillow/billing/stripe/v2/price";
/**
 * get the root categories
 */

var getPillowCategories = function getPillowCategories(configOverride) {
  return Http.getRequest(getPillowCategories.key, undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowCategories.key = "/Pillow/categories";
/**
 * get a path
 */

var getPillowCategoriesPath = function getPillowCategoriesPath(path, queryParams, configOverride) {
  return Http.getRequest(template(getPillowCategoriesPath.key, {
    path: path
  }), queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowCategoriesPath.key = "/Pillow/categories/{path}";
/**
 * get a path
 */

var getPillowCategoryPath = function getPillowCategoryPath(categoryPath, queryParams, configOverride) {
  return Http.getRequest(template(getPillowCategoryPath.key, {
    categoryPath: categoryPath
  }), queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowCategoryPath.key = "/Pillow/{categoryPath}";
/**
 * get a chapter track
 */

var getPillowChapterLive = function getPillowChapterLive(chapter, queryParams, configOverride) {
  return Http.getRequest(template(getPillowChapterLive.key, {
    chapter: chapter
  }), queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowChapterLive.key = "/Pillow/{chapter}/live";
/**
 * Read chapter progress.
 */

var getPillowListenV2ProgressChapter_id = function getPillowListenV2ProgressChapter_id(chapter_id, configOverride) {
  return Http.getRequest(template(getPillowListenV2ProgressChapter_id.key, {
    chapter_id: chapter_id
  }), undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowListenV2ProgressChapter_id.key = "/Pillow/listen/v2/progress/{chapter_id}";
/**
 * Read podcast chapters progress.
 */

var getPillowListenV2ProgressPodcast = function getPillowListenV2ProgressPodcast(podcast, configOverride) {
  return Http.getRequest(template(getPillowListenV2ProgressPodcast.key, {
    podcast: podcast
  }), undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowListenV2ProgressPodcast.key = "/Pillow/listen/v2/progress/{podcast}";
/**
 * find metadata in radio history
 */

var getPillowMetadataHistorySearch = function getPillowMetadataHistorySearch(queryParams, configOverride) {
  return Http.getRequest(getPillowMetadataHistorySearch.key, queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowMetadataHistorySearch.key = "/Pillow/metadata/history/search";
/**
 * find metadata live on radios
 */

var getPillowMetadataLiveSearch = function getPillowMetadataLiveSearch(queryParams, configOverride) {
  return Http.getRequest(getPillowMetadataLiveSearch.key, queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowMetadataLiveSearch.key = "/Pillow/metadata/live/search";
/**
 * get a podcast
 */

var getPillowPodcast = function getPillowPodcast(podcast, configOverride) {
  return Http.getRequest(template(getPillowPodcast.key, {
    podcast: podcast
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowPodcast.key = "/Pillow/{podcast}";
/**
 * get a podcast chapters
 */

var getPillowPodcastChapters = function getPillowPodcastChapters(podcast, queryParams, configOverride) {
  return Http.getRequest(template(getPillowPodcastChapters.key, {
    podcast: podcast
  }), queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowPodcastChapters.key = "/Pillow/{podcast}/chapters";
/**
 * get a podcast radio
 */

var getPillowPodcastLatest = function getPillowPodcastLatest(podcast, configOverride) {
  return Http.getRequest(template(getPillowPodcastLatest.key, {
    podcast: podcast
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowPodcastLatest.key = "/Pillow/{podcast}/latest";
/**
 * get a podcast radio
 */

var getPillowPodcastRadio = function getPillowPodcastRadio(podcast, configOverride) {
  return Http.getRequest(template(getPillowPodcastRadio.key, {
    podcast: podcast
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowPodcastRadio.key = "/Pillow/{podcast}/radio";
/**
 * get a podcast radio
 */

var getPillowPodcastSimilar = function getPillowPodcastSimilar(podcast, configOverride) {
  return Http.getRequest(template(getPillowPodcastSimilar.key, {
    podcast: podcast
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowPodcastSimilar.key = "/Pillow/{podcast}/similar";
/**
 * get a chapter
 */

var getPillowPodcastchapter = function getPillowPodcastchapter(podcastchapter, configOverride) {
  return Http.getRequest(template(getPillowPodcastchapter.key, {
    podcastchapter: podcastchapter
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowPodcastchapter.key = "/Pillow/{podcastchapter}";
/**
 * get a chapter streams
 */

var getPillowPodcastchapterPlay = function getPillowPodcastchapterPlay(podcastchapter, configOverride) {
  return Http.getRequest(template(getPillowPodcastchapterPlay.key, {
    podcastchapter: podcastchapter
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowPodcastchapterPlay.key = "/Pillow/{podcastchapter}/play";
/**
 * get a radio
 */

var getPillowRadio = function getPillowRadio(radio, configOverride) {
  return Http.getRequest(template(getPillowRadio.key, {
    radio: radio
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowRadio.key = "/Pillow/{radio}";
/**
 * Get the last 10 tracks from a given radio
 */

var getPillowRadioHistory = function getPillowRadioHistory(radio, configOverride) {
  return Http.getRequest(template(getPillowRadioHistory.key, {
    radio: radio
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowRadioHistory.key = "/Pillow/{radio}/history";
/**
 * find metadata in radio history
 */

var getPillowRadioHistorySearch = function getPillowRadioHistorySearch(radio, queryParams, configOverride) {
  return Http.getRequest(template(getPillowRadioHistorySearch.key, {
    radio: radio
  }), queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowRadioHistorySearch.key = "/Pillow/{radio}/history/search";
/**
 * the current state hash of the radio
 */

var getPillowRadioLive = function getPillowRadioLive(radio, queryParams, configOverride) {
  return Http.getRequest(template(getPillowRadioLive.key, {
    radio: radio
  }), queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowRadioLive.key = "/Pillow/{radio}/live";
/**
 * get the streams of a radio
 */

var getPillowRadioPlay = function getPillowRadioPlay(radio, configOverride) {
  return Http.getRequest(template(getPillowRadioPlay.key, {
    radio: radio
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowRadioPlay.key = "/Pillow/{radio}/play";
/**
 * get the podcasts of a radio
 */

var getPillowRadioPodcasts = function getPillowRadioPodcasts(radio, queryParams, configOverride) {
  return Http.getRequest(template(getPillowRadioPodcasts.key, {
    radio: radio
  }), queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowRadioPodcasts.key = "/Pillow/{radio}/podcasts";
/**
 * get radio's schedule for today
 */

var getPillowRadioSchedulesToday = function getPillowRadioSchedulesToday(radio, queryParams, configOverride) {
  return Http.getRequest(template(getPillowRadioSchedulesToday.key, {
    radio: radio
  }), queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowRadioSchedulesToday.key = "/Pillow/{radio}/schedules/today";
/**
 * get a podcast radio
 */

var getPillowRadioSimilar = function getPillowRadioSimilar(radio, configOverride) {
  return Http.getRequest(template(getPillowRadioSimilar.key, {
    radio: radio
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowRadioSimilar.key = "/Pillow/{radio}/similar";
/**
 * Search or filter radios and podcasts
 */

var getPillowSearch = function getPillowSearch(queryParams, configOverride) {
  return Http.getRequest(getPillowSearch.key, queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowSearch.key = "/Pillow/search";
/**
 * Get login code for display in device and check it's status.
 */

var getPillowSessionV2Login_code = function getPillowSessionV2Login_code(configOverride) {
  return Http.getRequest(getPillowSessionV2Login_code.key, undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowSessionV2Login_code.key = "/Pillow/session/v2/login_code";
/**
 * Session info.
 */

var getPillowSessionV2SessionInfo = function getPillowSessionV2SessionInfo(configOverride) {
  return Http.getRequest(getPillowSessionV2SessionInfo.key, undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowSessionV2SessionInfo.key = "/Pillow/session/v2/session/info";
var getPillowSuggestTypeQuery = function getPillowSuggestTypeQuery(type, query, configOverride) {
  return Http.getRequest(template(getPillowSuggestTypeQuery.key, {
    type: type,
    query: query
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowSuggestTypeQuery.key = "/Pillow/suggest/{type}/{query}";
/**
 * get all tag of a type
 */

var getPillowTags = function getPillowTags(queryParams, configOverride) {
  return Http.getRequest(getPillowTags.key, queryParams, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowTags.key = "/Pillow/tags";
/**
 * get a tag
 */

var getPillowTagsTag = function getPillowTagsTag(tag, configOverride) {
  return Http.getRequest(template(getPillowTagsTag.key, {
    tag: tag
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowTagsTag.key = "/Pillow/tags/{tag}";
/**
 * Read user info.
 */

var getPillowUserV2UsersMe = function getPillowUserV2UsersMe(configOverride) {
  return Http.getRequest(getPillowUserV2UsersMe.key, undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowUserV2UsersMe.key = "/Pillow/user/v2/users/me";
/**
 * get your IP's country code, WARNING it can be empty string
 */

var getPillowV2Country = function getPillowV2Country(configOverride) {
  return Http.getRequest(getPillowV2Country.key, undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowV2Country.key = "/Pillow/v2/country";
/**
 * get live wall
 */

var getPillowWall = function getPillowWall(configOverride) {
  return Http.getRequest(getPillowWall.key, undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

getPillowWall.key = "/Pillow/wall";
/**
 * add presets to user
 */

var postAccountUsersMePresets = function postAccountUsersMePresets(requestBody, queryParams, configOverride) {
  return Http.postRequest(postAccountUsersMePresets.key, queryParams, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postAccountUsersMePresets.key = "/account/users/me/presets";
/**
 * set a preset offline property
 */

var postAccountUsersMePresetsOffline = function postAccountUsersMePresetsOffline(requestBody, queryParams, configOverride) {
  return Http.postRequest(postAccountUsersMePresetsOffline.key, queryParams, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postAccountUsersMePresetsOffline.key = "/account/users/me/presets/offline";
var postAccountUsersMeSupport = function postAccountUsersMeSupport(requestBody, configOverride) {
  return Http.postRequest(postAccountUsersMeSupport.key, undefined, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postAccountUsersMeSupport.key = "/account/users/me/support";
/**
 * Create seen coupon. Send email to the user.
 */

var postPillowAdvertisementV2Seen_coupons = function postPillowAdvertisementV2Seen_coupons(requestBody, configOverride) {
  return Http.postRequest(postPillowAdvertisementV2Seen_coupons.key, undefined, requestBody, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowAdvertisementV2Seen_coupons.key = "/Pillow/advertisement/v2/seen_coupons";
/**
 * Create payment link for logged in user.
 */

var postPillowBillingStripeV2Payment_link = function postPillowBillingStripeV2Payment_link(requestBody, configOverride) {
  return Http.postRequest(postPillowBillingStripeV2Payment_link.key, undefined, requestBody, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowBillingStripeV2Payment_link.key = "/Pillow/billing/stripe/v2/payment_link";
/**
 * Add to Deezer playlist track currently played in radio.
 */

var postPillowDeezerV2DeezerTrack_addRadio_id = function postPillowDeezerV2DeezerTrack_addRadio_id(radio_id, configOverride) {
  return Http.postRequest(template(postPillowDeezerV2DeezerTrack_addRadio_id.key, {
    radio_id: radio_id
  }), undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowDeezerV2DeezerTrack_addRadio_id.key = "/Pillow/deezer/v2/deezer/track_add/{radio_id}";
/**
 * Update chapter progress.
 */

var postPillowListenV2ProgressChapter_id = function postPillowListenV2ProgressChapter_id(chapter_id, requestBody, configOverride) {
  return Http.postRequest(template(postPillowListenV2ProgressChapter_id.key, {
    chapter_id: chapter_id
  }), undefined, requestBody, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowListenV2ProgressChapter_id.key = "/Pillow/listen/v2/progress/{chapter_id}";
var postPillowSessionSupport = function postPillowSessionSupport(requestBody, configOverride) {
  return Http.postRequest(postPillowSessionSupport.key, undefined, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowSessionSupport.key = "/Pillow/session/support";
/**
 * Accept login code.
 */

var postPillowSessionV2Login_codeAccept = function postPillowSessionV2Login_codeAccept(requestBody, configOverride) {
  return Http.postRequest(postPillowSessionV2Login_codeAccept.key, undefined, requestBody, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowSessionV2Login_codeAccept.key = "/Pillow/session/v2/login_code/accept";
/**
 * Create session and obtain access token.
 */

var postPillowSessionV2SessionCreate = function postPillowSessionV2SessionCreate(requestBody, configOverride) {
  return Http.postRequest(postPillowSessionV2SessionCreate.key, undefined, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowSessionV2SessionCreate.key = "/Pillow/session/v2/session/create";
/**
 * Login with Apple ID.
 */

var postPillowSessionV2SessionExternalAppleid = function postPillowSessionV2SessionExternalAppleid(requestBody, configOverride) {
  return Http.postRequest(postPillowSessionV2SessionExternalAppleid.key, undefined, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowSessionV2SessionExternalAppleid.key = "/Pillow/session/v2/session/external/appleid";
/**
 * Login with Facebook.
 */

var postPillowSessionV2SessionExternalFacebook = function postPillowSessionV2SessionExternalFacebook(requestBody, configOverride) {
  return Http.postRequest(postPillowSessionV2SessionExternalFacebook.key, undefined, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowSessionV2SessionExternalFacebook.key = "/Pillow/session/v2/session/external/facebook";
/**
 * Login with token.
 */

var postPillowSessionV2SessionLogin_token = function postPillowSessionV2SessionLogin_token(requestBody, configOverride) {
  return Http.postRequest(postPillowSessionV2SessionLogin_token.key, undefined, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowSessionV2SessionLogin_token.key = "/Pillow/session/v2/session/login_token";
/**
 * Logout session.
 */

var postPillowSessionV2SessionLogout = function postPillowSessionV2SessionLogout(configOverride) {
  return Http.postRequest(postPillowSessionV2SessionLogout.key, undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowSessionV2SessionLogout.key = "/Pillow/session/v2/session/logout";
/**
 * Session refresh.
 */

var postPillowSessionV2SessionRefresh = function postPillowSessionV2SessionRefresh(requestBody, configOverride) {
  return Http.postRequest(postPillowSessionV2SessionRefresh.key, undefined, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowSessionV2SessionRefresh.key = "/Pillow/session/v2/session/refresh";
/**
 * Add to Spotify playlist track currently played in radio.
 */

var postPillowSpotifyV2SpotifyTrack_addRadio_id = function postPillowSpotifyV2SpotifyTrack_addRadio_id(radio_id, configOverride) {
  return Http.postRequest(template(postPillowSpotifyV2SpotifyTrack_addRadio_id.key, {
    radio_id: radio_id
  }), undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowSpotifyV2SpotifyTrack_addRadio_id.key = "/Pillow/spotify/v2/spotify/track_add/{radio_id}";
/**
 * Connect Deezer user.
 */

var postPillowUserV2UsersMeDeezer = function postPillowUserV2UsersMeDeezer(requestBody, configOverride) {
  return Http.postRequest(postPillowUserV2UsersMeDeezer.key, undefined, requestBody, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowUserV2UsersMeDeezer.key = "/Pillow/user/v2/users/me/deezer";
/**
 * Change logged-in user password.
 */

var postPillowUserV2UsersMePassword = function postPillowUserV2UsersMePassword(requestBody, configOverride) {
  return Http.postRequest(postPillowUserV2UsersMePassword.key, undefined, requestBody, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowUserV2UsersMePassword.key = "/Pillow/user/v2/users/me/password";
/**
 * Connect spotify user.
 */

var postPillowUserV2UsersMeSpotify = function postPillowUserV2UsersMeSpotify(requestBody, configOverride) {
  return Http.postRequest(postPillowUserV2UsersMeSpotify.key, undefined, requestBody, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowUserV2UsersMeSpotify.key = "/Pillow/user/v2/users/me/spotify";
/**
 * Password reset.
 */

var postPillowUserV2UsersPasswordReset = function postPillowUserV2UsersPasswordReset(requestBody, configOverride) {
  return Http.postRequest(postPillowUserV2UsersPasswordReset.key, undefined, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowUserV2UsersPasswordReset.key = "/Pillow/user/v2/users/password/reset";
/**
 * Register user.
 */

var postPillowUserV2UsersRegister = function postPillowUserV2UsersRegister(requestBody, configOverride) {
  return Http.postRequest(postPillowUserV2UsersRegister.key, undefined, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

postPillowUserV2UsersRegister.key = "/Pillow/user/v2/users/register";
/**
 * set list of presets of the user
 */

var putAccountUsersMePresets = function putAccountUsersMePresets(requestBody, queryParams, configOverride) {
  return Http.putRequest(putAccountUsersMePresets.key, queryParams, requestBody, undefined, overrideConfig(_CONSTANT0, configOverride));
};
/** Key is end point string without base url */

putAccountUsersMePresets.key = "/account/users/me/presets";
var _CONSTANT0 = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  }
};
var _CONSTANT1 = [{
  "bearerAuth": []
}];

/***/ }),

/***/ 37248:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(4614), __webpack_require__(67294)) : 0;
})(this, function (exports, dexie, React) {
  'use strict';

  function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
      'default': e
    };
  }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

  function useObservable(observableFactory, arg2, arg3) {
    // Resolve vars from overloading variants of this function:
    var deps;
    var defaultResult;

    if (typeof observableFactory === 'function') {
      deps = arg2 || [];
      defaultResult = arg3;
    } else {
      deps = [];
      defaultResult = arg2;
    } // Create a ref that keeps the state we need


    var monitor = React__default['default'].useRef({
      hasResult: false,
      result: defaultResult,
      error: null
    }); // We control when component should rerender. Make triggerUpdate
    // as examplified on React's docs at:
    // https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate

    var _a = React__default['default'].useReducer(function (x) {
      return x + 1;
    }, 0);

    _a[0];
    var triggerUpdate = _a[1]; // Memoize the observable based on deps

    var observable = React__default['default'].useMemo(function () {
      // Make it remember previous subscription's default value when
      // resubscribing.
      var observable = typeof observableFactory === 'function' ? observableFactory() : observableFactory;

      if (!observable || typeof observable.subscribe !== 'function') {
        if (observableFactory === observable) {
          throw new TypeError("Given argument to useObservable() was neither a valid observable nor a function.");
        } else {
          throw new TypeError("Observable factory given to useObservable() did not return a valid observable.");
        }
      }

      if (!monitor.current.hasResult) {
        // Optimize for BehaviorSubject and other observables implementing getValue():
        if (typeof observable.getValue === 'function') {
          monitor.current.result = observable.getValue();
          monitor.current.hasResult = true;
        } else {
          // Find out if the observable has a current value: try get it by subscribing and
          // unsubscribing synchronously
          var subscription = observable.subscribe(function (val) {
            monitor.current.result = val;
            monitor.current.hasResult = true;
          }); // Unsubscribe directly. We only needed any synchronous value if it was possible.

          if (typeof subscription === 'function') {
            subscription();
          } else {
            subscription.unsubscribe();
          }
        }
      }

      return observable;
    }, deps); // Integrate with react devtools:

    React__default['default'].useDebugValue(monitor.current.result); // Subscribe to the observable

    React__default['default'].useEffect(function () {
      var subscription = observable.subscribe(function (val) {
        var current = monitor.current;

        if (current.error !== null || current.result !== val) {
          current.error = null;
          current.result = val;
          current.hasResult = true;
          triggerUpdate();
        }
      }, function (err) {
        var current = monitor.current;

        if (current.error !== err) {
          current.error = err;
          triggerUpdate();
        }
      });
      return typeof subscription === 'function' ? subscription // Support observables that return unsubscribe directly
      : subscription.unsubscribe.bind(subscription);
    }, deps); // Throw if observable has emitted error so that
    // an ErrorBoundrary can catch it

    if (monitor.current.error) throw monitor.current.error; // Return the current result

    return monitor.current.result;
  }

  function useLiveQuery(querier, deps, defaultResult) {
    return useObservable(function () {
      return dexie.liveQuery(querier);
    }, deps || [], defaultResult);
  }

  function usePermissions(firstArg, table, obj) {
    if (!firstArg) throw new TypeError("Invalid arguments to usePermissions(): undefined or null");
    var db;

    if (arguments.length >= 3) {
      if (!('transaction' in firstArg)) {
        // Using ducktyping instead of instanceof in case there are multiple Dexie modules in app.
        // First arg is  ensures first arg is a Dexie instance
        throw new TypeError("Invalid arguments to usePermission(db, table, obj): 1st arg must be a Dexie instance");
      }

      if (typeof table !== 'string') throw new TypeError("Invalid arguments to usePermission(db, table, obj): 2nd arg must be string");
      if (!obj || typeof obj !== 'object') throw new TypeError("Invalid arguments to usePermission(db, table, obj): 3rd arg must be an object");
      db = firstArg;
    } else {
      if (firstArg instanceof dexie.Dexie) throw new TypeError("Invalid arguments to usePermission(db, table, obj): Missing table and obj arguments.");

      if (typeof firstArg.table === 'function' && typeof firstArg.db === 'object') {
        db = firstArg.db;
        obj = firstArg;
        table = firstArg.table();
      } else {
        throw new TypeError("Invalid arguments to usePermissions(). " + "Expected usePermissions(entity: DexieCloudEntity) or " + "usePermissions(db: Dexie, table: string, obj: DexieCloudObject)");
      }
    }

    if (!('cloud' in db)) throw new Error("usePermissions() is only for Dexie Cloud but there's no dexie-cloud-addon active in given db.");
    if (!('permissions' in db['cloud'])) throw new Error("usePermissions() requires a newer version of dexie-cloud-addon. Please upgrade it.");
    return useObservable( // @ts-ignore
    function () {
      return db.cloud.permissions(obj, table);
    }, [obj.realmId, obj.owner, table]);
  }

  exports.useLiveQuery = useLiveQuery;
  exports.useObservable = useObservable;
  exports.usePermissions = usePermissions;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});

/***/ }),

/***/ 4614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dexie": function() { return /* binding */ $n; },
/* harmony export */   "RangeSet": function() { return /* binding */ In; },
/* harmony export */   "default": function() { return /* binding */ $n; },
/* harmony export */   "liveQuery": function() { return /* binding */ Wn; },
/* harmony export */   "mergeRanges": function() { return /* binding */ Tn; },
/* harmony export */   "rangesOverlap": function() { return /* binding */ Rn; }
/* harmony export */ });
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27812);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92777);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82262);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16835);






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e22) { throw _e22; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e23) { didErr = true; err = _e23; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self :  true ? window : 0,
    t = Object.keys,
    n = Array.isArray;

function r(e, n) {
  return "object" != typeof n || t(n).forEach(function (t) {
    e[t] = n[t];
  }), e;
}

"undefined" == typeof Promise || e.Promise || (e.Promise = Promise);
var s = Object.getPrototypeOf,
    i = {}.hasOwnProperty;

function o(e, t) {
  return i.call(e, t);
}

function a(e, n) {
  "function" == typeof n && (n = n(s(e))), ("undefined" == typeof Reflect ? t : Reflect.ownKeys)(n).forEach(function (t) {
    l(e, t, n[t]);
  });
}

var u = Object.defineProperty;

function l(e, t, n, s) {
  u(e, t, r(n && o(n, "get") && "function" == typeof n.get ? {
    get: n.get,
    set: n.set,
    configurable: !0
  } : {
    value: n,
    configurable: !0,
    writable: !0
  }, s));
}

function c(e) {
  return {
    from: function from(t) {
      return e.prototype = Object.create(t.prototype), l(e.prototype, "constructor", e), {
        extend: a.bind(null, e.prototype)
      };
    }
  };
}

var h = Object.getOwnPropertyDescriptor;

function d(e, t) {
  var n;
  return h(e, t) || (n = s(e)) && d(n, t);
}

var f = [].slice;

function p(e, t, n) {
  return f.call(e, t, n);
}

function y(e, t) {
  return t(e);
}

function m(e) {
  if (!e) throw new Error("Assertion Failed");
}

function v(t) {
  e.setImmediate ? setImmediate(t) : setTimeout(t, 0);
}

function g(e, t) {
  return e.reduce(function (e, n, r) {
    var s = t(n, r);
    return s && (e[s[0]] = s[1]), e;
  }, {});
}

function b(e, t) {
  if (o(e, t)) return e[t];
  if (!t) return e;

  if ("string" != typeof t) {
    for (var n = [], r = 0, s = t.length; r < s; ++r) {
      var i = b(e, t[r]);
      n.push(i);
    }

    return n;
  }

  var a = t.indexOf(".");

  if (-1 !== a) {
    var u = e[t.substr(0, a)];
    return void 0 === u ? void 0 : b(u, t.substr(a + 1));
  }
}

function _(e, t, r) {
  if (e && void 0 !== t && (!("isFrozen" in Object) || !Object.isFrozen(e))) if ("string" != typeof t && "length" in t) {
    m("string" != typeof r && "length" in r);

    for (var s = 0, i = t.length; s < i; ++s) {
      _(e, t[s], r[s]);
    }
  } else {
    var a = t.indexOf(".");

    if (-1 !== a) {
      var u = t.substr(0, a),
          l = t.substr(a + 1);
      if ("" === l) void 0 === r ? n(e) && !isNaN(parseInt(u)) ? e.splice(u, 1) : delete e[u] : e[u] = r;else {
        var c = e[u];
        c && o(e, u) || (c = e[u] = {}), _(c, l, r);
      }
    } else void 0 === r ? n(e) && !isNaN(parseInt(t)) ? e.splice(t, 1) : delete e[t] : e[t] = r;
  }
}

function w(e) {
  var t = {};

  for (var n in e) {
    o(e, n) && (t[n] = e[n]);
  }

  return t;
}

var x = [].concat;

function k(e) {
  return x.apply([], e);
}

var E = "Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat(k([8, 16, 32, 64].map(function (e) {
  return ["Int", "Uint", "Float"].map(function (t) {
    return t + e + "Array";
  });
}))).filter(function (t) {
  return e[t];
}),
    P = E.map(function (t) {
  return e[t];
});
g(E, function (e) {
  return [e, !0];
});
var K = null;

function O(e) {
  K = "undefined" != typeof WeakMap && new WeakMap();
  var t = S(e);
  return K = null, t;
}

function S(e) {
  if (!e || "object" != typeof e) return e;
  var t = K && K.get(e);
  if (t) return t;

  if (n(e)) {
    t = [], K && K.set(e, t);

    for (var r = 0, i = e.length; r < i; ++r) {
      t.push(S(e[r]));
    }
  } else if (P.indexOf(e.constructor) >= 0) t = e;else {
    var _n2 = s(e);

    for (var a in t = _n2 === Object.prototype ? {} : Object.create(_n2), K && K.set(e, t), e) {
      o(e, a) && (t[a] = S(e[a]));
    }
  }

  return t;
}

var _ref = {},
    A = _ref.toString;

function C(e) {
  return A.call(e).slice(8, -1);
}

var j = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator",
    D = "symbol" == typeof j ? function (e) {
  var t;
  return null != e && (t = e[j]) && t.apply(e);
} : function () {
  return null;
},
    I = {};

function B(e) {
  var t, r, s, i;

  if (1 === arguments.length) {
    if (n(e)) return e.slice();
    if (this === I && "string" == typeof e) return [e];

    if (i = D(e)) {
      for (r = []; !(s = i.next()).done;) {
        r.push(s.value);
      }

      return r;
    }

    if (null == e) return [e];

    if ("number" == typeof (t = e.length)) {
      for (r = new Array(t); t--;) {
        r[t] = e[t];
      }

      return r;
    }

    return [e];
  }

  for (t = arguments.length, r = new Array(t); t--;) {
    r[t] = arguments[t];
  }

  return r;
}

var T = "undefined" != typeof Symbol ? function (e) {
  return "AsyncFunction" === e[Symbol.toStringTag];
} : function () {
  return !1;
};
var R = "undefined" != typeof location && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);

function F(e, t) {
  R = e, M = t;
}

var M = function M() {
  return !0;
};

var N = !new Error("").stack;

function q() {
  if (N) try {
    throw q.arguments, new Error();
  } catch (e) {
    return e;
  }
  return new Error();
}

function $(e, t) {
  var n = e.stack;
  return n ? (t = t || 0, 0 === n.indexOf(e.name) && (t += (e.name + e.message).split("\n").length), n.split("\n").slice(t).filter(M).map(function (e) {
    return "\n" + e;
  }).join("")) : "";
}

var U = ["Unknown", "Constraint", "Data", "TransactionInactive", "ReadOnly", "Version", "NotFound", "InvalidState", "InvalidAccess", "Abort", "Timeout", "QuotaExceeded", "Syntax", "DataClone"],
    L = ["Modify", "Bulk", "OpenFailed", "VersionChange", "Schema", "Upgrade", "InvalidTable", "MissingAPI", "NoSuchDatabase", "InvalidArgument", "SubTransaction", "Unsupported", "Internal", "DatabaseClosed", "PrematureCommit", "ForeignAwait"].concat(U),
    V = {
  VersionChanged: "Database version changed by other database connection",
  DatabaseClosed: "Database has been closed",
  Abort: "Transaction aborted",
  TransactionInactive: "Transaction has already completed or failed",
  MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};

function W(e, t) {
  this._e = q(), this.name = e, this.message = t;
}

function Y(e, t) {
  return e + ". Errors: " + Object.keys(t).map(function (e) {
    return t[e].toString();
  }).filter(function (e, t, n) {
    return n.indexOf(e) === t;
  }).join("\n");
}

function z(e, t, n, r) {
  this._e = q(), this.failures = t, this.failedKeys = r, this.successCount = n, this.message = Y(e, t);
}

function G(e, t) {
  this._e = q(), this.name = "BulkError", this.failures = Object.keys(t).map(function (e) {
    return t[e];
  }), this.failuresByPos = t, this.message = Y(e, t);
}

c(W).from(Error).extend({
  stack: {
    get: function get() {
      return this._stack || (this._stack = this.name + ": " + this.message + $(this._e, 2));
    }
  },
  toString: function toString() {
    return this.name + ": " + this.message;
  }
}), c(z).from(W), c(G).from(W);
var H = L.reduce(function (e, t) {
  return e[t] = t + "Error", e;
}, {});
var Q = W;
var X = L.reduce(function (e, t) {
  var n = t + "Error";

  function r(e, r) {
    this._e = q(), this.name = n, e ? "string" == typeof e ? (this.message = "".concat(e).concat(r ? "\n " + r : ""), this.inner = r || null) : "object" == typeof e && (this.message = "".concat(e.name, " ").concat(e.message), this.inner = e) : (this.message = V[t] || n, this.inner = null);
  }

  return c(r).from(Q), e[t] = r, e;
}, {});
X.Syntax = SyntaxError, X.Type = TypeError, X.Range = RangeError;
var J = U.reduce(function (e, t) {
  return e[t + "Error"] = X[t], e;
}, {});
var Z = L.reduce(function (e, t) {
  return -1 === ["Syntax", "Type", "Range"].indexOf(t) && (e[t + "Error"] = X[t]), e;
}, {});

function ee() {}

function te(e) {
  return e;
}

function ne(e, t) {
  return null == e || e === te ? t : function (n) {
    return t(e(n));
  };
}

function re(e, t) {
  return function () {
    e.apply(this, arguments), t.apply(this, arguments);
  };
}

function se(e, t) {
  return e === ee ? t : function () {
    var n = e.apply(this, arguments);
    void 0 !== n && (arguments[0] = n);
    var r = this.onsuccess,
        s = this.onerror;
    this.onsuccess = null, this.onerror = null;
    var i = t.apply(this, arguments);
    return r && (this.onsuccess = this.onsuccess ? re(r, this.onsuccess) : r), s && (this.onerror = this.onerror ? re(s, this.onerror) : s), void 0 !== i ? i : n;
  };
}

function ie(e, t) {
  return e === ee ? t : function () {
    e.apply(this, arguments);
    var n = this.onsuccess,
        r = this.onerror;
    this.onsuccess = this.onerror = null, t.apply(this, arguments), n && (this.onsuccess = this.onsuccess ? re(n, this.onsuccess) : n), r && (this.onerror = this.onerror ? re(r, this.onerror) : r);
  };
}

function oe(e, t) {
  return e === ee ? t : function (n) {
    var s = e.apply(this, arguments);
    r(n, s);
    var i = this.onsuccess,
        o = this.onerror;
    this.onsuccess = null, this.onerror = null;
    var a = t.apply(this, arguments);
    return i && (this.onsuccess = this.onsuccess ? re(i, this.onsuccess) : i), o && (this.onerror = this.onerror ? re(o, this.onerror) : o), void 0 === s ? void 0 === a ? void 0 : a : r(s, a);
  };
}

function ae(e, t) {
  return e === ee ? t : function () {
    return !1 !== t.apply(this, arguments) && e.apply(this, arguments);
  };
}

function ue(e, t) {
  return e === ee ? t : function () {
    var n = e.apply(this, arguments);

    if (n && "function" == typeof n.then) {
      for (var r = this, s = arguments.length, i = new Array(s); s--;) {
        i[s] = arguments[s];
      }

      return n.then(function () {
        return t.apply(r, i);
      });
    }

    return t.apply(this, arguments);
  };
}

Z.ModifyError = z, Z.DexieError = W, Z.BulkError = G;
var le = {};

var _ref2 = "undefined" == typeof Promise ? [] : function () {
  var e = Promise.resolve();
  if ("undefined" == typeof crypto || !crypto.subtle) return [e, s(e), e];
  var t = crypto.subtle.digest("SHA-512", new Uint8Array([0]));
  return [t, s(t), e];
}(),
    _ref3 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref2, 3),
    ce = _ref3[0],
    he = _ref3[1],
    de = _ref3[2],
    fe = he && he.then,
    pe = ce && ce.constructor,
    ye = !!de;

var me = !1,
    ve = de ? function () {
  de.then(qe);
} : e.setImmediate ? setImmediate.bind(null, qe) : e.MutationObserver ? function () {
  var e = document.createElement("div");
  new MutationObserver(function () {
    qe(), e = null;
  }).observe(e, {
    attributes: !0
  }), e.setAttribute("i", "1");
} : function () {
  setTimeout(qe, 0);
},
    ge = function ge(e, t) {
  Oe.push([e, t]), _e && (ve(), _e = !1);
},
    be = !0,
    _e = !0,
    we = [],
    xe = [],
    ke = null,
    Ee = te,
    Pe = {
  id: "global",
  global: !0,
  ref: 0,
  unhandleds: [],
  onunhandled: ct,
  pgp: !1,
  env: {},
  finalize: function finalize() {
    this.unhandleds.forEach(function (e) {
      try {
        ct(e[0], e[1]);
      } catch (e) {}
    });
  }
},
    Ke = Pe,
    Oe = [],
    Se = 0,
    Ae = [];

function Ce(e) {
  if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");
  this._listeners = [], this.onuncatched = ee, this._lib = !1;
  var t = this._PSD = Ke;

  if (R && (this._stackHolder = q(), this._prev = null, this._numPrev = 0), "function" != typeof e) {
    if (e !== le) throw new TypeError("Not a function");
    return this._state = arguments[1], this._value = arguments[2], void (!1 === this._state && Be(this, this._value));
  }

  this._state = null, this._value = null, ++t.ref, Ie(this, e);
}

var je = {
  get: function get() {
    var e = Ke,
        t = Qe;

    function n(n, r) {
      var _this = this;

      var s = !e.global && (e !== Ke || t !== Qe);
      var i = s && !et();
      var o = new Ce(function (t, o) {
        Re(_this, new De(ut(n, e, s, i), ut(r, e, s, i), t, o, e));
      });
      return R && Ne(o, this), o;
    }

    return n.prototype = le, n;
  },
  set: function set(e) {
    l(this, "then", e && e.prototype === le ? je : {
      get: function get() {
        return e;
      },
      set: je.set
    });
  }
};

function De(e, t, n, r, s) {
  this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.resolve = n, this.reject = r, this.psd = s;
}

function Ie(e, t) {
  try {
    t(function (t) {
      if (null === e._state) {
        if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
        var n = e._lib && $e();
        t && "function" == typeof t.then ? Ie(e, function (e, n) {
          t instanceof Ce ? t._then(e, n) : t.then(e, n);
        }) : (e._state = !0, e._value = t, Te(e)), n && Ue();
      }
    }, Be.bind(null, e));
  } catch (t) {
    Be(e, t);
  }
}

function Be(e, t) {
  if (xe.push(t), null === e._state) {
    var n = e._lib && $e();
    t = Ee(t), e._state = !1, e._value = t, R && null !== t && "object" == typeof t && !t._promise && function (e, t, n) {
      try {
        e.apply(null, n);
      } catch (e) {
        t && t(e);
      }
    }(function () {
      var n = d(t, "stack");
      t._promise = e, l(t, "stack", {
        get: function get() {
          return me ? n && (n.get ? n.get.apply(t) : n.value) : e.stack;
        }
      });
    }), function (e) {
      we.some(function (t) {
        return t._value === e._value;
      }) || we.push(e);
    }(e), Te(e), n && Ue();
  }
}

function Te(e) {
  var t = e._listeners;
  e._listeners = [];

  for (var n = 0, r = t.length; n < r; ++n) {
    Re(e, t[n]);
  }

  var s = e._PSD;
  --s.ref || s.finalize(), 0 === Se && (++Se, ge(function () {
    0 == --Se && Le();
  }, []));
}

function Re(e, t) {
  if (null !== e._state) {
    var n = e._state ? t.onFulfilled : t.onRejected;
    if (null === n) return (e._state ? t.resolve : t.reject)(e._value);
    ++t.psd.ref, ++Se, ge(Fe, [n, e, t]);
  } else e._listeners.push(t);
}

function Fe(e, t, n) {
  try {
    ke = t;
    var r,
        s = t._value;
    t._state ? r = e(s) : (xe.length && (xe = []), r = e(s), -1 === xe.indexOf(s) && function (e) {
      var t = we.length;

      for (; t;) {
        if (we[--t]._value === e._value) return void we.splice(t, 1);
      }
    }(t)), n.resolve(r);
  } catch (e) {
    n.reject(e);
  } finally {
    ke = null, 0 == --Se && Le(), --n.psd.ref || n.psd.finalize();
  }
}

function Me(e, t, n) {
  if (t.length === n) return t;
  var r = "";

  if (!1 === e._state) {
    var s,
        i,
        o = e._value;
    null != o ? (s = o.name || "Error", i = o.message || o, r = $(o, 0)) : (s = o, i = ""), t.push(s + (i ? ": " + i : "") + r);
  }

  return R && ((r = $(e._stackHolder, 2)) && -1 === t.indexOf(r) && t.push(r), e._prev && Me(e._prev, t, n)), t;
}

function Ne(e, t) {
  var n = t ? t._numPrev + 1 : 0;
  n < 100 && (e._prev = t, e._numPrev = n);
}

function qe() {
  $e() && Ue();
}

function $e() {
  var e = be;
  return be = !1, _e = !1, e;
}

function Ue() {
  var e, t, n;

  do {
    for (; Oe.length > 0;) {
      for (e = Oe, Oe = [], n = e.length, t = 0; t < n; ++t) {
        var r = e[t];
        r[0].apply(null, r[1]);
      }
    }
  } while (Oe.length > 0);

  be = !0, _e = !0;
}

function Le() {
  var e = we;
  we = [], e.forEach(function (e) {
    e._PSD.onunhandled.call(null, e._value, e);
  });

  for (var t = Ae.slice(0), n = t.length; n;) {
    t[--n]();
  }
}

function Ve(e) {
  return new Ce(le, !1, e);
}

function We(e, t) {
  var n = Ke;
  return function () {
    var r = $e(),
        s = Ke;

    try {
      return st(n, !0), e.apply(this, arguments);
    } catch (e) {
      t && t(e);
    } finally {
      st(s, !1), r && Ue();
    }
  };
}

a(Ce.prototype, {
  then: je,
  _then: function _then(e, t) {
    Re(this, new De(null, null, e, t, Ke));
  },
  catch: function _catch(e) {
    if (1 === arguments.length) return this.then(null, e);
    var t = arguments[0],
        n = arguments[1];
    return "function" == typeof t ? this.then(null, function (e) {
      return e instanceof t ? n(e) : Ve(e);
    }) : this.then(null, function (e) {
      return e && e.name === t ? n(e) : Ve(e);
    });
  },
  finally: function _finally(e) {
    return this.then(function (t) {
      return e(), t;
    }, function (t) {
      return e(), Ve(t);
    });
  },
  stack: {
    get: function get() {
      if (this._stack) return this._stack;

      try {
        me = !0;
        var e = Me(this, [], 20).join("\nFrom previous: ");
        return null !== this._state && (this._stack = e), e;
      } finally {
        me = !1;
      }
    }
  },
  timeout: function timeout(e, t) {
    var _this2 = this;

    return e < 1 / 0 ? new Ce(function (n, r) {
      var s = setTimeout(function () {
        return r(new X.Timeout(t));
      }, e);

      _this2.then(n, r).finally(clearTimeout.bind(null, s));
    }) : this;
  }
}), "undefined" != typeof Symbol && Symbol.toStringTag && l(Ce.prototype, Symbol.toStringTag, "Dexie.Promise"), Pe.env = it(), a(Ce, {
  all: function all() {
    var e = B.apply(null, arguments).map(tt);
    return new Ce(function (t, n) {
      0 === e.length && t([]);
      var r = e.length;
      e.forEach(function (s, i) {
        return Ce.resolve(s).then(function (n) {
          e[i] = n, --r || t(e);
        }, n);
      });
    });
  },
  resolve: function resolve(e) {
    if (e instanceof Ce) return e;
    if (e && "function" == typeof e.then) return new Ce(function (t, n) {
      e.then(t, n);
    });
    var t = new Ce(le, !0, e);
    return Ne(t, ke), t;
  },
  reject: Ve,
  race: function race() {
    var e = B.apply(null, arguments).map(tt);
    return new Ce(function (t, n) {
      e.map(function (e) {
        return Ce.resolve(e).then(t, n);
      });
    });
  },
  PSD: {
    get: function get() {
      return Ke;
    },
    set: function set(e) {
      return Ke = e;
    }
  },
  totalEchoes: {
    get: function get() {
      return Qe;
    }
  },
  newPSD: Je,
  usePSD: ot,
  scheduler: {
    get: function get() {
      return ge;
    },
    set: function set(e) {
      ge = e;
    }
  },
  rejectionMapper: {
    get: function get() {
      return Ee;
    },
    set: function set(e) {
      Ee = e;
    }
  },
  follow: function follow(e, t) {
    return new Ce(function (n, r) {
      return Je(function (t, n) {
        var r = Ke;
        r.unhandleds = [], r.onunhandled = n, r.finalize = re(function () {
          var _this3 = this;

          !function (e) {
            function t() {
              e(), Ae.splice(Ae.indexOf(t), 1);
            }

            Ae.push(t), ++Se, ge(function () {
              0 == --Se && Le();
            }, []);
          }(function () {
            0 === _this3.unhandleds.length ? t() : n(_this3.unhandleds[0]);
          });
        }, r.finalize), e();
      }, t, n, r);
    });
  }
}), pe && (pe.allSettled && l(Ce, "allSettled", function () {
  var e = B.apply(null, arguments).map(tt);
  return new Ce(function (t) {
    0 === e.length && t([]);
    var n = e.length;
    var r = new Array(n);
    e.forEach(function (e, s) {
      return Ce.resolve(e).then(function (e) {
        return r[s] = {
          status: "fulfilled",
          value: e
        };
      }, function (e) {
        return r[s] = {
          status: "rejected",
          reason: e
        };
      }).then(function () {
        return --n || t(r);
      });
    });
  });
}), pe.any && "undefined" != typeof AggregateError && l(Ce, "any", function () {
  var e = B.apply(null, arguments).map(tt);
  return new Ce(function (t, n) {
    0 === e.length && n(new AggregateError([]));
    var r = e.length;
    var s = new Array(r);
    e.forEach(function (e, i) {
      return Ce.resolve(e).then(function (e) {
        return t(e);
      }, function (e) {
        s[i] = e, --r || n(new AggregateError(s));
      });
    });
  });
}));
var Ye = {
  awaits: 0,
  echoes: 0,
  id: 0
};
var ze = 0,
    Ge = [],
    He = 0,
    Qe = 0,
    Xe = 0;

function Je(e, t, n, s) {
  var i = Ke,
      o = Object.create(i);
  o.parent = i, o.ref = 0, o.global = !1, o.id = ++Xe;
  var a = Pe.env;
  o.env = ye ? {
    Promise: Ce,
    PromiseProp: {
      value: Ce,
      configurable: !0,
      writable: !0
    },
    all: Ce.all,
    race: Ce.race,
    allSettled: Ce.allSettled,
    any: Ce.any,
    resolve: Ce.resolve,
    reject: Ce.reject,
    nthen: lt(a.nthen, o),
    gthen: lt(a.gthen, o)
  } : {}, t && r(o, t), ++i.ref, o.finalize = function () {
    --this.parent.ref || this.parent.finalize();
  };
  var u = ot(o, e, n, s);
  return 0 === o.ref && o.finalize(), u;
}

function Ze() {
  return Ye.id || (Ye.id = ++ze), ++Ye.awaits, Ye.echoes += 100, Ye.id;
}

function et() {
  return !!Ye.awaits && (0 == --Ye.awaits && (Ye.id = 0), Ye.echoes = 100 * Ye.awaits, !0);
}

function tt(e) {
  return Ye.echoes && e && e.constructor === pe ? (Ze(), e.then(function (e) {
    return et(), e;
  }, function (e) {
    return et(), ht(e);
  })) : e;
}

function nt(e) {
  ++Qe, Ye.echoes && 0 != --Ye.echoes || (Ye.echoes = Ye.id = 0), Ge.push(Ke), st(e, !0);
}

function rt() {
  var e = Ge[Ge.length - 1];
  Ge.pop(), st(e, !1);
}

function st(t, n) {
  var r = Ke;

  if ((n ? !Ye.echoes || He++ && t === Ke : !He || --He && t === Ke) || at(n ? nt.bind(null, t) : rt), t !== Ke && (Ke = t, r === Pe && (Pe.env = it()), ye)) {
    var s = Pe.env.Promise,
        i = t.env;
    he.then = i.nthen, s.prototype.then = i.gthen, (r.global || t.global) && (Object.defineProperty(e, "Promise", i.PromiseProp), s.all = i.all, s.race = i.race, s.resolve = i.resolve, s.reject = i.reject, i.allSettled && (s.allSettled = i.allSettled), i.any && (s.any = i.any));
  }
}

function it() {
  var t = e.Promise;
  return ye ? {
    Promise: t,
    PromiseProp: Object.getOwnPropertyDescriptor(e, "Promise"),
    all: t.all,
    race: t.race,
    allSettled: t.allSettled,
    any: t.any,
    resolve: t.resolve,
    reject: t.reject,
    nthen: he.then,
    gthen: t.prototype.then
  } : {};
}

function ot(e, t, n, r, s) {
  var i = Ke;

  try {
    return st(e, !0), t(n, r, s);
  } finally {
    st(i, !1);
  }
}

function at(e) {
  fe.call(ce, e);
}

function ut(e, t, n, r) {
  return "function" != typeof e ? e : function () {
    var s = Ke;
    n && Ze(), st(t, !0);

    try {
      return e.apply(this, arguments);
    } finally {
      st(s, !1), r && at(et);
    }
  };
}

function lt(e, t) {
  return function (n, r) {
    return e.call(this, ut(n, t), ut(r, t));
  };
}

-1 === ("" + fe).indexOf("[native code]") && (Ze = et = ee);

function ct(t, n) {
  var s;

  try {
    s = n.onuncatched(t);
  } catch (e) {}

  if (!1 !== s) try {
    var i,
        o = {
      promise: n,
      reason: t
    };
    if (e.document && document.createEvent ? ((i = document.createEvent("Event")).initEvent("unhandledrejection", !0, !0), r(i, o)) : e.CustomEvent && r(i = new CustomEvent("unhandledrejection", {
      detail: o
    }), o), i && e.dispatchEvent && (dispatchEvent(i), !e.PromiseRejectionEvent && e.onunhandledrejection)) try {
      e.onunhandledrejection(i);
    } catch (e) {}
    R && i && !i.defaultPrevented && console.warn("Unhandled rejection: ".concat(t.stack || t));
  } catch (e) {}
}

var ht = Ce.reject;

function dt(e, t, n, r) {
  if (e.idbdb && (e._state.openComplete || Ke.letThrough || e._vip)) {
    var s = e._createTransaction(t, n, e._dbSchema);

    try {
      s.create(), e._state.PR1398_maxLoop = 3;
    } catch (s) {
      return s.name === H.InvalidState && e.isOpen() && --e._state.PR1398_maxLoop > 0 ? (console.warn("Dexie: Need to reopen db"), e._close(), e.open().then(function () {
        return dt(e, t, n, r);
      })) : ht(s);
    }

    return s._promise(t, function (e, t) {
      return Je(function () {
        return Ke.trans = s, r(e, t, s);
      });
    }).then(function (e) {
      return s._completion.then(function () {
        return e;
      });
    });
  }

  if (e._state.openComplete) return ht(new X.DatabaseClosed(e._state.dbOpenError));

  if (!e._state.isBeingOpened) {
    if (!e._options.autoOpen) return ht(new X.DatabaseClosed());
    e.open().catch(ee);
  }

  return e._state.dbReadyPromise.then(function () {
    return dt(e, t, n, r);
  });
}

var ft = String.fromCharCode(65535),
    pt = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.",
    yt = [],
    mt = "undefined" != typeof navigator && /(MSIE|Trident|Edge)/.test(navigator.userAgent),
    vt = mt,
    gt = mt,
    bt = function bt(e) {
  return !/(dexie\.js|dexie\.min\.js)/.test(e);
};

function _t(e, t) {
  return e ? t ? function () {
    return e.apply(this, arguments) && t.apply(this, arguments);
  } : e : t;
}

var wt = {
  type: 3,
  lower: -1 / 0,
  lowerOpen: !1,
  upper: [[]],
  upperOpen: !1
};

function xt(e) {
  return "string" != typeof e || /\./.test(e) ? function (e) {
    return e;
  } : function (t) {
    return void 0 === t[e] && e in t && delete (t = O(t))[e], t;
  };
}

var kt = /*#__PURE__*/function () {
  function kt() {
    (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, kt);
  }

  (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(kt, [{
    key: "_trans",
    value: function _trans(e, t, n) {
      var r = this._tx || Ke.trans,
          s = this.name;

      function i(e, n, r) {
        if (!r.schema[s]) throw new X.NotFound("Table " + s + " not part of transaction");
        return t(r.idbtrans, r);
      }

      var o = $e();

      try {
        return r && r.db === this.db ? r === Ke.trans ? r._promise(e, i, n) : Je(function () {
          return r._promise(e, i, n);
        }, {
          trans: r,
          transless: Ke.transless || Ke
        }) : dt(this.db, e, [this.name], i);
      } finally {
        o && Ue();
      }
    }
  }, {
    key: "get",
    value: function get(e, t) {
      var _this4 = this;

      return e && e.constructor === Object ? this.where(e).first(t) : this._trans("readonly", function (t) {
        return _this4.core.get({
          trans: t,
          key: e
        }).then(function (e) {
          return _this4.hook.reading.fire(e);
        });
      }).then(t);
    }
  }, {
    key: "where",
    value: function where(e) {
      if ("string" == typeof e) return new this.db.WhereClause(this, e);
      if (n(e)) return new this.db.WhereClause(this, "[".concat(e.join("+"), "]"));
      var r = t(e);
      if (1 === r.length) return this.where(r[0]).equals(e[r[0]]);
      var s = this.schema.indexes.concat(this.schema.primKey).filter(function (e) {
        return e.compound && r.every(function (t) {
          return e.keyPath.indexOf(t) >= 0;
        }) && e.keyPath.every(function (e) {
          return r.indexOf(e) >= 0;
        });
      })[0];
      if (s && this.db._maxKey !== ft) return this.where(s.name).equals(s.keyPath.map(function (t) {
        return e[t];
      }));
      !s && R && console.warn("The query ".concat(JSON.stringify(e), " on ").concat(this.name, " would benefit of a compound index [").concat(r.join("+"), "]"));
      var i = this.schema.idxByName,
          o = this.db._deps.indexedDB;

      function a(e, t) {
        try {
          return 0 === o.cmp(e, t);
        } catch (e) {
          return !1;
        }
      }

      var _r$reduce = r.reduce(function (_ref4, s) {
        var _ref5 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref4, 2),
            t = _ref5[0],
            r = _ref5[1];

        var o = i[s],
            u = e[s];
        return [t || o, t || !o ? _t(r, o && o.multi ? function (e) {
          var t = b(e, s);
          return n(t) && t.some(function (e) {
            return a(u, e);
          });
        } : function (e) {
          return a(u, b(e, s));
        }) : r];
      }, [null, null]),
          _r$reduce2 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_r$reduce, 2),
          u = _r$reduce2[0],
          l = _r$reduce2[1];

      return u ? this.where(u.name).equals(e[u.keyPath]).filter(l) : s ? this.filter(l) : this.where(r).equals("");
    }
  }, {
    key: "filter",
    value: function filter(e) {
      return this.toCollection().and(e);
    }
  }, {
    key: "count",
    value: function count(e) {
      return this.toCollection().count(e);
    }
  }, {
    key: "offset",
    value: function offset(e) {
      return this.toCollection().offset(e);
    }
  }, {
    key: "limit",
    value: function limit(e) {
      return this.toCollection().limit(e);
    }
  }, {
    key: "each",
    value: function each(e) {
      return this.toCollection().each(e);
    }
  }, {
    key: "toArray",
    value: function toArray(e) {
      return this.toCollection().toArray(e);
    }
  }, {
    key: "toCollection",
    value: function toCollection() {
      return new this.db.Collection(new this.db.WhereClause(this));
    }
  }, {
    key: "orderBy",
    value: function orderBy(e) {
      return new this.db.Collection(new this.db.WhereClause(this, n(e) ? "[".concat(e.join("+"), "]") : e));
    }
  }, {
    key: "reverse",
    value: function reverse() {
      return this.toCollection().reverse();
    }
  }, {
    key: "mapToClass",
    value: function mapToClass(e) {
      this.schema.mappedClass = e;

      var t = function t(_t2) {
        if (!_t2) return _t2;
        var n = Object.create(e.prototype);

        for (var r in _t2) {
          if (o(_t2, r)) try {
            n[r] = _t2[r];
          } catch (e) {}
        }

        return n;
      };

      return this.schema.readHook && this.hook.reading.unsubscribe(this.schema.readHook), this.schema.readHook = t, this.hook("reading", t), e;
    }
  }, {
    key: "defineClass",
    value: function defineClass() {
      return this.mapToClass(function (e) {
        r(this, e);
      });
    }
  }, {
    key: "add",
    value: function add(e, t) {
      var _this5 = this;

      var _this$schema$primKey = this.schema.primKey,
          n = _this$schema$primKey.auto,
          r = _this$schema$primKey.keyPath;
      var s = e;
      return r && n && (s = xt(r)(e)), this._trans("readwrite", function (e) {
        return _this5.core.mutate({
          trans: e,
          type: "add",
          keys: null != t ? [t] : null,
          values: [s]
        });
      }).then(function (e) {
        return e.numFailures ? Ce.reject(e.failures[0]) : e.lastResult;
      }).then(function (t) {
        if (r) try {
          _(e, r, t);
        } catch (e) {}
        return t;
      });
    }
  }, {
    key: "update",
    value: function update(e, r) {
      if ("object" != typeof e || n(e)) return this.where(":id").equals(e).modify(r);
      {
        var _n3 = b(e, this.schema.primKey.keyPath);

        if (void 0 === _n3) return ht(new X.InvalidArgument("Given object does not contain its primary key"));

        try {
          "function" != typeof r ? t(r).forEach(function (t) {
            _(e, t, r[t]);
          }) : r(e, {
            value: e,
            primKey: _n3
          });
        } catch (e) {}

        return this.where(":id").equals(_n3).modify(r);
      }
    }
  }, {
    key: "put",
    value: function put(e, t) {
      var _this6 = this;

      var _this$schema$primKey2 = this.schema.primKey,
          n = _this$schema$primKey2.auto,
          r = _this$schema$primKey2.keyPath;
      var s = e;
      return r && n && (s = xt(r)(e)), this._trans("readwrite", function (e) {
        return _this6.core.mutate({
          trans: e,
          type: "put",
          values: [s],
          keys: null != t ? [t] : null
        });
      }).then(function (e) {
        return e.numFailures ? Ce.reject(e.failures[0]) : e.lastResult;
      }).then(function (t) {
        if (r) try {
          _(e, r, t);
        } catch (e) {}
        return t;
      });
    }
  }, {
    key: "delete",
    value: function _delete(e) {
      var _this7 = this;

      return this._trans("readwrite", function (t) {
        return _this7.core.mutate({
          trans: t,
          type: "delete",
          keys: [e]
        });
      }).then(function (e) {
        return e.numFailures ? Ce.reject(e.failures[0]) : void 0;
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this8 = this;

      return this._trans("readwrite", function (e) {
        return _this8.core.mutate({
          trans: e,
          type: "deleteRange",
          range: wt
        });
      }).then(function (e) {
        return e.numFailures ? Ce.reject(e.failures[0]) : void 0;
      });
    }
  }, {
    key: "bulkGet",
    value: function bulkGet(e) {
      var _this9 = this;

      return this._trans("readonly", function (t) {
        return _this9.core.getMany({
          keys: e,
          trans: t
        }).then(function (e) {
          return e.map(function (e) {
            return _this9.hook.reading.fire(e);
          });
        });
      });
    }
  }, {
    key: "bulkAdd",
    value: function bulkAdd(e, t, n) {
      var _this10 = this;

      var r = Array.isArray(t) ? t : void 0,
          s = (n = n || (r ? void 0 : t)) ? n.allKeys : void 0;
      return this._trans("readwrite", function (t) {
        var _this10$schema$primKe = _this10.schema.primKey,
            n = _this10$schema$primKe.auto,
            i = _this10$schema$primKe.keyPath;
        if (i && r) throw new X.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
        if (r && r.length !== e.length) throw new X.InvalidArgument("Arguments objects and keys must have the same length");
        var o = e.length;
        var a = i && n ? e.map(xt(i)) : e;
        return _this10.core.mutate({
          trans: t,
          type: "add",
          keys: r,
          values: a,
          wantResults: s
        }).then(function (_ref6) {
          var e = _ref6.numFailures,
              t = _ref6.results,
              n = _ref6.lastResult,
              r = _ref6.failures;
          if (0 === e) return s ? t : n;
          throw new G("".concat(_this10.name, ".bulkAdd(): ").concat(e, " of ").concat(o, " operations failed"), r);
        });
      });
    }
  }, {
    key: "bulkPut",
    value: function bulkPut(e, t, n) {
      var _this11 = this;

      var r = Array.isArray(t) ? t : void 0,
          s = (n = n || (r ? void 0 : t)) ? n.allKeys : void 0;
      return this._trans("readwrite", function (t) {
        var _this11$schema$primKe = _this11.schema.primKey,
            n = _this11$schema$primKe.auto,
            i = _this11$schema$primKe.keyPath;
        if (i && r) throw new X.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
        if (r && r.length !== e.length) throw new X.InvalidArgument("Arguments objects and keys must have the same length");
        var o = e.length;
        var a = i && n ? e.map(xt(i)) : e;
        return _this11.core.mutate({
          trans: t,
          type: "put",
          keys: r,
          values: a,
          wantResults: s
        }).then(function (_ref7) {
          var e = _ref7.numFailures,
              t = _ref7.results,
              n = _ref7.lastResult,
              r = _ref7.failures;
          if (0 === e) return s ? t : n;
          throw new G("".concat(_this11.name, ".bulkPut(): ").concat(e, " of ").concat(o, " operations failed"), r);
        });
      });
    }
  }, {
    key: "bulkDelete",
    value: function bulkDelete(e) {
      var _this12 = this;

      var t = e.length;
      return this._trans("readwrite", function (t) {
        return _this12.core.mutate({
          trans: t,
          type: "delete",
          keys: e
        });
      }).then(function (_ref8) {
        var e = _ref8.numFailures,
            n = _ref8.lastResult,
            r = _ref8.failures;
        if (0 === e) return n;
        throw new G("".concat(_this12.name, ".bulkDelete(): ").concat(e, " of ").concat(t, " operations failed"), r);
      });
    }
  }]);

  return kt;
}();

function Et(e) {
  var r = {},
      s = function s(t, n) {
    if (n) {
      for (var s = arguments.length, i = new Array(s - 1); --s;) {
        i[s - 1] = arguments[s];
      }

      return r[t].subscribe.apply(null, i), e;
    }

    if ("string" == typeof t) return r[t];
  };

  s.addEventType = a;

  for (var i = 1, o = arguments.length; i < o; ++i) {
    a(arguments[i]);
  }

  return s;

  function a(e, t, n) {
    if ("object" == typeof e) return u(e);
    t || (t = ae), n || (n = ee);
    var i = {
      subscribers: [],
      fire: n,
      subscribe: function subscribe(e) {
        -1 === i.subscribers.indexOf(e) && (i.subscribers.push(e), i.fire = t(i.fire, e));
      },
      unsubscribe: function unsubscribe(e) {
        i.subscribers = i.subscribers.filter(function (t) {
          return t !== e;
        }), i.fire = i.subscribers.reduce(t, n);
      }
    };
    return r[e] = s[e] = i, i;
  }

  function u(e) {
    t(e).forEach(function (t) {
      var r = e[t];
      if (n(r)) a(t, e[t][0], e[t][1]);else {
        if ("asap" !== r) throw new X.InvalidArgument("Invalid event config");
        var s = a(t, te, function () {
          for (var e = arguments.length, t = new Array(e); e--;) {
            t[e] = arguments[e];
          }

          s.subscribers.forEach(function (e) {
            v(function () {
              e.apply(null, t);
            });
          });
        });
      }
    });
  }
}

function Pt(e, t) {
  return c(t).from({
    prototype: e
  }), t;
}

function Kt(e, t) {
  return !(e.filter || e.algorithm || e.or) && (t ? e.justLimit : !e.replayFilter);
}

function Ot(e, t) {
  e.filter = _t(e.filter, t);
}

function St(e, t, n) {
  var r = e.replayFilter;
  e.replayFilter = r ? function () {
    return _t(r(), t());
  } : t, e.justLimit = n && !r;
}

function At(e, t) {
  if (e.isPrimKey) return t.primaryKey;
  var n = t.getIndexByKeyPath(e.index);
  if (!n) throw new X.Schema("KeyPath " + e.index + " on object store " + t.name + " is not indexed");
  return n;
}

function Ct(e, t, n) {
  var r = At(e, t.schema);
  return t.openCursor({
    trans: n,
    values: !e.keysOnly,
    reverse: "prev" === e.dir,
    unique: !!e.unique,
    query: {
      index: r,
      range: e.range
    }
  });
}

function jt(e, t, n, r) {
  var s = e.replayFilter ? _t(e.filter, e.replayFilter()) : e.filter;

  if (e.or) {
    var _i = {},
        _a = function _a(e, n, r) {
      if (!s || s(n, r, function (e) {
        return n.stop(e);
      }, function (e) {
        return n.fail(e);
      })) {
        var a = n.primaryKey,
            u = "" + a;
        "[object ArrayBuffer]" === u && (u = "" + new Uint8Array(a)), o(_i, u) || (_i[u] = !0, t(e, n, r));
      }
    };

    return Promise.all([e.or._iterate(_a, n), Dt(Ct(e, r, n), e.algorithm, _a, !e.keysOnly && e.valueMapper)]);
  }

  return Dt(Ct(e, r, n), _t(e.algorithm, s), t, !e.keysOnly && e.valueMapper);
}

function Dt(e, t, n, r) {
  var s = We(r ? function (e, t, s) {
    return n(r(e), t, s);
  } : n);
  return e.then(function (e) {
    if (e) return e.start(function () {
      var n = function n() {
        return e.continue();
      };

      t && !t(e, function (e) {
        return n = e;
      }, function (t) {
        e.stop(t), n = ee;
      }, function (t) {
        e.fail(t), n = ee;
      }) || s(e.value, e, function (e) {
        return n = e;
      }), n();
    });
  });
}

function It(e, t) {
  try {
    var _n4 = Bt(e),
        _r = Bt(t);

    if (_n4 !== _r) return "Array" === _n4 ? 1 : "Array" === _r ? -1 : "binary" === _n4 ? 1 : "binary" === _r ? -1 : "string" === _n4 ? 1 : "string" === _r ? -1 : "Date" === _n4 ? 1 : "Date" !== _r ? NaN : -1;

    switch (_n4) {
      case "number":
      case "Date":
      case "string":
        return e > t ? 1 : e < t ? -1 : 0;

      case "binary":
        return function (e, t) {
          var n = e.length,
              r = t.length,
              s = n < r ? n : r;

          for (var _n5 = 0; _n5 < s; ++_n5) {
            if (e[_n5] !== t[_n5]) return e[_n5] < t[_n5] ? -1 : 1;
          }

          return n === r ? 0 : n < r ? -1 : 1;
        }(Tt(e), Tt(t));

      case "Array":
        return function (e, t) {
          var n = e.length,
              r = t.length,
              s = n < r ? n : r;

          for (var _n6 = 0; _n6 < s; ++_n6) {
            var _r2 = It(e[_n6], t[_n6]);

            if (0 !== _r2) return _r2;
          }

          return n === r ? 0 : n < r ? -1 : 1;
        }(e, t);
    }
  } catch (e) {}

  return NaN;
}

function Bt(e) {
  var t = typeof e;
  if ("object" !== t) return t;
  if (ArrayBuffer.isView(e)) return "binary";
  var n = C(e);
  return "ArrayBuffer" === n ? "binary" : n;
}

function Tt(e) {
  return e instanceof Uint8Array ? e : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : new Uint8Array(e);
}

var Rt = /*#__PURE__*/function () {
  function Rt() {
    (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, Rt);
  }

  (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Rt, [{
    key: "_read",
    value: function _read(e, t) {
      var n = this._ctx;
      return n.error ? n.table._trans(null, ht.bind(null, n.error)) : n.table._trans("readonly", e).then(t);
    }
  }, {
    key: "_write",
    value: function _write(e) {
      var t = this._ctx;
      return t.error ? t.table._trans(null, ht.bind(null, t.error)) : t.table._trans("readwrite", e, "locked");
    }
  }, {
    key: "_addAlgorithm",
    value: function _addAlgorithm(e) {
      var t = this._ctx;
      t.algorithm = _t(t.algorithm, e);
    }
  }, {
    key: "_iterate",
    value: function _iterate(e, t) {
      return jt(this._ctx, e, t, this._ctx.table.core);
    }
  }, {
    key: "clone",
    value: function clone(e) {
      var t = Object.create(this.constructor.prototype),
          n = Object.create(this._ctx);
      return e && r(n, e), t._ctx = n, t;
    }
  }, {
    key: "raw",
    value: function raw() {
      return this._ctx.valueMapper = null, this;
    }
  }, {
    key: "each",
    value: function each(e) {
      var t = this._ctx;
      return this._read(function (n) {
        return jt(t, e, n, t.table.core);
      });
    }
  }, {
    key: "count",
    value: function count(e) {
      var _this13 = this;

      return this._read(function (e) {
        var t = _this13._ctx,
            n = t.table.core;
        if (Kt(t, !0)) return n.count({
          trans: e,
          query: {
            index: At(t, n.schema),
            range: t.range
          }
        }).then(function (e) {
          return Math.min(e, t.limit);
        });
        var r = 0;
        return jt(t, function () {
          return ++r, !1;
        }, e, n).then(function () {
          return r;
        });
      }).then(e);
    }
  }, {
    key: "sortBy",
    value: function sortBy(e, t) {
      var n = e.split(".").reverse(),
          r = n[0],
          s = n.length - 1;

      function i(e, t) {
        return t ? i(e[n[t]], t - 1) : e[r];
      }

      var o = "next" === this._ctx.dir ? 1 : -1;

      function a(e, t) {
        var n = i(e, s),
            r = i(t, s);
        return n < r ? -o : n > r ? o : 0;
      }

      return this.toArray(function (e) {
        return e.sort(a);
      }).then(t);
    }
  }, {
    key: "toArray",
    value: function toArray(e) {
      var _this14 = this;

      return this._read(function (e) {
        var t = _this14._ctx;

        if ("next" === t.dir && Kt(t, !0) && t.limit > 0) {
          var _n7 = t.valueMapper,
              _r3 = At(t, t.table.core.schema);

          return t.table.core.query({
            trans: e,
            limit: t.limit,
            values: !0,
            query: {
              index: _r3,
              range: t.range
            }
          }).then(function (_ref9) {
            var e = _ref9.result;
            return _n7 ? e.map(_n7) : e;
          });
        }

        {
          var _n8 = [];
          return jt(t, function (e) {
            return _n8.push(e);
          }, e, t.table.core).then(function () {
            return _n8;
          });
        }
      }, e);
    }
  }, {
    key: "offset",
    value: function offset(e) {
      var t = this._ctx;
      return e <= 0 || (t.offset += e, Kt(t) ? St(t, function () {
        var t = e;
        return function (e, n) {
          return 0 === t || (1 === t ? (--t, !1) : (n(function () {
            e.advance(t), t = 0;
          }), !1));
        };
      }) : St(t, function () {
        var t = e;
        return function () {
          return --t < 0;
        };
      })), this;
    }
  }, {
    key: "limit",
    value: function limit(e) {
      return this._ctx.limit = Math.min(this._ctx.limit, e), St(this._ctx, function () {
        var t = e;
        return function (e, n, r) {
          return --t <= 0 && n(r), t >= 0;
        };
      }, !0), this;
    }
  }, {
    key: "until",
    value: function until(e, t) {
      return Ot(this._ctx, function (n, r, s) {
        return !e(n.value) || (r(s), t);
      }), this;
    }
  }, {
    key: "first",
    value: function first(e) {
      return this.limit(1).toArray(function (e) {
        return e[0];
      }).then(e);
    }
  }, {
    key: "last",
    value: function last(e) {
      return this.reverse().first(e);
    }
  }, {
    key: "filter",
    value: function filter(e) {
      var t, n;
      return Ot(this._ctx, function (t) {
        return e(t.value);
      }), t = this._ctx, n = e, t.isMatch = _t(t.isMatch, n), this;
    }
  }, {
    key: "and",
    value: function and(e) {
      return this.filter(e);
    }
  }, {
    key: "or",
    value: function or(e) {
      return new this.db.WhereClause(this._ctx.table, e, this);
    }
  }, {
    key: "reverse",
    value: function reverse() {
      return this._ctx.dir = "prev" === this._ctx.dir ? "next" : "prev", this._ondirectionchange && this._ondirectionchange(this._ctx.dir), this;
    }
  }, {
    key: "desc",
    value: function desc() {
      return this.reverse();
    }
  }, {
    key: "eachKey",
    value: function eachKey(e) {
      var t = this._ctx;
      return t.keysOnly = !t.isMatch, this.each(function (t, n) {
        e(n.key, n);
      });
    }
  }, {
    key: "eachUniqueKey",
    value: function eachUniqueKey(e) {
      return this._ctx.unique = "unique", this.eachKey(e);
    }
  }, {
    key: "eachPrimaryKey",
    value: function eachPrimaryKey(e) {
      var t = this._ctx;
      return t.keysOnly = !t.isMatch, this.each(function (t, n) {
        e(n.primaryKey, n);
      });
    }
  }, {
    key: "keys",
    value: function keys(e) {
      var t = this._ctx;
      t.keysOnly = !t.isMatch;
      var n = [];
      return this.each(function (e, t) {
        n.push(t.key);
      }).then(function () {
        return n;
      }).then(e);
    }
  }, {
    key: "primaryKeys",
    value: function primaryKeys(e) {
      var t = this._ctx;
      if ("next" === t.dir && Kt(t, !0) && t.limit > 0) return this._read(function (e) {
        var n = At(t, t.table.core.schema);
        return t.table.core.query({
          trans: e,
          values: !1,
          limit: t.limit,
          query: {
            index: n,
            range: t.range
          }
        });
      }).then(function (_ref10) {
        var e = _ref10.result;
        return e;
      }).then(e);
      t.keysOnly = !t.isMatch;
      var n = [];
      return this.each(function (e, t) {
        n.push(t.primaryKey);
      }).then(function () {
        return n;
      }).then(e);
    }
  }, {
    key: "uniqueKeys",
    value: function uniqueKeys(e) {
      return this._ctx.unique = "unique", this.keys(e);
    }
  }, {
    key: "firstKey",
    value: function firstKey(e) {
      return this.limit(1).keys(function (e) {
        return e[0];
      }).then(e);
    }
  }, {
    key: "lastKey",
    value: function lastKey(e) {
      return this.reverse().firstKey(e);
    }
  }, {
    key: "distinct",
    value: function distinct() {
      var e = this._ctx,
          t = e.index && e.table.schema.idxByName[e.index];
      if (!t || !t.multi) return this;
      var n = {};
      return Ot(this._ctx, function (e) {
        var t = e.primaryKey.toString(),
            r = o(n, t);
        return n[t] = !0, !r;
      }), this;
    }
  }, {
    key: "modify",
    value: function modify(e) {
      var _this15 = this;

      var n = this._ctx;
      return this._write(function (r) {
        var s;
        if ("function" == typeof e) s = e;else {
          var i = t(e),
              o = i.length;

          s = function s(t) {
            for (var n = !1, r = 0; r < o; ++r) {
              var s = i[r],
                  a = e[s];
              b(t, s) !== a && (_(t, s, a), n = !0);
            }

            return n;
          };
        }
        var a = n.table.core,
            _a$schema$primaryKey = a.schema.primaryKey,
            u = _a$schema$primaryKey.outbound,
            l = _a$schema$primaryKey.extractKey,
            c = _this15.db._options.modifyChunkSize || 200,
            h = [];
        var d = 0;

        var f = [],
            p = function p(e, n) {
          var r = n.failures,
              s = n.numFailures;
          d += e - s;

          var _iterator = _createForOfIteratorHelper(t(r)),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _e2 = _step.value;
              h.push(r[_e2]);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        };

        return _this15.clone().primaryKeys().then(function (t) {
          var i = function i(o) {
            var h = Math.min(c, t.length - o);
            return a.getMany({
              trans: r,
              keys: t.slice(o, o + h),
              cache: "immutable"
            }).then(function (d) {
              var f = [],
                  y = [],
                  m = u ? [] : null,
                  v = [];

              for (var _e3 = 0; _e3 < h; ++_e3) {
                var _n9 = d[_e3],
                    _r4 = {
                  value: O(_n9),
                  primKey: t[o + _e3]
                };
                !1 !== s.call(_r4, _r4.value, _r4) && (null == _r4.value ? v.push(t[o + _e3]) : u || 0 === It(l(_n9), l(_r4.value)) ? (y.push(_r4.value), u && m.push(t[o + _e3])) : (v.push(t[o + _e3]), f.push(_r4.value)));
              }

              var g = Kt(n) && n.limit === 1 / 0 && ("function" != typeof e || e === Ft) && {
                index: n.index,
                range: n.range
              };
              return Promise.resolve(f.length > 0 && a.mutate({
                trans: r,
                type: "add",
                values: f
              }).then(function (e) {
                for (var _t3 in e.failures) {
                  v.splice(parseInt(_t3), 1);
                }

                p(f.length, e);
              })).then(function () {
                return (y.length > 0 || g && "object" == typeof e) && a.mutate({
                  trans: r,
                  type: "put",
                  keys: m,
                  values: y,
                  criteria: g,
                  changeSpec: "function" != typeof e && e
                }).then(function (e) {
                  return p(y.length, e);
                });
              }).then(function () {
                return (v.length > 0 || g && e === Ft) && a.mutate({
                  trans: r,
                  type: "delete",
                  keys: v,
                  criteria: g
                }).then(function (e) {
                  return p(v.length, e);
                });
              }).then(function () {
                return t.length > o + h && i(o + c);
              });
            });
          };

          return i(0).then(function () {
            if (h.length > 0) throw new z("Error modifying one or more objects", h, d, f);
            return t.length;
          });
        });
      });
    }
  }, {
    key: "delete",
    value: function _delete() {
      var e = this._ctx,
          t = e.range;
      return Kt(e) && (e.isPrimKey && !gt || 3 === t.type) ? this._write(function (n) {
        var r = e.table.core.schema.primaryKey,
            s = t;
        return e.table.core.count({
          trans: n,
          query: {
            index: r,
            range: s
          }
        }).then(function (t) {
          return e.table.core.mutate({
            trans: n,
            type: "deleteRange",
            range: s
          }).then(function (_ref11) {
            var e = _ref11.failures,
                n = _ref11.lastResult,
                r = _ref11.results,
                s = _ref11.numFailures;
            if (s) throw new z("Could not delete some values", Object.keys(e).map(function (t) {
              return e[t];
            }), t - s);
            return t - s;
          });
        });
      }) : this.modify(Ft);
    }
  }]);

  return Rt;
}();

var Ft = function Ft(e, t) {
  return t.value = null;
};

function Mt(e, t) {
  return e < t ? -1 : e === t ? 0 : 1;
}

function Nt(e, t) {
  return e > t ? -1 : e === t ? 0 : 1;
}

function qt(e, t, n) {
  var r = e instanceof Yt ? new e.Collection(e) : e;
  return r._ctx.error = n ? new n(t) : new TypeError(t), r;
}

function $t(e) {
  return new e.Collection(e, function () {
    return Wt("");
  }).limit(0);
}

function Ut(e, t, n, r, s, i) {
  for (var o = Math.min(e.length, r.length), a = -1, u = 0; u < o; ++u) {
    var l = t[u];
    if (l !== r[u]) return s(e[u], n[u]) < 0 ? e.substr(0, u) + n[u] + n.substr(u + 1) : s(e[u], r[u]) < 0 ? e.substr(0, u) + r[u] + n.substr(u + 1) : a >= 0 ? e.substr(0, a) + t[a] + n.substr(a + 1) : null;
    s(e[u], l) < 0 && (a = u);
  }

  return o < r.length && "next" === i ? e + n.substr(e.length) : o < e.length && "prev" === i ? e.substr(0, n.length) : a < 0 ? null : e.substr(0, a) + r[a] + n.substr(a + 1);
}

function Lt(e, t, n, r) {
  var s,
      i,
      o,
      a,
      u,
      l,
      c,
      h = n.length;
  if (!n.every(function (e) {
    return "string" == typeof e;
  })) return qt(e, "String expected.");

  function d(e) {
    s = function (e) {
      return "next" === e ? function (e) {
        return e.toUpperCase();
      } : function (e) {
        return e.toLowerCase();
      };
    }(e), i = function (e) {
      return "next" === e ? function (e) {
        return e.toLowerCase();
      } : function (e) {
        return e.toUpperCase();
      };
    }(e), o = "next" === e ? Mt : Nt;
    var t = n.map(function (e) {
      return {
        lower: i(e),
        upper: s(e)
      };
    }).sort(function (e, t) {
      return o(e.lower, t.lower);
    });
    a = t.map(function (e) {
      return e.upper;
    }), u = t.map(function (e) {
      return e.lower;
    }), l = e, c = "next" === e ? "" : r;
  }

  d("next");
  var f = new e.Collection(e, function () {
    return Vt(a[0], u[h - 1] + r);
  });

  f._ondirectionchange = function (e) {
    d(e);
  };

  var p = 0;
  return f._addAlgorithm(function (e, n, r) {
    var s = e.key;
    if ("string" != typeof s) return !1;
    var d = i(s);
    if (t(d, u, p)) return !0;

    for (var f = null, y = p; y < h; ++y) {
      var m = Ut(s, d, a[y], u[y], o, l);
      null === m && null === f ? p = y + 1 : (null === f || o(f, m) > 0) && (f = m);
    }

    return n(null !== f ? function () {
      e.continue(f + c);
    } : r), !1;
  }), f;
}

function Vt(e, t, n, r) {
  return {
    type: 2,
    lower: e,
    upper: t,
    lowerOpen: n,
    upperOpen: r
  };
}

function Wt(e) {
  return {
    type: 1,
    lower: e,
    upper: e
  };
}

var Yt = /*#__PURE__*/function () {
  function Yt() {
    (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, Yt);
  }

  (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Yt, [{
    key: "Collection",
    get: function get() {
      return this._ctx.table.db.Collection;
    }
  }, {
    key: "between",
    value: function between(e, t, n, r) {
      n = !1 !== n, r = !0 === r;

      try {
        return this._cmp(e, t) > 0 || 0 === this._cmp(e, t) && (n || r) && (!n || !r) ? $t(this) : new this.Collection(this, function () {
          return Vt(e, t, !n, !r);
        });
      } catch (e) {
        return qt(this, pt);
      }
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return null == e ? qt(this, pt) : new this.Collection(this, function () {
        return Wt(e);
      });
    }
  }, {
    key: "above",
    value: function above(e) {
      return null == e ? qt(this, pt) : new this.Collection(this, function () {
        return Vt(e, void 0, !0);
      });
    }
  }, {
    key: "aboveOrEqual",
    value: function aboveOrEqual(e) {
      return null == e ? qt(this, pt) : new this.Collection(this, function () {
        return Vt(e, void 0, !1);
      });
    }
  }, {
    key: "below",
    value: function below(e) {
      return null == e ? qt(this, pt) : new this.Collection(this, function () {
        return Vt(void 0, e, !1, !0);
      });
    }
  }, {
    key: "belowOrEqual",
    value: function belowOrEqual(e) {
      return null == e ? qt(this, pt) : new this.Collection(this, function () {
        return Vt(void 0, e);
      });
    }
  }, {
    key: "startsWith",
    value: function startsWith(e) {
      return "string" != typeof e ? qt(this, "String expected.") : this.between(e, e + ft, !0, !0);
    }
  }, {
    key: "startsWithIgnoreCase",
    value: function startsWithIgnoreCase(e) {
      return "" === e ? this.startsWith(e) : Lt(this, function (e, t) {
        return 0 === e.indexOf(t[0]);
      }, [e], ft);
    }
  }, {
    key: "equalsIgnoreCase",
    value: function equalsIgnoreCase(e) {
      return Lt(this, function (e, t) {
        return e === t[0];
      }, [e], "");
    }
  }, {
    key: "anyOfIgnoreCase",
    value: function anyOfIgnoreCase() {
      var e = B.apply(I, arguments);
      return 0 === e.length ? $t(this) : Lt(this, function (e, t) {
        return -1 !== t.indexOf(e);
      }, e, "");
    }
  }, {
    key: "startsWithAnyOfIgnoreCase",
    value: function startsWithAnyOfIgnoreCase() {
      var e = B.apply(I, arguments);
      return 0 === e.length ? $t(this) : Lt(this, function (e, t) {
        return t.some(function (t) {
          return 0 === e.indexOf(t);
        });
      }, e, ft);
    }
  }, {
    key: "anyOf",
    value: function anyOf() {
      var _this16 = this;

      var e = B.apply(I, arguments);
      var t = this._cmp;

      try {
        e.sort(t);
      } catch (e) {
        return qt(this, pt);
      }

      if (0 === e.length) return $t(this);
      var n = new this.Collection(this, function () {
        return Vt(e[0], e[e.length - 1]);
      });

      n._ondirectionchange = function (n) {
        t = "next" === n ? _this16._ascending : _this16._descending, e.sort(t);
      };

      var r = 0;
      return n._addAlgorithm(function (n, s, i) {
        var o = n.key;

        for (; t(o, e[r]) > 0;) {
          if (++r, r === e.length) return s(i), !1;
        }

        return 0 === t(o, e[r]) || (s(function () {
          n.continue(e[r]);
        }), !1);
      }), n;
    }
  }, {
    key: "notEqual",
    value: function notEqual(e) {
      return this.inAnyRange([[-(1 / 0), e], [e, this.db._maxKey]], {
        includeLowers: !1,
        includeUppers: !1
      });
    }
  }, {
    key: "noneOf",
    value: function noneOf() {
      var e = B.apply(I, arguments);
      if (0 === e.length) return new this.Collection(this);

      try {
        e.sort(this._ascending);
      } catch (e) {
        return qt(this, pt);
      }

      var t = e.reduce(function (e, t) {
        return e ? e.concat([[e[e.length - 1][1], t]]) : [[-(1 / 0), t]];
      }, null);
      return t.push([e[e.length - 1], this.db._maxKey]), this.inAnyRange(t, {
        includeLowers: !1,
        includeUppers: !1
      });
    }
  }, {
    key: "inAnyRange",
    value: function inAnyRange(e, t) {
      var _this17 = this;

      var n = this._cmp,
          r = this._ascending,
          s = this._descending,
          i = this._min,
          o = this._max;
      if (0 === e.length) return $t(this);
      if (!e.every(function (e) {
        return void 0 !== e[0] && void 0 !== e[1] && r(e[0], e[1]) <= 0;
      })) return qt(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", X.InvalidArgument);
      var a = !t || !1 !== t.includeLowers,
          u = t && !0 === t.includeUppers;
      var l,
          c = r;

      function h(e, t) {
        return c(e[0], t[0]);
      }

      try {
        l = e.reduce(function (e, t) {
          var r = 0,
              s = e.length;

          for (; r < s; ++r) {
            var _s = e[r];

            if (n(t[0], _s[1]) < 0 && n(t[1], _s[0]) > 0) {
              _s[0] = i(_s[0], t[0]), _s[1] = o(_s[1], t[1]);
              break;
            }
          }

          return r === s && e.push(t), e;
        }, []), l.sort(h);
      } catch (e) {
        return qt(this, pt);
      }

      var d = 0;
      var f = u ? function (e) {
        return r(e, l[d][1]) > 0;
      } : function (e) {
        return r(e, l[d][1]) >= 0;
      },
          p = a ? function (e) {
        return s(e, l[d][0]) > 0;
      } : function (e) {
        return s(e, l[d][0]) >= 0;
      };
      var y = f;
      var m = new this.Collection(this, function () {
        return Vt(l[0][0], l[l.length - 1][1], !a, !u);
      });
      return m._ondirectionchange = function (e) {
        "next" === e ? (y = f, c = r) : (y = p, c = s), l.sort(h);
      }, m._addAlgorithm(function (e, t, n) {
        for (var s = e.key; y(s);) {
          if (++d, d === l.length) return t(n), !1;
        }

        return !!function (e) {
          return !f(e) && !p(e);
        }(s) || (0 === _this17._cmp(s, l[d][1]) || 0 === _this17._cmp(s, l[d][0]) || t(function () {
          c === r ? e.continue(l[d][0]) : e.continue(l[d][1]);
        }), !1);
      }), m;
    }
  }, {
    key: "startsWithAnyOf",
    value: function startsWithAnyOf() {
      var e = B.apply(I, arguments);
      return e.every(function (e) {
        return "string" == typeof e;
      }) ? 0 === e.length ? $t(this) : this.inAnyRange(e.map(function (e) {
        return [e, e + ft];
      })) : qt(this, "startsWithAnyOf() only works with strings");
    }
  }]);

  return Yt;
}();

function zt(e) {
  return We(function (t) {
    return Gt(t), e(t.target.error), !1;
  });
}

function Gt(e) {
  e.stopPropagation && e.stopPropagation(), e.preventDefault && e.preventDefault();
}

var Ht = Et(null, "storagemutated");

var Qt = /*#__PURE__*/function () {
  function Qt() {
    (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, Qt);
  }

  (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Qt, [{
    key: "_lock",
    value: function _lock() {
      return m(!Ke.global), ++this._reculock, 1 !== this._reculock || Ke.global || (Ke.lockOwnerFor = this), this;
    }
  }, {
    key: "_unlock",
    value: function _unlock() {
      if (m(!Ke.global), 0 == --this._reculock) for (Ke.global || (Ke.lockOwnerFor = null); this._blockedFuncs.length > 0 && !this._locked();) {
        var e = this._blockedFuncs.shift();

        try {
          ot(e[1], e[0]);
        } catch (e) {}
      }
      return this;
    }
  }, {
    key: "_locked",
    value: function _locked() {
      return this._reculock && Ke.lockOwnerFor !== this;
    }
  }, {
    key: "create",
    value: function create(e) {
      var _this18 = this;

      if (!this.mode) return this;
      var t = this.db.idbdb,
          n = this.db._state.dbOpenError;
      if (m(!this.idbtrans), !e && !t) switch (n && n.name) {
        case "DatabaseClosedError":
          throw new X.DatabaseClosed(n);

        case "MissingAPIError":
          throw new X.MissingAPI(n.message, n);

        default:
          throw new X.OpenFailed(n);
      }
      if (!this.active) throw new X.TransactionInactive();
      return m(null === this._completion._state), (e = this.idbtrans = e || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
        durability: this.chromeTransactionDurability
      }) : t.transaction(this.storeNames, this.mode, {
        durability: this.chromeTransactionDurability
      }))).onerror = We(function (t) {
        Gt(t), _this18._reject(e.error);
      }), e.onabort = We(function (t) {
        Gt(t), _this18.active && _this18._reject(new X.Abort(e.error)), _this18.active = !1, _this18.on("abort").fire(t);
      }), e.oncomplete = We(function () {
        _this18.active = !1, _this18._resolve(), "mutatedParts" in e && Ht.storagemutated.fire(e.mutatedParts);
      }), this;
    }
  }, {
    key: "_promise",
    value: function _promise(e, t, n) {
      var _this19 = this;

      if ("readwrite" === e && "readwrite" !== this.mode) return ht(new X.ReadOnly("Transaction is readonly"));
      if (!this.active) return ht(new X.TransactionInactive());
      if (this._locked()) return new Ce(function (r, s) {
        _this19._blockedFuncs.push([function () {
          _this19._promise(e, t, n).then(r, s);
        }, Ke]);
      });
      if (n) return Je(function () {
        var e = new Ce(function (e, n) {
          _this19._lock();

          var r = t(e, n, _this19);
          r && r.then && r.then(e, n);
        });
        return e.finally(function () {
          return _this19._unlock();
        }), e._lib = !0, e;
      });
      var r = new Ce(function (e, n) {
        var r = t(e, n, _this19);
        r && r.then && r.then(e, n);
      });
      return r._lib = !0, r;
    }
  }, {
    key: "_root",
    value: function _root() {
      return this.parent ? this.parent._root() : this;
    }
  }, {
    key: "waitFor",
    value: function waitFor(e) {
      var t = this._root();

      var n = Ce.resolve(e);
      if (t._waitingFor) t._waitingFor = t._waitingFor.then(function () {
        return n;
      });else {
        t._waitingFor = n, t._waitingQueue = [];
        var r = t.idbtrans.objectStore(t.storeNames[0]);
        !function e() {
          for (++t._spinCount; t._waitingQueue.length;) {
            t._waitingQueue.shift()();
          }

          t._waitingFor && (r.get(-1 / 0).onsuccess = e);
        }();
      }
      var s = t._waitingFor;
      return new Ce(function (e, r) {
        n.then(function (n) {
          return t._waitingQueue.push(We(e.bind(null, n)));
        }, function (e) {
          return t._waitingQueue.push(We(r.bind(null, e)));
        }).finally(function () {
          t._waitingFor === s && (t._waitingFor = null);
        });
      });
    }
  }, {
    key: "abort",
    value: function abort() {
      this.active && (this.active = !1, this.idbtrans && this.idbtrans.abort(), this._reject(new X.Abort()));
    }
  }, {
    key: "table",
    value: function table(e) {
      var t = this._memoizedTables || (this._memoizedTables = {});
      if (o(t, e)) return t[e];
      var n = this.schema[e];
      if (!n) throw new X.NotFound("Table " + e + " not part of transaction");
      var r = new this.db.Table(e, n, this);
      return r.core = this.db.core.table(e), t[e] = r, r;
    }
  }]);

  return Qt;
}();

function Xt(e, t, n, r, s, i, o) {
  return {
    name: e,
    keyPath: t,
    unique: n,
    multi: r,
    auto: s,
    compound: i,
    src: (n && !o ? "&" : "") + (r ? "*" : "") + (s ? "++" : "") + Jt(t)
  };
}

function Jt(e) {
  return "string" == typeof e ? e : e ? "[" + [].join.call(e, "+") + "]" : "";
}

function Zt(e, t, n) {
  return {
    name: e,
    primKey: t,
    indexes: n,
    mappedClass: null,
    idxByName: g(n, function (e) {
      return [e.name, e];
    })
  };
}

var _en = function en(e) {
  try {
    return e.only([[]]), _en = function en() {
      return [[]];
    }, [[]];
  } catch (e) {
    return _en = function en() {
      return ft;
    }, ft;
  }
};

function tn(e) {
  return null == e ? function () {} : "string" == typeof e ? function (e) {
    return 1 === e.split(".").length ? function (t) {
      return t[e];
    } : function (t) {
      return b(t, e);
    };
  }(e) : function (t) {
    return b(t, e);
  };
}

function nn(e) {
  return [].slice.call(e);
}

var rn = 0;

function sn(e) {
  return null == e ? ":id" : "string" == typeof e ? e : "[".concat(e.join("+"), "]");
}

function on(e, t, r) {
  function s(e) {
    if (3 === e.type) return null;
    if (4 === e.type) throw new Error("Cannot convert never type to IDBKeyRange");
    var n = e.lower,
        r = e.upper,
        s = e.lowerOpen,
        i = e.upperOpen;
    return void 0 === n ? void 0 === r ? null : t.upperBound(r, !!i) : void 0 === r ? t.lowerBound(n, !!s) : t.bound(n, r, !!s, !!i);
  }

  var _ref12 = function (e, t) {
    var r = nn(e.objectStoreNames);
    return {
      schema: {
        name: e.name,
        tables: r.map(function (e) {
          return t.objectStore(e);
        }).map(function (e) {
          var t = e.keyPath,
              r = e.autoIncrement,
              s = n(t),
              i = null == t,
              o = {},
              a = {
            name: e.name,
            primaryKey: {
              name: null,
              isPrimaryKey: !0,
              outbound: i,
              compound: s,
              keyPath: t,
              autoIncrement: r,
              unique: !0,
              extractKey: tn(t)
            },
            indexes: nn(e.indexNames).map(function (t) {
              return e.index(t);
            }).map(function (e) {
              var t = e.name,
                  r = e.unique,
                  s = e.multiEntry,
                  i = e.keyPath,
                  a = {
                name: t,
                compound: n(i),
                keyPath: i,
                unique: r,
                multiEntry: s,
                extractKey: tn(i)
              };
              return o[sn(i)] = a, a;
            }),
            getIndexByKeyPath: function getIndexByKeyPath(e) {
              return o[sn(e)];
            }
          };
          return o[":id"] = a.primaryKey, null != t && (o[sn(t)] = a.primaryKey), a;
        })
      },
      hasGetAll: r.length > 0 && "getAll" in t.objectStore(r[0]) && !("undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
    };
  }(e, r),
      i = _ref12.schema,
      o = _ref12.hasGetAll,
      a = i.tables.map(function (e) {
    return function (e) {
      var t = e.name;
      return {
        name: t,
        schema: e,
        mutate: function mutate(_ref13) {
          var e = _ref13.trans,
              n = _ref13.type,
              r = _ref13.keys,
              i = _ref13.values,
              o = _ref13.range;
          return new Promise(function (a, u) {
            a = We(a);
            var l = e.objectStore(t),
                c = null == l.keyPath,
                h = "put" === n || "add" === n;
            if (!h && "delete" !== n && "deleteRange" !== n) throw new Error("Invalid operation type: " + n);

            var _ref14 = r || i || {
              length: 1
            },
                d = _ref14.length;

            if (r && i && r.length !== i.length) throw new Error("Given keys array must have same length as given values array.");
            if (0 === d) return a({
              numFailures: 0,
              failures: {},
              results: [],
              lastResult: void 0
            });
            var f;
            var p = [],
                y = [];
            var m = 0;

            var v = function v(e) {
              ++m, Gt(e);
            };

            if ("deleteRange" === n) {
              if (4 === o.type) return a({
                numFailures: m,
                failures: y,
                results: [],
                lastResult: void 0
              });
              3 === o.type ? p.push(f = l.clear()) : p.push(f = l.delete(s(o)));
            } else {
              var _ref15 = h ? c ? [i, r] : [i, null] : [r, null],
                  _ref16 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref15, 2),
                  _e4 = _ref16[0],
                  _t4 = _ref16[1];

              if (h) for (var _r5 = 0; _r5 < d; ++_r5) {
                p.push(f = _t4 && void 0 !== _t4[_r5] ? l[n](_e4[_r5], _t4[_r5]) : l[n](_e4[_r5])), f.onerror = v;
              } else for (var _t5 = 0; _t5 < d; ++_t5) {
                p.push(f = l[n](_e4[_t5])), f.onerror = v;
              }
            }

            var g = function g(e) {
              var t = e.target.result;
              p.forEach(function (e, t) {
                return null != e.error && (y[t] = e.error);
              }), a({
                numFailures: m,
                failures: y,
                results: "delete" === n ? r : p.map(function (e) {
                  return e.result;
                }),
                lastResult: t
              });
            };

            f.onerror = function (e) {
              v(e), g(e);
            }, f.onsuccess = g;
          });
        },
        getMany: function getMany(_ref17) {
          var e = _ref17.trans,
              n = _ref17.keys;
          return new Promise(function (r, s) {
            r = We(r);
            var i = e.objectStore(t),
                o = n.length,
                a = new Array(o);
            var u,
                l = 0,
                c = 0;

            var h = function h(e) {
              var t = e.target;
              a[t._pos] = t.result, ++c === l && r(a);
            },
                d = zt(s);

            for (var _e5 = 0; _e5 < o; ++_e5) {
              null != n[_e5] && (u = i.get(n[_e5]), u._pos = _e5, u.onsuccess = h, u.onerror = d, ++l);
            }

            0 === l && r(a);
          });
        },
        get: function get(_ref18) {
          var e = _ref18.trans,
              n = _ref18.key;
          return new Promise(function (r, s) {
            r = We(r);
            var i = e.objectStore(t).get(n);
            i.onsuccess = function (e) {
              return r(e.target.result);
            }, i.onerror = zt(s);
          });
        },
        query: function (e) {
          return function (n) {
            return new Promise(function (r, i) {
              r = We(r);
              var o = n.trans,
                  a = n.values,
                  u = n.limit,
                  l = n.query,
                  c = u === 1 / 0 ? void 0 : u,
                  h = l.index,
                  d = l.range,
                  f = o.objectStore(t),
                  p = h.isPrimaryKey ? f : f.index(h.name),
                  y = s(d);
              if (0 === u) return r({
                result: []
              });

              if (e) {
                var _e6 = a ? p.getAll(y, c) : p.getAllKeys(y, c);

                _e6.onsuccess = function (e) {
                  return r({
                    result: e.target.result
                  });
                }, _e6.onerror = zt(i);
              } else {
                var _e7 = 0;

                var _t6 = a || !("openKeyCursor" in p) ? p.openCursor(y) : p.openKeyCursor(y),
                    _n10 = [];

                _t6.onsuccess = function (s) {
                  var i = _t6.result;
                  return i ? (_n10.push(a ? i.value : i.primaryKey), ++_e7 === u ? r({
                    result: _n10
                  }) : void i.continue()) : r({
                    result: _n10
                  });
                }, _t6.onerror = zt(i);
              }
            });
          };
        }(o),
        openCursor: function openCursor(_ref19) {
          var e = _ref19.trans,
              n = _ref19.values,
              r = _ref19.query,
              i = _ref19.reverse,
              o = _ref19.unique;
          return new Promise(function (a, u) {
            a = We(a);
            var l = r.index,
                c = r.range,
                h = e.objectStore(t),
                d = l.isPrimaryKey ? h : h.index(l.name),
                f = i ? o ? "prevunique" : "prev" : o ? "nextunique" : "next",
                p = n || !("openKeyCursor" in d) ? d.openCursor(s(c), f) : d.openKeyCursor(s(c), f);
            p.onerror = zt(u), p.onsuccess = We(function (t) {
              var n = p.result;
              if (!n) return void a(null);
              n.___id = ++rn, n.done = !1;
              var r = n.continue.bind(n);
              var s = n.continuePrimaryKey;
              s && (s = s.bind(n));

              var i = n.advance.bind(n),
                  o = function o() {
                throw new Error("Cursor not stopped");
              };

              n.trans = e, n.stop = n.continue = n.continuePrimaryKey = n.advance = function () {
                throw new Error("Cursor not started");
              }, n.fail = We(u), n.next = function () {
                var _this20 = this;

                var e = 1;
                return this.start(function () {
                  return e-- ? _this20.continue() : _this20.stop();
                }).then(function () {
                  return _this20;
                });
              }, n.start = function (e) {
                var t = new Promise(function (e, t) {
                  e = We(e), p.onerror = zt(t), n.fail = t, n.stop = function (t) {
                    n.stop = n.continue = n.continuePrimaryKey = n.advance = o, e(t);
                  };
                }),
                    a = function a() {
                  if (p.result) try {
                    e();
                  } catch (e) {
                    n.fail(e);
                  } else n.done = !0, n.start = function () {
                    throw new Error("Cursor behind last entry");
                  }, n.stop();
                };

                return p.onsuccess = We(function (e) {
                  p.onsuccess = a, a();
                }), n.continue = r, n.continuePrimaryKey = s, n.advance = i, a(), t;
              }, a(n);
            }, u);
          });
        },
        count: function count(_ref20) {
          var e = _ref20.query,
              n = _ref20.trans;
          var r = e.index,
              i = e.range;
          return new Promise(function (e, o) {
            var a = n.objectStore(t),
                u = r.isPrimaryKey ? a : a.index(r.name),
                l = s(i),
                c = l ? u.count(l) : u.count();
            c.onsuccess = We(function (t) {
              return e(t.target.result);
            }), c.onerror = zt(o);
          });
        }
      };
    }(e);
  }),
      u = {};

  return a.forEach(function (e) {
    return u[e.name] = e;
  }), {
    stack: "dbcore",
    transaction: e.transaction.bind(e),
    table: function table(e) {
      if (!u[e]) throw new Error("Table '".concat(e, "' not found"));
      return u[e];
    },
    MIN_KEY: -1 / 0,
    MAX_KEY: _en(t),
    schema: i
  };
}

function an(_ref21, t) {
  var e = _ref21._novip;

  var n = t.db,
      r = function (e, t, _ref22, s) {
    var n = _ref22.IDBKeyRange,
        r = _ref22.indexedDB;

    var i = function (e, t) {
      return t.reduce(function (e, _ref23) {
        var t = _ref23.create;
        return _objectSpread(_objectSpread({}, e), t(e));
      }, e);
    }(on(t, n, s), e.dbcore);

    return {
      dbcore: i
    };
  }(e._middlewares, n, e._deps, t);

  e.core = r.dbcore, e.tables.forEach(function (t) {
    var n = t.name;
    e.core.schema.tables.some(function (e) {
      return e.name === n;
    }) && (t.core = e.core.table(n), e[n] instanceof e.Table && (e[n].core = t.core));
  });
}

function un(_ref24, t, n, r) {
  var e = _ref24._novip;
  n.forEach(function (n) {
    var s = r[n];
    t.forEach(function (t) {
      var r = d(t, n);
      (!r || "value" in r && void 0 === r.value) && (t === e.Transaction.prototype || t instanceof e.Transaction ? l(t, n, {
        get: function get() {
          return this.table(n);
        },
        set: function set(e) {
          u(this, n, {
            value: e,
            writable: !0,
            configurable: !0,
            enumerable: !0
          });
        }
      }) : t[n] = new e.Table(n, s));
    });
  });
}

function ln(_ref25, t) {
  var e = _ref25._novip;
  t.forEach(function (t) {
    for (var _n11 in t) {
      t[_n11] instanceof e.Table && delete t[_n11];
    }
  });
}

function cn(e, t) {
  return e._cfg.version - t._cfg.version;
}

function hn(e, n, r, s) {
  var i = e._dbSchema,
      o = e._createTransaction("readwrite", e._storeNames, i);

  o.create(r), o._completion.catch(s);

  var a = o._reject.bind(o),
      u = Ke.transless || Ke;

  Je(function () {
    Ke.trans = o, Ke.transless = u, 0 === n ? (t(i).forEach(function (e) {
      fn(r, e, i[e].primKey, i[e].indexes);
    }), an(e, r), Ce.follow(function () {
      return e.on.populate.fire(o);
    }).catch(a)) : function (_ref26, n, r, s) {
      var e = _ref26._novip;
      var i = [],
          o = e._versions;
      var a = e._dbSchema = yn(e, e.idbdb, s),
          u = !1;

      function l() {
        return i.length ? Ce.resolve(i.shift()(r.idbtrans)).then(l) : Ce.resolve();
      }

      return o.filter(function (e) {
        return e._cfg.version >= n;
      }).forEach(function (o) {
        i.push(function () {
          var i = a,
              l = o._cfg.dbschema;
          mn(e, i, s), mn(e, l, s), a = e._dbSchema = l;
          var c = dn(i, l);
          c.add.forEach(function (e) {
            fn(s, e[0], e[1].primKey, e[1].indexes);
          }), c.change.forEach(function (e) {
            if (e.recreate) throw new X.Upgrade("Not yet support for changing primary key");
            {
              var _t7 = s.objectStore(e.name);

              e.add.forEach(function (e) {
                return pn(_t7, e);
              }), e.change.forEach(function (e) {
                _t7.deleteIndex(e.name), pn(_t7, e);
              }), e.del.forEach(function (e) {
                return _t7.deleteIndex(e);
              });
            }
          });
          var h = o._cfg.contentUpgrade;

          if (h && o._cfg.version > n) {
            an(e, s), r._memoizedTables = {}, u = !0;

            var _n12 = w(l);

            c.del.forEach(function (e) {
              _n12[e] = i[e];
            }), ln(e, [e.Transaction.prototype]), un(e, [e.Transaction.prototype], t(_n12), _n12), r.schema = _n12;

            var _o = T(h);

            var _a2;

            _o && Ze();

            var _d = Ce.follow(function () {
              if (_a2 = h(r), _a2 && _o) {
                var e = et.bind(null, null);

                _a2.then(e, e);
              }
            });

            return _a2 && "function" == typeof _a2.then ? Ce.resolve(_a2) : _d.then(function () {
              return _a2;
            });
          }
        }), i.push(function (t) {
          if (!u || !vt) {
            !function (e, t) {
              [].slice.call(t.db.objectStoreNames).forEach(function (n) {
                return null == e[n] && t.db.deleteObjectStore(n);
              });
            }(o._cfg.dbschema, t);
          }

          ln(e, [e.Transaction.prototype]), un(e, [e.Transaction.prototype], e._storeNames, e._dbSchema), r.schema = e._dbSchema;
        });
      }), l().then(function () {
        var e, n;
        n = s, t(e = a).forEach(function (t) {
          n.db.objectStoreNames.contains(t) || fn(n, t, e[t].primKey, e[t].indexes);
        });
      });
    }(e, n, o, r).catch(a);
  });
}

function dn(e, t) {
  var n = {
    del: [],
    add: [],
    change: []
  };
  var r;

  for (r in e) {
    t[r] || n.del.push(r);
  }

  for (r in t) {
    var _s2 = e[r],
        _i2 = t[r];

    if (_s2) {
      var _e8 = {
        name: r,
        def: _i2,
        recreate: !1,
        del: [],
        add: [],
        change: []
      };
      if ("" + (_s2.primKey.keyPath || "") != "" + (_i2.primKey.keyPath || "") || _s2.primKey.auto !== _i2.primKey.auto && !mt) _e8.recreate = !0, n.change.push(_e8);else {
        var _t8 = _s2.idxByName,
            _r6 = _i2.idxByName;

        var _o2 = void 0;

        for (_o2 in _t8) {
          _r6[_o2] || _e8.del.push(_o2);
        }

        for (_o2 in _r6) {
          var _n13 = _t8[_o2],
              _s3 = _r6[_o2];
          _n13 ? _n13.src !== _s3.src && _e8.change.push(_s3) : _e8.add.push(_s3);
        }

        (_e8.del.length > 0 || _e8.add.length > 0 || _e8.change.length > 0) && n.change.push(_e8);
      }
    } else n.add.push([r, _i2]);
  }

  return n;
}

function fn(e, t, n, r) {
  var s = e.db.createObjectStore(t, n.keyPath ? {
    keyPath: n.keyPath,
    autoIncrement: n.auto
  } : {
    autoIncrement: n.auto
  });
  return r.forEach(function (e) {
    return pn(s, e);
  }), s;
}

function pn(e, t) {
  e.createIndex(t.name, t.keyPath, {
    unique: t.unique,
    multiEntry: t.multi
  });
}

function yn(e, t, n) {
  var r = {};
  return p(t.objectStoreNames, 0).forEach(function (e) {
    var t = n.objectStore(e);
    var s = t.keyPath;
    var i = Xt(Jt(s), s || "", !1, !1, !!t.autoIncrement, s && "string" != typeof s, !0),
        o = [];

    for (var _e9 = 0; _e9 < t.indexNames.length; ++_e9) {
      var _n14 = t.index(t.indexNames[_e9]);

      s = _n14.keyPath;
      var a = Xt(_n14.name, s, !!_n14.unique, !!_n14.multiEntry, !1, s && "string" != typeof s, !1);
      o.push(a);
    }

    r[e] = Zt(e, i, o);
  }), r;
}

function mn(_ref27, n, r) {
  var t = _ref27._novip;
  var s = r.db.objectStoreNames;

  for (var _e10 = 0; _e10 < s.length; ++_e10) {
    var _i3 = s[_e10],
        _o3 = r.objectStore(_i3);

    t._hasGetAll = "getAll" in _o3;

    for (var _e11 = 0; _e11 < _o3.indexNames.length; ++_e11) {
      var _t9 = _o3.indexNames[_e11],
          _r7 = _o3.index(_t9).keyPath,
          _s4 = "string" == typeof _r7 ? _r7 : "[" + p(_r7).join("+") + "]";

      if (n[_i3]) {
        var _e12 = n[_i3].idxByName[_s4];
        _e12 && (_e12.name = _t9, delete n[_i3].idxByName[_s4], n[_i3].idxByName[_t9] = _e12);
      }
    }
  }

  "undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && e.WorkerGlobalScope && e instanceof e.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604 && (t._hasGetAll = !1);
}

var vn = /*#__PURE__*/function () {
  function vn() {
    (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, vn);
  }

  (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(vn, [{
    key: "_parseStoresSpec",
    value: function _parseStoresSpec(e, r) {
      t(e).forEach(function (t) {
        if (null !== e[t]) {
          var s = e[t].split(",").map(function (e, t) {
            var r = (e = e.trim()).replace(/([&*]|\+\+)/g, ""),
                s = /^\[/.test(r) ? r.match(/^\[(.*)\]$/)[1].split("+") : r;
            return Xt(r, s || null, /\&/.test(e), /\*/.test(e), /\+\+/.test(e), n(s), 0 === t);
          }),
              i = s.shift();
          if (i.multi) throw new X.Schema("Primary key cannot be multi-valued");
          s.forEach(function (e) {
            if (e.auto) throw new X.Schema("Only primary key can be marked as autoIncrement (++)");
            if (!e.keyPath) throw new X.Schema("Index must have a name and cannot be an empty string");
          }), r[t] = Zt(t, i, s);
        }
      });
    }
  }, {
    key: "stores",
    value: function stores(e) {
      var n = this.db;
      this._cfg.storesSource = this._cfg.storesSource ? r(this._cfg.storesSource, e) : e;
      var s = n._versions,
          i = {};
      var o = {};
      return s.forEach(function (e) {
        r(i, e._cfg.storesSource), o = e._cfg.dbschema = {}, e._parseStoresSpec(i, o);
      }), n._dbSchema = o, ln(n, [n._allTables, n, n.Transaction.prototype]), un(n, [n._allTables, n, n.Transaction.prototype, this._cfg.tables], t(o), o), n._storeNames = t(o), this;
    }
  }, {
    key: "upgrade",
    value: function upgrade(e) {
      return this._cfg.contentUpgrade = ue(this._cfg.contentUpgrade || ee, e), this;
    }
  }]);

  return vn;
}();

function gn(e, t) {
  var n = e._dbNamesDB;
  return n || (n = e._dbNamesDB = new $n("__dbnames", {
    addons: [],
    indexedDB: e,
    IDBKeyRange: t
  }), n.version(1).stores({
    dbnames: "name"
  })), n.table("dbnames");
}

function bn(e) {
  return e && "function" == typeof e.databases;
}

function _n(e) {
  return Je(function () {
    return Ke.letThrough = !0, e();
  });
}

function wn() {
  var e;
  return !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent) && indexedDB.databases ? new Promise(function (t) {
    var n = function n() {
      return indexedDB.databases().finally(t);
    };

    e = setInterval(n, 100), n();
  }).finally(function () {
    return clearInterval(e);
  }) : Promise.resolve();
}

function xn(e) {
  var n = e._state,
      r = e._deps.indexedDB;
  if (n.isBeingOpened || e.idbdb) return n.dbReadyPromise.then(function () {
    return n.dbOpenError ? ht(n.dbOpenError) : e;
  });
  R && (n.openCanceller._stackHolder = q()), n.isBeingOpened = !0, n.dbOpenError = null, n.openComplete = !1;
  var s = n.openCanceller;

  function i() {
    if (n.openCanceller !== s) throw new X.DatabaseClosed("db.open() was cancelled");
  }

  var o = n.dbReadyResolve,
      a = null,
      u = !1;
  return Ce.race([s, ("undefined" == typeof navigator ? Ce.resolve() : wn()).then(function () {
    return new Ce(function (s, o) {
      if (i(), !r) throw new X.MissingAPI();
      var l = e.name,
          c = n.autoSchema ? r.open(l) : r.open(l, Math.round(10 * e.verno));
      if (!c) throw new X.MissingAPI();
      c.onerror = zt(o), c.onblocked = We(e._fireOnBlocked), c.onupgradeneeded = We(function (t) {
        if (a = c.transaction, n.autoSchema && !e._options.allowEmptyDB) {
          c.onerror = Gt, a.abort(), c.result.close();

          var _e13 = r.deleteDatabase(l);

          _e13.onsuccess = _e13.onerror = We(function () {
            o(new X.NoSuchDatabase("Database ".concat(l, " doesnt exist")));
          });
        } else {
          a.onerror = zt(o);
          var s = t.oldVersion > Math.pow(2, 62) ? 0 : t.oldVersion;
          u = s < 1, e._novip.idbdb = c.result, hn(e, s / 10, a, o);
        }
      }, o), c.onsuccess = We(function () {
        a = null;
        var r = e._novip.idbdb = c.result,
            i = p(r.objectStoreNames);
        if (i.length > 0) try {
          var _s5 = r.transaction(1 === (o = i).length ? o[0] : o, "readonly");

          n.autoSchema ? function (_ref28, n, r) {
            var e = _ref28._novip;
            e.verno = n.version / 10;
            var s = e._dbSchema = yn(0, n, r);
            e._storeNames = p(n.objectStoreNames, 0), un(e, [e._allTables], t(s), s);
          }(e, r, _s5) : (mn(e, e._dbSchema, _s5), function (e, t) {
            var n = dn(yn(0, e.idbdb, t), e._dbSchema);
            return !(n.add.length || n.change.some(function (e) {
              return e.add.length || e.change.length;
            }));
          }(e, _s5) || console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.")), an(e, _s5);
        } catch (e) {}
        var o;
        yt.push(e), r.onversionchange = We(function (t) {
          n.vcFired = !0, e.on("versionchange").fire(t);
        }), r.onclose = We(function (t) {
          e.on("close").fire(t);
        }), u && function (_ref29, n) {
          var e = _ref29.indexedDB,
              t = _ref29.IDBKeyRange;
          !bn(e) && "__dbnames" !== n && gn(e, t).put({
            name: n
          }).catch(ee);
        }(e._deps, l), s();
      }, o);
    });
  })]).then(function () {
    return i(), n.onReadyBeingFired = [], Ce.resolve(_n(function () {
      return e.on.ready.fire(e.vip);
    })).then(function t() {
      if (n.onReadyBeingFired.length > 0) {
        var _r8 = n.onReadyBeingFired.reduce(ue, ee);

        return n.onReadyBeingFired = [], Ce.resolve(_n(function () {
          return _r8(e.vip);
        })).then(t);
      }
    });
  }).finally(function () {
    n.onReadyBeingFired = null, n.isBeingOpened = !1;
  }).then(function () {
    return e;
  }).catch(function (t) {
    n.dbOpenError = t;

    try {
      a && a.abort();
    } catch (e) {}

    return s === n.openCanceller && e._close(), ht(t);
  }).finally(function () {
    n.openComplete = !0, o();
  });
}

function kn(e) {
  var t = function t(_t10) {
    return e.next(_t10);
  },
      r = i(t),
      s = i(function (t) {
    return e.throw(t);
  });

  function i(e) {
    return function (t) {
      var i = e(t),
          o = i.value;
      return i.done ? o : o && "function" == typeof o.then ? o.then(r, s) : n(o) ? Promise.all(o).then(r, s) : r(o);
    };
  }

  return i(t)();
}

function En(e, t, n) {
  var r = arguments.length;
  if (r < 2) throw new X.InvalidArgument("Too few arguments");

  for (var s = new Array(r - 1); --r;) {
    s[r - 1] = arguments[r];
  }

  n = s.pop();
  var i = k(s);
  return [e, i, n];
}

function Pn(e, t, n, r, s) {
  return Ce.resolve().then(function () {
    var i = Ke.transless || Ke,
        o = e._createTransaction(t, n, e._dbSchema, r),
        a = {
      trans: o,
      transless: i
    };

    if (r) o.idbtrans = r.idbtrans;else try {
      o.create(), e._state.PR1398_maxLoop = 3;
    } catch (r) {
      return r.name === H.InvalidState && e.isOpen() && --e._state.PR1398_maxLoop > 0 ? (console.warn("Dexie: Need to reopen db"), e._close(), e.open().then(function () {
        return Pn(e, t, n, null, s);
      })) : ht(r);
    }
    var u = T(s);
    var l;
    u && Ze();
    var c = Ce.follow(function () {
      if (l = s.call(o, o), l) if (u) {
        var e = et.bind(null, null);
        l.then(e, e);
      } else "function" == typeof l.next && "function" == typeof l.throw && (l = kn(l));
    }, a);
    return (l && "function" == typeof l.then ? Ce.resolve(l).then(function (e) {
      return o.active ? e : ht(new X.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
    }) : c.then(function () {
      return l;
    })).then(function (e) {
      return r && o._resolve(), o._completion.then(function () {
        return e;
      });
    }).catch(function (e) {
      return o._reject(e), ht(e);
    });
  });
}

function Kn(e, t, r) {
  var s = n(e) ? e.slice() : [e];

  for (var _e14 = 0; _e14 < r; ++_e14) {
    s.push(t);
  }

  return s;
}

var On = {
  stack: "dbcore",
  name: "VirtualIndexMiddleware",
  level: 1,
  create: function create(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      table: function table(t) {
        var n = e.table(t),
            r = n.schema,
            s = {},
            i = [];

        function o(e, t, n) {
          var r = sn(e),
              a = s[r] = s[r] || [],
              u = null == e ? 0 : "string" == typeof e ? 1 : e.length,
              l = t > 0,
              c = _objectSpread(_objectSpread({}, n), {}, {
            isVirtual: l,
            keyTail: t,
            keyLength: u,
            extractKey: tn(e),
            unique: !l && n.unique
          });

          if (a.push(c), c.isPrimaryKey || i.push(c), u > 1) {
            o(2 === u ? e[0] : e.slice(0, u - 1), t + 1, n);
          }

          return a.sort(function (e, t) {
            return e.keyTail - t.keyTail;
          }), c;
        }

        var a = o(r.primaryKey.keyPath, 0, r.primaryKey);
        s[":id"] = [a];

        var _iterator2 = _createForOfIteratorHelper(r.indexes),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e15 = _step2.value;
            o(_e15.keyPath, 0, _e15);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        function u(t) {
          var n = t.query.index;
          return n.isVirtual ? _objectSpread(_objectSpread({}, t), {}, {
            query: {
              index: n,
              range: (r = t.query.range, s = n.keyTail, {
                type: 1 === r.type ? 2 : r.type,
                lower: Kn(r.lower, r.lowerOpen ? e.MAX_KEY : e.MIN_KEY, s),
                lowerOpen: !0,
                upper: Kn(r.upper, r.upperOpen ? e.MIN_KEY : e.MAX_KEY, s),
                upperOpen: !0
              })
            }
          }) : t;
          var r, s;
        }

        var l = _objectSpread(_objectSpread({}, n), {}, {
          schema: _objectSpread(_objectSpread({}, r), {}, {
            primaryKey: a,
            indexes: i,
            getIndexByKeyPath: function getIndexByKeyPath(e) {
              var t = s[sn(e)];
              return t && t[0];
            }
          }),
          count: function count(e) {
            return n.count(u(e));
          },
          query: function query(e) {
            return n.query(u(e));
          },
          openCursor: function openCursor(t) {
            var _t$query$index = t.query.index,
                r = _t$query$index.keyTail,
                s = _t$query$index.isVirtual,
                i = _t$query$index.keyLength;
            if (!s) return n.openCursor(t);
            return n.openCursor(u(t)).then(function (n) {
              return n && function (n) {
                var s = Object.create(n, {
                  continue: {
                    value: function value(s) {
                      null != s ? n.continue(Kn(s, t.reverse ? e.MAX_KEY : e.MIN_KEY, r)) : t.unique ? n.continue(n.key.slice(0, i).concat(t.reverse ? e.MIN_KEY : e.MAX_KEY, r)) : n.continue();
                    }
                  },
                  continuePrimaryKey: {
                    value: function value(t, s) {
                      n.continuePrimaryKey(Kn(t, e.MAX_KEY, r), s);
                    }
                  },
                  primaryKey: {
                    get: function get() {
                      return n.primaryKey;
                    }
                  },
                  key: {
                    get: function get() {
                      var e = n.key;
                      return 1 === i ? e[0] : e.slice(0, i);
                    }
                  },
                  value: {
                    get: function get() {
                      return n.value;
                    }
                  }
                });
                return s;
              }(n);
            });
          }
        });

        return l;
      }
    });
  }
};

function Sn(e, n, r, s) {
  return r = r || {}, s = s || "", t(e).forEach(function (t) {
    if (o(n, t)) {
      var i = e[t],
          a = n[t];

      if ("object" == typeof i && "object" == typeof a && i && a) {
        var _e16 = C(i);

        _e16 !== C(a) ? r[s + t] = n[t] : "Object" === _e16 ? Sn(i, a, r, s + t + ".") : i !== a && (r[s + t] = n[t]);
      } else i !== a && (r[s + t] = n[t]);
    } else r[s + t] = void 0;
  }), t(n).forEach(function (t) {
    o(e, t) || (r[s + t] = n[t]);
  }), r;
}

var An = {
  stack: "dbcore",
  name: "HooksMiddleware",
  level: 2,
  create: function create(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      table: function table(t) {
        var n = e.table(t),
            r = n.schema.primaryKey,
            s = _objectSpread(_objectSpread({}, n), {}, {
          mutate: function mutate(e) {
            var s = Ke.trans,
                _s$table$hook = s.table(t).hook,
                i = _s$table$hook.deleting,
                a = _s$table$hook.creating,
                u = _s$table$hook.updating;

            switch (e.type) {
              case "add":
                if (a.fire === ee) break;
                return s._promise("readwrite", function () {
                  return l(e);
                }, !0);

              case "put":
                if (a.fire === ee && u.fire === ee) break;
                return s._promise("readwrite", function () {
                  return l(e);
                }, !0);

              case "delete":
                if (i.fire === ee) break;
                return s._promise("readwrite", function () {
                  return l(e);
                }, !0);

              case "deleteRange":
                if (i.fire === ee) break;
                return s._promise("readwrite", function () {
                  return function (e) {
                    return c(e.trans, e.range, 1e4);
                  }(e);
                }, !0);
            }

            return n.mutate(e);

            function l(e) {
              var t = Ke.trans,
                  s = e.keys || function (e, t) {
                return "delete" === t.type ? t.keys : t.keys || t.values.map(e.extractKey);
              }(r, e);

              if (!s) throw new Error("Keys missing");
              return "delete" !== (e = "add" === e.type || "put" === e.type ? _objectSpread(_objectSpread({}, e), {}, {
                keys: s
              }) : _objectSpread({}, e)).type && (e.values = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(e.values)), e.keys && (e.keys = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(e.keys)), function (e, t, n) {
                return "add" === t.type ? Promise.resolve([]) : e.getMany({
                  trans: t.trans,
                  keys: n,
                  cache: "immutable"
                });
              }(n, e, s).then(function (l) {
                var c = s.map(function (n, s) {
                  var c = l[s],
                      h = {
                    onerror: null,
                    onsuccess: null
                  };
                  if ("delete" === e.type) i.fire.call(h, n, c, t);else if ("add" === e.type || void 0 === c) {
                    var _i4 = a.fire.call(h, n, e.values[s], t);

                    null == n && null != _i4 && (n = _i4, e.keys[s] = n, r.outbound || _(e.values[s], r.keyPath, n));
                  } else {
                    var _r9 = Sn(c, e.values[s]),
                        _i5 = u.fire.call(h, _r9, n, c, t);

                    if (_i5) {
                      var _t11 = e.values[s];
                      Object.keys(_i5).forEach(function (e) {
                        o(_t11, e) ? _t11[e] = _i5[e] : _(_t11, e, _i5[e]);
                      });
                    }
                  }
                  return h;
                });
                return n.mutate(e).then(function (_ref30) {
                  var t = _ref30.failures,
                      n = _ref30.results,
                      r = _ref30.numFailures,
                      i = _ref30.lastResult;

                  for (var _r10 = 0; _r10 < s.length; ++_r10) {
                    var _i6 = n ? n[_r10] : s[_r10],
                        _o4 = c[_r10];

                    null == _i6 ? _o4.onerror && _o4.onerror(t[_r10]) : _o4.onsuccess && _o4.onsuccess("put" === e.type && l[_r10] ? e.values[_r10] : _i6);
                  }

                  return {
                    failures: t,
                    results: n,
                    numFailures: r,
                    lastResult: i
                  };
                }).catch(function (e) {
                  return c.forEach(function (t) {
                    return t.onerror && t.onerror(e);
                  }), Promise.reject(e);
                });
              });
            }

            function c(e, t, s) {
              return n.query({
                trans: e,
                values: !1,
                query: {
                  index: r,
                  range: t
                },
                limit: s
              }).then(function (_ref31) {
                var n = _ref31.result;
                return l({
                  type: "delete",
                  keys: n,
                  trans: e
                }).then(function (r) {
                  return r.numFailures > 0 ? Promise.reject(r.failures[0]) : n.length < s ? {
                    failures: [],
                    numFailures: 0,
                    lastResult: void 0
                  } : c(e, _objectSpread(_objectSpread({}, t), {}, {
                    lower: n[n.length - 1],
                    lowerOpen: !0
                  }), s);
                });
              });
            }
          }
        });

        return s;
      }
    });
  }
};

function Cn(e, t, n) {
  try {
    if (!t) return null;
    if (t.keys.length < e.length) return null;
    var _r11 = [];

    for (var _s6 = 0, _i7 = 0; _s6 < t.keys.length && _i7 < e.length; ++_s6) {
      0 === It(t.keys[_s6], e[_i7]) && (_r11.push(n ? O(t.values[_s6]) : t.values[_s6]), ++_i7);
    }

    return _r11.length === e.length ? _r11 : null;
  } catch (e) {
    return null;
  }
}

var jn = {
  stack: "dbcore",
  level: -1,
  create: function create(e) {
    return {
      table: function table(t) {
        var n = e.table(t);
        return _objectSpread(_objectSpread({}, n), {}, {
          getMany: function getMany(e) {
            if (!e.cache) return n.getMany(e);
            var t = Cn(e.keys, e.trans._cache, "clone" === e.cache);
            return t ? Ce.resolve(t) : n.getMany(e).then(function (t) {
              return e.trans._cache = {
                keys: e.keys,
                values: "clone" === e.cache ? O(t) : t
              }, t;
            });
          },
          mutate: function mutate(e) {
            return "add" !== e.type && (e.trans._cache = null), n.mutate(e);
          }
        });
      }
    };
  }
};

function Dn(e) {
  return !("from" in e);
}

var In = function In(e, t) {
  if (!this) {
    var _t12 = new In();

    return e && "d" in e && r(_t12, e), _t12;
  }

  r(this, arguments.length ? {
    d: 1,
    from: e,
    to: arguments.length > 1 ? t : e
  } : {
    d: 0
  });
};

function Bn(e, t, n) {
  var s = It(t, n);
  if (isNaN(s)) return;
  if (s > 0) throw RangeError();
  if (Dn(e)) return r(e, {
    from: t,
    to: n,
    d: 1
  });
  var i = e.l,
      o = e.r;
  if (It(n, e.from) < 0) return i ? Bn(i, t, n) : e.l = {
    from: t,
    to: n,
    d: 1,
    l: null,
    r: null
  }, Mn(e);
  if (It(t, e.to) > 0) return o ? Bn(o, t, n) : e.r = {
    from: t,
    to: n,
    d: 1,
    l: null,
    r: null
  }, Mn(e);
  It(t, e.from) < 0 && (e.from = t, e.l = null, e.d = o ? o.d + 1 : 1), It(n, e.to) > 0 && (e.to = n, e.r = null, e.d = e.l ? e.l.d + 1 : 1);
  var a = !e.r;
  i && !e.l && Tn(e, i), o && a && Tn(e, o);
}

function Tn(e, t) {
  Dn(t) || function e(t, _ref32) {
    var n = _ref32.from,
        r = _ref32.to,
        s = _ref32.l,
        i = _ref32.r;
    Bn(t, n, r), s && e(t, s), i && e(t, i);
  }(e, t);
}

function Rn(e, t) {
  var n = Fn(t);
  var r = n.next();
  if (r.done) return !1;
  var s = r.value;
  var i = Fn(e);
  var o = i.next(s.from),
      a = o.value;

  for (; !r.done && !o.done;) {
    if (It(a.from, s.to) <= 0 && It(a.to, s.from) >= 0) return !0;
    It(s.from, a.from) < 0 ? s = (r = n.next(a.from)).value : a = (o = i.next(s.from)).value;
  }

  return !1;
}

function Fn(e) {
  var t = Dn(e) ? null : {
    s: 0,
    n: e
  };
  return {
    next: function next(e) {
      var n = arguments.length > 0;

      for (; t;) {
        switch (t.s) {
          case 0:
            if (t.s = 1, n) for (; t.n.l && It(e, t.n.from) < 0;) {
              t = {
                up: t,
                n: t.n.l,
                s: 1
              };
            } else for (; t.n.l;) {
              t = {
                up: t,
                n: t.n.l,
                s: 1
              };
            }

          case 1:
            if (t.s = 2, !n || It(e, t.n.to) <= 0) return {
              value: t.n,
              done: !1
            };

          case 2:
            if (t.n.r) {
              t.s = 3, t = {
                up: t,
                n: t.n.r,
                s: 0
              };
              continue;
            }

          case 3:
            t = t.up;
        }
      }

      return {
        done: !0
      };
    }
  };
}

function Mn(e) {
  var t, n;
  var r = ((null === (t = e.r) || void 0 === t ? void 0 : t.d) || 0) - ((null === (n = e.l) || void 0 === n ? void 0 : n.d) || 0),
      s = r > 1 ? "r" : r < -1 ? "l" : "";

  if (s) {
    var _t13 = "r" === s ? "l" : "r",
        _n15 = _objectSpread({}, e),
        _r12 = e[s];

    e.from = _r12.from, e.to = _r12.to, e[s] = _r12[s], _n15[s] = _r12[_t13], e[_t13] = _n15, _n15.d = Nn(_n15);
  }

  e.d = Nn(e);
}

function Nn(_ref33) {
  var e = _ref33.r,
      t = _ref33.l;
  return (e ? t ? Math.max(e.d, t.d) : e.d : t ? t.d : 0) + 1;
}

a(In.prototype, (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
  add: function add(e) {
    return Tn(this, e), this;
  },
  addKey: function addKey(e) {
    return Bn(this, e, e), this;
  },
  addKeys: function addKeys(e) {
    var _this21 = this;

    return e.forEach(function (e) {
      return Bn(_this21, e, e);
    }), this;
  }
}, j, function () {
  return Fn(this);
}));
var qn = {
  stack: "dbcore",
  level: 0,
  create: function create(e) {
    var r = e.schema.name,
        s = new In(e.MIN_KEY, e.MAX_KEY);
    return _objectSpread(_objectSpread({}, e), {}, {
      table: function table(i) {
        var o = e.table(i),
            a = o.schema,
            u = a.primaryKey,
            l = u.extractKey,
            c = u.outbound,
            h = _objectSpread(_objectSpread({}, o), {}, {
          mutate: function mutate(e) {
            var t = e.trans,
                u = t.mutatedParts || (t.mutatedParts = {}),
                l = function l(e) {
              var t = "idb://".concat(r, "/").concat(i, "/").concat(e);
              return u[t] || (u[t] = new In());
            },
                c = l(""),
                h = l(":dels"),
                d = e.type;

            var _ref34 = "deleteRange" === e.type ? [e.range] : "delete" === e.type ? [e.keys] : e.values.length < 50 ? [[], e.values] : [],
                _ref35 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref34, 2),
                f = _ref35[0],
                p = _ref35[1];

            var y = e.trans._cache;
            return o.mutate(e).then(function (e) {
              if (n(f)) {
                "delete" !== d && (f = e.results), c.addKeys(f);

                var _t14 = Cn(f, y);

                _t14 || "add" === d || h.addKeys(f), (_t14 || p) && function (e, t, r, s) {
                  function i(t) {
                    var i = e(t.name || "");

                    function o(e) {
                      return null != e ? t.extractKey(e) : null;
                    }

                    var a = function a(e) {
                      return t.multiEntry && n(e) ? e.forEach(function (e) {
                        return i.addKey(e);
                      }) : i.addKey(e);
                    };

                    (r || s).forEach(function (e, t) {
                      var n = r && o(r[t]),
                          i = s && o(s[t]);
                      0 !== It(n, i) && (null != n && a(n), null != i && a(i));
                    });
                  }

                  t.indexes.forEach(i);
                }(l, a, _t14, p);
              } else if (f) {
                var _e17 = {
                  from: f.lower,
                  to: f.upper
                };
                h.add(_e17), c.add(_e17);
              } else c.add(s), h.add(s), a.indexes.forEach(function (e) {
                return l(e.name).add(s);
              });

              return e;
            });
          }
        }),
            d = function d(_ref36) {
          var _ref36$query = _ref36.query,
              t = _ref36$query.index,
              n = _ref36$query.range;
          var r, s;
          return [t, new In(null !== (r = n.lower) && void 0 !== r ? r : e.MIN_KEY, null !== (s = n.upper) && void 0 !== s ? s : e.MAX_KEY)];
        },
            f = {
          get: function get(e) {
            return [u, new In(e.key)];
          },
          getMany: function getMany(e) {
            return [u, new In().addKeys(e.keys)];
          },
          count: d,
          query: d,
          openCursor: d
        };

        return t(f).forEach(function (e) {
          h[e] = function (t) {
            var _Ke = Ke,
                n = _Ke.subscr;

            if (n) {
              var _a4 = function _a4(e) {
                var t = "idb://".concat(r, "/").concat(i, "/").concat(e);
                return n[t] || (n[t] = new In());
              },
                  _u = _a4(""),
                  _h = _a4(":dels"),
                  _f$e = f[e](t),
                  _f$e2 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_f$e, 2),
                  _d2 = _f$e2[0],
                  _p = _f$e2[1];

              if (_a4(_d2.name || "").add(_p), !_d2.isPrimaryKey) {
                if ("count" !== e) {
                  var _n16 = "query" === e && c && t.values && o.query(_objectSpread(_objectSpread({}, t), {}, {
                    values: !1
                  }));

                  return o[e].apply(this, arguments).then(function (r) {
                    if ("query" === e) {
                      if (c && t.values) return _n16.then(function (_ref37) {
                        var e = _ref37.result;
                        return _u.addKeys(e), r;
                      });

                      var _e18 = t.values ? r.result.map(l) : r.result;

                      t.values ? _u.addKeys(_e18) : _h.addKeys(_e18);
                    } else if ("openCursor" === e) {
                      var _e19 = r,
                          _n17 = t.values;
                      return _e19 && Object.create(_e19, {
                        key: {
                          get: function get() {
                            return _h.addKey(_e19.primaryKey), _e19.key;
                          }
                        },
                        primaryKey: {
                          get: function get() {
                            var t = _e19.primaryKey;
                            return _h.addKey(t), t;
                          }
                        },
                        value: {
                          get: function get() {
                            return _n17 && _u.addKey(_e19.primaryKey), _e19.value;
                          }
                        }
                      });
                    }

                    return r;
                  });
                }

                _h.add(s);
              }
            }

            return o[e].apply(this, arguments);
          };
        }), h;
      }
    });
  }
};

var $n = /*#__PURE__*/function () {
  function $n(e, t) {
    var _this22 = this;

    (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, $n);

    this._middlewares = {}, this.verno = 0;
    var n = $n.dependencies;
    this._options = t = _objectSpread({
      addons: $n.addons,
      autoOpen: !0,
      indexedDB: n.indexedDB,
      IDBKeyRange: n.IDBKeyRange
    }, t), this._deps = {
      indexedDB: t.indexedDB,
      IDBKeyRange: t.IDBKeyRange
    };
    var _t15 = t,
        r = _t15.addons;
    this._dbSchema = {}, this._versions = [], this._storeNames = [], this._allTables = {}, this.idbdb = null, this._novip = this;
    var s = {
      dbOpenError: null,
      isBeingOpened: !1,
      onReadyBeingFired: null,
      openComplete: !1,
      dbReadyResolve: ee,
      dbReadyPromise: null,
      cancelOpen: ee,
      openCanceller: null,
      autoSchema: !0,
      PR1398_maxLoop: 3
    };
    var i;
    s.dbReadyPromise = new Ce(function (e) {
      s.dbReadyResolve = e;
    }), s.openCanceller = new Ce(function (e, t) {
      s.cancelOpen = t;
    }), this._state = s, this.name = e, this.on = Et(this, "populate", "blocked", "versionchange", "close", {
      ready: [ue, ee]
    }), this.on.ready.subscribe = y(this.on.ready.subscribe, function (e) {
      return function (t, n) {
        $n.vip(function () {
          var r = _this22._state;
          if (r.openComplete) r.dbOpenError || Ce.resolve().then(t), n && e(t);else if (r.onReadyBeingFired) r.onReadyBeingFired.push(t), n && e(t);else {
            e(t);
            var _r13 = _this22;
            n || e(function e() {
              _r13.on.ready.unsubscribe(t), _r13.on.ready.unsubscribe(e);
            });
          }
        });
      };
    }), this.Collection = (i = this, Pt(Rt.prototype, function (e, t) {
      this.db = i;
      var n = wt,
          r = null;
      if (t) try {
        n = t();
      } catch (e) {
        r = e;
      }
      var s = e._ctx,
          o = s.table,
          a = o.hook.reading.fire;
      this._ctx = {
        table: o,
        index: s.index,
        isPrimKey: !s.index || o.schema.primKey.keyPath && s.index === o.schema.primKey.name,
        range: n,
        keysOnly: !1,
        dir: "next",
        unique: "",
        algorithm: null,
        filter: null,
        replayFilter: null,
        justLimit: !0,
        isMatch: null,
        offset: 0,
        limit: 1 / 0,
        error: r,
        or: s.or,
        valueMapper: a !== te ? a : null
      };
    })), this.Table = function (e) {
      return Pt(kt.prototype, function (t, n, r) {
        this.db = e, this._tx = r, this.name = t, this.schema = n, this.hook = e._allTables[t] ? e._allTables[t].hook : Et(null, {
          creating: [se, ee],
          reading: [ne, te],
          updating: [oe, ee],
          deleting: [ie, ee]
        });
      });
    }(this), this.Transaction = function (e) {
      return Pt(Qt.prototype, function (t, n, r, s, i) {
        var _this23 = this;

        this.db = e, this.mode = t, this.storeNames = n, this.schema = r, this.chromeTransactionDurability = s, this.idbtrans = null, this.on = Et(this, "complete", "error", "abort"), this.parent = i || null, this.active = !0, this._reculock = 0, this._blockedFuncs = [], this._resolve = null, this._reject = null, this._waitingFor = null, this._waitingQueue = null, this._spinCount = 0, this._completion = new Ce(function (e, t) {
          _this23._resolve = e, _this23._reject = t;
        }), this._completion.then(function () {
          _this23.active = !1, _this23.on.complete.fire();
        }, function (e) {
          var t = _this23.active;
          return _this23.active = !1, _this23.on.error.fire(e), _this23.parent ? _this23.parent._reject(e) : t && _this23.idbtrans && _this23.idbtrans.abort(), ht(e);
        });
      });
    }(this), this.Version = function (e) {
      return Pt(vn.prototype, function (t) {
        this.db = e, this._cfg = {
          version: t,
          storesSource: null,
          dbschema: {},
          tables: {},
          contentUpgrade: null
        };
      });
    }(this), this.WhereClause = function (e) {
      return Pt(Yt.prototype, function (t, n, r) {
        this.db = e, this._ctx = {
          table: t,
          index: ":id" === n ? null : n,
          or: r
        };
        var s = e._deps.indexedDB;
        if (!s) throw new X.MissingAPI();
        this._cmp = this._ascending = s.cmp.bind(s), this._descending = function (e, t) {
          return s.cmp(t, e);
        }, this._max = function (e, t) {
          return s.cmp(e, t) > 0 ? e : t;
        }, this._min = function (e, t) {
          return s.cmp(e, t) < 0 ? e : t;
        }, this._IDBKeyRange = e._deps.IDBKeyRange;
      });
    }(this), this.on("versionchange", function (e) {
      e.newVersion > 0 ? console.warn("Another connection wants to upgrade database '".concat(_this22.name, "'. Closing db now to resume the upgrade.")) : console.warn("Another connection wants to delete database '".concat(_this22.name, "'. Closing db now to resume the delete request.")), _this22.close();
    }), this.on("blocked", function (e) {
      !e.newVersion || e.newVersion < e.oldVersion ? console.warn("Dexie.delete('".concat(_this22.name, "') was blocked")) : console.warn("Upgrade '".concat(_this22.name, "' blocked by other connection holding version ").concat(e.oldVersion / 10));
    }), this._maxKey = _en(t.IDBKeyRange), this._createTransaction = function (e, t, n, r) {
      return new _this22.Transaction(e, t, n, _this22._options.chromeTransactionDurability, r);
    }, this._fireOnBlocked = function (e) {
      _this22.on("blocked").fire(e), yt.filter(function (e) {
        return e.name === _this22.name && e !== _this22 && !e._state.vcFired;
      }).map(function (t) {
        return t.on("versionchange").fire(e);
      });
    }, this.use(On), this.use(An), this.use(qn), this.use(jn), this.vip = Object.create(this, {
      _vip: {
        value: !0
      }
    }), r.forEach(function (e) {
      return e(_this22);
    });
  }

  (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)($n, [{
    key: "version",
    value: function version(e) {
      if (isNaN(e) || e < .1) throw new X.Type("Given version is not a positive number");
      if (e = Math.round(10 * e) / 10, this.idbdb || this._state.isBeingOpened) throw new X.Schema("Cannot add version when database is open");
      this.verno = Math.max(this.verno, e);
      var t = this._versions;
      var n = t.filter(function (t) {
        return t._cfg.version === e;
      })[0];
      return n || (n = new this.Version(e), t.push(n), t.sort(cn), n.stores({}), this._state.autoSchema = !1, n);
    }
  }, {
    key: "_whenReady",
    value: function _whenReady(e) {
      var _this24 = this;

      return this.idbdb && (this._state.openComplete || Ke.letThrough || this._vip) ? e() : new Ce(function (e, t) {
        if (_this24._state.openComplete) return t(new X.DatabaseClosed(_this24._state.dbOpenError));

        if (!_this24._state.isBeingOpened) {
          if (!_this24._options.autoOpen) return void t(new X.DatabaseClosed());

          _this24.open().catch(ee);
        }

        _this24._state.dbReadyPromise.then(e, t);
      }).then(e);
    }
  }, {
    key: "use",
    value: function use(_ref38) {
      var e = _ref38.stack,
          t = _ref38.create,
          n = _ref38.level,
          r = _ref38.name;
      r && this.unuse({
        stack: e,
        name: r
      });
      var s = this._middlewares[e] || (this._middlewares[e] = []);
      return s.push({
        stack: e,
        create: t,
        level: null == n ? 10 : n,
        name: r
      }), s.sort(function (e, t) {
        return e.level - t.level;
      }), this;
    }
  }, {
    key: "unuse",
    value: function unuse(_ref39) {
      var e = _ref39.stack,
          t = _ref39.name,
          n = _ref39.create;
      return e && this._middlewares[e] && (this._middlewares[e] = this._middlewares[e].filter(function (e) {
        return n ? e.create !== n : !!t && e.name !== t;
      })), this;
    }
  }, {
    key: "open",
    value: function open() {
      return xn(this);
    }
  }, {
    key: "_close",
    value: function _close() {
      var e = this._state,
          t = yt.indexOf(this);

      if (t >= 0 && yt.splice(t, 1), this.idbdb) {
        try {
          this.idbdb.close();
        } catch (e) {}

        this._novip.idbdb = null;
      }

      e.dbReadyPromise = new Ce(function (t) {
        e.dbReadyResolve = t;
      }), e.openCanceller = new Ce(function (t, n) {
        e.cancelOpen = n;
      });
    }
  }, {
    key: "close",
    value: function close() {
      this._close();

      var e = this._state;
      this._options.autoOpen = !1, e.dbOpenError = new X.DatabaseClosed(), e.isBeingOpened && e.cancelOpen(e.dbOpenError);
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _this25 = this;

      var e = arguments.length > 0,
          t = this._state;
      return new Ce(function (n, r) {
        var s = function s() {
          _this25.close();

          var e = _this25._deps.indexedDB.deleteDatabase(_this25.name);

          e.onsuccess = We(function () {
            !function (_ref40, n) {
              var e = _ref40.indexedDB,
                  t = _ref40.IDBKeyRange;
              !bn(e) && "__dbnames" !== n && gn(e, t).delete(n).catch(ee);
            }(_this25._deps, _this25.name), n();
          }), e.onerror = zt(r), e.onblocked = _this25._fireOnBlocked;
        };

        if (e) throw new X.InvalidArgument("Arguments not allowed in db.delete()");
        t.isBeingOpened ? t.dbReadyPromise.then(s) : s();
      });
    }
  }, {
    key: "backendDB",
    value: function backendDB() {
      return this.idbdb;
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return null !== this.idbdb;
    }
  }, {
    key: "hasBeenClosed",
    value: function hasBeenClosed() {
      var e = this._state.dbOpenError;
      return e && "DatabaseClosed" === e.name;
    }
  }, {
    key: "hasFailed",
    value: function hasFailed() {
      return null !== this._state.dbOpenError;
    }
  }, {
    key: "dynamicallyOpened",
    value: function dynamicallyOpened() {
      return this._state.autoSchema;
    }
  }, {
    key: "tables",
    get: function get() {
      var _this26 = this;

      return t(this._allTables).map(function (e) {
        return _this26._allTables[e];
      });
    }
  }, {
    key: "transaction",
    value: function transaction() {
      var e = En.apply(this, arguments);
      return this._transaction.apply(this, e);
    }
  }, {
    key: "_transaction",
    value: function _transaction(e, t, n) {
      var _this27 = this;

      var r = Ke.trans;
      r && r.db === this && -1 === e.indexOf("!") || (r = null);
      var s = -1 !== e.indexOf("?");
      var i, o;
      e = e.replace("!", "").replace("?", "");

      try {
        if (o = t.map(function (e) {
          var t = e instanceof _this27.Table ? e.name : e;
          if ("string" != typeof t) throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
          return t;
        }), "r" == e || "readonly" === e) i = "readonly";else {
          if ("rw" != e && "readwrite" != e) throw new X.InvalidArgument("Invalid transaction mode: " + e);
          i = "readwrite";
        }

        if (r) {
          if ("readonly" === r.mode && "readwrite" === i) {
            if (!s) throw new X.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
            r = null;
          }

          r && o.forEach(function (e) {
            if (r && -1 === r.storeNames.indexOf(e)) {
              if (!s) throw new X.SubTransaction("Table " + e + " not included in parent transaction.");
              r = null;
            }
          }), s && r && !r.active && (r = null);
        }
      } catch (e) {
        return r ? r._promise(null, function (t, n) {
          n(e);
        }) : ht(e);
      }

      var a = Pn.bind(null, this, i, o, r, n);
      return r ? r._promise(i, a, "lock") : Ke.trans ? ot(Ke.transless, function () {
        return _this27._whenReady(a);
      }) : this._whenReady(a);
    }
  }, {
    key: "table",
    value: function table(e) {
      if (!o(this._allTables, e)) throw new X.InvalidTable("Table ".concat(e, " does not exist"));
      return this._allTables[e];
    }
  }]);

  return $n;
}();

var Un = "undefined" != typeof Symbol && "observable" in Symbol ? Symbol.observable : "@@observable";

var Ln = /*#__PURE__*/function () {
  function Ln(e) {
    (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, Ln);

    this._subscribe = e;
  }

  (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Ln, [{
    key: "subscribe",
    value: function subscribe(e, t, n) {
      return this._subscribe(e && "function" != typeof e ? e : {
        next: e,
        error: t,
        complete: n
      });
    }
  }, {
    key: Un,
    value: function value() {
      return this;
    }
  }]);

  return Ln;
}();

function Vn(e, n) {
  return t(n).forEach(function (t) {
    Tn(e[t] || (e[t] = new In()), n[t]);
  }), e;
}

function Wn(e) {
  return new Ln(function (n) {
    var r = T(e);
    var s = !1,
        i = {},
        o = {};
    var a = {
      get closed() {
        return s;
      },

      unsubscribe: function unsubscribe() {
        s = !0, Ht.storagemutated.unsubscribe(h);
      }
    };
    n.start && n.start(a);
    var u = !1,
        l = !1;

    function c() {
      return t(o).some(function (e) {
        return i[e] && Rn(i[e], o[e]);
      });
    }

    var h = function h(e) {
      Vn(i, e), c() && d();
    },
        d = function d() {
      if (u || s) return;
      i = {};

      var t = {},
          f = function (t) {
        r && Ze();

        var n = function n() {
          return Je(e, {
            subscr: t,
            trans: null
          });
        },
            s = Ke.trans ? ot(Ke.transless, n) : n();

        return r && s.then(et, et), s;
      }(t);

      l || (Ht("storagemutated", h), l = !0), u = !0, Promise.resolve(f).then(function (e) {
        u = !1, s || (c() ? d() : (i = {}, o = t, n.next && n.next(e)));
      }, function (e) {
        u = !1, n.error && n.error(e), a.unsubscribe();
      });
    };

    return d(), a;
  });
}

var Yn;

try {
  Yn = {
    indexedDB: e.indexedDB || e.mozIndexedDB || e.webkitIndexedDB || e.msIndexedDB,
    IDBKeyRange: e.IDBKeyRange || e.webkitIDBKeyRange
  };
} catch (e) {
  Yn = {
    indexedDB: null,
    IDBKeyRange: null
  };
}

var zn = $n;

function Gn(e) {
  var t = Hn;

  try {
    Hn = !0, Ht.storagemutated.fire(e);
  } finally {
    Hn = t;
  }
}

a(zn, _objectSpread(_objectSpread({}, Z), {}, {
  delete: function _delete(e) {
    return new zn(e, {
      addons: []
    }).delete();
  },
  exists: function exists(e) {
    return new zn(e, {
      addons: []
    }).open().then(function (e) {
      return e.close(), !0;
    }).catch("NoSuchDatabaseError", function () {
      return !1;
    });
  },
  getDatabaseNames: function getDatabaseNames(e) {
    try {
      return function (_ref41) {
        var e = _ref41.indexedDB,
            t = _ref41.IDBKeyRange;
        return bn(e) ? Promise.resolve(e.databases()).then(function (e) {
          return e.map(function (e) {
            return e.name;
          }).filter(function (e) {
            return "__dbnames" !== e;
          });
        }) : gn(e, t).toCollection().primaryKeys();
      }(zn.dependencies).then(e);
    } catch (e) {
      return ht(new X.MissingAPI());
    }
  },
  defineClass: function defineClass() {
    return function (e) {
      r(this, e);
    };
  },
  ignoreTransaction: function ignoreTransaction(e) {
    return Ke.trans ? ot(Ke.transless, e) : e();
  },
  vip: _n,
  async: function async(e) {
    return function () {
      try {
        var t = kn(e.apply(this, arguments));
        return t && "function" == typeof t.then ? t : Ce.resolve(t);
      } catch (e) {
        return ht(e);
      }
    };
  },
  spawn: function spawn(e, t, n) {
    try {
      var r = kn(e.apply(n, t || []));
      return r && "function" == typeof r.then ? r : Ce.resolve(r);
    } catch (e) {
      return ht(e);
    }
  },
  currentTransaction: {
    get: function get() {
      return Ke.trans || null;
    }
  },
  waitFor: function waitFor(e, t) {
    var n = Ce.resolve("function" == typeof e ? zn.ignoreTransaction(e) : e).timeout(t || 6e4);
    return Ke.trans ? Ke.trans.waitFor(n) : n;
  },
  Promise: Ce,
  debug: {
    get: function get() {
      return R;
    },
    set: function set(e) {
      F(e, "dexie" === e ? function () {
        return !0;
      } : bt);
    }
  },
  derive: c,
  extend: r,
  props: a,
  override: y,
  Events: Et,
  on: Ht,
  liveQuery: Wn,
  extendObservabilitySet: Vn,
  getByKeyPath: b,
  setByKeyPath: _,
  delByKeyPath: function delByKeyPath(e, t) {
    "string" == typeof t ? _(e, t, void 0) : "length" in t && [].map.call(t, function (t) {
      _(e, t, void 0);
    });
  },
  shallowClone: w,
  deepClone: O,
  getObjectDiff: Sn,
  cmp: It,
  asap: v,
  minKey: -(1 / 0),
  addons: [],
  connections: yt,
  errnames: H,
  dependencies: Yn,
  semVer: "3.2.2",
  version: "3.2.2".split(".").map(function (e) {
    return parseInt(e);
  }).reduce(function (e, t, n) {
    return e + t / Math.pow(10, 2 * n);
  })
})), zn.maxKey = _en(zn.dependencies.IDBKeyRange), "undefined" != typeof dispatchEvent && "undefined" != typeof addEventListener && (Ht("storagemutated", function (e) {
  if (!Hn) {
    var _t16;

    mt ? (_t16 = document.createEvent("CustomEvent"), _t16.initCustomEvent("x-storagemutated-1", !0, !0, e)) : _t16 = new CustomEvent("x-storagemutated-1", {
      detail: e
    }), Hn = !0, dispatchEvent(_t16), Hn = !1;
  }
}), addEventListener("x-storagemutated-1", function (_ref42) {
  var e = _ref42.detail;
  Hn || Gn(e);
}));
var Hn = !1;

if ("undefined" != typeof BroadcastChannel) {
  var _e20 = new BroadcastChannel("x-storagemutated-1");

  Ht("storagemutated", function (t) {
    Hn || _e20.postMessage(t);
  }), _e20.onmessage = function (e) {
    e.data && Gn(e.data);
  };
} else if ("undefined" != typeof self && "undefined" != typeof navigator) {
  Ht("storagemutated", function (e) {
    try {
      Hn || ("undefined" != typeof localStorage && localStorage.setItem("x-storagemutated-1", JSON.stringify({
        trig: Math.random(),
        changedParts: e
      })), "object" == typeof self.clients && (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(self.clients.matchAll({
        includeUncontrolled: !0
      })).forEach(function (t) {
        return t.postMessage({
          type: "x-storagemutated-1",
          changedParts: e
        });
      }));
    } catch (e) {}
  }), "undefined" != typeof addEventListener && addEventListener("storage", function (e) {
    if ("x-storagemutated-1" === e.key) {
      var _t17 = JSON.parse(e.newValue);

      _t17 && Gn(_t17.changedParts);
    }
  });

  var _e21 = self.document && navigator.serviceWorker;

  _e21 && _e21.addEventListener("message", function (_ref43) {
    var e = _ref43.data;
    e && "x-storagemutated-1" === e.type && Gn(e.changedParts);
  });
}

Ce.rejectionMapper = function (e, t) {
  if (!e || e instanceof W || e instanceof TypeError || e instanceof SyntaxError || !e.name || !J[e.name]) return e;
  var n = new J[e.name](t || e.message, e);
  return "stack" in e && l(n, "stack", {
    get: function get() {
      return this.inner.stack;
    }
  }), n;
}, F(R, bt);


/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(14649);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","container":"error-fallback_container__h5Kuc"};

/***/ }),

/***/ 44156:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","wrapper":"exit-confirmation_wrapper__JRa7y","content":"exit-confirmation_content__7YUnr","title":"exit-confirmation_title__FvzPN","action_wrapper":"exit-confirmation_action_wrapper__mrfvM"};

/***/ }),

/***/ 8541:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","footer":"footer_footer__2E9fz","no_background":"footer_no_background__Gy9CD","bottom":"footer_bottom__rulxg","social_button":"footer_social_button__VgccX","facebook":"footer_facebook__HfRn0","header":"footer_header__fFzMR","logo":"footer_logo__PNRay","prm":"footer_prm__svOZv","stores":"footer_stores__aSxyZ","old_website":"footer_old_website__dmdaK","section":"footer_section__woAgj","menu":"footer_menu__LAead","alt_button":"footer_alt_button__8_RCK","download":"footer_download__xpQTO"};

/***/ }),

/***/ 96424:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","profile":"header_profile__JoA5q","menu_item":"header_menu_item__NK86m","mobile_menu_wrapper":"header_mobile_menu_wrapper__xAHAr","menu_items":"header_menu_items__cDk_y","logo_wrapper":"header_logo_wrapper__97n8T","logo":"header_logo__i2FW2","navigation_mobile":"header_navigation_mobile__daxfg","navigation_mobile_inner":"header_navigation_mobile_inner__rkGFu","navigation_item":"header_navigation_item__F4r1y","active":"header_active__aCW7X","label":"header_label__KLeY9","mobile":"header_mobile__c4vqy","icon":"header_icon__pbbv6","icon_wrapper":"header_icon_wrapper__lVMH4","search_mobile":"header_search_mobile__Ls463","demo_indicator":"header_demo_indicator__IU6_G","header":"header_header__RatYy","inner_wrapper":"header_inner_wrapper__GUH1i","player_wrapper":"header_player_wrapper__AO12O","side":"header_side__D_gTc","side_items":"header_side_items__oLEj1","menu_item_icon":"header_menu_item_icon__HVaYE","menu_item_icon_wrapper":"header_menu_item_icon_wrapper__W_7MJ","menu_toggle":"header_menu_toggle__QeAhj","bar":"header_bar__Btpgk","mobile_active":"header_mobile_active__GInV8"};

/***/ }),

/***/ 58590:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","rotate_bar":"Loader_rotate_bar__BSq0p","barRotate":"Loader_barRotate__Y_3LI"};

/***/ }),

/***/ 46743:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","button_close":"previously-played_button_close__7k2Ca","button_cta":"previously-played_button_cta__JUuRa","wrapper":"previously-played_wrapper__MBiEB","inner":"previously-played_inner__qYwSd","header":"previously-played_header__QTeed","info":"previously-played_info__KabpS","buttons":"previously-played_buttons__PNEwT","category_info":"previously-played_category_info__DzQWX","cover":"previously-played_cover__2zOYF","category_title":"previously-played_category_title__9pWg6","category_subtitle":"previously-played_category_subtitle__KAraa"};

/***/ }),

/***/ 8043:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","wrapper":"toast_wrapper__vIZ5Q","toast":"toast_toast__UZhkv","slide_down":"toast_slide_down__VR538","slideDown":"toast_slideDown__oPF9c","slide_up":"toast_slide_up__JxU2I","slideUp":"toast_slideUp__ai3il","toast_error":"toast_toast_error__V5ls7","toast_container":"toast_toast_container__96I8h","bottom-left":"toast_bottom-left__us0HD","bottom-right":"toast_bottom-right__SKAQ4","bottom-center":"toast_bottom-center__g4uZH","top-left":"toast_top-left__Dp1it","top-right":"toast_top-right__0V8t4","top-center":"toast_top-center__4mAFQ"};

/***/ }),

/***/ 1711:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","button":"button_button__lkdEr","button_text":"button_button_text__QNzVA","compact":"button_compact__HbPXx","small":"button_small__hNAtw","accent":"button_accent__ptK7d","button_outline":"button_button_outline__6fUgh","button_danger":"button_button_danger__aV93j"};

/***/ }),

/***/ 59992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","keycap":"virtual-keyboard_keycap__ZcJRO","wrapper":"virtual-keyboard_wrapper___evE1","row":"virtual-keyboard_row__SbF3r"};

/***/ }),

/***/ 74831:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73579)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7942)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(69898)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72189)


/***/ }),

/***/ 70631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(24654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 55798:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 80129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(58261);
var parse = __webpack_require__(55235);
var formats = __webpack_require__(55798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 55235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(12769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 58261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(12769);
var formats = __webpack_require__(55798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + (commaRoundTrip && isArray(obj) && valuesArray.length === 1 ? '[]' : '') + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(55798);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 35800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(67294)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 59852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75068);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52943);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var focusManager = new FocusManager();

/***/ }),

/***/ 46747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _queryClient__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61284);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86755);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "QueryErrorResetBoundary")) __webpack_require__.d(__webpack_exports__, { "QueryErrorResetBoundary": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.QueryErrorResetBoundary; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; } });














 // Types



/***/ }),

/***/ 36997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ infiniteQueryBehavior; },
/* harmony export */   "Qy": function() { return /* binding */ hasNextPage; },
/* harmony export */   "ZF": function() { return /* binding */ hasPreviousPage; }
/* harmony export */ });
/* unused harmony exports getNextPageParam, getPreviousPageParam */
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21216);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAbortController */ .G9)();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}

/***/ }),

/***/ 41909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ setLogger; },
/* harmony export */   "j": function() { return /* binding */ getLogger; }
/* harmony export */ });
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 81262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41909);
/* harmony import */ var _notifyManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(101);
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21216);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT).catch(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,_logger__WEBPACK_IMPORTED_MODULE_2__/* .getLogger */ .j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new _retryer__WEBPACK_IMPORTED_MODULE_3__/* .Retryer */ .m4({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    _notifyManager__WEBPACK_IMPORTED_MODULE_4__/* .notifyManager.batch */ .V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: true
      });

    case 'continue':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: false
      });

    case 'loading':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, action.state);

    default:
      return state;
  }
}

/***/ }),

/***/ 101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export NotifyManager */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),

/***/ 40068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75068);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52943);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var onlineManager = new OnlineManager();

/***/ }),

/***/ 61284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(52288);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(75068);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41909);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(21216);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey);
    var abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new retryer/* Retryer */.m4({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!(0,retryer/* isCancelledError */.DV)(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });

      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });

      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }

        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(52943);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/mutation.js
var core_mutation = __webpack_require__(81262);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new core_mutation/* Mutation */.m({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(59852);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/onlineManager.js
var onlineManager = __webpack_require__(40068);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(36997);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryClient.js








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, (0,esm_extends/* default */.Z)({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),

/***/ 21216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "LE": function() { return /* binding */ isCancelable; },
/* harmony export */   "m4": function() { return /* binding */ Retryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59852);
/* harmony import */ var _onlineManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40068);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!_focusManager__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || !_onlineManager__WEBPACK_IMPORTED_MODULE_2__/* .onlineManager.isOnline */ .N.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),

/***/ 52943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),

/***/ 86755:
/***/ (function() {



/***/ }),

/***/ 52288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, replaceAt, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationFn: arg1
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),

/***/ 88767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; },
/* harmony export */   "QueryClientProvider": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; },
/* harmony export */   "QueryErrorResetBoundary": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryErrorResetBoundary; },
/* harmony export */   "useInfiniteQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; },
/* harmony export */   "useMutation": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useMutation; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQuery; },
/* harmony export */   "useQueryClient": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46747);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryErrorResetBoundary")) __webpack_require__.d(__webpack_exports__, { "QueryErrorResetBoundary": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryErrorResetBoundary; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQueryClient; } });
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3407);



/***/ }),

/***/ 3407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QueryClientProvider": function() { return /* reexport */ QueryClientProvider; },
  "QueryErrorResetBoundary": function() { return /* reexport */ QueryErrorResetBoundary; },
  "useInfiniteQuery": function() { return /* reexport */ useInfiniteQuery; },
  "useMutation": function() { return /* reexport */ useMutation; },
  "useQuery": function() { return /* reexport */ useQuery; },
  "useQueryClient": function() { return /* reexport */ useQueryClient; }
});

// UNUSED EXPORTS: Hydrate, useHydrate, useIsFetching, useIsMutating, useQueries, useQueryErrorResetBoundary

// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41909);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setLogger.js


(0,logger/* setLogger */.E)(logger_logger);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryClientProvider.js

var defaultContext = /*#__PURE__*/react.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/react.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = react.useContext(getQueryClientContext(react.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  react.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/react.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/react.createElement(Context.Provider, {
    value: client
  }, children));
};
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryErrorResetBoundary.js
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return react.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = react.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/react.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(52288);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(75068);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/mutation.js
var mutation = __webpack_require__(81262);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(52943);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationObserver.js





// CLASS
var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationObserver, _Subscribable);

  function MutationObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;

    _this.setOptions(options);

    _this.bindMethods();

    _this.updateResult();

    return _this;
  }

  var _proto = MutationObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  };

  _proto.setOptions = function setOptions(options) {
    this.options = this.client.defaultMutationOptions(options);
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  };

  _proto.onMutationUpdate = function onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    var notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.reset = function reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  };

  _proto.mutate = function mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, (0,esm_extends/* default */.Z)({}, this.options, {
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    }));
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  };

  _proto.updateResult = function updateResult() {
    var state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();

    var result = (0,esm_extends/* default */.Z)({}, state, {
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    });

    this.currentResult = result;
  };

  _proto.notify = function notify(options) {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the mutate callbacks
      if (_this2.mutateOptions) {
        if (options.onSuccess) {
          _this2.mutateOptions.onSuccess == null ? void 0 : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
        } else if (options.onError) {
          _this2.mutateOptions.onError == null ? void 0 : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        _this2.listeners.forEach(function (listener) {
          listener(_this2.currentResult);
        });
      }
    });
  };

  return MutationObserver;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/utils.js
function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useMutation.js






 // HOOK

function useMutation(arg1, arg2, arg3) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  var queryClient = useQueryClient();
  var obsRef = react.useRef();

  if (!obsRef.current) {
    obsRef.current = new MutationObserver(queryClient, options);
  } else {
    obsRef.current.setOptions(options);
  }

  var currentResult = obsRef.current.getCurrentResult();
  react.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = obsRef.current.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);
  var mutate = react.useCallback(function (variables, mutateOptions) {
    obsRef.current.mutate(variables, mutateOptions).catch(utils/* noop */.ZT);
  }, []);

  if (currentResult.error && shouldThrowError(undefined, obsRef.current.options.useErrorBoundary, [currentResult.error])) {
    throw currentResult.error;
  }

  return (0,esm_extends/* default */.Z)({}, currentResult, {
    mutate: mutate,
    mutateAsync: currentResult.mutate
  });
}
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(59852);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(21216);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryObserver.js








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.selectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch((0,esm_extends/* default */.Z)({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    var time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
          data = this.selectResult;
        } else {
          try {
            this.selectFn = options.select;
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.selectResult = data;
            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify((0,esm_extends/* default */.Z)({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(subscribable/* Subscribable */.l);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useBaseQuery.js





function useBaseQuery(options, Observer) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = react.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  react.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useQuery.js


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
// EXTERNAL MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(36997);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/infiniteQueryObserver.js




var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  (0,inheritsLoose/* default */.Z)(InfiniteQueryObserver, _QueryObserver);

  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function InfiniteQueryObserver(client, options) {
    return _QueryObserver.call(this, client, options) || this;
  }

  var _proto = InfiniteQueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    _QueryObserver.prototype.bindMethods.call(this);

    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    _QueryObserver.prototype.setOptions.call(this, (0,esm_extends/* default */.Z)({}, options, {
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }), notifyOptions);
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return _QueryObserver.prototype.getOptimisticResult.call(this, options);
  };

  _proto.fetchNextPage = function fetchNextPage(options) {
    var _options$cancelRefetc;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.fetchPreviousPage = function fetchPreviousPage(options) {
    var _options$cancelRefetc2;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.createResult = function createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    var state = query.state;

    var result = _QueryObserver.prototype.createResult.call(this, query, options);

    return (0,esm_extends/* default */.Z)({}, result, {
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    });
  };

  return InfiniteQueryObserver;
}(QueryObserver);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useInfiniteQuery.js


 // HOOK

function useInfiniteQuery(arg1, arg2, arg3) {
  var options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(options, InfiniteQueryObserver);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 25617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connect, connectAdvanced, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual, useStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

var Context_ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (Context_ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function Subscription_createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = Subscription_createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || Context_ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/react-is/index.js
var react_is = __webpack_require__(72973);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js


var _excluded = (/* unused pure expression or super */ null && (["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"])),
    _excluded2 = (/* unused pure expression or super */ null && (["reactReduxForwardedRef"]));





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = (/* unused pure expression or super */ null && ([]));
var NO_SUBSCRIPTION_ARRAY = (/* unused pure expression or super */ null && ([null, null]));

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced_connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose(_ref2, _excluded);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = useMemo(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = _objectWithoutPropertiesLoose(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = useMemo(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && isContextConsumer( /*#__PURE__*/React.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = useMemo(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = useMemo(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = useMemo(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = useRef();
      var lastWrapperProps = useRef(wrapperProps);
      var childPropsFromStoreUpdate = useRef();
      var renderIsScheduled = useRef(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = useMemo(function () {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = useMemo(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? React.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/React.createElement(Connect, _extends({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistStatics(forwarded, WrappedComponent);
    }

    return hoistStatics(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js


var connect_excluded = (/* unused pure expression or super */ null && (["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]));






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? defaultSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, connect_excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/(/* unused pure expression or super */ null && (createConnect())));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext_useReduxContext() {
  var contextValue = (0,react.useContext)(Context_ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useStore = context === Context_ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0,react.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0,react.useMemo)(function () {
    return Subscription_createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0,react.useRef)();
  var latestSelector = (0,react.useRef)();
  var latestStoreState = (0,react.useRef)();
  var latestSelectedState = (0,react.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);


/***/ }),

/***/ 88359:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 72973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(88359);
} else {}


/***/ }),

/***/ 76362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S1": function() { return /* binding */ off; },
/* harmony export */   "ae": function() { return /* binding */ isNavigator; },
/* harmony export */   "jU": function() { return /* binding */ isBrowser; },
/* harmony export */   "on": function() { return /* binding */ on; }
/* harmony export */ });
/* unused harmony export noop */
var noop = function () { };
function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
var isBrowser = typeof window !== 'undefined';
var isNavigator = typeof navigator !== 'undefined';


/***/ }),

/***/ 18127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useEffectOnce = function (effect) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(effect, []);
};
/* harmony default export */ __webpack_exports__["Z"] = (useEffectOnce);


/***/ }),

/***/ 6765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useNetworkState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _misc_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76362);


var nav = _misc_util__WEBPACK_IMPORTED_MODULE_1__/* .isNavigator */ .ae ? navigator : undefined;
var conn = nav && (nav.connection || nav.mozConnection || nav.webkitConnection);
function getConnectionState(previousState) {
    var online = nav === null || nav === void 0 ? void 0 : nav.onLine;
    var previousOnline = previousState === null || previousState === void 0 ? void 0 : previousState.online;
    return {
        online: online,
        previous: previousOnline,
        since: online !== previousOnline ? new Date() : previousState === null || previousState === void 0 ? void 0 : previousState.since,
        downlink: conn === null || conn === void 0 ? void 0 : conn.downlink,
        downlinkMax: conn === null || conn === void 0 ? void 0 : conn.downlinkMax,
        effectiveType: conn === null || conn === void 0 ? void 0 : conn.effectiveType,
        rtt: conn === null || conn === void 0 ? void 0 : conn.rtt,
        saveData: conn === null || conn === void 0 ? void 0 : conn.saveData,
        type: conn === null || conn === void 0 ? void 0 : conn.type,
    };
}
function useNetworkState(initialState) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState !== null && initialState !== void 0 ? initialState : getConnectionState), state = _a[0], setState = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var handleStateChange = function () {
            setState(getConnectionState);
        };
        (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__.on)(window, 'online', handleStateChange, { passive: true });
        (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__.on)(window, 'offline', handleStateChange, { passive: true });
        if (conn) {
            (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__.on)(conn, 'change', handleStateChange, { passive: true });
        }
        return function () {
            (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__/* .off */ .S1)(window, 'online', handleStateChange);
            (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__/* .off */ .S1)(window, 'offline', handleStateChange);
            if (conn) {
                (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__/* .off */ .S1)(conn, 'change', handleStateChange);
            }
        };
    }, []);
    return state;
}


/***/ }),

/***/ 77823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useEffectOnce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18127);


var useUnmount = function (fn) {
    var fnRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0,_useEffectOnce__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () { return function () { return fnRef.current(); }; });
};
/* harmony default export */ __webpack_exports__["Z"] = (useUnmount);


/***/ }),

/***/ 8662:
/***/ (function() {

(function () {
    'use strict';

    var UNSUPPORTED_ENVIRONMENT = typeof window === "undefined";

    /**
     * Is true if the browser natively supports the 'scroll-behavior' CSS-property.
     * @type {boolean}
     */
    var SUPPORTS_SCROLL_BEHAVIOR = UNSUPPORTED_ENVIRONMENT ? false : "scrollBehavior" in document.documentElement.style;

    

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function getScrollingElement() {
        if (document.scrollingElement != null) {
            return document.scrollingElement;
        }
        else {
            return document.documentElement;
        }
    }

    var STYLE_ATTRIBUTE_PROPERTY_NAME = "scroll-behavior";
    var STYLE_ATTRIBUTE_PROPERTY_REGEXP = new RegExp(STYLE_ATTRIBUTE_PROPERTY_NAME + ":\\s*([^;]*)");
    /**
     * Given an Element, this function appends the given ScrollBehavior CSS property value to the elements' 'style' attribute.
     * If it doesnt already have one, it will add it.
     * @param {Element} element
     * @param {ScrollBehavior} behavior
     */
    function appendScrollBehaviorToStyleAttribute(element, behavior) {
        var addition = STYLE_ATTRIBUTE_PROPERTY_NAME + ":" + behavior;
        var attributeValue = element.getAttribute("style");
        if (attributeValue == null || attributeValue === "") {
            element.setAttribute("style", addition);
            return;
        }
        // The style attribute may already include a 'scroll-behavior:<something>' in which case that should be replaced
        var existingValueForProperty = parseScrollBehaviorFromStyleAttribute(element);
        if (existingValueForProperty != null) {
            var replacementProperty = STYLE_ATTRIBUTE_PROPERTY_NAME + ":" + existingValueForProperty;
            // Replace the variant that ends with a semi-colon which it may
            attributeValue = attributeValue.replace(replacementProperty + ";", "");
            // Replace the variant that *doesn't* end with a semi-colon
            attributeValue = attributeValue.replace(replacementProperty, "");
        }
        // Now, append the behavior to the string.
        element.setAttribute("style", attributeValue.endsWith(";") ? "" + attributeValue + addition : ";" + attributeValue + addition);
    }
    /**
     * Given an Element, this function attempts to parse its 'style' attribute (if it has one)' to extract
     * a value for the 'scroll-behavior' CSS property (if it is given within that style attribute)
     * @param {Element} element
     * @returns {ScrollBehavior?}
     */
    function parseScrollBehaviorFromStyleAttribute(element) {
        var styleAttributeValue = element.getAttribute("style");
        if (styleAttributeValue != null && styleAttributeValue.includes(STYLE_ATTRIBUTE_PROPERTY_NAME)) {
            var match = styleAttributeValue.match(STYLE_ATTRIBUTE_PROPERTY_REGEXP);
            if (match != null) {
                var _a = __read(match, 2), behavior = _a[1];
                if (behavior != null && behavior !== "") {
                    return behavior;
                }
            }
        }
        return undefined;
    }

    var styleDeclarationPropertyName = "scrollBehavior";
    /**
     * Determines the scroll behavior to use, depending on the given ScrollOptions and the position of the Element
     * within the DOM
     * @param {Element|HTMLElement|Window} inputTarget
     * @param {ScrollOptions} [options]
     * @returns {ScrollBehavior}
     */
    function getScrollBehavior(inputTarget, options) {
        // If the given 'behavior' is 'smooth', apply smooth scrolling no matter what
        if (options != null && options.behavior === "smooth")
            return "smooth";
        var target = "style" in inputTarget ? inputTarget : getScrollingElement();
        var value;
        if ("style" in target) {
            // Check if scroll-behavior is set as a property on the CSSStyleDeclaration
            var scrollBehaviorPropertyValue = target.style[styleDeclarationPropertyName];
            // Return it if it is given and has a proper value
            if (scrollBehaviorPropertyValue != null && scrollBehaviorPropertyValue !== "") {
                value = scrollBehaviorPropertyValue;
            }
        }
        if (value == null) {
            var attributeValue = target.getAttribute("scroll-behavior");
            if (attributeValue != null && attributeValue !== "") {
                value = attributeValue;
            }
        }
        if (value == null) {
            // Otherwise, check if it is set as an inline style
            value = parseScrollBehaviorFromStyleAttribute(target);
        }
        if (value == null) {
            // Take the computed style for the element and see if it contains a specific 'scroll-behavior' value
            var computedStyle = getComputedStyle(target);
            var computedStyleValue = computedStyle.getPropertyValue("scrollBehavior");
            if (computedStyleValue != null && computedStyleValue !== "") {
                value = computedStyleValue;
            }
        }
        // In all other cases, use the value from the CSSOM
        return value;
    }

    

    

    var HALF = 0.5;
    /**
     * The easing function to use when applying the smooth scrolling
     * @param {number} k
     * @returns {number}
     */
    function ease(k) {
        return HALF * (1 - Math.cos(Math.PI * k));
    }

    var NOOP = {
        reset: function () { }
    };
    var map = typeof WeakMap === "undefined" ? undefined : new WeakMap();
    function disableScrollSnap(scroller) {
        // If scroll-behavior is natively supported, or if there is no native WeakMap support, there's no need for this fix
        if (SUPPORTS_SCROLL_BEHAVIOR || map == null) {
            return NOOP;
        }
        var scrollingElement = getScrollingElement();
        var cachedScrollSnapValue;
        var cachedScrollBehaviorStyleAttributeValue;
        var secondaryScroller;
        var secondaryScrollerCachedScrollSnapValue;
        var secondaryScrollerCachedScrollBehaviorStyleAttributeValue;
        var existingResult = map.get(scroller);
        if (existingResult != null) {
            cachedScrollSnapValue = existingResult.cachedScrollSnapValue;
            cachedScrollBehaviorStyleAttributeValue = existingResult.cachedScrollBehaviorStyleAttributeValue;
            secondaryScroller = existingResult.secondaryScroller;
            secondaryScrollerCachedScrollSnapValue = existingResult.secondaryScrollerCachedScrollSnapValue;
            secondaryScrollerCachedScrollBehaviorStyleAttributeValue = existingResult.secondaryScrollerCachedScrollBehaviorStyleAttributeValue;
            existingResult.release();
        }
        else {
            cachedScrollSnapValue = scroller.style.scrollSnapType === "" ? null : scroller.style.scrollSnapType;
            cachedScrollBehaviorStyleAttributeValue = parseScrollBehaviorFromStyleAttribute(scroller);
            secondaryScroller = scroller === scrollingElement && scrollingElement !== document.body ? document.body : undefined;
            secondaryScrollerCachedScrollSnapValue =
                secondaryScroller == null ? undefined : secondaryScroller.style.scrollSnapType === "" ? null : secondaryScroller.style.scrollSnapType;
            secondaryScrollerCachedScrollBehaviorStyleAttributeValue =
                secondaryScroller == null ? undefined : parseScrollBehaviorFromStyleAttribute(secondaryScroller);
            var cachedComputedScrollSnapValue = getComputedStyle(scroller).getPropertyValue("scroll-snap-type");
            var secondaryScrollerCachedComputedScrollSnapValue = secondaryScroller == null ? undefined : getComputedStyle(secondaryScroller).getPropertyValue("scroll-snap-type");
            // If it just so happens that there actually isn't any scroll snapping going on, there's no point in performing any additional work here.
            if (cachedComputedScrollSnapValue === "none" && secondaryScrollerCachedComputedScrollSnapValue === "none") {
                return NOOP;
            }
        }
        scroller.style.scrollSnapType = "none";
        if (secondaryScroller !== undefined) {
            secondaryScroller.style.scrollSnapType = "none";
        }
        if (cachedScrollBehaviorStyleAttributeValue !== undefined) {
            appendScrollBehaviorToStyleAttribute(scroller, cachedScrollBehaviorStyleAttributeValue);
        }
        if (secondaryScroller !== undefined && secondaryScrollerCachedScrollBehaviorStyleAttributeValue !== undefined) {
            appendScrollBehaviorToStyleAttribute(secondaryScroller, secondaryScrollerCachedScrollBehaviorStyleAttributeValue);
        }
        var hasReleased = false;
        var eventTarget = scroller === scrollingElement ? window : scroller;
        function release() {
            eventTarget.removeEventListener("scroll", resetHandler);
            if (map != null) {
                map["delete"](scroller);
            }
            hasReleased = true;
        }
        function resetHandler() {
            scroller.style.scrollSnapType = cachedScrollSnapValue;
            if (secondaryScroller != null && secondaryScrollerCachedScrollSnapValue !== undefined) {
                secondaryScroller.style.scrollSnapType = secondaryScrollerCachedScrollSnapValue;
            }
            if (cachedScrollBehaviorStyleAttributeValue !== undefined) {
                appendScrollBehaviorToStyleAttribute(scroller, cachedScrollBehaviorStyleAttributeValue);
            }
            if (secondaryScroller !== undefined && secondaryScrollerCachedScrollBehaviorStyleAttributeValue !== undefined) {
                appendScrollBehaviorToStyleAttribute(secondaryScroller, secondaryScrollerCachedScrollBehaviorStyleAttributeValue);
            }
            release();
        }
        function reset() {
            setTimeout(function () {
                if (hasReleased)
                    return;
                eventTarget.addEventListener("scroll", resetHandler);
            });
        }
        map.set(scroller, {
            release: release,
            cachedScrollSnapValue: cachedScrollSnapValue,
            cachedScrollBehaviorStyleAttributeValue: cachedScrollBehaviorStyleAttributeValue,
            secondaryScroller: secondaryScroller,
            secondaryScrollerCachedScrollSnapValue: secondaryScrollerCachedScrollSnapValue,
            secondaryScrollerCachedScrollBehaviorStyleAttributeValue: secondaryScrollerCachedScrollBehaviorStyleAttributeValue
        });
        return {
            reset: reset
        };
    }

    /**
     * The duration of a smooth scroll
     * @type {number}
     */
    var SCROLL_TIME = 15000;
    /**
     * Performs a smooth repositioning of the scroll
     * @param {ISmoothScrollOptions} options
     */
    function smoothScroll(options) {
        var startTime = options.startTime, startX = options.startX, startY = options.startY, endX = options.endX, endY = options.endY, method = options.method, scroller = options.scroller;
        var timeLapsed = 0;
        var distanceX = endX - startX;
        var distanceY = endY - startY;
        var speed = Math.max(Math.abs((distanceX / 1000) * SCROLL_TIME), Math.abs((distanceY / 1000) * SCROLL_TIME));
        // Temporarily disables any scroll snapping that may be active since it fights for control over the scroller with this polyfill
        var scrollSnapFix = disableScrollSnap(scroller);
        requestAnimationFrame(function animate(timestamp) {
            timeLapsed += timestamp - startTime;
            var percentage = Math.max(0, Math.min(1, speed === 0 ? 0 : timeLapsed / speed));
            var positionX = Math.floor(startX + distanceX * ease(percentage));
            var positionY = Math.floor(startY + distanceY * ease(percentage));
            method(positionX, positionY);
            if (positionX !== endX || positionY !== endY) {
                requestAnimationFrame(animate);
            }
            else {
                if (scrollSnapFix != null) {
                    scrollSnapFix.reset();
                    scrollSnapFix = undefined;
                }
            }
        });
    }

    /**
     * Returns a High Resolution timestamp if possible, otherwise fallbacks to Date.now()
     * @returns {number}
     */
    function now() {
        if ("performance" in window)
            return performance.now();
        return Date.now();
    }

    

    var ELEMENT_ORIGINAL_SCROLL = UNSUPPORTED_ENVIRONMENT ? undefined : Element.prototype.scroll;

    var WINDOW_ORIGINAL_SCROLL = UNSUPPORTED_ENVIRONMENT ? undefined : window.scroll;

    var ELEMENT_ORIGINAL_SCROLL_BY = UNSUPPORTED_ENVIRONMENT ? undefined : Element.prototype.scrollBy;

    var WINDOW_ORIGINAL_SCROLL_BY = UNSUPPORTED_ENVIRONMENT ? undefined : window.scrollBy;

    var ELEMENT_ORIGINAL_SCROLL_TO = UNSUPPORTED_ENVIRONMENT ? undefined : Element.prototype.scrollTo;

    var WINDOW_ORIGINAL_SCROLL_TO = UNSUPPORTED_ENVIRONMENT ? undefined : window.scrollTo;

    /**
     * A fallback if Element.prototype.scroll is not defined
     * @param {number} x
     * @param {number} y
     */
    function elementPrototypeScrollFallback(x, y) {
        this.__adjustingScrollPosition = true;
        this.scrollLeft = x;
        this.scrollTop = y;
        delete this.__adjustingScrollPosition;
    }
    /**
     * A fallback if Element.prototype.scrollTo is not defined
     * @param {number} x
     * @param {number} y
     */
    function elementPrototypeScrollToFallback(x, y) {
        return elementPrototypeScrollFallback.call(this, x, y);
    }
    /**
     * A fallback if Element.prototype.scrollBy is not defined
     * @param {number} x
     * @param {number} y
     */
    function elementPrototypeScrollByFallback(x, y) {
        this.__adjustingScrollPosition = true;
        this.scrollLeft += x;
        this.scrollTop += y;
        delete this.__adjustingScrollPosition;
    }
    /**
     * Gets the original non-patched prototype method for the given kind
     * @param {ScrollMethodName} kind
     * @param {Element|Window} element
     * @return {Function}
     */
    function getOriginalScrollMethodForKind(kind, element) {
        switch (kind) {
            case "scroll":
                if (element instanceof Element) {
                    if (ELEMENT_ORIGINAL_SCROLL != null) {
                        return ELEMENT_ORIGINAL_SCROLL;
                    }
                    else {
                        return elementPrototypeScrollFallback;
                    }
                }
                else {
                    return WINDOW_ORIGINAL_SCROLL;
                }
            case "scrollBy":
                if (element instanceof Element) {
                    if (ELEMENT_ORIGINAL_SCROLL_BY != null) {
                        return ELEMENT_ORIGINAL_SCROLL_BY;
                    }
                    else {
                        return elementPrototypeScrollByFallback;
                    }
                }
                else {
                    return WINDOW_ORIGINAL_SCROLL_BY;
                }
            case "scrollTo":
                if (element instanceof Element) {
                    if (ELEMENT_ORIGINAL_SCROLL_TO != null) {
                        return ELEMENT_ORIGINAL_SCROLL_TO;
                    }
                    else {
                        return elementPrototypeScrollToFallback;
                    }
                }
                else {
                    return WINDOW_ORIGINAL_SCROLL_TO;
                }
        }
    }

    /**
     * Gets the Smooth Scroll Options to use for the step function
     * @param {Element|Window} element
     * @param {number} x
     * @param {number} y
     * @param {ScrollMethodName} kind
     * @returns {ISmoothScrollOptions}
     */
    function getSmoothScrollOptions(element, x, y, kind) {
        var startTime = now();
        if (!(element instanceof Element)) {
            // Use window as the scroll container
            var scrollX_1 = window.scrollX, pageXOffset_1 = window.pageXOffset, scrollY_1 = window.scrollY, pageYOffset_1 = window.pageYOffset;
            var startX = scrollX_1 == null || scrollX_1 === 0 ? pageXOffset_1 : scrollX_1;
            var startY = scrollY_1 == null || scrollY_1 === 0 ? pageYOffset_1 : scrollY_1;
            return {
                startTime: startTime,
                startX: startX,
                startY: startY,
                endX: Math.floor(kind === "scrollBy" ? startX + x : x),
                endY: Math.floor(kind === "scrollBy" ? startY + y : y),
                method: getOriginalScrollMethodForKind("scrollTo", window).bind(window),
                scroller: getScrollingElement()
            };
        }
        else {
            var scrollLeft = element.scrollLeft, scrollTop = element.scrollTop;
            var startX = scrollLeft;
            var startY = scrollTop;
            return {
                startTime: startTime,
                startX: startX,
                startY: startY,
                endX: Math.floor(kind === "scrollBy" ? startX + x : x),
                endY: Math.floor(kind === "scrollBy" ? startY + y : y),
                method: getOriginalScrollMethodForKind("scrollTo", element).bind(element),
                scroller: element
            };
        }
    }

    /**
     * Ensures that the given value is numeric
     * @param {number} value
     * @return {number}
     */
    function ensureNumeric(value) {
        if (value == null)
            return 0;
        else if (typeof value === "number") {
            return value;
        }
        else if (typeof value === "string") {
            return parseFloat(value);
        }
        else {
            return 0;
        }
    }

    /**
     * Returns true if the given value is some ScrollToOptions
     * @param {number | ScrollToOptions} value
     * @return {value is ScrollToOptions}
     */
    function isScrollToOptions(value) {
        return value != null && typeof value === "object";
    }

    /**
     * Handles a scroll method
     * @param {Element|Window} element
     * @param {ScrollMethodName} kind
     * @param {number | ScrollToOptions} optionsOrX
     * @param {number} y
     */
    function handleScrollMethod(element, kind, optionsOrX, y) {
        onScrollWithOptions(getScrollToOptionsWithValidation(optionsOrX, y), element, kind);
    }
    /**
     * Invoked when a 'ScrollToOptions' dict is provided to 'scroll()' as the first argument
     * @param {ScrollToOptions} options
     * @param {Element|Window} element
     * @param {ScrollMethodName} kind
     */
    function onScrollWithOptions(options, element, kind) {
        var behavior = getScrollBehavior(element, options);
        // If the behavior is 'auto' apply instantaneous scrolling
        if (behavior == null || behavior === "auto") {
            getOriginalScrollMethodForKind(kind, element).call(element, options.left, options.top);
        }
        else {
            smoothScroll(getSmoothScrollOptions(element, options.left, options.top, kind));
        }
    }
    /**
     * Normalizes the given scroll coordinates
     * @param {number?} x
     * @param {number?} y
     * @return {Required<Pick<ScrollToOptions, "top" | "left">>}
     */
    function normalizeScrollCoordinates(x, y) {
        return {
            left: ensureNumeric(x),
            top: ensureNumeric(y)
        };
    }
    /**
     * Gets ScrollToOptions based on the given arguments. Will throw if validation fails
     * @param {number | ScrollToOptions} optionsOrX
     * @param {number} y
     * @return {Required<ScrollToOptions>}
     */
    function getScrollToOptionsWithValidation(optionsOrX, y) {
        // If only one argument is given, and it isn't an options object, throw a TypeError
        if (y === undefined && !isScrollToOptions(optionsOrX)) {
            throw new TypeError("Failed to execute 'scroll' on 'Element': parameter 1 ('options') is not an object.");
        }
        // Scroll based on the primitive values given as arguments
        if (!isScrollToOptions(optionsOrX)) {
            return __assign(__assign({}, normalizeScrollCoordinates(optionsOrX, y)), { behavior: "auto" });
        }
        // Scroll based on the received options object
        else {
            return __assign(__assign({}, normalizeScrollCoordinates(optionsOrX.left, optionsOrX.top)), { behavior: optionsOrX.behavior == null ? "auto" : optionsOrX.behavior });
        }
    }

    /**
     * Patches the 'scroll' method on the Element prototype
     */
    function patchElementScroll() {
        Element.prototype.scroll = function (optionsOrX, y) {
            handleScrollMethod(this, "scroll", optionsOrX, y);
        };
    }

    /**
     * Patches the 'scrollBy' method on the Element prototype
     */
    function patchElementScrollBy() {
        Element.prototype.scrollBy = function (optionsOrX, y) {
            handleScrollMethod(this, "scrollBy", optionsOrX, y);
        };
    }

    /**
     * Patches the 'scrollTo' method on the Element prototype
     */
    function patchElementScrollTo() {
        Element.prototype.scrollTo = function (optionsOrX, y) {
            handleScrollMethod(this, "scrollTo", optionsOrX, y);
        };
    }

    /**
     * Patches the 'scroll' method on the Window prototype
     */
    function patchWindowScroll() {
        window.scroll = function (optionsOrX, y) {
            handleScrollMethod(this, "scroll", optionsOrX, y);
        };
    }

    /**
     * Patches the 'scrollBy' method on the Window prototype
     */
    function patchWindowScrollBy() {
        window.scrollBy = function (optionsOrX, y) {
            handleScrollMethod(this, "scrollBy", optionsOrX, y);
        };
    }

    /**
     * Patches the 'scrollTo' method on the Window prototype
     */
    function patchWindowScrollTo() {
        window.scrollTo = function (optionsOrX, y) {
            handleScrollMethod(this, "scrollTo", optionsOrX, y);
        };
    }

    // tslint:disable:no-any
    /**
     * Gets the parent of an element, taking into account DocumentFragments, ShadowRoots, as well as the root context (window)
     * @param {EventTarget} currentElement
     * @returns {EventTarget | null}
     */
    function getParent(currentElement) {
        if ("nodeType" in currentElement && currentElement.nodeType === 1) {
            return currentElement.parentNode;
        }
        if ("ShadowRoot" in window && currentElement instanceof window.ShadowRoot) {
            return currentElement.host;
        }
        else if (currentElement === document) {
            return window;
        }
        else if (currentElement instanceof Node)
            return currentElement.parentNode;
        return null;
    }

    /**
     * Returns true if the given overflow property represents a scrollable overflow value
     * @param {string | null} overflow
     * @return {boolean}
     */
    function canOverflow(overflow) {
        return overflow !== "visible" && overflow !== "clip";
    }
    /**
     * Returns true if the given element is scrollable
     * @param {Element} element
     * @return {boolean}
     */
    function isScrollable(element) {
        if (element.clientHeight < element.scrollHeight || element.clientWidth < element.scrollWidth) {
            var style = getComputedStyle(element, null);
            return canOverflow(style.overflowY) || canOverflow(style.overflowX);
        }
        return false;
    }
    /**
     * Finds the nearest ancestor of an element that can scroll
     * @param {Element} target
     * @returns {Element|Window?}
     */
    function findNearestAncestorsWithScrollBehavior(target) {
        var currentElement = target;
        var scrollingElement = getScrollingElement();
        while (currentElement != null) {
            var behavior = getScrollBehavior(currentElement);
            if (behavior != null && (currentElement === scrollingElement || isScrollable(currentElement))) {
                return [currentElement, behavior];
            }
            var parent_1 = getParent(currentElement);
            currentElement = parent_1;
        }
        // No such element could be found. Start over, but this time find the nearest ancestor that can simply scroll
        currentElement = target;
        while (currentElement != null) {
            if (currentElement === scrollingElement || isScrollable(currentElement)) {
                return [currentElement, "auto"];
            }
            var parent_2 = getParent(currentElement);
            currentElement = parent_2;
        }
        // Default to the scrolling element
        return [scrollingElement, "auto"];
    }

    // tslint:disable:no-any
    /**
     * Finds the nearest root from an element
     * @param {Element} target
     * @returns {Document|ShadowRoot}
     */
    function findNearestRoot(target) {
        var currentElement = target;
        while (currentElement != null) {
            if ("ShadowRoot" in window && currentElement instanceof window.ShadowRoot) {
                // Assume this is a ShadowRoot
                return currentElement;
            }
            var parent_1 = getParent(currentElement);
            if (parent_1 === currentElement) {
                return document;
            }
            currentElement = parent_1;
        }
        return document;
    }

    /**
     * Gets the origin of the given Location or HTMLAnchorElement if available in the runtime, and otherwise shims it. (it's a one-liner)
     * @returns {string}
     */
    function getLocationOrigin(locationLike) {
        if (locationLike === void 0) { locationLike = location; }
        if ("origin" in locationLike && locationLike.origin != null) {
            return locationLike.origin;
        }
        var port = locationLike.port != null && locationLike.port.length > 0 ? ":" + locationLike.port : "";
        if (locationLike.protocol === "http:" && port === ":80") {
            port = "";
        }
        else if (locationLike.protocol === "https:" && port === ":443") {
            port = "";
        }
        return locationLike.protocol + "//" + locationLike.hostname + port;
    }

    /**
     * A Regular expression that matches id's of the form "#[digit]"
     * @type {RegExp}
     */
    var ID_WITH_LEADING_DIGIT_REGEXP = /^#\d/;
    /**
     * Catches anchor navigation to IDs within the same root and ensures that they can be smooth-scrolled
     * if the scroll behavior is smooth in the first rooter within that context
     */
    function catchNavigation() {
        // Listen for 'click' events globally
        window.addEventListener("click", function (e) {
            // Only work with trusted events on HTMLAnchorElements
            if (!e.isTrusted || !(e.target instanceof HTMLAnchorElement))
                return;
            var _a = e.target, pathname = _a.pathname, search = _a.search, hash = _a.hash;
            var pointsToCurrentPage = getLocationOrigin(e.target) === getLocationOrigin(location) && pathname === location.pathname && search === location.search;
            // Only work with HTMLAnchorElements that navigates to a specific ID on the current page
            if (!pointsToCurrentPage || hash == null || hash.length < 1) {
                return;
            }
            // Find the nearest root, whether it be a ShadowRoot or the document itself
            var root = findNearestRoot(e.target);
            // Attempt to match the selector from that root. querySelector' doesn't support IDs that start with a digit, so work around that limitation
            var elementMatch = hash.match(ID_WITH_LEADING_DIGIT_REGEXP) != null ? root.getElementById(hash.slice(1)) : root.querySelector(hash);
            // If no selector could be found, don't proceed
            if (elementMatch == null)
                return;
            // Find the nearest ancestor that can be scrolled
            var _b = __read(findNearestAncestorsWithScrollBehavior(elementMatch), 2), behavior = _b[1];
            // If the behavior isn't smooth, don't proceed
            if (behavior !== "smooth")
                return;
            // Otherwise, first prevent the default action.
            e.preventDefault();
            // Now, scroll to the element with that ID
            elementMatch.scrollIntoView({
                behavior: behavior
            });
        });
    }

    var ELEMENT_ORIGINAL_SCROLL_INTO_VIEW = UNSUPPORTED_ENVIRONMENT ? undefined : Element.prototype.scrollIntoView;

    /**
     * The majority of this file is based on https://github.com/stipsan/compute-scroll-into-view (MIT license),
     * but has been rewritten to accept a scroller as an argument.
     */
    /**
     * Find out which edge to align against when logical scroll position is "nearest"
     * Interesting fact: "nearest" works similarly to "if-needed", if the element is fully visible it will not scroll it
     *
     * Legends:
     * ┌────────┐ ┏ ━ ━ ━ ┓
     * │ target │   frame
     * └────────┘ ┗ ━ ━ ━ ┛
     */
    function alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
        /**
         * If element edge A and element edge B are both outside scrolling box edge A and scrolling box edge B
         *
         *          ┌──┐
         *        ┏━│━━│━┓
         *          │  │
         *        ┃ │  │ ┃        do nothing
         *          │  │
         *        ┗━│━━│━┛
         *          └──┘
         *
         *  If element edge C and element edge D are both outside scrolling box edge C and scrolling box edge D
         *
         *    ┏ ━ ━ ━ ━ ┓
         *   ┌───────────┐
         *   │┃         ┃│        do nothing
         *   └───────────┘
         *    ┗ ━ ━ ━ ━ ┛
         */
        if ((elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd) ||
            (elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd)) {
            return 0;
        }
        /**
         * If element edge A is outside scrolling box edge A and element height is less than scrolling box height
         *
         *          ┌──┐
         *        ┏━│━━│━┓         ┏━┌━━┐━┓
         *          └──┘             │  │
         *  from  ┃      ┃     to  ┃ └──┘ ┃
         *
         *        ┗━ ━━ ━┛         ┗━ ━━ ━┛
         *
         * If element edge B is outside scrolling box edge B and element height is greater than scrolling box height
         *
         *        ┏━ ━━ ━┓         ┏━┌━━┐━┓
         *                           │  │
         *  from  ┃ ┌──┐ ┃     to  ┃ │  │ ┃
         *          │  │             │  │
         *        ┗━│━━│━┛         ┗━│━━│━┛
         *          │  │             └──┘
         *          │  │
         *          └──┘
         *
         * If element edge C is outside scrolling box edge C and element width is less than scrolling box width
         *
         *       from                 to
         *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
         *  ┌───┐                 ┌───┐
         *  │ ┃ │       ┃         ┃   │     ┃
         *  └───┘                 └───┘
         *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
         *
         * If element edge D is outside scrolling box edge D and element width is greater than scrolling box width
         *
         *       from                 to
         *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
         *        ┌───────────┐   ┌───────────┐
         *    ┃   │     ┃     │   ┃         ┃ │
         *        └───────────┘   └───────────┘
         *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
         */
        if ((elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize) ||
            (elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize)) {
            return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
        }
        /**
         * If element edge B is outside scrolling box edge B and element height is less than scrolling box height
         *
         *        ┏━ ━━ ━┓         ┏━ ━━ ━┓
         *
         *  from  ┃      ┃     to  ┃ ┌──┐ ┃
         *          ┌──┐             │  │
         *        ┗━│━━│━┛         ┗━└━━┘━┛
         *          └──┘
         *
         * If element edge A is outside scrolling box edge A and element height is greater than scrolling box height
         *
         *          ┌──┐
         *          │  │
         *          │  │             ┌──┐
         *        ┏━│━━│━┓         ┏━│━━│━┓
         *          │  │             │  │
         *  from  ┃ └──┘ ┃     to  ┃ │  │ ┃
         *                           │  │
         *        ┗━ ━━ ━┛         ┗━└━━┘━┛
         *
         * If element edge C is outside scrolling box edge C and element width is greater than scrolling box width
         *
         *           from                 to
         *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
         *  ┌───────────┐           ┌───────────┐
         *  │     ┃     │   ┃       │ ┃         ┃
         *  └───────────┘           └───────────┘
         *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
         *
         * If element edge D is outside scrolling box edge D and element width is less than scrolling box width
         *
         *           from                 to
         *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
         *                ┌───┐             ┌───┐
         *        ┃       │ ┃ │       ┃     │   ┃
         *                └───┘             └───┘
         *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
         *
         */
        if ((elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize) || (elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize)) {
            return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
        }
        return 0;
    }
    function computeScrollIntoView(target, scroller, options) {
        var block = options.block, inline = options.inline;
        // Used to handle the top most element that can be scrolled
        var scrollingElement = getScrollingElement();
        // Support pinch-zooming properly, making sure elements scroll into the visual viewport
        // Browsers that don't support visualViewport will report the layout viewport dimensions on document.documentElement.clientWidth/Height
        // and viewport dimensions on window.innerWidth/Height
        // https://www.quirksmode.org/mobile/viewports2.html
        // https://bokand.github.io/viewport/index.html
        var viewportWidth = window.visualViewport != null ? visualViewport.width : innerWidth;
        var viewportHeight = window.visualViewport != null ? visualViewport.height : innerHeight;
        var viewportX = window.scrollX != null ? window.scrollX : window.pageXOffset;
        var viewportY = window.scrollY != null ? window.scrollY : window.pageYOffset;
        var _a = target.getBoundingClientRect(), targetHeight = _a.height, targetWidth = _a.width, targetTop = _a.top, targetRight = _a.right, targetBottom = _a.bottom, targetLeft = _a.left;
        // These values mutate as we loop through and generate scroll coordinates
        var targetBlock = block === "start" || block === "nearest" ? targetTop : block === "end" ? targetBottom : targetTop + targetHeight / 2; // block === 'center
        var targetInline = inline === "center" ? targetLeft + targetWidth / 2 : inline === "end" ? targetRight : targetLeft; // inline === 'start || inline === 'nearest
        var _b = scroller.getBoundingClientRect(), height = _b.height, width = _b.width, top = _b.top, right = _b.right, bottom = _b.bottom, left = _b.left;
        var frameStyle = getComputedStyle(scroller);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        // The property existance checks for offset[Width|Height] is because only HTMLElement objects have them, but any Element might pass by here
        // @TODO find out if the "as HTMLElement" overrides can be dropped
        var scrollbarWidth = "offsetWidth" in scroller ? scroller.offsetWidth - scroller.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = "offsetHeight" in scroller ? scroller.offsetHeight - scroller.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === scroller) {
            // Handle viewport logic (document.documentElement or document.body)
            if (block === "start") {
                blockScroll = targetBlock;
            }
            else if (block === "end") {
                blockScroll = targetBlock - viewportHeight;
            }
            else if (block === "nearest") {
                blockScroll = alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            }
            else {
                // block === 'center' is the default
                blockScroll = targetBlock - viewportHeight / 2;
            }
            if (inline === "start") {
                inlineScroll = targetInline;
            }
            else if (inline === "center") {
                inlineScroll = targetInline - viewportWidth / 2;
            }
            else if (inline === "end") {
                inlineScroll = targetInline - viewportWidth;
            }
            else {
                // inline === 'nearest' is the default
                inlineScroll = alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            }
            // Apply scroll position offsets and ensure they are within bounds
            // @TODO add more test cases to cover this 100%
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        }
        else {
            // Handle each scrolling frame that might exist between the target and the viewport
            if (block === "start") {
                blockScroll = targetBlock - top - borderTop;
            }
            else if (block === "end") {
                blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            }
            else if (block === "nearest") {
                blockScroll = alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            }
            else {
                // block === 'center' is the default
                blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
            }
            if (inline === "start") {
                inlineScroll = targetInline - left - borderLeft;
            }
            else if (inline === "center") {
                inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
            }
            else if (inline === "end") {
                inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            }
            else {
                // inline === 'nearest' is the default
                inlineScroll = alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            }
            var scrollLeft = scroller.scrollLeft, scrollTop = scroller.scrollTop;
            // Ensure scroll coordinates are not out of bounds while applying scroll offsets
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, scroller.scrollHeight - height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, scroller.scrollWidth - width + scrollbarWidth));
        }
        return {
            top: blockScroll,
            left: inlineScroll
        };
    }

    /**
     * Patches the 'scrollIntoView' method on the Element prototype
     */
    function patchElementScrollIntoView() {
        Element.prototype.scrollIntoView = function (arg) {
            var normalizedOptions = arg == null || arg === true
                ? {
                    block: "start",
                    inline: "nearest"
                }
                : arg === false
                    ? {
                        block: "end",
                        inline: "nearest"
                    }
                    : arg;
            // Find the nearest ancestor that can be scrolled
            var _a = __read(findNearestAncestorsWithScrollBehavior(this), 2), ancestorWithScroll = _a[0], ancestorWithScrollBehavior = _a[1];
            var behavior = normalizedOptions.behavior != null ? normalizedOptions.behavior : ancestorWithScrollBehavior;
            // If the behavior isn't smooth, simply invoke the original implementation and do no more
            if (behavior !== "smooth") {
                // Assert that 'scrollIntoView' is actually defined
                if (ELEMENT_ORIGINAL_SCROLL_INTO_VIEW != null) {
                    ELEMENT_ORIGINAL_SCROLL_INTO_VIEW.call(this, normalizedOptions);
                }
                // Otherwise, invoke 'scrollTo' instead and provide the scroll coordinates
                else {
                    var _b = computeScrollIntoView(this, ancestorWithScroll, normalizedOptions), top_1 = _b.top, left = _b.left;
                    getOriginalScrollMethodForKind("scrollTo", this).call(this, left, top_1);
                }
                return;
            }
            ancestorWithScroll.scrollTo(__assign({ behavior: behavior }, computeScrollIntoView(this, ancestorWithScroll, normalizedOptions)));
        };
        // On IE11, HTMLElement has its own declaration of scrollIntoView and does not inherit this from the prototype chain, so we'll need to patch that one too.
        if (HTMLElement.prototype.scrollIntoView != null && HTMLElement.prototype.scrollIntoView !== Element.prototype.scrollIntoView) {
            HTMLElement.prototype.scrollIntoView = Element.prototype.scrollIntoView;
        }
    }

    var ELEMENT_ORIGINAL_SCROLL_TOP_SET_DESCRIPTOR = UNSUPPORTED_ENVIRONMENT
        ? undefined
        : Object.getOwnPropertyDescriptor(Element.prototype, "scrollTop").set;

    /**
     * Patches the 'scrollTop' property descriptor on the Element prototype
     */
    function patchElementScrollTop() {
        Object.defineProperty(Element.prototype, "scrollTop", {
            set: function (scrollTop) {
                if (this.__adjustingScrollPosition) {
                    return ELEMENT_ORIGINAL_SCROLL_TOP_SET_DESCRIPTOR.call(this, scrollTop);
                }
                handleScrollMethod(this, "scrollTo", this.scrollLeft, scrollTop);
                return scrollTop;
            }
        });
    }

    var ELEMENT_ORIGINAL_SCROLL_LEFT_SET_DESCRIPTOR = UNSUPPORTED_ENVIRONMENT
        ? undefined
        : Object.getOwnPropertyDescriptor(Element.prototype, "scrollLeft").set;

    /**
     * Patches the 'scrollLeft' property descriptor on the Element prototype
     */
    function patchElementScrollLeft() {
        Object.defineProperty(Element.prototype, "scrollLeft", {
            set: function (scrollLeft) {
                if (this.__adjustingScrollPosition) {
                    return ELEMENT_ORIGINAL_SCROLL_LEFT_SET_DESCRIPTOR.call(this, scrollLeft);
                }
                handleScrollMethod(this, "scrollTo", scrollLeft, this.scrollTop);
                return scrollLeft;
            }
        });
    }

    /**
     * Applies the polyfill
     */
    function patch() {
        // Element.prototype methods
        patchElementScroll();
        patchElementScrollBy();
        patchElementScrollTo();
        patchElementScrollIntoView();
        // Element.prototype descriptors
        patchElementScrollLeft();
        patchElementScrollTop();
        // window methods
        patchWindowScroll();
        patchWindowScrollBy();
        patchWindowScrollTo();
        // Navigation
        catchNavigation();
    }

    /**
     * Is true if the browser natively supports the Element.prototype.[scroll|scrollTo|scrollBy|scrollIntoView] methods
     * @type {boolean}
     */
    var SUPPORTS_ELEMENT_PROTOTYPE_SCROLL_METHODS = UNSUPPORTED_ENVIRONMENT
        ? false
        : "scroll" in Element.prototype && "scrollTo" in Element.prototype && "scrollBy" in Element.prototype && "scrollIntoView" in Element.prototype;

    if (!UNSUPPORTED_ENVIRONMENT && (!SUPPORTS_SCROLL_BEHAVIOR || !SUPPORTS_ELEMENT_PROTOTYPE_SCROLL_METHODS)) {
        patch();
    }

}());
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 37478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(21924);
var inspect = __webpack_require__(70631);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 70655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldIn": function() { return /* binding */ __classPrivateFieldIn; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArray": function() { return /* binding */ __spreadArray; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__values": function() { return /* binding */ __values; }
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 50079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UL": function() { return /* binding */ _inheritsLoose; },
/* harmony export */   "gK": function() { return /* binding */ _objectWithoutPropertiesLoose; },
/* harmony export */   "gY": function() { return /* binding */ _extends; },
/* harmony export */   "wm": function() { return /* binding */ _wrapNativeSuper; }
/* harmony export */ });
/* unused harmony exports construct, getPrototypeOf, isNativeFunction, isNativeReflectConstruct, setPrototypeOf */
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}


//# sourceMappingURL=use-intl.esm.js.map


/***/ }),

/***/ 31954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ defaultOnError; },
/* harmony export */   "i": function() { return /* binding */ defaultGetMessageFallback; }
/* harmony export */ });
/**
 * Contains defaults that are used for all entry points into the core.
 * See also `InitializedIntlConfiguration`.
 */
function defaultGetMessageFallback(props) {
  return [props.namespace, props.key].filter(function (part) {
    return part != null;
  }).join('.');
}
function defaultOnError(error) {
  console.error(error);
}


//# sourceMappingURL=use-intl.esm5.js.map


/***/ }),

/***/ 31733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IntlContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var IntlContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);


//# sourceMappingURL=use-intl.esm7.js.map


/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 25934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 75068:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inheritsLoose; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 10748:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 92777:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 82262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 59499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 37247:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 81531:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90607);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 63553:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14027);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10748);


function _possibleConstructorReturn(self, call) {
  if (call && (next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 90607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 27812:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(94367), __webpack_exec__(6840), __webpack_exec__(69898); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);